/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var About, AccessibilitySupport, LocationTransition, Page, Root;
	
	__webpack_require__(35);
	
	__webpack_require__(13);
	
	__webpack_require__(53);
	
	__webpack_require__(17);
	
	__webpack_require__(65);
	
	__webpack_require__(5);
	
	__webpack_require__(14);
	
	__webpack_require__(3);
	
	__webpack_require__(4);
	
	__webpack_require__(7);
	
	__webpack_require__(68);
	
	__webpack_require__(24);
	
	__webpack_require__(66);
	
	__webpack_require__(2);
	
	__webpack_require__(36);
	
	__webpack_require__(37);
	
	__webpack_require__(47);
	
	__webpack_require__(21);
	
	__webpack_require__(26);
	
	__webpack_require__(72);
	
	__webpack_require__(70);
	
	__webpack_require__(1);
	
	__webpack_require__(73);
	
	__webpack_require__(76);
	
	__webpack_require__(23);
	
	__webpack_require__(10);
	
	__webpack_require__(69);
	
	__webpack_require__(63);
	
	__webpack_require__(80);
	
	__webpack_require__(67);
	
	__webpack_require__(64);
	
	__webpack_require__(77);
	
	__webpack_require__(34);
	
	__webpack_require__(79);
	
	__webpack_require__(19);
	
	__webpack_require__(81);
	
	__webpack_require__(40);
	
	__webpack_require__(71);
	
	__webpack_require__(74);
	
	try {
	  __webpack_require__(45);
	} catch (error) {
	  console.error('no product page code');
	}
	
	styles += "#content {\n  min-width: 320px;\n}\n\n";
	
	fetch('root');
	
	AccessibilitySupport = ReactiveComponent({
	  displayName: 'AccessibilitySupport',
	  render: function() {
	    return DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto'
	      }
	    }, H1({
	      style: {
	        fontSize: 32,
	        fontWeight: 600,
	        marginTop: 30,
	        marginBottom: 10
	      }
	    }, TRANSLATE({
	      id: 'accessibility.heading'
	    }, 'Accessibility Support')), P({
	      style: {
	        paddingBottom: 18,
	        fontSize: 24
	      }
	    }, TRANSLATE({
	      id: "accessibility.feedback_or_help",
	      link: {
	        component: A,
	        args: {
	          href: "mailto:accessibility@consider.it?subject=Accessibility support",
	          style: {
	            textDecoration: 'underline'
	          }
	        }
	      }
	    }, "If you are having difficulty using Considerit to give feedback, contact us at <link>accessibility@consider.it</link>. We will help you personally.")));
	  }
	});
	
	About = ReactiveComponent({
	  displayName: 'About',
	  UNSAFE_componentWillMount: function() {
	    this.local.embed_html_directly = true;
	    this.local.html = null;
	    return this.local.save;
	  },
	  componentDidMount: function() {
	    return this.handleContent();
	  },
	  componentDidUpdate: function() {
	    return this.handleContent();
	  },
	  handleContent: function() {
	    var el, iframe;
	    el = ReactDOM.findDOMNode(this);
	    if (this.local.embed_html_directly) {
	      if (this.local.html) {
	        return this.refs.embedded_about_html.innerHTML = this.local.html;
	      }
	    } else {
	      iframe = el;
	      return _.delay(function() {
	        var e;
	        try {
	          return iframe.height = iframe.contentWindow.document.body.scrollHeight + "px";
	        } catch (error) {
	          e = error;
	          iframe.height = "2000px";
	          console.error('http/https mismatch for about page. Should work in production.');
	          return console.error(e);
	        }
	      }, 1000);
	    }
	  },
	  render: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (this.local.embed_html_directly && !this.local.html && subdomain.about_page_url) {
	      $.get(subdomain.about_page_url, (function(_this) {
	        return function(response) {
	          _this.local.html = response;
	          return save(_this.local);
	        };
	      })(this));
	    }
	    return DIV({
	      style: {
	        marginTop: 20
	      }
	    }, !subdomain.about_page_url ? DIV(null, 'No about page defined') : !this.local.embed_html_directly ? IFRAME({
	      src: subdomain.about_page_url,
	      width: CONTENT_WIDTH(),
	      style: {
	        display: 'block',
	        margin: 'auto'
	      }
	    }) : DIV({
	      ref: 'embedded_about_html',
	      className: 'embedded_about_html'
	    }));
	  }
	});
	
	LocationTransition = ReactiveComponent({
	  displayName: 'locationTransition',
	  render: function() {
	    var auth, edit_forum, loc;
	    loc = fetch('location');
	    if (is_a_dialogue_page() && loc.query_params.edit_forum) {
	      edit_forum = fetch('edit_forum');
	      edit_forum.editing = true;
	      save(edit_forum);
	      delete loc.query_params.edit_forum;
	      save(loc);
	    }
	    if (loc.query_params.flash) {
	      show_flash(loc.query_params.flash, 3000);
	      delete loc.query_params.flash;
	    }
	    if (this.last_location !== loc.url) {
	      auth = fetch('auth');
	      if (auth.form) {
	        reset_key(auth);
	      }
	      edit_forum = fetch('edit_forum');
	      if (edit_forum.editing && !is_a_dialogue_page()) {
	        stop_editing_forum();
	      }
	      this.last_location = loc.url;
	    }
	    return SPAN(null);
	  }
	});
	
	Page = ReactiveComponent({
	  displayName: 'Page',
	  mixins: [AccessControlled],
	  render: function() {
	    var access_granted, auth, loc, page, subdomain;
	    subdomain = fetch('/subdomain');
	    loc = fetch('location');
	    auth = fetch('auth');
	    page = fetch(this.props.page);
	    access_granted = this.accessGranted();
	    return DIV({
	      className: 'full_height',
	      style: {
	        display: 'flex',
	        flexDirection: 'column'
	      },
	      'aria-hidden': auth.form ? true : void 0
	    }, STYLE({
	      dangerouslySetInnerHTML: {
	        __html: customization('style')
	      }
	    }), access_granted ? Header({
	      key: 'page_header'
	    }) : void 0, MAIN({
	      role: 'main',
	      className: (is_a_dialogue_page() ? 'main_background' : '') + " " + (embedded_demo() ? 'embedded-demo' : ''),
	      style: {
	        position: 'relative',
	        margin: 'auto',
	        flexGrow: 1,
	        width: '100%'
	      }
	    }, (function() {
	      if (!access_granted) {
	        return AccessDenied();
	      } else if (loc.url.startsWith('/dashboard')) {
	        return Dashboard();
	      } else if (loc.url.startsWith('/docs/')) {
	        return DocumentationGroup();
	      } else {
	        switch (loc.url) {
	          case '/':
	            return Homepage({
	              key: 'homepage'
	            });
	          case '/about':
	            return About();
	          case '/accessibility_support':
	            return AccessibilitySupport();
	          case '/histogram_test':
	            return HistogramTester();
	          default:
	            if ((page != null ? page.result : void 0) === 'Not found') {
	              return DIV({
	                style: {
	                  textAlign: 'center',
	                  fontSize: 32,
	                  marginTop: 50
	                }
	              }, "There doesn't seem to be a proposal here", DIV({
	                style: {
	                  color: '#555',
	                  fontSize: 16
	                }
	              }, "Check if the url is correct. The author may also have deleted it. Good luck!"));
	            } else {
	              return Homepage({
	                key: 'homepage'
	              });
	            }
	        }
	      }
	    })()), access_granted ? Footer({
	      key: 'page_footer'
	    }) : void 0);
	  }
	});
	
	Root = ReactiveComponent({
	  displayName: 'Root',
	  render: function() {
	    var app, condensed_fonts, current_user, fonts, header_fonts, loc, page, subdomain;
	    loc = fetch('location');
	    app = fetch('/application');
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    page = fetch("/page" + loc.url);
	    setTimeout(function() {
	      return fetch('/users');
	    });
	    if (!fetch('customizations_signature').signature || !app.web_worker) {
	      return DIV({
	        className: 'full_height'
	      }, CustomizationTransition(), DIV({
	        style: {
	          position: 'absolute',
	          left: '48%'
	        }
	      }, LOADING_INDICATOR));
	    }
	    if (!app.web_worker) {
	      return ProposalsLoading();
	    }
	    fonts = customization('font');
	    header_fonts = customization('header_font') || fonts;
	    condensed_fonts = customization('condensed_font') || header_fonts;
	    return DIV({
	      className: 'full_height',
	      onTouchMove: function() {
	        window.is_swipping = true;
	        return true;
	      },
	      onTouchEnd: function() {
	        window.is_swipping = false;
	        return true;
	      },
	      onClick: this.resetSelection
	    }, AuthTransition(), CustomizationTransition(), LocationTransition(), HomepageTabTransition(), BrowserLocation(), GoogleTranslate(), typeof LoadAvatars === "function" ? LoadAvatars() : void 0, STYLE({
	      dangerouslySetInnerHTML: {
	        __html: ".content, input, button, textarea {\n  font-family: " + fonts + "; \n}\n.content h1, .content h2, .content h3, .content h1 button, .content h2 button, .content h3 button, .content h4 button {\n  font-family: " + header_fonts + ";\n  // letter-spacing: -1px;\n}\n\n.monospaced {\n  font-family: " + (mono_font()) + ";\n}\n\n.condensed {\n  font-family: " + condensed_fonts + ";\n}"
	      }
	    }), !subdomain.name ? LOADING_INDICATOR : DIV({
	      className: 'full_height'
	    }, fetch('auth').form ? Auth() : void 0, BrowserHacks(), Page({
	      page: "/page" + loc.url
	    })), Tooltip(), Popover(), Flash(), (function() {
	      app = fetch('/application');
	      return DIV(null, app.dev ? Development() : void 0, current_user.is_super_admin || app.su ? SU() : void 0);
	    })());
	  },
	  resetSelection: function(e) {
	    var loc, opinion_views, page, selected, wysiwyg_editor;
	    loc = fetch('location');
	    page = get_page();
	    if (!fetch('auth').form && page.proposal) {
	      opinion_views = fetch('opinion_views');
	      if (get_selected_point()) {
	        delete loc.query_params.selected;
	        save(loc);
	      } else if (opinion_views.active_views.single_opinion_selected || opinion_views.active_views.region_selected) {
	        clear_histogram_managed_opinion_views(opinion_views);
	      }
	    }
	    if (!fetch('auth').form && loc.url === '/') {
	      opinion_views = fetch('opinion_views');
	      if (opinion_views.active_views.single_opinion_selected || opinion_views.active_views.region_selected) {
	        clear_histogram_managed_opinion_views(opinion_views);
	      }
	    }
	    wysiwyg_editor = fetch('wysiwyg_editor');
	    if (wysiwyg_editor.showing) {
	      selected = document.getSelection();
	      if (selected.isCollapsed) {
	        wysiwyg_editor.showing = false;
	        return save(wysiwyg_editor);
	      }
	    }
	  }
	});
	
	window.Franklin = Root;
	
	window.get_page = function() {
	  return fetch("/page" + (fetch('location').url));
	};
	
	__webpack_require__(27);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var USE_STRICT_MODE, el, height_cache, log_writer, logs_to_write, safe_string, size_cache, videos_viewport_status, width_cache,
	  hasProp = {}.hasOwnProperty;
	
	window.styles = "";
	
	window.screencasting = function() {
	  var ref;
	  if (window.__screencasting == null) {
	    window.__screencasting = ((ref = fetch('location').query_params) != null ? ref.screencasting : void 0) === 'true';
	  }
	  return window.__screencasting;
	};
	
	window.embedded_demo = function() {
	  var ref;
	  if (window.__embedded_demo == null) {
	    window.__embedded_demo = ((ref = fetch('location').query_params) != null ? ref.embedded_demo : void 0) === 'true' || location.search.indexOf('embedded_demo') > -1;
	  }
	  return window.__embedded_demo;
	};
	
	__webpack_require__(22);
	
	__webpack_require__(15);
	
	window.ajax_submit_files_in_form = function(opts) {
	  var cb, form, frm, k, ref, v, xhr;
	  if (opts == null) {
	    opts = {};
	  }
	  cb = function(evt) {
	    var status;
	    if (xhr.readyState === XMLHttpRequest.DONE) {
	      status = xhr.status;
	      if (status === 0 || (status >= 200 && status < 400)) {
	        return typeof opts.success === "function" ? opts.success(xhr.responseText) : void 0;
	      } else {
	        return typeof opts.error === "function" ? opts.error({
	          response: xhr.responseText,
	          status: status
	        }) : void 0;
	      }
	    }
	  };
	  form = document.querySelector(opts.form);
	  frm = new FormData(form);
	  ref = opts.additional_data || {};
	  for (k in ref) {
	    v = ref[k];
	    frm.append(k, v);
	  }
	  xhr = new XMLHttpRequest;
	  xhr.addEventListener('readystatechange', cb, false);
	  xhr.open(opts.type || 'POST', opts.uri || form.getAttribute('action'), true);
	  return xhr.send(frm);
	};
	
	window.pad = function(num, len) {
	  var dec, i, str;
	  str = num;
	  dec = str.split('.');
	  i = 0;
	  while (i < len - dec[0].toString().length) {
	    dec[0] = "0" + dec[0];
	    i += 1;
	  }
	  return dec[0] + (dec.length > 0 ? '.' + dec[1] : '');
	};
	
	window.back_to_homepage_button = function(style, text) {
	  var hash, loc;
	  loc = fetch('location');
	  hash = loc.url.split('/')[1].replace('-', '_');
	  return NAV({
	    role: 'navigation'
	  }, A({
	    className: 'back_to_homepage',
	    title: 'back to homepage',
	    key: 'back_to_homepage_button',
	    "data-no-scroll": true,
	    href: "/#" + hash,
	    style: _.defaults({}, style, {
	      fontSize: 43,
	      visibility: is_a_dialogue_page() || !customization('has_homepage') ? 'hidden' : 'visible',
	      color: 'black',
	      display: 'flex',
	      alignItems: 'center'
	    })
	  }, ChevronLeft(20), text ? SPAN({
	    style: {
	      paddingLeft: 20
	    }
	  }, text) : void 0));
	};
	
	window.get_region_name = function() {
	  var reg, region;
	  region = fetch('/application').region;
	  if (!region) {
	    return "";
	  }
	  if (region === 'US') {
	    reg = "the United States";
	  } else if (region === 'CA') {
	    reg = "Canada";
	  } else if (region === 'EU') {
	    reg = "the European Union";
	  } else {
	    throw "Unknown region " + region;
	  }
	  return translator("server.region_string." + reg, reg);
	};
	
	for (el in ReactDOMFactories) {
	  window[el.toUpperCase()] = React.createFactory(el);
	}
	
	USE_STRICT_MODE = false;
	
	if (USE_STRICT_MODE) {
	  window['STRICTMODE'] = React.createFactory(React.StrictMode);
	}
	
	if (typeof ReactFlipToolkit !== "undefined" && ReactFlipToolkit !== null) {
	  window.FLIPPER = React.createFactory(ReactFlipToolkit.Flipper);
	  window.FLIPPED = React.createFactory(ReactFlipToolkit.Flipped);
	  window.EXITCONTAINER = React.createFactory(ReactFlipToolkit.ExitContainer);
	}
	
	window.LIVE_UPDATE_INTERVAL = 3 * 60 * 1000;
	
	window.live_update = function() {
	  var key, results;
	  results = [];
	  for (key in arest.components_4_key.hash) {
	    if (key[0] === '/' && arest.components_4_key.get(key).length > 0 && !key.match(/\/(current_user|proposal|user|opinion|point|visits|subdomain|application|translations)/)) {
	      results.push(arest.serverFetch(key));
	    } else {
	      results.push(void 0);
	    }
	  }
	  return results;
	};
	
	setInterval(live_update, LIVE_UPDATE_INTERVAL);
	
	(function() {
	  var event, idle_time_before_subdomain_fetch, j, last_activity, len1, ref, reload_subdomain, resetTimer, results, timer;
	  idle_time_before_subdomain_fetch = 30 * 60 * 1000;
	  last_activity = Date.now();
	  reload_subdomain = function() {
	    if (Date.now() - last_activity >= idle_time_before_subdomain_fetch) {
	      return arest.serverFetch('/subdomain');
	    }
	  };
	  timer = setInterval(reload_subdomain, 60 * 1000);
	  resetTimer = function() {
	    return last_activity = Date.now();
	  };
	  window.addEventListener('load', resetTimer, true);
	  ref = ['mousedown', 'mousemove', 'keydown', 'touchstart'];
	  results = [];
	  for (j = 0, len1 = ref.length; j < len1; j++) {
	    event = ref[j];
	    results.push(document.addEventListener(event, resetTimer, true));
	  }
	  return results;
	})();
	
	window.POINT_MOUTH_WIDTH = 17;
	
	window.getCoords = function(el) {
	  var docEl, offset, rect;
	  rect = el.getBoundingClientRect();
	  docEl = document.documentElement;
	  offset = {
	    top: rect.top + window.pageYOffset,
	    left: rect.left + window.pageXOffset
	  };
	  return _.extend(offset, {
	    width: rect.width,
	    height: rect.height,
	    cx: offset.left + rect.width / 2,
	    cy: offset.top + rect.height / 2,
	    right: offset.left + rect.width,
	    bottom: offset.top + rect.height
	  });
	};
	
	window.asset = function(name) {
	  var a, app;
	  app = fetch('/application');
	  if (app.asset_host != null) {
	    a = (app.asset_host || '') + "/images/" + name;
	  } else {
	    a = (window.asset_host || '') + "/images/" + name;
	  }
	  return a;
	};
	
	window.lazyLoadJavascript = function(src, args) {
	  var already_loaded, id, script;
	  id = slugify(src);
	  already_loaded = document.body.querySelector("script#" + id);
	  if (!already_loaded) {
	    script = document.createElement('script');
	    script.type = 'text/javascript';
	    script.id = id;
	    script.src = src;
	    if (args.onload) {
	      script.onload = args.onload;
	    }
	    if (args.onerror) {
	      script.onerror = args.onerror;
	    }
	    document.body.appendChild(script);
	  }
	  return !!already_loaded;
	};
	
	window.LoadScripts = {
	  loadScripts: function() {
	    var done_loading, fn, j, len1, ref, req;
	    if (!this.local.loading && !this.local.loaded) {
	      if (this.scripts_loaded == null) {
	        this.scripts_loaded = {};
	      }
	      done_loading = (function(_this) {
	        return function() {
	          var k, loaded, ref, v;
	          loaded = 0;
	          ref = _this.scripts_loaded;
	          for (k in ref) {
	            v = ref[k];
	            if (v) {
	              loaded += 1;
	            }
	          }
	          return loaded >= (_this.js_dependencies || []).length;
	        };
	      })(this);
	      ref = this.js_dependencies || [];
	      fn = (function(_this) {
	        return function(req) {
	          if (!_this.scripts_loaded[req]) {
	            return _this.scripts_loaded[req] = lazyLoadJavascript((fetch('/application').asset_host) + "/vendor/" + req, {
	              onload: function() {
	                _this.scripts_loaded[req] = true;
	                _this.local.loaded = done_loading();
	                _this.local.loading = !_this.local.loaded;
	                return save(_this.local);
	              },
	              onerror: function() {
	                _this.scripts_loaded[req] = false;
	                _this.local.error = true;
	                _this.local.loaded = false;
	                _this.local.loading = false;
	                return save(_this.local);
	              }
	            });
	          }
	        };
	      })(this);
	      for (j = 0, len1 = ref.length; j < len1; j++) {
	        req = ref[j];
	        fn(req);
	      }
	      return this.local.loading = !done_loading();
	    }
	  }
	};
	
	window.opinionsForProposal = function(proposal) {
	  var opinions;
	  opinions = fetch(proposal).opinions || [];
	  return opinions;
	};
	
	window.namespaced_key = function(base_key, base_object) {
	  var namespace_key;
	  namespace_key = fetch(base_object).key;
	  if (namespace_key[0] === '/') {
	    namespace_key = namespace_key.substring(1, namespace_key.length);
	  }
	  return namespace_key + "_" + base_key;
	};
	
	window.on_ajax_error = function() {
	  var root;
	  root = fetch('root');
	  root.server_error = true;
	  return save(root);
	};
	
	window.on_client_error = function(e) {
	  if (navigator.userAgent.indexOf('PhantomJS') >= 0) {
	    return;
	  }
	  return save({
	    key: '/new/client_error',
	    stack: e.stack,
	    message: e.message || e.description,
	    name: e.name,
	    line_number: e.lineNumber,
	    column_number: e.columnNumber
	  });
	};
	
	logs_to_write = [];
	
	log_writer = null;
	
	window.writeToLog = function(entry) {
	  return;
	  entry.where = fetch('location').url;
	  logs_to_write.push(entry);
	  if (!log_writer) {
	    return setTimeout(function() {
	      return log_writer = setInterval(function() {
	        var j, len1, log;
	        for (j = 0, len1 = logs_to_write.length; j < len1; j++) {
	          log = logs_to_write[j];
	          log.key = '/new/log';
	          save(log);
	        }
	        return logs_to_write = [];
	      }, 100);
	    }, 2000);
	  }
	};
	
	window.prettyDate = function(time) {
	  var date, day_diff, diff, r, subdomain;
	  subdomain = fetch('/subdomain');
	  date = new Date(time);
	  diff = ((new Date()).getTime() - date.getTime()) / 1000;
	  day_diff = Math.floor(diff / 86400);
	  if (isNaN(day_diff) || day_diff < 0) {
	    return;
	  }
	  if (subdomain.lang !== 'en') {
	    return (date.getMonth() + 1) + "/" + (date.getDate()) + "/" + (date.getFullYear());
	  }
	  r = day_diff === 0 && (diff < 60 && "just now" || diff < 120 && "1 minute ago" || diff < 3600 && Math.floor(diff / 60) + " minutes ago" || diff < 7200 && "1 hour ago" || diff < 86400 && Math.floor(diff / 3600) + " hours ago") || day_diff === 1 && "Yesterday" || day_diff < 7 && day_diff + " days ago" || day_diff < 31 && Math.ceil(day_diff / 7) + " weeks ago" || ((date.getMonth() + 1) + "/" + (date.getDate() + 1) + "/" + (date.getFullYear()));
	  r = r.replace('1 days ago', '1 day ago').replace('1 weeks ago', '1 week ago').replace('1 years ago', '1 year ago');
	  return r;
	};
	
	window.inRange = function(val, min, max) {
	  return val <= max && val >= min;
	};
	
	window.capitalize = function(string) {
	  return string.charAt(0).toUpperCase() + string.substring(1);
	};
	
	window.capitalize_each_word = function(str) {
	  return str.replace(/\b\w/g, function(l) {
	    return l.toUpperCase();
	  });
	};
	
	window.loading_indicator = DIV({
	  className: 'loading sk-wave',
	  dangerouslySetInnerHTML: {
	    __html: "<div class=\"sk-rect sk-rect1\"></div>\n<div class=\"sk-rect sk-rect2\"></div>\n<div class=\"sk-rect sk-rect3\"></div>\n<div class=\"sk-rect sk-rect4\"></div>\n<div class=\"sk-rect sk-rect5\"></div>"
	  }
	});
	
	window.LOADING_INDICATOR = window.loading_indicator;
	
	styles += ".sk-wave {\n  margin: 40px auto;\n  width: 50px;\n  height: 40px;\n  text-align: center;\n  font-size: 10px; }\n  .sk-wave .sk-rect {\n    background-color: rgba(223, 98, 100, .5);\n    height: 100%;\n    width: 6px;\n    display: inline-block;\n    -webkit-animation: sk-waveStretchDelay 1.2s infinite ease-in-out;\n            animation: sk-waveStretchDelay 1.2s infinite ease-in-out; }\n  .sk-wave .sk-rect1 {\n    -webkit-animation-delay: -1.2s;\n            animation-delay: -1.2s; }\n  .sk-wave .sk-rect2 {\n    -webkit-animation-delay: -1.1s;\n            animation-delay: -1.1s; }\n  .sk-wave .sk-rect3 {\n    -webkit-animation-delay: -1s;\n            animation-delay: -1s; }\n  .sk-wave .sk-rect4 {\n    -webkit-animation-delay: -0.9s;\n            animation-delay: -0.9s; }\n  .sk-wave .sk-rect5 {\n    -webkit-animation-delay: -0.8s;\n            animation-delay: -0.8s; }\n\n@-webkit-keyframes sk-waveStretchDelay {\n  0%, 40%, 100% {\n    -webkit-transform: scaleY(0.4);\n            transform: scaleY(0.4); }\n  20% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1); } }\n\n@keyframes sk-waveStretchDelay {\n  0%, 40%, 100% {\n    -webkit-transform: scaleY(0.4);\n            transform: scaleY(0.4); }\n  20% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1); } }";
	
	window.shared_local_key = function(key_or_object) {
	  var key;
	  key = key_or_object.key || key_or_object;
	  if (key[0] === '/') {
	    key = key.substring(1, key.length);
	    return key + "/shared";
	  } else {
	    return key;
	  }
	};
	
	window.reset_key = function(obj_or_key, updates) {
	  var k, resetting_totally, v;
	  resetting_totally = !updates;
	  updates = updates || {};
	  if (!obj_or_key.key) {
	    obj_or_key = fetch(obj_or_key);
	  }
	  updates.key = obj_or_key.key;
	  if (obj_or_key.key === 'auth' && (obj_or_key.after != null)) {
	    if (!resetting_totally) {
	      if (updates.after == null) {
	        updates.after = obj_or_key.after;
	      }
	    } else {
	      if (typeof obj_or_key.after === "function") {
	        obj_or_key.after();
	      }
	    }
	  }
	  if (_.isEqual(obj_or_key, updates)) {
	    return;
	  }
	  for (k in obj_or_key) {
	    if (!hasProp.call(obj_or_key, k)) continue;
	    v = obj_or_key[k];
	    if (k !== 'key') {
	      delete obj_or_key[k];
	    }
	  }
	  _.extend(obj_or_key, updates);
	  return save(obj_or_key);
	};
	
	safe_string = function(user_content) {
	  var hyperlink_pattern;
	  user_content = user_content.replace(/(<li>|<br\s?\/?>|<p>)/g, '\n');
	  user_content = user_content.replace(/(<([^>]+)>)/ig, "");
	  hyperlink_pattern = /(^|[\s\n])((?:https?):\/\/[\-A-Z0-9+\u0026\u2019@#\/%?=()\[\]\-\$&\*~_|!:,.;']*[\-A-Z0-9+\u0026@#\/%=~()_|])/gi;
	  user_content = user_content.replace(hyperlink_pattern, "$1(*-&)link:$2(*-&)");
	  return user_content;
	};
	
	window.splitParagraphs = function(user_content, append) {
	  var WRAPPER, idx, j, len1, para, paragraphs, pidx, results, text;
	  if (!user_content) {
	    return SPAN(null);
	  }
	  user_content = safe_string(user_content);
	  paragraphs = user_content.split(/(?:\r?\n)/g);
	  if (paragraphs.length < 2) {
	    WRAPPER = SPAN;
	  } else {
	    WRAPPER = P;
	  }
	  results = [];
	  for (pidx = j = 0, len1 = paragraphs.length; j < len1; pidx = ++j) {
	    para = paragraphs[pidx];
	    results.push(WRAPPER({
	      key: "para-" + pidx
	    }, (function() {
	      var len2, m, ref, results1;
	      ref = para.split('(*-&)');
	      results1 = [];
	      for (idx = m = 0, len2 = ref.length; m < len2; idx = ++m) {
	        text = ref[idx];
	        if (text.substring(0, 5) === 'link:') {
	          results1.push(A({
	            key: idx,
	            href: text.substring(5, text.length),
	            target: '_blank'
	          }, text.substring(5, text.length)));
	        } else {
	          results1.push(SPAN({
	            key: idx
	          }, text));
	        }
	      }
	      return results1;
	    })(), append && pidx === paragraphs.length - 1 ? append : void 0));
	  }
	  return results;
	};
	
	width_cache = {};
	
	window.widthWhenRendered = function(str, style) {
	  var key, parent, width;
	  key = JSON.stringify(_.extend({
	    str: str
	  }, style));
	  if (!(key in width_cache)) {
	    if (style.display == null) {
	      style.display = 'inline-block';
	    }
	    el = document.createElement('span');
	    el.id = "width_test";
	    el.style.setProperty('position', 'absolute');
	    el.style.setProperty('visibility', 'hidden');
	    el.innerHTML = "<span>" + str + "</span>";
	    parent = document.getElementById('content');
	    parent.appendChild(el);
	    $$.setStyles("#width_test", style);
	    width = $$.width(el);
	    parent.removeChild(el);
	    width_cache[key] = width;
	  }
	  return width_cache[key];
	};
	
	height_cache = {};
	
	window.heightWhenRendered = function(str, style, el, skip_caching) {
	  var height, k, key, parent, v;
	  key = JSON.stringify(_.extend({
	    str: str
	  }, style));
	  if ((!(key in height_cache)) || skip_caching) {
	    if (el == null) {
	      el = document.createElement('div');
	    }
	    el.style.position = 'absolute';
	    el.style.visibility = 'hidden';
	    el.innerHTML = "<div>" + str + "</div>";
	    for (k in style) {
	      v = style[k];
	      if (k.indexOf('-') > -1) {
	        el.style.setProperty(k, v);
	      } else {
	        el.style[k] = v;
	      }
	    }
	    parent = document.getElementById('content');
	    parent.appendChild(el);
	    height = $$.height(el);
	    parent.removeChild(el);
	    height_cache[key] = height;
	  }
	  return height_cache[key];
	};
	
	size_cache = {};
	
	window.sizeWhenRendered = function(str, style) {
	  var h, k, key, main, test, v, w;
	  main = document.getElementById('content');
	  if (!main) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	  style || (style = {});
	  style.str = str;
	  key = JSON.stringify(style);
	  delete style.str;
	  if (!(key in size_cache)) {
	    style.display || (style.display = 'inline-block');
	    test = document.createElement("div");
	    test.style.position = 'absolute';
	    test.style.visibility = 'hidden';
	    test.innerHTML = "<div>" + str + "</div>";
	    for (k in style) {
	      v = style[k];
	      key = k.replace(/([A-Z])/g, '-$1').toLowerCase();
	      if (key === 'font-size' || key === 'max-width' || key === 'max-height') {
	        test.style[key] = v + "px";
	      } else {
	        test.style[key] = v;
	      }
	    }
	    main.appendChild(test);
	    h = test.offsetHeight;
	    w = test.offsetWidth;
	    main.removeChild(test);
	    size_cache[key] = {
	      width: w,
	      height: h
	    };
	  }
	  return size_cache[key];
	};
	
	window.translateStanceToPixelX = function(stance, width) {
	  return (stance + 1) / 2 * width;
	};
	
	window.translatePixelXToStance = function(pixel_x, width) {
	  return 2 * (pixel_x / width) - 1;
	};
	
	window.closest = function(node, check) {
	  if (!node || node === document) {
	    return false;
	  } else {
	    return check(node) || closest(node.parentNode, check);
	  }
	};
	
	window.location_origin = function() {
	  if (!window.location.origin) {
	    return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	  } else {
	    return window.location.origin;
	  }
	};
	
	window.focus_color = function() {
	  return focus_blue;
	};
	
	window.css = {};
	
	css.crossbrowserify = function(styles) {
	  return styles;
	};
	
	css.grab_cursor = function(selector) {
	  return selector + " {\n  cursor: move;\n  cursor: ew-resize;\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n} " + selector + ":active {\n  cursor: move;\n  cursor: ew-resize;\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n}";
	};
	
	window.cssTriangle = function(direction, color, width, height, style) {
	  var border_color, border_width;
	  style = style || {};
	  switch (direction) {
	    case 'top':
	      border_width = "0 " + (width / 2) + "px " + height + "px " + (width / 2) + "px";
	      border_color = "transparent transparent " + color + " transparent";
	      break;
	    case 'bottom':
	      border_width = height + "px " + (width / 2) + "px 0 " + (width / 2) + "px";
	      border_color = color + " transparent transparent transparent";
	      break;
	    case 'left':
	      border_width = (height / 2) + "px " + width + "px " + (height / 2) + "px 0";
	      border_color = "transparent " + color + " transparent transparent";
	      break;
	    case 'right':
	      border_width = (height / 2) + "px 0 " + (height / 2) + "px " + width + "px";
	      border_color = "transparent transparent transparent " + color;
	  }
	  _.defaults(style, {
	    width: 0,
	    height: 0,
	    borderStyle: 'solid',
	    borderWidth: border_width,
	    borderColor: border_color
	  });
	  return style;
	};
	
	window.header_font = function() {
	  return customization('header_font') || customization('font');
	};
	
	window.mono_font = function() {
	  return customization('mono_font') || customization('font');
	};
	
	window.responsive_css_rule = function(arg) {
	  var XX, YY, ZZ, max_size, max_vw, min_size, min_vw;
	  min_size = arg.min_size, max_size = arg.max_size, min_vw = arg.min_vw, max_vw = arg.max_vw;
	  XX = min_vw / 100;
	  YY = 100 * (max_size - min_size) / (max_vw - min_vw);
	  ZZ = min_size;
	  return "clamp(" + min_size + "px, calc(" + ZZ + "px + ((1vw - " + XX + "px) * " + YY + ")), " + max_size + "px)";
	};
	
	window.slugify = function(text) {
	  var slug;
	  slug = text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^a-zA-Z0-9_\u3400-\u9FBF\s-]/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
	  if ((text != null ? text.length : void 0) > 0 && (slug != null ? slug.length : void 0) === 0) {
	    slug = md5(text);
	  }
	  return slug;
	};
	
	videos_viewport_status = {};
	
	window.play_videos_when_in_viewport = function(parent_el, args) {
	  var j, len1, observe_video, play_only_topmost_video, play_or_pause_after_event, results, video, video_id, videos;
	  play_only_topmost_video = (args || {}).play_only_topmost_video;
	  videos = parent_el.querySelectorAll('video[autoplay]:not([data-initialized])');
	  video_id = function(video) {
	    return video.getElementsByTagName("source")[0].src;
	  };
	  play_or_pause_after_event = function() {
	    var j, len1, play_rest, results, should_play, video;
	    play_rest = true;
	    results = [];
	    for (j = 0, len1 = videos.length; j < len1; j++) {
	      video = videos[j];
	      if (video.readyState < 1) {
	        continue;
	      }
	      should_play = !document.hidden && videos_viewport_status[video_id(video)];
	      if (should_play && play_rest) {
	        video.play();
	        if (play_only_topmost_video) {
	          results.push(play_rest = false);
	        } else {
	          results.push(void 0);
	        }
	      } else {
	        results.push(video.pause());
	      }
	    }
	    return results;
	  };
	  document.addEventListener('visibilitychange', play_or_pause_after_event);
	  observe_video = function(video) {
	    var id;
	    id = video_id(video);
	    video.setAttribute('data-initialized', "");
	    video.setAttribute('playsinline', "");
	    video.addEventListener("loadstart", function(e) {
	      video.classList.add('loading');
	      if (video.hasAttribute('controls')) {
	        video.setAttribute('data-controls', "");
	      }
	      if (!video.hasAttribute('poster')) {
	        return video.setAttribute('controls', "");
	      }
	    });
	    return video.addEventListener('loadeddata', function(e) {
	      var eligible_to_play, observer, observer_options;
	      if (video.readyState >= 1) {
	        video.classList.remove('loading');
	        if (!video.hasAttribute('data-controls')) {
	          video.removeAttribute('controls');
	        }
	        eligible_to_play = null;
	        observer_options = {
	          root: null,
	          threshold: [1.0]
	        };
	        observer = new IntersectionObserver(function(entries) {
	          return entries.forEach(function(entry) {
	            if (!entry.isIntersecting) {
	              videos_viewport_status[id] = false;
	            } else {
	              videos_viewport_status[id] = true;
	            }
	            return play_or_pause_after_event();
	          });
	        }, observer_options);
	        return observer.observe(video);
	      }
	    });
	  };
	  results = [];
	  for (j = 0, len1 = videos.length; j < len1; j++) {
	    video = videos[j];
	    results.push(observe_video(video));
	  }
	  return results;
	};
	
	window.styles += "\n/* \nhttps://stackoverflow.com/questions/2710764/preserve-html-font-size-when-iphone-orientation-changes-from-portrait-to-landsca \n*/\nhtml {\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;  \n}\n\n\n/* RESET\n * Eric Meyer's Reset CSS v2.0 (http://meyerweb.com/eric/tools/css/reset/)\n * http://cssreset.com\n */\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  line-height: 1.4; }\n\n\n#content .fa {\n  font-family: FontAwesome;  \n}\n\n#content, body, html, .full_height {\n  height: 100%;\n}\n\nbutton {\n  line-height: 1.4;\n}\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid #cccccc;\n  margin: 0;\n  padding: 0; }\n\nbody {\n  min-height: 100%; }\n\nol, ul {\n  list-style: none;\n  list-style-position: inside; }\n\nblockquote, q {\n  quotes: none; }\n\nblockquote:before, blockquote:after,\nq:before, q:after {\n  content: '';\n  content: none; }\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\n\ntd, th {vertical-align: top;}\n\nh1, h2, h3, h4, h5, h6, strong {\n  font-weight: bold; }\n\nem, i {\n  font-style: italic; }\n\nb, strong { font-weight: bold; }\n\n/* ELEMENT DEFAULTS */\n* {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box; \n}\n.goog-te-gadget-simple .goog-te-menu-value span {\n  font-weight: 400;\n}\na {\n  color: inherit;\n  cursor: pointer;\n  text-decoration: underline; \n  font-weight: 700;}\n  a:focus {\n  }\n  a:active {\n  }  \n  a img {\n    border: none; }\n\n:focus {\n}\n.button, button, input[type='submit'] {\n  cursor: pointer;\n  text-align: center; \n  font-size: inherit;\n} .button:focus, button:focus, input[type='submit']:focus {\n} .button:active:focus, button:active:focus, input[type='submit']:active:focus{\n}\n\nbutton.like_link, input[type='submit'].like_link {\n  background: none;\n  border: none;\n  text-decoration: underline;\n  padding: 0px;\n}\n\n.btn {\n  color: white;\n  border: 0;\n  font-weight: 700;\n  padding: .325rem 1.5rem .4rem;\n  line-height: 1.5;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n\n  border-radius: .25rem;\n  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;\n  margin: 0;\n  background-color: " + focus_blue + "; \n} .btn[disabled=\"true\"], .btn[disabled] {\n  cursor: default;\n  opacity: .5;\n}\n\n\ntable {\n  border-collapse: separate; }\n\nul {\n  margin: 0;\n  list-style-type: disc; }\n\nol {\n  margin: 0;\n  list-style-type: decimal; }\n\nblockquote {\n  quotes: '\"' '\"' \"'\" \"'\"; }\n  blockquote:before {\n    content: open-quote;}\n  blockquote:after {\n    content: close-quote;}\n";
	
	window.styles += "\nbody, h1, h2, h3, h4, h5, h6 {\n  color: black; }\n\nhtml[lang='cs'] body, html[lang='cs'] input, html[lang='cs'] button, html[lang='cs'] textarea {\n  font-family: Helvetica, Verdana, Arial, 'Lucida Grande', 'Lucida Sans Unicode', sans-serif; }\n\n\ninput[type=\"checkbox\"], input[type=\"radio\"], button, a {\n  cursor: pointer;\n}\n\ninput[type=\"checkbox\"].bigger, input[type=\"radio\"].bigger {\n  transform: scale(1.5) translate(20%,0);\n  font-size: 24px;\n}\n\n.hidden {\n  position:absolute;\n  left:-10000px;\n  top:auto;\n  width:1px;\n  height:1px;\n  overflow:hidden;}\n\na.skip:active, \na.skip:focus, \na.skip:hover {\n    position: fixed;\n    left: 0; \n    top: 0;\n    width: auto; \n    height: auto; \n    overflow: visible; \n}\n\n\n.content {\n  position: relative;\n  font-size: 16px;\n  color: black;\n  min-height: 100%; \n  font-weight: 400;\n\n  background-color: #ffffff;\n\n}\n\n\n.flipped {\n  -moz-transform: scaleX(-1);\n  -o-transform: scaleX(-1);\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: 'FlipH'; }\n\n.primary_button, .primary_cancel_button {\n  border-radius: 16px;\n  text-align: center;\n  padding: 3px;\n  cursor: pointer; }\n\n.primary_button {\n  color: white;\n  font-size: 29px;\n  margin-top: 14px;\n  border: none;\n  padding: 8px 36px; }\n\nbutton.disabled {\n  background-color: #eeeeee;\n  color: #cccccc;\n  box-shadow: none;\n  border: none;\n  cursor: wait; }\n\n.primary_cancel_button {\n  color: #888888;\n  margin-top: 0.5em; }\n\n.cancel_opinion_button {\n  float: right;\n  background: transparent;\n  border: none;\n  margin-top: 0.5em; }\n\nbutton.primary_button, input[type='submit'] {\n  display: inline-block; }\n\nselect.unstyled:not([multiple]){\n    -webkit-appearance:none;\n    -moz-appearance:none;\n    background-position:right 50%;\n    background-repeat:no-repeat;\n    background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDZFNDEwNjlGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDZFNDEwNkFGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0NkU0MTA2N0Y3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0NkU0MTA2OEY3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuGsgwQAAAA5SURBVHjaYvz//z8DOYCJgUxAf42MQIzTk0D/M+KzkRGPoQSdykiKJrBGpOhgJFYTWNEIiEeAAAMAzNENEOH+do8AAAAASUVORK5CYII=);\n    padding: .5em;\n    padding-right:1.5em;\n    border-radius: 16px;\n}\n";


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __convert, convert_customization, customizations_by_file, masthead_only, text_and_masthead;
	
	window.customizations = {};
	
	customizations_by_file = {};
	
	window._ = _;
	
	window.FUNCTION_IDENTIFIER = "#javascript\n";
	
	convert_customization = function(obj) {
	  return __convert(obj, []);
	};
	
	__convert = function(obj, path) {
	  var func, k, p, str_func, tree, v, vv;
	  if (Array.isArray(obj)) {
	    return (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = obj.length; i < len; i++) {
	        vv = obj[i];
	        results.push(__convert(vv, path));
	      }
	      return results;
	    })();
	  } else if (obj === null) {
	    return null;
	  } else if (typeof obj === 'object') {
	    tree = {};
	    for (k in obj) {
	      v = obj[k];
	      p = path.slice();
	      p.push(k);
	      tree[k] = __convert(v, p);
	    }
	    return tree;
	  } else if (typeof obj === 'function') {
	    return "" + FUNCTION_IDENTIFIER + (obj.toString());
	  } else if (typeof obj === 'string' && obj.startsWith(FUNCTION_IDENTIFIER)) {
	    str_func = obj.substring(FUNCTION_IDENTIFIER.length);
	    func = new Function("return " + str_func)();
	    return func;
	  } else {
	    return obj;
	  }
	};
	
	window.load_customization = function(subdomain) {
	  var customizations_file_used, error, ref, subdomain_name;
	  if (!subdomain.name) {
	    return;
	  }
	  subdomain_name = (ref = subdomain.name) != null ? ref.toLowerCase() : void 0;
	  try {
	    customizations_file_used = !!customizations_by_file[subdomain_name];
	    if (customizations_file_used) {
	      console.log(subdomain_name + " config for import: \n", JSON.stringify(convert_customization(customizations_by_file[subdomain_name]), null, 2));
	    }
	    subdomain = fetch('/subdomain');
	    return customizations[subdomain_name] = _.extend({}, customizations_by_file[subdomain_name] || {}, convert_customization(subdomain.customizations));
	  } catch (error1) {
	    error = error1;
	    return console.error(error);
	  }
	};
	
	window.customization = function(field, object_or_key, subdomain) {
	  var chain_of_configs, config, i, key, len, list_key, obj, proposal, ref, ref1, subdomain_config, subdomain_name, value;
	  if (!!object_or_key && (object_or_key.key == null)) {
	    obj = fetch(object_or_key);
	  } else {
	    obj = object_or_key;
	  }
	  if (subdomain == null) {
	    if (object_or_key != null ? (ref = object_or_key.key) != null ? ref.match('/subdomain/') : void 0 : void 0) {
	      subdomain = object_or_key;
	    } else {
	      subdomain = fetch('/subdomain');
	      if (((obj != null ? obj.subdomain_id : void 0) != null) && obj.subdomain_id !== subdomain.id) {
	        subdomain = fetch("/subdomain/" + obj.subdomain_id);
	      }
	    }
	  }
	  subdomain_name = (ref1 = subdomain.name) != null ? ref1.toLowerCase() : void 0;
	  key = obj ? obj.key ? obj.key : obj : null;
	  chain_of_configs = [];
	  if (customizations[subdomain_name] != null) {
	    subdomain_config = customizations[subdomain_name];
	    if (key) {
	      if (subdomain_config[key] != null) {
	        chain_of_configs.push(subdomain_config[key]);
	      }
	      if (key.match(/\/proposal\//)) {
	        proposal = obj;
	        list_key = get_list_for_proposal(proposal);
	        if (subdomain_config[list_key] != null) {
	          chain_of_configs.push(subdomain_config[list_key]);
	        }
	      }
	    }
	    chain_of_configs.push(subdomain_config);
	  }
	  chain_of_configs.push(customizations['default']);
	  value = void 0;
	  for (i = 0, len = chain_of_configs.length; i < len; i++) {
	    config = chain_of_configs[i];
	    value = config[field];
	    if (value != null) {
	      break;
	    }
	  }
	  return value;
	};
	
	window.CustomizationTransition = ReactiveComponent({
	  displayName: 'CustomizationTransition',
	  render: function() {
	    var check_update_customizations_object, ck, customizations_signature, subdomain;
	    subdomain = fetch('/subdomain');
	    customizations_signature = fetch('customizations_signature');
	    check_update_customizations_object = function() {
	      var signature;
	      signature = JSON.stringify(subdomain.customizations);
	      if (customizations_signature.signature !== signature) {
	        customizations_signature.signature = signature;
	        load_customization(subdomain);
	        save(customizations_signature);
	        return re_render(['/subdomain']);
	      }
	    };
	    ck = setInterval(function() {
	      if (!arest.pending_saves['/subdomain']) {
	        check_update_customizations_object();
	        return clearInterval(ck);
	      }
	    }, 1);
	    return SPAN(null);
	  }
	});
	
	__webpack_require__(4);
	
	__webpack_require__(11);
	
	__webpack_require__(16);
	
	customizations["default"] = {
	  point_labels: point_labels.pro_con,
	  slider_pole_labels: slider_labels.agree_disagree,
	  list_opinions_title: 'Opinions',
	  list_items_title: 'Proposals',
	  discussion_enabled: true,
	  homepage_show_search_and_sort: true,
	  list_permit_new_items: true,
	  homepage_show_new_proposal_button: true,
	  show_proposal_meta_data: true,
	  slider_handle: slider_handle.flat,
	  slider_regions: null,
	  show_proposal_scores: true,
	  show_proposer_icon: true,
	  collapse_proposal_description_at: 300,
	  list_is_archived: false,
	  list_uncollapseable: false,
	  list_item_name: 'Proposal',
	  auth_footer: false,
	  has_homepage: true,
	  auth_callout: true,
	  user_tags: {},
	  font: "IBM Plex Sans, Helvetica Neue, sans-serif",
	  header_font: "IBM Plex Sans, IBM Plex Sans, Helvetica Neue, sans-serif",
	  condensed_font: "IBM Plex Sans Condensed, IBM Plex Sans, Helvetica Neue, sans-serif",
	  mono_font: "IBM Plex Mono, Menlo, Consolas, Monaco, Fira Mono, Liberation Mono, Lucida Console, monospace",
	  new_proposal_fields: function() {
	    return {
	      name: translator("engage.edit_proposal.summary_label", "Summary"),
	      description: translator("engage.edit_proposal.description_label", "Details") + (" (" + (translator('optional', 'optional')) + ")"),
	      additional_fields: [],
	      create_description: function(fields) {
	        return fields.description;
	      }
	    };
	  }
	};
	
	text_and_masthead = ['educacion2025', 'ynpn', 'lsfyl', 'kealaiwikuamoo', 'iwikuamoo'];
	
	masthead_only = ["kamakakoi", "seattletimes", "kevin", "ihub", "SilverLakeNC", "Relief-Demo", "GS-Demo", "ri", "ITFeedback", "Committee-Meeting", "policyninja", "SocialSecurityWorks", "amberoon", "economist", "impacthub-demo", "mos", "Cattaca", "Airbdsm", "bitcoin-ukraine", "lyftoff", "hcao", "arlingtoncountyfair", "progressive", "design", "crm", "safenetwork", "librofm", "washingtonpost", "MSNBC", "PublicForum", "AMA-RFS", "AmySchumer", "VillaGB", "AwesomeHenri", "citySENS", "alcala", "MovilidadCDMX", "deus_ex", "neuwrite", "bitesizebio", "HowScienceIsMade", "SABF", "engagedpublic", "sabfteam", "Tunisia", "theartofco", "SGU", "radiolab", "ThisLand", "Actuality", 'cimsec', 'sosh', 'swotconsultants'];
	
	setTimeout(function() {
	  var i, j, len, len1, results, sub;
	  if (typeof ImageHeader !== "undefined" && ImageHeader !== null) {
	    window.LegacyImageHeader = ImageHeader;
	    for (i = 0, len = text_and_masthead.length; i < len; i++) {
	      sub = text_and_masthead[i];
	      customizations_by_file[sub.toLowerCase()] = {
	        HomepageHeader: LegacyImageHeader
	      };
	    }
	    results = [];
	    for (j = 0, len1 = masthead_only.length; j < len1; j++) {
	      sub = masthead_only[j];
	      results.push(customizations_by_file[sub.toLowerCase()] = {
	        HomepageHeader: LegacyImageHeader
	      });
	    }
	    return results;
	  }
	});


/***/ },
/* 3 */
/***/ function(module, exports) {

	var is_android_browser, rxaosp;
	
	rxaosp = window.navigator.userAgent.match(/Android.*AppleWebKit\/([\d.]+)/);
	
	is_android_browser = !!(rxaosp && rxaosp[1] < 537);
	
	window.browser = {
	  key: 'browser',
	  is_android_browser: is_android_browser,
	  is_opera_mini: !!navigator.userAgent.match(/Opera Mini/),
	  high_density_display: (window.matchMedia && (window.matchMedia('(min-resolution: 124dpi), \n(min-resolution: 1.3dppx), \n(min-resolution: 48.8dpcm)').matches || window.matchMedia('(-webkit-min-device-pixel-ratio: 1.3), \n(-o-min-device-pixel-ratio: 2.6/2), \n(min--moz-device-pixel-ratio: 1.3), \n(min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3),
	  is_mobile: is_android_browser || navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i),
	  touch: matchMedia('(hover: none)').matches
	};
	
	save(browser);
	
	window.BrowserHacks = ReactiveComponent({
	  displayName: 'BrowserHacks',
	  render: function() {
	    var browser;
	    browser = fetch('browser');
	    if (browser.is_opera_mini) {
	      return DIV({
	        style: {
	          backgroundColor: 'red',
	          padding: 10,
	          textAlign: 'center',
	          color: 'white',
	          fontSize: 24
	        }
	      }, "This website does not work well with ", browser.is_android_browser ? 'the Android Browser' : 'Opera Mini', ". Please use ", A({
	        href: "https://play.google.com/store/apps/details?id=com.android.chrome&hl=en",
	        style: {
	          color: 'white',
	          textDecoration: 'underline'
	        }
	      }, 'Chrome for Android'), ' if you experience difficulty. Thanks, and sorry for the inconvenience!');
	    } else {
	      return SCRIPT({
	        type: 'text/javascript',
	        src: '//browser-update.org/update.js'
	      });
	    }
	  }
	});


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var addEventListener, location, old_A, parseURL, popstate_event, ref, relativeURLFromLocation, relativeURLFromStatebus,
	  hasProp = {}.hasOwnProperty;
	
	__webpack_require__(1);
	
	__webpack_require__(3);
	
	window.is_a_dialogue_page = function() {
	  var url;
	  url = fetch('location').url;
	  return url.indexOf('/dashboard') === -1 && url.indexOf('/docs/') === -1;
	};
	
	parseURL = function(url) {
	  var alt_search, i, parser, pathname, queries, searchObject, split;
	  parser = document.createElement('a');
	  parser.href = url;
	  pathname = parser.pathname || '/';
	  if (pathname[0] !== '/') {
	    pathname = "/" + pathname;
	  }
	  searchObject = {};
	  alt_search = new URLSearchParams(parser.search);
	  queries = parser.search.replace(/^\?/, '').split('&');
	  i = 0;
	  while (i < queries.length) {
	    if (queries[i].length > 0) {
	      split = queries[i].split('=');
	      searchObject[split[0]] = alt_search.get(split[0]);
	    }
	    i++;
	  }
	  return {
	    protocol: parser.protocol,
	    host: parser.host,
	    hostname: parser.hostname,
	    port: parser.port,
	    pathname: pathname,
	    search: parser.search,
	    searchObject: searchObject,
	    hash: parser.hash
	  };
	};
	
	window.loadPage = function(url, query_params, triggered_by) {
	  var hash, k, loc, ref, url_parts, v;
	  loc = fetch('location');
	  loc.query_params = query_params || {};
	  url_parts = parseURL("" + (location_origin()) + url);
	  ref = url_parts.searchObject;
	  for (k in ref) {
	    v = ref[k];
	    if (k.length > 0) {
	      loc.query_params[decodeURIComponent(k)] = decodeURIComponent(v);
	    }
	  }
	  if (loc.query_params.u) {
	    delete loc.query_params.u;
	  }
	  if (loc.query_params.t) {
	    delete loc.query_params.t;
	  }
	  hash = url_parts.hash;
	  if (hash && hash.length > 0) {
	    hash = hash.substring(1);
	    loc.seek_to_hash = hash;
	  }
	  loc.url = decodeURIComponent(url_parts.pathname);
	  loc.hash = hash;
	  loc.triggered_by = triggered_by;
	  return save(loc);
	};
	
	old_A = A;
	
	window.is_swipping = false;
	
	window.A = React.createFactory(createReactClass({
	  displayName: 'modified_A',
	  render: function() {
	    var props;
	    props = _.extend({}, this.props);
	    if (props.treat_as_external_link != null) {
	      delete props.treat_as_external_link;
	    }
	    if (props.href) {
	      this._onclick = props.onClick || (function() {
	        return null;
	      });
	      if (browser.is_mobile) {
	        props.onTouchEnd = (function(_this) {
	          return function(e) {
	            if (!is_swipping) {
	              return _this.handleClick(e);
	            }
	          };
	        })(this);
	        if (browser.is_android_browser) {
	          props.onClick = function(e) {
	            e.preventDefault();
	            return e.stopPropagation();
	          };
	        }
	      } else {
	        props.onClick = this.handleClick;
	      }
	    }
	    return old_A(props, props.children);
	  },
	  handleClick: function(event) {
	    var href, is_external_link, is_mailto, no_scroll, node, opened_in_new_tab;
	    node = ReactDOM.findDOMNode(this);
	    no_scroll = node.getAttribute('data-no-scroll');
	    href = node.getAttribute('href');
	    is_external_link = href.indexOf('//') > -1 || this.props.treat_as_external_link;
	    is_mailto = href.toLowerCase().indexOf('mailto') > -1;
	    opened_in_new_tab = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
	    if (!is_external_link && !opened_in_new_tab && !is_mailto && !node.getAttribute('data-nojax')) {
	      event.preventDefault();
	      event.stopPropagation();
	      loadPage(href);
	      this._onclick(event);
	      return setTimeout((function(_this) {
	        return function() {
	          if (!no_scroll || no_scroll === 'false') {
	            return window.scrollTo(0, 0);
	          }
	        };
	      })(this), 1);
	    } else {
	      return this._onclick(event);
	    }
	  }
	}));
	
	window.BrowserLocation = ReactiveComponent({
	  displayName: 'BrowserLocation',
	  render: function() {
	    var doc, loc, new_location, title;
	    loc = fetch('location');
	    doc = fetch('document');
	    title = doc.title || document.title;
	    if (doc.title && document.title !== doc.title) {
	      document.title = doc.title;
	    }
	    new_location = relativeURLFromStatebus();
	    if (this.last_location !== new_location) {
	      if (relativeURLFromLocation() !== new_location) {
	        history.pushState(loc.query_params, title, new_location);
	      }
	      this.last_location = new_location;
	      writeToLog({
	        what: 'changing url',
	        where: loc.url
	      });
	    }
	    return SPAN(null);
	  },
	  componentDidUpdate: function() {
	    var int, loc;
	    loc = fetch('location');
	    if (loc.seek_to_hash) {
	      loc.seek_to_hash = false;
	      save(loc);
	      return int = setInterval(function() {
	        var docks, e, el, noop, seek_below;
	        el = null;
	        try {
	          el = document.querySelector("#" + loc.hash);
	        } catch (error) {
	          e = error;
	          noop = 1;
	        }
	        el || (el = document.querySelector("[name=\"" + loc.hash + "\"]") || document.querySelector("#p" + loc.hash));
	        if (el) {
	          docks = fetch('docking_station');
	          seek_below = docks.y_stack || 50;
	          window.scrollTo(0, getCoords(el).top - seek_below);
	          el.focus();
	          return clearInterval(int);
	        }
	      }, 100);
	    }
	  }
	});
	
	relativeURLFromLocation = function() {
	  var loc, ref, ref1, search;
	  search = (ref = location.search) != null ? ref.replace(/\%2[fF]/g, '/') : void 0;
	  loc = (ref1 = location.pathname) != null ? ref1.replace(/\%20/g, ' ') : void 0;
	  return "" + loc + search + location.hash;
	};
	
	relativeURLFromStatebus = function() {
	  var k, loc, query_params, ref, relative_url, v;
	  loc = fetch('location');
	  relative_url = loc.url;
	  if (_.keys(loc.query_params).length > 0) {
	    query_params = (function() {
	      var ref, results;
	      ref = loc.query_params;
	      results = [];
	      for (k in ref) {
	        if (!hasProp.call(ref, k)) continue;
	        v = ref[k];
	        results.push(k + "=" + (encodeURIComponent(v)));
	      }
	      return results;
	    })();
	    relative_url += "?" + (query_params.join('&'));
	  }
	  if (((ref = loc.hash) != null ? ref.length : void 0) > 0) {
	    relative_url += "#" + loc.hash;
	  }
	  return relative_url;
	};
	
	location = window.history.location || window.location;
	
	ref = window.addEventListener ? ['addEventListener', 'popstate'] : ['attachEvent', 'onpopstate'], addEventListener = ref[0], popstate_event = ref[1];
	
	window[addEventListener](popstate_event, function(ev) {
	  return loadPage(relativeURLFromLocation());
	});
	
	loadPage(relativeURLFromLocation());


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(4);
	
	__webpack_require__(2);
	
	__webpack_require__(1);
	
	__webpack_require__(9);
	
	window.AuthCallout = ReactiveComponent({
	  displayName: 'AuthCallout',
	  render: function() {
	    var create_account_button_style, current_user, subdomain;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    if (current_user.logged_in || customization('contribution_phase') === 'frozen') {
	      return SPAN(null);
	    }
	    create_account_button_style = {
	      marginRight: 8
	    };
	    return DIV({
	      style: {
	        width: '100%'
	      }
	    }, DIV({
	      style: {
	        padding: 12,
	        textAlign: 'center'
	      }
	    }, DIV({
	      style: {
	        fontSize: PHONE_SIZE() ? 16 : 20,
	        fontWeight: 600
	      }
	    }, AUTH_CALLOUT_BUTTONS(create_account_button_style), indexOf.call(subdomain.roles.participant, '*') < 0 ? DIV({
	      style: {
	        fontSize: 12,
	        marginTop: 4
	      }
	    }, translator('engage.permissions.only_some_participate', 'Only some accounts are authorized to participate.')) : void 0), this.props.children ? this.props.children : void 0));
	  }
	});
	
	window.AUTH_CALLOUT_BUTTONS = function(button_style) {
	  var subdomain;
	  if (button_style == null) {
	    button_style = {};
	  }
	  if (PHONE_SIZE()) {
	    _.extend(button_style, {
	      display: 'block',
	      margin: 'auto'
	    });
	  }
	  subdomain = fetch('/subdomain');
	  if (subdomain.SSO_domain) {
	    return TRANSLATE({
	      id: 'create_account.call_out',
	      BUTTON1: {
	        component: A,
	        args: {
	          className: "btn create_account",
	          href: '/login_via_saml',
	          treat_as_external_link: true,
	          style: button_style
	        }
	      }
	    }, "<BUTTON1>Create an Account</BUTTON1> to share your thoughts");
	  } else if (embedded_demo()) {
	    return DIV(null, BUTTON({
	      key: 'create_button',
	      'data-action': 'create',
	      onClick: (function(_this) {
	        return function(e) {
	          return reset_key('auth', {
	            form: 'create account'
	          });
	        };
	      })(this),
	      style: button_style,
	      className: "btn create_account"
	    }, "Choose a persona"), "to participate here");
	  } else {
	    return TRANSLATE({
	      id: 'create_account.call_out',
	      BUTTON1: {
	        component: BUTTON,
	        args: {
	          key: 'create_button',
	          'data-action': 'create',
	          onClick: (function(_this) {
	            return function(e) {
	              return reset_key('auth', {
	                form: 'create account'
	              });
	            };
	          })(this),
	          style: button_style,
	          className: "btn create_account"
	        }
	      }
	    }, "<BUTTON1>Create an Account</BUTTON1> to share your thoughts");
	  }
	};
	
	window.AuthTransition = ReactiveComponent({
	  displayName: 'AuthTransition',
	  render: function() {
	    var allegiance, auth, avatar_url, base, current_user, email, id, name, ref, subdomain;
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if ((base = this.local).logged_in_last_render == null) {
	      base.logged_in_last_render = current_user.logged_in;
	    }
	    if (current_user.csrf) {
	      arest.csrf();
	    }
	    if (this.local.current_auth !== auth.form) {
	      this.local.current_auth = auth.form;
	      current_user.errors = [];
	    }
	    if ((auth.form !== 'user questions' && !this.local.logged_in_last_render && current_user.logged_in && !auth.show_user_questions_after_account_creation) || (auth.form === 'verify email' && current_user.verified) || (auth.form === 'user questions' && (current_user.completed_host_questions && !auth.show_user_questions_after_account_creation)) || (auth.form === 'create account via invitation' && !current_user.needs_to_complete_profile)) {
	      reset_key(auth);
	    }
	    if (current_user.needs_to_complete_profile && ((ref = auth.form) !== 'edit profile' && ref !== 'create account via invitation')) {
	      subdomain = fetch('/subdomain');
	      reset_key('auth', {
	        key: 'auth',
	        form: subdomain.SSO_domain ? 'edit profile' : 'create account via invitation',
	        goal: ''
	      });
	      if (subdomain.SSO_domain) {
	        loadPage('/dashboard/edit_profile');
	      }
	    } else if (current_user.logged_in && ((!current_user.completed_host_questions && !auth.form) || auth.show_user_questions_after_account_creation)) {
	      reset_key('auth', {
	        form: 'user questions',
	        goal: '',
	        show_user_questions_after_account_creation: auth.show_user_questions_after_account_creation
	      });
	    } else if (current_user.needs_to_verify && !window.send_verification_token) {
	      current_user.trying_to = 'send_verification_token';
	      save(current_user);
	      window.send_verification_token = true;
	      reset_key('auth', {
	        key: 'auth',
	        form: 'verify email',
	        goal: 'To participate, please demonstrate you control this email.'
	      });
	    }
	    this.local.logged_in_last_render = current_user.logged_in;
	    if (embedded_demo() && fetch('/subdomain').name === 'galacticfederation') {
	      if (auth.form === 'create account') {
	        id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 15);
	        _.extend(current_user, {
	          name: "temp",
	          email: "temp-" + id + "@galacticfederation.gov",
	          password: "" + (Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 15)),
	          trying_to: 'create account'
	        });
	        save(current_user);
	        reset_key('auth', {
	          form: 'user questions',
	          goal: "",
	          after: auth.after,
	          show_user_questions_after_account_creation: auth.show_user_questions_after_account_creation
	        });
	      } else if (current_user.tags.federation_allegiance && current_user.name === 'temp') {
	        allegiance = current_user.tags.federation_allegiance;
	        id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 15);
	        switch (allegiance) {
	          case 'Dark':
	            name = "Stormtrooper #" + id;
	            email = "stormtrooper-" + id + "@deathstar.org";
	            avatar_url = "https://d2rtgkroh5y135.cloudfront.net/system/avatars/287330/large/stormtrooper1.png";
	            break;
	          case 'Light':
	            name = "Ewok #" + id;
	            email = "endorite-" + id + "@endor.net";
	            avatar_url = "https://f.consider.it/galacticfederation/ewok.png";
	            break;
	          case "Wouldn't you like to know":
	            name = "Wookiee #" + id;
	            email = "kashyyyk-wook" + id + "@oo.com";
	            avatar_url = 'https://f.consider.it/galacticfederation/wookiee.jpeg';
	            break;
	          case 'Non-binary':
	            name = "Rodian #" + id;
	            email = "rodia-" + id + "@bountyhuntersrus.com";
	            avatar_url = 'https://f.consider.it/galacticfederation/rodian.jpeg';
	            break;
	        }
	        _.extend(current_user, {
	          name: name,
	          email: email,
	          avatar_url: avatar_url
	        });
	        save(current_user);
	        poll_until_avatar_arrives();
	      }
	    }
	    return SPAN(null);
	  }
	});
	
	window.Auth = ReactiveComponent({
	  displayName: 'Auth',
	  render: function() {
	    var auth, current_user;
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (auth.form === 'reset password') {
	      return ResetPassword(this.props);
	    } else if (auth.form === 'verify email') {
	      return VerifyEmail(this.props);
	    } else if (auth.form === 'login') {
	      return Login(this.props);
	    } else if (auth.form === 'create account') {
	      return CreateAccount(this.props);
	    } else if (auth.form === 'create account via invitation') {
	      return CreateAccount({
	        by_invitation: true
	      });
	    } else if (auth.form === 'user questions') {
	      return HostQuestions(this.props);
	    } else {
	      return SPAN(null);
	    }
	  },
	  componentDidMount: function() {
	    return writeToLog({
	      what: 'accessed authentication'
	    });
	  }
	});
	
	window.logout = function() {
	  var auth, current_user, loc;
	  current_user = fetch('/current_user');
	  current_user.logged_in = false;
	  current_user.trying_to = 'logout';
	  auth = fetch('auth');
	  loc = fetch('location');
	  if (loc.url.match('/dashboard')) {
	    loadPage('/');
	  }
	  reset_key(auth);
	  return save(current_user, (function(_this) {
	    return function() {
	      return location.reload();
	    };
	  })(this));
	};
	
	window.auth_text_gray = '#444';
	
	window.styles += ".AUTH {}\n\n#AUTH_wrapper {\n  margin: 0 auto;\n  position: relative;\n  z-index: 0;\n  padding: 3em 0;\n}\n\n.AUTH_header {\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n#AUTH_goal {\n  font-size: 16px;\n  text-align: center;\n  color: white;\n  margin-bottom: 8px;\n  font-style: italic;\n}\n\n#AUTH_task {\n  font-size: 38px;\n  font-weight: 700;\n  margin-bottom: 18px;\n}\n\n.AUTH_body_wrapper {\n  padding: 3.5em 105px 4em 90px;\n  font-size: 16px;\n  box-shadow: 0 2px 4px rgba(0,0,0,.4), 0 0 100px rgb(255 255 255 / 40%);\n  background-color: white;\n  position: relative;\n  border-radius: 16px;\n}\n\n.AUTH_cancel {\n  background-color: transparent;\n  border: none;\n  opacity: .7;\n}\n\n.AUTH_cancel.floating {\n  color: white;\n  position: absolute;\n  cursor: pointer;\n  right: -46px;\n  top: 16px;\n  padding: 10px;\n  font-size: 24px;\n}\n.AUTH_cancel.embedded {\n  margin: 8px auto 0px auto;\n  padding: 8px 0 8px 8px;\n  font-size: 18px;\n}\n\n@media " + PHONE_MEDIA + " {\n  .AUTH_cancel.floating {\n    display: none;\n  }\n}\n\n.AUTH_submit_button {\n  font-size: 22px;\n  display: block;\n  width: 100%;\n  margin-top: 20px;\n  border-radius: 16px;\n  padding: .8rem 1.5rem .8rem;\n  background-color: " + selected_color + ";\n}\n\n.AUTH_field_wrapper {\n  margin-bottom: 12px;\n}\n\n.AUTH_field_label {\n  color: #444;\n  font-size: 12px;\n  display: block;\n  text-transform: uppercase;\n}\n\n.AUTH_text_input {\n  margin-bottom: 6px;\n  width: 100%;\n  border: 1px solid #ccc;\n  padding: 10px 14px;\n  font-size: 20px;\n  display: inline-block;\n  background-color: #f2f2f2;\n}\n\n\n@media " + PHONE_MEDIA + " {\n  .AUTH_body_wrapper {\n    padding: 2em 16px;\n  }\n  #AUTH_task {\n    font-size: 28px;      \n  }\n}\n\n";
	
	window.AuthForm = {
	  Draw: function(options, children) {
	    var cancel_modal;
	    cancel_modal = function(e) {
	      if (typeof options.before_cancel === "function") {
	        options.before_cancel();
	      }
	      if (location.pathname === '/proposal/new') {
	        loadPage('/');
	      }
	      return reset_key('auth');
	    };
	    return DIV({
	      className: 'AUTH'
	    }, !this.props.no_modal ? DIV({
	      id: 'lightbox'
	    }) : void 0, DIV({
	      id: !this.props.no_modal ? 'modal' : void 0,
	      ref: !this.props.no_modal ? 'dialog' : void 0,
	      role: !this.props.no_modal ? 'dialog' : void 0,
	      'aria-labelledby': 'AUTH_task',
	      'aria-describedby': options.goal ? 'AUTH_goal' : void 0
	    }, DIV({
	      id: 'AUTH_wrapper',
	      style: {
	        maxWidth: AUTH_WIDTH()
	      }
	    }, !options.disallow_cancel && !this.props.disallow_cancel ? BUTTON({
	      className: 'AUTH_cancel floating',
	      title: translator('shared.cancel_button', 'cancel'),
	      onClick: cancel_modal
	    }, DIV({
	      dangerouslySetInnerHTML: {
	        __html: '<svg x="0px" y="0px" fill="white" viewBox="0 0 64 80" enable-background="new 0 0 64 64" xml:space="preserve"><g><path d="M17.586,46.414C17.977,46.805,18.488,47,19,47s1.023-0.195,1.414-0.586L32,34.828l11.586,11.586   C43.977,46.805,44.488,47,45,47s1.023-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828L34.828,32l11.586-11.586   c0.781-0.781,0.781-2.047,0-2.828c-0.781-0.781-2.047-0.781-2.828,0L32,29.172L20.414,17.586c-0.781-0.781-2.047-0.781-2.828,0   c-0.781,0.781-0.781,2.047,0,2.828L29.172,32L17.586,43.586C16.805,44.367,16.805,45.633,17.586,46.414z"/><path d="M32,64c8.547,0,16.583-3.329,22.626-9.373C60.671,48.583,64,40.547,64,32s-3.329-16.583-9.374-22.626   C48.583,3.329,40.547,0,32,0S15.417,3.329,9.374,9.373C3.329,15.417,0,23.453,0,32s3.329,16.583,9.374,22.626   C15.417,60.671,23.453,64,32,64z M12.202,12.202C17.49,6.913,24.521,4,32,4s14.51,2.913,19.798,8.202C57.087,17.49,60,24.521,60,32   s-2.913,14.51-8.202,19.798C46.51,57.087,39.479,60,32,60s-14.51-2.913-19.798-8.202C6.913,46.51,4,39.479,4,32   S6.913,17.49,12.202,12.202z"/></g></svg>'
	      },
	      style: {
	        width: 30
	      }
	    })) : void 0, options.goal ? DIV({
	      id: 'AUTH_goal'
	    }, options.goal) : void 0, DIV({
	      className: "AUTH_body_wrapper"
	    }, DIV({
	      className: 'AUTH_header'
	    }, H1({
	      id: 'AUTH_task'
	    }, options.task), typeof options.render_below_title === "function" ? options.render_below_title() : void 0), children, BUTTON({
	      className: "btn AUTH_submit_button " + (this.local.submitting ? 'disabled' : void 0),
	      onClick: options.on_submit
	    }, options.submit_button || this.i18n().submit_button), !options.disallow_cancel ? DIV({
	      style: {
	        textAlign: 'center'
	      }
	    }, BUTTON({
	      ref: 'cancel_dialog',
	      className: 'AUTH_cancel embedded',
	      title: translator('shared.cancel_button', 'cancel'),
	      onClick: cancel_modal
	    }, translator('shared.cancel_button', 'cancel'))) : void 0, options.under_submit ? options.under_submit : void 0))));
	  },
	  RenderInput: function(opts) {
	    var base, base1, current_user, field_id, name, type;
	    current_user = fetch('/current_user');
	    type = opts.type || 'text';
	    name = opts.name;
	    field_id = "user_" + name;
	    if ((base = this.local).updates == null) {
	      base.updates = {};
	    }
	    if ((base1 = this.local.updates)[name] == null) {
	      base1[name] = current_user[name];
	    }
	    return DIV({
	      key: field_id,
	      className: 'AUTH_field_wrapper',
	      style: {
	        opacity: opts.disabled ? .5 : void 0
	      }
	    }, LABEL({
	      className: 'AUTH_field_label',
	      htmlFor: field_id
	    }, opts.label), opts.render ? opts.render() : INPUT({
	      id: 'user_' + name,
	      key: name + "_inputBox",
	      name: "user[" + name + "]",
	      type: type,
	      className: 'AUTH_text_input',
	      defaultValue: this.local.updates[name],
	      'aria-label': opts.label,
	      autoComplete: 'off',
	      disabled: opts.disabled,
	      onChange: (function(_this) {
	        return function(event) {
	          if (type === 'email') {
	            _this.local.updates[name] = event.target.value.trim();
	          } else {
	            _this.local.updates[name] = event.target.value;
	          }
	          return save(_this.local);
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(event) {
	          if (event.which === 13) {
	            return opts.on_submit(event);
	          }
	        };
	      })(this)
	    }));
	  },
	  Submit: function(ev, opts) {
	    var current_user;
	    current_user = fetch('/current_user');
	    ev.preventDefault();
	    if (opts == null) {
	      opts = {};
	    }
	    if (opts.has_host_questions) {
	      this.local.errors = errors_in_host_questions(current_user.tags);
	    } else {
	      this.local.errors = [];
	    }
	    if (this.local.errors.length === 0) {
	      current_user.trying_to = opts.action;
	      if (this.local.updates) {
	        _.extend(current_user, this.local.updates);
	      }
	      this.local.submitting = true;
	      save(current_user, (function(_this) {
	        return function() {
	          _this.local.saved_successfully = current_user.errors.length + _this.local.errors.length === 0;
	          _this.local.submitting = false;
	          save(_this.local);
	          if (_this.local.saved_successfully) {
	            return typeof opts.onSuccess === "function" ? opts.onSuccess() : void 0;
	          }
	        };
	      })(this));
	      if (opts.has_avatar_upload) {
	        upload_avatar();
	      }
	    }
	    return save(this.local);
	  },
	  ShowErrors: function(errors) {
	    var current_user, error;
	    current_user = fetch('/current_user');
	    errors = (current_user.errors || []).concat(this.local.errors || []);
	    if (!errors || errors.length === 0) {
	      return SPAN(null);
	    }
	    return DIV({
	      role: 'alert',
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = errors.length; i < len; i++) {
	        error = errors[i];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    })());
	  },
	  i18n: function() {
	    return {
	      name_label: translator('auth.create.name_label', 'Your name or pseudonym'),
	      email_label: translator('auth.login.email_label', 'Your email'),
	      password_label: translator('auth.login.password_label', 'Your password'),
	      old_password_label: translator('auth.login.old_password_label', 'Your old password'),
	      new_password_label: translator('auth.login.new_password_label', 'New password'),
	      pic_prompt: translator('auth.create.pic_prompt', 'Your picture'),
	      code_label: translator('auth.code_entry', 'Code'),
	      successful_update: translator("auth.successful_update", "Updated successfully"),
	      verification_sent_message: translator('auth.verification_sent', 'We just emailed you a verification code. Copy / paste it below.'),
	      submit_button: translator("auth.submit", 'Done')
	    };
	  }
	};
	
	__webpack_require__(32);
	
	__webpack_require__(30);
	
	__webpack_require__(33);
	
	__webpack_require__(28);
	
	__webpack_require__(29);


/***/ },
/* 6 */
/***/ function(module, exports) {

	/**
	 * JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)
	 * 
	 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
	 * @see http://github.com/garycourt/murmurhash-js
	 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
	 * @see http://sites.google.com/site/murmurhash/
	 * 
	 * @param {string} key ASCII only
	 * @param {number} seed Positive integer only
	 * @return {number} 32-bit positive integer hash 
	 */
	
	function murmurhash3_32_gc(key, seed) {
	  var remainder, bytes, h1, h1b, c1, c1b, c2, c2b, k1, i;
	  
	  remainder = key.length & 3; // key.length % 4
	  bytes = key.length - remainder;
	  h1 = seed;
	  c1 = 0xcc9e2d51;
	  c2 = 0x1b873593;
	  i = 0;
	  
	  while (i < bytes) {
	      k1 = 
	        ((key.charCodeAt(i) & 0xff)) |
	        ((key.charCodeAt(++i) & 0xff) << 8) |
	        ((key.charCodeAt(++i) & 0xff) << 16) |
	        ((key.charCodeAt(++i) & 0xff) << 24);
	    ++i;
	    
	    k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
	    k1 = (k1 << 15) | (k1 >>> 17);
	    k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;
	
	    h1 ^= k1;
	        h1 = (h1 << 13) | (h1 >>> 19);
	    h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
	    h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
	  }
	  
	  k1 = 0;
	  
	  switch (remainder) {
	    case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
	    case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
	    case 1: k1 ^= (key.charCodeAt(i) & 0xff);
	    
	    k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
	    k1 = (k1 << 15) | (k1 >>> 17);
	    k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
	    h1 ^= k1;
	  }
	  
	  h1 ^= key.length;
	
	  h1 ^= h1 >>> 16;
	  h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
	  h1 ^= h1 >>> 13;
	  h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
	  h1 ^= h1 >>> 16;
	
	  return h1 >>> 0;
	}
	
	
	window.murmurhash = murmurhash3_32_gc
	


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	
	__webpack_require__(12);
	
	window.Bubblemouth = function(props) {
	  var apex, bubblemouth_path, cx, full_width, id, qx1, qx2, qy1, qy2, ref, ref1, ref2, ref3, ref4, skew_x, skew_y, svg_h, svg_w, x1, x2, x3, x_pad, y1, y2, y3;
	  _.defaults(props, {
	    svg_w: 85,
	    svg_h: 100,
	    skew_x: 15,
	    skew_y: 80,
	    apex_xfrac: .5,
	    fill: 'white',
	    stroke: focus_color(),
	    stroke_width: 10,
	    box_shadow: null
	  });
	  full_width = props.svg_w + 4 * props.skew_x * Math.max(.5, Math.abs(.5 - props.apex_xfrac));
	  _.defaults(props, {
	    width: full_width,
	    height: props.svg_h
	  });
	  apex = props.apex_xfrac;
	  svg_w = props.svg_w;
	  svg_h = props.svg_h;
	  skew_x = props.skew_x;
	  skew_y = props.skew_y;
	  cx = skew_x + svg_w / 2;
	  ref = [skew_x - apex * skew_x, svg_h], x1 = ref[0], y1 = ref[1];
	  ref1 = [skew_x + apex * svg_w, 0], x2 = ref1[0], y2 = ref1[1];
	  ref2 = [x1 + svg_w + skew_x, svg_h], x3 = ref2[0], y3 = ref2[1];
	  ref3 = [-skew_x + apex * (cx + 2 * skew_x), skew_y], qx1 = ref3[0], qy1 = ref3[1];
	  ref4 = [qx1 + cx, skew_y], qx2 = ref4[0], qy2 = ref4[1];
	  bubblemouth_path = "M  " + x1 + "  " + y1 + "\nQ " + qx1 + " " + qy1 + "\n   " + x2 + "  " + y2 + "\nQ " + qx2 + " " + qy2 + "\n   " + x3 + "  " + y3 + "\n";
	  id = "x-" + ((Math.random() * 10000000000).toFixed(0));
	  x_pad = 0;
	  if (props.box_shadow) {
	    x_pad = (props.box_shadow.dx || 0) + (props.box_shadow.stdDeviation || 0);
	    if (x_pad > 0) {
	      x_pad *= -1;
	    }
	  }
	  return SVG({
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg",
	    width: props.width,
	    height: props.height,
	    viewBox: x_pad + " 0 " + full_width + " " + svg_h,
	    preserveAspectRatio: "none",
	    style: props.style ? props.style : void 0
	  }, DEFS(null, CLIPPATH({
	    id: id
	  }, PATH({
	    strokeWidth: props.stroke_width * 2,
	    d: bubblemouth_path
	  })), props.box_shadow ? svg.dropShadow(_.extend(props.box_shadow, {
	    id: id + "-shadow"
	  })) : void 0), props.box_shadow ? PATH({
	    key: 'shadow',
	    fill: props.fill,
	    style: {
	      filter: "url(#" + id + "-shadow)"
	    },
	    d: bubblemouth_path
	  }) : void 0, PATH({
	    key: 'stroke',
	    fill: props.fill,
	    stroke: props.stroke,
	    strokeWidth: props.stroke_width * 2,
	    clipPath: "url(#" + id + ")",
	    strokeDasharray: props.dash_array ? props.dash_array : void 0,
	    d: bubblemouth_path
	  }));
	};
	
	window.PointBubblemouth = function(props) {
	  var apex, bubblemouth_path, cx, full_width, qx1, qx2, qy1, qy2, ref, ref1, ref2, ref3, ref4, skew_x, skew_y, svg_h, svg_w, x1, x2, x3, x_pad, y1, y2, y3;
	  _.defaults(props, {
	    svg_w: 85,
	    svg_h: 100,
	    skew_x: 15,
	    skew_y: 80,
	    apex_xfrac: .5,
	    fill: 'white',
	    stroke: focus_color(),
	    stroke_width: 10,
	    box_shadow: null
	  });
	  full_width = props.svg_w + 4 * props.skew_x * Math.max(.5, Math.abs(.5 - props.apex_xfrac));
	  _.defaults(props, {
	    width: full_width,
	    height: props.svg_h
	  });
	  apex = props.apex_xfrac;
	  svg_w = props.svg_w;
	  svg_h = props.svg_h;
	  skew_x = props.skew_x;
	  skew_y = props.skew_y;
	  cx = skew_x + svg_w / 2;
	  ref = [skew_x - apex * skew_x, svg_h], x1 = ref[0], y1 = ref[1];
	  ref1 = [skew_x + apex * svg_w, 0], x2 = ref1[0], y2 = ref1[1];
	  ref2 = [x1 + svg_w + skew_x, svg_h], x3 = ref2[0], y3 = ref2[1];
	  ref3 = [-skew_x + apex * (cx + 2 * skew_x), skew_y], qx1 = ref3[0], qy1 = ref3[1];
	  ref4 = [qx1 + cx, skew_y], qx2 = ref4[0], qy2 = ref4[1];
	  bubblemouth_path = "M  " + x1 + "  " + y1 + "\nQ " + qx1 + " " + qy1 + "\n   " + x2 + "  " + y2 + "\nQ " + qx2 + " " + qy2 + "\n   " + x3 + "  " + y3 + "\n";
	  x_pad = 0;
	  if (props.box_shadow) {
	    x_pad = (props.box_shadow.dx || 0) + (props.box_shadow.stdDeviation || 0);
	    if (x_pad > 0) {
	      x_pad *= -1;
	    }
	  }
	  return SVG({
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg",
	    width: props.width,
	    height: props.height,
	    viewBox: x_pad + " 0 " + full_width + " " + svg_h,
	    preserveAspectRatio: "none",
	    style: props.style ? props.style : void 0
	  }, PATH({
	    key: 'stroke',
	    fill: props.fill,
	    stroke: props.stroke,
	    strokeWidth: props.stroke_width * 2,
	    strokeDasharray: props.dash_array ? props.dash_array : void 0,
	    d: bubblemouth_path,
	    style: props.style || {}
	  }));
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var CHUNK_SIZE, DEVELOPMENT_LANGUAGE, IN_SITU_TRANSLATOR, TranslationsDash, TranslationsForLang, deleteTranslationString, draw_translation_metadata, editable_translation, log_translation_count, promote_temporary_translations, regexp_tmatch, regexp_tsplit, rejectProposals, submitTranslationProposalsInChunks, translation_cache, translation_logging_in_progress, translation_uses, translation_uses_last_written_at, translation_uses_write_after, translations_loaded, try_submit_translations, updateTranslations,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(2);
	
	window.translation_progress = function(lang, key_prefix) {
	  var dev_language, k, proposed_translations, target_lang, translated, v;
	  key_prefix || (key_prefix = '/translations');
	  proposed_translations = fetch("/proposed_translations/" + lang + (key_prefix.replace('/translations', '')));
	  dev_language = fetch(key_prefix + "/en");
	  target_lang = fetch(key_prefix + "/" + lang);
	  translated = (function() {
	    var results;
	    results = [];
	    for (k in dev_language) {
	      v = dev_language[k];
	      if (target_lang[k] || proposed_translations[k]) {
	        results.push(k);
	      }
	    }
	    return results;
	  })();
	  return translated.length / (Object.keys(dev_language).length - 1);
	};
	
	regexp_tsplit = /<(\w+)>[^<]+<\/[\w|\s]+>/g;
	
	regexp_tmatch = /<(\w+)>([^<]+)<\/[\w|\s]+>/g;
	
	window.TRANSLATE = function(args, native_text) {
	  var def, j, lang_used, len, match, matches, message, part, parts, props, ref, target_lang, tr, translation, translations;
	  if (typeof args === "string") {
	    if (native_text) {
	      args = {
	        id: args
	      };
	    } else {
	      native_text = args;
	      args = {};
	    }
	  }
	  tr = fetch('translations');
	  args.return_lang_used = true;
	  if (args.key) {
	    console.trace();
	    console.warn("args.key is no longer accepted for translator. use local=true instead");
	  }
	  ref = translator(args, native_text), message = ref.message, lang_used = ref.lang_used, target_lang = ref.target_lang;
	  if (!message) {
	    return native_text;
	  }
	  if (message.indexOf('<') > -1) {
	    parts = message.split(regexp_tsplit);
	    matches = {};
	    while (match = regexp_tmatch.exec(message)) {
	      matches[match[1]] = match[2];
	    }
	    translation = [];
	    for (j = 0, len = parts.length; j < len; j++) {
	      part = parts[j];
	      if (part in matches && part in args) {
	        def = args[part];
	        if (def.render != null) {
	          translation.push(def.render());
	        } else if (args.as_html) {
	          translation.push("<" + def.component + " " + def.args + ">" + matches[part] + "</" + def.component + ">");
	        } else {
	          translation.push(def.component(def.args, matches[part]));
	        }
	      } else {
	        translation.push(part);
	      }
	    }
	  } else {
	    translation = message;
	  }
	  if (!tr.in_situ_translations) {
	    return translation;
	  } else {
	    translations = fetch("/translations/" + target_lang);
	    props = _.extend({
	      lang_used: lang_used,
	      target_lang: target_lang,
	      message: message,
	      native_text: native_text
	    }, args);
	    props.translation_key = props.key;
	    return IN_SITU_TRANSLATOR(props, translation);
	  }
	};
	
	IN_SITU_TRANSLATOR = ReactiveComponent({
	  displayName: 'InSituTranslator',
	  render: function() {
	    var available_languages, id, key, message_style, proposed_translations, subdomain, subdomain_id, target_lang, translated, updated_translations;
	    key = this.props.translation_key || '/translations';
	    target_lang = this.props.target_lang;
	    translated = this.props.lang_used === target_lang;
	    id = this.props.id || this.props.native_text;
	    return SPAN({
	      style: {
	        backgroundColor: translated ? "rgba(166, 195, 151, .5)" : "rgba(251,124,124,.5)",
	        position: 'relative'
	      },
	      onMouseOver: (function(_this) {
	        return function() {
	          if (!_this.local.show_translator) {
	            _this.local.show_translator = true;
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }, this.props.children, this.local.show_translator ? (available_languages = fetch('/supported_languages').available_languages, this.props.local ? (subdomain = fetch('/subdomain'), updated_translations = fetch("local_translations/" + target_lang + "/" + subdomain.name), proposed_translations = fetch("/proposed_translations/" + target_lang + "/" + subdomain.name), subdomain_id = subdomain.id) : (updated_translations = fetch("local_translations/" + target_lang), proposed_translations = fetch("/proposed_translations/" + target_lang), subdomain_id = null), message_style = {
	      fontWeight: 700
	    }, DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 9999,
	        fontSize: 14,
	        width: 300,
	        padding: '4px 8px',
	        backgroundColor: 'white',
	        border: "1px solid #ccc"
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          e.stopPropagation();
	          return e.preventDefault();
	        };
	      })(this)
	    }, DIV({
	      style: {}
	    }, "English message: ", DIV({
	      style: message_style
	    }, "" + this.props.native_text)), DIV({
	      style: {
	        marginTop: 8
	      }
	    }, LABEL(null, available_languages[target_lang] + " translation:"), editable_translation(id, target_lang, subdomain_id, updated_translations, proposed_translations.proposals[id], message_style)), BUTTON({
	      className: "btn",
	      style: {
	        fontSize: 14
	      },
	      onClick: (function(_this) {
	        return function() {
	          promote_temporary_translations(updated_translations.key);
	          _this.local.show_translator = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Save"), BUTTON({
	      style: {
	        backgroundColor: 'none',
	        border: 'none',
	        color: '#888'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_translator = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Cancel"))) : void 0);
	  }
	});
	
	DEVELOPMENT_LANGUAGE = 'en';
	
	translation_cache = {};
	
	translations_loaded = false;
	
	window.T = window.t = function(args, native_text) {
	  console.trace();
	  console.warn("Deprecated: calling window.t or window.T should be replaced with window.translator");
	  return translator(args, native_text);
	};
	
	window.translator = function(args, native_text) {
	  var cache_key, e, id, j, lang, lang_used, langs, len, message, subdomain, translations, translations_key_prefix, translations_native, translator, user;
	  if (translations_loaded) {
	    cache_key = JSON.stringify(args, native_text);
	    if (cache_key in translation_cache) {
	      if (typeof args === "string") {
	        if (native_text) {
	          args = {
	            id: args
	          };
	        } else {
	          native_text = args;
	          args = {};
	        }
	      }
	      id = args.id || native_text;
	      log_translation_count(id);
	      return translation_cache[cache_key];
	    }
	  }
	  if (args.key) {
	    console.trace();
	    console.warn("Deprecated: do not pass args.key to translator. Pass in local: true instead");
	  }
	  subdomain = fetch('/subdomain');
	  if (args.local && !subdomain.name) {
	    return '...';
	  }
	  if (args.local) {
	    translations_key_prefix = "/translations/" + subdomain.name;
	  } else {
	    translations_key_prefix = "/translations";
	  }
	  translations_native = fetch(translations_key_prefix + "/" + DEVELOPMENT_LANGUAGE);
	  if (waiting_for(translations_native)) {
	    return '...';
	  }
	  translations_loaded || (translations_loaded = true);
	  if (cache_key == null) {
	    cache_key = JSON.stringify(args, native_text);
	  }
	  if (typeof args === "string") {
	    if (native_text) {
	      args = {
	        id: args
	      };
	    } else {
	      native_text = args;
	      args = {};
	    }
	  }
	  id = args.id || native_text;
	  native_text = native_text.replace(/\n/g, "");
	  if (translations_native[id] !== native_text) {
	    console.log('updating', {
	      args: args,
	      key: translations_native.key,
	      id: id,
	      native_text: native_text,
	      saved: translations_native[id]
	    }, translations_native[id] === native_text);
	    translations_native[id] = native_text;
	    setTimeout(function() {
	      var proposed_update;
	      proposed_update = {
	        string_id: id,
	        lang_code: DEVELOPMENT_LANGUAGE,
	        subdomain_id: args.local ? subdomain.id : null,
	        translation: native_text
	      };
	      return updateTranslations([proposed_update]);
	    }, 1000);
	  }
	  user = {};
	  langs = [user.lang, subdomain.lang, DEVELOPMENT_LANGUAGE].filter(function(l) {
	    return l != null;
	  });
	  if (langs.length > 1) {
	    langs = Array.from(new Set(langs));
	  }
	  lang_used = null;
	  message = null;
	  for (j = 0, len = langs.length; j < len; j++) {
	    lang = langs[j];
	    translations = fetch(translations_key_prefix + "/" + lang);
	    if (translations[id] != null) {
	      message = translations[id];
	      if (message) {
	        lang_used = lang;
	        break;
	      }
	    }
	  }
	  try {
	    translator = new IntlMessageFormat.IntlMessageFormat(message, lang_used);
	    message = translator.format(args);
	  } catch (error) {
	    e = error;
	    console.error("Error translating " + id, {
	      error: e,
	      message: message,
	      native_text: native_text
	    });
	    message = translations_native[id];
	  }
	  if (args.return_lang_used) {
	    translation_cache[cache_key] = {
	      message: message,
	      lang_used: lang_used,
	      target_lang: fetch('translations').translating_lang || langs[0]
	    };
	  } else {
	    translation_cache[cache_key] = message;
	  }
	  log_translation_count(id);
	  return translation_cache[cache_key];
	};
	
	translation_uses = {};
	
	log_translation_count = function(string_id) {
	  var ref;
	  if (((ref = window.navigator.userAgent) != null ? ref.indexOf('Prerender') : void 0) > -1) {
	    return;
	  }
	  return translation_uses[string_id] = 1;
	};
	
	translation_uses_write_after = 1000 * 60;
	
	translation_uses_last_written_at = Date.now() - translation_uses_write_after * .95;
	
	translation_logging_in_progress = false;
	
	try_submit_translations = function() {
	  var frm, xhr;
	  frm = new FormData();
	  frm.append("authenticity_token", arest.csrf());
	  frm.append("counts", JSON.stringify(translation_uses));
	  translation_logging_in_progress = true;
	  xhr = new XMLHttpRequest;
	  xhr.addEventListener('readystatechange', function(evt) {
	    if (xhr.readyState >= 3) {
	      if (xhr.status === 200) {
	        translation_uses = {};
	        translation_uses_last_written_at = Date.now();
	        return translation_logging_in_progress = false;
	      } else if (xhr.status === 422) {
	        return arest.serverFetch('/current_user', function() {
	          return setTimeout(function() {
	            return translation_logging_in_progress = false;
	          }, 1000);
	        });
	      } else {
	        return translation_logging_in_progress = false;
	      }
	    }
	  }, false);
	  xhr.open('PUT', '/log_translation_counts', true);
	  return xhr.send(frm);
	};
	
	setInterval(function() {
	  var logging_due;
	  logging_due = Object.keys(translation_uses).length > 0 && Date.now() - translation_uses_last_written_at >= translation_uses_write_after;
	  if (logging_due && !translation_logging_in_progress && Object.keys(arest.pending_saves).length === 0 && Object.keys(arest.outstanding_fetches).length === 0) {
	    return try_submit_translations();
	  }
	}, 200);
	
	styles += ".translation_filters {\n  margin-top: 48px;\n}\n\n.translation_filters button {\n  background-color: #eaeaea;\n  border: none;\n  border-radius: 8px;\n  margin: 0 8px;\n}\n\n.translation_filters button.active {\n  background-color: " + focus_blue + ";\n  color: white;\n}\n";
	
	TranslationsDash = ReactiveComponent({
	  displayName: 'TranslationsDash',
	  render: function() {
	    var all_langs, current_user, filter, filters, k, local, subdomain, translations, v;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    translations = fetch('/supported_languages');
	    if (!translations.available_languages) {
	      return DIV();
	    }
	    local = fetch('translations');
	    if (local.filters == null) {
	      local.filters = [];
	    }
	    all_langs = (function() {
	      var ref, results;
	      ref = translations.available_languages;
	      results = [];
	      for (k in ref) {
	        v = ref[k];
	        if (k !== DEVELOPMENT_LANGUAGE) {
	          results.push([k, v]);
	        }
	      }
	      return results;
	    })();
	    if (current_user.is_super_admin) {
	      all_langs.push(['pseudo-en', "Pseudo English (for testing)"]);
	    }
	    if (!local.translating_lang) {
	      if (subdomain.lang && subdomain.lang !== 'en') {
	        local.translating_lang = subdomain.lang;
	      } else {
	        local.translating_lang = all_langs[0][0];
	      }
	    }
	    return DIV(null, DIV({
	      style: {}
	    }, "Consider.it's native development language is English (en). Please help us translate it to your language!"), DIV({
	      style: {
	        marginTop: 24
	      }
	    }, "Which language do you wish to translate for?", SELECT({
	      value: local.translating_lang || subdomain.lang || 'en',
	      style: {
	        fontSize: 20,
	        marginLeft: 14,
	        display: 'inline-block'
	      },
	      onChange: (function(_this) {
	        return function(ev) {
	          local.translating_lang = ev.target.value;
	          return save(local);
	        };
	      })(this)
	    }, (function() {
	      var j, len, ref, results;
	      results = [];
	      for (j = 0, len = all_langs.length; j < len; j++) {
	        ref = all_langs[j], k = ref[0], v = ref[1];
	        results.push(OPTION({
	          key: k + "-" + v,
	          value: k
	        }, v + " (" + k + ")"));
	      }
	      return results;
	    })()), DIV({
	      style: {
	        fontSize: 12
	      }
	    }, "Is your language not available? Email us at hello@consider.it to get your language added.")), current_user.is_super_admin ? DIV({
	      style: {
	        marginTop: 24
	      }
	    }, LABEL({
	      htmlFor: 'insitutranslations'
	    }, "Enable in-situ translations?"), INPUT({
	      id: 'insitutranslations',
	      type: 'checkbox',
	      checked: fetch('translations').in_situ_translations,
	      style: {
	        fontSize: 36
	      },
	      onChange: (function(_this) {
	        return function() {
	          var tr;
	          tr = fetch('translations');
	          tr.in_situ_translations = !tr.in_situ_translations;
	          return save(tr);
	        };
	      })(this)
	    }), DIV({
	      style: {
	        fontSize: 12
	      }
	    }, "In-situ mode lets you browse the rest of the site and add some translations in context.")) : void 0, current_user.is_super_admin ? DIV({
	      style: {
	        marginTop: 24
	      }
	    }, "Add a new language", DIV(null, INPUT({
	      style: {
	        fontSize: 18
	      },
	      type: 'text',
	      ref: 'newlang_abbrev',
	      placeholder: 'Abbreviation'
	    }), INPUT({
	      type: 'text',
	      ref: 'newlang_label',
	      placeholder: 'Full Name',
	      style: {
	        margin: '0 8px',
	        fontSize: 18
	      }
	    }), BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          var abbrev, label;
	          abbrev = _this.refs.newlang_abbrev.value;
	          label = _this.refs.newlang_label.value;
	          if (!(abbrev in translations.available_languages)) {
	            translations.available_languages[abbrev] = label;
	            save(translations);
	            _this.refs.newlang_abbrev.value = "";
	            return _this.refs.newlang_label.value = "";
	          }
	        };
	      })(this)
	    }, "Add"))) : void 0, local.translating_lang ? (filters = ['Untranslated', 'Not translated by you', 'High use', 'Medium use', 'Low use', 'Rarely used'], current_user.is_super_admin ? filters.push('Under review') : void 0, DIV(null, DIV({
	      className: 'translation_filters'
	    }, LABEL(null, "Filter translations to:"), (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = filters.length; j < len; j++) {
	        filter = filters[j];
	        results.push((function(_this) {
	          return function(filter) {
	            return BUTTON({
	              key: filter,
	              className: indexOf.call(local.filters, filter) >= 0 ? 'active' : void 0,
	              onClick: function() {
	                if (indexOf.call(local.filters, filter) >= 0) {
	                  local.filters.splice(local.filters.indexOf(filter), 1);
	                } else {
	                  local.filters.push(filter);
	                }
	                return save(local);
	              }
	            }, filter);
	          };
	        })(this)(filter));
	      }
	      return results;
	    }).call(this)), TranslationsForLang({
	      key: "translations_for_" + local.translating_lang,
	      lang: local.translating_lang,
	      filtered_users: local.filters
	    }), TranslationsForLang({
	      key: "forum_translations_for_" + local.translating_lang,
	      lang: local.translating_lang,
	      forum_specific: true,
	      filters: local.filters
	    }), DIV({
	      style: {
	        position: 'fixed',
	        bottom: 0,
	        left: 0,
	        width: WINDOW_WIDTH(),
	        zIndex: 999,
	        backgroundColor: 'rgba(220,220,220,.8)',
	        textAlign: 'center',
	        padding: '8px'
	      }
	    }, BUTTON({
	      className: 'btn',
	      onClick: (function(_this) {
	        return function() {
	          promote_temporary_translations("local_translations/" + local.translating_lang);
	          return promote_temporary_translations("local_translations/" + local.translating_lang + "/" + subdomain.name);
	        };
	      })(this)
	    }, "Save Changes"), fetch('translations_interface').saved_successfully ? DIV({
	      style: {
	        color: 'green',
	        marginTop: 10
	      }
	    }, "Successfully saved") : void 0))) : void 0);
	  }
	});
	
	TranslationsForLang = ReactiveComponent({
	  displayName: 'TranslationsForLang',
	  render: function() {
	    var all_uses, available_languages, col, cols, could_not_find, current_user, has_use_filter, idx, j, k, lang, len, local, name, name1, names, native_messages, native_messages_with_count, passes_use_range, percentRank, percentiles, proposed_translations, rank, ref, ref1, ref2, ref3, rows, section, sections, sp, subdomain, subdomain_id, to_translate, trans, translation, translation_key_prefix, updated_translations, uses, v;
	    lang = this.props.lang;
	    subdomain = fetch('/subdomain');
	    if (this.props.forum_specific) {
	      translation_key_prefix = "/translations/" + subdomain.name;
	      proposed_translations = fetch("/proposed_translations/" + lang + "/" + subdomain.name);
	      subdomain_id = subdomain.id;
	      updated_translations = fetch("local_translations/" + lang + "/" + subdomain.name);
	    } else {
	      translation_key_prefix = "/translations";
	      proposed_translations = fetch("/proposed_translations/" + lang);
	      subdomain_id = null;
	      updated_translations = fetch("local_translations/" + lang);
	    }
	    available_languages = fetch("/supported_languages").available_languages;
	    native_messages = fetch(translation_key_prefix + "/" + DEVELOPMENT_LANGUAGE);
	    native_messages_with_count = fetch("/proposed_translations/" + DEVELOPMENT_LANGUAGE);
	    if (waiting_for(native_messages) || waiting_for(proposed_translations) || waiting_for(native_messages_with_count)) {
	      return DIV();
	    }
	    to_translate = (function() {
	      var results;
	      results = [];
	      for (k in native_messages) {
	        v = native_messages[k];
	        if (k !== 'key') {
	          results.push(k);
	        }
	      }
	      return results;
	    })();
	    if (to_translate.length === 0) {
	      return DIV();
	    }
	    sections = {};
	    could_not_find = {};
	    if (!this.props.forum_specific) {
	      percentRank = function(array, n) {
	        var L, N, S, aa, i, j, len;
	        L = 0;
	        S = 0;
	        N = array.length;
	        for (i = j = 0, len = array.length; j < len; i = ++j) {
	          aa = array[i];
	          if (array[i] < n) {
	            L += 1;
	          } else if (array[i] === n) {
	            S += 1;
	          }
	        }
	        return (L + (0.5 * S)) / N;
	      };
	      percentiles = {};
	      uses = [];
	      ref = native_messages_with_count.proposals;
	      for (name in ref) {
	        trans = ref[name];
	        if (name === 'key') {
	          continue;
	        }
	        if (trans.accepted.uses_this_period + trans.accepted.uses_last_period > 0) {
	          uses.push(trans.accepted.uses_this_period + trans.accepted.uses_last_period);
	        }
	      }
	      all_uses = uses.sort(function(a, b) {
	        return a - b;
	      });
	      ref1 = native_messages_with_count.proposals;
	      for (name in ref1) {
	        trans = ref1[name];
	        if (name === 'key') {
	          continue;
	        }
	        uses = trans.accepted.uses_this_period + trans.accepted.uses_last_period;
	        if (uses === 0) {
	          rank = -1;
	        } else {
	          rank = percentRank(all_uses, uses) * 100;
	        }
	        percentiles[name] = rank;
	      }
	    }
	    local = fetch('translations');
	    for (j = 0, len = to_translate.length; j < len; j++) {
	      name = to_translate[j];
	      if (((ref2 = local.filters) != null ? ref2.length : void 0) > 0) {
	        translation = proposed_translations.proposals[name];
	        if (indexOf.call(local.filters, 'Untranslated') >= 0 && !!translation) {
	          continue;
	        }
	        if (indexOf.call(local.filters, 'Not translated by you') >= 0 && !!(translation != null ? translation.yours : void 0)) {
	          continue;
	        }
	        if (indexOf.call(local.filters, 'Under review') >= 0 && !(translation != null ? (ref3 = translation.proposals) != null ? ref3.length : void 0 : void 0) > 0) {
	          continue;
	        }
	        if (!this.props.forum_specific) {
	          passes_use_range = false;
	          has_use_filter = false;
	          if (indexOf.call(local.filters, 'High use') >= 0) {
	            has_use_filter = true;
	            passes_use_range || (passes_use_range = percentiles[name] >= 75);
	          }
	          if (indexOf.call(local.filters, 'Medium use') >= 0) {
	            has_use_filter = true;
	            passes_use_range || (passes_use_range = percentiles[name] >= 25 && percentiles[name] < 75);
	          }
	          if (indexOf.call(local.filters, 'Low use') >= 0) {
	            has_use_filter = true;
	            passes_use_range || (passes_use_range = percentiles[name] >= 0 && percentiles[name] < 25);
	          }
	          if (indexOf.call(local.filters, 'Rarely used') >= 0) {
	            has_use_filter = true;
	            passes_use_range || (passes_use_range = percentiles[name] === -1);
	          }
	          if (!passes_use_range && has_use_filter) {
	            continue;
	          }
	        }
	      }
	      sp = name.split('.');
	      if (sp.length > 1) {
	        sections[name1 = sp[0]] || (sections[name1] = []);
	        sections[sp[0]].push(name);
	      } else {
	        sections.misc || (sections.misc = []);
	        sections.misc.push(name);
	      }
	    }
	    current_user = fetch('/current_user');
	    if (this.props.forum_specific) {
	      cols = ['Message', "Translation. Leave blank if Message already " + available_languages[lang]];
	    } else {
	      cols = ['Message in English', "Translation to " + available_languages[lang]];
	    }
	    return DIV({
	      style: {
	        marginTop: 36
	      }
	    }, H2({
	      style: {
	        fontSize: 22,
	        marginBottom: 12
	      }
	    }, TRANSLATE({
	      id: "translations.language_header",
	      percent_complete: Math.round(translation_progress(lang, translation_key_prefix) * 100),
	      language: available_languages[lang]
	    }, "Translations for {language} ({percent_complete}% completed)")), current_user.is_super_admin ? DIV(null, BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          var candidates, id, latest, len1, m, proposal, proposals, props, ref4, ref5, ref6, ref7, to_accept;
	          proposals = [];
	          ref4 = proposed_translations.proposals;
	          for (id in ref4) {
	            props = ref4[id];
	            if (((ref5 = props.proposals) != null ? ref5.length : void 0) > 0) {
	              latest = null;
	              to_accept = null;
	              candidates = props.proposals.slice();
	              if (props.accepted) {
	                candidates.push(props.accepted);
	              }
	              for (m = 0, len1 = candidates.length; m < len1; m++) {
	                proposal = candidates[m];
	                if (!latest || proposal.created_at > latest) {
	                  latest = proposal.created_at;
	                  to_accept = proposal;
	                }
	              }
	              if (!to_accept.accepted) {
	                console.log("Promoting", to_accept.id, " over ", (ref6 = props.accepted) != null ? ref6.id : void 0, "(" + proposal.created_at + " over " + ((ref7 = props.accepted) != null ? ref7.created_at : void 0));
	                to_accept['accepted'] = true;
	                proposals.push(to_accept);
	              }
	            }
	          }
	          if (proposals.length > 0) {
	            return updateTranslations(proposals);
	          }
	        };
	      })(this)
	    }, "Accept latest proposed translations"), BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          var id, len1, m, proposal, proposals, props, ref4, ref5, ref6;
	          proposals = [];
	          ref4 = proposed_translations.proposals;
	          for (id in ref4) {
	            props = ref4[id];
	            if (((ref5 = props.proposals) != null ? ref5.length : void 0) > 0) {
	              ref6 = props.proposals;
	              for (m = 0, len1 = ref6.length; m < len1; m++) {
	                proposal = ref6[m];
	                if (proposal.accepted || (proposed_translations.accepted && proposal.translation === proposed_translations.accepted.translation)) {
	                  continue;
	                }
	                console.log("Proposed to delete:", proposal);
	                proposals.push(proposal);
	              }
	            }
	          }
	          if (proposals.length > 0) {
	            return rejectProposals(proposals);
	          }
	        };
	      })(this)
	    }, "Clear proposals"), BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          var id, proposals, props, ref4;
	          proposals = [];
	          ref4 = proposed_translations.proposals;
	          for (id in ref4) {
	            props = ref4[id];
	            if (props.accepted) {
	              proposals.push(props.accepted);
	            }
	          }
	          if (proposals.length > 0) {
	            return updateTranslations(proposals);
	          }
	        };
	      })(this)
	    }, "Propagate accepted")) : void 0, TABLE({
	      style: {
	        width: HOMEPAGE_WIDTH()
	      }
	    }, TBODY(null, (function() {
	      var fn, len1, m, results;
	      results = [];
	      for (section in sections) {
	        names = sections[section];
	        if (names.length === 0) {
	          continue;
	        }
	        names.sort();
	        rows = [];
	        rows.push(TR({
	          key: 'preamble'
	        }, TD({
	          colSpan: cols.length,
	          style: {
	            fontSize: 24,
	            paddingTop: 12
	          }
	        }, section.toUpperCase().replace(/\_/g, ' '), DIV({
	          style: {
	            fontSize: 12,
	            marginBottom: 8
	          }
	        }, "Translation strings support ICU format for e.g. pluralization. For complicated translations, you may wish to ", A({
	          href: "http://format-message.github.io/icu-message-format-for-translators/editor.html",
	          target: '_blank',
	          style: {
	            textDecoration: 'underline'
	          }
	        }, "use this helper"), "."))));
	        rows.push(TR({
	          key: 'header',
	          style: {
	            backgroundColor: '#dfdfdf'
	          }
	        }, (function() {
	          var len1, m, results1;
	          results1 = [];
	          for (m = 0, len1 = cols.length; m < len1; m++) {
	            col = cols[m];
	            results1.push(TH({
	              key: col,
	              style: {
	                textAlign: 'left',
	                padding: "4px 6px"
	              }
	            }, col));
	          }
	          return results1;
	        })()));
	        fn = (function(_this) {
	          return function(name, idx) {
	            var no_id, percentile, proposal, proposals, ref4, use_color, use_label;
	            no_id = name === native_messages[name];
	            if (!_this.props.forum_specific) {
	              percentile = percentiles[name];
	              if (percentile >= 75) {
	                use_color = 'red';
	                use_label = 'high use';
	              } else if (percentile >= 25) {
	                use_color = 'orange';
	                use_label = 'medium use';
	              } else if (percentile >= 0) {
	                use_color = 'green';
	                use_label = 'low use';
	              } else {
	                use_color = 'blue';
	                use_label = 'rarely used';
	              }
	            }
	            return rows.push(TR({
	              key: "row-id-" + name,
	              style: {
	                backgroundColor: idx % 2 === 1 ? '#f8f8f8' : void 0
	              }
	            }, TD({
	              style: {
	                padding: "2px 4px",
	                width: "40%"
	              }
	            }, DIV({
	              ref: "message-" + name + "-" + idx,
	              title: no_id ? 'no ID' : name
	            }, "" + native_messages[name], !_this.props.forum_specific ? SPAN({
	              style: {
	                color: use_color,
	                fontSize: 12,
	                paddingLeft: 12
	              }
	            }, use_label) : void 0)), TD({
	              style: {
	                width: '58%',
	                padding: "2px 4px",
	                position: 'relative'
	              }
	            }, DIV({
	              style: {
	                position: 'relative'
	              }
	            }, editable_translation(name, lang, subdomain_id, updated_translations, proposed_translations.proposals[name]), current_user.is_super_admin ? (function(name) {
	              return BUTTON({
	                style: {
	                  fontSize: 14,
	                  backgroundColor: 'transparent',
	                  border: 'none',
	                  color: '#ccc',
	                  position: 'absolute',
	                  right: -25,
	                  padding: '4px',
	                  top: 'calc(50% - 14px)'
	                },
	                onClick: function() {
	                  deleteTranslationString(name);
	                  delete native_messages[name];
	                  return delete updated_translations[name];
	                }
	              }, "x");
	            })(name) : void 0), current_user.is_super_admin && ((ref4 = proposed_translations.proposals[name]) != null ? ref4.proposals.length : void 0) > 0 ? (proposals = proposed_translations.proposals[name].proposals, proposed_translations.proposals[name].accepted ? proposals.unshift(proposed_translations.proposals[name].accepted) : void 0, UL({
	              style: {}
	            }, (function() {
	              var len2, o, results1;
	              results1 = [];
	              for (idx = o = 0, len2 = proposals.length; o < len2; idx = ++o) {
	                proposal = proposals[idx];
	                results1.push((function(_this) {
	                  return function(proposal, name, idx) {
	                    return LI({
	                      key: name + "-" + proposal.translation + "-" + proposal.id,
	                      style: {
	                        padding: "2px 0px 8px 0px",
	                        listStyle: 'none'
	                      }
	                    }, DIV({
	                      style: {
	                        color: proposal.accepted ? 'darkgreen' : void 0
	                      }
	                    }, proposal.translation), draw_translation_metadata(proposal), !proposal.accepted ? DIV(null, BUTTON({
	                      style: {
	                        borderRadius: 8
	                      },
	                      onClick: function() {
	                        proposal.accepted = true;
	                        return updateTranslations([proposal]);
	                      }
	                    }, "Ok"), BUTTON({
	                      style: {
	                        backgroundColor: 'transparent',
	                        display: 'inline-block',
	                        marginLeft: 20,
	                        border: 'none',
	                        color: '#999',
	                        textDecoration: 'underline',
	                        fontSize: 14
	                      },
	                      onClick: function() {
	                        return rejectProposals(name, [proposal]);
	                      }
	                    }, "reject")) : void 0);
	                  };
	                })(this)(proposal, name, idx));
	              }
	              return results1;
	            }).call(_this))) : void 0)));
	          };
	        })(this);
	        for (idx = m = 0, len1 = names.length; m < len1; idx = ++m) {
	          name = names[idx];
	          fn(name, idx);
	        }
	        results.push(rows);
	      }
	      return results;
	    }).call(this))));
	  }
	});
	
	draw_translation_metadata = function(proposal) {
	  var proposer;
	  if (proposal.user_id) {
	    proposer = fetch("/user/" + proposal.user_id);
	  } else {
	    proposer = fetch('/current_user');
	  }
	  return SPAN({
	    style: {
	      fontSize: 14,
	      color: "#aaa",
	      paddingRight: 4
	    }
	  }, proposal.origin_server + " - " + (proposer.name || proposer.user || proposal.user_id) + " " + (prettyDate(proposal.created_at)));
	};
	
	CHUNK_SIZE = 15;
	
	submitTranslationProposalsInChunks = function(proposals, http_method, endpoint, cb) {
	  var chunk_id, next_chunk, submit_form;
	  submit_form = function(chunk_o_proposals) {
	    var frm, xhr;
	    if (!((chunk_o_proposals != null ? chunk_o_proposals.length : void 0) > 0)) {
	      if (typeof cb === "function") {
	        cb();
	      }
	      return;
	    }
	    frm = new FormData();
	    frm.append("authenticity_token", arest.csrf());
	    frm.append("proposals", JSON.stringify(chunk_o_proposals));
	    xhr = new XMLHttpRequest;
	    xhr.addEventListener('readystatechange', null, false);
	    xhr.open(http_method, endpoint, true);
	    xhr.onload = function() {
	      var next_proposals, result;
	      result = JSON.parse(xhr.responseText);
	      arest.update_cache(result);
	      next_proposals = next_chunk();
	      console.log("SUBMITTING", next_proposals);
	      return submit_form(next_proposals);
	    };
	    return xhr.send(frm);
	  };
	  chunk_id = 0;
	  next_chunk = function() {
	    chunk_id += 1;
	    return proposals.slice((chunk_id - 1) * CHUNK_SIZE, chunk_id * CHUNK_SIZE);
	  };
	  return submit_form(next_chunk());
	};
	
	updateTranslations = function(proposals, cb) {
	  var ref;
	  if (((ref = window.navigator.userAgent) != null ? ref.indexOf('Prerender') : void 0) > -1) {
	    return;
	  }
	  return submitTranslationProposalsInChunks(proposals, 'PUT', '/translations', function() {
	    translation_cache = {};
	    return typeof cb === "function" ? cb() : void 0;
	  });
	};
	
	rejectProposals = function(proposals) {
	  return submitTranslationProposalsInChunks(proposals, 'DELETE', '/translation_proposal');
	};
	
	deleteTranslationString = function(string_id) {
	  var frm, xhr;
	  frm = new FormData();
	  frm.append("authenticity_token", arest.csrf());
	  frm.append("string_id", string_id);
	  xhr = new XMLHttpRequest;
	  xhr.addEventListener('readystatechange', null, false);
	  xhr.open('DELETE', '/translations', true);
	  xhr.onload = function() {
	    var result;
	    result = JSON.parse(xhr.responseText);
	    return arest.update_cache(result);
	  };
	  return xhr.send(frm);
	};
	
	editable_translation = function(id, lang_code, subdomain_id, updated_translations, proposed_translations, style) {
	  var accepted, current_user, proposal, proposed, ref, val;
	  current_user = fetch('/current_user');
	  accepted = proposed = val = proposal = null;
	  if (proposed_translations) {
	    if (proposed_translations.accepted) {
	      accepted = val = proposed_translations.accepted.translation;
	      proposal = proposed_translations.accepted;
	    }
	    if (proposed_translations.yours) {
	      proposed = val = proposed_translations.yours.translation;
	      proposal = proposed_translations.yours;
	    }
	  }
	  return SPAN({
	    key: id + "-" + accepted + "-" + proposed
	  }, accepted && proposed && accepted.user_id !== proposed.user_id ? DIV(null, DIV({
	    style: {
	      fontStyle: 'italic',
	      fontSize: 14
	    }
	  }, "Current translation:"), accepted, DIV({
	    style: {
	      fontStyle: 'italic',
	      marginTop: 12,
	      fontSize: 14
	    }
	  }, "Your proposed translation:")) : void 0, AutoGrowTextArea({
	    defaultValue: ((ref = updated_translations[id]) != null ? ref.translation : void 0) || val,
	    style: _.defaults(style || {}, {
	      verticalAlign: 'top',
	      fontSize: 'inherit',
	      width: '100%',
	      borderColor: '#ddd'
	    }),
	    onChange: function(e) {
	      var trans;
	      trans = e.target.value;
	      if (!updated_translations[id]) {
	        return updated_translations[id] = {
	          string_id: id,
	          lang_code: lang_code,
	          subdomain_id: subdomain_id,
	          translation: e.target.value
	        };
	      } else {
	        return updated_translations[id].translation = e.target.value;
	      }
	    }
	  }));
	};
	
	promote_temporary_translations = function(key) {
	  var k, proposals, updated_translations, v;
	  updated_translations = fetch(key);
	  proposals = [];
	  for (k in updated_translations) {
	    v = updated_translations[k];
	    if (k === 'key') {
	      continue;
	    }
	    proposals.push(v);
	  }
	  if (proposals.length === 0) {
	    return;
	  }
	  return updateTranslations(proposals, function() {
	    var trans_UI;
	    for (k in updated_translations) {
	      v = updated_translations[k];
	      if (k !== 'key') {
	        delete updated_translations[k];
	      }
	    }
	    save(updated_translations);
	    trans_UI = fetch('translations_interface');
	    trans_UI.saved_successfully = true;
	    save(trans_UI);
	    return _.delay(function() {
	      trans_UI.saved_successfully = false;
	      return save(trans_UI);
	    }, 4000);
	  });
	};
	
	window.TranslationsDash = TranslationsDash;


/***/ },
/* 9 */
/***/ function(module, exports) {

	window.styles += "#lightbox {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(0,0,0,.6);\n\n  \n  width: 100vw;\n  height: 100vh;\n  z-index: 99999;\n}\n\n#modal-wrapper {\n  margin: 0 auto;\n  position: relative;\n  z-index: 0;\n  padding: 3em 0;\n}\n\n#modal-body {\n  padding: 2.5em 125px 3.5em 125px;\n  font-size: 16px;\n  box-shadow: 0 2px 4px rgba(0,0,0,.4), 0 0 100px rgb(255 255 255 / 40%);\n  background-color: white; /* #f1f1f1; */\n  position: relative;\n  border-radius: 16px;\n}\n\n@media (max-width: 700px) {\n  #modal-body {\n    padding: 2.5em 42px 3.5em 42px;\n  }\n}\n";
	
	window.Modal = {
	  accessibility_on_keydown: function(e) {
	    var is_tab_pressed, ref;
	    if (e.key === 'Escape' || e.keyCode === 27) {
	      if (this.refs.cancel_dialog) {
	        if ((ref = ReactDOM.findDOMNode(this.refs.cancel_dialog)) != null) {
	          ref.click();
	        }
	      }
	    }
	    is_tab_pressed = e.key === 'Tab' || e.keyCode === 9;
	    if (!is_tab_pressed) {
	      return;
	    }
	    if (e.shiftKey) {
	      if (document.activeElement === this.first_focusable_element) {
	        this.last_focusable_element.focus();
	        e.preventDefault();
	      }
	    } else {
	      if (document.activeElement === this.last_focusable_element) {
	        this.first_focusable_element.focus();
	        e.preventDefault();
	      }
	    }
	  },
	  UNSAFE_componentWillMount: function() {
	    this.scroll_Y = window.scrollY;
	    return setTimeout((function(_this) {
	      return function() {
	        if (!_this.scroll_Y) {
	          return _this.scroll_Y = window.scrollY;
	        }
	      };
	    })(this));
	  },
	  componentDidMount: function() {
	    return this.componentDidUpdate();
	  },
	  componentDidUpdate: function() {
	    var modal, ref;
	    modal = ((ref = this.refs) != null ? ref.dialog : void 0) || document.querySelector('[role=dialog]');
	    if (!modal || this.mounted) {
	      return;
	    }
	    this.mounted = true;
	    return setTimeout((function(_this) {
	      return function() {
	        var e, focusable_content, focusable_elements, ref1, scroll_bar_width;
	        _this.focused_element_before_opening = document.activeElement;
	        focusable_elements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
	        _this.first_focusable_element = modal.querySelectorAll(focusable_elements)[0];
	        focusable_content = modal.querySelectorAll(focusable_elements);
	        _this.last_focusable_element = focusable_content[focusable_content.length - 1];
	        document.addEventListener('keydown', _this.accessibility_on_keydown);
	        try {
	          if ((ref1 = modal.querySelector('input:not([disabled])')) != null) {
	            ref1.focus();
	          }
	        } catch (error) {
	          e = error;
	          console.error(e);
	        }
	        _.extend(modal.style, {
	          position: 'fixed',
	          top: "0px",
	          left: "0px",
	          width: '100vw',
	          height: '100vh',
	          overflow: 'auto',
	          zIndex: 99999
	        });
	        scroll_bar_width = window.innerWidth - document.body.offsetWidth;
	        return _.extend(document.body.style, {
	          marginRight: scroll_bar_width,
	          overflow: 'hidden',
	          position: 'fixed',
	          top: "-" + _this.scroll_Y + "px",
	          width: '100vw'
	        });
	      };
	    })(this));
	  },
	  componentWillUnmount: function() {
	    if (this.focused_element_before_opening && document.body.contains(this.focused_element_before_opening)) {
	      this.focused_element_before_opening.focus();
	      clear_tooltip();
	    }
	    document.removeEventListener('keydown', this.accessibility_on_keydown);
	    _.extend(document.body.style, {
	      marginRight: null,
	      overflow: null,
	      position: null,
	      top: 0,
	      width: null
	    });
	    return window.scroll(0, this.scroll_Y);
	  }
	};
	
	window.wrap_in_modal = function(width, click_lightbox_callback, children) {
	  return DIV(null, DIV({
	    id: 'lightbox'
	  }), DIV({
	    id: 'modal',
	    ref: 'dialog',
	    role: 'dialog',
	    onClick: click_lightbox_callback ? click_lightbox_callback : void 0
	  }, DIV({
	    id: 'modal-wrapper',
	    style: {
	      maxWidth: width || AUTH_WIDTH()
	    },
	    onClick: click_lightbox_callback ? function(e) {
	      return e.stopPropagation();
	    } : void 0
	  }, DIV({
	    id: 'modal-body'
	  }, children))));
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var DELAY_TO_SHOW_POPOVER, clear_popover, hide_popover, show_popover_from_dom, toggle_popover, zero_popover;
	
	__webpack_require__(1);
	
	zero_popover = function() {
	  var popover;
	  popover = fetch('popover');
	  popover.coords = popover.tip = popover.render = popover.top = popover.positioned = null;
	  popover.offsetY = popover.offsetX = null;
	  popover.rendered_size = false;
	  popover.id = null;
	  popover.hide_triangle = false;
	  popover.size_checked = void 0;
	  return save(popover);
	};
	
	clear_popover = function(immediate, cb) {
	  var id, popover;
	  popover = fetch('popover');
	  if (!popover.id) {
	    return;
	  }
	  if (immediate) {
	    zero_popover();
	    return typeof cb === "function" ? cb() : void 0;
	  } else {
	    id = popover.id;
	    return setTimeout(function() {
	      if (!popover.has_focus && popover.id === id && !popover.element_in_focus) {
	        zero_popover();
	        return typeof cb === "function" ? cb() : void 0;
	      }
	    }, 200);
	  }
	};
	
	hide_popover = function(e) {
	  var popover;
	  if (e.target.getAttribute('data-popover')) {
	    if (e.target.getAttribute('data-title')) {
	      e.target.setAttribute('title', e.target.getAttribute('data-title'));
	      e.target.removeAttribute('data-title');
	    }
	    popover = fetch('popover');
	    popover.element_in_focus = false;
	    if (popover.coords) {
	      return clear_popover(false, function() {
	        if (e.target.getAttribute('data-previous_zindex') != null) {
	          e.target.style.zIndex = e.target.getAttribute('data-previous_zindex');
	          return e.target.removeAttribute('data-previous_zindex');
	        }
	      });
	    }
	  }
	};
	
	toggle_popover = function(e) {
	  var popover;
	  if (e.target.getAttribute('data-popover')) {
	    popover = fetch('popover');
	    if (popover.element_in_focus) {
	      return hide_popover(e);
	    } else {
	      return show_popover_from_dom(e);
	    }
	  }
	};
	
	DELAY_TO_SHOW_POPOVER = 1000;
	
	window.update_avatar_popover_from_canvas_histo = function(opts) {
	  var already_hovering_on_avatar, anon, coords, id, opinion, popover, user;
	  popover = fetch('popover');
	  already_hovering_on_avatar = !!popover.id;
	  if (!opts) {
	    popover.element_in_focus = null;
	    clear_popover(false);
	    return;
	  }
	  id = opts.id, user = opts.user, coords = opts.coords, anon = opts.anon, opinion = opts.opinion;
	  popover.element_in_focus = id;
	  return setTimeout(function() {
	    if (popover.element_in_focus === id) {
	      if (popover.id !== id) {
	        clear_popover(true);
	        popover.id = id;
	        popover.render = function() {
	          return AvatarPopover({
	            key: user,
	            user: user,
	            anon: anon,
	            opinion: opinion
	          });
	        };
	      }
	      popover.coords = coords;
	      return save(popover);
	    }
	  }, (popover.delay || DELAY_TO_SHOW_POPOVER) * (already_hovering_on_avatar ? .25 : 1));
	};
	
	show_popover_from_dom = function(e) {
	  var popover;
	  if (e.target.getAttribute('data-popover')) {
	    popover = fetch('popover');
	    popover.element_in_focus = e.target.getAttribute('data-popover');
	    setTimeout(function() {
	      var anon, attribute, group, key, proposal, style, user;
	      if (popover.element_in_focus === e.target.getAttribute('data-popover')) {
	        if (e.target.getAttribute('title')) {
	          e.target.setAttribute('data-title', e.target.getAttribute('title'));
	          e.target.removeAttribute('title');
	        }
	        style = getComputedStyle(e.target);
	        if (style != null ? style.zIndex : void 0) {
	          e.target.setAttribute('data-previous_zindex', "" + e.target.style.zIndex);
	          e.target.style.zIndex = "" + (parseInt(style.zIndex) + 1);
	        }
	        if (e.target.getAttribute('data-user')) {
	          user = e.target.getAttribute('data-user');
	          if (user !== popover.id) {
	            clear_popover(true);
	            anon = e.target.getAttribute('data-anonymous') === 'true';
	            popover.id = user;
	            popover.render = function() {
	              return AvatarPopover({
	                key: user,
	                user: user,
	                anon: anon,
	                opinion: e.target.getAttribute('data-opinion')
	              });
	            };
	          }
	        } else if (e.target.getAttribute('data-group')) {
	          proposal = e.target.getAttribute('data-popover');
	          attribute = e.target.getAttribute('data-attribute');
	          group = e.target.getAttribute('data-group');
	          key = proposal.key + "-" + attribute + "-" + group;
	          if (key !== popover.id) {
	            clear_popover(true);
	            popover.id = key;
	            popover.delay = 100;
	            popover.render = function() {
	              return AggregatedGroupPopover({
	                key: key,
	                proposal: proposal,
	                attribute: attribute,
	                group: group,
	                stance: e.target.getAttribute('data-stance'),
	                num_opinions: e.target.getAttribute('data-opinion-count')
	              });
	            };
	          }
	        } else if (e.target.getAttribute('data-proposal-scores')) {
	          proposal = e.target.getAttribute('data-popover');
	          if (proposal !== popover.id) {
	            clear_popover(true);
	            popover.render = function() {
	              return ProposalScoresPopover({
	                key: proposal,
	                proposal: proposal,
	                overall_avg: parseFloat(e.target.getAttribute('data-proposal-scores'))
	              });
	            };
	            popover.offsetY = e.target.offsetHeight + 12;
	            popover.offsetX = -e.target.offsetWidth / 2 + 36;
	            popover.positioned = 'right';
	            popover.top = false;
	            popover.id = proposal;
	          }
	        } else {
	          popover.tip = e.target.getAttribute('data-popover');
	        }
	        popover.coords = calc_coords_for_tooltip_or_popover(e.target);
	        return save(popover);
	      }
	    }, popover.delay || DELAY_TO_SHOW_POPOVER);
	    return e.preventDefault();
	  }
	};
	
	window.calc_coords_for_tooltip_or_popover = function(el) {
	  var coords;
	  coords = $$.offset(el);
	  coords.width = el.offsetWidth;
	  coords.height = el.offsetHeight;
	  coords.left += el.offsetWidth / 2;
	  return coords;
	};
	
	document.addEventListener("mouseover", show_popover_from_dom);
	
	document.addEventListener("mouseout", hide_popover);
	
	$$.add_delegated_listener(document.body, 'focusin', '[data-popover]', show_popover_from_dom);
	
	$$.add_delegated_listener(document.body, 'focusout', '[data-popover]', hide_popover);
	
	$$.add_delegated_listener(document.body, 'click', '[data-popover]', toggle_popover);
	
	window.get_tooltip_or_popover_position = function(arg) {
	  var arrow_adjustment, arrow_size, arrow_up, coords, left, popover, ref, tip, tooltip, top, try_bottom, try_top, viewport_bottom, viewport_top, window_height;
	  popover = arg.popover, tooltip = arg.tooltip, arrow_size = arg.arrow_size;
	  if (popover == null) {
	    popover = tooltip;
	  }
	  coords = popover.coords;
	  tip = popover.tip;
	  window_height = window.innerHeight;
	  viewport_top = window.scrollY;
	  viewport_bottom = viewport_top + window_height;
	  arrow_up = popover.top || (popover.top == null);
	  try_top = function(force) {
	    var ref, top;
	    top = coords.top + (popover.offsetY || 0) - (((ref = popover.rendered_size) != null ? ref.height : void 0) || 0) - arrow_size.height - 6;
	    if (top < viewport_top && !force) {
	      arrow_up = false;
	      return null;
	    } else {
	      arrow_up = true;
	      return top;
	    }
	  };
	  try_bottom = function(force) {
	    var ref, top;
	    top = coords.top + (popover.offsetY || 0) + arrow_size.height + coords.height + 12;
	    if (top + (((ref = popover.rendered_size) != null ? ref.height : void 0) || 0) + arrow_size.height > viewport_bottom && !force) {
	      arrow_up = true;
	      return null;
	    } else {
	      arrow_up = false;
	      return top;
	    }
	  };
	  if (popover.top || (popover.top == null)) {
	    top = try_top();
	    if (top === null) {
	      top = try_bottom();
	      if (top === null) {
	        top = try_top(true);
	      }
	    }
	  } else {
	    top = try_bottom();
	    if (top === null) {
	      top = try_top();
	      if (top === null) {
	        top = try_bottom(true);
	      }
	    }
	  }
	  arrow_adjustment = 0;
	  if ((ref = popover.rendered_size) != null ? ref.width : void 0) {
	    left = coords.left + (popover.offsetX || 0) - popover.rendered_size.width / 2;
	    if (left < 0) {
	      arrow_adjustment = -1 * left;
	      left = 0;
	    } else if (left + popover.rendered_size.width > window.innerWidth) {
	      arrow_adjustment = (window.innerWidth - popover.rendered_size.width) - left;
	      left = window.innerWidth - popover.rendered_size.width;
	    }
	  } else {
	    left = -999999;
	  }
	  return {
	    top: top,
	    left: left,
	    arrow_up: arrow_up,
	    arrow_adjustment: arrow_adjustment
	  };
	};
	
	window.Popover = ReactiveComponent({
	  displayName: 'Popover',
	  render: function() {
	    var arrow_adjustment, arrow_size, arrow_up, get_focus, left, lose_focus, popover, ref, style, top, x1;
	    popover = fetch('popover');
	    if (!popover.coords || !popover.render) {
	      return SPAN(null);
	    }
	    arrow_size = {
	      height: 10,
	      width: 26
	    };
	    ref = get_tooltip_or_popover_position({
	      popover: popover,
	      arrow_size: arrow_size
	    }), top = ref.top, left = ref.left, arrow_up = ref.arrow_up, arrow_adjustment = ref.arrow_adjustment;
	    style = _.defaults({
	      top: top,
	      left: left
	    }, this.props.style || {}, {
	      fontSize: 14,
	      padding: '4px 8px',
	      borderRadius: 8,
	      zIndex: 9999,
	      color: 'black',
	      backgroundColor: 'white',
	      position: 'absolute',
	      boxShadow: '0 1px 9px rgba(0,0,0,.5)',
	      maxWidth: '80vw'
	    });
	    get_focus = function() {
	      popover.has_focus = true;
	      return save(popover);
	    };
	    lose_focus = function() {
	      popover.has_focus = false;
	      clear_popover();
	      return save(popover);
	    };
	    return DIV({
	      id: 'popover',
	      role: "popover",
	      style: style,
	      onFocus: get_focus,
	      onMouseEnter: get_focus,
	      onBlur: lose_focus,
	      onMouseLeave: lose_focus
	    }, popover.render ? popover.render() : DIV({
	      dangerouslySetInnerHTML: {
	        __html: tip
	      }
	    }), SVG({
	      width: arrow_size.width,
	      height: arrow_size.height,
	      viewBox: "0 0 531.74 460.5",
	      preserveAspectRatio: "none",
	      style: {
	        position: 'absolute',
	        bottom: arrow_up ? -arrow_size.height : void 0,
	        top: !arrow_up ? -arrow_size.height : void 0,
	        left: popover.positioned !== 'right' ? "calc(50% - " + (arrow_size.width / 2 + arrow_adjustment) + "px)" : void 0,
	        right: popover.positioned === 'right' ? 7 : void 0,
	        transform: !arrow_up ? 'scale(1,-1)' : void 0,
	        display: popover.hide_triangle ? 'none' : void 0
	      }
	    }, POLYGON({
	      stroke: "none",
	      fill: 'white',
	      points: "530.874,0.5 265.87,459.5 0.866,0.5"
	    }), G(null, (function() {
	      var i, len, ref1, results;
	      ref1 = [0.866, 530.874];
	      results = [];
	      for (i = 0, len = ref1.length; i < len; i++) {
	        x1 = ref1[i];
	        results.push(LINE({
	          key: x1,
	          x1: x1,
	          y1: 0.5,
	          x2: 265.87,
	          y2: 459.5,
	          stroke: "black",
	          strokeWidth: 35,
	          strokeOpacity: .25
	        }));
	      }
	      return results;
	    })())));
	  },
	  componentDidUpdate: function() {
	    var popover, rendered_size;
	    popover = fetch('popover');
	    if (popover.coords) {
	      rendered_size = {
	        width: ReactDOM.findDOMNode(this).offsetWidth,
	        height: ReactDOM.findDOMNode(this).offsetHeight
	      };
	      if (popover.rendered_size == null) {
	        popover.rendered_size = {};
	      }
	      if (rendered_size.width !== popover.rendered_size.width || rendered_size.height !== popover.rendered_size.height) {
	        if (popover.size_checked == null) {
	          popover.size_checked = Date.now();
	        }
	        if (Date.now() - popover.size_checked < 500) {
	          popover.rendered_size = rendered_size;
	          return save(popover);
	        }
	      }
	    }
	  }
	});


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	
	window.Slider = ReactiveComponent({
	  displayName: 'Slider',
	  full_props: function() {
	    return _.defaults({}, this.props, {
	      handle_height: 6,
	      base_height: 6,
	      base_endpoint: 'square',
	      base_color: 'rgb(200, 200, 200)',
	      polarized: false,
	      draw_helpers: false,
	      respond_to_click: true
	    });
	  },
	  render: function() {
	    var draw_handle, props, slider, slider_style;
	    props = this.full_props();
	    draw_handle = props.draw_handle;
	    if (draw_handle == null) {
	      draw_handle = true;
	    }
	    if (draw_handle) {
	      slider = fetch(props.slider_key);
	      if (slider.value == null) {
	        _.defaults(slider, {
	          value: props.polarized ? -1.0 : 0,
	          has_moved: false,
	          is_moving: false
	        });
	        save(slider);
	      }
	    }
	    slider_style = _.defaults({}, props.slider_style || {}, {
	      width: props.width,
	      height: Math.max(props.base_height, props.handle_height),
	      position: 'relative'
	    });
	    return DIV({
	      className: 'slider',
	      style: slider_style,
	      onBlur: props.onBlur ? props.onBlur : void 0,
	      onFocus: props.onFocus ? props.onFocus : void 0
	    }, this.drawSliderBase(), draw_handle ? this.drawSliderHandle() : void 0);
	  },
	  drawSliderBase: function() {
	    var d, endpoint, endpoints, idx, inc, num_ticks, props, region, slider, slider_base_style, sty, tick_position, w;
	    props = this.full_props();
	    slider_base_style = {
	      width: props.width,
	      height: props.base_height,
	      backgroundColor: props.base_color,
	      position: 'absolute'
	    };
	    slider = fetch(props.slider_key);
	    if (typeof props.base_endpoint === 'string') {
	      endpoints = [props.base_endpoint, props.base_endpoint];
	    } else {
	      endpoints = props.base_endpoint;
	    }
	    return DIV({
	      ref: 'base',
	      key: 'slider_base',
	      className: 'slider_base',
	      style: slider_base_style,
	      onClick: this.handleMouseClick
	    }, props.show_val_highlighter ? DIV({
	      style: {
	        height: props.base_height + 4,
	        backgroundColor: "rgb(81, 142, 255)",
	        boxShadow: "0 0 " + (1.5 * (props.base_height + 4)) + "px rgb(255 255 255), 0 0 3px rgba(0,0,0,.2) inset",
	        position: 'relative',
	        top: -2,
	        width: (Math.abs(100 * slider.value * (props.polarized ? .5 : 1))) + "%",
	        left: !props.polarized ? 0 : slider.value < 0 ? (50 + 50 * slider.value) + "%" : '50%'
	      }
	    }) : void 0, (function() {
	      var results;
	      if (props.ticks) {
	        num_ticks = 2 / props.ticks.increment;
	        inc = slider_base_style.width / num_ticks;
	        tick_position = -inc;
	        results = [];
	        while (tick_position <= slider_base_style.width - inc) {
	          tick_position += inc;
	          results.push(DIV({
	            key: "tick-" + tick_position,
	            style: {
	              position: 'absolute',
	              left: ((tick_position - (Math.abs(tick_position - slider_base_style.width) < 2 ? 1 : 0)) / props.width * 100) + "%",
	              top: 0,
	              width: 1,
	              height: (props.ticks.height || 5) * (Math.abs(tick_position - slider_base_style.width / 2) < 3 ? 2 : 1),
	              backgroundColor: "#aaa"
	            }
	          }));
	        }
	        return results;
	      }
	    })(), (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = endpoints.length; i < len; idx = ++i) {
	        endpoint = endpoints[idx];
	        if (endpoint === 'square') {
	          continue;
	        }
	        if (endpoint === 'sharp') {
	          results.push(DIV({
	            key: "endpoint-" + idx,
	            style: {
	              position: 'absolute',
	              left: idx === 0 ? -5 : void 0,
	              right: idx === 1 ? -5 : void 0,
	              width: 5,
	              height: slider_base_style.height,
	              backgroundColor: slider_base_style.backgroundColor
	            }
	          }, DIV({
	            style: cssTriangle((idx === 0 ? 'left' : 'right'), slider_base_style.backgroundColor, 12, 6, {
	              position: 'absolute',
	              left: idx === 0 ? -12 : void 0,
	              right: idx === 1 ? -12 : void 0
	            })
	          })));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    })(), (function() {
	      var i, len, ref, results;
	      if (props.regions) {
	        d = props.width / props.regions.length;
	        sty = {
	          color: '#BDBDBD',
	          fontSize: 14
	        };
	        ref = props.regions;
	        results = [];
	        for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	          region = ref[idx];
	          w = sizeWhenRendered(region.abbrev, sty);
	          results.push(DIV({
	            style: _.extend({}, sty, {
	              color: '#BDBDBD',
	              fontSize: 14,
	              position: 'absolute',
	              left: (idx + .5) * d - w.width / 2,
	              top: 4
	            })
	          }, region.abbrev));
	        }
	        return results;
	      }
	    })());
	  },
	  drawSliderHandle: function() {
	    var handle_height, handle_width, props, slider, sliderHandle, support;
	    props = this.full_props();
	    handle_width = handle_height = props.handle_height;
	    slider = fetch(props.slider_key);
	    sliderHandle = props.handle || slider_handle.flat;
	    return DIV({
	      className: 'the_handle',
	      role: 'slider',
	      'aria-valuemin': props.polarized ? -1 : 0,
	      'aria-valuemax': 1,
	      'aria-valuenow': slider.value,
	      'aria-valuetext': typeof props.readable_text === "function" ? props.readable_text(slider.value) : void 0,
	      'aria-label': props.label,
	      tabIndex: 0,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          var amount, direction, new_val, ref, ref1, ref2, ref3, ref4;
	          if ((ref = e.which) === 37 || ref === 38 || ref === 39 || ref === 40 || ref === 33 || ref === 34 || ref === 35 || ref === 36) {
	            amount = (ref1 = e.which) === 37 || ref1 === 38 || ref1 === 39 || ref1 === 40 ? .05 : (ref2 = e.which) === 33 || ref2 === 34 ? .25 : (ref3 = e.which) === 35 || ref3 === 36 ? 10000 : void 0;
	            direction = (ref4 = e.which) === 37 || ref4 === 40 || ref4 === 34 || ref4 === 36 ? -1 : 1;
	            new_val = slider.value;
	            new_val += direction * amount;
	            new_val = Math.max(new_val, (props.polarized ? -1 : 0));
	            new_val = Math.min(new_val, 1);
	            if (new_val !== slider.value) {
	              slider.value = new_val;
	              save(slider);
	              if (typeof props.onMouseUpCallback === "function") {
	                props.onMouseUpCallback(e);
	              }
	            }
	            return e.preventDefault();
	          } else if (e.which === 13 || e.which === 32) {
	            if (props.onMouseUpCallback) {
	              props.onMouseUpCallback(e);
	            }
	            return e.preventDefault();
	          }
	        };
	      })(this),
	      onMouseUp: this.handleMouseUp,
	      onMouseDown: this.handleMouseDown,
	      onTouchEnd: this.handleMouseUp,
	      onTouchCancel: this.handleMouseUp,
	      onTouchStart: this.handleMouseDown,
	      onTouchMove: this.handleMouseMove,
	      onBlur: (function(_this) {
	        return function() {
	          _this.local.has_focus = false;
	          return save(_this.local);
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function() {
	          _this.local.has_focus = true;
	          return save(_this.local);
	        };
	      })(this),
	      style: _.extend(props.handle_style || {}, {
	        width: handle_width,
	        height: handle_height,
	        top: props.offset ? 0 : -(handle_height - props.base_height) / 2,
	        position: 'relative',
	        marginLeft: -handle_width / 2,
	        zIndex: 10,
	        outline: 'none',
	        left: props.polarized ? props.width * (slider.value + 1) / 2 : props.width * slider.value
	      })
	    }, sliderHandle(_.extend(props.handle_props || {}, {
	      value: props.polarized ? (slider.value + 1) / 2 : slider.value,
	      handle_height: handle_height,
	      handle_width: handle_width,
	      has_focus: this.local.has_focus
	    })), props.draw_helpers ? DIV(null, (function() {
	      var i, len, ref, results;
	      ref = [true, false];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        support = ref[i];
	        results.push(DIV({
	          key: support + "1",
	          style: {
	            right: support ? -21 : void 0,
	            left: !support ? -21 : void 0,
	            position: 'absolute',
	            top: 7.5,
	            color: 'white',
	            pointerEvents: 'none'
	          }
	        }, support ? ChevronRight(15) : ChevronLeft(15)));
	      }
	      return results;
	    })(), (function() {
	      var i, len, ref, results;
	      ref = [true, false];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        support = ref[i];
	        results.push(DIV({
	          key: support + "2",
	          style: {
	            right: support ? -19 : void 0,
	            left: !support ? -19 : void 0,
	            position: 'absolute',
	            top: 7.5,
	            color: 'white',
	            pointerEvents: 'none'
	          }
	        }, support ? ChevronRight(15) : ChevronLeft(15)));
	      }
	      return results;
	    })(), (function() {
	      var i, len, ref, results;
	      ref = [true, false];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        support = ref[i];
	        results.push(DIV({
	          key: support + "3",
	          style: {
	            right: support ? -20 : void 0,
	            left: !support ? -20 : void 0,
	            position: 'absolute',
	            top: 7.5,
	            color: focus_color(),
	            pointerEvents: 'none'
	          }
	        }, support ? ChevronRight(15) : ChevronLeft(15)));
	      }
	      return results;
	    })()) : void 0);
	  },
	  handleMouseDown: function(e) {
	    var el, props, slider;
	    props = this.full_props();
	    el = ReactDOM.findDOMNode(this);
	    e.preventDefault();
	    slider = fetch(props.slider_key);
	    slider.is_moving = true;
	    save(slider);
	    this.local.starting_adjustment = (parseInt(e.currentTarget.style.left, 10) || 0) - (e.clientX || e.touches[0].clientX);
	    save(this.local);
	    if (props.onMouseDownCallback) {
	      props.onMouseDownCallback(e);
	    }
	    document.addEventListener("mousemove", this.handleMouseMove);
	    return document.addEventListener("mouseup", this.handleMouseUp);
	  },
	  handleMouseMove: function(e) {
	    var clientX, props, slider, x;
	    props = this.full_props();
	    e.preventDefault();
	    e.stopPropagation();
	    slider = fetch(props.slider_key);
	    clientX = e.clientX || e.touches[0].clientX;
	    x = clientX + this.local.starting_adjustment;
	    x = x < 0 ? 0 : x > props.width ? props.width : x;
	    slider.is_moving = true;
	    slider.has_moved = true;
	    slider.value = x / props.width;
	    if (props.polarized) {
	      slider.value = slider.value * 2 - 1;
	    }
	    slider.value = Math.round(slider.value * 10000) / 10000;
	    save(slider);
	    if (props.onMouseMoveCallback) {
	      return props.onMouseMoveCallback(e);
	    }
	  },
	  handleMouseUp: function(e) {
	    var props, slider;
	    props = this.full_props();
	    slider = fetch(props.slider_key);
	    if (typeof props.onMouseUpCallback === "function") {
	      props.onMouseUpCallback(e);
	    }
	    if (slider.is_moving) {
	      e.preventDefault();
	      slider.is_moving = false;
	      save(slider);
	    }
	    document.removeEventListener("mousemove", this.handleMouseMove);
	    return document.removeEventListener("mouseup", this.handleMouseUp);
	  },
	  handleMouseClick: function(e) {
	    var clientX, props, slider, val;
	    props = this.full_props();
	    if (props.respond_to_click) {
	      e.preventDefault();
	      clientX = e.clientX || e.touches[0].clientX;
	      val = (clientX - $$.offset(this.refs.base).left) / props.width;
	      if (val < 0) {
	        val = 0;
	      }
	      if (val > 1) {
	        val = 1;
	      }
	      if (props.polarized) {
	        val = val * 2 - 1;
	      }
	      slider = fetch(props.slider_key);
	      slider.has_moved = true;
	      slider.value = Math.round(val * 10000) / 10000;
	      save(slider);
	      return typeof props.onClickCallback === "function" ? props.onClickCallback(e) : void 0;
	    }
	  }
	});
	
	window.slider_handle || (window.slider_handle = {});
	
	slider_handle.face = function(props) {
	  var bh, bw, direction, is_left, x, y;
	  return SVG({
	    height: props.handle_height,
	    width: props.handle_width,
	    viewBox: "-2 -1 104 104",
	    style: {
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      filter: props.has_focus ? "drop-shadow(0 0 1px rgba(0,0,0,.5))" : void 0
	    }
	  }, DEFS(null, svg.innerbevel({
	    id: 'handle-innerbevel',
	    shadows: [
	      {
	        color: 'black',
	        opacity: 1.0,
	        dx: 0,
	        dy: -3,
	        stdDeviation: 3
	      }, {
	        color: 'white',
	        opacity: .25,
	        dx: 0,
	        dy: 3,
	        stdDeviation: 3
	      }
	    ]
	  })), CIRCLE({
	    fill: props.color,
	    stroke: props.color,
	    cx: 50,
	    cy: 50,
	    r: 50
	  }), G(null, CIRCLE({
	    fill: props.color,
	    filter: "url(#handle-innerbevel)",
	    cx: 50,
	    cy: 50,
	    r: 50
	  }), props.detail ? G(null, (function() {
	    var i, len, ref, results;
	    ref = [true, false];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      is_left = ref[i];
	      direction = is_left ? -1 : 1;
	      bw = 15;
	      bh = 2;
	      x = 50 + direction * (28 + 4 * (1 - props.value)) - (is_left ? 0 : bw);
	      y = 28 - 4 * (1 - props.value);
	      results.push(RECT({
	        x: x,
	        y: y,
	        width: bw,
	        height: bh,
	        transform: "rotate(" + (direction * (5 + 30 * Math.abs(.5 - props.value))) + " " + (x + (is_left ? bw : 0)) + " " + (y + bh) + ")",
	        fill: 'white'
	      }));
	    }
	    return results;
	  })(), (function() {
	    var i, len, ref, results;
	    ref = [true, false];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      is_left = ref[i];
	      direction = is_left ? -1 : 1;
	      results.push(CIRCLE({
	        cx: 50 + direction * (13 + 6 * (1 - props.value)),
	        cy: 39,
	        r: 3,
	        fill: 'white'
	      }));
	    }
	    return results;
	  })(), (function(_this) {
	    return function() {
	      var frowniness, mw, my, qx1, qy1, ref, ref1, ref2, x1, x2, y1, y2;
	      frowniness = 5;
	      mw = 40;
	      my = 65;
	      ref = [50 - mw / 2, my + frowniness * (1 - props.value)], x1 = ref[0], y1 = ref[1];
	      ref1 = [50 + mw / 2, y1], x2 = ref1[0], y2 = ref1[1];
	      ref2 = [50, my + .5 * frowniness + 2 * frowniness * (2 * props.value - 1)], qx1 = ref2[0], qy1 = ref2[1];
	      return PATH({
	        stroke: 'white',
	        fill: focus_color(),
	        strokeWidth: 3,
	        d: "M " + x1 + " " + y1 + "\nQ " + qx1 + " " + qy1 + "\n  " + x2 + " " + y2
	      });
	    };
	  })(this)()) : void 0));
	};
	
	slider_handle.triangley = function(props) {
	  var id, svg_props;
	  svg_props = {
	    height: props.handle_height,
	    width: props.handle_width,
	    viewBox: "0 0 21 18",
	    style: {
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      zIndex: 10,
	      filter: props.has_focus ? "drop-shadow(0 0 3px rgba(0,0,0,.5))" : void 0
	    }
	  };
	  id = "triangley_filter-" + ((Math.random() * 1000000).toFixed(0));
	  return SVG(svg_props, DEFS(null, FILTER({
	    id: id,
	    x: "-50%",
	    y: "-50%",
	    width: "200%",
	    height: "200%",
	    filterUnits: "objectBoundingBox"
	  }, FEOFFSET({
	    dx: "0",
	    dy: "1",
	    'in': "SourceAlpha",
	    result: "shadowOffsetOuter1"
	  }), FEGAUSSIANBLUR({
	    stdDeviation: "0.5",
	    'in': "shadowOffsetOuter1",
	    result: "shadowBlurOuter1"
	  }), FECOLORMATRIX({
	    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16479563 0",
	    'in': "shadowBlurOuter1",
	    type: "matrix",
	    result: "shadowMatrixOuter1"
	  }), FEOFFSET({
	    dx: "0",
	    dy: "-1",
	    'in': "SourceAlpha",
	    result: "shadowOffsetInner1"
	  }), FEGAUSSIANBLUR({
	    stdDeviation: "1",
	    'in': "shadowOffsetInner1",
	    result: "shadowBlurInner1"
	  }), FECOMPOSITE({
	    'in': "shadowBlurInner1",
	    in2: "SourceAlpha",
	    operator: "arithmetic",
	    k2: "-1",
	    k3: "1",
	    result: "shadowInnerInner1"
	  }), FECOLORMATRIX({
	    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
	    'in': "shadowInnerInner1",
	    type: "matrix",
	    result: "shadowMatrixInner1"
	  }), FEMERGE(null, FEMERGENODE({
	    'in': "shadowMatrixOuter1"
	  }), FEMERGENODE({
	    'in': "SourceGraphic"
	  }), FEMERGENODE({
	    'in': "shadowMatrixInner1"
	  })))), G({
	    stroke: "none",
	    strokeWidth: "0",
	    fill: focus_color(),
	    fillRule: "evenodd"
	  }, PATH({
	    d: "M1,6 L20,6 L20,16 L1,16 L1,6 Z M10.5,0 L20,6 L1,6 L10.5,0 Z",
	    fill: focus_color(),
	    filter: "url(#" + id + ")"
	  })));
	};
	
	slider_handle.flat = function(props) {
	  var svg_props;
	  return DIV({
	    style: {
	      borderRadius: '50%',
	      position: 'absolute',
	      top: 0,
	      zIndex: 10,
	      height: props.handle_height,
	      width: props.handle_width,
	      backgroundColor: focus_color(),
	      boxShadow: 'inset 0 -1px 2px rgba(0,0,0,.3)'
	    }
	  });
	  svg_props = {
	    height: props.handle_height,
	    width: props.handle_width,
	    viewBox: "-2 -1 104 104",
	    style: {
	      pointerEvents: 'none',
	      zIndex: 10,
	      filter: props.has_focus ? "drop-shadow(0 0 3px rgba(0,0,0,.5))" : void 0
	    }
	  };
	  return SVG(svg_props, DEFS(null, CLIPPATH({
	    id: 'slider-avatar-clip'
	  }, CIRCLE({
	    cx: 50,
	    cy: 50,
	    r: 48
	  }))), CIRCLE({
	    fill: props.color,
	    stroke: props.color,
	    cx: 50,
	    cy: 50,
	    r: 50
	  }), props.use_face ? (function(_this) {
	    return function() {
	      var user;
	      user = fetch(fetch('/current_user').user);
	      if (user.avatar_file_name) {
	        return IMAGE({
	          'xlink:href': avatarUrl(user, 'large'),
	          x: 2,
	          y: 2,
	          width: 96,
	          height: 96,
	          clipPath: 'url(#slider-avatar-clip)'
	        });
	      }
	    };
	  })(this)() : void 0);
	};
	
	styles += "" + (css.grab_cursor('.the_handle'));


/***/ },
/* 12 */
/***/ function(module, exports) {

	window.svg = {
	  setSize: function(base_width, base_height, props) {
	    if (props.width && (props.height == null)) {
	      return props.height = props.width * base_height / base_width;
	    } else if (props.height && (props.width == null)) {
	      return props.width = props.height * base_width / base_height;
	    }
	  },
	  dropShadow: function(props) {
	    return FILTER({
	      id: props.id
	    }, FEOFFSET({
	      "in": "SourceAlpha",
	      dx: props.dx,
	      dy: props.dy,
	      result: "offsetblur"
	    }), FEGAUSSIANBLUR({
	      "in": 'offsetblur',
	      stdDeviation: props.stdDeviation,
	      result: 'blur2'
	    }), FECOLORMATRIX({
	      "in": 'blur2',
	      result: 'color',
	      type: 'matrix',
	      values: "0 0 0 0  0\n0 0 0 0  0 \n0 0 0 0  0 \n0 0 0 " + props.opacity + " 0"
	    }), FEMERGE(null, FEMERGENODE({
	      "in": 'color'
	    }), FEMERGENODE({
	      "in": 'SourceGraphic'
	    })));
	  },
	  innerbevel: function(props) {
	    var idx, shadow;
	    return FILTER({
	      id: props.id,
	      x0: "-50%",
	      y0: "-50%",
	      width: "200%",
	      height: "200%"
	    }, (function() {
	      var i, len, ref, results;
	      ref = props.shadows;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        shadow = ref[idx];
	        results.push([
	          FEGAUSSIANBLUR({
	            "in": 'SourceAlpha',
	            stdDeviation: shadow.stdDeviation,
	            result: "blur" + idx
	          }), FEOFFSET({
	            dy: shadow.dy,
	            dx: shadow.dx
	          }), FECOMPOSITE({
	            in2: 'SourceAlpha',
	            operator: "arithmetic",
	            k2: "-1",
	            k3: "1",
	            result: "shadowDiff"
	          }), FEFLOOD({
	            floodColor: shadow.color,
	            floodOpacity: shadow.opacity
	          }), FECOMPOSITE({
	            in2: "shadowDiff",
	            operator: "in"
	          }), FECOMPOSITE({
	            in2: idx === 0 ? 'SourceGraphic' : "result" + (idx - 1),
	            operator: "over",
	            result: "result" + idx
	          })
	        ]);
	      }
	      return results;
	    })());
	  }
	};


/***/ },
/* 13 */
/***/ function(module, exports) {

	(function () {
	
	    // ****************
	    // Public API
	    var cache = {}
	    function fetch(url, defaults) {
	        //if (window.watch && watch(url)) console.trace()
	
	        if (!url) return null
	        if (url.key) url = url.key   // If user passes key as object
	
	        window.record_dependence && record_dependence(url)
	
	        // Return the cached version if it exists
	        if (cache[url]) return cache[url]
	
	        // Else, start a serverFetch in the background and return stub.
	        if (url[0] === '/')
	            server_fetch(url)
	
	        update_cache(extend({key: url}, defaults), true)
	        return cache[url]
	    }
	
	    /*  Updates cache and saves to server.
	     *  You can pass a callback that will run when the saves have finished.
	     */
	    function save(object, continuation) {
	        update_cache(object)
	
	        // Save all the objects
	        if (object.key && object.key[0] == '/')
	            server_save(object, continuation)
	        else
	            if (continuation) continuation()
	    }
	
	    /*  Deletes from server (if it's there) and removes from cache
	     *  You can pass a callback that will run when the delete has finished.
	     */
	    function destroy(key, continuation) {
	        if (!key) return
	
	        // Save all the objects
	        if (key[0] == '/')
	            server_destroy(key, continuation)
	        else {
	            // Just remove the key from the cache if this state is
	            // owned by the client.  Note that this won't clean up
	            // references to this object in e.g. any lists. The Client
	            // is responsible for updating all the relevant
	            // references.
	            delete cache[key]
	            if (continuation) continuation()
	        }
	    }
	
	
	    // ================================
	    // == Internal funcs
	
	    var new_index = 0
	    var affected_keys = new Set()
	    var re_render_timer = null
	    function update_cache(object, from_fetch) {
	        do_not_recurse = !!object.key && object.key.startsWith('/translations/')
	
	        function recurse(object) {
	            // Recurses into object and folds it into the cache.
	
	            // If this object has a key, update the cache for it
	            var key = object && object.key
	            if (key) {
	                // if (!key || !key.match) {
	                //     console.trace()
	                //     console.log(key)
	                // }
	
	                // Change /new/thing to /new/thing/45
	                if (key.match(new RegExp('^/new/'))     // Starts with /new/
	                    && !key.match(new RegExp('/\\d+$'))) // Doesn't end in a /number
	                    key = object.key = key + '/' + new_index++
	
	                var cached = cache[key]
	                if (!cached)
	                    // This object is new.  Let's cache it.
	                    cache[key] = object
	                else if (object !== cached)
	                    // Else, mutate cache to match the object.
	                    for (var k in object)          // Mutating in place preserves
	                        cache[key][k] = object[k]  // pointers to this object
	
	                // Remember this key for re-rendering
	                if (!from_fetch) {
	                    affected_keys.add(key)
	                }
	            }
	
	            // Now recurse into this object.
	            //  - Through each element in arrays
	            //  - And each property on objects
	            if (Array.isArray(object))
	                for (var i=0; i < object.length; i++)
	                    object[i] = recurse(object[i])
	            else if (typeof(object) === 'object' && object !== null && !do_not_recurse)
	                for (var k in object){
	                    object[k] = recurse(object[k])
	                }
	
	            // Return the new cached representation of this object
	            return cache[key] || object
	        }
	
	        recurse(object)
	
	        // Now initiate the re-rendering, if there isn't a timer already going
	        if (!re_render_timer){
	            re_render_timer = requestAnimationFrame(function () {
	                re_render_timer = null
	                var keys = affected_keys.all()
	                affected_keys.clear()
	                if (keys.length > 0) {
	                    var re_render = (window.re_render || function () {
	                        console.log('You need to implement re_render()') })
	                    re_render(keys)
	                }
	            })
	        }
	    }
	
	    var outstanding_fetches = {}
	    function server_fetch(key, continuation) {
	        // Error check
	        if (outstanding_fetches[key]) {
	            console.error('Duplicate request for '+key)
	            return
	        }
	
	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            delete outstanding_fetches[key]
	            if (request.status === 200) {
	                var result = JSON.parse(request.responseText)
	                if (window.arest.trans_in)
	                    result = arest.trans_in(result)
	                update_cache(result)
	                if (continuation) continuation()                
	            }
	            else if (request.status === 500)
	                if (window.on_ajax_error) window.on_ajax_error()
	
	        }
	
	        // Open request
	        outstanding_fetches[key] = request
	        request.open('GET', key, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	
	        request.send(null)
	    }
	
	    var pending_saves = {} // Stores xmlhttprequest of any key being saved
	                           // (Note: This shim will fail in many situations...)
	    function server_save(object, continuation) {
	        if (pending_saves[object.key]) {
	            console.log('Yo foo, aborting', object.key)
	            pending_saves[object.key].abort()
	            delete pending_saves[object.key]
	        }
	
	        var original_key = object.key
	        
	        // Special case for /new.  Grab the pieces of the URL.
	        var pattern = new RegExp("/new/([^/]+)/(\\d+)")
	        var match = original_key.match(pattern)
	        var url = (match && '/' + match[1]) || original_key
	
	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            // No longer pending
	            delete pending_saves[original_key]
	
	            if (request.status === 200) {
	                var result = JSON.parse(request.responseText)
	                // console.log('New save result', result)
	                // Handle /new/stuff
	                deep_map(function (obj) {
	                    match = obj.key && obj.key.match(/(.*)\?original_id=(\d+)$/)
	                    if (match && match[2]) {
	                        // Let's map the old and new together
	                        var new_key = match[1]                // It's got a fresh key
	                        cache[new_key] = cache[original_key]  // Point them at the same thing
	                        obj.key = new_key                     // And it's no longer "/new/*"
	                    }
	                },
	                        result)
	
	
	                update_cache(result)
	                if (continuation) continuation()
	            }
	            else if (request.status === 500)
	                window.ajax_error && window.ajax_error()
	        }
	
	        object = clone(object)
	        object['authenticity_token'] = csrf()
	
	        // Open request
	        var POST_or_PUT = match ? 'POST' : 'PUT'
	        request.open(POST_or_PUT, url, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
	        request.setRequestHeader('X-CSRF-Token', csrf())
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	
	        request.send(JSON.stringify(object))
	
	        // Remember it
	        pending_saves[original_key] = request
	    }
	
	    function server_destroy(key, continuation) {
	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            if (request.status === 200) {
	                console.log('Destroy returned for', key)
	                var result = JSON.parse(request.responseText)
	                delete cache[key]
	                update_cache(result)
	                if (continuation) continuation()
	            }
	            else if (request.status === 500)
	                if (window.on_ajax_error) window.on_ajax_error()
	            else {
	                // TODO: give user feedback that DELETE failed
	                console.log('DELETE of', key, 'failed!')
	            }
	
	        }
	
	        payload = {'authenticity_token': csrf()}
	
	        // Open request
	        request.open('DELETE', key, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
	        request.setRequestHeader('X-CSRF-Token', csrf())
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	        request.send(JSON.stringify(payload))
	    }
	
	    // This is used in a specific hack.  I need to work on it.
	    function clear_matching_objects (match_key_func) {
	        // Clears all keys where match_key_func(key) returns true
	        for (key in cache)
	            if (match_key_func(key))
	                delete cache[key]
	    }
	
	
	    var csrf_token = null
	    function csrf(new_token) {
	        if (new_token) {
	            csrf_token = new_token;
	            return csrf_token;
	        }
	
	        if (cache['/current_user']) {
	            csrf_token = cache['/current_user'].csrf
	        }
	
	        if (csrf_token) return csrf_token
	        var metas = document.getElementsByTagName('meta')
	        for (i=0; i<metas.length; i++) { 
	            if (metas[i].getAttribute("name") == "csrf-token") { 
	                return metas[i].getAttribute("content");
	            } 
	        } 
	        return ""
	    }
	
	    window.loading_indicator = React.createFactory(ReactDOMFactories.div)({style: {height: '100%', width: '100%'},
	                                       className: 'loading'}, 'Loading')
	
	    function error_indicator(message) {
	        return ReactDOMFactories.div(null, 'Error! ' + message)
	    }
	
	
	    // ****************
	    // Wrapper for React Components
	    var components = {}                  // Indexed by 'component/0', 'component/1', etc.
	    var components_count = 0
	    var dirty_components = {}
	    var execution_context = []  // The stack of components that are being rendered
	
	    function ReactiveComponent(component) {
	
	        // STEP 1: Define get() and save()
	        component.fetch = component.data = component.get = function (key, defaults) {
	            if (!this.isMounted)
	                throw Error('Component ' + this.name + ' (' + this.local_key
	                            + ') is tryin to get data(' + key + ') after it died.')
	
	            if (key === undefined)    key = this.mounted_key || this.name
	            if (!key)                 return null
	            // if (!key)    throw TypeError('Component mounted onto a null key. '
	            //                              + this.name + ' ' + this.local_key)
	            if (key.key) key = key.key   // If user passes key as object
	            return fetch(key, defaults)  // Call into main activerest
	        }
	        component.save = save                  // Call into main activerest
	        
	
	        // STEP 2: Wrap all the component's methods
	        function wrap(obj, method, before, after) {
	            var original_method = obj[method]
	            if (!(original_method || before || after)) return
	            obj[method] = function() {
	                before && before.apply(this, arguments)
	                if (this.local_key !== undefined)
	                    // We only want to set the execution context on wrapped methods
	                    // that are called on live instance.  getDefaultProps(), for
	                    // instance, is called when defining a component class, but not
	                    // on actual instances.  You can't render new components from
	                    // within there, so we don't need to track the execution context.
	                    execution_context = this.props.parents.concat([this.local_key])
	
	                try {
	                    var result = original_method && original_method.apply(this, arguments)
	                    // if (method == 'render') {
	                    //     console.log(this.name, result)
	                    //     result = DIV({"data-widget": this.name}, result)
	                    // }
	                } catch (e) {
	                    execution_context = []
	                    if (this.is_waiting()){
	                        // console.log('waiting for', this.name, 'missing', this.is_waiting())
	                        return loading_indicator
	                    }
	                    else {
	                        // Then let's re-cause the error, but without catching it
	                        original_method.apply(this, arguments)
	                        console.assert(false) // this cannot happen unless method has side effects
	                    }
	                }
	
	                execution_context = []
	                after && after.apply(this, arguments)
	
	                return result
	            }
	        }
	
	        // We register the component when mounting it into the DOM
	        wrap(component, 'UNSAFE_componentWillMount',
	            function () { 
	
	                 // STEP 1. Register the component's basic info
	                 if (component.displayName === undefined)
	                     throw 'Component needs a displayName'
	                 this.name = component.displayName.replace(' ', '_')
	                 this.local_key = 'component/' + components_count++
	                 components[this.local_key] = this
	
	                 // XXX Putting this into WillMount probably won't let you use the
	                 // mounted_key inside getInitialState!  But you should be using
	                 // activerest state anyway, right?
	                 this.mounted_key = this._reactInternals.key
	
	                 // // You can pass an object in as a key if you want:
	                 // console.log("GOT KEY!", component.displayName, this._reactInternals.key)
	                 if (this.mounted_key && this.mounted_key.key){
	                     // This is broken now that React doesn't allow props to be modified                 
	                     // this.props.key = this.props.key.key
	                     console.error("component", component.displayName, " received an object as a key")
	                 }
	
	
	
	                 // STEP 2: Create shortcut for this component's local key
	                 
	                 function add_shortcut (obj, shortcut_name, to_key) {
	                     //console.log('Giving '+obj.name+' shorcut @'+shortcut_name+'='+to_key)
	                     // console.log('shortcut', obj, shortcut_name, to_key)
	                     delete obj[name]
	                     Object.defineProperty(obj, shortcut_name, {
	                         get: function () {
	                            if (!obj.shortcuts)
	                                obj.shortcuts = Object.create(null)
	                            if (!obj.shortcuts[to_key])
	                              obj.shortcuts[to_key] = obj.get(to_key)
	                            return obj.shortcuts[to_key]
	                         },
	                         configurable: true })
	                 }
	
	                 add_shortcut(this, 'local', this.local_key)
	                 
	            })
	
	        wrap(component, 'render', function () {
	            // Render will need to clear the component's old
	            // dependencies before rendering and finding new ones
	            clear_component_dependencies(this.local_key)
	            delete dirty_components[this.local_key]
	            if (this.shortcuts) {
	                keys = Object.keys(this.shortcuts)
	                for (var i=0; i < keys.length; i++){
	                    key = keys[i]
	                    keys_4_component.add(this.local_key, key)  // Track dependencies
	                    components_4_key.add(key, this.local_key)  // both ways
	                }
	            }
	        })
	
	        wrap(component, 'componentDidMount', function () {
	            ReactDOM.findDOMNode(this).setAttribute('data-widget', component.displayName)
	            if (this.mounted_key)
	                ReactDOM.findDOMNode(this).setAttribute('data-key', this.mounted_key)              
	        })
	        wrap(component, 'componentDidUpdate', function () {
	            ReactDOM.findDOMNode(this).setAttribute('data-widget', component.displayName)
	            if (this.mounted_key)
	                ReactDOM.findDOMNode(this).setAttribute('data-key', this.mounted_key)              
	        })
	        //wrap(component, 'componentWillReceiveProps')
	        wrap(component, 'componentWillUnmount', function () {
	            // Clean up
	            clear_component_dependencies(this.local_key)
	            delete cache[this.local_key]
	            delete components[this.local_key]
	            delete dirty_components[this.local_key]
	        })
	
	        component.shouldComponentUpdate = function (next_props, next_state) {
	            // This component definitely needs to update if it is marked as dirty
	            if (dirty_components[this.local_key] !== undefined) return true
	
	            // Otherwise, we'll check to see if its state or props
	            // have changed.  We can do so by simply serializing them
	            // and then comparing them.  But ignore React's 'children'
	            // prop, because it often has a circular reference.
	            next_props = clone(next_props); this_props = clone(this.props)
	            delete next_props['children']; delete this_props['children']
	
	            // console.assert(!_.isEqual([next_state, next_props], [this.state, this_props]) == JSON.stringify([next_state, next_props]) != JSON.stringify([this.state, this_props]), {next_state: next_state, next_props: next_props})
	            if (_)
	                return !_.isEqual([next_state, next_props], [this.state, this_props])
	            else 
	                return JSON.stringify([next_state, next_props]) != JSON.stringify([this.state, this_props])
	        }
	        
	        component.is_waiting = function () {
	            // Does this component depend on any keys that are being
	            // requested?
	            var dependent_keys = keys_4_component.get(this.local_key)
	            for (var i=0; i<dependent_keys.length; i++)
	                if (outstanding_fetches[dependent_keys[i]])
	                    return dependent_keys[i]
	            return false
	        }
	
	        window.waiting_for = function(obj_or_key) {
	            return !!outstanding_fetches[obj_or_key.key || obj_or_key]
	        }
	
	        // STEP 3: Configure the global function hooks for React
	        window.re_render = react_rerender
	        window.record_dependence = record_component_dependence
	
	        // Now create the actual React class with this definition, and
	        // return it.
	        var react_class = React.createFactory(createReactClass(component))
	        var result = function (props, children) {
	            props = props || {}
	            props.parents = execution_context.slice()
	            return react_class(props, children)
	        }
	        // Give it the same prototype as the original class so that it
	        // passes React.isValidClass() inspection
	        result.prototype = react_class.prototype
	        return result
	    }
	
	
	    // *****************
	    // Dependency-tracking for React components
	    var keys_4_component = new One_To_Many() // Maps component to its dependence keys
	    var components_4_key = new One_To_Many() // Maps key to its dependent components
	    function react_rerender (keys) {
	        // Re-renders only the components that depend on `keys'
	        // console.log('RENDERING BASED ON:', keys)
	        // First we determine the components that will need to be updated
	        for (var i = 0; i < keys.length; i++) {
	            affected_components = components_4_key.get(keys[i])
	            for (var j = 0; j < affected_components.length; j++)
	                dirty_components[affected_components[j]] = true
	        }
	
	        // Then we sweep through and update them
	        for (var comp_key in dirty_components){
	            // the check on both dirty_components and components is a PATCH
	            // for a possible inconsistency between dirty_components and components
	            // that occurs if a component has a componentWillUnmount method.
	            if (dirty_components[comp_key] && components[comp_key]){ // Since one component might update another
	                // console.log("\tREDO", comp_key, arest.components[comp_key], keys)
	                components[comp_key].forceUpdate()
	            }
	        }
	    }
	    function record_component_dependence(key) {
	        // Looks up current component from the execution context
	        if (execution_context.length > 0) {
	            var component = execution_context[execution_context.length-1]
	            keys_4_component.add(component, key)  // Track dependencies
	            components_4_key.add(key, component)  // both ways
	        }
	    }
	    function clear_component_dependencies(component) {
	        var depends_on_keys = keys_4_component.get(component)
	        for (var i=0; i<depends_on_keys.length; i++)
	            components_4_key.del(depends_on_keys[i], component)
	        keys_4_component.delAll(component)
	    }
	
	
	    // ****************
	    // Utility for React Components
	    window.add_cnt = {}
	    window.print_add_cnt = function(){
	        var my_keys = Object.keys(add_cnt);
	        var values = Object.values(add_cnt)
	        values = values.sort(function(a,b){return (b - a)})
	        sorted_keys = my_keys.sort(function(a,b){return parseInt(add_cnt[b]) - parseInt(add_cnt[a])})
	        var idx=0
	        for(var i=0; i < sorted_keys.length; i++){
	            key = sorted_keys[i]
	            console.log(key, add_cnt[key])
	            idx = idx + 1
	            if (idx > 100)
	                break
	        }
	    }
	    function One_To_Many() {
	        var hash = this.hash = Object.create(null)
	        this.get = function (k) { return Object.keys(hash[k] || {}) }
	        this.add = function (k, v) {
	            if (hash[k] === undefined)
	                hash[k] = Object.create(null)
	
	            // if (window.add_cnt[k + v] == undefined)
	            //     window.add_cnt[k+v] = 0 
	            // if (k == 'component/64' && v == '/subdomain')
	            //     console.trace()
	            // window.add_cnt[k+v] += 1
	            hash[k][v] = true
	        }
	        this.del = function (k, v) {
	            delete hash[k][v]
	        }
	        this.delAll = function (k) { hash[k] = Object.create(null) }
	    }
	    function Set() {
	        var hash = {}
	        this.add = function (a) { if (!hash[a]) hash[a] = true }
	        this.all = function () { return Object.keys(hash) }
	        this.clear = function () { hash = {} }
	    }
	
	
	    // ******************
	    // General utility funcs
	    function clone(obj) {
	        if (obj == null) return obj
	        var copy = obj.constructor()
	        for (var attr in obj)
	            if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
	        return copy
	    }
	    function extend(obj, with_obj) {
	        if (with_obj === undefined) return obj
	        for (var attr in with_obj)
	            if (!obj.hasOwnProperty(attr)) obj[attr] = with_obj[attr]
	        return obj
	    }
	    function deep_map(func, object) {
	        // This function isn't actually a full "deep map" yet.
	        // Limitations: It only applies func to OBJECTS (not arrays or
	        // atoms), and doesn't return anything.
	        if (Array.isArray(object))
	            for (var i=0; i < object.length; i++)
	                deep_map(func, object[i])
	        else if (typeof(object) === 'object' && object !== null) {
	            func(object)
	            for (var k in object)
	                deep_map(func, object[k])
	        }
	    }
	    function error(e, name) {
	        console.error('In', name + ':', e.stack)
	        if (window.on_client_error)
	            window.on_client_error(e)
	    }
	
	    function key_id(string) {
	        return string.match(/\/[^\/]+\/(-?\d+)/)[1]
	    }
	
	    // Camelcased API options
	    var updateCache=update_cache, serverFetch=server_fetch,
	        serverSave=server_save, serverDestroy=server_destroy
	
	    // Export the public API
	    window.ReactiveComponent = ReactiveComponent
	    window.fetch = fetch
	    window.save = save
	    window.destroy = destroy
	
	    // Make the private methods accessible under "window.arest"
	    vars = [['cache', cache], ['fetch',fetch], ['save',save], ['server_fetch', server_fetch], ['serverFetch', serverFetch], ['server_save', server_save], ['serverSave',serverSave], ['update_cache',update_cache], ['updateCache',updateCache], ['csrf',csrf], ['keys_4_component',keys_4_component], ['components_4_key', components_4_key], ['components',components], ['execution_context',execution_context], ['One_To_Many',One_To_Many], ['clone',clone], ['dirty_components', dirty_components], ['affected_keys',affected_keys], ['clear_matching_objects',clear_matching_objects], ['deep_map', deep_map], ['key_id', key_id], ['pending_saves', pending_saves], ['outstanding_fetches', outstanding_fetches]]
	    window.arest = {}
	    for (var i=0; i<vars.length; i++)
	        window.arest[vars[i][0]] = vars[i][1]
	
	})()


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var cached_anonymous_avatars, cached_avatars, colors_used, createCompositeGroupIcon, createFallbackIcon, createUserIcon, create_avatar, create_pixelated_avatar, group_colored_icons, icon_cache, loaded_images, missing_images, my_question_mark_icon, props_to_strip, question_mark_icon, user_name, users2images,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(1);
	
	__webpack_require__(10);
	
	__webpack_require__(2);
	
	__webpack_require__(6);
	
	window.avatarUrl = function(user, img_size) {
	  var app;
	  user = fetch(user);
	  if (user.avatar_file_name.endsWith('svg')) {
	    img_size = 'original';
	  }
	  if (!!user.avatar_file_name) {
	    app = arest.cache['/application'] || fetch('/application');
	    return (app.asset_host || '') + "/system/avatars/" + ((user.key.split('/')[2]) + "/" + img_size + "/" + user.avatar_file_name);
	  } else {
	    return null;
	  }
	};
	
	window.user_is_organization_account = function(user) {
	  var ref;
	  return ref = user.key || user, indexOf.call(customization('organizational_account') || [], ref) >= 0;
	};
	
	window.anonymous_label = function() {
	  return translator('anonymous', 'Anonymous');
	};
	
	user_name = function(user, anon) {
	  user = fetch(user);
	  if (!user.name || user.name.trim().length === 0) {
	    return anonymous_label();
	  } else {
	    return user.name;
	  }
	};
	
	window.AvatarPopover = ReactiveComponent({
	  displayName: 'AvatarPopover',
	  render: function() {
	    var alt, anon, anonymous, attribute, attributes, cnt, grouped_by, has_opinion, inclusions, is_grouped, name, o_trans, opinion, opinion_views, pixelate_anon_current_user, point, reason, reasons_trans, ref, stance, toggle_reasons, unreported, user, user_val, val;
	    ref = this.props, user = ref.user, anon = ref.anon, opinion = ref.opinion;
	    user = fetch(user);
	    anonymous = arest.key_id(user.key) < 0 || anon || customization('anonymize_permanently');
	    opinion_views = fetch('opinion_views');
	    name = user_name(user, anonymous);
	    has_opinion = opinion != null;
	    if (has_opinion) {
	      opinion = fetch(opinion);
	      stance = opinion.stance;
	      if (stance > .01) {
	        alt = ((stance * 100).toFixed(0)) + "%";
	      } else if (stance < -.01) {
	        alt = "–" + ((stance * -100).toFixed(0)) + "%";
	      } else {
	        alt = translator("engage.histogram.user_is_neutral", "is neutral");
	      }
	      anonymous || (anonymous = opinion.hide_name);
	    }
	    pixelate_anon_current_user = user.key === fetch('/current_user').user && anonymous;
	    return DIV({
	      style: {
	        padding: '8px 4px',
	        position: 'relative',
	        maxWidth: "min(80vw, 800px)"
	      }
	    }, DIV({
	      style: {
	        display: 'flex'
	      }
	    }, user.avatar_file_name ? IMG({
	      alt: this.props.alt || alt || ("Image of " + (anonymous ? 'Image of an anonymous user "#{user.name}"' : user.name)),
	      className: pixelate_anon_current_user ? 'pixelated-avatar' : void 0,
	      style: {
	        width: 120,
	        height: 120,
	        borderRadius: '50%',
	        marginRight: 24,
	        display: 'inline-block',
	        filter: pixelate_anon_current_user ? "blur(" + (.025 * 120) + "px)" : void 0
	      },
	      src: anonymous && !pixelate_anon_current_user ? user.avatar_file_name : avatarUrl(user, 'large')
	    }) : void 0, DIV(null, DIV({
	      style: {
	        letterSpacing: -1,
	        fontSize: 18,
	        fontWeight: 'bold'
	      }
	    }, name), pixelate_anon_current_user ? I(null, your_opinion_i18n.anon_assurance()) : void 0, (typeof get_participant_attributes !== "undefined" && get_participant_attributes !== null) && !anonymous && !user_is_organization_account(user) ? (attributes = get_participant_attributes(), grouped_by = opinion_views.active_views.group_by, unreported = missing_attribute_info_label(), UL({
	      style: {
	        listStyle: 'none',
	        marginTop: 4
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = attributes.length; i < len; i++) {
	        attribute = attributes[i];
	        is_grouped = grouped_by && grouped_by.name === attribute.name;
	        if (attribute.pass) {
	          user_val = attribute.pass(user);
	          if (user_val == null) {
	            user_val = unreported;
	          }
	          if (typeof user_val === "string" && (user_val != null ? user_val.indexOf(CHECKLIST_SEPARATOR > -1) : void 0)) {
	            user_val = user_val.split(CHECKLIST_SEPARATOR);
	          } else {
	            user_val = ["" + user_val];
	          }
	        } else {
	          user_val = user.tags[attribute.key];
	          if (user_val == null) {
	            user_val = unreported;
	          }
	          if (typeof user_val === "string" && (user_val != null ? user_val.indexOf(CHECKLIST_SEPARATOR > -1) : void 0)) {
	            user_val = user_val.split(CHECKLIST_SEPARATOR);
	          } else if (is_grouped) {
	            user_val = [user_val];
	          }
	        }
	        if (!is_grouped && !user_val) {
	          continue;
	        }
	        results.push(LI({
	          key: attribute.name,
	          style: {
	            padding: '3px 0'
	          }
	        }, DIV({
	          key: 'attribute name',
	          style: {
	            fontSize: 14,
	            fontStyle: 'italic'
	          }
	        }, attribute.name), (function() {
	          var j, len1, results1;
	          results1 = [];
	          for (j = 0, len1 = user_val.length; j < len1; j++) {
	            val = user_val[j];
	            results1.push(SPAN({
	              key: val || unreported,
	              style: {
	                fontSize: 14,
	                backgroundColor: is_grouped ? get_color_for_group(val || unreported) : void 0,
	                color: is_grouped ? 'white' : void 0,
	                display: 'inline-block',
	                marginRight: 8,
	                padding: is_grouped ? '2px 8px' : void 0
	              }
	            }, val || unreported));
	          }
	          return results1;
	        })()));
	      }
	      return results;
	    })())) : void 0)), has_opinion ? (inclusions = opinion.point_inclusions || [], cnt = inclusions.length, toggle_reasons = (function(_this) {
	      return function(e) {
	        var popover;
	        _this.local.show_reasons = !_this.local.show_reasons;
	        save(_this.local);
	        popover = fetch('popover');
	        popover.hide_triangle = _this.local.show_reasons;
	        save(popover);
	        e.stopPropagation();
	        return e.preventDefault();
	      };
	    })(this), o_trans = translator('opinion', 'Opinion'), reasons_trans = translator({
	      id: 'avatar_popover.reason_count',
	      cnt: cnt
	    }, '{cnt, plural, one {# reason} other {# reasons}} given'), DIV({
	      style: {
	        marginTop: 8
	      }
	    }, DIV({
	      style: {
	        fontWeight: 'bold',
	        textAlign: 'center'
	      }
	    }, o_trans + ": " + alt + " • " + reasons_trans, cnt > 0 ? BUTTON({
	      tabIndex: 1,
	      className: 'like_link',
	      style: {
	        paddingLeft: 8
	      },
	      onClick: toggle_reasons
	    }, this.local.show_reasons ? translator('avatar_popover.hide_reasons', 'Hide reasons') : translator('avatar_popover.show_reasons', 'Show reasons')) : void 0), this.local.show_reasons ? UL({
	      style: {
	        listStyle: 'none',
	        margin: '12px auto'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = inclusions.length; i < len; i++) {
	        reason = inclusions[i];
	        point = fetch(reason);
	        results.push(LI({
	          style: {
	            paddingTop: 12,
	            maxWidth: 450,
	            borderRadius: 16,
	            padding: '0.5em 16px',
	            backgroundColor: '#f6f7f9',
	            boxShadow: '#b5b5b5 0 1px 1px 0px',
	            margin: '0px 16px 12px 16px'
	          }
	        }, SPAN({
	          style: {
	            textTransform: 'uppercase',
	            color: '#555',
	            paddingRight: 8
	          }
	        }, point.is_pro ? get_point_label('pro') : get_point_label('con'), ':'), SPAN({
	          style: {}
	        }, point.nutshell), SPAN({
	          style: {
	            fontStyle: 'italic',
	            marginLeft: 12
	          }
	        }, "~ " + (fetch(point.user).name))));
	      }
	      return results;
	    })()) : void 0)) : void 0);
	  }
	});
	
	props_to_strip = ['user', 'anonymous', 'set_bg_color', 'custom_bg_color', 'hide_popover', 'parents', 'img_size'];
	
	window.avatar = function(user, props) {
	  var alt, anonymous, attrs, classes, i, img_size, k, len, name, prop_to_strip, ref, ref1, ref2, src, style, v;
	  attrs = _.clone(props);
	  if (!user.key) {
	    if (user === ((ref = arest.cache['/current_user']) != null ? ref.user : void 0)) {
	      user = fetch(user);
	    } else if (arest.cache[user]) {
	      user = arest.cache[user];
	    } else {
	      fetch(user);
	      return SPAN(null);
	    }
	  }
	  style = {};
	  if (attrs.style) {
	    ref1 = attrs.style;
	    for (k in ref1) {
	      v = ref1[k];
	      style[k] = v;
	    }
	  }
	  anonymous = attrs.anonymous || (user && arest.key_id(user.key) < 0) || customization('anonymize_permanently');
	  src = null;
	  if (!attrs.custom_bg_color && user.avatar_file_name) {
	    if ((style != null ? style.width : void 0) >= 50) {
	      img_size = 'large';
	    } else {
	      img_size = attrs.img_size || 'small';
	    }
	    if (anonymous && user.avatar_file_name.indexOf('/') > -1) {
	      src = user.avatar_file_name;
	    } else {
	      src = avatarUrl(user, img_size);
	    }
	    style.backgroundColor = 'white';
	  } else if (attrs.set_bg_color && !attrs.custom_bg_color) {
	    if (user.bg_color == null) {
	      user.bg_color = hsv2rgb(Math.random() / 5 + .6, Math.random() / 8 + .025, Math.random() / 4 + .4);
	    }
	    style.backgroundColor = user.bg_color;
	  }
	  name = user_name(user, anonymous);
	  if (attrs.alt) {
	    alt = attrs.alt.replace('<user>', name);
	  } else {
	    alt = name;
	  }
	  classes = "avatar" + (attrs.className ? ' ' + attrs.className : '');
	  if (anonymous) {
	    if (user.key === ((ref2 = arest.cache['/current_user']) != null ? ref2.user : void 0)) {
	      classes += " pixelated-avatar";
	      style.filter = "blur(" + (.025 * (style.width || 50)) + "px)";
	    }
	  }
	  attrs = _.extend(attrs, {
	    key: user.key,
	    className: classes,
	    'data-user': user.key,
	    'data-popover': !props.hide_popover && !anonymous && !screencasting() ? alt : void 0,
	    'data-tooltip': anonymous ? alt : void 0,
	    'data-anon': anonymous,
	    tabIndex: props.focusable ? 0 : -1,
	    width: style != null ? style.width : void 0,
	    height: style != null ? style.width : void 0,
	    style: style
	  });
	  for (i = 0, len = props_to_strip.length; i < len; i++) {
	    prop_to_strip = props_to_strip[i];
	    if (prop_to_strip in attrs) {
	      delete attrs[prop_to_strip];
	    }
	  }
	  if (src) {
	    attrs.src = src;
	    return IMG(attrs);
	  } else {
	    return SPAN(attrs);
	  }
	};
	
	window.Avatar = ReactiveComponent({
	  displayName: 'Avatar',
	  render: function() {
	    return avatar(this.data(), this.props);
	  }
	});
	
	styles += ".avatar {\n  position: relative; /* for containing the :after image */\n  border: none;\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  border-radius: 50%;\n  background-size: cover;\n  background-color: " + default_avatar_in_histogram_color + "; \n  transition: width 750ms, height 750ms, transform 750ms, background-color 750ms, opacity 50ms;\n  user-select: none; \n  -moz-user-select: none; \n  -webkit-user-select: none;\n  -ms-user-select: none;\n}\n\n/* for styling icon of broken images */\nimg.avatar:after { \n  position: absolute;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #f7954c; \n  border-radius: 50%;\n  content: \"\";\n}\n\n\n.pixelated-avatar::before {\n  content: \"?\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: black;\n  font-size: 24px;\n  font-weight: bold;\n}\n";
	
	cached_avatars = {};
	
	cached_anonymous_avatars = {};
	
	missing_images = {};
	
	loaded_images = {};
	
	users2images = {};
	
	window.getCanvasAvatar = function(user, anonymous) {
	  var key, ref;
	  if (anonymous == null) {
	    anonymous = false;
	  }
	  key = user.key || user;
	  if (anonymous && key === ((ref = arest.cache['/current_user']) != null ? ref.user : void 0)) {
	    if (key in cached_avatars) {
	      if (!(key in cached_anonymous_avatars)) {
	        cached_anonymous_avatars[key] = create_pixelated_avatar(cached_avatars[key]);
	      }
	      return cached_anonymous_avatars[key];
	    } else {
	      return cached_avatars["default"];
	    }
	  }
	  return cached_avatars[key] || cached_avatars["default"];
	};
	
	colors_used = {};
	
	window.createHitRegionAvatar = function(user) {
	  var b, color, g, r;
	  while ((color == null) || color in colors_used) {
	    r = Math.round(Math.random() * 255);
	    g = Math.round(Math.random() * 255);
	    b = Math.round(Math.random() * 255);
	    color = "rgb(" + r + "," + g + "," + b + ")";
	  }
	  colors_used[color] = true;
	  user.hit_region_color = color;
	  return createUserIcon(user.hit_region_color);
	};
	
	group_colored_icons = {};
	
	window.getGroupIcon = function(key, color) {
	  if (!(key in group_colored_icons)) {
	    group_colored_icons[key] = createUserIcon(color);
	  }
	  return group_colored_icons[key];
	};
	
	icon_cache = {};
	
	createUserIcon = function(fill) {
	  var canv, ctx, rx;
	  if (fill in icon_cache) {
	    return icon_cache[fill];
	  }
	  canv = document.createElement('canvas');
	  canv.width = canv.height = 50 * window.devicePixelRatio;
	  rx = canv.width / 2;
	  ctx = canv.getContext("2d");
	  ctx.arc(rx, rx, rx, 0, 2 * Math.PI);
	  ctx.fillStyle = fill;
	  ctx.fill();
	  icon_cache[fill] = canv;
	  return canv;
	};
	
	window.getCompositeGroupIcon = function(key, groups, colors) {
	  if (!(key in group_colored_icons)) {
	    group_colored_icons[key] = createCompositeGroupIcon(groups, colors);
	  }
	  return group_colored_icons[key];
	};
	
	createCompositeGroupIcon = function(groups, colors) {
	  var canv, color, ctx, group, i, idx, len, num, rx;
	  num = groups.length;
	  canv = document.createElement('canvas');
	  canv.width = canv.height = 50 * window.devicePixelRatio;
	  rx = canv.width / 2;
	  ctx = canv.getContext("2d");
	  for (idx = i = 0, len = groups.length; i < len; idx = ++i) {
	    group = groups[idx];
	    color = colors[group];
	    ctx.beginPath();
	    ctx.moveTo(rx, rx);
	    ctx.arc(rx, rx, rx, idx * 2 * Math.PI / num, (idx + 1) * 2 * Math.PI / num);
	    ctx.fillStyle = color;
	    ctx.fill();
	  }
	  return canv;
	};
	
	createFallbackIcon = function(user) {
	  var h, s, v;
	  if (user.bg_color == null) {
	    h = Math.random() / 5 + .6;
	    s = Math.random() / 8 + .025;
	    v = Math.random() / 4 + .4;
	    h = Math.round(h * 15) / 15;
	    s = Math.round(s * 15) / 15;
	    v = Math.round(v * 15) / 15;
	    user.bg_color = hsv2rgb(h, s, v);
	  }
	  return createUserIcon(user.bg_color);
	};
	
	create_avatar = function(img, clip) {
	  var canv, ctx;
	  if (clip == null) {
	    clip = true;
	  }
	  canv = document.createElement('canvas');
	  canv.width = img.width;
	  canv.height = img.height;
	  ctx = canv.getContext('2d');
	  if (clip) {
	    ctx.arc(img.width / 2, img.height / 2, img.height / 2, 0, Math.PI * 2);
	    ctx.clip();
	  }
	  ctx.drawImage(img, 0, 0);
	  canv.original_image = img;
	  return canv;
	};
	
	create_pixelated_avatar = function(canv, showQuestionMarkOverlay) {
	  var anon_canv, ctx, h, pixelSize, size, tempCanvas, tempCtx, w;
	  if (showQuestionMarkOverlay == null) {
	    showQuestionMarkOverlay = false;
	  }
	  if (!canv.original_image) {
	    return cached_avatars["default"];
	  }
	  anon_canv = create_avatar(canv.original_image, false);
	  w = anon_canv.width;
	  h = anon_canv.height;
	  ctx = anon_canv.getContext('2d');
	  pixelSize = w / 10;
	  tempCanvas = document.createElement('canvas');
	  tempCanvas.width = w / pixelSize;
	  tempCanvas.height = h / pixelSize;
	  tempCtx = tempCanvas.getContext('2d');
	  tempCtx.imageSmoothingEnabled = false;
	  tempCtx.drawImage(anon_canv, 0, 0, w / pixelSize, h / pixelSize);
	  ctx.drawImage(tempCanvas, 0, 0, w / pixelSize, h / pixelSize, 0, 0, w, h);
	  if (showQuestionMarkOverlay) {
	    size = w / 2;
	    ctx.drawImage(my_question_mark_icon, w / 2 - size / 2, h / 2 - size / 2, size, size);
	  }
	  canv = document.createElement('canvas');
	  canv.width = w;
	  canv.height = h;
	  ctx = canv.getContext('2d');
	  ctx.arc(w / 2, h / 2, h / 2, 0, Math.PI * 2);
	  ctx.clip();
	  ctx.drawImage(anon_canv, 0, 0);
	  return canv;
	};
	
	question_mark_icon = function() {
	  var iconHeight, iconWidth, path1, qm_canv, qm_ctx, svgPath1;
	  iconWidth = 24;
	  iconHeight = 24;
	  qm_canv = document.createElement('canvas');
	  qm_canv.width = iconWidth;
	  qm_canv.height = iconHeight;
	  qm_ctx = qm_canv.getContext('2d');
	  svgPath1 = "M9.11241 7.82201C9.44756 6.83666 10.5551 6 12 6C13.7865 6 15 7.24054 15 8.5C15 9.75946 13.7865 11 12 11C11.4477 11 11 11.4477 11 12L11 14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14L13 12.9082C15.203 12.5001 17 10.7706 17 8.5C17 5.89347 14.6319 4 12 4C9.82097 4 7.86728 5.27185 7.21894 7.17799C7.0411 7.70085 7.3208 8.26889 7.84366 8.44673C8.36653 8.62458 8.93457 8.34488 9.11241 7.82201ZM12 20C12.8285 20 13.5 19.3284 13.5 18.5C13.5 17.6716 12.8285 17 12 17C11.1716 17 10.5 17.6716 10.5 18.5C10.5 19.3284 11.1716 20 12 20Z";
	  qm_ctx.fillStyle = 'black';
	  qm_ctx.strokeStyle = 'white';
	  qm_ctx.lineWidth = 1;
	  path1 = new Path2D(svgPath1);
	  qm_ctx.fill(path1);
	  qm_ctx.stroke(path1);
	  return qm_canv;
	};
	
	my_question_mark_icon = question_mark_icon();
	
	window.LoadAvatars = ReactiveComponent({
	  displayName: "LoadAvatars",
	  render: function() {
	    var loading, users;
	    users = fetch('/users');
	    loading = fetch('avatar_loading');
	    return SPAN(null);
	  },
	  load: function() {
	    var all_users, app, avatars_to_load, current_user, i, id, img, img_url, len, loading, name1, pic, ref, results, user, users;
	    users = fetch('/users');
	    current_user = fetch('/current_user');
	    if (!users.users || fetch('location').url.match('/dashboard')) {
	      return;
	    }
	    loading = fetch('avatar_loading');
	    app = arest.cache['/application'] || fetch('/application');
	    avatars_to_load = {};
	    all_users = users.users.slice() || [];
	    if (ref = current_user.user, indexOf.call(all_users, ref) < 0) {
	      all_users.push(current_user.user);
	    }
	    if (!cached_avatars["default"]) {
	      cached_avatars["default"] = createFallbackIcon({
	        key: 'default'
	      });
	    }
	    for (i = 0, len = all_users.length; i < len; i++) {
	      user = all_users[i];
	      user = fetch(user);
	      id = arest.key_id(user.key);
	      if (user.avatar_file_name) {
	        if (id < 0) {
	          img_url = user.avatar_file_name;
	        } else {
	          img_url = avatarUrl(user, 'large');
	        }
	        if ((users2images[user.key] !== img_url || !(img_url in loaded_images)) && !(img_url in missing_images)) {
	          if (avatars_to_load[img_url] == null) {
	            avatars_to_load[img_url] = [];
	          }
	          avatars_to_load[img_url].push(user);
	          users2images[user.key] = img_url;
	        }
	      }
	      if (cached_avatars[name1 = user.key] == null) {
	        cached_avatars[name1] = createFallbackIcon(user);
	      }
	    }
	    if (Object.keys(avatars_to_load).length > 0) {
	      if (!loading.loading) {
	        loading.loading = true;
	        save(loading);
	        this.loading_cnt = 0;
	        results = [];
	        for (img in avatars_to_load) {
	          users = avatars_to_load[img];
	          this.loading_cnt += 1;
	          pic = new Image();
	          pic.onload = (function(_this) {
	            return function(img, users, pic) {
	              return function() {
	                var cached_avatar, j, len1, u;
	                cached_avatar = create_avatar(pic);
	                for (j = 0, len1 = users.length; j < len1; j++) {
	                  user = users[j];
	                  loaded_images[img] = cached_avatars[user.key] = cached_avatar;
	                }
	                _this.loading_cnt -= 1;
	                if (_this.loading_cnt === 0) {
	                  loading.loading = false;
	                  loading.loaded = murmurhash((JSON.stringify(Object.keys(loaded_images))) + "-" + (JSON.stringify((function() {
	                    var l, len2, results1;
	                    results1 = [];
	                    for (l = 0, len2 = avatars_to_load.length; l < len2; l++) {
	                      u = avatars_to_load[l];
	                      results1.push(u.name);
	                    }
	                    return results1;
	                  })())), 0);
	                  return save(loading);
	                }
	              };
	            };
	          })(this)(img, users, pic);
	          pic.onerror = (function(_this) {
	            return function(user) {
	              return function() {
	                _this.loading_cnt -= 1;
	                return missing_images[user.avatar_file_name] = 1;
	              };
	            };
	          })(this)(user);
	          results.push(pic.src = img);
	        }
	        return results;
	      } else {
	        return setTimeout(this.load, 10);
	      }
	    }
	  },
	  componentDidMount: function() {
	    return this.load();
	  },
	  componentDidUpdate: function() {
	    return this.load();
	  }
	});


/***/ },
/* 15 */
/***/ function(module, exports) {

	var golden_ratio_conjugate, hsp_sample_size;
	
	window.focus_blue = '#456ae4';
	
	window.logo_red = "#B03A44";
	
	window.considerit_red = "#df6264";
	
	window.default_avatar_in_histogram_color = '#999';
	
	window.considerit_gray = '#f6f7f9';
	
	window.selected_color = '#DA4570';
	
	window.upgrade_color = '#16a1e3';
	
	window.attention_orange = "#fb7e26";
	
	window.main_background_color = '#f6f7f9';
	
	if (location.href.indexOf('aeroparticipa') > -1) {
	  window.focus_blue = "#073682";
	  window.selected_color = focus_blue;
	}
	
	window.parseCssRgb = function(css_color_str) {
	  var rgb, test;
	  test = document.createElement('div');
	  test.style.color = css_color_str;
	  css_color_str = test.style.color;
	  if (css_color_str === 'transparent') {
	    return {
	      r: 0,
	      g: 0,
	      b: 0,
	      a: 0
	    };
	  } else {
	    rgb = /^rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+),?\s*([\.\d]+)?\s*\)$/i.exec(css_color_str);
	    if (rgb) {
	      return {
	        r: parseInt(rgb[1]),
	        g: parseInt(rgb[2]),
	        b: parseInt(rgb[3]),
	        a: rgb.length > 4 && (rgb[4] != null) ? parseFloat(rgb[4]) : 1
	      };
	    } else {
	      console.error("Color " + css_color_str + " could not be parsed");
	      return {
	        r: 0,
	        g: 0,
	        b: 0
	      };
	    }
	  }
	};
	
	window.parseCssHsl = function(css_color_str) {
	  var rgb;
	  rgb = parseCssRgb(css_color_str);
	  return rgb2hsl(rgb);
	};
	
	window.rgb2hsl = function(rgb) {
	  var b, d, g, h, l, max, min, r, s;
	  r = rgb.r / 255;
	  g = rgb.g / 255;
	  b = rgb.b / 255;
	  max = Math.max(r, g, b);
	  min = Math.min(r, g, b);
	  l = (max + min) / 2;
	  if (max === min) {
	    h = s = 0;
	  } else {
	    d = max - min;
	    s = (l > 0.5 ? d / (2 - max - min) : d / (max + min));
	    switch (max) {
	      case r:
	        h = (g - b) / d + (g < b ? 6 : 0);
	        break;
	      case g:
	        h = (b - r) / d + 2;
	        break;
	      case b:
	        h = (r - g) / d + 4;
	    }
	    h /= 6;
	  }
	  return {
	    h: h,
	    s: s,
	    l: l
	  };
	};
	
	window.hsv2rgb = function(h, s, v, as_array) {
	  var b, f, g, h_i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, t;
	  h_i = Math.floor(h * 6);
	  f = h * 6 - h_i;
	  p = v * (1 - s);
	  q = v * (1 - f * s);
	  t = v * (1 - (1 - f) * s);
	  if (h_i === 0) {
	    ref = [v, t, p], r = ref[0], g = ref[1], b = ref[2];
	  }
	  if (h_i === 1) {
	    ref1 = [q, v, p], r = ref1[0], g = ref1[1], b = ref1[2];
	  }
	  if (h_i === 2) {
	    ref2 = [p, v, t], r = ref2[0], g = ref2[1], b = ref2[2];
	  }
	  if (h_i === 3) {
	    ref3 = [p, q, v], r = ref3[0], g = ref3[1], b = ref3[2];
	  }
	  if (h_i === 4) {
	    ref4 = [t, p, v], r = ref4[0], g = ref4[1], b = ref4[2];
	  }
	  if (h_i === 5) {
	    ref5 = [v, p, q], r = ref5[0], g = ref5[1], b = ref5[2];
	  }
	  if (as_array) {
	    return [r, g, b];
	  } else {
	    return "rgb(" + (Math.round(r * 256)) + ", " + (Math.round(g * 256)) + ", " + (Math.round(b * 256)) + ")";
	  }
	};
	
	window.addOpacity = function(color, opacity) {
	  var c;
	  c = parseCssRgb(color);
	  return "rgba(" + c.r + "," + c.g + "," + c.b + "," + opacity;
	};
	
	golden_ratio_conjugate = 0.618033988749895;
	
	window.getNiceRandomHues = function(num, seed) {
	  var h, hues, i;
	  h = seed || .5;
	  hues = [];
	  i = num;
	  while (i > 0) {
	    hues.push(h % 1);
	    h += golden_ratio_conjugate;
	    i -= 1;
	  }
	  return hues;
	};
	
	window.getColors = function(num, continuous) {
	  var colors, group_colors, hue, hues, idx, inc, j, k, len, ref;
	  if (continuous) {
	    group_colors = [];
	    inc = 1 / (num + 1);
	    colors = group_colors;
	    for (idx = j = 0, ref = num - 1; 0 <= ref ? j <= ref : j >= ref; idx = 0 <= ref ? ++j : --j) {
	      hue = inc * idx;
	      group_colors.push(hsv2rgb(hue, .75, .65));
	    }
	  } else if (num >= 3 && num <= 12) {
	    if (num <= 5) {
	      group_colors = colorbrewer.Set1[num];
	    } else if (num <= 8) {
	      group_colors = colorbrewer.Dark2[num];
	    } else {
	      group_colors = colorbrewer.Paired[num];
	    }
	  } else {
	    group_colors = [];
	    hues = getNiceRandomHues(num);
	    colors = group_colors;
	    for (idx = k = 0, len = hues.length; k < len; idx = ++k) {
	      hue = hues[idx];
	      group_colors.push(hsv2rgb(hue, Math.random() / 2 + .5, Math.random() / 2 + .5));
	    }
	  }
	  return group_colors;
	};
	
	window.is_light_background = function(color) {
	  var ref;
	  color || (color = fetch('edit_banner').background_css || ((ref = customization('banner')) != null ? ref.background_css : void 0) || DEFAULT_BACKGROUND_COLOR);
	  if (color in named_colors) {
	    color = named_colors[color];
	  }
	  return parseCssHsl(color).l > .75;
	};
	
	hsp_sample_size = 100;
	
	window.is_image_mostly_light = function(image_data, width, height) {
	  var b, col, col_sample, g, hsp, j, k, len, len1, light_pixels, r, row, row_sample, start;
	  row_sample = _.sample(_.range(height), hsp_sample_size);
	  light_pixels = 0;
	  for (j = 0, len = row_sample.length; j < len; j++) {
	    row = row_sample[j];
	    col_sample = _.sample(_.range(width), hsp_sample_size);
	    for (k = 0, len1 = col_sample.length; k < len1; k++) {
	      col = col_sample[k];
	      start = row * (width * 4) + col * 4;
	      r = image_data[start];
	      g = image_data[start + 1];
	      b = image_data[start + 2];
	      hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
	      if (hsp > 127.5) {
	        light_pixels += 1;
	      }
	    }
	  }
	  return light_pixels >= hsp_sample_size * hsp_sample_size / 2;
	};
	
	window.named_colors = {
	  'aliceblue': '#f0f8ff',
	  'antiquewhite': '#faebd7',
	  'aqua': '#00ffff',
	  'aquamarine': '#7fffd4',
	  'azure': '#f0ffff',
	  'beige': '#f5f5dc',
	  'bisque': '#ffe4c4',
	  'black': '#000000',
	  'blanchedalmond': '#ffebcd',
	  'blue': '#0000ff',
	  'blueviolet': '#8a2be2',
	  'brown': '#a52a2a',
	  'burlywood': '#deb887',
	  'cadetblue': '#5f9ea0',
	  'chartreuse': '#7fff00',
	  'chocolate': '#d2691e',
	  'coral': '#ff7f50',
	  'cornflowerblue': '#6495ed',
	  'cornsilk': '#fff8dc',
	  'crimson': '#dc143c',
	  'cyan': '#00ffff',
	  'darkblue': '#00008b',
	  'darkcyan': '#008b8b',
	  'darkgoldenrod': '#b8860b',
	  'darkgray': '#a9a9a9',
	  'darkgreen': '#006400',
	  'darkkhaki': '#bdb76b',
	  'darkmagenta': '#8b008b',
	  'darkolivegreen': '#556b2f',
	  'darkorange': '#ff8c00',
	  'darkorchid': '#9932cc',
	  'darkred': '#8b0000',
	  'darksalmon': '#e9967a',
	  'darkseagreen': '#8fbc8f',
	  'darkslateblue': '#483d8b',
	  'darkslategray': '#2f4f4f',
	  'darkturquoise': '#00ced1',
	  'darkviolet': '#9400d3',
	  'deeppink': '#ff1493',
	  'deepskyblue': '#00bfff',
	  'dimgray': '#696969',
	  'dodgerblue': '#1e90ff',
	  'firebrick': '#b22222',
	  'floralwhite': '#fffaf0',
	  'forestgreen': '#228b22',
	  'fuchsia': '#ff00ff',
	  'gainsboro': '#dcdcdc',
	  'ghostwhite': '#f8f8ff',
	  'gold': '#ffd700',
	  'goldenrod': '#daa520',
	  'gray': '#808080',
	  'green': '#008000',
	  'greenyellow': '#adff2f',
	  'honeydew': '#f0fff0',
	  'hotpink': '#ff69b4',
	  'indianred ': '#cd5c5c',
	  'indigo': '#4b0082',
	  'ivory': '#fffff0',
	  'khaki': '#f0e68c',
	  'lavender': '#e6e6fa',
	  'lavenderblush': '#fff0f5',
	  'lawngreen': '#7cfc00',
	  'lemonchiffon': '#fffacd',
	  'lightblue': '#add8e6',
	  'lightcoral': '#f08080',
	  'lightcyan': '#e0ffff',
	  'lightgoldenrodyellow': '#fafad2',
	  'lightgrey': '#d3d3d3',
	  'lightgreen': '#90ee90',
	  'lightpink': '#ffb6c1',
	  'lightsalmon': '#ffa07a',
	  'lightseagreen': '#20b2aa',
	  'lightskyblue': '#87cefa',
	  'lightslategray': '#778899',
	  'lightsteelblue': '#b0c4de',
	  'lightyellow': '#ffffe0',
	  'lime': '#00ff00',
	  'limegreen': '#32cd32',
	  'linen': '#faf0e6',
	  'magenta': '#ff00ff',
	  'maroon': '#800000',
	  'mediumaquamarine': '#66cdaa',
	  'mediumblue': '#0000cd',
	  'mediumorchid': '#ba55d3',
	  'mediumpurple': '#9370d8',
	  'mediumseagreen': '#3cb371',
	  'mediumslateblue': '#7b68ee',
	  'mediumspringgreen': '#00fa9a',
	  'mediumturquoise': '#48d1cc',
	  'mediumvioletred': '#c71585',
	  'midnightblue': '#191970',
	  'mintcream': '#f5fffa',
	  'mistyrose': '#ffe4e1',
	  'moccasin': '#ffe4b5',
	  'navajowhite': '#ffdead',
	  'navy': '#000080',
	  'oldlace': '#fdf5e6',
	  'olive': '#808000',
	  'olivedrab': '#6b8e23',
	  'orange': '#ffa500',
	  'orangered': '#ff4500',
	  'orchid': '#da70d6',
	  'palegoldenrod': '#eee8aa',
	  'palegreen': '#98fb98',
	  'paleturquoise': '#afeeee',
	  'palevioletred': '#d87093',
	  'papayawhip': '#ffefd5',
	  'peachpuff': '#ffdab9',
	  'peru': '#cd853f',
	  'pink': '#ffc0cb',
	  'plum': '#dda0dd',
	  'powderblue': '#b0e0e6',
	  'purple': '#800080',
	  'rebeccapurple': '#663399',
	  'red': '#ff0000',
	  'rosybrown': '#bc8f8f',
	  'royalblue': '#4169e1',
	  'saddlebrown': '#8b4513',
	  'salmon': '#fa8072',
	  'sandybrown': '#f4a460',
	  'seagreen': '#2e8b57',
	  'seashell': '#fff5ee',
	  'sienna': '#a0522d',
	  'silver': '#c0c0c0',
	  'skyblue': '#87ceeb',
	  'slateblue': '#6a5acd',
	  'slategray': '#708090',
	  'snow': '#fffafa',
	  'springgreen': '#00ff7f',
	  'steelblue': '#4682b4',
	  'tan': '#d2b48c',
	  'teal': '#008080',
	  'thistle': '#d8bfd8',
	  'tomato': '#ff6347',
	  'turquoise': '#40e0d0',
	  'violet': '#ee82ee',
	  'wheat': '#f5deb3',
	  'white': '#ffffff',
	  'whitesmoke': '#f5f5f5',
	  'yellow': '#ffff00',
	  'yellowgreen': '#9acd32'
	};


/***/ },
/* 16 */
/***/ function(module, exports) {

	window.passes_tags = function(user, tags) {
	  var i, len, passes, ref, ref1, ref2, tag;
	  if (typeof tags === 'string') {
	    tags = [tags];
	  }
	  user = fetch(user);
	  passes = true;
	  for (i = 0, len = tags.length; i < len; i++) {
	    tag = tags[i];
	    passes && (passes = !!((user != null ? (ref = user.tags) != null ? ref[tag] : void 0 : void 0) && !((ref1 = ("" + (user != null ? (ref2 = user.tags) != null ? ref2[tag] : void 0 : void 0)).toLowerCase()) === 'no' || ref1 === 'No' || ref1 === 'False' || ref1 === 'false' || ref1 === false)));
	  }
	  return passes;
	};
	
	window.passes_tag_filter = function(user, tag, regex) {
	  var ref, ref1;
	  user = fetch(user);
	  return !!(user != null ? (ref = user.tags) != null ? (ref1 = ref[tag]) != null ? ref1.match(regex) : void 0 : void 0 : void 0);
	};
	
	window.cluster_link = function(href, anchor) {
	  anchor || (anchor = href);
	  return "<a href='" + href + "' target='_blank' style='font-weight: 600; text-decoration:underline'>" + anchor + "</a>";
	};
	
	window.point_labels = {
	  pro_con: {
	    translate: true,
	    pro: 'pro',
	    pros: 'pros',
	    con: 'con',
	    cons: 'cons',
	    your_header: "Give your {arguments}",
	    other_header: "Others' {arguments}",
	    top_header: "Top {arguments}",
	    your_cons_header: null,
	    your_pros_header: null
	  },
	  strengths_weaknesses: {
	    translate: true,
	    pro: 'strength',
	    pros: 'strengths',
	    con: 'weakness',
	    cons: 'weaknesses',
	    your_header: "{arguments}",
	    other_header: "{arguments} observed",
	    top_header: "Top {arguments}"
	  }
	};
	
	window.get_point_label = function(id, proposal) {
	  var conf, prop, ref, val;
	  prop = ((ref = id.split('.')) != null ? ref[1] : void 0) || id;
	  if (proposal) {
	    conf = customization('point_labels', proposal);
	  } else {
	    conf = customization('point_labels');
	  }
	  val = conf[prop];
	  if (!val) {
	    return "";
	  } else {
	    return translator({
	      id: "point_labels." + val,
	      local: !conf.translate
	    }, val);
	  }
	};
	
	window.get_slider_label = function(id, proposal, subdomain) {
	  var conf, label, ref, side;
	  side = ((ref = id.split('.')) != null ? ref[1] : void 0) || id;
	  if (proposal) {
	    conf = customization('slider_pole_labels', proposal, subdomain);
	  } else {
	    conf = customization('slider_pole_labels', null, subdomain);
	  }
	  label = conf[side];
	  if (!label) {
	    return "";
	  } else {
	    return translator({
	      id: "sliders.pole." + label,
	      local: !conf.translate
	    }, label);
	  }
	};
	
	window.positive_scale = function(value, proposal) {
	  var conf;
	  value = (value + 1) / 2;
	  conf = customization('slider_pole_labels', proposal, fetch('/subdomain'));
	  return (Math.round(value * 100)) + "% " + conf.support;
	};
	
	window.fully_firmly_slightly_scale = function(value, proposal) {
	  var degree, strength_of_opinion, valence;
	  if (Math.abs(value) < 0.02) {
	    return translator({
	      id: "sliders.feedback.neutral"
	    }, "You are neutral");
	  } else {
	    valence = get_slider_label((value > 0 ? 'support' : 'oppose'), proposal);
	    degree = Math.abs(value);
	    strength_of_opinion = degree > .999 ? "Fully" : degree > .5 ? "Firmly" : "Slightly";
	    return translator({
	      id: "sliders.feedback." + strength_of_opinion,
	      strength_of_opinion: strength_of_opinion,
	      valence: valence
	    }, "You " + strength_of_opinion + " {valence}");
	  }
	};
	
	window.slider_labels = {
	  agree_disagree: {
	    translate: true,
	    support: 'Agree',
	    oppose: 'Disagree',
	    slider_feedback: fully_firmly_slightly_scale
	  },
	  support_oppose: {
	    translate: true,
	    support: 'Support',
	    oppose: 'Oppose',
	    slider_feedback: fully_firmly_slightly_scale
	  },
	  priority: {
	    translate: true,
	    support: 'High Priority',
	    oppose: 'Low Priority',
	    slider_feedback: positive_scale
	  },
	  important_unimportant: {
	    translate: true,
	    support: 'More Important',
	    oppose: 'Less Important'
	  },
	  relevance: {
	    support: 'Big impact!',
	    oppose: 'No impact on me'
	  },
	  interested: {
	    support: 'More Interesting',
	    oppose: 'Less Interesting'
	  },
	  yes_no: {
	    support: 'Yes',
	    oppose: 'No'
	  },
	  strong_weak: {
	    support: 'Strong',
	    oppose: 'Weak'
	  },
	  promising_weak: {
	    support: 'Promising',
	    oppose: 'Weak'
	  },
	  ready_not_ready: {
	    support: 'Ready',
	    oppose: 'Not ready'
	  },
	  plus_minus: {
	    support: '+',
	    oppose: '–'
	  },
	  effective_ineffective: {
	    support: 'Effective',
	    oppose: 'Ineffective'
	  }
	};
	
	window.ExpandableSection = ReactiveComponent({
	  displayName: 'ExpandableSection',
	  render: function() {
	    var expanded, label, symbol, text;
	    label = this.props.label;
	    text = this.props.text;
	    expanded = this.local.expanded;
	    symbol = expanded ? 'fa-chevron-down' : 'fa-chevron-right';
	    return DIV(null, DIV({
	      onClick: (function(_this) {
	        return function() {
	          _this.local.expanded = !_this.local.expanded;
	          return save(_this.local);
	        };
	      })(this),
	      style: {
	        fontWeight: 600,
	        color: this.props.text_color || 'black',
	        cursor: 'pointer',
	        marginTop: 12,
	        fontSize: 22
	      }
	    }, SPAN({
	      className: "fa " + symbol,
	      style: {
	        opacity: .7,
	        position: 'relative',
	        left: -3,
	        paddingRight: 6,
	        display: 'inline-block',
	        width: 20
	      }
	    }), SPAN({
	      style: {}
	    }, label)), expanded ? text : void 0);
	  }
	});


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var debug, dockingStation, realDimensions,
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(3);
	
	__webpack_require__(1);
	
	window.Dock = ReactiveComponent({
	  displayName: 'Dock',
	  render: function() {
	    var dock, l, len, positioning_method, prop_to_strip, props, ref, ref1, style, x, y;
	    dock = fetch(this.key);
	    if (dock.docked) {
	      ref = [dock.x, dock.y], x = ref[0], y = ref[1];
	      positioning_method = 'fixed';
	      style = {
	        top: 0,
	        position: positioning_method,
	        WebkitBackfaceVisibility: "hidden",
	        transform: "translate(" + x + "px, " + y + "px)",
	        zIndex: 999999 - this.local.stack_priority,
	        width: '100%'
	      };
	    }
	    props = _.extend({}, this.props);
	    ref1 = ['dock_key', 'dock_on_zoomed_screens', 'skip_jut', 'dummy', 'parents', 'docked_key', 'constraints', 'dockable', 'dummy2', 'stop'];
	    for (l = 0, len = ref1.length; l < len; l++) {
	      prop_to_strip = ref1[l];
	      if (prop_to_strip in props) {
	        delete props[prop_to_strip];
	      }
	    }
	    return DIV(props, DIV({
	      style: {
	        height: dock.docked ? this.local.placeholder_height : 0
	      }
	    }), DIV({
	      ref: 'dock_child',
	      style: style || {}
	    }, this.props.children));
	  },
	  UNSAFE_componentWillMount: function() {
	    var dock;
	    this.key = this.props.dock_key != null ? this.props.dock_key : this.local.key;
	    dock = fetch(this.key, {
	      docked: false,
	      y: void 0,
	      x: void 0
	    });
	    return save(dock);
	  },
	  componentDidMount: function() {
	    var el, element_height, jut_above, jut_below, last_dom, placeholder_height, ref, serializer;
	    el = this.refs.dock_child.firstChild;
	    this.local.stack_priority = $$.offset(el).top;
	    placeholder_height = (ref = el.style.position) === 'absolute' || ref === 'fixed' ? 0 : el.offsetHeight;
	    this.local.placeholder_height = placeholder_height;
	    save(this.local);
	    element_height = jut_above = jut_below = last_dom = null;
	    serializer = new XMLSerializer();
	    return dockingStation.register(this.key, (function(_this) {
	      return function() {
	        var base, current_dom, dock_el, ref1;
	        el = _this.refs.dock_child.firstChild;
	        current_dom = serializer.serializeToString(el) + _this.props.skip_jut;
	        if (current_dom !== last_dom) {
	          ref1 = !_this.props.skip_jut ? realDimensions(el) : [$$.height(el), 0, 0], element_height = ref1[0], jut_above = ref1[1], jut_below = ref1[2];
	          last_dom = current_dom;
	        }
	        dock_el = ReactDOM.findDOMNode(_this);
	        return {
	          start: _.isFunction(_this.props.start) ? _this.props.start() : $$.offset(dock_el).top + (_this.props.start || 0),
	          stop: (typeof (base = _this.props).stop === "function" ? base.stop() : void 0) || 2e308,
	          dock_on_zoom: _this.props.dock_on_zoomed_screens != null ? _this.props.dock_on_zoomed_screens : true,
	          skip_docking: _this.props.dockable && !_this.props.dockable(),
	          stack_priority: _this.local.stack_priority,
	          jut_above: jut_above,
	          height: element_height,
	          constraints: _this.props.constraints || [],
	          docked_key: _this.props.docked_key
	        };
	      };
	    })(this));
	  },
	  componentWillUnmount: function() {
	    return dockingStation.unregister(this.key);
	  }
	});
	
	debug = false;
	
	window.ccnt = 0;
	
	dockingStation = {
	  registry: {},
	  listening_to_scroll_events: false,
	  component_history: {},
	  viewport: {},
	  register: function(key, info_callback) {
	    dockingStation.registry[key] = info_callback;
	    dockingStation.component_history[key] = {
	      previous: {},
	      on_dock: {}
	    };
	    if (!dockingStation.listening_to_scroll_events) {
	      this.on_scroll = function() {
	        return window.requestAnimationFrame(dockingStation.onScroll);
	      };
	      window.addEventListener("scroll", this.on_scroll);
	      window.addEventListener("resize", dockingStation.onResize);
	      dockingStation.check_resize_interval = setInterval(dockingStation.onCheckStickyResize, 500);
	      return dockingStation.listening_to_scroll_events = true;
	    }
	  },
	  unregister: function(key) {
	    delete dockingStation.registry[key];
	    if (_.keys(dockingStation.registry).length === 0) {
	      window.removeEventListener("scroll", this.on_scroll);
	      window.removeEventListener("resize", dockingStation.onResize);
	      dockingStation.listening_to_scroll_events = false;
	      clearInterval(dockingStation.check_resize_interval);
	      dockingStation.check_resize_interval = null;
	      clearInterval(dockingStation.interval);
	      return dockingStation.interval = null;
	    }
	  },
	  onScroll: function() {
	    var e, max_change;
	    try {
	      ccnt += 1;
	      dockingStation.updateViewport();
	      max_change = dockingStation.viewport.last.top != null ? Math.abs(dockingStation.viewport.top - dockingStation.viewport.last.top) : 2e308;
	      return dockingStation.layout(max_change);
	    } catch (error) {
	      e = error;
	      console.log("Problem with docking station onScroll");
	      return console.error(e);
	    }
	  },
	  onResize: function() {
	    var max_change;
	    dockingStation.updateViewport();
	    max_change = Math.abs(dockingStation.viewport.height - dockingStation.viewport.last.height);
	    return dockingStation.layout(max_change);
	  },
	  onCheckStickyResize: function() {
	    var dock, height_change, k, ref, results, v;
	    ref = dockingStation.registry;
	    results = [];
	    for (k in ref) {
	      if (!hasProp.call(ref, k)) continue;
	      v = ref[k];
	      dock = fetch(k);
	      if (dock.docked && v().height !== dockingStation.component_history[k].previous.height) {
	        height_change = v().height - dockingStation.component_history[k].previous.height;
	        if (debug) {
	          console.log("HEIGHT RESIZE at most " + height_change);
	        }
	        dockingStation.layout(Math.abs(height_change));
	        break;
	      } else {
	        results.push(void 0);
	      }
	    }
	    return results;
	  },
	  updateViewport: function() {
	    return dockingStation.viewport = {
	      last: {
	        top: dockingStation.viewport.top,
	        height: dockingStation.viewport.height
	      },
	      top: document.documentElement.scrollTop || document.body.scrollTop,
	      height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
	    };
	  },
	  layout: function(max_change) {
	    var dock, docked, docks, k, l, len, len1, m, ref, ref1, ref2, undocked, v, x, y, y_pos, y_stack;
	    docks = {};
	    ref = dockingStation.registry;
	    for (k in ref) {
	      if (!hasProp.call(ref, k)) continue;
	      v = ref[k];
	      docks[k] = v();
	      docks[k].key = k;
	    }
	    ref1 = dockingStation.determineIfDocked(docks), docked = ref1[0], undocked = ref1[1], y_stack = ref1[2];
	    for (l = 0, len = undocked.length; l < len; l++) {
	      k = undocked[l];
	      if (fetch(k).docked) {
	        dockingStation.toggleDocked(k, docks[k]);
	      }
	    }
	    if (docked.length > 0) {
	      y_pos = dockingStation.solveForY(docked, docks, max_change);
	      if (y_pos == null) {
	        return;
	      }
	      for (m = 0, len1 = docked.length; m < len1; m++) {
	        k = docked[m];
	        dock = fetch(k);
	        dockingStation.component_history[k].previous = _.extend(docks[k], {
	          calculated_y: y_pos[k].value
	        });
	        ref2 = dockingStation.adjustForDevice(y_pos[k].value, docks[k]), x = ref2[0], y = ref2[1];
	        if (dock.y !== y || dock.x !== x) {
	          if (debug) {
	            console.log("UPDATING " + dock.key);
	          }
	          dock.y = y;
	          dock.x = x;
	          if (!dock.docked) {
	            dockingStation.toggleDocked(k, docks[k]);
	          }
	          save(dock);
	        }
	      }
	      docks = fetch('docking_station');
	      if (docks.y_stack !== y_stack) {
	        docks.y_stack = y_stack;
	        return save(docks);
	      }
	    }
	  },
	  determineIfDocked: function(docks) {
	    var dimensions, docked, is_docked, l, len, sorted, undocked, v, y_stack, zoomed_or_small;
	    docked = [];
	    undocked = [];
	    zoomed_or_small = window.innerWidth / document.documentElement.clientWidth < .95 || screen.width <= 700;
	    sorted = _.sortBy(_.values(docks), function(v) {
	      return v.stack_priority;
	    });
	    y_stack = 0;
	    for (l = 0, len = sorted.length; l < len; l++) {
	      v = sorted[l];
	      if (v.skip_docking || (!v.dock_on_zoom && zoomed_or_small)) {
	        is_docked = false;
	      } else {
	        dimensions = fetch(v.key).docked ? dockingStation.component_history[v.key].on_dock : {
	          height: v.height,
	          jut_above: v.jut_above
	        };
	        is_docked = dockingStation.viewport.top + y_stack + dimensions.jut_above >= v.start;
	      }
	      if (is_docked) {
	        y_stack += dimensions.height;
	        docked.push(v.key);
	      } else {
	        undocked.push(v.key);
	      }
	    }
	    return [docked, undocked, y_stack];
	  },
	  toggleDocked: function(k, v) {
	    var dock, external_docked, is_docked;
	    dock = fetch(k);
	    is_docked = !dock.docked;
	    dock.docked = is_docked;
	    if (!is_docked) {
	      dock.y = dock.x = null;
	      dockingStation.component_history[k].previous = {};
	    } else {
	      dockingStation.component_history[k].on_dock = v;
	    }
	    save(dock);
	    if (v.docked_key != null) {
	      external_docked = fetch(v.docked_key);
	      external_docked.docked = is_docked;
	      save(external_docked);
	    }
	    if (debug) {
	      return console.log("Toggled " + k + " to " + dock.docked);
	    }
	  },
	  solveForY: function(docked, docks, max_change) {
	    var c, dock, i, j, k, l, len, len1, len2, m, n, previous_calculated_y, scroll_distance, sk, solver, sorted, sv, v, y_pos, y_stack;
	    if (typeof cassowary === "undefined" || cassowary === null) {
	      if (dockingStation.cassowary_loading == null) {
	        dockingStation.cassowary_loading = setInterval(function() {
	          if (typeof cassowary !== "undefined" && cassowary !== null) {
	            dockingStation.solveForY(docked, docks, max_change);
	            return clearInterval(dockingStation.cassowary_loading);
	          }
	        }, 10);
	      }
	      return;
	    }
	    c = cassowary;
	    solver = new c.SimplexSolver();
	    scroll_distance = Math.abs(dockingStation.viewport.top - dockingStation.viewport.last.top);
	    if (scroll_distance > 0) {
	      dockingStation.scrolling_down = dockingStation.viewport.top > dockingStation.viewport.last.top;
	    }
	    if (debug) {
	      console.log("viewport height: ", dockingStation.viewport.height);
	    }
	    y_stack = 0;
	    sorted = (function() {
	      var results;
	      results = [];
	      for (k in docks) {
	        if (!hasProp.call(docks, k)) continue;
	        v = docks[k];
	        if (indexOf.call(docked, k) >= 0) {
	          results.push(v);
	        }
	      }
	      return results;
	    })();
	    sorted = _.sortBy(sorted, function(v) {
	      return v.stack_priority;
	    });
	    y_pos = {};
	    for (l = 0, len = sorted.length; l < len; l++) {
	      v = sorted[l];
	      y_pos[v.key] = new c.Variable;
	    }
	    for (i = m = 0, len1 = sorted.length; m < len1; i = ++m) {
	      v = sorted[i];
	      if (debug) {
	        console.log("**" + v.key + " constraints**");
	      }
	      k = v.key;
	      dock = fetch(k);
	      previous_calculated_y = dockingStation.component_history[k].previous.calculated_y;
	      if (debug) {
	        console.log("\tSTART: " + k + " >= " + v.start + ", strong");
	      }
	      solver.addConstraint(new c.Inequality(y_pos[k], c.GEQ, v.start, c.Strength.strong));
	      if (v.stop !== 2e308) {
	        if (debug) {
	          console.log("\tSTOP: " + k + " <= " + v.stop + " - " + v.height + ", strong");
	        }
	        solver.addConstraint(new c.Inequality(y_pos[k], c.LEQ, v.stop - v.height, c.Strength.strong));
	      }
	      if ((max_change != null) && (previous_calculated_y != null)) {
	        if (debug) {
	          console.log("\tBOUNDED BY MAX CHANGE: |" + k + " - " + previous_calculated_y + "| <= " + max_change + ", strong");
	        }
	        solver.addConstraint(new c.Inequality(y_pos[k], c.LEQ, previous_calculated_y + max_change, c.Strength.strong));
	        solver.addConstraint(new c.Inequality(y_pos[k], c.GEQ, previous_calculated_y - max_change, c.Strength.strong));
	      }
	      if (debug) {
	        console.log("\tTOP OF COMPONENT VISIBLE: \n" + k + " >= " + dockingStation.viewport.top + " + " + v.jut_above + " + " + y_stack + ", \n" + (dockingStation.scrolling_down ? 'weak' : 'medium'));
	      }
	      solver.addConstraint(new c.Inequality(y_pos[k], c.GEQ, dockingStation.viewport.top + v.jut_above + y_stack, dockingStation.scrolling_down ? c.Strength.weak : c.Strength.medium));
	      y_stack += v.height;
	      if (debug) {
	        console.log("\tBOTTOM OF COMPONENT VISIBLE: \n" + k + " + " + v.height + " <= " + dockingStation.viewport.top + " + " + dockingStation.viewport.height + ", \n" + (dockingStation.scrolling_down ? 'medium' : 'weak'));
	      }
	      solver.addConstraint(new c.Inequality(y_pos[k], c.LEQ, dockingStation.viewport.top + dockingStation.viewport.height - v.height, dockingStation.scrolling_down ? c.Strength.medium : c.Strength.weak));
	      for (j = n = 0, len2 = sorted.length; n < len2; j = ++n) {
	        sv = sorted[j];
	        sk = sv.key;
	        if (j < i && indexOf.call(v.constraints, sk) >= 0) {
	          if (debug) {
	            console.log("\tRELATIONAL: \n" + k + " >= " + sk + " + " + sv.height + " + " + v.jut_above + " - " + sv.jut_above + "}, required");
	          }
	          solver.addConstraint(new c.Inequality(y_pos[k], c.GEQ, c.plus(y_pos[sk], sv.height + v.jut_above - sv.jut_above), c.Strength.required));
	          solver.addConstraint(new c.Equation(y_pos[k], c.plus(y_pos[sk], sv.height + v.jut_above - sv.jut_above), c.Strength.strong));
	        }
	      }
	    }
	    solver.resolve();
	    if (debug) {
	      for (k in y_pos) {
	        if (!hasProp.call(y_pos, k)) continue;
	        v = y_pos[k];
	        console.info(k + ": " + v.value);
	      }
	    }
	    return y_pos;
	  },
	  adjustForDevice: function(y, v) {
	    var x;
	    y -= dockingStation.viewport.top;
	    x = -document.body.scrollLeft;
	    return [x, y];
	  },
	  initialize: function() {
	    return dockingStation.updateViewport();
	  }
	};
	
	dockingStation.initialize();
	
	realDimensions = function(el) {
	  var jut_above, jut_below, max_top, min_top, offset, recurse, ref;
	  recurse = function(cur_el, min_top, max_top) {
	    var child, h, l, len, ref, ref1, t;
	    t = $$.offset(cur_el).top;
	    h = $$.height(cur_el);
	    if (h === 0 || cur_el.style.display === 'none') {
	      return [min_top, max_top];
	    }
	    if (min_top > t) {
	      min_top = t;
	    }
	    if (t + h > max_top) {
	      max_top = t + h;
	    }
	    ref = cur_el.children;
	    for (l = 0, len = ref.length; l < len; l++) {
	      child = ref[l];
	      ref1 = recurse(child, min_top, max_top), min_top = ref1[0], max_top = ref1[1];
	    }
	    return [min_top, max_top];
	  };
	  ref = recurse(el, 2e308, 0), min_top = ref[0], max_top = ref[1];
	  offset = $$.offset(el).top;
	  jut_above = offset - min_top;
	  jut_below = max_top - (offset + $$.height(el));
	  return [max_top - min_top, jut_above, jut_below];
	};


/***/ },
/* 18 */
/***/ function(module, exports) {

	var EvaluateLayout, Placer, histo_queue, histo_running, layout_complete, positionAvatarsWithJustLayout, process_next_layout, top_level, write_layout;
	
	histo_queue = [];
	
	histo_running = null;
	
	if (typeof window !== "undefined" && window !== null) {
	  top_level = window;
	} else {
	  top_level = DedicatedWorkerGlobalScope;
	}
	
	top_level.enqueue_histo_layout = function(opts) {
	  histo_queue.push(opts);
	  return process_next_layout();
	};
	
	write_layout = function(opts, positions) {
	  return postMessage({
	    opts: {
	      k: opts.k,
	      histo: opts.histo
	    },
	    positions: positions
	  });
	};
	
	layout_complete = function(opts, positions) {
	  histo_running = null;
	  write_layout(opts, positions);
	  return process_next_layout();
	};
	
	process_next_layout = function() {
	  if (!histo_running && histo_queue.length > 0) {
	    histo_running = histo_queue.shift();
	    return positionAvatarsWithJustLayout(histo_running);
	  }
	};
	
	positionAvatarsWithJustLayout = function(opts) {
	  var evaluator, global_running_state, l, layout_params, len, n, name, nodes, opinions, placer, positions, r, running_state, t0;
	  layout_params = opts.layout_params;
	  if (layout_params.verbose) {
	    t0 = performance.now();
	  }
	  placer = Placer(opts);
	  nodes = placer.pixelated_layout();
	  while (!nodes && opts.r > 0) {
	    console.error("At least one avatar couldn't be placed with base radius " + opts.r + ". Trying again with base radius=" + (opts.r - 1));
	    opts.r -= 1;
	    placer = Placer(opts);
	    nodes = placer.pixelated_layout();
	  }
	  nodes.sort(function(a, b) {
	    return a.x_target - b.x_target;
	  });
	  placer.sweep_all_for_position_swaps(function(a, b) {
	    var tmpx, tmpy;
	    tmpx = a.x;
	    tmpy = a.y;
	    a.x = b.x;
	    a.y = b.y;
	    b.x = tmpx;
	    b.y = tmpy;
	    return true;
	  }, nodes);
	  if (opts.groups) {
	    placer.sweep_all_for_group_swaps(function(a, b) {
	      var tmpx, tmpy;
	      tmpx = a.x;
	      tmpy = a.y;
	      a.x = b.x;
	      a.y = b.y;
	      b.x = tmpx;
	      b.y = tmpy;
	      return true;
	    }, opts.groups, opts.all_groups, nodes);
	  }
	  opinions = opts.o;
	  positions = {};
	  for (l = 0, len = nodes.length; l < len; l++) {
	    n = nodes[l];
	    r = n.radius;
	    positions[n.user] = [Math.round((n.x - r) * 10) / 10, Math.round((n.y - r) * 10) / 10, r];
	  }
	  if (layout_params.verbose) {
	    global_running_state = fetch('histo-timing');
	    running_state = fetch(opts.histo_key);
	    if (global_running_state[name = layout_params.param_hash] == null) {
	      global_running_state[name] = {
	        tick_time: 0,
	        truth: 0,
	        visibility: 0,
	        stability: 0,
	        cnt: 0
	      };
	    }
	    evaluator = EvaluateLayout(opts, nodes, placer);
	    evaluator.evaluate_layout();
	    running_state.layout_time = performance.now() - t0;
	    global_running_state[layout_params.param_hash].tick_time += running_state.layout_time;
	    save(running_state);
	    save(global_running_state);
	  }
	  return layout_complete(opts, positions);
	};
	
	top_level.calculateAvatarRadius = function(width, height, opinions, weights, arg) {
	  var area, area_at_radius, avg_inc, candidate_r, current_window, densest_window, fill_ratio, idx, l, len, len1, m, o, opinion_space, r, ref, stance, sum, weight, window_size;
	  fill_ratio = arg.fill_ratio;
	  if (fill_ratio == null) {
	    fill_ratio = .25;
	  }
	  if (!width || !height) {
	    return 0;
	  }
	  opinions.sort(function(a, b) {
	    return a.stance - b.stance;
	  });
	  avg_inc = .025;
	  candidate_r = [];
	  ref = [.05, .10, .2];
	  for (l = 0, len = ref.length; l < len; l++) {
	    window_size = ref[l];
	    opinion_space = 0;
	    idx = 0;
	    stance = -1.0;
	    while (stance <= 1.0 + window_size) {
	      o = idx;
	      area = 0;
	      current_window = [];
	      while (o < opinions.length) {
	        if (opinions[o].stance < stance - window_size) {
	          idx = o;
	        } else if (opinions[o].stance > stance + window_size) {
	          break;
	        } else {
	          weight = weights[opinions[o].user] || 1;
	          current_window.push(weight);
	          area += weight;
	        }
	        o += 1;
	      }
	      if (area > opinion_space) {
	        opinion_space = area;
	        densest_window = current_window;
	      }
	      stance += avg_inc;
	    }
	    if (opinion_space > 0) {
	      area = fill_ratio * width * 2 * window_size * height;
	      r = 1;
	      while (true) {
	        area_at_radius = 0;
	        for (m = 0, len1 = densest_window.length; m < len1; m++) {
	          weight = densest_window[m];
	          area_at_radius += weight * 4 * r * r;
	        }
	        if (area_at_radius > area) {
	          if (r > 1) {
	            r = Math.round(r * area / area_at_radius);
	          }
	          break;
	        }
	        r += 1;
	      }
	    } else {
	      r = Math.sqrt(width * height / opinions.length * fill_ratio) / 2;
	    }
	    candidate_r.push(r);
	  }
	  sum = function(a, b) {
	    return a + b;
	  };
	  r = candidate_r.reduce(sum, 0) / candidate_r.length;
	  if (r > width / 2 || r > height / 2) {
	    r = Math.min(width / 2, height / 2);
	  }
	  return Math.max(1, Math.round(r));
	};
	
	Placer = function(opts, bodies) {
	  var Openings, avatar_mask, base_radius, build_occupancy_map, cleanup_overlap, get_mask, get_opinion_density, height, imprint_body_on_map, layout_params, opinion_density, opinions, pixelated_layout, running_state, save_snapshots, sweep_all_for_group_swaps, sweep_all_for_position_swaps, width, window_sizes;
	  opinions = opts.o;
	  width = Math.round(opts.w);
	  height = Math.round(opts.h);
	  layout_params = opts.layout_params;
	  base_radius = opts.r;
	  cleanup_overlap = layout_params.cleanup_overlap || 2;
	  if (layout_params.verbose) {
	    running_state = fetch(opts.histo_key);
	  }
	  save_snapshots = layout_params.verbose && layout_params.save_snapshots;
	  opinion_density = null;
	  window_sizes = [.1, .25, .4];
	  get_opinion_density = function(body) {
	    var area, avg_inc, densities, density, idx, l, len, len1, m, max_density, o, sorted_opinions, stance, window_size;
	    if (!opinion_density) {
	      opinion_density = {};
	      sorted_opinions = opinions.slice();
	      sorted_opinions.sort(function(a, b) {
	        return a[1] - b[1];
	      });
	      avg_inc = .01;
	      for (l = 0, len = window_sizes.length; l < len; l++) {
	        window_size = window_sizes[l];
	        idx = 0;
	        stance = -1.0 + window_size;
	        opinion_density[window_size] = densities = [];
	        max_density = 0;
	        while (stance <= 1.0 - window_size) {
	          o = idx;
	          area = 0;
	          while (o < sorted_opinions.length) {
	            if (sorted_opinions[o][1] < stance - window_size) {
	              idx = o;
	            } else if (sorted_opinions[o][1] > stance + window_size) {
	              break;
	            } else {
	              area += sorted_opinions[o][2] || 1;
	            }
	            o += 1;
	          }
	          if (max_density < area) {
	            max_density = area;
	          }
	          densities.push(area);
	          stance += avg_inc;
	        }
	        if (max_density > 0) {
	          for (idx = m = 0, len1 = densities.length; m < len1; idx = ++m) {
	            area = densities[idx];
	            densities[idx] /= max_density;
	          }
	        }
	      }
	    }
	    if (!body.opinion_density_at_target) {
	      density = 0;
	      for (window_size in opinion_density) {
	        densities = opinion_density[window_size];
	        density += densities[Math.round(body.x_target / (width - body.radius) * (densities.length - 1))];
	      }
	      density /= window_sizes.length;
	      body.opinion_density_at_target = density;
	    }
	    return body.opinion_density_at_target;
	  };
	  pixelated_layout = function() {
	    var adjusted_stance, current_cleanup, idx, l, laid_out, len, len1, m, moves_within, o, openings, place_body, radius, run_next, success, topple_towers, weight;
	    laid_out = [];
	    if (opinions.length === 0) {
	      return laid_out;
	    }
	    for (l = 0, len = opinions.length; l < len; l++) {
	      o = opinions[l];
	      weight = o[2] || 1;
	      o.radius = Math.round(Math.sqrt(weight) * base_radius);
	      if (o.radius < 1) {
	        o.radius = 1;
	      }
	      radius = o.radius;
	      adjusted_stance = (o[1] + 1) / 2;
	      o.x_target = adjusted_stance * (width - 2 * radius) + radius;
	    }
	    opinions.sort(function(a, b) {
	      var a_abs, b_abs, diff;
	      diff = Math.abs(b[1] - a[1]);
	      if ((b[3] || a[3]) && b[3] !== a[3]) {
	        return b[3] - a[3];
	      } else if (b[2] !== a[2]) {
	        return b[2] - a[2];
	      } else if (layout_params.rando_order && diff < layout_params.rando_order && Math.abs(b[1]) < 1 - layout_params.rando_order) {
	        return Math.random() - 0.5;
	      } else {
	        b_abs = Math.abs(b[1]);
	        a_abs = Math.abs(a[1]);
	        return b_abs - a_abs;
	      }
	    });
	    openings = Openings();
	    moves_within = [Math.round(width * .125), Math.round(width * .5), width];
	    topple_towers = layout_params.topple_towers;
	    place_body = function(o, idx) {
	      var b, consider_only_prime_positions, elevation, len1, len2, m, max_score, move_within, occupancy_map, options, p, placed, ref, sag, score, sparsity, top_candidate, total_dist, x, x_dist, x_target, xt, y, y_dist;
	      radius = o.radius;
	      x_target = o.x_target;
	      xt = Math.round(x_target);
	      if (save_snapshots) {
	        occupancy_map = build_occupancy_map(laid_out);
	      }
	      placed = false;
	      for (m = 0, len1 = moves_within.length; m < len1; m++) {
	        move_within = moves_within[m];
	        ref = [true, false];
	        for (p = 0, len2 = ref.length; p < len2; p++) {
	          consider_only_prime_positions = ref[p];
	          options = openings.get_openings(radius, consider_only_prime_positions);
	          max_score = -999999;
	          top_candidate = null;
	          x = Math.max(radius - 1, xt - move_within);
	          while (x <= Math.min(width - radius, xt + move_within)) {
	            if (options[x] > 0) {
	              score = 1 / (Math.abs(x_target - x) / width + 1);
	              if (topple_towers) {
	                sparsity = 1 - get_opinion_density(o);
	                elevation = options[x] / height + 1;
	                score = ((1 - topple_towers) - sparsity * topple_towers) * score + (topple_towers + sparsity * topple_towers) * elevation;
	              }
	              if (score > max_score) {
	                top_candidate = x;
	                max_score = score;
	              }
	            }
	            x += 1;
	          }
	          if (top_candidate !== null) {
	            x = top_candidate;
	            y = options[x];
	            if (layout_params.jostle) {
	              x_dist = x_target - x;
	              y_dist = (height - radius) - y;
	              x_dist *= 2;
	              total_dist = Math.abs(x_dist) + Math.abs(y_dist);
	              if (total_dist > 1) {
	                sag = base_radius * layout_params.jostle * Math.random();
	                if (layout_params.density_modified_jostle) {
	                  sag *= (1 - layout_params.density_modified_jostle) + layout_params.density_modified_jostle * get_opinion_density(o);
	                }
	                if (radius <= 1) {
	                  sag += radius / 4;
	                } else {
	                  sag += .5;
	                }
	                x += sag * x_dist / total_dist;
	                y += sag * y_dist / total_dist;
	              }
	            }
	            b = {
	              radius: radius,
	              x: x,
	              y: y,
	              x_target: x_target,
	              user: o[0]
	            };
	            laid_out.push(b);
	            openings.add_body(b);
	            placed = true;
	            break;
	          }
	          if (!placed && consider_only_prime_positions === false && move_within === width) {
	            console.error("Could not place", xt, o);
	            return false;
	          }
	        }
	        if (placed) {
	          break;
	        }
	      }
	      if (save_snapshots) {
	        current_cleanup.push({
	          body: JSON.parse(JSON.stringify({
	            x: b.x,
	            y: b.y,
	            radius: b.radius,
	            x_target: b.x_target
	          })),
	          from: {
	            x: x,
	            y: y
	          },
	          to: {
	            x: b.x,
	            y: b.y
	          },
	          candidates: [],
	          openings: openings.by_radii[radius].open_spots.slice(),
	          occupancy: occupancy_map,
	          prime_positions: options.slice(),
	          unstable_bodies: [],
	          bodies: JSON.parse(JSON.stringify((function() {
	            var len3, q, results;
	            results = [];
	            for (q = 0, len3 = laid_out.length; q < len3; q++) {
	              b = laid_out[q];
	              results.push({
	                user: b[0],
	                neighbors: b.neighbors,
	                x: b.x,
	                y: b.y,
	                radius: b.radius,
	                x_target: b.x_target
	              });
	            }
	            return results;
	          })())),
	          iteration: 0
	        });
	      }
	      return true;
	    };
	    if (save_snapshots) {
	      current_cleanup = [];
	      running_state = fetch(opts.histo_key);
	    }
	    if (!layout_params.show_histogram_layout) {
	      for (idx = m = 0, len1 = opinions.length; m < len1; idx = ++m) {
	        o = opinions[idx];
	        success = place_body(o, idx);
	        if (!success) {
	          return false;
	        }
	      }
	      if (save_snapshots) {
	        if (running_state.cleanup == null) {
	          running_state.cleanup = [];
	        }
	        running_state.cleanup.push(current_cleanup);
	        save(running_state);
	      }
	    } else {
	      idx = 0;
	      run_next = function() {
	        var body, len2, p, positions, r;
	        place_body(opinions[idx], idx);
	        positions = {};
	        for (p = 0, len2 = laid_out.length; p < len2; p++) {
	          body = laid_out[p];
	          r = body.radius;
	          positions[body[0]] = [Math.round((body.x - r) * 10) / 10, Math.round((body.y - r) * 10) / 10, r];
	        }
	        write_layout(opts, positions);
	        idx += 1;
	        return setTimeout(function() {
	          if (idx < opinions.length) {
	            return run_next();
	          } else if (save_snapshots) {
	            if (running_state.cleanup == null) {
	              running_state.cleanup = [];
	            }
	            running_state.cleanup.push(current_cleanup);
	            return save(running_state);
	          }
	        }, 25);
	      };
	      run_next();
	    }
	    return laid_out;
	  };
	  build_occupancy_map = function(bodies, additional_r, r_mult) {
	    var body, l, len, mask, occupancy_map, r;
	    if (r_mult == null) {
	      r_mult = 1;
	    }
	    occupancy_map = new Int32Array(width * height);
	    if (additional_r == null) {
	      additional_r = 0;
	    }
	    for (l = 0, len = bodies.length; l < len; l++) {
	      body = bodies[l];
	      r = Math.round(additional_r + body.radius * r_mult) - 1;
	      mask = get_mask(r);
	      imprint_body_on_map(occupancy_map, body, 1, r);
	    }
	    return occupancy_map;
	  };
	  Openings = function(to_map) {
	    var add_body, by_radii, get_openings, mapped, point_dist, radii;
	    mapped = [];
	    radii = [];
	    by_radii = {};
	    point_dist = function(a, b) {
	      return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y));
	    };
	    add_body = function(body) {
	      var b_r, body_pos, col, dirty, dirty_r, l, len, openings_for_radius, radius, x, y;
	      x = Math.round(body.x);
	      y = Math.round(body.y);
	      b_r = body.radius;
	      body_pos = {
	        x: x,
	        y: y
	      };
	      for (l = 0, len = radii.length; l < len; l++) {
	        radius = radii[l];
	        dirty_r = Math.round((b_r + radius) * (cleanup_overlap - 1)) - 1;
	        openings_for_radius = by_radii[radius].open_spots;
	        imprint_body_on_map(openings_for_radius, body_pos, 1, dirty_r);
	        col = x - dirty_r;
	        dirty = by_radii[radius].dirty;
	        while (col < x + dirty_r) {
	          dirty[col] = 1;
	          col += 1;
	        }
	      }
	      return mapped.push(body);
	    };
	    get_openings = function(target_radius, filter_to_prime_positions) {
	      var b, build_flattened, build_flattened_init, candidates, dirty, disjoint_next, disjoint_prev, dist, flattened_openings, hypo_pos, i, initialized, l, len, open_spots, r_long, radius, radius_next, radius_prev, ref, y, y_next, y_prev;
	      radius = target_radius || base_radius;
	      if (!by_radii[radius]) {
	        by_radii[radius] = {
	          open_spots: new Int32Array(width * height),
	          flattened_openings: new Int32Array(width + 1),
	          initialized: false,
	          dirty: {}
	        };
	        radii.push(radius);
	        open_spots = by_radii[radius].open_spots;
	        for (l = 0, len = mapped.length; l < len; l++) {
	          b = mapped[l];
	          imprint_body_on_map(open_spots, b, 1, Math.round((b.radius + radius) * (cleanup_overlap - 1)) - 1);
	        }
	      }
	      ref = by_radii[radius], open_spots = ref.open_spots, initialized = ref.initialized, dirty = ref.dirty, flattened_openings = ref.flattened_openings;
	      build_flattened_init = function() {
	        var col, row, y;
	        col = 0;
	        while (col < width) {
	          y = 0;
	          if (col >= radius - 1 && col <= width - radius) {
	            row = height - radius;
	            while (row >= 0) {
	              if (open_spots[row * width + col] === 0) {
	                y = row;
	                break;
	              }
	              row -= 1;
	            }
	          }
	          flattened_openings[col] = y;
	          col += 1;
	        }
	        return by_radii[radius].initialized = true;
	      };
	      build_flattened = function() {
	        var col, k, row, v, y;
	        for (k in dirty) {
	          v = dirty[k];
	          col = parseInt(k);
	          y = 0;
	          if (col >= radius - 1 && col <= width - radius) {
	            row = flattened_openings[col];
	            if (row == null) {
	              row = height - radius;
	            }
	            while (row >= 0) {
	              if (open_spots[row * width + col] === 0) {
	                y = row;
	                break;
	              }
	              row -= 1;
	            }
	          }
	          flattened_openings[col] = y;
	        }
	        return by_radii[radius].dirty = {};
	      };
	      if (initialized) {
	        build_flattened();
	      } else {
	        build_flattened_init();
	      }
	      if (!filter_to_prime_positions) {
	        return flattened_openings;
	      }
	      candidates = [];
	      r_long = Math.round(radius * layout_params.cleanup_overlap) - 1;
	      dist = Math.floor(radius / 2);
	      i = 0;
	      while (i < width) {
	        y = flattened_openings[i];
	        y_prev = flattened_openings[i - dist];
	        y_next = flattened_openings[i + dist];
	        hypo_pos = {
	          y: y + r_long,
	          x: i
	        };
	        if (y_next != null) {
	          disjoint_next = hypo_pos.y < y_next;
	          radius_next = point_dist(hypo_pos, {
	            x: i + dist,
	            y: y_next
	          }) - r_long;
	        }
	        if (y_prev != null) {
	          disjoint_prev = hypo_pos.y < y_prev;
	          radius_prev = point_dist(hypo_pos, {
	            x: i - dist,
	            y: y_prev
	          }) - r_long;
	        }
	        if ((((y_next == null) || (!disjoint_next && radius_next > -1)) && ((y_prev == null) || (!disjoint_prev && radius_prev > -1))) || (!disjoint_prev && !disjoint_next && Math.abs(radius_next) < 1 && Math.abs(radius_prev) < 1 && Math.abs(radius_next + radius_prev) < 0.5)) {
	          candidates.push(y);
	        } else {
	          candidates.push(0);
	        }
	        i += 1;
	      }
	      return candidates;
	    };
	    return {
	      get_openings: get_openings,
	      add_body: add_body,
	      by_radii: by_radii
	    };
	  };
	  avatar_mask = {};
	  get_mask = function(r) {
	    var col, mask, row;
	    mask = avatar_mask[r];
	    if (!mask) {
	      mask = avatar_mask[r] = new Int32Array(4 * r * r);
	      col = row = 0;
	      while (row < 2 * r) {
	        while (col < 2 * r) {
	          if (Math.sqrt((r - .5 - row) * (r - .5 - row) + (r - .5 - col) * (r - .5 - col)) < r) {
	            mask[row * 2 * r + col] = 1;
	          }
	          col += 1;
	        }
	        row += 1;
	        col = 0;
	      }
	    }
	    return mask;
	  };
	  imprint_body_on_map = function(occupancy_map, body, increment, radius) {
	    var col, mask, mask_col, mask_row, offset_col, offset_row, r, results, row, x, y;
	    if (increment == null) {
	      increment = 1;
	    }
	    if (radius == null) {
	      radius = null;
	    }
	    r = Math.round(radius || body.radius);
	    x = Math.round(body.x);
	    y = Math.round(body.y);
	    mask = get_mask(r);
	    row = y - r;
	    col = x - r;
	    mask_row = mask_col = 0;
	    results = [];
	    while (mask_row < 2 * r) {
	      offset_row = row + mask_row;
	      if (offset_row >= 0 && offset_row < height) {
	        while (mask_col < 2 * r) {
	          offset_col = col + mask_col;
	          if (offset_col >= 0 && offset_col < width && mask[mask_row * 2 * r + mask_col]) {
	            occupancy_map[offset_row * width + offset_col] += increment;
	          }
	          mask_col += 1;
	        }
	      }
	      mask_row += 1;
	      results.push(mask_col = 0);
	    }
	    return results;
	  };
	  sweep_all_for_position_swaps = function(attempt_swap, nodes) {
	    var body, body2, i, j, num, num_swaps, result, results;
	    num = nodes.length;
	    num_swaps = 1;
	    results = [];
	    while (num_swaps > 0) {
	      num_swaps = 0;
	      i = 0;
	      results.push((function() {
	        var results1;
	        results1 = [];
	        while (i < num) {
	          body = nodes[i];
	          j = i + 1;
	          while (j < num) {
	            if (j === i) {
	              j += 1;
	              continue;
	            }
	            body2 = nodes[j];
	            if (body.radius === body2.radius && ((body.x > body2.x && body.x_target < body2.x_target) || (body.x < body2.x && body.x_target > body2.x_target))) {
	              result = attempt_swap(body, body2);
	              if (result) {
	                num_swaps += 1;
	              }
	            }
	            j += 1;
	          }
	          results1.push(i += 1);
	        }
	        return results1;
	      })());
	    }
	    return results;
	  };
	  sweep_all_for_group_swaps = function(attempt_swap, groups, all_groups, nodes) {
	    var body, body2, body2_g_idx, body_g_idx, g, group_idx, i, idx, j, l, len, num, num_swaps, result, results;
	    group_idx = {};
	    for (idx = l = 0, len = all_groups.length; l < len; idx = ++l) {
	      g = all_groups[idx];
	      group_idx[g] = idx;
	    }
	    num = nodes.length;
	    num_swaps = 1;
	    results = [];
	    while (num_swaps > 0) {
	      num_swaps = 0;
	      i = 0;
	      results.push((function() {
	        var results1;
	        results1 = [];
	        while (i < num) {
	          body = nodes[i];
	          j = i + 1;
	          body_g_idx = Math.min.apply(null, (function() {
	            var len1, m, ref, results2;
	            ref = groups[body.user];
	            results2 = [];
	            for (m = 0, len1 = ref.length; m < len1; m++) {
	              g = ref[m];
	              results2.push(group_idx[g]);
	            }
	            return results2;
	          })());
	          while (j < num) {
	            if (j === i) {
	              j += 1;
	              continue;
	            }
	            body2 = nodes[j];
	            body2_g_idx = Math.min.apply(null, (function() {
	              var len1, m, ref, results2;
	              ref = groups[body2.user];
	              results2 = [];
	              for (m = 0, len1 = ref.length; m < len1; m++) {
	                g = ref[m];
	                results2.push(group_idx[g]);
	              }
	              return results2;
	            })());
	            if (body.radius === body2.radius && Math.abs(body.x_target - body2.x_target) < (body.radius + body2.radius) && ((body.y < body2.y && body_g_idx < body2_g_idx) || (body.y > body2.y && body_g_idx > body2_g_idx))) {
	              result = attempt_swap(body, body2);
	              if (result) {
	                num_swaps += 1;
	              }
	            }
	            j += 1;
	          }
	          results1.push(i += 1);
	        }
	        return results1;
	      })());
	    }
	    return results;
	  };
	  return {
	    Openings: Openings,
	    sweep_all_for_position_swaps: sweep_all_for_position_swaps,
	    sweep_all_for_group_swaps: sweep_all_for_group_swaps,
	    pixelated_layout: pixelated_layout,
	    get_mask: get_mask,
	    imprint_body_on_map: imprint_body_on_map
	  };
	};
	
	EvaluateLayout = function(opts, bodies, placer) {
	  var a180, a270, a360, a90, base_radius, build_occupancy_map, calc_stability, cleanup_overlap, evaluate_body_position, evaluate_layout, find_neighbors, global_running_state, height, layout_params, opinions, running_state, width;
	  opinions = opts.o;
	  width = opts.w;
	  height = opts.h;
	  layout_params = opts.layout_params;
	  base_radius = opts.r;
	  cleanup_overlap = layout_params.cleanup_overlap || 2;
	  if (layout_params.verbose) {
	    global_running_state = fetch('histo-timing');
	    running_state = fetch(opts.histo_key);
	  }
	  a90 = Math.PI / 2;
	  a180 = Math.PI;
	  a270 = 3 * Math.PI / 2;
	  a360 = 2 * Math.PI;
	  find_neighbors = function(epsilon) {
	    var a, a_angle, a_r, a_x, a_y, aa, angle, b, b_angle, b_r, b_x, b_y, bb, body, i, j, l, len, n, results;
	    if (epsilon == null) {
	      epsilon = 1;
	    }
	    n = bodies.length;
	    for (l = 0, len = bodies.length; l < len; l++) {
	      body = bodies[l];
	      body.neighbors = [];
	    }
	    i = 0;
	    results = [];
	    while (i < n) {
	      j = i + 1;
	      a = bodies[i];
	      while (j < n) {
	        b = bodies[j];
	        if (b.y < a.y || (b.y === a.y && a.x > b.x)) {
	          aa = bodies[j];
	          bb = bodies[i];
	        } else {
	          aa = bodies[i];
	          bb = bodies[j];
	        }
	        a_x = aa.x;
	        a_y = aa.y;
	        b_x = bb.x;
	        b_y = bb.y;
	        a_r = aa.radius;
	        b_r = bb.radius;
	        if ((a_x - b_x) * (a_x - b_x) + (a_y - b_y) * (a_y - b_y) <= (a_r + b_r) * (a_r + b_r) + epsilon) {
	          if (a_y === b_y) {
	            a_angle = 0;
	            b_angle = a180;
	          } else if (a_x === b_x) {
	            a_angle = a90;
	            b_angle = a270;
	          } else {
	            angle = Math.atan(Math.abs(a_x - b_x) / Math.abs(a_y - b_y));
	            if (a_x < b_x) {
	              a_angle = a90 - angle;
	              b_angle = a180 + (a90 - angle);
	            } else {
	              a_angle = a90 + angle;
	              b_angle = a360 - (a90 - angle);
	            }
	          }
	          aa.neighbors.push([bb.body_index, a_angle]);
	          bb.neighbors.push([aa.body_index, b_angle]);
	        }
	        j += 1;
	      }
	      results.push(i += 1);
	    }
	    return results;
	  };
	  calc_stability = function(body, blacklist) {
	    var adj_angle, angle, angle_between, deviation_from_stable, l, len, len1, m, most_stable, n, n_angle, neighbors, other_idx, r, stabilizing_neighbors, x, y;
	    if (blacklist == null) {
	      blacklist = {};
	    }
	    x = Math.round(body.x);
	    y = Math.round(body.y);
	    r = body.radius;
	    if (y + r + 1 >= height) {
	      return 1;
	    }
	    adj_angle = 0;
	    neighbors = body.neighbors.slice();
	    stabilizing_neighbors = (function() {
	      var l, len, ref, results;
	      results = [];
	      for (l = 0, len = neighbors.length; l < len; l++) {
	        ref = neighbors[l], other_idx = ref[0], angle = ref[1];
	        if (angle < Math.PI && angle > 0 && !blacklist[other_idx]) {
	          results.push(angle);
	        }
	      }
	      return results;
	    })();
	    if (stabilizing_neighbors.length === 0) {
	      return 0;
	    }
	    most_stable = 2 * Math.PI;
	    for (l = 0, len = stabilizing_neighbors.length; l < len; l++) {
	      angle = stabilizing_neighbors[l];
	      if (Math.abs(Math.PI / 2 - angle) < most_stable) {
	        most_stable = angle;
	      }
	    }
	    stabilizing_neighbors.sort();
	    if (x <= r) {
	      neighbors.unshift(['left edge', Math.PI + adj_angle]);
	    } else if (x >= width - r) {
	      neighbors.unshift(['right edge', adj_angle]);
	    }
	    for (m = 0, len1 = neighbors.length; m < len1; m++) {
	      n = neighbors[m];
	      if (!(!blacklist[n[0]])) {
	        continue;
	      }
	      n_angle = n[1];
	      if (n_angle > Math.PI * 3 / 2) {
	        n_angle -= Math.PI * 2;
	      }
	      angle_between = n_angle - most_stable;
	      if ((most_stable < Math.PI / 2 && angle_between > 0 && angle_between < Math.PI) || (most_stable > Math.PI / 2 && angle_between < 0 && angle_between > -Math.PI)) {
	        return 1;
	      }
	    }
	    deviation_from_stable = Math.abs(most_stable - Math.PI / 2);
	    return 1 - deviation_from_stable / (Math.PI / 2);
	  };
	  evaluate_body_position = function(body, occupancy_map) {
	    var ccol, col, could_free_fall, dist, l, left, m, mask, overlapped_pixels, p, percent_visible, pixel, r, ref, ref1, ref2, ref3, row, space_below, top, total_pixels, truth, x, y;
	    if (occupancy_map == null) {
	      occupancy_map = build_occupancy_map();
	    }
	    dist = Math.abs(body.x - body.x_target);
	    dist /= width;
	    truth = Math.pow(1 - dist, 2);
	    body.truth = truth;
	    r = body.radius;
	    mask = placer.get_mask(r);
	    x = Math.round(body.x);
	    y = Math.round(body.y);
	    left = x - r;
	    top = y - r;
	    overlapped_pixels = 0;
	    total_pixels = 0;
	    for (row = l = 0, ref = 2 * r; 0 <= ref ? l <= ref : l >= ref; row = 0 <= ref ? ++l : --l) {
	      for (col = m = 0, ref1 = 2 * r; 0 <= ref1 ? m <= ref1 : m >= ref1; col = 0 <= ref1 ? ++m : --m) {
	        if (mask[row * 2 * r + col] > 0) {
	          pixel = occupancy_map[(top + row) * width + (left + col)];
	          total_pixels += 1;
	          if (pixel > 1) {
	            overlapped_pixels += 1;
	          }
	        }
	      }
	    }
	    percent_visible = 1 - overlapped_pixels / total_pixels;
	    body.visibility = percent_visible;
	    body.stability = calc_stability(body);
	    row = y + r + 2;
	    col = x;
	    space_below = 0;
	    while (true) {
	      if (row >= height) {
	        break;
	      }
	      pixel = occupancy_map[row * width + col];
	      if (pixel > 0) {
	        break;
	      }
	      space_below += 1;
	      row += 1;
	    }
	    if (space_below > 1) {
	      could_free_fall = true;
	      row = y + r + 2;
	      for (ccol = p = ref2 = col - r, ref3 = col + r; ref2 <= ref3 ? p <= ref3 : p >= ref3; ccol = ref2 <= ref3 ? ++p : --p) {
	        if (ccol < 0 || ccol >= width) {
	          continue;
	        }
	        could_free_fall && (could_free_fall = occupancy_map[row * width + ccol] === 0);
	        if (!could_free_fall) {
	          break;
	        }
	      }
	      if (could_free_fall) {
	        space_below = Math.pow(space_below, 3);
	      }
	    }
	    return body.space_below = space_below;
	  };
	  evaluate_layout = function() {
	    var body, l, len, occupancy_map, stability, truth, visibility;
	    find_neighbors();
	    occupancy_map = build_occupancy_map();
	    truth = 1;
	    visibility = 1;
	    stability = 0;
	    for (l = 0, len = bodies.length; l < len; l++) {
	      body = bodies[l];
	      evaluate_body_position(body, occupancy_map);
	      if (body.truth < truth) {
	        truth = body.truth;
	      }
	      if (body.visibility < visibility) {
	        visibility = body.visibility;
	      }
	      if (body.stability != null) {
	        stability += Math.pow(body.stability, 2);
	      }
	    }
	    stability /= bodies.length;
	    running_state.truth = truth;
	    running_state.visibility = visibility;
	    running_state.stability = stability;
	    global_running_state[layout_params.param_hash].truth += truth;
	    global_running_state[layout_params.param_hash].visibility += visibility;
	    global_running_state[layout_params.param_hash].stability += stability;
	    return global_running_state[layout_params.param_hash].cnt += 1;
	  };
	  build_occupancy_map = function(additional_r, r_mult) {
	    var body, l, len, mask, occupancy_map, r;
	    if (r_mult == null) {
	      r_mult = 1;
	    }
	    occupancy_map = new Int32Array(width * height);
	    if (additional_r == null) {
	      additional_r = 0;
	    }
	    for (l = 0, len = bodies.length; l < len; l++) {
	      body = bodies[l];
	      r = Math.round(additional_r + body.radius * r_mult) - 1;
	      mask = placer.get_mask(r);
	      placer.imprint_body_on_map(occupancy_map, body, 1, r);
	    }
	    return occupancy_map;
	  };
	  return {
	    calc_stability: calc_stability,
	    evaluate_layout: evaluate_layout
	  };
	};


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var ProposalBlock, ProposalItemWrapper, proposal_url;
	
	window.ANIMATION_SPEED_ITEM_EXPANSION = 0.6;
	
	window.STAGE1_DELAY = 0;
	
	window.STAGE2_DELAY = ANIMATION_SPEED_ITEM_EXPANSION * 1.5;
	
	window.STAGE3_DELAY = ANIMATION_SPEED_ITEM_EXPANSION * .5;
	
	window.PROPOSAL_ITEM_SPRING = {
	  stiffness: 130,
	  damping: 17
	};
	
	window.PROPOSAL_DESCRIPTION_MAX_HEIGHT_ON_EXPAND = 500;
	
	__webpack_require__(42);
	
	__webpack_require__(41);
	
	__webpack_require__(39);
	
	styles += ".prep_for_flip {\n  transform-origin: 0px 0px;    \n}\n\n.proposal_item_animation {\n  transition-duration: " + ANIMATION_SPEED_ITEM_EXPANSION + "s;\n  transition-timing-function: linear;\n  transition-delay: 0ms;    \n}\n\n.ProposalItem, .show-all-proposals {\n  position: relative;\n}\n\n\n.ProposalItem {\n  min-height: 84px;\n  list-style: none;    \n  padding: 0px;\n  margin: 0px 0px 32px 0px;\n\n  top: 0;\n\n  z-index: 1;\n}\n\n\n\n.is_expanded.ProposalItem {\n  z-index: 3; /* put it above surrounding ProposalItems */\n\n} \n\n@media " + LAPTOP_MEDIA + " {\n  .ProposalItem, .show-all-proposals {\n    left: calc(-1 * var(--LIST_PADDING_LEFT));\n    width: calc(100% + var(--LIST_PADDING_LEFT) + var(--LIST_PADDING_RIGHT) );\n  }\n\n  .show_list_title.ProposalItem {\n    margin-bottom: 48px;\n  }\n\n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .ProposalItem {\n    margin-bottom: 64px;\n  }\n\n  .show_list_title.ProposalItem {\n    margin-bottom: 78px;\n  }\n\n}\n\n:not(.collapsing):not([data-in-viewport=\"true\"]).is_collapsed.ProposalItem {\n  content-visibility: auto; /* Content-visibility can be very expensive. Specifically, React Flip Toolkit\n                               has to call getBoundingClientRect on all Flipped elements to figure out how \n                               to animate them. content-visibility will prevent the rendering\n                               of out-of-viewport items (as intended!), but this means that getBoundingClientRect\n                               call on an unpainted item will trigger a reflow and style re-calc. *for \n                               each element*. This creates significant jank in the beginning of an animation\n                               when there are a decent number of out-of-viewport items.  \n                               Note: I've made a forked version of react-flip-trip that almost entirely\n                                     eliminates this expense. But content-visibility is also expensive when\n                                     scrolling long lists.\n                               */    \n}\n\n/* When changing list order, content-visibility: auto cuts things off */\n\n.list_order_event .is_collapsed.ProposalItem {\n  content-visibility: visible;\n}\n\n\n/* partially implemented experimental lightbox */\n/* .is_expanded.ProposalItem:before {\n  content: \"\";\n  background-color: rgba(0,0,0,.15);\n  position: absolute;\n  height: 999999px;\n  width: 999999px;\n  top: -9999px;\n  left: -9999px;\n  z-index: 2;\n} */";
	
	window.ProposalItem = ReactiveComponent({
	  displayName: 'ProposalItem',
	  shouldFlipIgnore: function() {
	    return !(this.local.in_viewport || (this.list_order_state_changed && this.props.num_proposals < 30));
	  },
	  shouldFlip: function() {
	    return this.local.in_viewport || (this.list_order_state_changed && this.props.num_proposals < 30);
	  },
	  expansion_state_updated: function() {
	    return this.expansion_state_changed;
	  },
	  onAnimationStart: function(el) {
	    var direction;
	    if (this.expansion_state_updated()) {
	      this.animating = true;
	      direction = this.is_expanded ? 'expanding' : 'collapsing';
	      el.classList.add("animating-expansion", direction);
	      return el.classList.remove("animation-resting");
	    }
	  },
	  onAnimationDone: function(el, dd) {
	    var direction;
	    if (this.expansion_state_updated() || el.classList.contains('animating-expansion')) {
	      direction = this.is_expanded ? 'expanding' : 'collapsing';
	      el.classList.remove('animating-expansion', direction);
	      el.classList.add("animation-resting");
	      this.animating = false;
	      return requestAnimationFrame((function(_this) {
	        return function() {
	          if (!_this.animating) {
	            _this.expansion_state_changed = false;
	            return _this.list_order_state_changed = false;
	          }
	        };
	      })(this));
	    }
	  },
	  componentDidMount: function() {
	    return this.adjustExpansionBasedOnLocAndBackForwardButtons();
	  },
	  componentDidUpdate: function() {
	    return this.adjustExpansionBasedOnLocAndBackForwardButtons();
	  },
	  adjustExpansionBasedOnLocAndBackForwardButtons: function() {
	    var already_toggling, loc, proposal;
	    loc = fetch('location');
	    proposal = fetch(this.props.proposal);
	    already_toggling = this.refs.proposal_item.classList.contains('will-expand-toggle');
	    if (((!this.is_expanded && this.props.accessed_by_url) || (this.is_expanded && !this.props.accessed_by_url)) && !this.expansion_intv && !already_toggling && loc.triggered_by !== 'toggle_expand') {
	      return this.expansion_intv = setInterval((function(_this) {
	        return function() {
	          if (collapsed_height_initialized[proposal.key]) {
	            return requestAnimationFrame(function() {
	              if (((_this.is_expanded && !_this.props.accessed_by_url) || (!_this.is_expanded && _this.props.accessed_by_url)) && !already_toggling) {
	                toggle_expand({
	                  proposal: proposal
	                });
	              }
	              clearInterval(_this.expansion_intv);
	              return _this.expansion_intv = null;
	            });
	          }
	        };
	      })(this), 10);
	    }
	  },
	  render: function() {
	    var loc, local_state, proposal;
	    proposal = fetch(this.props.proposal);
	    loc = fetch('location');
	    if (!proposal.name) {
	      return;
	    }
	    this.is_expanded = this.props.is_expanded;
	    this.expansion_state_changed = ((this.expansion_state_changed != null) || this.props.accessed_by_url) && this.last_expansion !== this.is_expanded;
	    this.list_order_state_changed = (this.list_order_state_changed != null) && this.last_list_order !== this.props.list_order;
	    this.last_expansion = this.is_expanded;
	    this.last_list_order = this.props.list_order;
	    local_state = fetch(shared_local_key(proposal));
	    return FLIPPED({
	      key: proposal.key,
	      flipId: proposal.key,
	      shouldInvert: this.shouldFlip,
	      onStartImmediate: this.onAnimationStart,
	      onComplete: this.onAnimationDone,
	      shouldFlipIgnore: this.shouldFlipIgnore
	    }, LI({
	      ref: 'proposal_item',
	      "data-widget": 'ProposalItem',
	      key: proposal.key,
	      className: "ProposalItem " + (this.is_expanded ? 'is_expanded' : 'is_collapsed') + " " + local_state.mode + " " + (this.props.show_list_title ? 'show_list_title' : '') + " prep_for_flip",
	      "data-name": slugify(proposal.name),
	      'data-visibility-name': 'ProposalItem',
	      'data-receive-viewport-visibility-updates': 4,
	      'data-component': this.local.key,
	      id: 'p' + (proposal.slug || ("" + proposal.id)).replace('-', '_')
	    }, FLIPPED({
	      inverseFlipId: proposal.key,
	      shouldInvert: this.shouldFlip,
	      shouldFlipIgnore: this.shouldFlipIgnore
	    }, DIV({
	      className: 'prep_for_flip'
	    }, ProposalItemWrapper({
	      proposal: this.props.proposal,
	      is_expanded: this.is_expanded,
	      list_key: this.props.list_key,
	      show_list_title: this.props.show_list_title,
	      list_title_color: this.props.list_title_color,
	      shouldFlip: this.shouldFlip,
	      shouldFlipIgnore: this.shouldFlipIgnore,
	      expansion_state_changed: this.expansion_state_updated,
	      hide_scores: this.props.hide_scores,
	      accessed_by_url: this.props.accessed_by_url
	    })))));
	  }
	});
	
	styles += "/* Container for the proposal */\n\n.proposal-block-container {\n  display: flex;\n  justify-content: center;\n}\n\n.is_collapsed .proposal-block-container {\n  flex-direction: row;\n}\n\n.one-col .is_collapsed .proposal-block-container, \n.is_expanded .proposal-block-container {\n  flex-direction: column;\n}\n\n.proposal-block-wrapper {\n  margin-top: 0;\n  width: 100%;        \n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .proposal-block-wrapper {\n    padding-bottom: 14px;\n  }\n}\n\n\n/* The container for the opinion area */\n\n\n.opinion-block-wrapper {\n  position: relative;\n  z-index: 1;\n\n  top: 10px;  /* move it down so that overflowing avatars don't get chopped off at the top */\n}\n\n.is_expanded .opinion-block-wrapper {\n  margin-bottom: 24px;\n  margin-top: 10px;\n  padding-right: 0px;\n  padding-bottom: 64px;    \n}\n\n\n\n/* The double up arrow at the bottom of an expanded proposal that will collapse the proposal */\n\n.bottom_closer {\n  position: absolute;\n  left: calc(50% - 26px);\n  bottom: -26px;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  opacity: 0;        \n}\n\n:not(.expanding).is_expanded .bottom_closer {\n  transition: opacity " + (2 * ANIMATION_SPEED_ITEM_EXPANSION) + "s;    \n  opacity: 1;\n  display: inline-block;    \n}\n.is_collapsed .bottom_closer {\n  pointer-events: none;\n}\n\n\n\n\n\n/* The wrapper for the expanded item */\n\n.opinion-block-wrapper::after {\n\n  content: \"\";    \n  opacity: 0;\n\n  position: absolute;\n  z-index: -1;\n\n  top: 0px;\n  height: 100%;\n\n  box-shadow: 0px 0px 0px rgba(0,0,0,.25);    \n\n  background-color: white;\n  border-radius: 128px;\n\n}\n\n@media " + LAPTOP_MEDIA + " {\n  .opinion-block-wrapper, .opinion-block-wrapper::after {\n    --EXPANDED_OPINION_BACKGROUND_GUTTER: 6px;\n    --OPINION_BLOCK_WRAPPER_WIDTH: min( 1400px, 100vw - 2 * var(--EXPANDED_OPINION_BACKGROUND_GUTTER) );\n  }\n\n  .opinion-block-wrapper::after {\n    --container_width: calc(var(--HOMEPAGE_WIDTH) + var(--LIST_PADDING_RIGHT) + var(--LIST_PADDING_LEFT));\n\n    width: var(--OPINION_BLOCK_WRAPPER_WIDTH);\n    left: calc( ( var(--container_width) - var(--OPINION_BLOCK_WRAPPER_WIDTH) ) / 2 );\n  }\n\n  .crafting .opinion-block-wrapper, .crafting .opinion-block-wrapper::after {\n    --OPINION_BLOCK_WRAPPER_WIDTH: min( 2000px, max(95vw, min( 1300px, 100vw - 2 * var(--EXPANDED_OPINION_BACKGROUND_GUTTER) )) );\n  }\n\n  .is_expanded .opinion-block-wrapper::after {\n    transition: opacity " + (.5 * ANIMATION_SPEED_ITEM_EXPANSION) + "s, box-shadow " + (.5 * ANIMATION_SPEED_ITEM_EXPANSION) + "s, width " + CRAFTING_TRANSITION_SPEED + "ms, left " + CRAFTING_TRANSITION_SPEED + "ms;\n  }\n\n}  \n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .opinion-block-wrapper::after {\n    width: 100%;\n    left: 0;\n    border-radius: 64px;\n  }\n}  \n\n\n.is_expanded .opinion-block-wrapper::after {\n  opacity: 1;\n  box-shadow: 0px 0px 3px rgba(0,0,0,.25);    \n  transition: opacity " + (.5 * ANIMATION_SPEED_ITEM_EXPANSION) + "s, box-shadow " + (.5 * ANIMATION_SPEED_ITEM_EXPANSION) + "s;\n\n}\n\n.is_expanded:not(.flipping) .opinion-block-wrapper::after {\n  background-image: linear-gradient(180deg, #f3f4f5 75px, #FFFFFF 150px, #FFFFFF 90%, #f3f4f5 96%);\n}\n\n\n.custom-shape-divider-top-1664224812 {\n  pointer-events: none;\n  position: absolute;\n  top: -39px;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  line-height: 0;\n}\n\n.custom-shape-divider-top-1664224812 svg {\n  position: relative;\n  display: block;\n  width: calc(100% + 1.3px);\n  height: 39px;\n  transform: scaleY(-1);\n  filter: drop-shadow(0px 1px 1px rgb(0 0 0 / 0.1));    \n}\n\n.is_expanded:not(.expanding) .custom-shape-divider-top-1664224812 svg {\n  filter: drop-shadow(0px 0px 1px rgb(0 0 0 / 0.25));\n}\n.custom-shape-divider-top-1664224812 .shape-fill {\n    fill: #f3f4f5;\n}\n\n";
	
	ProposalItemWrapper = ReactiveComponent({
	  displayName: 'ProposalItemWrapper',
	  render: function() {
	    var proposal, subdomain;
	    proposal = fetch(this.props.proposal);
	    subdomain = fetch('/subdomain');
	    return DIV({
	      className: "proposal-block-container"
	    }, FLIPPED({
	      flipId: "proposal-block-" + proposal.key,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }, DIV({
	      className: 'proposal-block-wrapper prep_for_flip'
	    }, FLIPPED({
	      inverseFlipId: "proposal-block-" + proposal.key,
	      shouldInvert: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }, DIV({
	      className: 'prep_for_flip'
	    }, ProposalBlock({
	      proposal: proposal.key,
	      accessed_by_url: this.props.accessed_by_url,
	      is_expanded: this.props.is_expanded,
	      list_key: this.props.list_key,
	      show_list_title: this.props.show_list_title,
	      list_title_color: this.props.list_title_color,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore,
	      expansion_state_changed: this.props.expansion_state_changed
	    }))))), DIV({
	      className: "proposal-slidergram-spacing"
	    }), FLIPPED({
	      flipId: "opinion-block-" + proposal.key,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }, DIV({
	      className: 'prep_for_flip opinion-block-wrapper'
	    }, this.props.is_expanded ? DIV({
	      className: "custom-shape-divider-top-1664224812",
	      dangerouslySetInnerHTML: {
	        __html: "<svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 120\" preserveAspectRatio=\"none\">\n    <path d=\"M649.97 0L550.03 0 599.91 54.12 649.97 0z\" class=\"shape-fill\"></path>\n</svg>"
	      }
	    }) : void 0, FLIPPED({
	      inverseFlipId: "opinion-block-" + proposal.key,
	      shouldInvert: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }, DIV({
	      className: 'prep_for_flip'
	    }, OpinionBlock({
	      proposal: proposal.key,
	      is_expanded: this.props.is_expanded,
	      list_key: this.props.list_key,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore,
	      hide_scores: this.props.hide_scores
	    }))), BUTTON({
	      className: 'bottom_closer',
	      onClick: (function(_this) {
	        return function() {
	          return toggle_expand({
	            proposal: fetch(_this.props.proposal)
	          });
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            return toggle_expand({
	              proposal: fetch(_this.props.proposal)
	            });
	          }
	        };
	      })(this)
	    }, double_up_icon(40)))));
	  }
	});
	
	styles += ".ProposalBlock {\n  display: flex;\n}\n\n.proposal-avatar-wrapper {\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: var(--PROPOSAL_AUTHOR_AVATAR_SIZE);\n  transition-property: padding-top;    \n}\n.using_bullets .proposal-avatar-wrapper {\n  width: 12px;\n  padding-top: 2px;\n}\n.is_expanded .using_bullets .proposal-avatar-wrapper {\n  padding-top: 9px;\n}\n\n.proposal-left-spacing {\n  /* width: 1px;  // removing the spacing causes a bit of a jump when animating back */\n  width: var(--LIST_PADDING_LEFT);\n  flex-grow: 0;\n  flex-shrink: 0;    \n  position: relative;\n}\n\n.proposal-avatar-spacing {\n  width: var(--PROPOSAL_AUTHOR_AVATAR_GUTTER);\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.proposal-slidergram-spacing {\n  width: var(--PROPOSAL_AUTHOR_AVATAR_SIZE);\n  flex-grow: 0;\n  flex-shrink: 0;    \n}\n\n.is_expanded .proposal-slidergram-spacing {\n  width: 0;\n  height: 0;\n}\n\n\n.using_bullets .proposal-avatar-spacing {\n  width: var(--PROPOSAL_BULLET_GUTTER);\n}\n\n\n.proposal-score-spacing {\n  width: var(--LIST_PADDING_RIGHT);\n  height: 2px;\n  flex-grow: 0;\n  flex-shrink: 0;        \n}\n\n@media " + TABLET_MEDIA + " {\n  .proposal-score-spacing {\n    width: 20px;\n  }\n}\n\n@media " + PHONE_MEDIA + " {\n  .proposal-score-spacing {\n    width: 8px;\n  }\n}\n\n\n.ProposalBlock .avatar, .ProposalBlock .proposal_pic {\n  height: var(--PROPOSAL_AUTHOR_AVATAR_SIZE);\n  width: var(--PROPOSAL_AUTHOR_AVATAR_SIZE);\n  border-radius: 0;  \n}\n\n\n\n.ProposalBlock .proposal-text {\n  flex-grow: 1;\n  flex-shrink: 1; \n}\n\n";
	
	ProposalBlock = ReactiveComponent({
	  displayName: 'ProposalBlock',
	  should_use_avatar: function() {
	    var icons, proposal, subdomain;
	    proposal = fetch(this.props.proposal);
	    subdomain = fetch('/subdomain');
	    return icons = customization('show_proposer_icon', proposal, subdomain);
	  },
	  render: function() {
	    var icons, proposal;
	    proposal = fetch(this.props.proposal);
	    this.is_expanded = this.props.is_expanded;
	    icons = this.should_use_avatar();
	    return DIV({
	      className: "ProposalBlock " + (!icons ? "using_bullets" : ''),
	      "data-widget": 'ProposalBlock'
	    }, DIV({
	      className: 'proposal-left-spacing'
	    }, this.draw_edit_and_delete()), FLIPPED({
	      flipId: "proposal-avatars-" + proposal.key,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore,
	      translate: true,
	      className: 'prep_for_flip'
	    }, DIV({
	      className: 'proposal-avatar-wrapper proposal_item_animation'
	    }, this.draw_avatar_or_bullet())), DIV({
	      className: "proposal-avatar-spacing"
	    }), DIV({
	      className: 'proposal-text'
	    }, ItemText({
	      accessed_by_url: this.props.accessed_by_url,
	      proposal: proposal.key,
	      is_expanded: this.is_expanded,
	      list_key: this.props.list_key,
	      show_list_title: this.props.show_list_title,
	      list_title_color: this.props.list_title_color,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore,
	      expansion_state_changed: this.props.expansion_state_changed
	    })));
	  },
	  draw_avatar_or_bullet: function() {
	    var anonymous, base, current_user, editor, editor_opinion, icons, proposal;
	    proposal = fetch(this.props.proposal);
	    current_user = fetch('/current_user');
	    icons = this.should_use_avatar();
	    return DIV({
	      style: {
	        position: 'relative',
	        top: icons ? 7 : void 0
	      }
	    }, icons ? (editor = proposal_editor(proposal), editor_opinion = _.findWhere(proposal.opinions, {
	      user: editor
	    }), anonymous = proposal.hide_name || (editor_opinion != null ? editor_opinion.hide_name : void 0), proposal.pic ? IMG({
	      className: 'proposal_pic',
	      src: proposal.pic
	    }) : editor ? Avatar({
	      key: editor,
	      user: editor,
	      img_size: 'large',
	      anonymous: anonymous,
	      style: {
	        height: PROPOSAL_AUTHOR_AVATAR_SIZE,
	        width: PROPOSAL_AUTHOR_AVATAR_SIZE
	      }
	    }) : SPAN({
	      className: 'empty_pic',
	      style: {
	        height: "var(--PROPOSAL_AUTHOR_AVATAR_SIZE)",
	        width: "var(--PROPOSAL_AUTHOR_AVATAR_SIZE)",
	        display: 'inline-block',
	        border: "2px dashed #ddd"
	      }
	    })) : (typeof (base = this.props).icon === "function" ? base.icon() : void 0) || SVG({
	      className: 'proposal_bullet',
	      key: 'bullet',
	      width: 8,
	      viewBox: '0 0 200 200'
	    }, CIRCLE({
	      cx: 100,
	      cy: 100,
	      r: 80,
	      fill: '#000000'
	    })));
	  },
	  draw_edit_and_delete: function() {
	    var can_edit, proposal, subdomain;
	    proposal = fetch(this.props.proposal);
	    subdomain = fetch('/subdomain');
	    can_edit = permit('update proposal', proposal, subdomain) > 0;
	    if (!can_edit) {
	      return SPAN(null);
	    }
	    return DIV({
	      className: 'edit_and_delete_block'
	    }, BUTTON({
	      className: 'like_link',
	      "aria-label": TRANSLATE('engage.edit_button', 'edit'),
	      "data-tooltip": TRANSLATE('engage.edit_button', 'edit'),
	      style: {
	        marginRight: 4
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          var proposal_editing;
	          proposal_editing = fetch('proposal_editing');
	          proposal_editing.editing = proposal.key;
	          proposal_editing.callback = function() {
	            delete _this.local.collapsed_title_height;
	            return save(_this.local);
	          };
	          save(proposal_editing);
	          e.stopPropagation();
	          return e.preventDefault();
	        };
	      })(this)
	    }, edit_icon(18, 18, '#444')), permit('delete proposal', proposal, subdomain) > 0 ? BUTTON({
	      className: 'like_link',
	      "data-tooltip": TRANSLATE('engage.delete_button', 'delete'),
	      "aria-label": TRANSLATE('engage.delete_button', 'delete'),
	      onClick: (function(_this) {
	        return function() {
	          if (confirm('Delete this proposal forever?')) {
	            destroy(proposal.key);
	            return loadPage('/');
	          }
	        };
	      })(this)
	    }, trash_icon(18, 18, '#444')) : void 0);
	  }
	});
	
	styles += ".edit_and_delete_block {\n  opacity: 0;\n  transition: opacity 1s;\n  position: absolute;\n  padding-top: 12px;\n}\n\n.is_expanded .edit_and_delete_block, \n.ProposalItem:hover .edit_and_delete_block,\n.ProposalItem:focus-within .edit_and_delete_block {\n  opacity: 1;    \n}\n\n@media " + LAPTOP_MEDIA + " {\n  .edit_and_delete_block {\n    top: 7px;\n    left: 14px;\n  }\n  .is_expanded .edit_and_delete_block, \n  .ProposalItem:hover .edit_and_delete_block,\n  .ProposalItem:focus-within .edit_and_delete_block {\n    right: 12px;\n    left: auto;\n  }\n\n}  \n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .edit_and_delete_block {\n    left: calc(var(--PROPOSAL_AUTHOR_AVATAR_SIZE) / 2 - 18px / 2 + 4px);\n    top: calc(var(--PROPOSAL_AUTHOR_AVATAR_SIZE) + 6px);\n  }\n\n}  \n\n.edit_and_delete_block button {\n  opacity: .3;\n  transition: opacity .6s ease;\n}\n\n.edit_and_delete_block button:hover,\n.edit_and_delete_block button:focus-within {\n  opacity: 1;\n}\n";
	
	styles += "\n.animating-expansion .histoavatars-container {\n  content-visibility: visible;\n}\n";
	
	proposal_url = function(proposal) {
	  proposal = fetch(proposal);
	  return "/" + proposal.slug;
	};
	
	window.personal_view_available = function(proposal) {
	  proposal = fetch(proposal);
	  return !TABLET_SIZE() && proposal.active && customization('discussion_enabled', proposal);
	};
	
	window.toggle_expand = function(arg) {
	  var current_user, el, ensure_open, expanded_state, just_you, list_key, mode, opinion_views, parent, personal_view_preferred, prefer_personal_view, proposal;
	  proposal = arg.proposal, ensure_open = arg.ensure_open, prefer_personal_view = arg.prefer_personal_view;
	  proposal = fetch(proposal);
	  el = document.querySelector(".proposal-title[data-proposal='" + proposal.key + "']");
	  list_key = el.closest('.List').getAttribute('data-key');
	  expanded_state = fetch("proposal_expansions-" + list_key);
	  if (ensure_open && expanded_state[proposal.key]) {
	    return;
	  }
	  current_user = fetch('/current_user');
	  opinion_views = fetch('opinion_views');
	  just_you = opinion_views.active_views['just_you'];
	  personal_view_preferred = prefer_personal_view || (just_you && current_user.logged_in);
	  mode = personal_view_available(proposal) && personal_view_preferred ? 'crafting' : 'results';
	  parent = el.closest('.ProposalItem');
	  parent.classList.add('will-expand-toggle');
	  return $$.ensureInView(el, {
	    dom_possibly_shifting: true,
	    extra_height: !expanded_state[proposal.key] ? 4000 : 0,
	    force: mode === 'crafting',
	    speed_mult: .5,
	    callback: (function(_this) {
	      return function() {
	        var loc, ref, ref1;
	        loc = fetch('location');
	        expanded_state[proposal.key] = !expanded_state[proposal.key];
	        parent.classList.remove('will-expand-toggle');
	        if (!expanded_state[proposal.key]) {
	          delete expanded_state[proposal.key];
	          update_proposal_mode(proposal, null);
	          loadPage("/", (((ref = loc.query_params) != null ? ref.tab : void 0) ? {
	            tab: loc.query_params.tab
	          } : {}), 'toggle_expand');
	        } else {
	          loadPage(proposal_url(proposal), (((ref1 = loc.query_params) != null ? ref1.selected : void 0) ? {
	            selected: loc.query_params.selected
	          } : {}), 'toggle_expand');
	          update_proposal_mode(proposal, mode);
	        }
	        return save(expanded_state);
	      };
	    })(this)
	  });
	};


/***/ },
/* 20 */
/***/ function(module, exports) {

	window.drawLogo = function(opts) {
	  var height, width;
	  opts = _.defaults(opts, {
	    main_text_color: 'white',
	    o_text_color: logo_red,
	    line_color: 'white',
	    i_dot_x: 252.25,
	    height: 60
	  });
	  opts.width || (opts.width = opts.height * 284 / 60);
	  height = opts.height;
	  width = opts.width;
	  return SVG({
	    id: 'considerit_logo',
	    height: height,
	    viewBox: "0 0 284 60",
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, TITLE({
	    id: 'considerit_logo_title'
	  }, 'Considerit Logo'), DEFS(null, CLIPPATH({
	    id: 'logo_clip'
	  }, RECT({
	    x: 0,
	    y: 0,
	    width: 284,
	    height: 45
	  })), FILTER({
	    id: "logo_shadow",
	    x: "-50%",
	    y: "-50%",
	    width: "200%",
	    height: "200%",
	    filterUnits: "objectBoundingBox"
	  }, FEOFFSET({
	    dx: "0",
	    dy: "1",
	    "in": "SourceAlpha",
	    result: "shadowOffsetOuter1"
	  }), FEGAUSSIANBLUR({
	    stdDeviation: "1",
	    "in": "shadowOffsetOuter1",
	    result: "shadowBlurOuter1"
	  }), FECOLORMATRIX({
	    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
	    type: "matrix",
	    "in": "shadowBlurOuter1",
	    result: "shadowMatrixOuter1"
	  }), FEMERGE(null, FEMERGENODE({
	    "in": "shadowMatrixOuter1"
	  }), FEMERGENODE({
	    "in": "SourceGraphic"
	  })))), G({
	    filter: opts.box_shadow ? 'url(#logo_shadow)' : void 0
	  }, opts.draw_line ? LINE({
	    id: 'underline',
	    x1: 8,
	    y1: 55,
	    x2: 284,
	    y2: 55,
	    stroke: opts.line_color,
	    strokeWidth: 1
	  }) : void 0, PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M18.2811874,48.356 \nC24.1163223,48.3559999 28.0501221,47.5510218 32.5084274,43.599315 \nC32.9673706,43.1801946 33.0984972,42.4018281 32.5739907,41.9827077 \nL30.2137104,37.099623 \nC29.8203305,36.740377 29.0991341,36.6805026 28.5746276,37.099623 \nC25.8209684,39.1353508 22.4772394,40.5124608 18.5434406,40.5124607 \nC14.4641389,40.5124606 9.32086755,37.716503 9.32086787,29.1762513 \nC9.32086836,20.6359996 15.4629989,17.6360006 18.2811869,17.6360001 \nC22.4641385,17.636 25.4641379,19.6359996 27.5746276,21.2528796 \nC28.0991341,21.7318743 28.7547672,21.7318743 29.2137104,21.2528796 \nL32.5739907,17.001801 \nC33.0984972,16.5228062 33.0984972,15.804314 32.5084274,15.3253193 \nC28.0501221,11.6729842 24.903082,10.236 18.2811874,10.236 \nC8.41026668,10.236 0.0764406792,17.8200837 0.0764406792,29.3558743 \nC0.0764406792,40.2729625 8.41026668,48.3560001 18.2811874,48.356 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M38.1601385,33.164 \nC38.1601385,41.444 44.7841385,48.356 52.9201385,48.356 \nC61.0561385,48.356 67.6801385,41.444 67.6801385,33.164 \nC67.6801385,25.028 61.0561385,18.116 52.9201385,18.116 \nC44.7841385,18.116 38.1601385,25.028 38.1601385,33.164 \nC38.1601385,33.164 38.1601385,25.028 38.1601385,33.164 \nZ\nM46.0081385,33.164 \nC46.0081385,29.132 49.0321385,25.892 52.9201385,25.892 \nC56.7361385,25.892 59.8321385,29.132 59.8321385,33.164 \nC59.8321385,37.268 56.7361385,40.58 52.9201385,40.58 \nC49.0321385,40.58 46.0081385,37.268 46.0081385,33.164 \nC46.0081385,33.164 46.0081385,37.268 46.0081385,33.164 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M74.0881385,46.268 \nC74.0881385,46.988 74.7361385,47.636 75.4561385,47.636 \nL80.7841385,47.636 \nC82.1521385,47.636 82.5841385,47.276 82.5841385,46.268 \nL82.5841385,30.428 \nC83.3041385,28.484 85.6081385,25.892 89.3521385,25.892 \nC92.8081385,25.892 94.7521385,28.268 94.7521385,32.012 \nL94.7521385,46.268 \nC94.7521385,46.988 95.3281385,47.636 96.1201385,47.636 \nL102.024139,47.636 \nC102.744139,47.636 103.392139,46.988 103.392139,46.268 \nL103.392139,32.444 \nC103.392139,24.956 99.7201385,18.116 90.5761385,18.116 \nC85.0321385,18.116 81.5041385,21.212 80.4241385,22.364 \nL79.4161385,19.7 \nC79.2001385,19.196 78.8401385,18.836 78.1921385,18.836 \nL75.4561385,18.836 \nC74.7361385,18.836 74.0881385,19.412 74.0881385,20.204 \nC74.0881385,20.204 74.0881385,19.412 74.0881385,20.204 \nL74.0881385,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M110.304139,45.692 \nC111.816139,46.844 115.128139,48.356 119.880139,48.356 \nC127.152139,48.356 131.328139,44.324 131.328139,39.572 \nC131.328139,33.956 127.152139,31.58 121.608139,29.42 \nC118.944139,28.34 117.648139,27.908 117.648139,26.612 \nC117.648139,25.676 118.368139,24.956 120.096139,24.956 \nC122.832139,24.956 126.072139,26.468 126.072139,26.468 \nC126.648139,26.684 127.440139,26.612 127.800139,25.964 \nL129.600139,22.292 \nC129.960139,21.572 129.600139,20.78 128.952139,20.348 \nC127.440139,19.34 124.344139,18.116 120.096139,18.116 \nC112.752139,18.116 109.512139,22.22 109.512139,26.612 \nC109.512139,31.004 112.104139,33.956 117.648139,36.116 \nC121.464139,37.628 122.472139,38.42 122.472139,39.716 \nC122.472139,40.94 121.464139,41.516 120.024139,41.516 \nC116.712139,41.516 113.472139,39.788 113.472139,39.788 \nC112.824139,39.428 112.104139,39.572 111.816139,40.292 \nL109.872139,44.18 \nC109.584139,44.756 109.872139,45.332 110.304139,45.692 \nC110.304139,45.692 109.872139,45.332 110.304139,45.692 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M137.664139,46.268 \nC137.664139,46.988 138.312139,47.636 139.032139,47.636 \nL145.008139,47.636 \nC145.728139,47.636 146.376139,46.988 146.376139,46.268 \nL146.376139,20.204 \nC146.376139,19.412 145.728139,18.836 145.008139,18.836 \nL139.032139,18.836 \nC138.312139,18.836 137.664139,19.412 137.664139,20.204 \nC137.664139,20.204 137.664139,19.412 137.664139,20.204 \nL137.664139,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M166.680139,48.356 \nC172.728139,48.356 176.112139,44.036 176.112139,44.036 \nL176.832139,46.268 \nC177.048139,47.06 177.552139,47.636 178.200139,47.636 \nL181.008139,47.636 \nC181.728139,47.636 182.376139,46.988 182.376139,46.268 \nL182.376139,1.604 \nC182.376139,0.884 181.728139,0.236 181.008139,0.236 \nL174.888139,0.236 \nC174.168139,0.236 173.520139,0.884 173.520139,1.604 \nL173.520139,19.412 \nC172.224139,18.908 169.992139,18.116 167.112139,18.116 \nC158.544139,18.116 152.856139,24.812 152.856139,33.236 \nC152.856139,41.516 158.832139,48.356 166.680139,48.356 \nZ \nM161.208139,33.236 \nC161.208139,29.204 164.160139,25.892 168.192139,25.892 \nC171.792139,25.892 173.808139,27.548 173.808139,27.548 \nL173.808139,35.9 \nC173.304139,37.628 171.576139,40.58 167.760139,40.58 \nC163.944139,40.58 161.208139,37.268 161.208139,33.236 \nC161.208139,33.236 161.208139,37.268 161.208139,33.236 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M188.856139,33.236 \nC188.856139,41.516 194.976139,48.356 203.616139,48.356 \nC208.296139,48.356 211.968139,46.628 214.344139,44.396 \nC215.064139,43.82 214.920139,43.028 214.416139,42.524 \nL211.464139,39.14 \nC210.960139,38.564 210.312139,38.708 209.592139,39.14 \nC208.296139,40.076 206.208139,40.94 203.976139,40.94 \nC199.800139,40.94 197.280139,37.628 197.064139,34.676 \nL215.496139,34.676 \nC216.144139,34.676 216.792139,34.172 216.864139,33.452 \nC216.936139,32.948 217.008139,32.012 217.008139,31.508 \nC217.008139,23.732 210.960139,18.116 203.544139,18.116 \nC194.976139,18.116 188.856139,25.1 188.856139,33.236 \nC188.856139,33.236 188.856139,25.1 188.856139,33.236 \nZ \nM197.712139,29.636 \nC198.072139,26.9 200.448139,24.74 203.328139,24.74 \nC206.064139,24.74 208.368139,26.972 208.584139,29.636 \nC208.584139,29.636 208.368139,26.972 208.584139,29.636 \nL197.712139,29.636 \nZ           "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M223.056139,46.268 \nC223.056139,46.988 223.704139,47.636 224.424139,47.636 \nL229.968139,47.636 \nC230.976139,47.636 231.624139,47.276 231.624139,46.268 \nL231.624139,28.844 \nC232.128139,27.836 233.856139,25.892 236.736139,25.892 \nC237.528139,25.892 238.608139,26.252 238.824139,26.324 \nC239.400139,26.612 240.120139,26.324 240.480139,25.676 \nL243.144139,20.996 \nC244.008139,19.196 240.984139,18.116 237.600139,18.116 \nC233.136139,18.116 230.472139,21.14 229.464139,22.58 \nL228.456139,19.772 \nC228.240139,19.196 227.808139,18.836 227.160139,18.836 \nL224.424139,18.836 \nC223.704139,18.836 223.056139,19.412 223.056139,20.204 \nC223.056139,20.204 223.056139,19.412 223.056139,20.204 \nL223.056139,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M247.608139,46.268 \nC247.608139,46.988 248.256139,47.636 248.976139,47.636 \nL254.952139,47.636 \nC255.672139,47.636 256.320139,46.988 256.320139,46.268 \nL256.320139,20.204 \nC256.320139,19.412 255.672139,18.836 254.952139,18.836 \nL248.976139,18.836 \nC248.256139,18.836 247.608139,19.412 247.608139,20.204 \nC247.608139,20.204 247.608139,19.412 247.608139,20.204 \nL247.608139,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M266.472139,39.068 \nC266.472139,44.9 268.920139,48.356 274.464139,48.356 \nC277.992139,48.356 282.672139,46.7 283.032139,46.484 \nC283.752139,46.196 284.112139,45.476 283.824139,44.756 \nL282.384139,40.22 \nC282.168139,39.5 281.592139,39.14 280.800139,39.428 \nC280.008139,39.716 278.496139,40.22 277.272139,40.22 \nC276.120139,40.22 275.040139,39.932 275.040139,37.916 \nL275.040139,26.396 \nL281.376139,26.396 \nC282.168139,26.396 282.744139,25.748 282.744139,25.028 \nL282.744139,20.204 \nC282.744139,19.412 282.168139,18.836 281.376139,18.836 \nL275.040139,18.836 \nL275.040139,10.772 \nC275.040139,10.052 274.464139,9.404 273.744139,9.404 \nL267.840139,9.476 \nC267.120139,9.476 266.472139,10.124 266.472139,10.844 \nL266.472139,18.836 \nL264.024139,18.836 \nC263.304139,18.836 262.728139,19.412 262.728139,20.204 \nL262.728139,25.028 \nC262.728139,25.748 263.304139,26.396 264.024139,26.396 \nL266.472139,26.396 \nL266.472139,39.068 \nZ"
	  }), CIRCLE({
	    id: 'i_dot',
	    style: {
	      transition: 'fill 500ms'
	    },
	    fill: opts.o_text_color,
	    cx: opts.i_dot_x,
	    cy: "55",
	    r: "4.25",
	    style: opts.transition ? {
	      transition: 'cx 1000ms'
	    } : void 0
	  })));
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var DateFilters, InteractiveOpinionViews, NonInteractiveOpinionViews, OpinionViews, VerificationProcessExplanation, _activate_opinion_view, activate_opinion_date_filter, add_influence, build_influencer_network, clear_all, clear_custom_date, construct_view_for_attribute, default_date_options, default_weights, get_activated_weights, get_participant_attributes_with_defaults, get_weights, i18n, influencer_scores_initialized, just_you_filter, reset_to_all, set_group_by_attribute, to_date_str, toggle_attribute_visibility, toggle_group, toggle_opinion_filter, toggle_weight, user_has_set_a_view,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(1);
	
	__webpack_require__(2);
	
	save({
	  key: 'opinion_views',
	  active_views: {}
	});
	
	save({
	  key: 'opinion_views_ui',
	  active: "all",
	  activated_attributes: {},
	  visible_attribute_values: {}
	});
	
	window.compose_opinion_views = function(opinions, proposal, opinion_views, ignore) {
	  var active_views, data_loaded, ggg, groups, has_groups, j, len, min_salience, o, s, salience, u, u_groups, view, view_name, weight, weights;
	  if (opinion_views == null) {
	    opinion_views = fetch('opinion_views');
	  }
	  if (opinion_views.active_views == null) {
	    opinion_views.active_views = {};
	  }
	  if (ignore == null) {
	    ignore = {};
	  }
	  active_views = opinion_views.active_views;
	  proposal = fetch(proposal);
	  if (!opinions) {
	    opinions = opinionsForProposal(proposal);
	  }
	  weights = {};
	  salience = {};
	  groups = {};
	  has_groups = false;
	  data_loaded = {};
	  for (view_name in active_views) {
	    view = active_views[view_name];
	    has_groups || (has_groups = view.get_group != null);
	    data_loaded[view_name] = (view.ready == null) || view.ready(opinions, proposal);
	  }
	  for (j = 0, len = opinions.length; j < len; j++) {
	    o = opinions[j];
	    weight = 1;
	    min_salience = 1;
	    if (has_groups) {
	      u_groups = [];
	    }
	    u = o.user.key || o.user;
	    for (view_name in active_views) {
	      view = active_views[view_name];
	      if (!data_loaded[view_name] || ignore[view_name]) {
	        continue;
	      }
	      if (view.get_salience != null) {
	        s = view.get_salience(u, o, proposal);
	        if (s < min_salience) {
	          min_salience = s;
	        }
	      }
	      if (view.get_weight != null) {
	        weight *= view.get_weight(u, o, proposal);
	      }
	      if (has_groups && (view.get_group != null)) {
	        ggg = view.get_group(u, o, proposal);
	        if (Array.isArray(ggg)) {
	          u_groups = u_groups.concat(ggg);
	        } else {
	          u_groups.push(ggg);
	        }
	      }
	    }
	    weights[u] = weight;
	    salience[u] = min_salience;
	    if (has_groups) {
	      groups[u] = u_groups;
	    }
	  }
	  return {
	    weights: weights,
	    salience: salience,
	    groups: groups
	  };
	};
	
	window.get_opinions_by_users = function() {
	  var j, len, name1, o, opinions, opinions_by_user, ref;
	  opinions = fetch('/opinions');
	  opinions_by_user = {};
	  ref = opinions.opinions || [];
	  for (j = 0, len = ref.length; j < len; j++) {
	    o = ref[j];
	    if (opinions_by_user[name1 = o.user] == null) {
	      opinions_by_user[name1] = [];
	    }
	    opinions_by_user[o.user].push(o);
	  }
	  return opinions_by_user;
	};
	
	window.get_opinions_for_proposal = function(opinions, proposal, weights) {
	  var groups, j, len, o, ref, results, salience;
	  if (!opinions) {
	    opinions = opinionsForProposal(proposal);
	  }
	  if (!weights) {
	    ref = compose_opinion_views(opinions, proposal), weights = ref.weights, salience = ref.salience, groups = ref.groups;
	  }
	  results = [];
	  for (j = 0, len = opinions.length; j < len; j++) {
	    o = opinions[j];
	    if (weights[o.user] > 0) {
	      results.push(o);
	    }
	  }
	  return results;
	};
	
	window.get_participant_attributes = function() {
	  var anonymization_safe_opinion_filters, attributes, custom_views, fn, is_admin, j, l, len, len1, len2, m, name, new_user_tags, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, show_others, tag, user_tags, view;
	  attributes = [];
	  is_admin = fetch('/current_user').is_admin;
	  show_others = (!customization('hide_opinions') || is_admin) && (!customization('anonymize_everything') || customization('anonymization_safe_opinion_filters'));
	  custom_views = customization('opinion_views');
	  user_tags = customization('user_tags');
	  if (show_others) {
	    if (custom_views) {
	      fn = function(view) {
	        if (view.visibility === 'open' || is_admin) {
	          if (view.pass || view.type === 'filter' || view.compute) {
	            return attributes.push(_.extend({}, view, {
	              key: view.label,
	              name: view.label,
	              options: view.options || ['true', 'false'],
	              continuous_value: view.continuous_value,
	              pass: function(u, value) {
	                var e, result;
	                try {
	                  result = (typeof view.compute === "function" ? view.compute(u) : void 0) || (typeof view.pass === "function" ? view.pass(u) : void 0);
	                } catch (error) {
	                  e = error;
	                  console.error("Opinion view failed", view, u, value);
	                  return false;
	                }
	                if (value != null) {
	                  if ((value === true || value === false || value === "true" || value === "false") && (result === true || result === false || result === "true" || result === "false")) {
	                    result = "" + result;
	                    value = "" + value;
	                  }
	                  return result === value;
	                } else {
	                  return result;
	                }
	              }
	            }));
	          }
	        }
	      };
	      for (j = 0, len = custom_views.length; j < len; j++) {
	        view = custom_views[j];
	        fn(view);
	      }
	    }
	    if (user_tags) {
	      anonymization_safe_opinion_filters = customization('anonymization_safe_opinion_filters');
	      if (anonymization_safe_opinion_filters && Array.isArray(anonymization_safe_opinion_filters)) {
	        new_user_tags = [];
	        for (l = 0, len1 = user_tags.length; l < len1; l++) {
	          tag = user_tags[l];
	          if (ref = tag.key, indexOf.call(anonymization_safe_opinion_filters, ref) >= 0) {
	            new_user_tags.push(tag);
	          }
	        }
	        user_tags = new_user_tags;
	      }
	      for (m = 0, len2 = user_tags.length; m < len2; m++) {
	        tag = user_tags[m];
	        name = tag.key;
	        if ((tag.visibility === 'open' || is_admin) && ((ref1 = ((ref2 = tag.self_report) != null ? ref2.input : void 0) || tag.input) === 'dropdown' || ref1 === 'boolean' || ref1 === 'checklist') && !tag.no_opinion_view) {
	          attributes.push({
	            key: name,
	            name: tag.view_name || tag.name || ((ref3 = tag.self_report) != null ? ref3.question : void 0) || name,
	            pass: (((ref4 = tag.self_report) != null ? ref4.input : void 0) || tag.input) !== 'checklist' ? (function(name, tag) {
	              return function(u, value) {
	                var ref5, ref6, ref7, result;
	                result = (typeof tag.compute === "function" ? tag.compute(u) : void 0) || ((ref5 = fetch(u)) != null ? (ref6 = ref5.tags) != null ? ref6[name] : void 0 : void 0);
	                if (value != null) {
	                  if ((((ref7 = tag.self_report) != null ? ref7.input : void 0) || tag.input) === 'boolean' && (value === true || value === false || value === "true" || value === "false") && (result === true || result === false || result === "true" || result === "false")) {
	                    result = "" + result;
	                    value = "" + value;
	                  }
	                  return result === value;
	                } else {
	                  return result;
	                }
	              };
	            })(name, tag) : void 0,
	            options: ((ref5 = tag.self_report) != null ? ref5.options : void 0) || tag.options || ((((ref6 = tag.self_report) != null ? ref6.input : void 0) || tag.input) === 'boolean' ? [true, false] : void 0),
	            input_type: (ref7 = tag.self_report) != null ? ref7.input : void 0,
	            continuous_value: tag.continuous_value
	          });
	        }
	      }
	    }
	  }
	  return attributes;
	};
	
	window.get_user_groups_from_views = function(groups) {
	  var g, group_set, has_groups, j, len, u, u_groups;
	  has_groups = Object.keys(groups).length > 0;
	  if (has_groups) {
	    group_set = new Set();
	    for (u in groups) {
	      u_groups = groups[u];
	      for (j = 0, len = u_groups.length; j < len; j++) {
	        g = u_groups[j];
	        group_set.add(g);
	      }
	    }
	    return Array.from(group_set);
	  } else {
	    return null;
	  }
	};
	
	window.group_colors = {};
	
	window.get_color_for_groups = function(group_array) {
	  var color, colors, idx, j, len, opinion_views, ref;
	  opinion_views = fetch('opinion_views');
	  if (!opinion_views.active_views.group_by) {
	    return group_colors;
	  }
	  group_array || (group_array = []);
	  if (ref = i18n().unreported, indexOf.call(group_array, ref) < 0) {
	    group_array = group_array.slice();
	    group_array.push(i18n().unreported);
	  }
	  colors = getColors(group_array.length, opinion_views.active_views.group_by.continuous_value);
	  for (idx = j = 0, len = colors.length; j < len; idx = ++j) {
	    color = colors[idx];
	    if (!(group_array[idx] in group_colors)) {
	      if (group_array[idx] === i18n().unreported) {
	        color = 'black';
	      }
	      group_colors[group_array[idx]] = color;
	    }
	  }
	  return group_colors;
	};
	
	window.get_color_for_group = function(val) {
	  return group_colors[val];
	};
	
	window.missing_attribute_info_label = function() {
	  return i18n().unreported;
	};
	
	i18n = function() {
	  return {
	    unreported: translator('opinion_views.unreported', 'Unreported')
	  };
	};
	
	window.influence_network = {};
	
	window.influencer_scores = {};
	
	influencer_scores_initialized = false;
	
	add_influence = function(influenced, influencer, amount) {
	  var base, base1;
	  if (amount == null) {
	    amount = 1;
	  }
	  if (influence_network[influenced] == null) {
	    influence_network[influenced] = {
	      influenced_by: {},
	      influenced: {}
	    };
	  }
	  if (influence_network[influencer] == null) {
	    influence_network[influencer] = {
	      influenced_by: {},
	      influenced: {}
	    };
	  }
	  if ((base = influence_network[influencer].influenced)[influenced] == null) {
	    base[influenced] = 0;
	  }
	  influence_network[influencer].influenced[influenced] += amount;
	  if ((base1 = influence_network[influenced].influenced_by)[influencer] == null) {
	    base1[influencer] = 0;
	  }
	  return influence_network[influenced].influenced_by[influencer] += amount;
	};
	
	build_influencer_network = function() {
	  var amount, influence, j, l, len, len1, len2, len3, m, max_influence, n, num_influenced, opinion, opinions, point, points, proposal, proposals, ref, ref1, ref2, ref3, total_influence, u, user;
	  proposals = fetch('/proposals');
	  points = fetch('/points');
	  if (!points.points || !proposals.proposals) {
	    return;
	  }
	  ref = points.points;
	  for (j = 0, len = ref.length; j < len; j++) {
	    point = ref[j];
	    ref1 = point.includers || [];
	    for (l = 0, len1 = ref1.length; l < len1; l++) {
	      user = ref1[l];
	      if ((user.key || user) === point.user) {
	        continue;
	      }
	      add_influence(user, point.user);
	    }
	  }
	  ref2 = proposals.proposals;
	  for (m = 0, len2 = ref2.length; m < len2; m++) {
	    proposal = ref2[m];
	    opinions = opinionsForProposal(proposal);
	    for (n = 0, len3 = opinions.length; n < len3; n++) {
	      opinion = opinions[n];
	      if (opinion.stance < 0.1) {
	        continue;
	      }
	      add_influence(opinion.user, proposal.user, opinion.stance);
	    }
	  }
	  max_influence = 0;
	  for (user in influence_network) {
	    influence = influence_network[user];
	    num_influenced = Object.keys(influence.influenced).length;
	    total_influence = 0;
	    ref3 = influence.influenced;
	    for (u in ref3) {
	      amount = ref3[u];
	      total_influence += amount;
	    }
	    influence = Math.log(2 + num_influenced + total_influence);
	    if (num_influenced + total_influence > max_influence) {
	      max_influence = influence;
	    }
	    influencer_scores[user] = influence;
	  }
	  for (user in influence_network) {
	    influence = influence_network[user];
	    influencer_scores[user] /= max_influence;
	  }
	  return influencer_scores_initialized = true;
	};
	
	just_you_filter = {
	  key: 'just_you',
	  name: 'Just you',
	  pass: function(u) {
	    var user;
	    user = fetch(u);
	    return user.key === fetch('/current_user').user;
	  }
	};
	
	default_weights = function() {
	  return [
	    {
	      key: 'weighed_by_substantiated',
	      name: translator('opinion_views.weights_reasons', 'Reasons given'),
	      label: translator('opinion_views.weights_reasons_label', 'Add weight to opinions that explained their stance with pro and/or con reasons.'),
	      weight: function(u, opinion, proposal) {
	        var point_inclusions, ref;
	        point_inclusions = Math.log(1 + Math.min(8, ((ref = opinion.point_inclusions) != null ? ref.length : void 0) || 0));
	        return .1 + point_inclusions;
	      },
	      icon: function(color) {
	        if (color == null) {
	          color = 'black';
	        }
	        return SVG({
	          width: 14,
	          height: 14,
	          viewBox: "0 0 23 23",
	          dangerouslySetInnerHTML: {
	            __html: "<g id=\"Group-8\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <polygon id=\"Rectangle\" stroke=\"" + color + "\" points=\"0 0 23 0 23 17.8367347 11.5 17.8367347 6.41522296 23 6.41522296 17.8367347 0 17.8367347\"></polygon>\n    <ellipse id=\"Oval\" fill=\"" + color + "\" cx=\"4.66666683\" cy=\"8.43750016\" rx=\"1.5333335\" ry=\"1.43750016\"></ellipse>\n    <line stroke=\"" + color + "\" x1=\"8.37575758\" y1=\"8.5\" x2=\"17.7575758\" y2=\"8.5\" id=\"Line-5\" stroke=\"#979797\" stroke-linecap=\"square\"></line>\n    <ellipse id=\"Oval\" fill=\"" + color + "\" cx=\"4.66666683\" cy=\"3.43750016\" rx=\"1.5333335\" ry=\"1.43750016\"></ellipse>\n    <line stroke=\"" + color + "\" x1=\"8.37575758\" y1=\"3.5\" x2=\"17.7575758\" y2=\"3.5\" id=\"Line-5\" stroke=\"#979797\" stroke-linecap=\"square\"></line>\n    <ellipse id=\"Oval\" fill=\"" + color + "\" cx=\"4.66666683\" cy=\"13.4375002\" rx=\"1.5333335\" ry=\"1.43750016\"></ellipse>\n    <line stroke=\"" + color + "\" x1=\"8.37575758\" y1=\"13.5\" x2=\"17.7575758\" y2=\"13.5\" id=\"Line-5\" stroke=\"#979797\" stroke-linecap=\"square\"></line>\n</g>"
	          }
	        });
	      }
	    }, {
	      key: 'weighed_by_deliberative',
	      name: translator('opinion_views.weights_tradeoffs', 'Tradeoffs recognized'),
	      label: translator('opinion_views.weights_tradeoffs_label', 'Add weight to opinions that acknowledge both pro and con tradeoffs.'),
	      ready: function(opinions, proposal) {
	        return !!fetch("/points").points;
	      },
	      weight: function(u, opinion, proposal) {
	        var cons, inc, j, len, pnt, point_inclusions, pros, tradeoffs_recognized;
	        point_inclusions = opinion.point_inclusions || [];
	        pros = 0;
	        cons = 0;
	        for (j = 0, len = point_inclusions.length; j < len; j++) {
	          inc = point_inclusions[j];
	          pnt = fetch(inc);
	          if (pnt.is_pro) {
	            pros += 1;
	          } else {
	            cons += 1;
	          }
	        }
	        tradeoffs_recognized = Math.min(pros, cons);
	        if (tradeoffs_recognized > 0) {
	          return 1 + Math.log(tradeoffs_recognized);
	        } else {
	          return .1;
	        }
	      },
	      icon: function(color) {
	        if (color == null) {
	          color = 'black';
	        }
	        return SVG({
	          width: 14,
	          height: 14,
	          viewBox: "0 0 23 23",
	          dangerouslySetInnerHTML: {
	            __html: "<g id=\"weigh\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <path fill=\"" + color + "\" d=\"M22.9670971,20.1929176 L22.9670971,20.1683744 C22.9815886,20.1324736 22.9922265,20.0943011 22.9987304,20.0548621 C22.9987304,20.0548621 22.9987304,20.0548621 22.9987304,20.0548621 C23.0004232,20.0293408 23.0004232,20.0036859 22.9987304,19.9781646 C22.9987304,19.9781646 22.9987304,19.9566893 22.9987304,19.9444177 C22.9987304,19.9321461 22.9987304,19.9229424 22.9987304,19.9137387 C22.9949502,19.8726516 22.9867644,19.8324016 22.9743971,19.7940906 L22.9743971,19.7940906 L18.9399256,8.02562631 C18.9506738,7.99615751 18.9588334,7.96529502 18.9642589,7.93358931 C18.9781664,7.81275485 18.9534152,7.68990536 18.8954544,7.59208741 C18.8374936,7.49426946 18.7510753,7.42950274 18.6552252,7.41204631 L13.4527523,6.45792942 C13.4151172,5.40049872 12.8144155,4.50934755 11.9927506,4.29199205 L11.9927506,0.460184995 C11.9927506,0.20603184 11.8293343,0 11.6277502,0 C11.426166,0 11.2627497,0.20603184 11.2627497,0.460184995 L11.2627497,4.29199205 C10.6280528,4.45682465 10.10874,5.03001236 9.89521475,5.80139883 L4.44940823,4.80126344 C4.35356714,4.78372914 4.25612781,4.81493501 4.1785425,4.88801078 C4.1009572,4.96108654 4.04958681,5.07004101 4.03574107,5.19088674 C4.03155491,5.23059483 4.03155491,5.27082675 4.03574107,5.31053484 L0.025602933,16.9992337 L0.025602933,16.9992337 C0.0132356207,17.0375447 0.00504978749,17.0777948 0.00126957058,17.1188818 C0.00126957058,17.1188818 0.00126957058,17.1403571 0.00126957058,17.1495608 C0.00126957058,17.1587645 0.00126957058,17.1710361 0.00126957058,17.1833077 C-0.000423190195,17.208829 -0.000423190195,17.2344839 0.00126957058,17.2600052 C0.00126957058,17.2600052 0.00126957058,17.2600052 0.00126957058,17.2600052 C0.00774547506,17.2994541 0.0183845876,17.3376312 0.0329029418,17.3735175 L0.0329029418,17.3980607 C0.0488060712,17.4339253 0.0684473538,17.4669431 0.0913030117,17.4962335 L0.699637073,18.2632085 C2.75983325,20.8606357 6.10004983,20.8606357 8.160246,18.2632085 L8.76858006,17.4962335 C8.79161354,17.465998 8.81126198,17.431936 8.82698013,17.3949928 L8.82698013,17.3704496 C8.84147172,17.3345488 8.85210954,17.2963764 8.85861351,17.2569373 C8.85861351,17.2569373 8.85861351,17.2569373 8.85861351,17.2569373 C8.86030627,17.231416 8.86030627,17.2057611 8.85861351,17.1802398 C8.85861351,17.1802398 8.85861351,17.1587645 8.85861351,17.1464929 C8.85861351,17.1342213 8.85861351,17.1250176 8.85861351,17.1158139 C8.85483329,17.0747269 8.84664746,17.0344768 8.83428014,16.9961658 L8.83428014,16.9961658 L5.01394224,5.83207783 L9.80274797,6.71256512 C9.85757198,7.80370794 10.5108448,8.69745358 11.3689468,8.85528909 C12.2270488,9.0131246 13.0556206,8.39194297 13.3554189,7.36602781 L18.1320579,8.2434472 L14.1584198,19.7879548 L14.1584198,19.7879548 C14.1460238,19.8262538 14.1378369,19.8665089 14.1340865,19.9076029 C14.1340865,19.9076029 14.1340865,19.9290782 14.1340865,19.9382819 C14.1340865,19.9474856 14.1340865,19.9597572 14.1340865,19.9720288 C14.1323937,19.9975501 14.1323937,20.023205 14.1340865,20.0487263 C14.1340865,20.0487263 14.1340865,20.0487263 14.1340865,20.0487263 C14.1405624,20.0881752 14.1512015,20.1263523 14.1657199,20.1622386 L14.1657199,20.1867818 C14.1816474,20.2226264 14.2012863,20.2556402 14.2241199,20.2849546 L14.832454,21.0519296 C16.8926502,23.6493568 20.2328667,23.6493568 22.2930629,21.0519296 L22.901397,20.2849546 C22.9264857,20.2581473 22.9485857,20.2271881 22.9670971,20.1929176 Z M15.0490209,19.5087759 L18.5627585,9.26505789 L22.0959627,19.5087759 L15.0490209,19.5087759 Z M0.916203999,16.7200548 L4.44940823,6.48247262 L7.96314577,16.7200548 L0.916203999,16.7200548 Z M1.24227106,17.6404248 L7.63707871,17.6404248 C5.86694476,19.8538124 3.01240501,19.8538124 1.24227106,17.6404248 L1.24227106,17.6404248 Z M11.6277502,7.95813251 C11.02159,7.94807762 10.5340258,7.32653669 10.5327488,6.56223802 C10.5327488,6.51928742 10.5327488,6.48247262 10.5327488,6.43952202 C10.5385866,6.42154559 10.5434641,6.40309702 10.5473489,6.38429982 C10.5510895,6.34660935 10.5510895,6.308478 10.5473489,6.27078753 C10.6654865,5.57212652 11.1829331,5.09866324 11.7464056,5.17365144 C12.3098781,5.24863963 12.7375156,5.84787683 12.7373515,6.56223802 C12.7373515,6.60518862 12.7373515,6.64507132 12.7373515,6.68802192 C12.7187894,6.74960828 12.7113093,6.81562397 12.7154515,6.88129962 C12.5971458,7.51670329 12.1454062,7.96392904 11.6277502,7.95813251 L11.6277502,7.95813251 Z M15.375088,20.4291459 L21.7698956,20.4291459 C19.9997617,22.6425334 17.1452219,22.6425334 15.375088,20.4291459 L15.375088,20.4291459 Z\" id=\"Shape\" fill-rule=\"nonzero\"></path>\n</g>"
	          }
	        });
	      }
	    }, {
	      key: 'weighed_by_influence',
	      name: translator('opinion_views.weights_influence', 'Influence'),
	      label: translator('opinion_views.weights_influence_label', 'Add weight to the opinions of people who have contributed proposals and pro/con reasons that other people have found valuable.'),
	      ready: function() {
	        return !!fetch('/proposals').proposals && !!fetch('/points').points;
	      },
	      weight: function(u, opinion, proposal) {
	        if (!influencer_scores_initialized) {
	          build_influencer_network();
	        }
	        if (!influencer_scores_initialized) {
	          return 1;
	        }
	        u = u.key || u;
	        return .1 + (influencer_scores[u] || 0);
	      },
	      icon: function(color) {
	        if (color == null) {
	          color = 'black';
	        }
	        return SVG({
	          width: 14,
	          height: 14,
	          viewBox: "0 0 23 23",
	          dangerouslySetInnerHTML: {
	            __html: "<g id=\"influence\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <ellipse id=\"Oval\" fill=\"" + color + "\" fill-rule=\"nonzero\" transform=\"translate(11.364066, 2.300000) scale(-1, 1) translate(-11.364066, -2.300000) \" cx=\"11.3640662\" cy=\"2.3\" rx=\"2.39243499\" ry=\"2.3\"></ellipse>\n    <path d=\"M12.5828538,4.6 L11.3640662,4.6 L10.1452786,4.6 C7.83466033,4.6 5.98108747,6.46815021 5.98108747,8.79694019 L5.98108747,13.403338 C5.98108747,13.940751 6.41274142,14.3502086 6.92056961,14.3502086 C7.4537892,14.3502086 7.86005174,13.9151599 7.86005174,13.403338 L7.86005174,8.7201669 C7.86005174,8.54102921 7.98700879,8.41307371 8.16474865,8.41307371 C8.34248851,8.41307371 8.46944556,8.54102921 8.46944556,8.7201669 L8.46944556,13.2753825 L8.46944556,22.0531293 C8.46944556,22.5905424 8.90109951,23 9.4089277,23 C9.94214729,23 10.3484098,22.5649513 10.3484098,22.0531293 L11.0085865,13.2753825 L11.6687631,13.2753825 L12.3797226,22.0531293 C12.3797226,22.5905424 12.8113765,23 13.3192047,23 C13.8524243,23 14.2586868,22.5649513 14.2586868,22.0531293 L14.2586868,13.2497914 L14.2586868,8.7201669 C14.2586868,8.54102921 14.3856439,8.41307371 14.5633837,8.41307371 C14.7411236,8.41307371 14.8680806,8.54102921 14.8680806,8.7201669 L14.8680806,13.403338 C14.8680806,13.940751 15.2997346,14.3502086 15.8075628,14.3502086 C16.3407824,14.3502086 16.7470449,13.9151599 16.7470449,13.403338 L16.7470449,8.79694019 C16.7470449,6.49374131 14.8934721,4.6 12.5828538,4.6 Z\" id=\"Path\" fill=\"" + color + "\" fill-rule=\"nonzero\" transform=\"translate(11.364066, 13.800000) scale(-1, 1) translate(-11.364066, -13.800000) \"></path>\n    <path d=\"M22.3105861,0 L18.7361296,0 C18.35544,0 18.0468076,0.283811841 18.0468076,0.633885886 C18.0468076,0.983959931 18.35544,1.26777177 18.7361296,1.26777177 L20.6463788,1.26777177 L16.9489473,4.66785115 C16.6797441,4.91540471 16.6797441,5.31678126 16.9489473,5.56433482 C17.2181506,5.81188839 17.6546293,5.81188839 17.9238325,5.56433482 L21.621264,2.16425545 L21.6213559,3.92088002 C21.6213559,4.27095406 21.9299884,4.5547659 22.310678,4.5547659 C22.6913675,4.5547659 23,4.27095406 23,3.92088002 L23,0.633885886 C22.9999081,0.283727323 22.6912756,0 22.3105861,0 Z\" id=\"Path\" fill=\"" + color + "\" fill-rule=\"nonzero\"></path>\n    <path d=\"M5.56354114,0 L1.98908469,0 C1.60839511,0 1.29976266,0.283811841 1.29976266,0.633885886 C1.29976266,0.983959931 1.60839511,1.26777177 1.98908469,1.26777177 L3.89933392,1.26777177 L0.201902425,4.66785115 C-0.0673008082,4.91540471 -0.0673008082,5.31678126 0.201902425,5.56433482 C0.471105657,5.81188839 0.907584371,5.81188839 1.1767876,5.56433482 L4.8742191,2.16425545 L4.87431101,3.92088002 C4.87431101,4.27095406 5.18294346,4.5547659 5.56363305,4.5547659 C5.94432263,4.5547659 6.25295508,4.27095406 6.25295508,3.92088002 L6.25295508,0.633885886 C6.25286317,0.283727323 5.94423072,0 5.56354114,0 Z\" id=\"Path\" fill=\"" + color + "\" fill-rule=\"nonzero\" transform=\"translate(3.126478, 2.875000) scale(-1, 1) translate(-3.126478, -2.875000) \"></path>\n    <path d=\"M22.3105861,16.1 L18.7361296,16.1 C18.35544,16.1 18.0468076,16.3838118 18.0468076,16.7338859 C18.0468076,17.0839599 18.35544,17.3677718 18.7361296,17.3677718 L20.6463788,17.3677718 L16.9489473,20.7678511 C16.6797441,21.0154047 16.6797441,21.4167813 16.9489473,21.6643348 C17.2181506,21.9118884 17.6546293,21.9118884 17.9238325,21.6643348 L21.621264,18.2642555 L21.6213559,20.02088 C21.6213559,20.3709541 21.9299884,20.6547659 22.310678,20.6547659 C22.6913675,20.6547659 23,20.3709541 23,20.02088 L23,16.7338859 C22.9999081,16.3837273 22.6912756,16.1 22.3105861,16.1 Z\" id=\"Path\" fill=\"" + color + "\" fill-rule=\"nonzero\" transform=\"translate(19.873522, 18.975000) scale(1, -1) translate(-19.873522, -18.975000) \"></path>\n    <path d=\"M5.56354114,16.1 L1.98908469,16.1 C1.60839511,16.1 1.29976266,16.3838118 1.29976266,16.7338859 C1.29976266,17.0839599 1.60839511,17.3677718 1.98908469,17.3677718 L3.89933392,17.3677718 L0.201902425,20.7678511 C-0.0673008082,21.0154047 -0.0673008082,21.4167813 0.201902425,21.6643348 C0.471105657,21.9118884 0.907584371,21.9118884 1.1767876,21.6643348 L4.8742191,18.2642555 L4.87431101,20.02088 C4.87431101,20.3709541 5.18294346,20.6547659 5.56363305,20.6547659 C5.94432263,20.6547659 6.25295508,20.3709541 6.25295508,20.02088 L6.25295508,16.7338859 C6.25286317,16.3837273 5.94423072,16.1 5.56354114,16.1 Z\" id=\"Path\" fill=\"" + color + "\" fill-rule=\"nonzero\" transform=\"translate(3.126478, 18.975000) scale(-1, -1) translate(-3.126478, -18.975000) \"></path>\n</g>"
	          }
	        });
	      }
	    }
	  ];
	};
	
	get_weights = function() {
	  var custom_views, is_admin, j, len, show_others, view, weights;
	  custom_views = customization('opinion_views');
	  is_admin = fetch('/current_user').is_admin;
	  show_others = (!customization('hide_opinions') || is_admin) && (!customization('anonymize_everything') || customization('anonymization_safe_opinion_filters'));
	  weights = default_weights();
	  if (show_others && custom_views) {
	    for (j = 0, len = custom_views.length; j < len; j++) {
	      view = custom_views[j];
	      if (view.visibility === 'open' || is_admin) {
	        if (view.type === 'weight') {
	          weights.push(_.extend({}, view, {
	            key: view.label,
	            name: view.label,
	            options: ['true', 'false']
	          }));
	        }
	      }
	    }
	  }
	  return weights;
	};
	
	toggle_group = function(view, replace_existing) {
	  return _activate_opinion_view(view, 'group', replace_existing);
	};
	
	toggle_weight = function(view, replace_existing) {
	  return _activate_opinion_view(view, 'weight', replace_existing);
	};
	
	toggle_opinion_filter = function(view, replace_existing) {
	  return _activate_opinion_view(view, 'filter', replace_existing);
	};
	
	activate_opinion_date_filter = function(view) {
	  return _activate_opinion_view(view, 'date-filter', true);
	};
	
	_activate_opinion_view = function(view, view_type, replace_existing) {
	  var active_views, j, k, len, opinion_views, to_delete, v, view_key;
	  opinion_views = fetch('opinion_views');
	  if (opinion_views.active_views == null) {
	    opinion_views.active_views = {};
	  }
	  active_views = opinion_views.active_views;
	  view_key = view.key || view.label;
	  if (view_key in active_views && !replace_existing) {
	    delete active_views[view_key];
	  } else {
	    if (view_type === 'filter') {
	      if (view_key === just_you_filter.key) {
	        to_delete = [];
	        for (k in active_views) {
	          v = active_views[k];
	          if (v.view_type === view_type) {
	            to_delete.push(k);
	          }
	        }
	        for (j = 0, len = to_delete.length; j < len; j++) {
	          k = to_delete[j];
	          delete active_views[k];
	        }
	      } else if (active_views[just_you_filter.key]) {
	        delete active_views[just_you_filter.key];
	      }
	    }
	    active_views[view_key] = {
	      key: view.key,
	      name: view.name,
	      view_type: view_type,
	      continuous_value: view.continuous_value,
	      ready: view.ready,
	      get_salience: function(u, opinion, proposal) {
	        if (view.salience != null) {
	          return view.salience(u, opinion, proposal);
	        } else if ((view.pass == null) || view.pass(u, opinion, proposal)) {
	          return 1;
	        } else {
	          return 0;
	        }
	      },
	      get_weight: function(u, opinion, proposal) {
	        if (view.weight != null) {
	          return view.weight(u, opinion, proposal);
	        } else if ((view.pass == null) || (typeof view.pass === "function" ? view.pass(u, opinion, proposal) : void 0)) {
	          return 1;
	        } else {
	          return 0;
	        }
	      },
	      get_group: view.group != null ? function(u, opinion, proposal) {
	        var group;
	        group = view.group(u, opinion, proposal);
	        if (group == null) {
	          group = i18n().unreported;
	        }
	        return group;
	      } : void 0,
	      options: view.options
	    };
	  }
	  return save(opinion_views);
	};
	
	window.date_option_changed = function(activated) {
	  var date_toggle_state, pass, tz_offset, view;
	  date_toggle_state = fetch('opinion-date-filter');
	  tz_offset = new Date().getTimezoneOffset() * 60 * 1000;
	  pass = function(u, opinion, proposal) {
	    var date, earliest, latest, now;
	    date = new Date(opinion.updated_at).getTime();
	    now = Date.now();
	    earliest = latest = null;
	    if (activated.key !== 'custom') {
	      clear_custom_date();
	    }
	    if (activated.key === 'today') {
	      earliest = now - 1000 * 60 * 60 * 24;
	    } else if (activated.key === 'week') {
	      earliest = now - 1000 * 60 * 60 * 24 * 7;
	    } else if (activated.key === 'custom') {
	      if (date_toggle_state.start) {
	        earliest = date_toggle_state.start + tz_offset;
	      }
	      if (date_toggle_state.end) {
	        latest = date_toggle_state.end + tz_offset;
	      }
	    }
	    return (earliest === null || earliest <= date) && (latest === null || latest >= date);
	  };
	  view = {
	    key: 'date',
	    salience: function(u, opinion, proposal) {
	      if (pass(u, opinion, proposal)) {
	        return 1;
	      } else {
	        return .1;
	      }
	    },
	    weight: function(u, opinion, proposal) {
	      if (pass(u, opinion, proposal)) {
	        return 1;
	      } else {
	        return .1;
	      }
	    },
	    name: activated.key
	  };
	  return activate_opinion_date_filter(view);
	};
	
	default_date_options = function() {
	  return [
	    {
	      key: 'all',
	      label: translator('opinion_views.date_all', 'All'),
	      callback: function() {
	        var opinion_views;
	        opinion_views = fetch('opinion_views');
	        clear_custom_date();
	        if (opinion_views.active_views['date']) {
	          delete opinion_views.active_views['date'];
	          return save(opinion_views);
	        }
	      }
	    }, {
	      key: 'today',
	      label: translator('opinion_views.date_today', 'Today'),
	      callback: date_option_changed
	    }, {
	      key: 'week',
	      label: translator('opinion_views.date_week', 'Past week'),
	      callback: date_option_changed
	    }, {
	      key: 'custom',
	      label: translator('opinion_views.date_custom', 'Custom'),
	      callback: date_option_changed
	    }
	  ];
	};
	
	clear_custom_date = function() {
	  var date_toggle_state;
	  date_toggle_state = fetch('opinion-date-filter');
	  date_toggle_state.start = null;
	  date_toggle_state.end = null;
	  return save(date_toggle_state);
	};
	
	DateFilters = function() {
	  var date_options, date_toggle_state, opinion_views, tz_offset;
	  opinion_views = fetch('opinion_views');
	  tz_offset = new Date().getTimezoneOffset() * 60 * 1000;
	  date_toggle_state = fetch('opinion-date-filter');
	  date_options = default_date_options();
	  return DIV({
	    className: 'grays'
	  }, ToggleButtons(date_options, date_toggle_state), date_toggle_state.active === 'custom' ? DIV({
	    className: 'opinion-date-filter'
	  }, SPAN({
	    style: {
	      position: 'relative'
	    }
	  }, LABEL(null, translator('opinion_views.date_from', 'From:')), INPUT({
	    type: 'date',
	    id: 'start',
	    name: 'opinion-start',
	    defaultValue: date_toggle_state.start ? to_date_str(date_toggle_state.start) : void 0,
	    onChange: function(e) {
	      date_toggle_state.start = new Date(e.target.value).getTime();
	      save(date_toggle_state);
	      date_option_changed(date_options[3]);
	      return e.preventDefault();
	    }
	  })), SPAN({
	    style: {
	      position: 'relative',
	      paddingLeft: 8
	    }
	  }, LABEL(null, translator('opinion_views.date_to', 'To:')), INPUT({
	    type: 'date',
	    id: 'end',
	    name: 'opinion-end',
	    defaultValue: date_toggle_state.end ? to_date_str(date_toggle_state.end) : void 0,
	    onChange: function(e) {
	      date_toggle_state.end = new Date(e.target.value).getTime();
	      save(date_toggle_state);
	      date_option_changed(date_options[3]);
	      return e.preventDefault();
	    }
	  }))) : void 0);
	};
	
	to_date_str = function(ms) {
	  var date, day, month, year;
	  ms += new Date().getTimezoneOffset() * 60 * 1000;
	  date = new Date(ms);
	  year = date.getFullYear();
	  month = ("0" + (date.getMonth() + 1)).slice(-2);
	  day = ("0" + date.getDate()).slice(-2);
	  return year + "-" + month + "-" + day;
	};
	
	clear_all = function(local_state) {
	  var attr, date_state, j, k, l, len, len1, opinion_views, opinion_views_ui, ref, ref1, ref2, to_remove, v, view;
	  opinion_views = fetch('opinion_views');
	  opinion_views_ui = fetch('opinion_views_ui');
	  opinion_views_ui.last_interacted_with = local_state.key || local_state;
	  save(opinion_views_ui);
	  to_remove = [];
	  ref = opinion_views.active_views;
	  for (k in ref) {
	    v = ref[k];
	    if ((ref1 = v.view_type) === 'filter' || ref1 === 'weight' || ref1 === 'group' || ref1 === 'date-filter') {
	      to_remove.push(v);
	    }
	  }
	  for (j = 0, len = to_remove.length; j < len; j++) {
	    view = to_remove[j];
	    toggle_opinion_filter(view);
	  }
	  ref2 = ['group_by', 'visible_attribute_values', 'activated_attributes'];
	  for (l = 0, len1 = ref2.length; l < len1; l++) {
	    attr = ref2[l];
	    if (attr === 'group_by') {
	      if (attr in opinion_views_ui) {
	        delete opinion_views_ui[attr];
	      }
	    } else {
	      opinion_views_ui[attr] = {};
	    }
	  }
	  save(opinion_views_ui);
	  date_state = fetch('opinion-date-filter');
	  date_state.start = date_state.end = date_state.active = null;
	  return save(date_state);
	};
	
	reset_to_all = function(local_state) {
	  var is_admin, opinion_views_ui, show_others;
	  clear_all(local_state);
	  is_admin = fetch('/current_user').is_admin;
	  show_others = !customization('hide_opinions') || is_admin;
	  opinion_views_ui = fetch('opinion_views_ui');
	  if (show_others) {
	    opinion_views_ui.active = 'all';
	  } else {
	    opinion_views_ui.active = 'you';
	  }
	  return save(opinion_views_ui);
	};
	
	user_has_set_a_view = function() {
	  var checked, j, k, len, opinion_views, opinion_views_ui, ref, ref1, ref2, v, val, view_is_set;
	  opinion_views = fetch('opinion_views');
	  view_is_set = false;
	  ref = opinion_views.active_views;
	  for (k in ref) {
	    v = ref[k];
	    if (v.view_type === 'filter' && v.options) {
	      opinion_views_ui = fetch('opinion_views_ui');
	      checked = 0;
	      ref1 = v.options;
	      for (j = 0, len = ref1.length; j < len; j++) {
	        val = ref1[j];
	        if (!!opinion_views_ui.visible_attribute_values[v.key][val]) {
	          checked += 1;
	        }
	      }
	      view_is_set || (view_is_set = checked > 0 && checked < v.options.length);
	    } else {
	      view_is_set || (view_is_set = (ref2 = v.view_type) === 'filter' || ref2 === 'weight' || ref2 === 'group' || ref2 === 'date-filter');
	    }
	  }
	  return view_is_set;
	};
	
	styles += "@media " + PHONE_MEDIA + " {\n  .filter_opinions_to {\n    display: none;\n  }\n\n}";
	
	OpinionViews = ReactiveComponent({
	  displayName: 'OpinionViews',
	  render: function() {
	    var has_other_filters, is_admin, local_state, opinion_views, opinion_views_ui, reset_to_default_view, show_all_not_available, show_others, view_buttons;
	    if (!fetch('/subdomain').name) {
	      return SPAN(null);
	    }
	    local_state = fetch(this.props.ui_key || this.local.key);
	    if (local_state.minimized == null) {
	      local_state.minimized = true;
	    }
	    has_other_filters = get_participant_attributes().length > 0;
	    opinion_views = fetch('opinion_views');
	    opinion_views_ui = fetch('opinion_views_ui');
	    is_admin = fetch('/current_user').is_admin;
	    show_others = !customization('hide_opinions') || is_admin;
	    show_all_not_available = !show_others;
	    view_buttons = [
	      {
	        key: 'all',
	        label: translator('opinion_views.view_buttons_all', 'All opinions'),
	        callback: function() {
	          return clear_all(local_state);
	        },
	        disabled: !show_others || this.props.disable_switching
	      }, {
	        key: 'you',
	        label: translator('opinion_views.view_buttons_you', 'Just you'),
	        disabled: this.props.disable_switching,
	        callback: function() {
	          clear_all(local_state);
	          return toggle_opinion_filter(just_you_filter);
	        }
	      }, {
	        key: 'custom',
	        label: translator('opinion_views.view_buttons_custom', 'Custom view'),
	        disabled: !show_others || this.props.disable_switching,
	        callback: (function(_this) {
	          return function(item, previous_state) {
	            if (previous_state === 'custom') {
	              if (user_has_set_a_view()) {
	                opinion_views_ui.last_interacted_with = local_state.key || local_state;
	                save(opinion_views_ui);
	                local_state.minimized = !local_state.minimized;
	                return save(local_state);
	              } else {
	                return reset_to_all(local_state);
	              }
	            } else {
	              local_state.minimized = false;
	              return clear_all(local_state);
	            }
	          };
	        })(this),
	        draw_when_active: (function(_this) {
	          return function() {
	            if (local_state.minimized || opinion_views_ui.last_interacted_with !== local_state.key) {
	              if (user_has_set_a_view()) {
	                return DIV({
	                  className: 'custom_view_triangle',
	                  style: {
	                    left: "calc(50% - 12px)",
	                    bottom: -5,
	                    width: 0,
	                    height: 0,
	                    borderLeft: '12px solid transparent',
	                    borderRight: '12px solid transparent',
	                    borderTop: "7px solid " + focus_blue
	                  }
	                });
	              }
	            } else {
	              return DIV({
	                className: 'custom_view_triangle',
	                style: {
	                  left: "calc(50% - 15px)",
	                  bottom: -29
	                },
	                dangerouslySetInnerHTML: {
	                  __html: "<svg width=\"25px\" height=\"13px\" viewBox=\"0 0 25 13\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Artboard\" transform=\"translate(-1086.000000, -586.000000)\" fill=\"#FFFFFF\" stroke=\"rgb(182,182,182)\"><polyline id=\"Path\" points=\"1087 599 1098.5 586 1110 599\"></polyline></g></g></svg>"
	                }
	              });
	            }
	          };
	        })(this)
	      }
	    ];
	    reset_to_default_view = function(force_all) {
	      var attribute, attributes, dfault, j, key, len, ref, ref1, v, vals, weight_key, weights;
	      clear_all(local_state);
	      dfault = customization('opinion_views_default');
	      if (!show_others || ((dfault != null ? dfault.active : void 0) === 'you' && !force_all)) {
	        toggle_opinion_filter(just_you_filter);
	        opinion_views_ui.active = 'you';
	      } else if (dfault && !force_all) {
	        opinion_views_ui.active = 'custom';
	        attributes = get_participant_attributes_with_defaults();
	        if (dfault.visible_attribute_values != null) {
	          ref = dfault.visible_attribute_values;
	          for (key in ref) {
	            vals = ref[key];
	            if (Object.keys(vals).length === 0) {
	              continue;
	            }
	            attribute = attributes.find(function(attr) {
	              return (attr != null ? attr.key : void 0) === key;
	            });
	            opinion_views_ui.visible_attribute_values[attribute.key] = vals;
	            opinion_views_ui.activated_attributes[attribute.key] = true;
	            construct_view_for_attribute(attribute);
	          }
	        }
	        if (dfault.group_by) {
	          attribute = attributes.find(function(attr) {
	            return (attr != null ? attr.key : void 0) === dfault.group_by;
	          });
	          set_group_by_attribute(attribute);
	        }
	        if (dfault.weights) {
	          weights = get_weights();
	          ref1 = dfault.weights;
	          for (j = 0, len = ref1.length; j < len; j++) {
	            weight_key = ref1[j];
	            v = weights.find(function(w) {
	              return w.key === weight_key;
	            });
	            if (v) {
	              toggle_weight(v);
	            }
	          }
	        }
	      } else {
	        opinion_views_ui.active = 'all';
	      }
	      return save(opinion_views_ui);
	    };
	    if (!opinion_views_ui.initialized) {
	      reset_to_default_view();
	      opinion_views_ui.initialized = true;
	      save(opinion_views_ui);
	    }
	    return DIV({
	      style: this.props.style || {},
	      className: 'filter_opinions_to'
	    }, DIV({
	      style: {
	        marginTop: 0,
	        lineHeight: 1
	      }
	    }, customization('verification-by-pic') ? VerificationProcessExplanation() : void 0, SPAN({
	      style: {
	        position: 'relative'
	      }
	    }, ToggleButtons(view_buttons, opinion_views_ui), SPAN({
	      style: {
	        position: 'absolute',
	        left: '100%',
	        top: 0
	      }
	    }, this.MinimizeExpandButton()))));
	  },
	  MinimizeExpandButton: function() {
	    var local_state, opinion_views_ui, toggle_expanded;
	    opinion_views_ui = fetch('opinion_views_ui');
	    if (!user_has_set_a_view() || opinion_views_ui.active !== 'custom') {
	      return SPAN(null);
	    }
	    local_state = fetch(this.props.ui_key || this.local.key);
	    toggle_expanded = (function(_this) {
	      return function(e) {
	        opinion_views_ui.last_interacted_with = local_state.key || local_state;
	        save(opinion_views_ui);
	        local_state.minimized = !local_state.minimized;
	        return save(local_state);
	      };
	    })(this);
	    return DIV(null, BUTTON({
	      className: 'like_link',
	      onClick: toggle_expanded,
	      style: {
	        fontSize: 12,
	        color: "#868686",
	        whiteSpace: 'nowrap',
	        marginLeft: 4
	      }
	    }, local_state.minimized ? translator('opinion_views.minimize_configure', 'configure view') : translator('opinion_views.minimize_minimize', 'minimize')));
	  }
	});
	
	get_participant_attributes_with_defaults = function() {
	  var attributes;
	  attributes = get_participant_attributes();
	  attributes.unshift({
	    key: 'date',
	    icon: date_icon,
	    name: translator('opinion_views.views_date', 'Date'),
	    render: DateFilters
	  });
	  return attributes;
	};
	
	toggle_attribute_visibility = function(attribute) {
	  var date_toggle_state, opinion_views, opinion_views_ui;
	  opinion_views = fetch('opinion_views');
	  opinion_views_ui = fetch('opinion_views_ui');
	  opinion_views_ui.activated_attributes[attribute.key] = !opinion_views_ui.activated_attributes[attribute.key];
	  if (!opinion_views_ui.activated_attributes[attribute.key] && opinion_views_ui.group_by === attribute.key) {
	    toggle_group(opinion_views.active_views.group_by);
	    opinion_views_ui.group_by = null;
	  }
	  opinion_views_ui.visible_attribute_values[attribute.key] = {};
	  save(opinion_views_ui);
	  if (attribute.key === 'date') {
	    date_toggle_state = fetch('opinion-date-filter');
	    date_toggle_state.active = null;
	    save(date_toggle_state);
	  }
	  if (attribute.key in opinion_views.active_views) {
	    delete opinion_views.active_views[attribute.key];
	    return save(opinion_views);
	  }
	};
	
	window.attribute_passes = function(u, attribute, passing_vals) {
	  var is_array, j, len, passes, passing_val, user, val, val_for_user;
	  user = fetch(u);
	  if (!user.tags) {
	    return false;
	  }
	  val_for_user = user.tags[attribute.key];
	  if (attribute.input_type === 'checklist' && val_for_user) {
	    val_for_user = val_for_user.split(CHECKLIST_SEPARATOR);
	    is_array = true;
	  }
	  passes = false;
	  for (j = 0, len = passing_vals.length; j < len; j++) {
	    passing_val = passing_vals[j];
	    if (attribute.pass) {
	      val = attribute.pass(u);
	      passes || (passes = passing_val === val);
	      if (passing_val === 'true') {
	        passes || (passes = true === val);
	      } else if (passing_val === 'false') {
	        passes || (passes = false === val);
	        passes || (passes = void 0 === val);
	      }
	    } else {
	      passes || (passes = val_for_user === passing_val || (is_array && indexOf.call(val_for_user, passing_val) >= 0));
	    }
	  }
	  return passes;
	};
	
	construct_view_for_attribute = function(attribute) {
	  var attr_key, enabled, has_one_enabled, opinion_views_ui, pass, ref, val, view;
	  opinion_views_ui = fetch('opinion_views_ui');
	  attr_key = attribute.key;
	  has_one_enabled = false;
	  ref = opinion_views_ui.visible_attribute_values[attr_key];
	  for (val in ref) {
	    enabled = ref[val];
	    has_one_enabled || (has_one_enabled = enabled);
	  }
	  if (!has_one_enabled) {
	    opinion_views_ui.visible_attribute_values[attr_key] = {};
	  }
	  pass = function(u) {
	    var passing_vals;
	    passing_vals = (function() {
	      var ref1, results;
	      ref1 = opinion_views_ui.visible_attribute_values[attr_key];
	      results = [];
	      for (val in ref1) {
	        enabled = ref1[val];
	        if (enabled) {
	          results.push(val);
	        }
	      }
	      return results;
	    })();
	    if (indexOf.call(passing_vals, 'either') >= 0) {
	      passing_vals.push('true');
	      passing_vals.push('false');
	    }
	    return attribute_passes(u, attribute, passing_vals);
	  };
	  view = {
	    key: attr_key,
	    salience: function(u) {
	      if (pass(u)) {
	        return 1;
	      } else {
	        return .1;
	      }
	    },
	    weight: function(u) {
	      if (pass(u)) {
	        return 1;
	      } else {
	        return .1;
	      }
	    },
	    options: attribute.options
	  };
	  return toggle_opinion_filter(view, has_one_enabled);
	};
	
	set_group_by_attribute = function(attribute) {
	  var opinion_views_ui, view;
	  opinion_views_ui = fetch('opinion_views_ui');
	  opinion_views_ui.group_by = attribute.key;
	  save(opinion_views_ui);
	  view = {
	    key: 'group_by',
	    name: attribute.name,
	    continuous_value: attribute.continuous_value,
	    group: function(u, opinion, proposal) {
	      var group_val, vals;
	      group_val = (attribute.pass ? attribute.pass(u) : fetch(u).tags[opinion_views_ui.group_by]) || i18n().unreported;
	      if (attribute.input_type === 'checklist') {
	        return vals = group_val.split(CHECKLIST_SEPARATOR).filter(function(i) {
	          return i.length > 0;
	        });
	      } else {
	        return group_val;
	      }
	    },
	    options: attribute.options
	  };
	  return toggle_group(view, true);
	};
	
	styles += ".opinion_view_interaction_wrapper {\n  max-height: 0;\n  overflow-y: hidden;\n  transition: max-height 0.5s;\n}\n.opinion_view_interaction_wrapper.showing_custom {\n  max-height: 1200px;\n}\n";
	
	window.OpinionViewInteractionWrapper = ReactiveComponent({
	  displayName: 'OpinionViewInteractionWrapper',
	  render: function() {
	    var local_state, opinion_views_ui, width;
	    opinion_views_ui = fetch('opinion_views_ui');
	    local_state = fetch(this.props.ui_key || this.local);
	    return DIV({
	      className: "opinion_view_interaction_wrapper " + (opinion_views_ui.active === 'custom' && (opinion_views_ui.last_interacted_with === local_state.key || local_state.minimized) ? 'showing_custom' : '')
	    }, opinion_views_ui.active === 'custom' ? (width = this.props.width, DIV({
	      style: {
	        position: 'relative'
	      }
	    }, local_state.minimized || opinion_views_ui.last_interacted_with !== local_state.key ? DIV({
	      style: {
	        marginTop: 0
	      }
	    }, NonInteractiveOpinionViews({
	      ui_key: this.props.ui_key,
	      more_views_positioning: this.props.more_views_positioning
	    })) : DIV({
	      style: {
	        display: 'flex',
	        justifyContent: this.props.more_views_positioning === 'left' ? 'flex-start' : this.props.more_views_positioning === 'centered' ? 'center' : 'flex-end'
	      }
	    }, DIV({
	      style: {
	        border: '1px solid #B6B6B6',
	        borderRadius: 8,
	        width: 'fit-content',
	        maxWidth: width ? width : void 0
	      }
	    }, DIV({
	      style: {
	        padding: '0px 24px'
	      }
	    }, InteractiveOpinionViews({
	      ui_key: this.props.ui_key
	    })))))) : void 0);
	  }
	});
	
	InteractiveOpinionViews = ReactiveComponent({
	  displayName: 'InteractiveOpinionViews',
	  render: function() {
	    var activated_weights, active_filters, all_groups, attr, attribute, attributes, base, cnt, cur_val, group_colors, idx, j, k, len, name1, opinion_views, opinion_views_ui, ref, v, weight;
	    opinion_views = fetch('opinion_views');
	    opinion_views_ui = fetch('opinion_views_ui');
	    attributes = get_participant_attributes_with_defaults();
	    active_filters = {};
	    ref = opinion_views.active_views;
	    for (k in ref) {
	      v = ref[k];
	      if (v.view_type === 'filter') {
	        active_filters[k] = v;
	      }
	    }
	    for (cnt = j = 0, len = attributes.length; j < len; cnt = ++j) {
	      attribute = attributes[cnt];
	      if ((base = opinion_views_ui.visible_attribute_values)[name1 = attribute.key] == null) {
	        base[name1] = {};
	      }
	    }
	    if (opinion_views_ui.group_by) {
	      all_groups = opinion_views.active_views.group_by.options;
	      group_colors = get_color_for_groups(all_groups);
	    }
	    activated_weights = get_activated_weights();
	    return DIV(null, (function() {
	      var l, len1;
	      if (attributes.length > 1) {
	        cur_val = -1;
	        for (idx = l = 0, len1 = attributes.length; l < len1; idx = ++l) {
	          attr = attributes[idx];
	          if (opinion_views_ui.group_by === attr.key) {
	            cur_val = idx;
	          }
	        }
	        return DIV({
	          className: 'opinion_view_row color_code',
	          style: {
	            borderTop: '1px dotted #DEDDDD'
	          }
	        }, group_by_icon(), LABEL({
	          className: 'opinion_view_name'
	        }, translator('opinion_views.view_type_group', 'Color code by'), ':'), SELECT({
	          style: {
	            maxWidth: '75%',
	            marginRight: 12,
	            borderColor: '#bbb',
	            backgroundColor: '#f9f9f9',
	            borderRadius: 2
	          },
	          onChange: function(ev) {
	            var len2, m, o, option, ref1, val;
	            if (ev.target.value !== null) {
	              attribute = attributes[ev.target.value];
	              opinion_views_ui.group_by = attribute != null ? attribute.key : void 0;
	            } else {
	              opinion_views_ui.group_by = null;
	            }
	            if (opinion_views_ui.group_by && (!opinion_views_ui.activated_attributes[opinion_views_ui.group_by] || ((function() {
	              var ref1, results;
	              ref1 = opinion_views_ui.visible_attribute_values[opinion_views_ui.group_by];
	              results = [];
	              for (o in ref1) {
	                val = ref1[o];
	                if (val) {
	                  results.push(o);
	                }
	              }
	              return results;
	            })()).length === 0)) {
	              opinion_views_ui.activated_attributes[opinion_views_ui.group_by] = true;
	              ref1 = attribute.options;
	              for (m = 0, len2 = ref1.length; m < len2; m++) {
	                option = ref1[m];
	                opinion_views_ui.visible_attribute_values[attribute.key][option] = true;
	              }
	            }
	            save(opinion_views_ui);
	            if (opinion_views_ui.group_by) {
	              return set_group_by_attribute(attribute);
	            } else {
	              delete opinion_views.active_views.group_by;
	              return save(opinion_views);
	            }
	          },
	          value: cur_val
	        }, OPTION({
	          value: null
	        }, ""), (function() {
	          var len2, m, results;
	          results = [];
	          for (idx = m = 0, len2 = attributes.length; m < len2; idx = ++m) {
	            attribute = attributes[idx];
	            if (!attribute.options) {
	              continue;
	            }
	            results.push((function(_this) {
	              return function(attribute) {
	                return OPTION({
	                  key: idx,
	                  value: idx
	                }, attribute.name || attribute.question);
	              };
	            })(this)(attribute));
	          }
	          return results;
	        }).call(this)), cur_val > -1 ? LABEL({
	          className: "attribute_value_selector",
	          "data-tooltip": "Instead of showing each individual person in a histogram, show a circle \nfor each value of " + (attributes[cur_val].name || attributes[cur_val].question) + ". \nThe position on the histogram is the average score for all the people with \nthat value, and the size of the circle is the number of people with that value."
	        }, SPAN({
	          className: 'toggle_switch'
	        }, INPUT({
	          type: 'checkbox',
	          checked: opinion_views_ui.aggregate_into_groups,
	          onChange: function(e) {
	            opinion_views_ui.aggregate_into_groups = !opinion_views_ui.aggregate_into_groups;
	            return save(opinion_views_ui);
	          }
	        }), SPAN({
	          className: 'toggle_switch_circle',
	          style: {
	            backgroundColor: opinion_views_ui.aggregate_into_groups ? focus_color() : void 0
	          }
	        })), SPAN({
	          style: {
	            fontSize: 14,
	            paddingLeft: 12
	          }
	        }, "Aggregate by Group")) : void 0);
	      }
	    }).call(this), attributes.length > 0 ? DIV({
	      className: 'opinion_view_row'
	    }, filter_icon(), LABEL({
	      className: 'opinion_view_name'
	    }, translator('opinion_views.view_type_filter', 'Narrow by'), ':'), UL({
	      style: {
	        listStyle: 'none'
	      }
	    }, (function() {
	      var l, len1, results;
	      results = [];
	      for (cnt = l = 0, len1 = attributes.length; l < len1; cnt = ++l) {
	        attribute = attributes[cnt];
	        results.push((function(attribute) {
	          var attr_name, shortened;
	          attr_name = attribute.name;
	          shortened = false;
	          if (attr_name.length > 40) {
	            attr_name = (attr_name.substring(0, 37)) + "...";
	            shortened = true;
	          }
	          return LI({
	            key: attr_name,
	            style: {
	              display: 'inline-block'
	            }
	          }, BUTTON({
	            "data-attribute": attr_name,
	            title: shortened ? attribute.name : void 0,
	            className: "filter opinion_view_button " + (opinion_views_ui.activated_attributes[attribute.key] ? 'active' : ''),
	            onClick: function() {
	              return toggle_attribute_visibility(attribute);
	            }
	          }, attribute.icon ? SPAN({
	            style: {
	              position: 'relative',
	              top: 2,
	              marginRight: 7
	            }
	          }, typeof attribute.icon === "function" ? attribute.icon(opinion_views_ui.activated_attributes[attribute.key]) : void 0) : void 0, attr_name));
	        })(attribute));
	      }
	      return results;
	    })())) : void 0, (function() {
	      var l, len1, results;
	      results = [];
	      for (cnt = l = 0, len1 = attributes.length; l < len1; cnt = ++l) {
	        attribute = attributes[cnt];
	        if (!opinion_views_ui.activated_attributes[attribute.key]) {
	          continue;
	        }
	        results.push((function(_this) {
	          return function(attribute) {
	            var checked, is_grouped, options, shortened, true_false, val, val_name;
	            return DIV({
	              key: attribute.key,
	              className: 'attribute_wrapper'
	            }, DIV({
	              className: 'attribute_group'
	            }, DIV({
	              className: 'attribute_name'
	            }, "" + attribute.name), attribute.render ? attribute.render() : (is_grouped = opinion_views_ui.group_by === attribute.key, true_false = !is_grouped && indexOf.call(attribute.options, true) >= 0 && indexOf.call(attribute.options, false) >= 0 && attribute.options.length === 2, true_false ? options = ['true', 'false', 'either'] : options = attribute.options, UL(null, (function() {
	              var len2, m, results1;
	              results1 = [];
	              for (m = 0, len2 = options.length; m < len2; m++) {
	                val = options[m];
	                if (true_false && opinion_views_ui.visible_attribute_values[attribute.key]['true'] && opinion_views_ui.visible_attribute_values[attribute.key]['false']) {
	                  checked = val === 'either';
	                } else {
	                  checked = !!opinion_views_ui.visible_attribute_values[attribute.key][val];
	                }
	                val_name = "" + val;
	                shortened = false;
	                if (val_name.length > 25) {
	                  val_name = (val_name.substring(0, 22)) + "...";
	                  shortened = true;
	                }
	                results1.push((function(_this) {
	                  return function(val) {
	                    return LI({
	                      key: val + ":" + attribute.name,
	                      "data-attribute": attribute.name,
	                      "data-value": val,
	                      style: {
	                        display: 'inline-block'
	                      }
	                    }, LABEL({
	                      className: "attribute_value_selector",
	                      title: shortened ? val : void 0
	                    }, SPAN({
	                      className: is_grouped ? 'toggle_switch' : ''
	                    }, INPUT({
	                      type: true_false ? 'radio' : 'checkbox',
	                      value: val,
	                      checked: checked,
	                      onChange: function(e) {
	                        if (true_false) {
	                          opinion_views_ui.visible_attribute_values[attribute.key][true] = false;
	                          opinion_views_ui.visible_attribute_values[attribute.key][false] = false;
	                          opinion_views_ui.visible_attribute_values[attribute.key]["either"] = false;
	                        }
	                        opinion_views_ui.visible_attribute_values[attribute.key][val] = e.target.checked;
	                        save(opinion_views_ui);
	                        return construct_view_for_attribute(attribute);
	                      }
	                    }), is_grouped ? SPAN({
	                      className: 'toggle_switch_circle',
	                      style: {
	                        backgroundColor: checked ? group_colors[val] : void 0
	                      }
	                    }) : void 0), SPAN({
	                      className: 'attribute_value_value',
	                      dangerouslySetInnerHTML: {
	                        __html: val_name
	                      }
	                    })));
	                  };
	                })(this)(val));
	              }
	              return results1;
	            }).call(_this)))), BUTTON({
	              className: 'attribute_close',
	              onClick: function() {
	                return toggle_attribute_visibility(attribute);
	              }
	            }, 'x'));
	          };
	        })(this)(attribute));
	      }
	      return results;
	    }).call(this), DIV({
	      className: 'opinion_view_row',
	      style: {
	        borderTop: '1px dotted #DEDDDD'
	      }
	    }, weigh_icon(), LABEL({
	      className: 'opinion_view_name'
	    }, translator('opinion_views.view_type_weigh', 'Weigh by'), ':'), UL({
	      style: {
	        listStyle: 'none'
	      }
	    }, (function() {
	      var l, len1, ref1, results;
	      ref1 = get_weights();
	      results = [];
	      for (l = 0, len1 = ref1.length; l < len1; l++) {
	        weight = ref1[l];
	        results.push((function(weight) {
	          return LI({
	            key: weight.key,
	            style: {
	              marginRight: 8,
	              marginBottom: 1,
	              display: 'inline-block'
	            },
	            'data-key': weight.key
	          }, BUTTON({
	            className: "weight opinion_view_button " + (activated_weights[weight.key] ? 'active' : ''),
	            "data-tooltip": weight.label,
	            onClick: function(e) {
	              toggle_weight(weight);
	              return e.stopPropagation();
	            }
	          }, weight.icon ? weight.icon(activated_weights[weight.key] ? 'white' : void 0) : void 0, SPAN({
	            style: {
	              paddingLeft: weight.icon ? 10 : void 0
	            }
	          }, weight.name)));
	        })(weight));
	      }
	      return results;
	    })())));
	  }
	});
	
	get_activated_weights = function() {
	  var activated_weights, k, opinion_views, ref, v;
	  opinion_views = fetch('opinion_views');
	  activated_weights = {};
	  ref = opinion_views.active_views;
	  for (k in ref) {
	    v = ref[k];
	    if (v.view_type === 'weight') {
	      activated_weights[k] = v;
	    }
	  }
	  return activated_weights;
	};
	
	NonInteractiveOpinionViews = ReactiveComponent({
	  displayName: 'NonInteractiveOpinionViews',
	  render: function() {
	    var activated_weights, attribute, attributes, checked, checked_string, cnt, date_toggle_state, filter_str, idx, is_grouped, j, l, label, len, len1, len2, len3, len4, len5, m, mini, minimized_views, n, opinion_views, opinion_views_ui, p, q, ref, ref1, ref2, unchecked, unchecked_string, val, weight;
	    minimized_views = [];
	    opinion_views = fetch('opinion_views');
	    opinion_views_ui = fetch('opinion_views_ui');
	    attributes = get_participant_attributes_with_defaults();
	    for (cnt = j = 0, len = attributes.length; j < len; cnt = ++j) {
	      attribute = attributes[cnt];
	      if (!opinion_views_ui.activated_attributes[attribute.key]) {
	        continue;
	      }
	      is_grouped = opinion_views_ui.group_by === attribute.key;
	      label = null;
	      checked = [];
	      unchecked = [];
	      if (attribute.key === 'date') {
	        date_toggle_state = fetch('opinion-date-filter');
	        if (!opinion_views.active_views['date'] || date_toggle_state.active === 'all' || (date_toggle_state.active === 'custom' && !date_toggle_state.start && !date_toggle_state.end)) {
	          continue;
	        }
	        if (date_toggle_state.active === 'custom') {
	          if (!date_toggle_state.start) {
	            filter_str = translator({
	              id: "opinion_views.date_up_to",
	              date: to_date_str(date_toggle_state.end)
	            }, "up to {date}");
	          } else if (!date_toggle_state.end) {
	            filter_str = translator({
	              id: "opinion_views.date_after",
	              date: to_date_str(date_toggle_state.start)
	            }, "after {date}");
	          } else {
	            filter_str = (to_date_str(date_toggle_state.start)) + " - " + (to_date_str(date_toggle_state.end));
	          }
	        } else {
	          filter_str = default_date_options().find(function(o) {
	            return o.key === date_toggle_state.active;
	          }).label;
	        }
	      } else if (attribute.input === 'boolean' || (attribute.options.length === 2 && ['yes', true, 'true', 'no', false, 'false'].filter(function(val) {
	        return attribute.options.includes(val);
	      }).length === 2)) {
	        ref = attribute.options;
	        for (l = 0, len1 = ref.length; l < len1; l++) {
	          val = ref[l];
	          if (!!opinion_views_ui.visible_attribute_values[attribute.key][val]) {
	            if (val === 'yes' || val === true || val === 'true') {
	              label = translator({
	                id: "opinion_views.narrow_to",
	                filter_string: ""
	              }, "Narrowed to {filter_string}");
	            } else {
	              label = translator({
	                id: "opinion_views.filter_out",
	                filter_string: ""
	              }, "Excluding {filter_string}");
	            }
	            break;
	          }
	        }
	        filter_str = null;
	      } else {
	        ref1 = attribute.options;
	        for (m = 0, len2 = ref1.length; m < len2; m++) {
	          val = ref1[m];
	          if (!!opinion_views_ui.visible_attribute_values[attribute.key][val]) {
	            checked.push(val);
	          } else {
	            unchecked.push(val);
	          }
	        }
	        if (!is_grouped && (checked.length === 0 || checked.length === attribute.options.length)) {
	          continue;
	        }
	        checked_string = "";
	        unchecked_string = "";
	        for (idx = n = 0, len3 = checked.length; n < len3; idx = ++n) {
	          val = checked[idx];
	          if (val.length > 25) {
	            val = (val.substring(0, 22)) + "...";
	          }
	          if (idx === checked.length - 1 && checked.length > 1) {
	            checked_string += ' and ';
	          }
	          checked_string += "&ldquo;" + val + "&rdquo;";
	          if (idx !== checked.length - 1 && checked.length > 2) {
	            checked_string += ', ';
	          }
	        }
	        for (idx = p = 0, len4 = unchecked.length; p < len4; idx = ++p) {
	          val = unchecked[idx];
	          if (val.length > 25) {
	            val = (val.substring(0, 22)) + "...";
	          }
	          if (idx === unchecked.length - 1 && unchecked.length > 1) {
	            unchecked_string += ' and ';
	          }
	          unchecked_string += "&ldquo;" + val + "&rdquo;";
	          if (idx !== unchecked.length - 1 && unchecked.length > 2) {
	            unchecked_string += ', ';
	          }
	        }
	        if (unchecked_string.length < checked_string.length) {
	          filter_str = unchecked_string;
	          if (unchecked_string.length > 0) {
	            filter_str = translator({
	              id: "opinion_views.filter_out",
	              filter_string: filter_str
	            }, "Excluding {filter_string}");
	          }
	        } else {
	          filter_str = checked_string;
	          if (checked_string.length > 0) {
	            filter_str = translator({
	              id: "opinion_views.narrow_to",
	              filter_string: filter_str
	            }, "Narrowed to {filter_string}");
	          }
	        }
	      }
	      minimized_views.push({
	        name: attribute.name,
	        label: label,
	        icon: is_grouped ? group_by_icon : void 0,
	        filters: filter_str,
	        toggle: (function(attribute, is_grouped) {
	          return function() {
	            if (is_grouped) {
	              delete opinion_views_ui.group_by;
	              save(opinion_views_ui);
	              toggle_group(opinion_views.active_views.group_by, false);
	            }
	            return toggle_attribute_visibility(attribute);
	          };
	        })(attribute, is_grouped)
	      });
	    }
	    activated_weights = get_activated_weights();
	    ref2 = get_weights();
	    for (q = 0, len5 = ref2.length; q < len5; q++) {
	      weight = ref2[q];
	      if (!activated_weights[weight.key]) {
	        continue;
	      }
	      minimized_views.push({
	        name: weight.name,
	        label: translator('opinion_views.mini_weigh', 'Weighing by'),
	        toggle: (function(weight) {
	          return function() {
	            return toggle_weight(weight);
	          };
	        })(weight)
	      });
	    }
	    return UL({
	      className: 'minimized_view_list',
	      style: {
	        width: this.props.more_views_positioning === 'centered' ? 'fit-content' : void 0,
	        textAlign: this.props.more_views_positioning === 'left' ? 'left' : 'right'
	      }
	    }, (function() {
	      var len6, r, results;
	      results = [];
	      for (r = 0, len6 = minimized_views.length; r < len6; r++) {
	        mini = minimized_views[r];
	        results.push((function(_this) {
	          return function(mini) {
	            return LI({
	              key: mini.name,
	              className: 'minimized_view_wrapper'
	            }, SPAN({
	              className: "minimized_view"
	            }, typeof mini.icon === "function" ? mini.icon(16) : void 0, mini.label, SPAN({
	              className: "minimized_view_name",
	              style: {
	                paddingLeft: 4
	              }
	            }, mini.name, mini.filters ? ": " : void 0), mini.filters ? SPAN({
	              style: {
	                paddingLeft: 4
	              },
	              dangerouslySetInnerHTML: {
	                __html: mini.filters
	              }
	            }) : void 0, BUTTON({
	              className: "minimized_view_close",
	              onClick: function() {
	                var local_state;
	                local_state = fetch(_this.props.ui_key || _this.local);
	                mini.toggle();
	                if (!user_has_set_a_view()) {
	                  return reset_to_all(local_state);
	                }
	              }
	            }, 'x')));
	          };
	        })(this)(mini));
	      }
	      return results;
	    }).call(this));
	  }
	});
	
	VerificationProcessExplanation = ReactiveComponent({
	  displayName: 'VerificationProcessExplanation',
	  render: function() {
	    var callout, para, user, users;
	    users = fetch('/users');
	    callout = "about verification";
	    return DIV({
	      style: {
	        position: 'absolute',
	        right: -sizeWhenRendered(callout, {
	          fontSize: 12
	        }).width,
	        top: -14
	      }
	    }, SPAN({
	      style: {
	        color: "#aaa",
	        fontSize: 14
	      }
	    }, SPAN({
	      style: {
	        textDecoration: 'underline',
	        cursor: 'pointer',
	        color: this.local.describe_process ? logo_red : void 0
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.describe_process = !_this.local.describe_process;
	          return save(_this.local);
	        };
	      })(this)
	    }, callout)), this.local.describe_process ? (para = {
	      marginBottom: 20
	    }, DIV({
	      style: {
	        textAlign: 'left',
	        position: 'absolute',
	        right: 0,
	        top: 40,
	        width: 650,
	        zIndex: 999,
	        padding: "20px 40px",
	        backgroundColor: '#eee',
	        fontSize: 18
	      }
	    }, SPAN({
	      style: cssTriangle('top', '#eee', 16, 8, {
	        position: 'absolute',
	        right: 50,
	        top: -8
	      })
	    }), DIV({
	      style: para
	    }, "Filters help us understand the opinions of the stakeholder groups. Filters are conjunctive: only users that pass all active filters are shown.\nThese are the filters:"), DIV({
	      style: para
	    }, SPAN({
	      style: {
	        fontWeight: 700
	      }
	    }, 'Users'), ". Verified users have emailed us a verification image to validate their account.  \nWe have also verified a few other people via other media channels, like Reddit. ", SPAN({
	      style: {
	        fontStyle: 'italic'
	      }
	    }, "Verification results shown below.")), DIV({
	      style: para
	    }, SPAN({
	      style: {
	        fontWeight: 700
	      }
	    }, 'Miners'), ". Miners are ", OL({
	      style: {
	        marginLeft: 20
	      }
	    }, LI(null, 'Users who control a mining pool with > 1% amount of hashrate'), LI(null, 'Users who control > 1% amount of hashrate')), 'We verify hashrate by consulting ', A({
	      href: 'https://blockchain.info/pools',
	      target: '_blank',
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'https://blockchain.info/pools'), '.'), DIV({
	      style: para
	    }, SPAN({
	      style: {
	        fontWeight: 700
	      }
	    }, 'Developers'), ". Bitcoin developers self-report by editing their user profile. If we recognize \nsomeone as a committer or maintainer of Core or XT, we assign it. \nWe aren’t satisfied by our criteria for developer. We hope to work with \nthe community to define a more robust standard for 'reputable technical voice'."), DIV({
	      style: para
	    }, SPAN({
	      style: {
	        fontWeight: 700
	      }
	    }, 'Businesses'), ". Bitcoin businesses self-report by editing their user profile. Business accounts\nare either users who operate the business or an account that will represent that \nbusinesses' official position."), DIV({
	      style: para
	    }, "These filters aren’t perfect. If you think there is a problem, email us at ", A({
	      href: "mailto:admin@consider.it",
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'admin@consider.it'), ". We will try to make a more trustless process in the future."), DIV({
	      style: {}
	    }, DIV({
	      style: {
	        fontWeight: 600,
	        fontSize: 26
	      }
	    }, 'Verification status'), (function() {
	      var j, len, ref, ref1, ref2, results;
	      ref = users.users;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        user = ref[j];
	        user = fetch(user);
	        if (user.tags.verified && ((ref1 = user.tags.verified.toLowerCase()) !== 'no' && ref1 !== 'false')) {
	          results.push(DIV({
	            style: {
	              marginTop: 20
	            }
	          }, DIV({
	            style: {
	              fontWeight: 600
	            }
	          }, user.name), ((ref2 = user.tags.verified) != null ? ref2.indexOf('http') : void 0) === 0 ? IMG({
	            src: user.tags.verified,
	            style: {
	              width: 400
	            }
	          }) : DIV({
	            style: {
	              fontStyle: 'italic'
	            }
	          }, user.tags.verified)));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    })()))) : void 0);
	  }
	});
	
	styles += "\nbutton.opinion_view_button {\n  border: 1px solid #E0E0E0;\n  border-bottom-color: #aaa;\n  background-color: #F0F0F0;\n  // box-shadow: inset 0 -1px 1px 0 rgba(0,0,0,0.62);\n  border-radius: 8px;    \n  font-size: 12px;\n  color: #000000;\n  font-weight: 400;\n}\nbutton.opinion_view_button.filter {\n  padding: 4px 12px;\n  margin: 0 8px 8px 0;\n\n}\nbutton.opinion_view_button.weight {\n  width: 100%;\n  display: flex;\n  padding: 4px 4px 4px 12px;\n  text-align: left;\n  align-items: center;\n  margin-right: 12px;\n\n}\n\nbutton.opinion_view_button.active {\n  background-color: " + focus_blue + ";\n  color: white;\n  border-color: " + focus_blue + ";\n}\n\n\n.opinion_view_row {\n  padding: 16px 0px;\n  display: flex;\n} \nsvg.opinion_view_class {\n  display: block; \n  margin-right: 18px;\n  flex-shrink: 0;\n}\n.minimized_view .svg.opinion_view_class{\n  margin-right: 4px;\n}\n\n.opinion_view_name {\n  margin-right: 18px;    \n  font-weight: 600;\n  font-size: 16px;\n  white-space: nowrap;\n}\n\n.attribute_wrapper {\n  display: flex;    \n  margin-bottom: 8px;\n}\n\n.attribute_group {\n  border-radius: 8px;    \n  padding: 8px 16px;\n}\n\n.attribute_group {\n  margin-left: 50px;\n  width: 100%;\n  background-color: #F3F3F3;  \n  display: flex;  \n  align-items: center;      \n}\n\n.attribute_name {\n  font-weight: 600;\n  font-size: 12px;\n  text-align: right;   \n  width: 100px;\n  padding-right: 16px; \n}\n.attribute_close, .minimized_view_close {\n  font-size: 13px;\n  color: #000000;\n  background-color: transparent;\n  border: none;\n}\n.custom_view_triangle {\n  position: absolute;\n  z-index: 1;\n}\n\n.minimized_view_close {\n  margin-top: 1px;\n  margin-left: 22px;\n  color: " + (focus_color()) + ";\n\n}\n.minimized_view_list {\n  list-style: none;\n  margin: auto;\n}\n.minimized_view_wrapper {\n  margin-bottom: 4px;\n  font-size: 12px; \n  position: relative;   \n}\nli.minimized_view_wrapper:not(:first-child) {\n  margin-left: 24px;    \n}\n\n.minimized_view {\n  color: " + focus_blue + ";\n  /* border: 1px solid #2478cc; */\n  background-color: #e9edfb;\n  width: fit-content;\n  position: relative;\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 8px;\n  min-width: 200px;\n}\n.minimized_view_name {\n  font-weight: 700;\n}\n\n.minimized_view svg.opinion_view_class {\n  display: inline;\n  position: relative;\n  top: 3px;\n  height: 12px;\n}\n\n.attribute_value_selector {\n  display: flex; \n  align-items: center;\n  cursor: pointer;\n  margin-right: 18px;\n}\n\n.attribute_value_selector > span {\n  display: flex; \n  align-items: center;\n}\n.attribute_value_selector input {\n\n}\n.attribute_value_selector .attribute_value_value {\n  padding-left: 8px;\n  font-size: 12px;\n  font-weight: 400;\n  text-transform: capitalize; \n}\n\n.opinion-date-filter {\n  display: inline-block;\n  margin-top: 8px;\n}\n.opinion-date-filter label {\n  padding: 0 8px 0 18px;\n  color: #666;\n  font-size: 12px;\n}\n\n.opinion-date-filter input {\n  font-size: 12px;\n  width: 128px;\n}\n";
	
	styles += ".toggle_buttons {\n  position: relative;\n  list-style: none;\n  margin: auto;\n  text-align: center;\n  white-space: nowrap;\n}\n.toggle_buttons li {\n  display: inline-block;\n  position: relative;\n}\n[data-widget=\"DropMenu\"].bluedrop button.dropMenu-anchor {\n  border-radius: 8px;\n}\n[data-widget=\"DropMenu\"].bluedrop button.dropMenu-anchor, .toggle_buttons button {\n  background-color: white;\n  color: " + focus_blue + ";\n  font-weight: 600;\n  font-size: 12px;\n  border: 1px solid;\n  border-color: " + focus_blue + ";\n  padding: 4px 16px;\n}  \n.toggle_buttons li:not(:last-child) button {\n  border-right: none;\n}\n.toggle_buttons li:first-child button {\n  border-radius: 8px 0 0 8px;\n}\n.toggle_buttons li:last-child button {\n  border-radius: 0px 8px 8px 0px;\n}\n\n.toggle_buttons li, .toggle_buttons li button {\n  margin: 0;\n}\n\n[data-widget=\"DropMenu\"].bluedrop button.dropMenu-anchor, .toggle_buttons .active button {\n  background-color: " + focus_blue + ";\n  color: white;\n}\n\n.toggle_buttons button[disabled] {\n  opacity: .4;\n  cursor: default;\n}\n\n.grays .toggle_buttons button {\n  color: #444;\n  border-color: #444;\n}\n.grays .toggle_buttons .active button {\n  background-color: #444;\n  color: white;\n}";
	
	window.ToggleButtons = function(items, view_state, style) {
	  var item, ref, ref1, toggle_state, toggled;
	  toggle_state = fetch(view_state);
	  if (toggle_state.active == null) {
	    toggle_state.active = ((ref = items[0]) != null ? ref.key : void 0) || ((ref1 = items[0]) != null ? ref1.label : void 0);
	  }
	  toggled = function(e, item) {
	    var prev;
	    prev = view_state.active;
	    view_state.active = item.key || item.label;
	    save(view_state);
	    return typeof item.callback === "function" ? item.callback(item, prev) : void 0;
	  };
	  return UL({
	    key: 'toggle buttons',
	    className: 'toggle_buttons',
	    style: style || {}
	  }, (function() {
	    var j, len, results;
	    results = [];
	    for (j = 0, len = items.length; j < len; j++) {
	      item = items[j];
	      results.push((function(_this) {
	        return function(item) {
	          var key;
	          key = item.key || item.label;
	          return LI({
	            ref: key,
	            key: key,
	            className: view_state.active === key ? 'active' : void 0,
	            'data-view-state': key
	          }, BUTTON({
	            disabled: item.disabled,
	            onClick: function(e) {
	              return toggled(e, item);
	            }
	          }, item.label), view_state.active === key && item.draw_when_active && !item.disabled ? item.draw_when_active() : void 0);
	        };
	      })(this)(item));
	    }
	    return results;
	  }).call(this));
	};
	
	window.OpinionViews = OpinionViews;
	
	window.passes_running_timelapse_simulation = function(dt) {
	  return (window.running_timelapse_simulation == null) || (new Date(dt).getTime() < window.running_timelapse_simulation);
	};
	
	window.participation_timelapse = function(step, interval) {
	  var change_date, date_options, date_toggle_state, end, filter_out, first, j, l, last, len, len1, o, prop, proposals, ref, ref1, simulator, t, users;
	  filter_out = fetch('filtered');
	  if (interval == null) {
	    interval = 500;
	  }
	  if (step == null) {
	    step = 1 * 60 * 60 * 1000;
	  }
	  proposals = fetch('/proposals');
	  if (!proposals.proposals) {
	    setTimeout(function() {
	      return simulate_participation();
	    }, 100);
	    return;
	  }
	  users = {};
	  last = 0;
	  first = 2e308;
	  ref = proposals.proposals;
	  for (j = 0, len = ref.length; j < len; j++) {
	    prop = ref[j];
	    prop = fetch(prop);
	    ref1 = prop.opinions;
	    for (l = 0, len1 = ref1.length; l < len1; l++) {
	      o = ref1[l];
	      t = new Date(o.created_at || o.updated_at).getTime();
	      if (t > last) {
	        last = t;
	      }
	      if (t < first) {
	        first = t;
	      }
	    }
	  }
	  date_options = default_date_options();
	  date_toggle_state = fetch('opinion-date-filter');
	  change_date = function(end) {
	    date_toggle_state.end = end;
	    save(date_toggle_state);
	    return date_option_changed(date_options[3]);
	  };
	  end = first;
	  return simulator = setInterval(function() {
	    change_date(end);
	    end += step;
	    window.running_timelapse_simulation = end;
	    if (end > last) {
	      clearInterval(simulator);
	      return delete window.running_timelapse_simulation;
	    }
	  }, interval);
	};


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var PHONE_BREAKPOINT, SUPER_NARROW_HEIGHT_BREAK, TABLET_BREAKPOINT, setResponsive;
	
	__webpack_require__(3);
	
	PHONE_BREAKPOINT = 545;
	
	TABLET_BREAKPOINT = 990;
	
	SUPER_NARROW_HEIGHT_BREAK = 150;
	
	window.PHONE_MEDIA = "(max-width: " + PHONE_BREAKPOINT + "px),      (max-height: " + SUPER_NARROW_HEIGHT_BREAK + "px)";
	
	window.TABLET_MEDIA = "(min-width: " + PHONE_BREAKPOINT + "px)   and (max-width:  " + TABLET_BREAKPOINT + "px) and (min-height: " + SUPER_NARROW_HEIGHT_BREAK + "px)";
	
	window.LAPTOP_MEDIA = "(min-width: " + TABLET_BREAKPOINT + "px)  and (min-height: " + SUPER_NARROW_HEIGHT_BREAK + "px)";
	
	window.NOT_LAPTOP_MEDIA = "(max-width: " + TABLET_BREAKPOINT + "px),     (max-height: " + SUPER_NARROW_HEIGHT_BREAK + "px)";
	
	window.NOT_PHONE_MEDIA = "(min-width: " + PHONE_BREAKPOINT + "px)   and (min-height: " + SUPER_NARROW_HEIGHT_BREAK + "px)";
	
	setResponsive = function() {
	  var content_width, doc_gutter, h, homepage_width, i, k, len, needs_save, new_vals, phone_size, portrait, registry, responsive, tablet_size, v, w;
	  responsive = fetch('responsive_vars');
	  w = Math.max(320, document.documentElement.clientWidth);
	  h = window.innerHeight;
	  phone_size = w < PHONE_BREAKPOINT || h < SUPER_NARROW_HEIGHT_BREAK;
	  tablet_size = w < TABLET_BREAKPOINT || phone_size;
	  portrait = h > w;
	  doc_gutter = phone_size ? 16 : tablet_size ? 40 : Math.max(80, .09 * w);
	  content_width = w - 2 * doc_gutter;
	  homepage_width = Math.round(Math.min(content_width, 1200));
	  new_vals = {
	    WINDOW_WIDTH: w,
	    DOC_GUTTER: doc_gutter,
	    DASHBOARD_WIDTH: Math.max(100, w),
	    AUTH_WIDTH: phone_size ? w - 8 : tablet_size ? content_width : 820,
	    TABLET_SIZE: tablet_size,
	    PHONE_SIZE: phone_size,
	    CONTENT_WIDTH: content_width,
	    PORTRAIT_MOBILE: portrait && browser.is_mobile,
	    LANDSCAPE_MOBILE: !portrait && browser.is_mobile,
	    HOMEPAGE_WIDTH: homepage_width,
	    SAAS_PAGE_WIDTH: Math.min(1120, w - 2 * 24)
	  };
	  for (i = 0, len = responsive_style_registry.length; i < len; i++) {
	    registry = responsive_style_registry[i];
	    _.extend(new_vals, registry(new_vals));
	  }
	  needs_save = false;
	  for (k in new_vals) {
	    v = new_vals[k];
	    if (window[k] == null) {
	      window[k] = (function(k) {
	        return function() {
	          return fetch('responsive_vars')[k];
	        };
	      })(k);
	    }
	    needs_save || (needs_save = responsive[k] !== v);
	  }
	  if (needs_save) {
	    _.extend(responsive, new_vals);
	    return save(responsive);
	  }
	};
	
	styles += "\n@media " + LAPTOP_MEDIA + " {\n  :after, :root {\n    --DOC_GUTTER: max(80px, 9vw);\n  }\n}\n\n@media " + TABLET_MEDIA + " {\n  :after, :root {\n    --DOC_GUTTER: 40px;\n  }\n\n}\n\n@media " + PHONE_MEDIA + " {\n  :after, :root {\n    --DOC_GUTTER: 16px;\n  }\n}\n\n:after, :root {\n  --WINDOW_WIDTH: max(350px, 100vw);\n  --SAAS_PAGE_WIDTH: min(1120px, 100vw - 2 * 24px);\n  --HOMEPAGE_WIDTH:  min(1200px, 100vw - 2 * var(--DOC_GUTTER));\n  --CONTENT_WIDTH: calc(var(--WINDOW_WIDTH) - 2 * var(--DOC_GUTTER));\n}\n";
	
	window.responsive_style_registry = [];
	
	setTimeout(setResponsive);
	
	window.addEventListener("resize", setResponsive);
	
	window.addEventListener("gestureend", setResponsive);
	
	window.matchMedia('screen and (min-resolution: 2dppx)').addEventListener("change", setResponsive);


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var TOOLTIP_DELAY, hide_tooltip, show_tooltip, toggle_tooltip, tooltip;
	
	__webpack_require__(1);
	
	styles += "\n#tooltip .downward_arrow {\n  width: 0; \n  height: 0; \n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;  \n  border-top: 10px solid black;\n}\n#tooltip .upward_arrow {\n  width: 0; \n  height: 0; \n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;  \n  border-bottom: 10px solid black;\n}\n";
	
	TOOLTIP_DELAY = 500;
	
	window.clear_tooltip = function() {
	  var tooltip;
	  tooltip = fetch('tooltip');
	  tooltip.coords = tooltip.tip = tooltip.top = tooltip.positioned = null;
	  tooltip.offsetY = tooltip.offsetX = null;
	  tooltip.rendered_size = false;
	  return save(tooltip);
	};
	
	toggle_tooltip = function(e) {
	  var tooltip, tooltip_el;
	  tooltip_el = $$.closest(e.target, '[data-tooltip]');
	  if (tooltip_el != null) {
	    tooltip = fetch('tooltip');
	    if (tooltip.coords) {
	      return clear_tooltip();
	    } else {
	      return show_tooltip(e);
	    }
	  }
	};
	
	show_tooltip = function(e) {
	  var name, tooltip, tooltip_el;
	  tooltip_el = $$.closest(e.target, '[data-tooltip]');
	  if ((tooltip_el == null) || tooltip_el.style.opacity === 0) {
	    return;
	  }
	  tooltip = fetch('tooltip');
	  name = tooltip_el.getAttribute('data-tooltip');
	  if (tooltip.tip !== name) {
	    tooltip.tip = name;
	    setTimeout(function() {
	      if (tooltip.tip === name) {
	        tooltip.coords = calc_coords_for_tooltip_or_popover(tooltip_el);
	        return save(tooltip);
	      }
	    }, TOOLTIP_DELAY);
	    e.preventDefault();
	    return e.stopPropagation();
	  }
	};
	
	tooltip = fetch('tooltip');
	
	hide_tooltip = function(e) {
	  if (e.target.getAttribute('data-tooltip')) {
	    clear_tooltip();
	    e.preventDefault();
	    return e.stopPropagation();
	  }
	};
	
	document.addEventListener("click", toggle_tooltip);
	
	document.body.addEventListener("mouseover", show_tooltip, true);
	
	document.body.addEventListener("mouseleave", hide_tooltip, true);
	
	$$.add_delegated_listener(document.body, 'focusin', '[data-tooltip]', show_tooltip);
	
	$$.add_delegated_listener(document.body, 'focusout', '[data-tooltip]', hide_tooltip);
	
	window.Tooltip = ReactiveComponent({
	  displayName: 'Tooltip',
	  render: function() {
	    var arrow_adjustment, arrow_size, arrow_up, coords, left, ref, style, tip, top;
	    tooltip = fetch('tooltip');
	    if (!tooltip.coords) {
	      return SPAN(null);
	    }
	    coords = tooltip.coords;
	    tip = tooltip.tip;
	    arrow_size = {
	      height: 7,
	      width: 14
	    };
	    ref = get_tooltip_or_popover_position({
	      tooltip: tooltip,
	      arrow_size: arrow_size
	    }), top = ref.top, left = ref.left, arrow_up = ref.arrow_up, arrow_adjustment = ref.arrow_adjustment;
	    style = _.defaults({
	      top: top,
	      left: left
	    }, this.props.style || {}, {
	      fontSize: 14,
	      padding: '4px 8px',
	      borderRadius: 8,
	      pointerEvents: 'none',
	      zIndex: 999999999999,
	      color: 'white',
	      backgroundColor: 'black',
	      position: 'absolute',
	      boxShadow: '0 1px 1px rgba(0,0,0,.2)',
	      maxWidth: 350
	    });
	    return DIV({
	      id: 'tooltip',
	      role: "tooltip",
	      style: style
	    }, DIV({
	      dangerouslySetInnerHTML: {
	        __html: tip
	      }
	    }), SVG({
	      width: arrow_size.width,
	      height: arrow_size.height,
	      viewBox: "0 0 531.74 460.5",
	      preserveAspectRatio: "none",
	      style: {
	        position: 'absolute',
	        bottom: arrow_up ? -arrow_size.height : void 0,
	        top: !arrow_up ? -arrow_size.height : void 0,
	        left: tooltip.positioned !== 'right' ? "calc(50% - " + (arrow_size.width / 2 + arrow_adjustment) + "px)" : void 0,
	        right: tooltip.positioned === 'right' ? 7 : void 0,
	        transform: !arrow_up ? 'scale(1,-1)' : void 0,
	        display: tooltip.hide_triangle ? 'none' : void 0
	      }
	    }, POLYGON({
	      stroke: "black",
	      fill: 'black',
	      points: "530.874,0.5 265.87,459.5 0.866,0.5"
	    })));
	  },
	  componentDidUpdate: function() {
	    tooltip = fetch('tooltip');
	    if (!tooltip.rendered_size && tooltip.coords) {
	      tooltip.rendered_size = {
	        width: ReactDOM.findDOMNode(this).offsetWidth,
	        height: ReactDOM.findDOMNode(this).offsetHeight
	      };
	      return save(tooltip);
	    }
	  }
	});


/***/ },
/* 24 */
/***/ function(module, exports) {

	styles += "[data-widget=\"EditList\"] .default_drop[data-widget=\"DropMenu\"] .dropmenu-menu {\n  right: -9999;\n  left: auto;\n}\n\n[data-widget=\"EditList\"] .default_drop[data-widget=\"DropMenu\"] .dropmenu-menu.dropmenu-menu-open {\n  right: 0;\n  left: auto;\n}\n\n\n[data-widget=\"EditList\"] .default_drop[data-widget=\"DropMenu\"] .dropmenu-menu {\n  width: 250px;\n}\n\n[data-widget=\"EditList\"] .default_drop[data-widget=\"DropMenu\"] .menu-item {\n  text-align: right;\n}  \n";
	
	window.EditList = ReactiveComponent({
	  displayName: 'EditList',
	  render: function() {
	    var admin_actions, current_user, edit_list, list, list_key, subdomain;
	    list = this.props.list;
	    list_key = list.key;
	    current_user = fetch('/current_user');
	    edit_list = fetch("edit-" + list_key);
	    subdomain = fetch('/subdomain');
	    if (!current_user.is_admin) {
	      return SPAN(null);
	    }
	    admin_actions = [
	      {
	        action: 'edit',
	        label: translator('edit', 'edit')
	      }, {
	        action: 'copy_link',
	        label: translator('engage.list-configuration.copy_link', 'copy link')
	      }, {
	        action: 'list_order',
	        label: translator('engage.list-configuration.reorder_topics', 'reorder')
	      }, {
	        action: 'close',
	        label: translator('engage.list-configuration.close', 'close to participation')
	      }, {
	        action: 'delete',
	        label: translator('delete', 'delete')
	      }
	    ];
	    return DIV(null, !edit_list.editing ? DropMenu({
	      className: 'default_drop',
	      options: admin_actions,
	      open_menu_on: 'activation',
	      wrapper_style: {
	        position: 'absolute',
	        right: PHONE_SIZE() ? -6 : 0,
	        top: 12,
	        minWidth: 'auto'
	      },
	      anchor_tooltip: translator("engage.list-config-icon-tooltip", "Configure list settings"),
	      render_anchor: function() {
	        return ThreeDotsIcon({
	          size: 26,
	          fill: '#888'
	        });
	      },
	      render_option: function(option, is_active) {
	        return SPAN({
	          key: option.action,
	          "data-option": option.action
	        }, option.label);
	      },
	      selection_made_callback: (function(_this) {
	        return function(option) {
	          var customizations, ef, has_permission, i, j, len, len1, link, proposal, ref, ref1, ref2;
	          if (option.action === 'edit') {
	            edit_list.editing = true;
	            return save(edit_list);
	          } else if (option.action === 'list_order') {
	            ef = fetch('edit_forum');
	            ef.editing = true;
	            return save(ef);
	          } else if (option.action === 'delete') {
	            return delete_list(list);
	          } else if (option.action === 'close') {
	            if (confirm(translator('engage.list-config-close-confirm', "Are you sure you want to close this list to participation? \nAny proposals in it will also be closed to further participation, \nthough all existing dialogue will remain visible."))) {
	              if (((ref = list.proposals) != null ? ref.length : void 0) > 0) {
	                has_permission = true;
	                ref1 = list.proposals;
	                for (i = 0, len = ref1.length; i < len; i++) {
	                  proposal = ref1[i];
	                  has_permission && (has_permission = permit('update proposal', proposal) > 0);
	                }
	                if (!has_permission) {
	                  alert("You apparently don't have permission to close one or more of the proposals in this list");
	                } else {
	                  ref2 = list.proposals;
	                  for (j = 0, len1 = ref2.length; j < len1; j++) {
	                    proposal = ref2[j];
	                    proposal.active = false;
	                    save_proposal(proposal);
	                  }
	                }
	              }
	              customizations = subdomain.customizations;
	              customizations[list_key].list_permit_new_items = false;
	              return save(subdomain);
	            }
	          } else if (option.action === 'copy_link') {
	            link = "" + location.origin + location.search + "#" + (list_link(list_key));
	            return navigator.clipboard.writeText(link).then(function() {
	              return show_flash(translator("engage.list-configuration.link-copied", "Link copied to clipboard"));
	            }, function(err) {
	              return show_flash_error(translator("engage.list-configuration.problem-copying-link", "Problem copying link to clipboard"));
	            });
	          }
	        };
	      })(this)
	    }) : EditNewList({
	      list: list,
	      fresh: false,
	      combines_these_lists: this.props.combines_these_lists,
	      done_callback: (function(_this) {
	        return function() {
	          edit_list.editing = false;
	          return save(edit_list);
	        };
	      })(this)
	    }));
	  }
	});
	
	styles += ".EditingNewList .ListHeader-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;    \n}\n\n.EditingNewList .LIST-title {\n  width: 100%;\n}\n\n.EditingNewList .LIST-description {\n  margin-top: 24px;\n}\n\n.LIST-fat-header-field {\n  background-color: white;\n  border: 1px solid #eaeaea;\n  border-radius: 8px;\n  outline-color: #ccc;\n  line-height: 1.4;\n  padding: 8px 12px;\n}\n\n.LIST-field-edit-label {\n  display: block;\n  font-weight: 400;\n  margin-top: 36px;\n  margin-bottom: 4px;\n  color: " + (focus_color()) + ";\n  font-size: 18px;\n}\n\n.LIST-option-block {    \n    display: flex;\n    align-items: center;\n    margin-top: 8px;\n}\n\n.LIST-option-block input[type=\"radio\"] {\n  height: 18px; \n  width: 18px;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.LIST-option-block .permissions_explanation {\n  color: #A0A0A0;\n  font-weight: 400;\n  margin-left: 24px;\n}\n\n@media " + PHONE_MEDIA + " {\n  .LIST-option-block .permissions_explanation {\n    display: none;\n  }\n}\n\n.LIST-slider-input {\n  padding-top: 2px;\n  position: absolute;\n  border: none;\n  outline: none;\n  color: #444;\n  font-size: 12px;\n}\n\n#edit_description .ql-editor {\n  min-height: 48px;\n  padding: 12px 12px;\n  border: 1px solid #eaeaea;\n  background-color: white;\n  text-align: inherit;\n}\n\n#edit_description .ql-editor.ql-blank::before {\n  width: 100%;\n}\n\n#edit_description.single-line .ql-editor.ql-blank::before {\n  transform: translateX(-50%);\n}\n\n.LIST_additional_options label {\n  display: flex;\n  align-items: center;\n}\n\n\n.LIST_additional_options input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n#edit_description .wysiwyg_text.focused {\n  outline: none;\n}\n\n\n.list_advanced_options {\n  margin: 36px 0 12px 0;\n}\n.list_advanced_option {\n  margin-bottom: 24px;\n}\n\n.list_advanced_option label span {\n  padding-left: 4px;\n}\n";
	
	window.EditNewList = ReactiveComponent({
	  displayName: 'EditNewList',
	  mixins: [Modal],
	  get_list_key: function() {
	    var base, list_key;
	    if (this.props.fresh) {
	      if ((base = this.local).edit_key == null) {
	        base.edit_key = "list/new-list-" + (Math.round(Math.random() * 1000));
	      }
	      list_key = this.local.edit_key;
	    } else {
	      list_key = this.props.list.key || this.props.list;
	    }
	    return list_key;
	  },
	  render: function() {
	    var cancel_edit, children, current_user, description, description_style, edit_list, exit_edit, list_key, subdomain, submit, title;
	    list_key = this.get_list_key();
	    current_user = fetch('/current_user');
	    edit_list = fetch("edit-" + list_key);
	    subdomain = fetch('/subdomain');
	    if (!current_user.is_admin) {
	      return SPAN(null);
	    }
	    WINDOW_WIDTH();
	    submit = (function(_this) {
	      return function() {
	        var customizations, description, f, fields, i, len, list_config, name, new_key, new_name, tab, val;
	        customizations = subdomain.customizations;
	        if (customizations[list_key] == null) {
	          customizations[list_key] = {};
	        }
	        list_config = customizations[list_key];
	        fields = ['list_title', 'list_description', 'list_permit_new_items', 'list_item_name', 'list_category', 'slider_pole_labels', 'list_opinions_title', 'discussion_enabled', 'list_is_archived', 'show_first_n_proposals'];
	        for (i = 0, len = fields.length; i < len; i++) {
	          f = fields[i];
	          val = edit_list[f];
	          if (val != null) {
	            list_config[f] = val;
	          }
	        }
	        description = fetch(list_key + "-description").html;
	        if (description === "<p><br></p>") {
	          description = "";
	        }
	        list_config.list_description = description;
	        if (_this.props.fresh) {
	          name = slugify(list_config.list_title || list_config.list_category || 'Proposals');
	          if (name.length > 140) {
	            name = name.substring(0, 140);
	          }
	          new_name = name + "-" + (Math.round(Math.random() * 100));
	          new_key = "list/" + new_name;
	          customizations[new_key] = customizations[list_key];
	          _.defaults(customizations[new_key], {
	            created_by: current_user.user,
	            created_at: Date.now()
	          });
	          delete customizations[list_key];
	          if (get_tabs()) {
	            tab = get_tab();
	            if (tab) {
	              tab.lists.push(new_key);
	            } else {
	              console.error("Cannot add the list to the current tab " + current_tab);
	            }
	          } else {
	            if (customizations.lists == null) {
	              customizations.lists = get_all_lists();
	            }
	            if (customizations.lists.indexOf('*') === -1 && customizations.lists.indexOf(new_key) === -1) {
	              customizations.lists.push(new_key);
	            }
	          }
	        }
	        return save(subdomain, function() {
	          if (subdomain.errors) {
	            console.error("Failed to save list changes", subdomain.errors);
	          }
	          return exit_edit();
	        });
	      };
	    })(this);
	    cancel_edit = (function(_this) {
	      return function() {
	        var customizations;
	        customizations = subdomain.customizations;
	        if (_this.props.fresh && list_key in customizations) {
	          delete customizations[list_key];
	          save(subdomain);
	        }
	        return exit_edit();
	      };
	    })(this);
	    exit_edit = (function(_this) {
	      return function() {
	        var base, k, v;
	        for (k in edit_list) {
	          v = edit_list[k];
	          if (k !== 'key') {
	            delete edit_list[k];
	          }
	        }
	        save(edit_list);
	        return typeof (base = _this.props).done_callback === "function" ? base.done_callback() : void 0;
	      };
	    })(this);
	    if (edit_list.list_category == null) {
	      edit_list.list_category = customization('list_category', list_key);
	    }
	    if (edit_list.list_item_name == null) {
	      edit_list.list_item_name = customization('list_item_name', list_key);
	    }
	    if (edit_list.discussion_enabled == null) {
	      edit_list.discussion_enabled = customization('discussion_enabled', list_key);
	    }
	    if (edit_list.list_is_archived == null) {
	      edit_list.list_is_archived = customization('list_is_archived', list_key);
	    }
	    if (edit_list.show_first_n_proposals == null) {
	      edit_list.show_first_n_proposals = customization('show_first_n_proposals', list_key);
	    }
	    title = edit_list.title || get_list_title(list_key, true, subdomain);
	    if (!this.props.fresh) {
	      if (edit_list.list_title == null) {
	        edit_list.list_title = title;
	      }
	    }
	    description = this.getDescription();
	    description_style = customization('list_description_style', list_key);
	    children = DIV({
	      className: 'List EditingNewList'
	    }, DIV({
	      className: 'ListHeader-wrapper'
	    }, DIV({
	      className: 'text-wrapper'
	    }, H1({
	      className: 'LIST-title'
	    }, AutoGrowTextArea({
	      id: "title-" + list_key,
	      className: 'LIST-title LIST-fat-header-field LIST-title-wrapper condensed',
	      ref: 'input',
	      focus_on_mount: true,
	      style: _.defaults({}, customization('list_label_style', list_key, subdomain) || {}, {
	        width: '100%'
	      }),
	      placeholder: translator("engage.list-config-title", "An open-ended question like \"What are your ideas?\" or a category like \"Recommendations\"."),
	      defaultValue: !this.props.fresh ? title : void 0,
	      onChange: function(e) {
	        edit_list.list_title = e.target.value;
	        return save(edit_list);
	      }
	    })), typeof description === 'function' ? DIV({
	      style: _.defaults({}, description_style || {})
	    }, description()) : DIV({
	      id: 'edit_description',
	      className: "LIST-description",
	      ref: 'description',
	      style: _.extend({}, description_style || {}, {
	        width: "100%"
	      })
	    }, WysiwygEditor({
	      key: list_key + "-description",
	      editor_key: list_key + "-description",
	      horizontal: true,
	      html: customization('list_description', list_key),
	      toolbar_style: {
	        right: 0
	      },
	      container_style: {
	        borderRadius: 8
	      },
	      placeholder: translator("engage.list-config-description", "Optional: Additional information")
	    }))), DIV({
	      style: {
	        maxWidth: 465
	      }
	    }, this.drawNameAnItem(), this.drawPermissionToAdd(), this.drawDefineSpectrum(), this.drawAdditionalOptions()), BUTTON({
	      className: 'btn',
	      style: {
	        backgroundColor: focus_color(),
	        fontSize: 24,
	        maxWidth: 465,
	        width: '100%',
	        marginTop: 36,
	        borderRadius: 16
	      },
	      disabled: (edit_list.list_title || "").length === 0,
	      onClick: submit
	    }, this.props.fresh ? translator('engage.create_list_button', 'Publish New Focus') : translator('engage.update_list_button', 'Update Focus')), BUTTON({
	      className: 'like_link',
	      style: {
	        color: '#777',
	        marginTop: 14
	      },
	      onClick: cancel_edit
	    }, translator('shared.cancel_button', 'cancel'))));
	    if (this.props.wrap_in_modal) {
	      return wrap_in_modal(HOMEPAGE_WIDTH() + 72, cancel_edit, children);
	    } else {
	      return children;
	    }
	  },
	  drawNameAnItem: function() {
	    var edit_list, list_key, subdomain;
	    list_key = this.get_list_key();
	    edit_list = fetch("edit-" + list_key);
	    subdomain = fetch('/subdomain');
	    return DIV({
	      style: {
	        marginBottom: 24
	      }
	    }, LABEL({
	      style: {}
	    }, DIV({
	      className: 'LIST-field-edit-label'
	    }, translator('engage.edit_list_item_name', 'What do you call a response to this focus?')), INPUT({
	      ref: 'list_item_name',
	      type: 'text',
	      defaultValue: edit_list.list_item_name || translator('shared.proposal', 'proposal'),
	      name: 'list_item_name',
	      style: {
	        padding: '4px 6px',
	        fontSize: 'inherit',
	        border: '1px solid #ccc'
	      },
	      onChange: (function(_this) {
	        return function(e) {
	          edit_list.list_item_name = e.target.value;
	          return save(edit_list);
	        };
	      })(this)
	    })));
	  },
	  drawPermissionToAdd: function() {
	    var edit_list, list_key, permit_new_items, subdomain;
	    if (this.props.combines_these_lists) {
	      return SPAN(null);
	    }
	    list_key = this.get_list_key();
	    subdomain = fetch('/subdomain');
	    edit_list = fetch("edit-" + list_key);
	    permit_new_items = customization('list_permit_new_items', list_key, subdomain);
	    return DIV({
	      style: {}
	    }, LABEL({
	      className: 'LIST-field-edit-label LIST-permissions',
	      htmlFor: 'list_permit_new_items'
	    }, TRANSLATE({
	      id: "engage.list-config-who-can-add",
	      ITEM_NAME: edit_list.list_item_name || translator('shared.proposal', 'proposal')
	    }, "Who is allowed to add a new {ITEM_NAME}?")), DIV({
	      className: 'LIST-option-block'
	    }, INPUT({
	      id: 'any-participant',
	      type: 'radio',
	      name: 'list_permit_new_items',
	      defaultChecked: permit_new_items,
	      style: {
	        marginTop: 0
	      },
	      onChange: (function(_this) {
	        return function(e) {
	          edit_list.list_permit_new_items = true;
	          return save(edit_list);
	        };
	      })(this)
	    }), LABEL({
	      style: {
	        marginLeft: 4
	      },
	      htmlFor: 'any-participant'
	    }, translator("engage.list-config-who-can-add-anyone", "Any registered participant"), SPAN({
	      className: 'permissions_explanation'
	    }, translator("engage.ideation-description", "For community ideation")))), DIV({
	      className: 'LIST-option-block'
	    }, INPUT({
	      id: 'host-only',
	      type: 'radio',
	      name: 'list_permit_new_items',
	      defaultChecked: !permit_new_items,
	      style: {
	        marginTop: 0
	      },
	      onChange: (function(_this) {
	        return function(e) {
	          edit_list.list_permit_new_items = false;
	          return save(edit_list);
	        };
	      })(this)
	    }), LABEL({
	      style: {
	        marginLeft: 4
	      },
	      htmlFor: 'host-only'
	    }, translator("engage.list-config-who-can-add-only-hosts", "Only forum hosts"), SPAN({
	      className: 'permissions_explanation'
	    }, translator("engage.closed-description", "For feedback on pre-defined proposals")))));
	  },
	  drawDefineSpectrum: function() {
	    var edit_list, k, list_key, subdomain, v;
	    if (this.props.combines_these_lists) {
	      return SPAN(null);
	    }
	    list_key = this.get_list_key();
	    subdomain = fetch('/subdomain');
	    edit_list = fetch("edit-" + list_key);
	    return DIV(null, LABEL({
	      className: 'LIST-field-edit-label'
	    }, TRANSLATE({
	      id: "engage.list-config-spectrum",
	      ITEM_NAME: edit_list.list_item_name || translator('shared.proposal', 'proposal')
	    }, "On what spectrum is each {ITEM_NAME} evaluated?")), DIV({
	      ref: 'slider_config',
	      style: {
	        paddingTop: 18,
	        position: 'relative',
	        marginTop: 8,
	        left: 0,
	        display: 'flex'
	      }
	    }, DIV({
	      style: {
	        position: 'relative',
	        flexGrow: 2,
	        width: '100%',
	        borderTop: '1px solid',
	        borderColor: '#999',
	        maxWidth: 500
	      }
	    }, INPUT({
	      type: 'text',
	      className: 'LIST-slider-input',
	      style: {
	        left: 0,
	        textAlign: 'left'
	      },
	      ref: 'oppose_slider',
	      defaultValue: customization('slider_pole_labels', list_key, subdomain).oppose,
	      placeholder: translator('engage.slider_config.negative-pole-placeholder', 'Negative pole'),
	      onChange: function(e) {
	        if (edit_list.slider_pole_labels == null) {
	          edit_list.slider_pole_labels = {};
	        }
	        edit_list.slider_pole_labels.oppose = e.target.value;
	        return save(edit_list);
	      }
	    }), INPUT({
	      type: 'text',
	      className: 'LIST-slider-input',
	      style: {
	        textAlign: 'right',
	        right: 0
	      },
	      ref: 'support_slider',
	      defaultValue: customization('slider_pole_labels', list_key, subdomain).support,
	      onChange: function(e) {
	        if (edit_list.slider_pole_labels == null) {
	          edit_list.slider_pole_labels = {};
	        }
	        edit_list.slider_pole_labels.support = e.target.value;
	        return save(edit_list);
	      },
	      placeholder: translator('engage.slider_config.positive-pole-placeholder', 'Positive pole')
	    })), DropMenu({
	      options: [
	        {
	          support: '',
	          oppose: ''
	        }
	      ].concat((function() {
	        var results;
	        results = [];
	        for (k in slider_labels) {
	          v = slider_labels[k];
	          results.push(v);
	        }
	        return results;
	      })()),
	      open_menu_on: 'activation',
	      wrapper_style: {
	        position: 'relative',
	        flexGrow: 0,
	        paddingLeft: 18,
	        top: -13
	      },
	      anchor_style: {
	        color: 'inherit',
	        height: '100%',
	        padding: '0px 4px',
	        position: 'relative',
	        right: 0,
	        cursor: 'pointer',
	        whiteSpace: 'nowrap'
	      },
	      menu_style: {
	        width: 420,
	        backgroundColor: '#fff',
	        border: "1px solid #aaa",
	        right: -99999,
	        left: 'auto',
	        top: 24,
	        fontWeight: 400,
	        overflow: 'hidden',
	        boxShadow: '0 1px 2px rgba(0,0,0,.3)',
	        textAlign: 'left'
	      },
	      menu_when_open_style: {
	        right: 0
	      },
	      option_style: {
	        padding: '8px 18px 12px 18px',
	        display: 'block',
	        color: 'black',
	        fontWeight: 400
	      },
	      active_option_style: {
	        color: 'black',
	        backgroundColor: '#efefef'
	      },
	      selection_made_callback: (function(_this) {
	        return function(option) {
	          _this.refs.oppose_slider.value = option.oppose;
	          _this.refs.support_slider.value = option.support;
	          edit_list.slider_pole_labels = {
	            support: option.support,
	            oppose: option.oppose
	          };
	          save(edit_list);
	          return setTimeout(function() {
	            $$.ensureInView(_this.refs.slider_config);
	            if (option.oppose === '') {
	              return moveCursorToEnd(_this.refs.oppose_slider);
	            }
	          }, 100);
	        };
	      })(this),
	      render_anchor: function() {
	        return SPAN(null, LABEL({
	          style: {
	            color: focus_color(),
	            fontSize: 14,
	            marginRight: 12,
	            cursor: 'pointer'
	          }
	        }, translator('engage.list-config-spectrum-select', 'presets')), SPAN({
	          style: _.extend(cssTriangle('bottom', focus_color(), 13, 8, {
	            display: 'inline-block'
	          }))
	        }));
	      },
	      render_option: function(option, is_active) {
	        if (option.oppose === '') {
	          return DIV({
	            style: {
	              fontSize: 16,
	              borderBottom: '1px dashed #ccc',
	              textAlign: 'center',
	              padding: '12px 0'
	            }
	          }, translator("engage.list-config-custom-spectrum", "Custom Spectrum"));
	        }
	        return DIV({
	          className: 'monospaced',
	          style: {
	            fontSize: 14,
	            textAlign: 'center'
	          }
	        }, SPAN({
	          style: {
	            display: 'inline-block',
	            width: 140,
	            textAlign: 'right',
	            paddingRight: 10
	          }
	        }, "" + option.oppose), SPAN({
	          dangerouslySetInnerHTML: {
	            __html: "&#10231;"
	          },
	          style: {
	            fontSize: 32,
	            color: '#888'
	          }
	        }), SPAN({
	          style: {
	            display: 'inline-block',
	            width: 140,
	            textAlign: 'left',
	            paddingLeft: 10
	          }
	        }, "" + option.support));
	      }
	    })));
	  },
	  drawAdditionalOptions: function() {
	    var edit_list, list_key, subdomain;
	    if (this.props.combines_these_lists) {
	      return SPAN(null);
	    }
	    list_key = this.get_list_key();
	    subdomain = fetch('/subdomain');
	    edit_list = fetch("edit-" + list_key);
	    return DIV({
	      className: 'LIST_additional_options',
	      style: {
	        marginTop: 24,
	        marginBottom: 12
	      }
	    }, !this.local.show_all_options ? BUTTON({
	      className: 'like_link',
	      style: {
	        textDecoration: 'underline',
	        color: focus_color(),
	        marginBottom: 24,
	        marginTop: 8,
	        display: screencasting() ? 'none' : void 0
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          _this.local.show_all_options = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, translator("engage.show_advanced_options", 'Show advanced options')) : DIV({
	      className: 'list_advanced_options'
	    }, DIV({
	      className: 'list_advanced_option'
	    }, LABEL(null, INPUT({
	      type: 'checkbox',
	      defaultChecked: !edit_list.discussion_enabled,
	      name: 'discussion_enabled',
	      onChange: (function(_this) {
	        return function(e) {
	          edit_list.discussion_enabled = !edit_list.discussion_enabled;
	          return save(edit_list);
	        };
	      })(this)
	    }), SPAN(null, translator({
	      id: 'engage.list-config-discussion-enabled',
	      ITEM_NAME: edit_list.list_item_name || translator('shared.proposal', 'proposal')
	    }, 'Disable pro/con commenting on each {ITEM_NAME}. Spectrums only.')))), DIV({
	      className: 'list_advanced_option'
	    }, LABEL(null, INPUT({
	      type: 'checkbox',
	      defaultChecked: edit_list.list_is_archived,
	      name: 'list_is_archived',
	      onChange: (function(_this) {
	        return function(e) {
	          edit_list.list_is_archived = !edit_list.list_is_archived;
	          return save(edit_list);
	        };
	      })(this)
	    }), SPAN(null, translator('engage.list-config-archived', 'Closed by default. Useful for archiving.')))), DIV({
	      className: 'list_advanced_option'
	    }, LABEL(null, INPUT({
	      type: 'checkbox',
	      defaultChecked: edit_list.show_first_n_proposals !== SHOW_FIRST_N_PROPOSALS,
	      name: 'show_first_n_proposals',
	      onChange: (function(_this) {
	        return function(e) {
	          if (edit_list.show_first_n_proposals !== SHOW_FIRST_N_PROPOSALS) {
	            edit_list.show_first_n_proposals = SHOW_FIRST_N_PROPOSALS;
	          } else {
	            edit_list.show_first_n_proposals = 999;
	          }
	          return save(edit_list);
	        };
	      })(this)
	    }), SPAN(null, translator({
	      id: 'engage.list-config-show_first_n_proposals',
	      DEFAULT: SHOW_FIRST_N_PROPOSALS
	    }, 'Show all proposals in this focus, without forcing people to click "show all". The default is to show the first {DEFAULT}.'))))));
	  },
	  componentDidMount: function() {
	    this.setFocusOnTitle();
	    return this.setAlignmentOnDescription();
	  },
	  componentDidUpdate: function() {
	    this.setFocusOnTitle();
	    return this.setAlignmentOnDescription();
	  },
	  setFocusOnTitle: function() {
	    if (!this.initialized && (this.refs.input != null)) {
	      setTimeout((function(_this) {
	        return function() {
	          return moveCursorToEnd(ReactDOM.findDOMNode(_this.refs.input));
	        };
	      })(this));
	      return this.initialized = true;
	    }
	  },
	  getDescription: function() {
	    var description, edit_list, list_key;
	    list_key = this.get_list_key();
	    edit_list = fetch("edit-" + list_key);
	    description = edit_list.description || customization('list_description', list_key);
	    if (Array.isArray(description)) {
	      description = description.join('\n');
	    }
	    return description;
	  },
	  setAlignmentOnDescription: function() {
	    var description, height, is_func, list_key, single_line;
	    list_key = this.get_list_key();
	    description = fetch(list_key + "-description").html || this.getDescription();
	    is_func = typeof description === 'function';
	    if (!is_func) {
	      if (!this.refs.description) {
	        return;
	      }
	      height = this.refs.description.clientHeight;
	      single_line = height < 60;
	      if (single_line) {
	        return this.refs.description.classList.add('single-line');
	      } else {
	        return this.refs.description.classList.remove('single-line');
	      }
	    }
	  }
	});


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var COLLAPSE_ICON_SIZE, CollapseList, EditableDescription, EditableTitle, ListItems, PROPOSAL_AUTHOR_AVATAR_SIZE_SMALL, PROPOSAL_AVATAR_GUTTER, PROPOSAL_AVATAR_GUTTER_SMALL, __remove_this_list, category_value, lists_ordered_by_most_recent_update, lists_ordered_by_randomized,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(9);
	
	__webpack_require__(24);
	
	__webpack_require__(19);
	
	window.PROPOSAL_AUTHOR_AVATAR_SIZE = 40;
	
	PROPOSAL_AVATAR_GUTTER = 18;
	
	PROPOSAL_AUTHOR_AVATAR_SIZE_SMALL = 20;
	
	PROPOSAL_AVATAR_GUTTER_SMALL = 12;
	
	window.styles += ":after,\n:root {\n  --PROPOSAL_BULLET_GUTTER: 12px; \n  --AVATAR_SIZE_AND_GUTTER: calc(var(--PROPOSAL_AUTHOR_AVATAR_SIZE) + var(--PROPOSAL_AUTHOR_AVATAR_GUTTER));\n\n  --LIST_PADDING_FULL: var(--LIST_PADDING_TOP) var(--LIST_PADDING_RIGHT) var(--LIST_PADDING_BOTTOM) var(--LIST_PADDING_LEFT);\n}\n\n\n@media " + LAPTOP_MEDIA + " {\n  :root, :before, :after {\n    --ITEM_TEXT_WIDTH:    calc( .6 * (var(--HOMEPAGE_WIDTH) - var(--LIST_PADDING_LEFT) - var(--AVATAR_SIZE_AND_GUTTER) - var(--PROPOSAL_AUTHOR_AVATAR_SIZE)) );\n    --ITEM_OPINION_WIDTH: calc( .4 * (var(--HOMEPAGE_WIDTH) - var(--LIST_PADDING_RIGHT)) );      \n  \n    --LIST_PADDING_TOP: 48px;\n    --LIST_PADDING_BOTTOM: 48px;\n    --LIST_PADDING_RIGHT: 66px;\n    --LIST_PADDING_LEFT: 66px;\n\n  }\n}\n\n@media " + TABLET_MEDIA + " {\n  :root, :before, :after {\n    --ITEM_TEXT_WIDTH:    calc( var(--HOMEPAGE_WIDTH) - var(--AVATAR_SIZE_AND_GUTTER) );\n    --ITEM_OPINION_WIDTH: calc( var(--HOMEPAGE_WIDTH) - var(--AVATAR_SIZE_AND_GUTTER) );  \n\n    --LIST_PADDING_TOP: 0px;\n    --LIST_PADDING_BOTTOM: 0px;\n    --LIST_PADDING_RIGHT: 4px;\n    --LIST_PADDING_LEFT: 4px;\n\n  }\n}\n\n\n@media " + PHONE_MEDIA + " {\n  :root, :before, :after {\n    --PROPOSAL_AUTHOR_AVATAR_SIZE: " + PROPOSAL_AUTHOR_AVATAR_SIZE_SMALL + "px;\n    --PROPOSAL_AUTHOR_AVATAR_GUTTER: " + PROPOSAL_AVATAR_GUTTER_SMALL + "px;\n    --ITEM_TEXT_WIDTH:    calc( var(--HOMEPAGE_WIDTH) - var(--AVATAR_SIZE_AND_GUTTER) );\n    --ITEM_OPINION_WIDTH: calc( var(--HOMEPAGE_WIDTH) - var(--AVATAR_SIZE_AND_GUTTER) );  \n\n    --LIST_PADDING_TOP: 0px;\n    --LIST_PADDING_BOTTOM: 0px;\n    --LIST_PADDING_RIGHT: 2px;\n    --LIST_PADDING_LEFT: 2px;\n  }\n}\n\n@media " + NOT_PHONE_MEDIA + " {\n  :root, :before, :after {\n    --PROPOSAL_AUTHOR_AVATAR_SIZE: " + PROPOSAL_AUTHOR_AVATAR_SIZE + "px;\n    --PROPOSAL_AUTHOR_AVATAR_GUTTER: " + PROPOSAL_AVATAR_GUTTER + "px;\n  }\n}";
	
	responsive_style_registry.unshift(function(responsive_vars) {
	  var avatar_spacing, bottom, homepage_width, left, phone_size, right, tablet_size, top;
	  homepage_width = responsive_vars.HOMEPAGE_WIDTH;
	  tablet_size = responsive_vars.TABLET_SIZE;
	  phone_size = responsive_vars.PHONE_SIZE;
	  if (tablet_size) {
	    right = left = 4;
	    top = bottom = 0;
	  } else {
	    right = 90;
	    left = 66;
	    top = bottom = 48;
	  }
	  if (phone_size) {
	    avatar_spacing = PROPOSAL_AUTHOR_AVATAR_SIZE_SMALL + PROPOSAL_AVATAR_GUTTER_SMALL;
	  } else {
	    avatar_spacing = PROPOSAL_AUTHOR_AVATAR_SIZE + PROPOSAL_AVATAR_GUTTER;
	  }
	  return {
	    LIST_PADDING_TOP: top,
	    LIST_PADDING_RIGHT: right,
	    LIST_PADDING_LEFT: left,
	    LIST_PADDING_BOTTOM: bottom,
	    AVATAR_SIZE_AND_GUTTER: avatar_spacing,
	    AVATAR_SIZE: phone_size ? PROPOSAL_AUTHOR_AVATAR_SIZE_SMALL : PROPOSAL_AUTHOR_AVATAR_SIZE,
	    ITEM_TEXT_WIDTH: tablet_size ? homepage_width - avatar_spacing : .6 * (homepage_width - left - avatar_spacing - PROPOSAL_AUTHOR_AVATAR_SIZE),
	    ITEM_OPINION_WIDTH: tablet_size ? homepage_width - avatar_spacing : .4 * (homepage_width - right),
	    LIST_ITEM_EXPANSION_SCALE: tablet_size ? 1 : 1.25
	  };
	});
	
	window.styles += ".List, .NewList, .draggable-wrapper {\n  background-color: white;\n  border: none;\n  border-radius: 16px;\n  box-shadow: -1px 1px 2px rgb(0 0 0 / 15%);\n  border-top: 1px solid #f3f3f3;\n}\n\n\n.List {\n  margin-bottom: 60px;\n  position: relative; \n  padding: var(--LIST_PADDING_FULL);   \n}\n\n.one-col .List, .one-col .NewList, .embedded-demo .List, .embedded-demo .NewList {\n  border-top: none;\n  box-shadow: none;\n}\n\n# .embedded-demo .List {\n#   padding: 0;\n# }\n\n\n.LIST_item_connector {\n  display: none;\n  /* position: absolute;\n  height: calc(100% - var(--PROPOSAL_AUTHOR_AVATAR_SIZE) - 28px);\n  width: 1px;\n  background-color: #ccc;\n  left: calc(50% - var(--HOMEPAGE_WIDTH) / 2 + var(--PROPOSAL_AUTHOR_AVATAR_SIZE)/2);\n  top: 28px;  /* half the line height of the list header */\n  z-index: 0; */ \n}";
	
	window.list_link = function(list_key) {
	  return list_key.substring(5).toLowerCase().replace(/ /g, '_');
	};
	
	window.SHOW_FIRST_N_PROPOSALS = 6;
	
	window.List = ReactiveComponent({
	  displayName: 'List',
	  render: function() {
	    var current_user, edit_list, is_collapsed, list, list_key, list_state, permitted, proposals;
	    current_user = fetch('/current_user');
	    list = get_list(this.props.list);
	    list_key = list.key;
	    fetch('homepage_you_updated_proposal');
	    proposals = list.proposals || [];
	    list_state = fetch(list_key);
	    if (list_state.show_first_num_items == null) {
	      list_state.show_first_num_items = this.props.show_first_num_items || customization('show_first_n_proposals', list_key) || SHOW_FIRST_N_PROPOSALS;
	    }
	    if (list_state.collapsed == null) {
	      list_state.collapsed = customization('list_is_archived', list_key);
	    }
	    is_collapsed = list_state.collapsed;
	    edit_list = fetch("edit-" + list_key);
	    if (edit_list.editing) {
	      return EditNewList({
	        list: list,
	        fresh: false,
	        combines_these_lists: this.props.combines_these_lists,
	        done_callback: (function(_this) {
	          return function() {
	            edit_list.editing = false;
	            return save(edit_list);
	          };
	        })(this)
	      });
	    }
	    return ARTICLE({
	      key: list_key,
	      className: "List",
	      id: list_key.substring(5).toLowerCase(),
	      style: screencasting() ? {
	        boxShadow: 'none',
	        borderTop: 'none',
	        paddingTop: 0
	      } : void 0
	    }, A({
	      name: list_link(list_key)
	    }), DIV({
	      ref: 'LIST_item_connector',
	      className: 'LIST_item_connector'
	    }), ListHeader({
	      list: list,
	      combines_these_lists: this.props.combines_these_lists,
	      proposals_count: proposals.length,
	      fresh: this.props.fresh,
	      allow_editing: (this.props.allow_editing == null) || this.props.allow_editing
	    }), !is_collapsed && !this.props.fresh ? (permitted = permit('create proposal', list_key), ListItems({
	      list: list,
	      key: list.key + "-items",
	      fresh: this.props.fresh,
	      show_first_num_items: list_state.show_all_proposals ? 999999 : list_state.show_first_num_items,
	      combines_these_lists: this.props.combines_these_lists,
	      show_new_button: (this.props.combines_these_lists && lists_current_user_can_add_to(this.props.combines_these_lists).length > 0) || (permitted > 0 || permitted === Permission.NOT_LOGGED_IN),
	      expansion_key: this.props.expansion_key
	    })) : void 0, customization('footer', list_key) && !is_collapsed ? customization('footer', list_key)() : void 0);
	  }
	});
	
	styles += "\n.show-all-proposals {\n  list-style: none;\n  position: relative;\n  margin-top: -105px;\n  z-index: 10;    \n}\n\n.show-all-proposals button {\n  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 60%, rgba(255,255,255,0) 100%);\n  width: 100%;\n  cursor: pointer;\n  padding: 32px 0 22px 0;\n  font-weight: 700;\n  text-align: center;\n  border: none;\n  font-size: 22px;\n  color: #446ae3;\n  padding-top: 96px;\n  margin-top: 12px;\n  margin-bottom: 8px;\n}\n\n.ListItems {\n  min-height: 0px;\n  transition: min-height 0s ease-out;\n}";
	
	ListItems = ReactiveComponent({
	  displayName: 'ListItems',
	  render: function() {
	    var aggregated_list, colors, expanded_state, expansion_key, expansion_state_changed, hues, i, idx, j, len, len1, len2, list, list_key, list_order_has_changed, loc, more_expanded, p, passes_idx_test, passes_url_test, proposal, proposals, proposals_to_render, ref, render_new, show_all_button, sort_key, sorted_key, url;
	    list = this.props.list;
	    list_key = list.key;
	    sort_key = "sorted-proposals-" + list_key;
	    proposals = !this.props.fresh ? sorted_proposals(list.proposals, sort_key, true) || [] : [];
	    if (this.props.combines_these_lists) {
	      hues = getNiceRandomHues(this.props.combines_these_lists.length);
	      colors = {};
	      ref = this.props.combines_these_lists;
	      for (idx = i = 0, len1 = ref.length; i < len1; idx = ++i) {
	        aggregated_list = ref[idx];
	        colors[aggregated_list] = hues[idx];
	      }
	    }
	    show_all_button = (function(_this) {
	      return function() {
	        return LI({
	          className: 'show-all-proposals',
	          key: "show-all-" + list_key,
	          style: {
	            listStyle: 'none'
	          }
	        }, BUTTON({
	          onClick: function() {
	            var list_state;
	            list_state = fetch(list_key);
	            list_state.show_all_proposals = true;
	            return save(list_state);
	          }
	        }, SPAN({
	          style: {
	            textDecoration: 'underline'
	          }
	        }, translator("engage.show_hidden_proposals", 'Show all')), SPAN({
	          className: 'monospaced',
	          style: {
	            paddingLeft: "var(--PROPOSAL_AUTHOR_AVATAR_GUTTER)",
	            color: '#444',
	            fontWeight: 400
	          }
	        }, "+" + (proposals.length - _this.props.show_first_num_items))));
	      };
	    })(this);
	    render_new = (function(_this) {
	      return function() {
	        return LI({
	          key: "new" + list_key,
	          style: {
	            padding: 0,
	            listStyle: 'none',
	            margin: "24px auto",
	            position: 'relative'
	          }
	        }, NewProposal({
	          list_key: list_key,
	          combines_these_lists: _this.props.combines_these_lists
	        }));
	      };
	    })(this);
	    loc = fetch('location');
	    proposals_to_render = [];
	    for (idx = j = 0, len2 = proposals.length; j < len2; idx = ++j) {
	      p = proposals[idx];
	      passes_idx_test = idx < this.props.show_first_num_items && passes_running_timelapse_simulation(p.created_at);
	      passes_url_test = loc.url === ("/" + p.slug);
	      if (passes_idx_test || passes_url_test) {
	        proposals_to_render.push(p);
	      }
	      if (idx >= this.props.show_first_num_items && loc.url === '/') {
	        break;
	      }
	    }
	    sorted_key = md5(((function() {
	      var len3, m, results;
	      results = [];
	      for (m = 0, len3 = proposals_to_render.length; m < len3; m++) {
	        p = proposals_to_render[m];
	        results.push(p.key);
	      }
	      return results;
	    })()).join('###'));
	    list_order_has_changed = (this.last_sorted_key != null) && this.last_sorted_key !== sorted_key;
	    this.last_sorted_key = sorted_key;
	    if (list_order_has_changed) {
	      schedule_viewport_position_check();
	    }
	    expansion_key = this.get_expansion_key();
	    more_expanded = (this.last_expansion_key != null) && expansion_key.length > this.last_expansion_key.length;
	    expansion_state_changed = (this.last_expansion_key != null) && this.last_expansion_key !== expansion_key;
	    this.last_expansion_key = expansion_key;
	    expanded_state = fetch("proposal_expansions-" + list.key);
	    len = proposals_to_render.length;
	    url = fetch('location').url;
	    return FLIPPER({
	      flipKey: sorted_key + expansion_key,
	      spring: PROPOSAL_ITEM_SPRING,
	      onStart: (function(_this) {
	        return function(el) {
	          el.classList.add("flipping");
	          if (expansion_state_changed) {
	            el.classList.add("expansion_event");
	            if (!more_expanded && (_this.last_expanded_height != null)) {
	              _this.refs.list_wrapper.style.transitionDuration = "0s";
	              _this.refs.list_wrapper.style.minHeight = _this.last_expanded_height + "px";
	              setTimeout(function() {
	                return requestAnimationFrame(function() {
	                  _this.refs.list_wrapper.style.transitionDuration = "1s";
	                  return _this.refs.list_wrapper.style.minHeight = null;
	                });
	              }, 600);
	            }
	          }
	          if (list_order_has_changed) {
	            return el.classList.add("list_order_event");
	          }
	        };
	      })(this),
	      onComplete: (function(_this) {
	        return function(el) {
	          el.classList.remove("flipping", "expansion_event", "list_order_event");
	          if (expansion_state_changed && more_expanded) {
	            return _this.last_expanded_height = _this.refs.list_wrapper.clientHeight;
	          }
	        };
	      })(this)
	    }, UL({
	      className: 'ListItems',
	      ref: 'list_wrapper'
	    }, !list.proposals ? LI({
	      style: {
	        listStyle: 'none'
	      },
	      className: 'sized_for_homepage'
	    }, ProposalsLoading()) : void 0, (function() {
	      var len3, m, results;
	      results = [];
	      for (idx = m = 0, len3 = proposals_to_render.length; m < len3; idx = ++m) {
	        proposal = proposals_to_render[idx];
	        results.push(ProposalItem({
	          key: "collapsed" + proposal.key,
	          proposal: proposal.key,
	          list_key: list_key,
	          list_order: sorted_key,
	          show_list_title: !!this.props.combines_these_lists,
	          list_title_color: this.props.combines_these_lists ? hsv2rgb(colors["list/" + (proposal.cluster || 'Proposals')], 1, .7) : void 0,
	          is_expanded: !!expanded_state[proposal.key],
	          accessed_by_url: url === ("/" + proposal.slug),
	          num_proposals: len
	        }));
	      }
	      return results;
	    }).call(this), proposals.length > this.props.show_first_num_items ? FLIPPED({
	      flipId: "show-all-" + list_key,
	      translate: true,
	      shouldFlip: (function(_this) {
	        return function() {
	          return expansion_state_changed;
	        };
	      })(this)
	    }, show_all_button()) : void 0, this.props.show_new_button ? FLIPPED({
	      flipId: "new-button-" + list_key,
	      translate: true,
	      shouldFlip: (function(_this) {
	        return function() {
	          return expansion_state_changed;
	        };
	      })(this)
	    }, render_new()) : void 0));
	  },
	  get_expansion_key: function() {
	    var expanded_state, expansion_key, key, state;
	    expanded_state = fetch("proposal_expansions-" + this.props.list.key);
	    expansion_key = ((function() {
	      var results;
	      results = [];
	      for (key in expanded_state) {
	        state = expanded_state[key];
	        if (key !== 'key') {
	          results.push(key + "-" + state);
	        }
	      }
	      return results;
	    })()).join('###');
	    return expansion_key;
	  }
	});
	
	__remove_this_list = function(list_key, page) {
	  var customizations, i, idx, j, len1, len2, list_in_other_pages, ol, subdomain, tab, tabs;
	  subdomain = fetch('/subdomain');
	  list_key = list_key.key || list_key;
	  tabs = get_tabs();
	  customizations = subdomain.customizations;
	  if (tabs) {
	    for (i = 0, len1 = tabs.length; i < len1; i++) {
	      tab = tabs[i];
	      if ((idx = tab.lists.indexOf(list_key)) > -1) {
	        tab.lists.splice(idx, 1);
	      }
	    }
	  } else {
	    ol = customizations.lists;
	    if (ol) {
	      idx = ol.indexOf(list_key);
	      if (idx > -1) {
	        ol.splice(idx, 1);
	        if (ol.length === 0) {
	          delete customizations.lists;
	        }
	      }
	    }
	  }
	  list_in_other_pages = false;
	  if (tabs) {
	    for (j = 0, len2 = tabs.length; j < len2; j++) {
	      tab = tabs[j];
	      if (tab.lists.indexOf(list_key) > -1) {
	        list_in_other_pages = true;
	        break;
	      }
	    }
	  }
	  if (!list_in_other_pages) {
	    delete customizations[list_key];
	  }
	  return save(subdomain);
	};
	
	window.delete_list = function(list_key, page, suppress_confirmation) {
	  var has_permission, i, j, len1, len2, len3, list_in_num_pages, m, proposal, proposals, subdomain, tab, tabs;
	  subdomain = fetch('/subdomain');
	  list_key = list_key.key || list_key;
	  tabs = get_tabs();
	  list_in_num_pages = 0;
	  if (tabs) {
	    for (i = 0, len1 = tabs.length; i < len1; i++) {
	      tab = tabs[i];
	      if (tab.lists.indexOf(list_key) > -1) {
	        list_in_num_pages += 1;
	      }
	    }
	  } else {
	    list_in_num_pages = 1;
	  }
	  if (list_in_num_pages <= 1) {
	    proposals = get_proposals_in_list(list_key);
	    if ((proposals != null ? proposals.length : void 0) > 0) {
	      has_permission = true;
	      for (j = 0, len2 = proposals.length; j < len2; j++) {
	        proposal = proposals[j];
	        has_permission && (has_permission = permit('delete proposal', proposal) > 0);
	      }
	      if (!has_permission) {
	        return alert("You apparently don't have permission to delete one or more of the proposals in this list");
	      } else if (has_permission && (suppress_confirmation || confirm(translator('engage.list-config-delete-confirm', 'Are you sure you want to delete this list? All of the proposals in it will also be permanently deleted. If you want to get rid of the list, but not delete the proposals, you could move the proposals first.')))) {
	        for (m = 0, len3 = proposals.length; m < len3; m++) {
	          proposal = proposals[m];
	          destroy(proposal.key);
	        }
	        return __remove_this_list(list_key, page);
	      }
	    } else if (suppress_confirmation || confirm(translator('engage.list-config-delete-confirm-when-no-proposals', 'Are you sure you want to delete this list? This is irreversable.'))) {
	      return __remove_this_list(list_key, page);
	    }
	  } else {
	    return __remove_this_list(list_key, page);
	  }
	};
	
	styles += ".ListHeader-wrapper {\n  display: flex;\n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n\n  .ListHeader-wrapper {\n    padding-top: 12px;\n    padding-bottom: 12px;\n    position: relative;\n    margin-left: calc(-1 * var(--LIST_PADDING_LEFT) - var(--homepagetab_left_padding) );\n    padding-left: calc(var(--LIST_PADDING_LEFT) + var(--homepagetab_left_padding) );\n    width: calc(100% + var(--LIST_PADDING_LEFT) + var(--LIST_PADDING_RIGHT) + var(--homepagetab_left_padding));\n  }\n\n  .ListHeader-wrapper, button.NewList {\n    background-color: #eee;\n  }\n\n}\n\n\n.text-wrapper {\n  // padding-left: var(--AVATAR_SIZE_AND_GUTTER);    \n  position: relative;\n  width: 100%;\n}\n\n@media " + TABLET_MEDIA + " {\n  .text-wrapper {\n    width: calc(var(--AVATAR_SIZE_AND_GUTTER) + var(--ITEM_TEXT_WIDTH) - 24px);\n    margin-left: 24px;\n  }\n}\n\n@media " + PHONE_MEDIA + " {\n  .text-wrapper {\n    margin-left: 24px;\n    width: calc(var(--AVATAR_SIZE_AND_GUTTER) + var(--ITEM_TEXT_WIDTH) - 24px);\n  }\n}\n\n\n.avatar-spacing {\n  width: var(--AVATAR_SIZE_AND_GUTTER);\n  min-height: 1px;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n";
	
	window.ListHeader = ReactiveComponent({
	  displayName: 'ListHeader',
	  render: function() {
	    var DIVIDER, description, is_collapsed, list, list_key, list_state, subdomain;
	    list = this.props.list;
	    list_key = list.key;
	    list_state = fetch(list_key);
	    is_collapsed = list_state.collapsed;
	    subdomain = fetch('/subdomain');
	    description = customization('list_description', list_key, subdomain);
	    DIVIDER = customization('list_divider', list_key, subdomain);
	    return DIV({
	      className: 'ListHeader',
	      style: {
	        marginBottom: !is_collapsed ? 16 : void 0
	      }
	    }, typeof DIVIDER === "function" ? DIVIDER() : void 0, DIV({
	      className: 'ListHeader-wrapper'
	    }, CollapseList(list_key), DIV({
	      className: 'text-wrapper'
	    }, EditableTitle({
	      list: this.props.list,
	      fresh: this.props.fresh
	    }), !is_collapsed && ((description != null ? description.length : void 0) > 0 || typeof description === 'function') ? EditableDescription({
	      list: this.props.list,
	      fresh: this.props.fresh
	    }) : void 0), this.props.allow_editing ? EditList({
	      list: this.props.list,
	      fresh: this.props.fresh,
	      combines_these_lists: this.props.combines_these_lists
	    }) : void 0), this.props.proposals_count > 0 && !is_collapsed && !customization('list_no_filters', list_key, subdomain) ? ListActions({
	      list: this.props.list,
	      add_new: !this.props.combines_these_lists && customization('list_permit_new_items', list_key, subdomain) && !is_collapsed && this.props.proposals_count > 4,
	      can_sort: customization('homepage_show_search_and_sort', null, subdomain) && this.props.proposals_count > 1,
	      fresh: this.props.fresh
	    }) : void 0);
	  }
	});
	
	styles += ".NewList, .EditingNewList {\n  border: 3px dashed " + (focus_color()) + "aa;\n  transition: border 500ms;    \n  box-shadow: none;\n}\n\n.NewList {\n  text-align: left;\n  margin-top: 55px;\n  display: block;\n  position: relative;\n  padding: var(--LIST_PADDING_TOP) 56px var(--LIST_PADDING_BOTTOM) 56px;\n  width: 100%;\n}\n\n.NewList:hover, .EditingNewList:hover,\n.NewList:focus-within, .EditingNewList:focus-within {\n  border-color: " + focus_blue + ";\n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  button.NewList, .EditingNewList {\n    border-radius: 0px;\n    border: none;\n  }\n  button.NewList {\n    padding: 24px 12px;\n  }\n\n}\n\n.NewList .LIST-title {\n  text-align: center;\n}\n\n\n.NewList .LIST-title span {\n  position: relative;\n  color: " + focus_blue + ";\n  border-bottom-width: 2px;\n  border-bottom-color: " + focus_blue + "aa;\n  border-bottom-style: solid;\n  transition: border-bottom 500ms;\n}\n\n.NewList:hover .LIST-title span,\n.NewList:focus-within .LIST-title span {\n  border-bottom-color: " + focus_blue + ";\n}\n\n.NewList .LIST-description {\n  text-align: center;\n}\n\n.NewList.draggable-list .LIST-description {\n  display: none;\n}\n\n.NewList.draggable-list .LIST-title {\n  text-align: left;\n  padding-left: 45px;\n}\n";
	
	window.NewList = ReactiveComponent({
	  displayName: 'NewList',
	  render: function() {
	    var base, subdomain, wide_layout;
	    subdomain = fetch('/subdomain');
	    wide_layout = WINDOW_WIDTH() > 1090;
	    if ((base = this.local).hovering == null) {
	      base.hovering = false;
	    }
	    return DIV(null, this.local.editing ? EditNewList({
	      fresh: true,
	      default_open_ended: this.local.default_open_ended,
	      done_callback: (function(_this) {
	        return function() {
	          _this.local.editing = false;
	          return save(_this.local);
	        };
	      })(this)
	    }) : BUTTON({
	      className: "NewList " + (this.props.wrapper_clss ? this.props.wrapper_clss : '') + " ",
	      onClick: (function(_this) {
	        return function(e) {
	          _this.local.editing = true;
	          _this.local.default_open_ended = e.target.classList.contains('open');
	          return save(_this.local);
	        };
	      })(this)
	    }, H1({
	      className: 'LIST-title'
	    }, SPAN(null, translator("engage.create_new_focus", "Create a New Focus"))), DIV({
	      className: 'LIST-description'
	    }, translator("engage.focus_description", "Focus your community on evaluating specific proposals. Or pose an open-ended question to focus your community on generating ideas."))));
	  }
	});
	
	window.list_i18n = function() {
	  return {
	    button: translator('engage.create_new_list_button', "Create a new call for ideas or feedback"),
	    explanation: translator('engage.create_new_list_explanation', 'Ask an open-ended question like "What are your ideas?" or establish a category like "Recommendations."'),
	    new_response_label: function(list_key) {
	      var item_name, subdomain;
	      item_name = customization('list_item_name', list_key);
	      if (item_name) {
	        item_name = capitalize(item_name);
	      }
	      if (item_name === 'proposal' || !item_name) {
	        return translator("engage.add_new_proposal_to_list", 'Add new proposal');
	      } else {
	        subdomain = fetch('/subdomain');
	        return translator({
	          id: "engage.add_new_" + item_name + "_to_list",
	          local: true
	        }, "Add a new " + item_name);
	      }
	    },
	    opinion_header: function(list_key) {
	      var item_name, subdomain;
	      item_name = customization('list_item_name', list_key);
	      if (item_name) {
	        item_name = capitalize(item_name);
	      }
	      if (!item_name || item_name.toLowerCase() === 'proposal') {
	        return translator("engage.opinion_header_results", 'Opinions about this proposal');
	      } else {
	        subdomain = fetch('/subdomain');
	        return translator({
	          id: "engage.opinion_header_results_" + item_name,
	          local: true
	        }, "Opinions about this " + item_name);
	      }
	    }
	  };
	};
	
	styles += ".LIST-title {\n  font-size: 35px;\n  font-weight: 600;\n  text-align: left;\n}\n\n.LIST-title-wrapper {\n  position: relative;\n  text-align: center;\n  outline: none;\n}\n\n@media " + TABLET_MEDIA + " {\n  .LIST-title {\n    font-size: 28px;\n  }  \n}\n@media " + PHONE_MEDIA + " {\n  .LIST-title {\n    font-size: 22px; \n    // margin-left: 28px; \n  }  \n\n  .EditableTitle {\n    // margin-right: 24px;\n  }\n\n}\n\n";
	
	EditableTitle = ReactiveComponent({
	  displayName: 'EditableTitle',
	  render: function() {
	    var list, list_key, subdomain, title;
	    list = this.props.list;
	    list_key = list.key;
	    subdomain = fetch('/subdomain');
	    title = get_list_title(list_key, true, subdomain);
	    return DIV({
	      className: 'EditableTitle'
	    }, H1({
	      className: 'LIST-title',
	      style: {
	        fontSize: title.replace(/^\s+|\s+$/g, '').length === 0 ? 0 : void 0
	      }
	    }, DIV({
	      className: 'LIST-title-wrapper condensed',
	      style: customization('list_label_style', list_key, subdomain) || {}
	    }, title)));
	  }
	});
	
	COLLAPSE_ICON_SIZE = 40;
	
	styles += "\n.CollapseList {\n  border: none;\n  background-color: transparent;\n  padding: 0; \n  margin: 0; \n  line-height: 0;\n  cursor: pointer;\n}\n\n.embedded-demo .CollapseList {\n  display: none;\n}\n\n@media " + LAPTOP_MEDIA + " {\n  .CollapseList {\n    transition: transform .25s, top .25s;\n    position: absolute;\n    left: calc(50% - " + (COLLAPSE_ICON_SIZE / 2) + "px);\n    bottom: " + (-COLLAPSE_ICON_SIZE / 2) + "px;\n  }\n\n  .CollapseList svg {\n\n  }\n\n  .CollapseList.collapsed {\n    transform: scaleY(-1);\n  }\n\n  .CollapseList.expanded {\n  }    \n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .CollapseList {\n    border: none;\n    background-color: transparent;\n    padding: 0; \n    margin: 0; \n    position: absolute;\n    cursor: pointer;\n    transition: transform .25s, top .25s;\n    top: 22px;\n    left: 6px;\n  }\n\n  .CollapseList svg {\n    position: relative;\n    left: 0;\n  }\n\n  .CollapseList.collapsed {\n  }\n\n  .CollapseList.expanded {\n    transform: rotate(90deg);\n  }\n\n  .embedded-demo .CollapseList {\n    display: none;\n  }\n\n}\n\n";
	
	CollapseList = function(list_key) {
	  var is_collapsed, list_state, list_uncollapseable, subdomain, toggle_list;
	  subdomain = fetch('/subdomain');
	  list_uncollapseable = customization('list_uncollapseable', list_key, subdomain);
	  if (list_uncollapseable) {
	    return SPAN(null);
	  }
	  list_state = fetch(list_key);
	  is_collapsed = list_state.collapsed;
	  toggle_list = function(collapse_button) {
	    var el, list_el;
	    list_el = collapse_button.closest('.List');
	    el = list_el.querySelector('.LIST-title');
	    return $$.ensureInView(el, {
	      offset_buffer: 120,
	      callback: function() {
	        var google_translate, padding_el, sty;
	        if (!list_state.collapsed) {
	          google_translate = document.querySelector('[data-widget="GoogleTranslate"]');
	          if (google_translate != null) {
	            google_translate.style.display = "none";
	          }
	          list_el.style.transition = "max-height 1000ms ease";
	          padding_el = TABLET_SIZE() ? list_el.querySelector('.ListHeader-wrapper') : list_el;
	          sty = getComputedStyle(padding_el);
	          list_el.style.maxHeight = list_el.clientHeight + "px";
	          list_el.style.overflow = 'hidden';
	          list_el.style.maxHeight = "calc(" + el.clientHeight + "px + " + sty.paddingTop + " + " + sty.paddingBottom + ")";
	          return setTimeout(function() {
	            list_state.collapsed = !list_state.collapsed;
	            save(list_state);
	            return setTimeout(function() {
	              list_el.style.transition = '';
	              list_el.style.maxHeight = '';
	              list_el.style.overflow = '';
	              return setTimeout(function() {
	                return google_translate != null ? google_translate.style.display = "" : void 0;
	              }, 1000);
	            }, 100);
	          }, 1000);
	        } else {
	          list_state.collapsed = !list_state.collapsed;
	          return save(list_state);
	        }
	      }
	    });
	  };
	  return BUTTON({
	    className: "CollapseList " + (is_collapsed ? 'collapsed' : 'expanded'),
	    'aria-label': translator('accessibility-expand-or-collapse-list', 'Expand or collapse list.'),
	    'aria-pressed': !is_collapsed,
	    onClick: function(e) {
	      toggle_list(e.target);
	      document.activeElement.blur();
	      return e.stopPropagation();
	    },
	    'aria-hidden': true
	  }, !TABLET_SIZE() ? double_up_icon(COLLAPSE_ICON_SIZE) : ChevronRight(18));
	};
	
	styles += ".LIST-description {\n  font-size: 16px;\n  font-weight: 400;\n  color: black;\n  margin-top: 14px;\n  margin-bottom: 18px;\n  padding: 0px var(--AVATAR_SIZE_AND_GUTTER);\n  /* font-style: italic; */\n}\n\n@media " + PHONE_MEDIA + " {\n  .LIST-description {\n    padding: 0px 0px;\n  }\n}\n\n.LIST-description.single-line {\n  text-align: center;\n}\n";
	
	EditableDescription = ReactiveComponent({
	  displayName: 'EditableDescription',
	  getDescription: function() {
	    var description, list, list_key;
	    list = this.props.list;
	    list_key = list.key;
	    description = customization('list_description', list_key);
	    if (Array.isArray(description)) {
	      description = description.join('\n');
	    }
	    return description;
	  },
	  setAlignment: function() {
	    var description, height, is_func, single_line;
	    description = this.getDescription();
	    is_func = typeof description === 'function';
	    if (!is_func) {
	      if (!this.refs.description) {
	        return;
	      }
	      height = this.refs.description.clientHeight;
	      single_line = height < 24;
	      if (single_line) {
	        return this.refs.description.classList.add('single-line');
	      } else {
	        return this.refs.description.classList.remove('single-line');
	      }
	    }
	  },
	  componentDidMount: function() {
	    return this.setAlignment();
	  },
	  componentDidUpdate: function() {
	    return this.setAlignment();
	  },
	  render: function() {
	    var current_user, description, description_style, is_func, list, list_key;
	    current_user = fetch('/current_user');
	    list = this.props.list;
	    list_key = list.key;
	    description = this.getDescription();
	    if (!description) {
	      return SPAN(null);
	    }
	    is_func = typeof description === 'function';
	    description_style = customization('list_description_style', list_key);
	    WINDOW_WIDTH();
	    return DIV({
	      style: _.defaults({}, description_style || {}),
	      className: "LIST-description " + (!is_func ? 'wysiwyg_text' : ''),
	      ref: 'description'
	    }, is_func ? description() : DIV({
	      style: {
	        marginBottom: 10
	      },
	      dangerouslySetInnerHTML: {
	        __html: description
	      }
	    }));
	  }
	});
	
	styles += ".list_actions_wrapper {\n  margin: 24px 0;\n}\n.ListActions {\n  display: flex;\n  align-items: baseline;\n\n  flex-direction: row;\n\n  position: relative;\n  left: calc(-1 * var(--LIST_PADDING_LEFT));\n  width: calc(100% + var(--LIST_PADDING_LEFT) + var(--LIST_PADDING_RIGHT) );\n}\n\n.opinion-view-container {\n  flex-shrink: 0;  \n  width: var(--ITEM_OPINION_WIDTH);  \n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .ListActions {\n    flex-direction: column;\n    align-items: center;\n    width: calc(var(--AVATAR_SIZE_AND_GUTTER) + var(--ITEM_TEXT_WIDTH));\n    left: 0;\n    margin: auto;\n  }\n\n  .opinion-view-container {  \n    width: auto;  \n  }\n}\n\n.sort_menu_wrapper {\n  width: 100%;\n  margin-left: var(--AVATAR_SIZE_AND_GUTTER); \n  display: flex;\n}\n";
	
	window.ListActions = function(props) {
	  var list_key, sort_key;
	  list_key = props.list.key;
	  return DIV({
	    className: 'list_actions_wrapper'
	  }, DIV({
	    className: 'ListActions'
	  }, DIV({
	    className: 'proposal-left-spacing'
	  }), DIV({
	    className: 'sort_menu_wrapper'
	  }, !TABLET_SIZE() && props.can_sort ? SortProposalsMenu() : void 0, !props.fresh ? (sort_key = "sorted-proposals-" + list_key, SPAN({
	    style: {
	      display: 'inline-block',
	      marginLeft: 12
	    }
	  }, ManualProposalResort({
	    sort_key: sort_key
	  }))) : void 0), DIV({
	    className: 'proposal-slidergram-spacing'
	  }), DIV({
	    className: 'opinion-view-container'
	  }, OpinionViews({
	    ui_key: "opinion-views-" + list_key,
	    style: {
	      marginBottom: 20
	    }
	  })), DIV({
	    className: "proposal-score-spacing"
	  })), DIV(null, OpinionViewInteractionWrapper({
	    ui_key: "opinion-views-" + list_key,
	    more_views_positioning: TABLET_SIZE() ? 'centered' : 'right',
	    width: ITEM_OPINION_WIDTH() + AVATAR_SIZE_AND_GUTTER() + ITEM_TEXT_WIDTH()
	  })));
	};
	
	window.get_list_title = function(list_key, include_category_value, subdomain) {
	  var title;
	  if (subdomain == null) {
	    subdomain = fetch('/subdomain');
	  }
	  title = customization('list_title', list_key, subdomain);
	  if (include_category_value) {
	    if (title == null) {
	      title = category_value(list_key, null, subdomain);
	    }
	  }
	  if (title === 'Show all' || (title == null)) {
	    title = translator("engage.all_proposals_list", "All Proposals");
	  } else if (title === 'Proposals') {
	    title = translator("engage.default_proposals_list", "Proposals");
	  }
	  return title;
	};
	
	category_value = function(list_key, fresh, subdomain) {
	  var category;
	  category = customization('list_category', list_key, subdomain);
	  if (!category && !customization(list_key, null, subdomain) && !fresh) {
	    if (category == null) {
	      category = list_key.substring(5);
	    }
	  }
	  if (category == null) {
	    category = translator('engage.default_proposals_list', 'Proposals');
	  }
	  return category;
	};
	
	window.get_all_lists = function() {
	  return fetch('/lists').lists || [];
	};
	
	window.get_all_lists_not_configured_for_a_page = function() {
	  var all_configured_lists, i, j, l, len1, len2, len3, lists, lst, m, ref, ref1, tab, unconfigured_lists;
	  lists = fetch('/lists').lists || [];
	  if (get_tabs()) {
	    all_configured_lists = {};
	    unconfigured_lists = {};
	    ref = get_tabs();
	    for (i = 0, len1 = ref.length; i < len1; i++) {
	      tab = ref[i];
	      ref1 = tab.lists;
	      for (j = 0, len2 = ref1.length; j < len2; j++) {
	        l = ref1[j];
	        if (l !== '*' && l !== '*-') {
	          all_configured_lists[l] = 1;
	        }
	      }
	    }
	    for (m = 0, len3 = lists.length; m < len3; m++) {
	      lst = lists[m];
	      if (!(lst in all_configured_lists)) {
	        unconfigured_lists[k] = 1;
	      }
	    }
	    return Object.keys(unconfigured_lists);
	  } else {
	    return [];
	  }
	};
	
	window.get_list_sort_method = function(tab) {
	  var ref;
	  if (tab == null) {
	    tab = get_current_tab_name();
	  }
	  return ((ref = get_tab(tab)) != null ? ref.list_sort_method : void 0) || customization('list_sort_method') || (customization('lists') || get_tabs() ? 'fixed' : 'newest_item');
	};
	
	window.get_list_for_proposal = function(proposal) {
	  if (!proposal.key) {
	    proposal = fetch(proposal);
	  }
	  return "list/" + ((proposal.cluster || 'Proposals').trim());
	};
	
	lists_ordered_by_most_recent_update = {};
	
	lists_ordered_by_randomized = {};
	
	window.get_lists_for_page = function(tab) {
	  var a_tab, by_random, by_recency, current_time, eligible_lists, homepage_tabs, i, j, len1, len2, len3, len4, len5, len6, len7, len8, len9, list, list_sort_method, lists, lists_in_tab, ll, lst, m, n, o, proposal, proposals, q, r, ready, ref, ref1, ref2, referenced_elsewhere, s, server_lst, t, tabs_config, time;
	  homepage_tabs = fetch('homepage_tabs');
	  if (tab == null) {
	    tab = get_current_tab_name();
	  }
	  tabs_config = get_tabs();
	  lists = get_all_lists();
	  if (tabs_config) {
	    eligible_lists = (ref = get_tab(tab)) != null ? ref.lists : void 0;
	  } else {
	    eligible_lists = customization('lists');
	    if (eligible_lists && indexOf.call(eligible_lists, '*-') >= 0) {
	      console.error("Illegal wildcard *- in lists customization");
	    }
	  }
	  if (!eligible_lists) {
	    eligible_lists = ['*'];
	  }
	  lists_in_tab = [];
	  for (i = 0, len1 = eligible_lists.length; i < len1; i++) {
	    list = eligible_lists[i];
	    if (list === '*' || (list === '*-' && !tabs_config)) {
	      for (j = 0, len2 = lists.length; j < len2; j++) {
	        ll = lists[j];
	        if (indexOf.call(eligible_lists, ll) < 0) {
	          lists_in_tab.push(ll);
	        }
	      }
	    } else if (list === '*-') {
	      referenced_elsewhere = {};
	      for (m = 0, len3 = tabs_config.length; m < len3; m++) {
	        a_tab = tabs_config[m];
	        if (a_tab.name === tab) {
	          continue;
	        }
	        ref1 = a_tab.lists;
	        for (n = 0, len4 = ref1.length; n < len4; n++) {
	          ll = ref1[n];
	          if (ll !== '*' && ll !== '*-') {
	            referenced_elsewhere[ll] = true;
	          }
	        }
	      }
	      for (o = 0, len5 = lists.length; o < len5; o++) {
	        ll = lists[o];
	        if (!(ll in referenced_elsewhere) && indexOf.call(eligible_lists, ll) < 0) {
	          lists_in_tab.push(ll);
	        }
	      }
	    } else {
	      lists_in_tab.push(list);
	    }
	  }
	  list_sort_method = get_list_sort_method(tab);
	  if (list_sort_method === 'newest_item') {
	    if (lists_ordered_by_most_recent_update[tab] == null) {
	      lists_ordered_by_most_recent_update[tab] = {};
	    }
	    by_recency = lists_ordered_by_most_recent_update[tab];
	    current_time = (new Date()).getTime();
	    ready = true;
	    for (q = 0, len6 = lists_in_tab.length; q < len6; q++) {
	      lst = lists_in_tab[q];
	      server_lst = '/' + lst;
	      if (!((ref2 = arest.cache[server_lst]) != null ? ref2.proposals : void 0)) {
	        fetch(server_lst).proposals || [];
	        ready = false;
	      }
	    }
	    if (!ready || lists_in_tab.length === 0) {
	      return lists_in_tab;
	    }
	    if (Object.keys(by_recency).length !== lists_in_tab.length) {
	      for (r = 0, len7 = lists_in_tab.length; r < len7; r++) {
	        lst = lists_in_tab[r];
	        proposals = fetch('/' + lst).proposals || [];
	        by_recency[lst] = -1;
	        for (s = 0, len8 = proposals.length; s < len8; s++) {
	          proposal = proposals[s];
	          time = new Date(proposal.created_at).getTime();
	          if (!by_recency[lst] || time > by_recency[lst]) {
	            by_recency[lst] = time;
	          }
	        }
	      }
	    }
	    lists_in_tab.sort(function(a, b) {
	      return ((current_time - by_recency[a]) || 99999999999) - ((current_time - by_recency[b]) || 99999999999);
	    });
	  } else if (list_sort_method === 'randomized') {
	    if (lists_ordered_by_randomized[tab] == null) {
	      lists_ordered_by_randomized[tab] = {};
	    }
	    by_random = lists_ordered_by_randomized[tab];
	    if (Object.keys(by_random).length !== lists_in_tab.length) {
	      for (t = 0, len9 = lists_in_tab.length; t < len9; t++) {
	        lst = lists_in_tab[t];
	        by_random[lst] = Math.random();
	      }
	    }
	    lists_in_tab.sort(function(a, b) {
	      return (by_random[a] || 99999999999) - (by_random[b] || 99999999999);
	    });
	  }
	  return lists_in_tab;
	};
	
	window.get_proposals_in_list = function(list_key) {
	  var list;
	  list = fetch("/" + list_key);
	  return list.proposals;
	};
	
	window.get_list = function(list_key) {
	  var lst;
	  if (list_key.key) {
	    return list_key;
	  }
	  return lst = _.extend({}, customization(list_key), {
	    key: list_key,
	    proposals: get_proposals_in_list(list_key)
	  });
	};
	
	window.lists_current_user_can_add_to = function(lists) {
	  var appendable, i, len1, list_key;
	  appendable = [];
	  for (i = 0, len1 = lists.length; i < len1; i++) {
	    list_key = lists[i];
	    if (permit('create proposal', list_key) > 0) {
	      appendable.push(list_key);
	    }
	  }
	  return appendable;
	};


/***/ },
/* 26 */
/***/ function(module, exports) {

	window.SubdomainSaveRateLimiter = {
	  save_customization_with_rate_limit: function(arg) {
	    var changed, config, f, fields, force_save, i, len, on_save_callback, subdomain, val, wait_for;
	    fields = arg.fields, config = arg.config, force_save = arg.force_save, on_save_callback = arg.on_save_callback, wait_for = arg.wait_for;
	    subdomain = fetch('/subdomain');
	    if (config == null) {
	      config = subdomain.customizations;
	    }
	    if (fields == null) {
	      fields = [];
	    }
	    changed = force_save;
	    for (i = 0, len = fields.length; i < len; i++) {
	      f = fields[i];
	      val = this.local[f];
	      if ((val != null) && JSON.stringify(val) !== JSON.stringify(config[f])) {
	        if (val === '*delete*') {
	          if (config[f] != null) {
	            delete config[f];
	            changed = true;
	          }
	        } else {
	          config[f] = val;
	          changed = true;
	        }
	      }
	    }
	    if (changed) {
	      this.save_in = wait_for || 1000;
	      return this.save_interval != null ? this.save_interval : this.save_interval = setInterval((function(_this) {
	        return function() {
	          _this.save_in -= 500;
	          if (_this.save_in <= 0) {
	            console.log("SAVING SUBDOMAIN", fields);
	            save(subdomain, function() {
	              return typeof on_save_callback === "function" ? on_save_callback() : void 0;
	            });
	            clearInterval(_this.save_interval);
	            return _this.save_interval = void 0;
	          }
	        };
	      })(this), 500);
	    }
	  }
	};
	
	window.HomepageTabTransition = ReactiveComponent({
	  displayName: "HomepageTabTransition",
	  render: function() {
	    var default_tab, find_tab, k, kk, loc, look_for_tab_for_proposal, ref, ref1, result, slug, tab_state, tab_state_changing, v, vv;
	    if (get_tabs()) {
	      loc = fetch('location');
	      tab_state = fetch('homepage_tabs');
	      default_tab = customization('homepage_default_tab') || ((ref = get_tabs()[0]) != null ? ref.name : void 0) || 'Show all';
	      tab_state_changing = loc.query_params.tab && loc.query_params.tab !== tab_state.active_tab;
	      if ((tab_state.active_tab == null) || tab_state_changing) {
	        if (loc.query_params.tab && get_tab(decodeURIComponent(loc.query_params.tab))) {
	          tab_state.active_tab = decodeURIComponent(loc.query_params.tab);
	        } else if (is_a_dialogue_page() && loc.url !== '/') {
	          slug = loc.url.substring(1);
	          find_tab = null;
	          look_for_tab_for_proposal = (function(_this) {
	            return function() {
	              var key, list, page, proposal, tab;
	              key = "/page/" + slug;
	              page = arest.cache[key];
	              _this.checked_times += 1;
	              proposal = null;
	              if (page != null ? page.proposal : void 0) {
	                proposal = fetch(page.proposal);
	                if (proposal.name) {
	                  list = get_list_for_proposal(proposal);
	                  tab = get_page_for_list(list);
	                  tab_state.active_tab = tab;
	                  save(tab_state);
	                  if (find_tab !== null) {
	                    clearInterval(find_tab);
	                  }
	                }
	              }
	              if (_this.checked_times > 100 && find_tab !== null) {
	                clearInterval(find_tab);
	              }
	              return !!proposal;
	            };
	          })(this);
	          result = look_for_tab_for_proposal();
	          if (!result) {
	            this.checked_times = 0;
	            find_tab = setInterval(look_for_tab_for_proposal, 100);
	          }
	        } else {
	          tab_state.active_tab = default_tab;
	        }
	        if (tab_state_changing) {
	          ref1 = arest.cache;
	          for (k in ref1) {
	            v = ref1[k];
	            if (k.startsWith('proposal_expansions-')) {
	              for (kk in v) {
	                vv = v[kk];
	                v[kk] = false;
	              }
	            }
	          }
	        }
	        save(tab_state);
	      }
	      if (loc.query_params.tab !== tab_state.active_tab) {
	        loc.query_params.tab = tab_state.active_tab;
	        save(loc);
	      }
	    }
	    return SPAN(null);
	  }
	});
	
	window.get_tabs = function() {
	  var idx, ref, ref1, tabs;
	  if (((ref = fetch('/subdomain').customizations) != null ? (ref1 = ref.homepage_tabs) != null ? ref1.length : void 0 : void 0) > 0) {
	    tabs = fetch('/subdomain').customizations.homepage_tabs;
	    idx = tabs.length - 1;
	    while (idx >= 0) {
	      if (tabs[idx].name === null) {
	        tabs.splice(idx, 1);
	      }
	      idx -= 1;
	    }
	    return tabs;
	  } else {
	    return null;
	  }
	};
	
	window.get_tab = function(name) {
	  var i, len, ref, tab;
	  if (name == null) {
	    name = get_current_tab_name();
	  }
	  ref = get_tabs() || [];
	  for (i = 0, len = ref.length; i < len; i++) {
	    tab = ref[i];
	    if (tab.name === name) {
	      return tab;
	    }
	  }
	  return null;
	};
	
	window.get_current_tab_name = function() {
	  return fetch('homepage_tabs').active_tab || null;
	};
	
	window.get_current_tab_view = function(args) {
	  var custom_view, i, len, tab, tabs, view;
	  tabs = customization('homepage_tabs');
	  if (!tabs) {
	    return SimpleHomepage(args);
	  }
	  custom_view = null;
	  for (i = 0, len = tabs.length; i < len; i++) {
	    tab = tabs[i];
	    if (tab.name === get_current_tab_name()) {
	      if (tab.render_page) {
	        custom_view = tab.render_page;
	      }
	      break;
	    }
	  }
	  if (!custom_view) {
	    custom_view = customization('render_page');
	  }
	  if (custom_view) {
	    view = custom_view(args);
	    if (typeof view === 'function') {
	      view = view(args);
	    }
	    return view;
	  } else {
	    return SimpleHomepage(args);
	  }
	};
	
	window.get_page_preamble = function(tab_name) {
	  var preamble, tab;
	  if (tab = get_tab(tab_name)) {
	    return preamble = tab.page_preamble;
	  } else {
	    return preamble = customization('page_preamble');
	  }
	};
	
	window.create_new_tab = function(tab_name) {
	  var idx, new_tab, new_tab_name, subdomain, tabs;
	  subdomain = fetch('/subdomain');
	  tabs = get_tabs();
	  idx = 2;
	  new_tab_name = tab_name;
	  while (!!get_tab(new_tab_name)) {
	    new_tab_name = tab_name + "-" + idx;
	    idx += 1;
	  }
	  if (!tabs) {
	    tabs = subdomain.customizations.homepage_tabs = [];
	  }
	  new_tab = {
	    name: new_tab_name,
	    lists: []
	  };
	  if (tabs.length === 0) {
	    new_tab.lists = get_all_lists();
	  }
	  tabs.push(new_tab);
	  return save(subdomain, function() {
	    return setTimeout(function() {
	      var loc;
	      loc = fetch('location');
	      loc.query_params.tab = new_tab_name;
	      return save(loc);
	    });
	  });
	};
	
	window.delete_tab = function(tab_name, skip_confirmation) {
	  var i, idx, len, ref, ref1, ref2, subdomain, tab, tab_state;
	  subdomain = fetch('/subdomain');
	  if (skip_confirmation || (((ref = get_tab(tab_name).type) === null || ref === (void 0) || ref === PAGE_TYPES.DEFAULT) && ((ref1 = get_lists_for_page(tab_name)) != null ? ref1.length : void 0) === 0) || confirm(translator("homepage_tab.confirm-tab-deletion", "Are you sure you want to delete this tab? None of the lists in it will be deleted."))) {
	    idx = -1;
	    ref2 = get_tabs() || [];
	    for (idx = i = 0, len = ref2.length; i < len; idx = ++i) {
	      tab = ref2[idx];
	      if (tab.name === tab_name) {
	        break;
	      }
	    }
	    if (get_current_tab_name() === tab_name) {
	      tab_state = fetch('homepage_tabs');
	      tab_state.active_tab = null;
	      save(tab_state);
	    }
	    if (subdomain.customizations.homepage_default_tab === tab_name) {
	      delete subdomain.customizations.homepage_default_tab;
	    }
	    subdomain.customizations.homepage_tabs.splice(idx, 1);
	    if (subdomain.customizations.homepage_tabs.length === 0) {
	      delete subdomain.customizations.homepage_tabs;
	    }
	    return save(subdomain);
	  }
	};
	
	window.get_page_for_list = function(list_key) {
	  var i, j, len, len1, list, page, ref, ref1;
	  ref = get_tabs() || [];
	  for (i = 0, len = ref.length; i < len; i++) {
	    page = ref[i];
	    ref1 = get_lists_for_page(page.name);
	    for (j = 0, len1 = ref1.length; j < len1; j++) {
	      list = ref1[j];
	      if (list === list_key) {
	        return page.name;
	      }
	    }
	  }
	  return null;
	};
	
	styles += "#tabs {\n  width: 100%;\n  z-index: 2;\n  margin-bottom: -2px;\n  margin-top: 20px;\n  position: relative;\n}\n#tabs > ul {\n  margin: auto;\n  text-align: center;\n  list-style: none;\n  max-width: 900px;\n}\n\n#tabs.editing > ul {\n  padding-top: 26px;\n}\n\n";
	
	window.HomepageTabs = ReactiveComponent({
	  displayName: 'HomepageTabs',
	  render: function() {
	    var demo, edit_forum, homepage_tabs, idx, is_light, paid, ref, subdomain, tab, tabs;
	    homepage_tabs = fetch('homepage_tabs');
	    edit_forum = fetch('edit_forum');
	    subdomain = fetch('/subdomain');
	    tabs = (ref = get_tabs()) != null ? ref.slice() : void 0;
	    if (!edit_forum.editing && !tabs) {
	      return DIV(null);
	    }
	    is_light = is_light_background();
	    demo = false;
	    if (edit_forum.editing) {
	      if (!tabs || tabs.length === 0) {
	        demo = true;
	        if (tabs == null) {
	          tabs = [];
	        }
	        tabs.push({
	          name: "Tabs",
	          demo: true
	        });
	        tabs.push({
	          name: "Help Organize",
	          demo: true
	        });
	        tabs.push({
	          name: "Your Forum",
	          demo: true,
	          "default": true
	        });
	      } else {
	        tabs.push({
	          name: "add new Page",
	          add_new: true
	        });
	      }
	    }
	    paid = permit('configure paid feature') > 0;
	    return DIV({
	      id: 'tabs',
	      className: (demo ? 'demo' : '') + " " + (edit_forum.editing ? 'editing' : ''),
	      style: this.props.wrapper_style
	    }, edit_forum.editing ? DIV({
	      style: {
	        display: 'flex',
	        justifyContent: 'center'
	      }
	    }, LABEL({
	      className: 'toggle_switch',
	      style: {
	        pointerEvents: !paid ? 'none' : void 0,
	        opacity: !paid ? .4 : void 0
	      }
	    }, INPUT({
	      id: 'enable_tabs',
	      type: 'checkbox',
	      name: 'enable_tabs',
	      checked: !!get_tabs(),
	      onChange: function(ev) {
	        var i, len, loc, new_tab_name, ref1, ref2, results, tab;
	        if (ev.target.checked) {
	          loc = fetch('location');
	          new_tab_name = prompt("What is the name of the first tab? You'll be able to add more later.");
	          if (new_tab_name) {
	            create_new_tab(new_tab_name);
	            loc.query_params.tab = new_tab_name;
	            if (subdomain.customizations.lists != null) {
	              delete subdomain.customizations.lists;
	              return save(subdomain);
	            }
	          }
	        } else {
	          if (confirm(translator("homepage_tab.disable_confirmation", "Are you sure you want to disable tabs? Existing tabs will be deleted. All existing lists will still be visible."))) {
	            ref2 = ((ref1 = get_tabs()) != null ? ref1.slice() : void 0) || [];
	            results = [];
	            for (i = 0, len = ref2.length; i < len; i++) {
	              tab = ref2[i];
	              results.push(delete_tab(tab.name, true));
	            }
	            return results;
	          }
	        }
	      }
	    }), SPAN({
	      className: 'toggle_switch_circle'
	    })), LABEL({
	      className: 'toggle_switch_label',
	      style: {
	        backgroundColor: is_light ? 'rgba(255,255,255,.4)' : 'rgba(0,0,0,.4)'
	      },
	      htmlFor: paid ? 'enable_tabs' : void 0
	    }, B(null, 'Enable Tabs.'), DIV(null, "Tabs help organize your forum into different pages.")), !paid ? UpgradeForumButton({
	      text: 'upgrade'
	    }) : void 0) : void 0, A({
	      name: 'active_tab'
	    }), UL({
	      ref: 'tablist',
	      role: 'tablist',
	      style: _.defaults({}, this.props.list_style, {
	        width: this.props.width
	      })
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = tabs.length; i < len; idx = ++i) {
	        tab = tabs[idx];
	        results.push(Tab({
	          key: tab.name,
	          tab: tab,
	          idx: idx,
	          current: homepage_tabs.active_tab === tab.name || (demo && tab["default"]),
	          tab_style: this.props.tab_style,
	          tab_wrapper_style: this.props.tab_wrapper_style,
	          active_style: this.props.active_style,
	          active_tab_wrapper_style: this.props.active_tab_wrapper_style,
	          featured: this.props.featured === tab.name,
	          featured_insertion: this.props.featured_insertion,
	          go_to_hash: this.props.go_to_hash
	        }));
	      }
	      return results;
	    }).call(this)));
	  },
	  isDraggable: function() {
	    var edit_forum;
	    edit_forum = fetch('edit_forum');
	    return edit_forum.editing;
	  },
	  componentDidMount: function() {
	    return this.initializeDragging();
	  },
	  componentDidUpdate: function() {
	    return this.initializeDragging();
	  },
	  initializeDragging: function() {
	    var tab_root;
	    if (!this.isDraggable() && this.drag_initialized) {
	      this.drag_initialized = false;
	      return this.draggable.destroy();
	    } else if (this.isDraggable() && !this.drag_initialized) {
	      this.drag_initialized = true;
	      tab_root = this.refs.tablist;
	      this.draggable = new Draggable.Sortable(tab_root, {
	        draggable: '.tab.tab-added.not-demo',
	        distance: 1
	      });
	      return this.draggable.on('sortable:stop', (function(_this) {
	        return function(arg) {
	          var data, from, subdomain, tabs, to;
	          data = arg.data;
	          from = data.oldIndex;
	          to = data.newIndex;
	          subdomain = fetch('/subdomain');
	          tabs = subdomain.customizations.homepage_tabs;
	          tabs.splice(to, 0, tabs.splice(from, 1)[0]);
	          return save(subdomain);
	        };
	      })(this));
	    }
	  }
	});
	
	styles += "#tabs > ul > li {\n  display: inline-block;\n  position: relative;\n  outline: none;\n}  \n\n.dragging-list #tabs > ul > li[data-accepts-lists=\"true\"] {\n  outline: 4px solid black;\n}\n\n.dragging-list .dark #tabs > ul > li[data-accepts-lists=\"true\"] {\n  outline: 4px solid white;\n}\n\n.dragging-list #tabs > ul > li.draggedOver-by_list[data-accepts-lists=\"true\"],\n.dragging-list .dark #tabs > ul > li.draggedOver-by_list[data-accepts-lists=\"true\"] {\n  outline: 4px solid red;\n}\n\n#tabs > ul > li[draggable=\"false\"].demo:not(.add_new):not(.selected) {\n  opacity: .5;\n  pointer-events: none;\n}\n\n\n#tabs > ul > li > h4 {\n  cursor: pointer;\n  position: relative;\n  padding: 10px 20px 4px 20px;\n  font-size: 16px;\n  font-weight: 600;        \n  color: white;\n}\n#tabs > ul > li.selected > h4 {\n  opacity: 1;\n  color: black;\n}\n#tabs > ul > li:hover > h4,\n#tabs > ul > li:focus-within > h4 {\n  opacity: 1;\n}\n\n#tabs > ul > li > h4 > input {\n  background-color: transparent;\n  border: 1px solid #ccc;\n  letter-spacing: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  color: inherit;\n  font-style: inherit;\n  min-width: 50px;\n  padding: 2px 4px;\n}\n\n#tabs > ul > li[draggable=\"false\"].demo.add_new {\n  background-color: transparent;\n}\n#tabs > ul > li[draggable=\"false\"].demo.add_new > h4 {\n  color: black;\n}  \n.dark #tabs > ul > li[draggable=\"false\"].demo.add_new > h4 {\n  color: white;\n}\n\n.tab.draggable-source--is-dragging {\n  opacity: .7;\n}\n";
	
	window.Tab = ReactiveComponent({
	  displayName: 'Tab',
	  mixins: [SubdomainSaveRateLimiter],
	  render: function() {
	    var accepts_lists, base, current, edit_forum, featured, ref, ref1, subdomain, tab, tab_name, tab_style, tab_wrapper_style;
	    subdomain = fetch('/subdomain');
	    edit_forum = fetch('edit_forum');
	    tab = this.props.tab;
	    tab_name = tab.name;
	    current = this.props.current;
	    featured = this.props.featured;
	    tab_style = _.extend({
	      display: 'inline-block'
	    }, this.props.tab_style);
	    tab_wrapper_style = _.extend({}, this.props.tab_wrapper_style);
	    if (current) {
	      _.extend(tab_style, this.props.active_style);
	      _.extend(tab_wrapper_style, this.props.active_tab_wrapper_style);
	    }
	    accepts_lists = ((ref = this.props.tab.type) !== PAGE_TYPES.ABOUT && ref !== PAGE_TYPES.ALL) && !tab.demo && !tab.add_new;
	    return LI({
	      className: "tab " + (current ? 'selected' : '') + " " + (tab.demo ? 'demo' : 'not-demo') + " " + (tab.add_new ? 'add_new' : 'tab-added'),
	      ref: 'tab',
	      tabIndex: 0,
	      role: 'tab',
	      style: tab_wrapper_style,
	      'data-tab': tab.name,
	      'aria-controls': 'homepagetab',
	      'aria-selected': current,
	      'data-accepts-lists': accepts_lists,
	      'data-page-name': tab_name,
	      onClick: (function(_this) {
	        return function() {
	          var el, loc, new_tab_name;
	          if (tab.demo && !tab.add_new) {
	            return;
	          }
	          loc = fetch('location');
	          if (tab.add_new) {
	            tab_name = new_tab_name = prompt("What is the name of the tab?");
	            if (tab_name) {
	              create_new_tab(new_tab_name);
	            }
	          } else {
	            tab_name = tab.name;
	            if (_this.props.go_to_hash) {
	              el = document.querySelector("[name='" + _this.props.go_to_hash + "']");
	              if (el) {
	                $$.ensureInView(el, {
	                  position: 'top',
	                  scroll: true
	                });
	              }
	            }
	          }
	          loc.query_params.tab = tab_name;
	          save(loc);
	          if (loc.url !== '/') {
	            loadPage('/', loc.query_params);
	          }
	          return document.activeElement.blur();
	        };
	      })(this)
	    }, edit_forum.editing && !tab.add_new && !tab.demo && get_tabs().length > 1 ? BUTTON({
	      style: {
	        cursor: 'move',
	        backgroundColor: 'transparent',
	        border: 'none'
	      }
	    }, drag_icon(15, '#888')) : void 0, H4({
	      className: current ? 'main_background' : void 0,
	      style: tab_style
	    }, tab.add_new ? SPAN(null, !tab.demo ? "+ " : void 0, SPAN({
	      style: {
	        textDecoration: 'underline'
	      }
	    }, translator({
	      id: "homepage_tab." + (((ref1 = get_tabs()) != null ? ref1.length : void 0) > 0 ? "add_more" : "enable") + "." + tab_name
	    }, tab_name))) : edit_forum.editing && tab_name === get_current_tab_name() ? INPUT({
	      className: "tab_name_input",
	      type: 'text',
	      defaultValue: tab_name,
	      style: {
	        fontSize: 'inherit',
	        color: 'inherit',
	        fontWeight: 'inherit',
	        fontDecoration: 'inherit',
	        fontStyle: 'inherit'
	      },
	      onKeyDown: (function(_this) {
	        return function(e) {
	          return e.stopPropagation();
	        };
	      })(this),
	      onClick: (function(_this) {
	        return function(e) {
	          return e.stopPropagation();
	        };
	      })(this),
	      onBlur: (function(_this) {
	        return function(e) {
	          var el;
	          if (e.target.value !== "") {
	            if (subdomain.customizations.homepage_default_tab === tab.name) {
	              subdomain.customizations.homepage_default_tab = e.target.value;
	            }
	            tab.name = e.target.value;
	            el = e.target;
	            return _this.save_customization_with_rate_limit({
	              force_save: true,
	              wait_for: 10,
	              on_save_callback: function() {
	                var loc;
	                loc = fetch('location');
	                loc.query_params.tab = tab.name;
	                return save(loc);
	              }
	            });
	          }
	        };
	      })(this)
	    }) : !subdomain.name ? '...' : translator({
	      id: "homepage_tab.name." + tab_name,
	      local: tab_name !== 'Show all'
	    }, tab_name)), edit_forum.editing && tab_name === get_current_tab_name() && !tab.demo ? BUTTON({
	      style: {
	        display: 'inline-block',
	        backgroundColor: 'transparent',
	        border: 'none',
	        cursor: 'pointer'
	      },
	      onClick: function() {
	        return delete_tab(tab.name);
	      }
	    }, trash_icon(15, 15, '#888')) : void 0, featured ? typeof (base = this.props).featured_insertion === "function" ? base.featured_insertion() : void 0 : void 0);
	  }
	});


/***/ },
/* 27 */
/***/ function(module, exports) {

	(function() {
	  var app, app_meta, container, i, len, meta, metas, root, style;
	  app = 'franklin';
	  metas = document.getElementsByTagName('meta');
	  app_meta = null;
	  for (i = 0, len = metas.length; i < len; i++) {
	    meta = metas[i];
	    if (meta.getAttribute('name') === 'app') {
	      app = meta.getAttribute('content');
	      app_meta = meta;
	      break;
	    }
	  }
	  if (!app) {
	    throw "Application not defined";
	  }
	  if (app !== 'franklin' && app !== 'proposal_embed') {
	    return;
	  }
	  style = document.createElement('style');
	  style.type = 'text/css';
	  if (style.styleSheet) {
	    style.styleSheet.cssText = window.styles;
	  } else {
	    style.appendChild(document.createTextNode(window.styles));
	  }
	  document.body.appendChild(style);
	  container = document.getElementById('content');
	  root = ReactDOM.createRoot(container);
	  return setTimeout(function() {
	    switch (app) {
	      case 'franklin':
	        if (typeof ahoy !== "undefined" && ahoy !== null) {
	          ahoy.configure({
	            cookies: false
	          });
	        }
	        return root.render(Franklin());
	      case 'proposal_embed':
	        return root.render(ProposalEmbed({
	          proposal: app_meta.getAttribute('proposal')
	        }));
	    }
	  });
	})();


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var OTHER_SEPARATOR;
	
	__webpack_require__(5);
	
	window.HostQuestions = ReactiveComponent({
	  displayName: 'CreateAccount',
	  mixins: [AuthForm, Modal],
	  render: function() {
	    var auth, avatar_url, current_user, i18n, title;
	    i18n = this.i18n();
	    auth = fetch('auth');
	    current_user = fetch('/current_user');
	    return this.Draw({
	      task: translator('auth.additional_info.heading', 'Questions from your host'),
	      disallow_cancel: true,
	      goal: auth.goal ? translator("auth.login_goal." + (auth.goal.toLowerCase()), auth.goal) : void 0,
	      on_submit: (function(_this) {
	        return function(ev) {
	          return _this.Submit(ev, {
	            action: 'user questions',
	            has_host_questions: true,
	            onSuccess: function() {
	              auth.show_user_questions_after_account_creation = false;
	              return save(auth);
	            }
	          });
	        };
	      })(this),
	      under_submit: customization('user_tags').length > 1 || !customization('user_tags')[0].key.match('pledge_taken') ? DIV({
	        style: {
	          fontSize: 13,
	          color: auth_text_gray,
	          padding: '16px 0',
	          textAlign: 'center'
	        }
	      }, "By proceeding, you consent to the collection of the above data on behalf of the Forum Host. You can edit your responses later in your User Profile.") : void 0,
	      render_below_title: function() {
	        var host_framing;
	        host_framing = customization('host_questions_framing');
	        if (host_framing) {
	          return DIV({
	            style: {
	              marginBottom: 12,
	              textAlign: host_framing.length > 80 ? 'left' : void 0
	            }
	          }, DIV({
	            style: {
	              fontSize: 14,
	              marginTop: 0
	            },
	            dangerouslySetInnerHTML: {
	              __html: host_framing
	            }
	          }));
	        } else {
	          return SPAN(null);
	        }
	      }
	    }, DIV(null, (function() {
	      var ref;
	      if (embedded_demo() && fetch('/subdomain').name === 'galacticfederation' && ((ref = fetch('local_tags').tags) != null ? ref.federation_allegiance : void 0)) {
	        switch (current_user.tags.federation_allegiance) {
	          case 'Dark':
	            avatar_url = "https://d2rtgkroh5y135.cloudfront.net/system/avatars/287330/large/stormtrooper1.png";
	            title = 'A Stormtrooper';
	            break;
	          case 'Light':
	            avatar_url = "https://f.consider.it/galacticfederation/ewok.png";
	            title = 'An Ewok';
	            break;
	          case "Wouldn't you like to know":
	            avatar_url = 'https://f.consider.it/galacticfederation/wookiee.jpeg';
	            title = 'A Wookiee';
	            break;
	          case 'Non-binary':
	            avatar_url = 'https://f.consider.it/galacticfederation/rodian.jpeg';
	            title = 'A Rodian';
	            break;
	        }
	        return DIV({
	          style: {
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 36
	          }
	        }, "In this parody, you'll participate as:", IMG({
	          "data-tooltip": title,
	          src: avatar_url,
	          style: {
	            height: 70,
	            marginLeft: 24,
	            borderRadius: '50%'
	          }
	        }));
	      }
	    })(), ShowHostQuestions({
	      disable_unchecking_required_booleans: this.props.disable_unchecking_required_booleans
	    }), customization('auth_footer') ? DIV({
	      style: {
	        fontSize: 13,
	        color: auth_text_gray,
	        padding: '16px 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: customization('auth_footer')
	      }
	    }) : void 0, this.ShowErrors()));
	  }
	});
	
	window.forum_has_host_questions = function() {
	  var tag;
	  return ((function() {
	    var i, len, ref, results;
	    ref = customization('user_tags') || [];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      tag = ref[i];
	      if (tag.self_report) {
	        results.push(tag);
	      }
	    }
	    return results;
	  })()).length > 0;
	};
	
	window.errors_in_host_questions = function(responses) {
	  var errors, has_response, i, is_valid_input, len, question, ref, ref1, tag, vals;
	  errors = [];
	  ref = customization('user_tags') || [];
	  for (i = 0, len = ref.length; i < len; i++) {
	    vals = ref[i];
	    if (!vals.self_report) {
	      continue;
	    }
	    tag = vals.key;
	    question = vals.self_report;
	    if (question.required) {
	      has_response = ((ref1 = question.input) === 'checklist') || !!responses[tag];
	      if (!has_response || (question.require_checked && !responses[tag])) {
	        errors.push(translator({
	          id: 'auth.validation.missing_answer',
	          question: question.question
	        }, "\"{question}\" is required."));
	      }
	      is_valid_input = true;
	      if (question.validation) {
	        is_valid_input = question.validation(responses[tag]);
	      }
	      if (!is_valid_input && has_response) {
	        errors.push(translator({
	          id: 'auth.validation.invalid_answer',
	          response: responses[tag],
	          question: question.question
	        }, "{response} isn't a valid answer to \"{question}\"!"));
	      }
	    }
	  }
	  return errors;
	};
	
	styles += "#SHOWHOSTQUESTIONS {\n  /* padding: 0px 36px; */\n  margin-top: 18px;\n}\n\n#SHOWHOSTQUESTIONS .question {\n  margin-bottom: 36px;\n}\n\n#SHOWHOSTQUESTIONS .question-prompt {\n  display: block;\n  font-weight: 600;\n  font-size: 18px;   \n}\n\n.question_metadata {\n  font-size: 14px;\n  color: #333;\n}\n.question_metadata .optionality {\n  font-style: italic;\n  text-transform: capitalize;\n}";
	
	window.ShowHostQuestions = ReactiveComponent({
	  displayName: 'ShowHostQuestions',
	  render: function() {
	    var field_id, host_questions, label, question, render;
	    host_questions = this.HostQuestionInputs();
	    if (host_questions.length === 0) {
	      return SPAN(null);
	    }
	    return DIV({
	      id: 'SHOWHOSTQUESTIONS'
	    }, UL({
	      style: {
	        padding: "6px 0px",
	        listStyle: 'none'
	      }
	    }, (function() {
	      var i, len, ref, ref1, ref2, ref3, results;
	      results = [];
	      for (i = 0, len = host_questions.length; i < len; i++) {
	        ref = host_questions[i], label = ref[0], render = ref[1], question = ref[2];
	        field_id = (render != null ? (ref1 = render.props) != null ? ref1.id : void 0 : void 0) || (render != null ? (ref2 = render[0]) != null ? (ref3 = ref2.props) != null ? ref3.id : void 0 : void 0 : void 0);
	        results.push(LI({
	          key: label,
	          className: 'question'
	        }, LABEL({
	          className: 'question-prompt',
	          htmlFor: field_id
	        }, SPAN({
	          style: {
	            paddingRight: !question.required ? 8 : void 0
	          },
	          dangerouslySetInnerHTML: {
	            __html: label
	          }
	        })), render, question.tag.indexOf('pledge_taken') === -1 ? DIV({
	          className: 'question_metadata'
	        }, SPAN({
	          className: 'optionality'
	        }, !question.required ? SPAN({
	          style: {
	            color: selected_color
	          }
	        }, translator('auth.optional_field', 'Optional')) : SPAN(null, translator('auth.required_field', 'Required'))), ". ", question.visibility === 'host-only' ? translator('auth.host-only-response', 'Your response will only be shared with the Forum Host.') : translator('auth.public-visibility-response', 'Your response will be visible to any participant.')) : void 0));
	      }
	      return results;
	    })()));
	  },
	  HostQuestionInputs: function() {
	    var auth, current_user, fn, i, inputs, j, len, len1, local, question, questions, ref, subdomain, tag, vals;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    local = fetch('local_tags');
	    if (!current_user.tags) {
	      return DIV();
	    }
	    questions = [];
	    ref = customization('user_tags') || [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      vals = ref[i];
	      tag = vals.key;
	      if (vals.self_report) {
	        questions.push(_.extend({}, vals.self_report, {
	          tag: tag
	        }, {
	          visibility: vals.visibility
	        }));
	      }
	    }
	    if (local.tags !== current_user.tags) {
	      local.tags = current_user.tags;
	      save(local);
	      return SPAN(null);
	    }
	    inputs = [];
	    fn = (function(_this) {
	      return function(question) {
	        var input, label, option, ref1, ref2, value;
	        label = "" + question.question;
	        switch (question.input) {
	          case 'text':
	            input = INPUT({
	              key: label,
	              style: _.defaults(question.input_style || {}, {
	                marginBottom: 6,
	                width: 300,
	                border: "1px solid #a1a1a1",
	                padding: '5px 10px',
	                fontSize: 18
	              }),
	              key: question.tag + "_inputBox",
	              id: slugify(question.tag + "inputBox"),
	              type: 'text',
	              value: local.tags[question.tag],
	              onChange: (function(question) {
	                return function(event) {
	                  local.tags[question.tag] = current_user.tags[question.tag] = event.target.value;
	                  return save(local);
	                };
	              })(question),
	              onKeyPress: function(event) {
	                if (event.which === 13) {
	                  return _this.submitAuth(event);
	                }
	              }
	            });
	            break;
	          case 'boolean':
	            input = DIV({
	              key: label,
	              style: {
	                marginBottom: 6
	              }
	            }, INPUT({
	              id: slugify(question.tag + "inputBox"),
	              key: question.tag + "_inputBox",
	              type: 'checkbox',
	              className: 'bigger',
	              style: {
	                fontSize: 24,
	                verticalAlign: 'top',
	                marginTop: 5,
	                marginLeft: 0,
	                marginRight: 6
	              },
	              checked: local.tags[question.tag],
	              onChange: (function(question) {
	                return function(event) {
	                  local.tags[question.tag] = current_user.tags[question.tag] = event.target.checked;
	                  return save(local);
	                };
	              })(question)
	            }), LABEL({
	              htmlFor: slugify(question.tag + "inputBox"),
	              style: {
	                display: 'inline-block',
	                width: '90%',
	                paddingLeft: 8
	              }
	            }, SPAN({
	              dangerouslySetInnerHTML: {
	                __html: question.question
	              }
	            }), question.tag.indexOf('pledge_taken') > -1 ? SPAN({
	              title: translator('auth.required_field', 'Required')
	            }, "*") : void 0));
	            label = '';
	            break;
	          case 'checklist':
	            input = DIV({
	              key: label,
	              style: {
	                margin: "10px 18px"
	              }
	            }, (function() {
	              var k, len2, ref1, results;
	              ref1 = question.options;
	              results = [];
	              for (k = 0, len2 = ref1.length; k < len2; k++) {
	                option = ref1[k];
	                results.push((function(_this) {
	                  return function(option) {
	                    var idx, is_checked, key, opt, options_checked, ref2, ref3;
	                    key = question.tag + "-" + option;
	                    options_checked = (function() {
	                      var l, len3, ref2, ref3, results1;
	                      ref3 = ((ref2 = current_user.tags[question.tag]) != null ? ref2.split(CHECKLIST_SEPARATOR) : void 0) || [];
	                      results1 = [];
	                      for (l = 0, len3 = ref3.length; l < len3; l++) {
	                        opt = ref3[l];
	                        results1.push(opt.split(OTHER_SEPARATOR)[0]);
	                      }
	                      return results1;
	                    })();
	                    is_checked = options_checked.indexOf(option) > -1;
	                    return DIV({
	                      key: key,
	                      style: {
	                        display: 'flex',
	                        alignItems: 'flex-start',
	                        marginBottom: 8
	                      }
	                    }, INPUT({
	                      id: slugify(key + "-inputBox"),
	                      key: key + "_inputBox",
	                      type: 'checkbox',
	                      className: 'bigger',
	                      style: {
	                        fontSize: 24,
	                        marginLeft: 0,
	                        marginTop: 5
	                      },
	                      checked: is_checked,
	                      onChange: (function(question, option) {
	                        return function(event) {
	                          var idx, int;
	                          if (event.target.checked) {
	                            options_checked.push(option);
	                          } else {
	                            idx = options_checked.indexOf(option);
	                            if (idx > -1) {
	                              options_checked.splice(idx, 1);
	                            }
	                          }
	                          local.tags[question.tag] = current_user.tags[question.tag] = options_checked.join(CHECKLIST_SEPARATOR);
	                          save(local);
	                          if (question.open_text_option === option && event.target.checked) {
	                            return int = setInterval(function() {
	                              if (_this.refs["open_value-" + question.tag] && !_this.refs["open_value-" + question.tag].getAttribute('disabled')) {
	                                _this.refs["open_value-" + question.tag].focus();
	                                return clearInterval(int);
	                              }
	                            }, 10);
	                          }
	                        };
	                      })(question, option)
	                    }), LABEL({
	                      htmlFor: slugify(key + "-inputBox"),
	                      style: {
	                        display: 'inline',
	                        paddingLeft: 12
	                      },
	                      dangerouslySetInnerHTML: {
	                        __html: option
	                      }
	                    }), question.open_text_option === option ? (idx = options_checked.indexOf(option), INPUT({
	                      ref: "open_value-" + question.tag,
	                      disabled: !is_checked,
	                      defaultValue: ((ref2 = current_user.tags[question.tag]) != null ? (ref3 = ref2.split(CHECKLIST_SEPARATOR)[idx]) != null ? ref3.split(OTHER_SEPARATOR)[1] : void 0 : void 0) || "",
	                      style: {
	                        display: 'inline-block',
	                        marginLeft: 12
	                      },
	                      type: 'text',
	                      onChange: (function(question, option) {
	                        return function(event) {
	                          var full_vals;
	                          full_vals = options_checked.slice();
	                          full_vals[idx] = "" + full_vals[idx] + OTHER_SEPARATOR + event.target.value;
	                          local.tags[question.tag] = current_user.tags[question.tag] = full_vals.join(CHECKLIST_SEPARATOR);
	                          return save(local);
	                        };
	                      })(question, option)
	                    })) : void 0);
	                  };
	                })(this)(option));
	              }
	              return results;
	            }).call(_this));
	            break;
	          case 'dropdown':
	            input = DIV({
	              key: question.tag + "-wrapper"
	            }, SELECT({
	              id: slugify(question.tag + "inputBox"),
	              key: question.tag + "_inputBox",
	              style: _.defaults(question.input_style || {}, {
	                fontSize: 18,
	                marginTop: 4,
	                maxWidth: '100%',
	                marginRight: 12,
	                marginBottom: 4
	              }),
	              defaultValue: (local.tags[question.tag] || '').split(OTHER_SEPARATOR)[0],
	              onChange: (function(question) {
	                return function(event) {
	                  var int;
	                  local.tags[question.tag] = current_user.tags[question.tag] = event.target.value;
	                  save(local);
	                  if (question.open_text_option === event.target.value) {
	                    return int = setInterval(function() {
	                      if (_this.refs["open_value-" + question.tag] && !_this.refs["open_value-" + question.tag].getAttribute('disabled')) {
	                        _this.refs["open_value-" + question.tag].focus();
	                        return clearInterval(int);
	                      }
	                    }, 10);
	                  }
	                };
	              })(question)
	            }, [
	              OPTION({
	                key: 'none',
	                value: '',
	                disabled: true,
	                hidden: true
	              }), (function() {
	                var k, len2, ref1, results;
	                ref1 = question.options;
	                results = [];
	                for (k = 0, len2 = ref1.length; k < len2; k++) {
	                  value = ref1[k];
	                  results.push(OPTION({
	                    key: value,
	                    value: value
	                  }, value));
	                }
	                return results;
	              })()
	            ]), question.open_text_option && question.open_text_option === ((ref1 = local.tags[question.tag]) != null ? ref1.split(OTHER_SEPARATOR)[0] : void 0) ? INPUT({
	              ref: "open_value-" + question.tag,
	              defaultValue: ((ref2 = current_user.tags[question.tag]) != null ? ref2.split(OTHER_SEPARATOR)[1] : void 0) || "",
	              style: {
	                display: 'inline-block'
	              },
	              type: 'text',
	              onChange: (function(question) {
	                return function(event) {
	                  var new_val;
	                  new_val = "" + (local.tags[question.tag].split(OTHER_SEPARATOR)[0]) + OTHER_SEPARATOR + event.target.value;
	                  local.tags[question.tag] = current_user.tags[question.tag] = new_val;
	                  return save(local);
	                };
	              })(question)
	            }) : void 0);
	            break;
	          default:
	            throw "Unsupported question type: " + question.input + " for " + question.tag;
	        }
	        return inputs.push([label, input, question]);
	      };
	    })(this);
	    for (j = 0, len1 = questions.length; j < len1; j++) {
	      question = questions[j];
	      fn(question);
	    }
	    return inputs;
	  }
	});
	
	window.CHECKLIST_SEPARATOR = ' ;;; ';
	
	OTHER_SEPARATOR = ' :: ';


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var toggle_modes;
	
	__webpack_require__(5);
	
	__webpack_require__(31);
	
	window.styles += "button.toggle_auth {\n  color: " + selected_color + ";\n  font-weight: 700;\n}";
	
	window.disallow_cancel = function() {
	  return permit('access forum') < 0;
	};
	
	toggle_modes = function() {
	  var auth, toggle_to;
	  auth = fetch('auth');
	  if (auth.form === 'create account') {
	    toggle_to = translator("auth.log_in", 'Log in');
	  } else {
	    toggle_to = translator("auth.login.toggle_to_create", 'Create an account');
	  }
	  return DIV({
	    style: {
	      textAlign: 'center'
	    }
	  }, DIV({
	    style: {
	      marginBottom: 12,
	      width: '100%'
	    }
	  }, SPAN({
	    style: {
	      fontWeight: 300,
	      fontSize: 16
	    }
	  }, auth.form === 'create account' ? TRANSLATE('auth.create.should_you_be_here', 'Already have an account?') : TRANSLATE('auth.login.should_you_be_here', 'Not registered?')), " ", BUTTON({
	    className: 'toggle_auth like_link',
	    onClick: (function(_this) {
	      return function(e) {
	        var current_user;
	        current_user = fetch('/current_user');
	        auth.form = auth.form === 'create account' ? 'login' : 'create account';
	        save(auth);
	        return setTimeout(function() {
	          var ref;
	          return (ref = document.getElementById('user_email')) != null ? ref.focus() : void 0;
	        }, 0);
	      };
	    })(this)
	  }, toggle_to)));
	};
	
	window.Login = ReactiveComponent({
	  displayName: 'Login',
	  mixins: [AuthForm, Modal, OAuthLogin],
	  render: function() {
	    var auth, i18n, on_submit;
	    i18n = this.i18n();
	    auth = fetch('auth');
	    on_submit = (function(_this) {
	      return function(ev) {
	        return _this.Submit(ev, {
	          action: 'login'
	        });
	      };
	    })(this);
	    return this.Draw({
	      task: translator("auth.login.heading", 'Login to Participate'),
	      goal: auth.goal ? translator("auth.login_goal." + (auth.goal.toLowerCase()), auth.goal) : void 0,
	      disallow_cancel: disallow_cancel(),
	      render_below_title: toggle_modes,
	      on_submit: on_submit,
	      submit_button: translator("auth.log_in", 'Log in')
	    }, DIV({
	      style: {
	        marginBottom: 36
	      }
	    }, this.WrapOAuth('login', DIV(null, this.RenderInput({
	      name: 'email',
	      type: 'email',
	      label: i18n.email_label,
	      on_submit: on_submit
	    }), this.RenderInput({
	      name: 'password',
	      type: 'password',
	      label: i18n.password_label,
	      on_submit: on_submit
	    }), this.resetPasswordLink(), this.ShowErrors(), customization('login_footer') ? (auth = fetch('auth'), auth.form === 'login' ? DIV({
	      style: {
	        fontSize: 13,
	        color: auth_text_gray,
	        padding: '16px 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: customization('login_footer')
	      }
	    }) : void 0) : void 0))));
	  },
	  resetPasswordLink: function() {
	    var reset;
	    reset = (function(_this) {
	      return function(e) {
	        var current_user, ref, ref1;
	        current_user = fetch('/current_user');
	        current_user.trying_to = 'send_password_reset_token';
	        if (((ref = _this.local.updates) != null ? (ref1 = ref.email) != null ? ref1.length : void 0 : void 0) > 0) {
	          current_user.email = _this.local.updates.email;
	        }
	        return save(current_user, function() {
	          var ref2;
	          if (((ref2 = current_user.errors) != null ? ref2.length : void 0) > 0) {
	            return arest.updateCache(current_user);
	          } else {
	            return reset_key('auth', {
	              form: 'reset password'
	            });
	          }
	        });
	      };
	    })(this);
	    return DIV({
	      style: {
	        textAlign: 'right',
	        width: '100%'
	      }
	    }, BUTTON({
	      style: {
	        textDecoration: 'underline',
	        color: '#333',
	        backgroundColor: 'transparent',
	        border: 'none',
	        fontSize: 12,
	        padding: 0,
	        position: 'relative',
	        top: -8,
	        fontWeight: 700
	      },
	      onClick: reset
	    }, translator('auth.forgot_password.link', 'Help! I forgot my password')));
	  }
	});
	
	window.CreateAccount = ReactiveComponent({
	  displayName: 'CreateAccount',
	  mixins: [AuthForm, Modal, OAuthLogin],
	  render: function() {
	    var auth, avatar_field, current_user, email_fields, form_name, i18n, on_submit;
	    i18n = this.i18n();
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    form_name = this.props.by_invitation ? 'create account via invitation' : 'create account';
	    avatar_field = AvatarInput();
	    on_submit = (function(_this) {
	      return function(ev) {
	        current_user.signed_pledge = document.querySelectorAll('.pledge-input').length === document.querySelectorAll('.pledge-input:checked').length;
	        if (forum_has_host_questions()) {
	          auth.show_user_questions_after_account_creation = true;
	          save(auth);
	        }
	        return _this.Submit(ev, {
	          action: form_name,
	          has_host_questions: false,
	          has_avatar_upload: true,
	          onSuccess: function() {
	            return typeof plausibleRegistrationEvent === "function" ? plausibleRegistrationEvent() : void 0;
	          }
	        });
	      };
	    })(this);
	    email_fields = DIV(null, this.RenderInput({
	      name: 'name',
	      label: i18n.name_label,
	      on_submit: on_submit
	    }), this.RenderInput({
	      name: 'email',
	      type: 'email',
	      label: i18n.email_label,
	      disabled: this.props.by_invitation ? true : void 0,
	      on_submit: on_submit
	    }), this.RenderInput({
	      name: 'password',
	      type: 'password',
	      label: i18n.password_label,
	      on_submit: on_submit
	    }), avatar_field ? DIV({
	      className: 'AUTH_field_wrapper',
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL({
	      className: 'AUTH_field_label'
	    }, i18n.pic_prompt, SPAN({
	      style: {
	        fontSize: 12,
	        color: "#666",
	        textTransform: 'lowercase',
	        marginLeft: 4,
	        display: 'inline-block'
	      }
	    }, " (" + (translator('optional', 'optional')) + ")")), avatar_field) : void 0);
	    return this.Draw({
	      task: this.props.by_invitation ? translator('auth.create-by-invitation.heading', 'Complete registration') : translator('auth.create.heading', 'Create your account'),
	      disallow_cancel: disallow_cancel(),
	      goal: auth.goal ? translator("auth.login_goal." + (auth.goal.toLowerCase()), auth.goal) : void 0,
	      on_submit: on_submit,
	      render_below_title: !this.props.by_invitation ? toggle_modes : void 0,
	      submit_button: translator("shared.auth.sign_up", "Sign up"),
	      under_submit: this.ConsideritTerms()
	    }, DIV({
	      style: {
	        marginBottom: 36
	      }
	    }, this.props.by_invitation ? email_fields : this.WrapOAuth('create_account', email_fields), this.ShowErrors(), customization('auth_footer') ? DIV({
	      style: {
	        fontSize: 13,
	        color: auth_text_gray,
	        padding: '16px 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: customization('auth_footer')
	      }
	    }) : void 0, customization('login_footer') ? (auth = fetch('auth'), auth.form === 'login' ? DIV({
	      style: {
	        fontSize: 13,
	        color: auth_text_gray,
	        padding: '16px 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: customization('login_footer')
	      }
	    }) : void 0) : void 0));
	  },
	  ConsideritTerms: function() {
	    var current_user, default_terms, terms;
	    current_user = fetch('/current_user');
	    default_terms = TRANSLATE({
	      id: 'auth.create.agree_to_terms',
	      as_html: true,
	      privacy_link: {
	        component: "a",
	        args: "href='/docs/legal/privacy_policy' style='font-weight: 700; color: " + selected_color + ";' target='_blank'"
	      },
	      terms_link: {
	        component: "a",
	        args: "href='/docs/legal/terms_of_service' style='font-weight: 700; color: " + selected_color + ";' target='_blank'"
	      },
	      br: {
	        component: 'br'
	      }
	    }, "By signing up, you agree to the Consider.it <privacy_link>Privacy Policy</privacy_link> and <terms_link>Terms of Service</terms_link>. <br>We will never sell your data to advertisers or other third-parties.");
	    terms = customization('terms') || default_terms.join('');
	    return DIV({
	      style: {
	        marginTop: 12,
	        fontSize: 13,
	        color: '#444',
	        textAlign: 'center'
	      },
	      dangerouslySetInnerHTML: {
	        __html: terms
	      }
	    });
	  }
	});


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(5);
	
	window.styles += "";
	
	window.ResetPassword = ReactiveComponent({
	  displayName: 'ResetPassword',
	  mixins: [AuthForm, Modal],
	  render: function() {
	    var i18n, on_submit;
	    i18n = this.i18n();
	    on_submit = (function(_this) {
	      return function(ev) {
	        return _this.Submit(ev, {
	          action: 'reset password'
	        });
	      };
	    })(this);
	    return this.Draw({
	      task: translator("auth.reset_password.heading", 'Reset Your Password'),
	      on_submit: on_submit
	    }, DIV(null, DIV({
	      style: {
	        color: auth_text_gray,
	        marginBottom: 18
	      }
	    }, i18n.verification_sent_message), INPUT({
	      name: 'user[verification_code]',
	      disabled: true,
	      style: {
	        display: 'none'
	      }
	    }), INPUT({
	      type: 'password',
	      name: 'user[password]',
	      disabled: true,
	      style: {
	        display: 'none'
	      }
	    }), this.RenderInput({
	      label: i18n.code_label,
	      name: 'verification_code',
	      on_submit: on_submit
	    }), this.RenderInput({
	      label: translator('auth.reset_password.new_pass', 'New password'),
	      type: 'password',
	      name: 'password',
	      on_submit: on_submit
	    }), this.ShowErrors(), DIV({
	      style: {
	        marginTop: 20,
	        textAlign: 'center'
	      }
	    }, TRANSLATE({
	      id: "auth.reset_password.help",
	      link: {
	        component: A,
	        args: {
	          target: '_blank',
	          href: 'https://vimeo.com/198802322',
	          style: {
	            textDecoration: 'underline',
	            fontWeight: 600
	          }
	        }
	      }
	    }, 'Having trouble resetting your password? Watch this brief <link>video tutorial</link>.'))));
	  }
	});


/***/ },
/* 31 */
/***/ function(module, exports) {

	var OAuthHandler, OAuth_providers;
	
	OAuthHandler = (function() {
	  function OAuthHandler(options) {
	    var callback, provider;
	    if (options == null) {
	      options = {};
	    }
	    provider = options.provider;
	    callback = options.callback;
	    if (provider === 'google') {
	      provider = 'google_oauth2';
	    }
	    this.callback = callback;
	    this.popup = this.openPopupWindow(location.protocol + "//" + (fetch('/subdomain').host) + "/auth/" + provider);
	  }
	
	  OAuthHandler.prototype.openPopupWindow = function(url) {
	    var cb, coords, openidpopup;
	    openidpopup = window.open(url, 'openid_popup', 'width=450,height=500,location=1,status=1,resizable=yes');
	    openidpopup.current_user_hash = null;
	    coords = this.getCenteredCoords(450, 500);
	    openidpopup.moveTo(coords[0], coords[1]);
	    cb = (function(_this) {
	      return function(event) {
	        if (event.source !== openidpopup) {
	          return;
	        }
	        _this.callback(event.data);
	        return window.removeEventListener("message", cb);
	      };
	    })(this);
	    window.addEventListener("message", cb, false);
	    return openidpopup;
	  };
	
	  OAuthHandler.prototype.getCenteredCoords = function(width, height) {
	    var parentPos, parentSize, xPos, yPos;
	    if (window.ActiveXObject) {
	      xPos = window.event.screenX - (width / 2) + 100;
	      yPos = window.event.screenY - (height / 2) - 100;
	    } else {
	      parentSize = [window.outerWidth, window.outerHeight];
	      parentPos = [window.screenX, window.screenY];
	      xPos = parentPos[0] + Math.max(0, Math.floor((parentSize[0] - width) / 2));
	      yPos = parentPos[1] + Math.max(0, Math.floor((parentSize[1] - (height * 1.25)) / 2));
	    }
	    yPos = 100;
	    return [xPos, yPos];
	  };
	
	  return OAuthHandler;
	
	})();
	
	OAuth_providers = ['google'];
	
	styles += ".oauth_wrapper {\n  display: flex;\n}\n\n.oauth_child_wrapper {\n  flex-grow: 4;\n}\n\n.oauth_providers_wrapper {\n  flex-grow: 0;\n}\n\n\n@media (min-width: 637px) {\n  .oauth_wrapper {\n\n  }\n\n  .oauth_child_wrapper {\n\n  }\n\n  .oauth_providers_wrapper {\n    border-left: 1px dashed #ccc;\n    margin-left: 40px;\n    padding: 15px 0 0 40px;\n  }\n}\n\n@media (max-width: 637px) {\n  .oauth_wrapper {\n    flex-direction: column;\n  }\n\n  .oauth_child_wrapper {\n\n  }\n\n  .oauth_providers_wrapper {\n    margin-top: 24px;\n  }\n}\n";
	
	window.OAuthLogin = {
	  startThirdPartyAuth: function(provider) {
	    var root;
	    root = fetch('root');
	    return new OAuthHandler({
	      provider: provider,
	      callback: (function(_this) {
	        return function(new_data) {
	          var auth, current_user, subdomain;
	          arest.updateCache(new_data);
	          subdomain = fetch('/subdomain');
	          if (subdomain.custom_url) {
	            current_user = fetch('/current_user');
	            current_user.trying_to = 'login';
	            save(current_user);
	          }
	          poll_until_avatar_arrives();
	          if (forum_has_host_questions() && fetch('/current_user').first_visit_to_forum) {
	            auth = fetch('auth');
	            auth.show_user_questions_after_account_creation = true;
	            return save(auth);
	          }
	        };
	      })(this)
	    });
	  },
	  WrapOAuth: function(form, children) {
	    return DIV({
	      className: 'oauth_wrapper'
	    }, DIV({
	      className: 'oauth_child_wrapper'
	    }, children), DIV({
	      className: 'oauth_providers_wrapper'
	    }, this.RenderOAuthProviders(form)));
	  },
	  RenderOAuthProviders: function(form) {
	    var current_user, provider, root, third_party_authenticated;
	    current_user = fetch('/current_user');
	    root = fetch('root');
	    third_party_authenticated = current_user.facebook_uid || current_user.twitter_uid || current_user.google_uid;
	    if (current_user.provider || third_party_authenticated) {
	      return SPAN(null);
	    }
	    return DIV({
	      className: 'third_party_auth'
	    }, LABEL(null, form === 'create_account' ? translator('auth.oauth.options_create-account', 'Or sign up using:') : translator('auth.oauth.options_login', 'Or log in using:')), (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = OAuth_providers.length; i < len; i++) {
	        provider = OAuth_providers[i];
	        results.push((function(_this) {
	          return function(provider) {
	            return BUTTON({
	              key: provider,
	              className: "third_party_option " + provider,
	              onClick: function() {
	                return _this.startThirdPartyAuth(provider);
	              }
	            }, provider === 'google' ? google_icon(22) : I({
	              className: "fa fa-" + provider
	            }), SPAN(null, provider));
	          };
	        })(this)(provider));
	      }
	      return results;
	    }).call(this));
	  }
	};
	
	styles += ".third_party_auth {\n  max-width: 75px;\n}\n.third_party_auth label {\n  font-size: 12px;\n  margin-bottom: 12px;\n  display: block;\n  white-space: nowrap;\n}\n.third_party_option.facebook span {\n  position: relative; \n  left: 12px;\n}\n.third_party_option {\n  border: 1px solid #bbb;\n  color: black;\n  width: 120px;\n  padding: 8px 0px;\n  margin-bottom: 12px;\n  text-align: center;\n  border-radius: 4px;\n  position: relative;\n  font-size: 11px;\n  text-transform: capitalize;\n  background-color: transparent;\n}\n\n.third_party_option svg {\n  vertical-align: middle;\n  position: relative; \n  left: -14px;\n}\n\n.third_party_option i {\n  display: inline-block;\n}\n\n.third_party_option i.fa-facebook {\n  color: #3C5997;\n  font-size: 24px;\n  position: relative;\n  left: -8px;\n  vertical-align: middle;\n}\n";


/***/ },
/* 32 */
/***/ function(module, exports) {

	window.AvatarInput = ReactiveComponent({
	  displayName: 'AvatarInput',
	  render: function() {
	    var base, current_user, img_preview_src, user;
	    if (!window.FormData) {
	      return SPAN(null);
	    }
	    current_user = fetch('/current_user');
	    user = fetch(fetch('/current_user').user);
	    if ((base = this.local).preview == null) {
	      base.preview = user.avatar_file_name || current_user.avatar_remote_url;
	    }
	    img_preview_src = this.local.newly_uploaded ? this.local.newly_uploaded : user.avatar_file_name ? avatarUrl(user, 'large') : current_user.avatar_remote_url ? current_user.avatar_remote_url : null;
	    return FORM({
	      id: 'user_avatar_form',
	      action: '/current_user'
	    }, DIV({
	      style: {
	        height: 60,
	        width: 60,
	        borderRadius: '50%',
	        backgroundColor: '#e6e6e6',
	        overflow: 'hidden',
	        display: 'inline-block',
	        marginRight: 18,
	        marginTop: 3
	      }
	    }, IMG({
	      alt: '',
	      id: 'avatar_preview',
	      ref: 'avatar_preview',
	      style: {
	        width: 60,
	        display: !this.local.preview ? 'none' : void 0
	      },
	      src: img_preview_src
	    }), !this.local.preview ? SVG({
	      width: 60,
	      viewBox: "0 0 100 100",
	      style: {
	        position: 'relative',
	        top: 8
	      }
	    }, PATH({
	      fill: "#ccc",
	      d: "M64.134,50.642c-0.938-0.75-1.93-1.43-2.977-2.023c8.734-6.078,10.867-18.086,4.797-26.805  c-6.086-8.727-18.086-10.875-26.82-4.797c-8.719,6.086-10.867,18.086-4.781,26.812c1.297,1.867,2.922,3.484,4.781,4.789  c-1.039,0.594-2.039,1.273-2.977,2.023c-6.242,5.031-11.352,11.312-15.023,18.438c-0.906,1.75-1.75,3.539-2.555,5.344  c17.883,16.328,45.266,16.328,63.133,0c-0.789-1.805-1.641-3.594-2.547-5.344C75.509,61.954,70.384,55.673,64.134,50.642z"
	    })) : void 0), INPUT({
	      id: 'user_avatar',
	      name: "avatar",
	      type: "file",
	      accept: "image/jpg, image/jpeg, image/pjpeg, image/png, image/x-png, image/gif, image/webp",
	      style: {
	        marginTop: 24,
	        verticalAlign: 'top'
	      },
	      onChange: (function(_this) {
	        return function(ev) {
	          var input, reader;
	          input = ev.target;
	          if (input.files && input.files[0]) {
	            reader = new FileReader();
	            reader.onload = function(e) {
	              _this.local.preview = true;
	              _this.local.newly_uploaded = e.target.result;
	              save(_this.local);
	              return _this.refs.avatar_preview.setAttribute('src', e.target.result);
	            };
	            return reader.readAsDataURL(input.files[0]);
	          } else {
	            return _this.refs.avatar_preview.setAttribute('src', asset('no_image_preview.png'));
	          }
	        };
	      })(this)
	    }));
	  }
	});
	
	window.upload_avatar = function() {
	  var avatar_file_input;
	  avatar_file_input = document.getElementById('user_avatar');
	  if ((avatar_file_input != null ? avatar_file_input.files.length : void 0) > 0) {
	    return ajax_submit_files_in_form({
	      type: 'PUT',
	      form: '#user_avatar_form',
	      additional_data: {
	        authenticity_token: arest.csrf(),
	        trying_to: 'update_avatar_hack'
	      },
	      success: function(resp) {
	        var errors, ref;
	        if (resp && (errors = (ref = JSON.parse(resp)[0]) != null ? ref.errors : void 0)) {
	          if (errors.length > 0) {
	            show_flash_error(errors[0]);
	          }
	        }
	        return poll_until_avatar_arrives();
	      },
	      error: function(problem) {
	        return console.error("Error uploading avatar", problem);
	      }
	    });
	  }
	};
	
	window.poll_until_avatar_arrives = function() {
	  var time_between, update_user;
	  time_between = 500;
	  update_user = function() {
	    var current_user, loading, user;
	    current_user = fetch('/current_user');
	    user = fetch(current_user.user || '/current_user');
	    if (!user.avatar_file_name) {
	      arest.serverFetch('/current_user');
	      time_between *= 1.5;
	      if (time_between < 100000) {
	        return setTimeout(update_user, time_between);
	      }
	    } else {
	      loading = fetch('avatar_loading');
	      if (loading.dummy == null) {
	        loading.dummy = 0;
	      }
	      loading.dummy += 1;
	      return save(loading);
	    }
	  };
	  return update_user();
	};


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(5);
	
	window.styles += "";
	
	window.VerifyEmail = ReactiveComponent({
	  displayName: 'VerifyEmail',
	  mixins: [AuthForm, Modal],
	  render: function() {
	    var auth, i18n, on_submit;
	    i18n = this.i18n();
	    auth = fetch('auth');
	    on_submit = (function(_this) {
	      return function(ev) {
	        return _this.Submit(ev, {
	          action: 'verify email'
	        });
	      };
	    })(this);
	    return this.Draw({
	      task: translator('auth.verify_email.heading', 'Verify Your Email'),
	      goal: auth.goal ? translator("auth.login_goal." + (auth.goal.toLowerCase()), auth.goal) : void 0,
	      on_submit: on_submit,
	      before_cancel: function() {
	        loadPage('/');
	        return setTimeout(logout, 1);
	      }
	    }, DIV(null, DIV({
	      style: {
	        color: auth_text_gray,
	        marginBottom: 18
	      }
	    }, i18n.verification_sent_message), this.RenderInput({
	      label: i18n.code_label,
	      name: 'verification_code',
	      on_submit: on_submit
	    }), this.ShowErrors()));
	  }
	});


/***/ },
/* 34 */
/***/ function(module, exports) {

	var GoogleDocEmbed, doc_groups;
	
	GoogleDocEmbed = ReactiveComponent({
	  displayName: 'GoogleDocEmbed',
	  render: function() {
	    return DIV({
	      style: {
	        width: '80%',
	        margin: 'auto',
	        maxWidth: 700
	      }
	    }, IFRAME({
	      ref: 'iframe',
	      width: '100%',
	      height: window.innerHeight,
	      src: this.props.link
	    }));
	  }
	});
	
	styles += ".Documentation {\n  background-color: #eee;\n  padding: 56px 0;\n}\n.doc_menu {\n}\n\n.doc_menu ul {\n  display: flex;\n  justify-content: center;\n}\n.doc_menu li {\n  padding: 6px 12px;\n  font-weight: 700;\n  display: inline-block;\n  list-style: none;\n  text-align: center;\n}\n.doc_menu li a {\n  text-decoration: none;\n  display: inline-block;    \n}\n.doc_menu li.active {\n  # background-color: " + (focus_color()) + ";\n  # color: white;\n  background-color: white;\n}\n\n.doc_groups {\n  display: flex;\n  justify-content: center; \n}\n\n.doc_group {\n  padding: 12px 24px;\n}\n\n.doc_group h2 {\n  font-size: 14px;\n}\n\n.doc_group ul {\n  list-style: none;\n}\n\n.doc_group li {\n  list-style: none;\n  padding-top: 8px;\n}\n\n.doc_group ul a {\n  text-decoration: none;\n  font-weight: 500;\n  color: #444;\n}\n\n.doc_group ul a:hover {\n  text-decoration: underline;\n}\n\n.doc_group ul .active a {\n  color: black;\n  text-decoration: underline;\n}\n\n\n@media " + NOT_PHONE_MEDIA + " {\n  .doc_groups {\n    flex-direction: row;\n  }\n}\n\n@media " + PHONE_MEDIA + " {\n  .doc_groups {\n    flex-direction: column;\n  }\n  .doc_group li, .doc_group h2 {\n    text-align: center;\n  }\n}\n";
	
	doc_groups = {
	  data: {
	    name: '',
	    groups: [
	      {
	        label: '',
	        docs: [
	          {
	            name: 'Data Export Documentation',
	            path: 'data_export'
	          }
	        ]
	      }
	    ]
	  },
	  legal: {
	    name: '',
	    groups: [
	      {
	        label: 'Terms',
	        docs: [
	          {
	            name: 'Terms of Service',
	            path: 'terms_of_service'
	          }, {
	            name: 'Forum Hosting Terms',
	            path: 'standard_hosting_terms'
	          }, {
	            name: 'Data Processing Addendum',
	            path: 'data_processing_addendum'
	          }
	        ]
	      }, {
	        label: 'Policies',
	        docs: [
	          {
	            name: 'Privacy Policy',
	            path: 'privacy_policy'
	          }, {
	            name: 'Acceptable Use',
	            path: 'use_restrictions'
	          }, {
	            name: 'Delete Your Data',
	            path: 'deleting_your_data'
	          }
	        ]
	      }, {
	        label: 'Background',
	        docs: [
	          {
	            name: 'Security Practices',
	            path: 'security'
	          }, {
	            name: 'Subprocessors',
	            path: 'subprocessors'
	          }
	        ]
	      }
	    ]
	  }
	};
	
	window.DocumentationGroup = ReactiveComponent({
	  displayName: 'DocumentationGroup',
	  render: function() {
	    var doc, ggroup, group, group_config, item, parts;
	    parts = fetch('location').url.split('/');
	    group = parts[parts.length - 2];
	    doc = parts[parts.length - 1];
	    group_config = doc_groups[group];
	    if (!group_config) {
	      return SPAN(null);
	    }
	    return DIV({
	      className: 'Documentation'
	    }, group_config.groups.length === 1 ? DIV({
	      className: 'doc_menu'
	    }, group_config.groups[0].docs.length > 1 ? UL({
	      style: {}
	    }, (function() {
	      var i, len, ref, results;
	      ref = group_config.groups[0].docs;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        item = ref[i];
	        fetch("/docs/" + item.path);
	        results.push(LI({
	          className: item.path === doc ? 'active' : void 0
	        }, A({
	          href: "/docs/" + group + "/" + item.path
	        }, item.name)));
	      }
	      return results;
	    })()) : void 0) : DIV({
	      className: 'doc_groups_container'
	    }, H1({
	      className: 'doc_center'
	    }, group_config.name), DIV({
	      className: 'doc_groups'
	    }, (function() {
	      var i, len, ref, results;
	      ref = group_config.groups;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        ggroup = ref[i];
	        results.push(DIV({
	          className: 'doc_group'
	        }, H2(null, ggroup.label), UL(null, (function() {
	          var j, len1, ref1, results1;
	          ref1 = ggroup.docs;
	          results1 = [];
	          for (j = 0, len1 = ref1.length; j < len1; j++) {
	            item = ref1[j];
	            fetch("/docs/" + item.path);
	            results1.push(LI({
	              className: item.path === doc ? 'active' : void 0
	            }, A({
	              href: "/docs/" + group + "/" + item.path
	            }, item.name)));
	          }
	          return results1;
	        })())));
	      }
	      return results;
	    })())), Documentation({
	      doc: doc
	    }));
	  }
	});
	
	styles += ".Documentation .markdown_doc {\n  width: 80%;\n  max-width: 1100px;\n  margin: 0px auto;\n  padding: 36px 86px;\n  background-color: white;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 2px;  \n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .Documentation .markdown_doc {\n    width: 100%;\n    padding: 36px 48px;      \n  }\n  .doc_menu li a {\n    font-size: 14px;\n    min-width: 76px;\n  }\n\n}\n\n@media " + PHONE_MEDIA + " {\n  .Documentation .markdown_doc {\n    width: 100%;\n    padding: 36px 24px;      \n  }\n  .doc_menu li {\n    padding: 6px 6px;\n  }\n\n  .doc_menu li a {\n    font-size: 14px;\n    min-width: 65px;\n  }\n\n}\n\n.markdown-body {\n  padding: 40px 36px; \n  max-width: 872px;\n  margin: auto;       \n}\n\n.markdown-body a {\n  text-decoration: underline; \n  color:" + considerit_red + ";    \n}\n.markdown-body li {\n  list-style-position: outside;\n  padding: 0px 0px 8px 12px;\n}\n\n.markdown-body b, .markdown-body strong {\n  color: black;\n}\n";
	
	window.Documentation = ReactiveComponent({
	  displayName: 'Documentation',
	  render: function() {
	    var html;
	    html = fetch("/docs/" + this.props.doc).html;
	    if (!html) {
	      return SPAN(null);
	    }
	    return DIV({
	      className: 'markdown_doc'
	    }, LINK({
	      rel: 'stylesheet',
	      type: 'text/css',
	      href: asset("../vendor/github-markdown.css")
	    }), DIV({
	      className: 'markdown-body',
	      dangerouslySetInnerHTML: {
	        __html: html
	      }
	    }));
	  }
	});


/***/ },
/* 35 */
/***/ function(module, exports) {

	window.$$ = {
	  add_delegated_listener: function(el, eventName, selector, callback) {
	    return el.addEventListener(eventName, function(e) {
	      var results, target;
	      try {
	        target = e.target;
	        results = [];
	        while (target && target !== el) {
	          if (target.matches(selector)) {
	            callback.call(target, e);
	            break;
	          }
	          results.push(target = target.parentNode);
	        }
	        return results;
	      } catch (error) {
	        e = error;
	        console.log('Got error in add_delegated_listener');
	        return console.error(e);
	      }
	    }, false);
	  },
	  closest: function(el, selector) {
	    var current_el, matchesSelector;
	    if (el.closest != null) {
	      return el.closest(selector);
	    } else {
	      matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
	      current_el = el;
	      while (current_el) {
	        if (matchesSelector.call(current_el, selector)) {
	          return current_el;
	        } else {
	          current_el = current_el.parentElement;
	        }
	      }
	      return null;
	    }
	  },
	  height: function(el) {
	    return Math.round(el.clientHeight);
	  },
	  width: function(el) {
	    return Math.round(el.getBoundingClientRect().width);
	  },
	  offset: function(el) {
	    var left, rect, top;
	    rect = el.getBoundingClientRect();
	    top = rect.top + window.pageYOffset - document.documentElement.clientTop;
	    left = rect.left + window.pageXOffset - document.documentElement.clientLeft;
	    return {
	      top: top,
	      left: left
	    };
	  },
	  offsetParent: function(el) {
	    return el.offsetParent || el;
	  },
	  scrollTop: function(el) {
	    if (el == null) {
	      el = document;
	    }
	    return (el.documentElement && el.documentElement.scrollTop) || el.body.scrollTop;
	  },
	  animate: function(el, params, speed) {
	    var k, results, v;
	    el.style.transition = 'all ' + speed;
	    results = [];
	    for (k in params) {
	      v = params[k];
	      results.push(el.style[k] = v);
	    }
	    return results;
	  },
	  ensureInView: function(el, options) {
	    var bottom_inside, distance_to_travel, doc_bottom, doc_height, doc_top, e, el_bottom, el_height, el_top, is_onscreen, no_adjustment_needed, target, top_inside;
	    if (options == null) {
	      options = {};
	    }
	    if (!el) {
	      options.callback();
	      return;
	    }
	    try {
	      _.defaults(options, {
	        fill_threshold: 0,
	        offset_buffer: 36,
	        scroll: true,
	        position: 'top',
	        speed: null,
	        speed_mult: 1,
	        callback: function() {}
	      });
	      el_height = $$.height(el) + (options.extra_height || 0);
	      el_top = $$.offset(el).top;
	      el_bottom = el_top + el_height;
	      doc_height = $$.height(document.body);
	      doc_top = $$.scrollTop();
	      doc_bottom = doc_top + doc_height;
	      is_onscreen = el_top > doc_top && el_bottom < doc_bottom;
	      bottom_inside = el_bottom < doc_bottom && (el_bottom - doc_top) > options.fill_threshold * el_height;
	      top_inside = el_top > doc_top && (doc_bottom - el_top) > options.fill_threshold * el_height;
	      no_adjustment_needed = !options.force && is_onscreen && top_inside && bottom_inside;
	      if (!no_adjustment_needed) {
	        switch (options.position) {
	          case 'top':
	            target = el_top - options.offset_buffer;
	            break;
	          case 'bottom':
	            target = el_bottom - doc_height + options.offset_buffer;
	            break;
	          default:
	            throw 'bad position for ensureInView';
	        }
	        if (options.scroll) {
	          distance_to_travel = options.speed || Math.abs(doc_top - (el_top - options.offset_buffer));
	          if (options.dom_possibly_shifting) {
	            if (options.position !== 'top') {
	              console.error("smoothScrollToTargetWithChangingElement doesn't support position targets except 'top'");
	            }
	            return $$.smoothScrollToTargetWithChangingElements({
	              el: el,
	              offset_buffer: options.offset_buffer,
	              duration: options.speed_mult * Math.min(distance_to_travel, 1500),
	              callback: options.callback
	            });
	          } else {
	            return $$.smoothScrollToTarget({
	              target: el_top - options.offset_buffer,
	              duration: options.speed_mult * Math.min(distance_to_travel, 1500),
	              callback: options.callback
	            });
	          }
	        } else {
	          window.scrollTo(0, target);
	          return options.callback();
	        }
	      } else {
	        return options.callback();
	      }
	    } catch (error) {
	      e = error;
	      console.log("Error in ensureInView");
	      return console.error(e);
	    }
	  },
	  ensure_in_viewport_when_appears: function(selector) {
	    var viewport_ensurer;
	    return viewport_ensurer = setInterval(function() {
	      var el;
	      el = document.querySelector(selector);
	      if (el) {
	        $$.ensureInView(el, {
	          scroll: true
	        });
	        return clearInterval(viewport_ensurer);
	      }
	    }, 10);
	  },
	  smoothScrollToTargetWithChangingElements: function(arg) {
	    var callback, diff, dist_per_frame, duration, el, frames, iter, offset_buffer, target;
	    duration = arg.duration, callback = arg.callback, el = arg.el, offset_buffer = arg.offset_buffer;
	    target = $$.offset(el).top - offset_buffer;
	    diff = target - window.pageYOffset;
	    frames = 60 * duration / 1000;
	    dist_per_frame = diff / frames;
	    iter = function(current_time) {
	      var done, e, scroll_to, top;
	      try {
	        top = el.getBoundingClientRect().top;
	        if (diff < 0) {
	          done = top + dist_per_frame > offset_buffer;
	        } else {
	          done = top - dist_per_frame < offset_buffer;
	        }
	        done || (done = document.documentElement.scrollHeight - document.documentElement.scrollTop - document.documentElement.clientHeight <= 0);
	        if (done) {
	          dist_per_frame = top - offset_buffer;
	        }
	        scroll_to = window.pageYOffset + dist_per_frame;
	        window.scrollTo(0, scroll_to);
	        if (!done) {
	          return requestAnimationFrame(iter);
	        } else {
	          return typeof callback === "function" ? callback() : void 0;
	        }
	      } catch (error) {
	        e = error;
	        console.log("Error in smoothScrollToTargetWithChangingElements");
	        return console.error(e);
	      }
	    };
	    return requestAnimationFrame(iter);
	  },
	  smoothScrollToTarget: function(arg) {
	    var callback, diff, duration, iter, requestId, start_pos, start_time, target;
	    target = arg.target, duration = arg.duration, callback = arg.callback;
	    start_pos = window.pageYOffset;
	    diff = target - start_pos;
	    start_time = null;
	    iter = function(current_time) {
	      var e, percent, requestId, time;
	      try {
	        if (!start_time) {
	          start_time = current_time;
	        }
	        time = current_time - start_time;
	        percent = Math.min(time / duration, 1);
	        window.scrollTo(0, start_pos + diff * percent);
	        if (time < duration) {
	          return requestId = window.requestAnimationFrame(iter);
	        } else {
	          window.cancelAnimationFrame(requestId);
	          return typeof callback === "function" ? callback() : void 0;
	        }
	      } catch (error) {
	        e = error;
	        console.log("Got error in smoothScrollToTarget");
	        return console.error(e);
	      }
	    };
	    return requestId = window.requestAnimationFrame(iter);
	  },
	  moveToTop: function(el, options) {
	    var el_bottom, el_top, target;
	    if (options == null) {
	      options = {};
	    }
	    _.defaults(options, {
	      offset_buffer: 50
	    });
	    el_top = $$.offset(el).top;
	    el_bottom = target = el_top - options.offset_buffer;
	    return window.scrollTo(0, target);
	  },
	  setStyles: function(selector, styles) {
	    var el, els, i, k, len, results, v;
	    els = document.querySelectorAll(selector);
	    results = [];
	    for (i = 0, len = els.length; i < len; i++) {
	      el = els[i];
	      results.push((function() {
	        var results1;
	        results1 = [];
	        for (k in styles) {
	          v = styles[k];
	          if (k.indexOf('-') > -1) {
	            results1.push(el.style.setProperty(k, v));
	          } else {
	            results1.push(el.style[k] = v);
	          }
	        }
	        return results1;
	      })());
	    }
	    return results;
	  }
	};


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var old_BUTTON;
	
	__webpack_require__(1);
	
	__webpack_require__(17);
	
	old_BUTTON = BUTTON;
	
	window.BUTTON = React.createFactory(createReactClass({
	  displayName: 'modified_BUTTON',
	  render: function() {
	    var k, new_props, ref, v;
	    new_props = {};
	    ref = this.props;
	    for (k in ref) {
	      v = ref[k];
	      new_props[k] = v;
	    }
	    if (new_props.onClick && !new_props.onKeyDown && !new_props.onKeyPress) {
	      new_props.onKeyPress = function(e) {
	        if (e.which === 13 || e.which === 32) {
	          e.target.click();
	          e.stopPropagation();
	          return e.preventDefault();
	        }
	      };
	    }
	    return old_BUTTON(new_props);
	  }
	}));
	
	window.moveCursorToEnd = function(el) {
	  var end;
	  if (!el) {
	    return;
	  }
	  end = el.value.length;
	  if (end > 0) {
	    el.setSelectionRange(end, end);
	  }
	  return el.focus();
	};
	
	window.styles += ".AutoGrowTextArea {\n  padding: 4px 8px;\n}";
	
	window.AutoGrowTextArea = ReactiveComponent({
	  displayName: 'AutoGrowTextArea',
	  onChange: function(e) {
	    var base;
	    if (typeof (base = this.props).onChange === "function") {
	      base.onChange(e);
	    }
	    return this.checkAndSetHeight();
	  },
	  componentDidMount: function() {
	    this.checkAndSetHeight();
	    if (this.props.focus_on_mount) {
	      return this.refs.input.focus();
	    }
	  },
	  componentDidUpdate: function() {
	    return this.checkAndSetHeight();
	  },
	  checkAndSetHeight: function() {
	    var client_height, h, max_height, scroll_height;
	    scroll_height = ReactDOM.findDOMNode(this).scrollHeight;
	    max_height = this.props.max_height || 600;
	    client_height = ReactDOM.findDOMNode(this).clientHeight;
	    if (scroll_height > client_height) {
	      h = Math.min(scroll_height + 5, max_height);
	      if (h !== this.local.height) {
	        this.local.height = h;
	        if (this.props.onHeightChange) {
	          this.props.onHeightChange();
	        }
	        return save(this.local);
	      }
	    }
	  },
	  render: function() {
	    var className, j, len, prop_to_strip, props, ref;
	    if (!this.local.height) {
	      this.local.height = this.props.min_height;
	    }
	    className = "AutoGrowTextArea " + (this.props.className ? this.props.className : '') + " skiptranslate";
	    props = _.extend({}, this.props, {
	      className: className,
	      onChange: this.onChange,
	      rows: 1,
	      style: _.extend({}, this.props.style || {}, {
	        height: this.local.height
	      }),
	      ref: 'input'
	    });
	    ref = ['parents', 'min_height', 'focus_on_mount', 'onHeightChange'];
	    for (j = 0, len = ref.length; j < len; j++) {
	      prop_to_strip = ref[j];
	      if (prop_to_strip in props) {
	        delete props[prop_to_strip];
	      }
	    }
	    return TEXTAREA(props);
	  }
	});
	
	window.CharacterCountTextInput = ReactiveComponent({
	  displayName: 'CharacterCountTextInput',
	  render: function() {
	    var class_name, count_style, j, len, prop_to_strip, props, ref;
	    if (this.local.count == null) {
	      this.local.count = (this.props.defaultValue || "").length;
	    }
	    count_style = this.props.count_style || {};
	    class_name = "is_counted";
	    props = _.extend({}, this.props, {
	      ref: 'input',
	      className: class_name,
	      onChange: (function(_this) {
	        return function() {
	          _this.local.count = ReactDOM.findDOMNode(_this.refs.input).value.length;
	          return save(_this.local);
	        };
	      })(this)
	    });
	    ref = ['parents', 'count_style', 'focus_on_mount'];
	    for (j = 0, len = ref.length; j < len; j++) {
	      prop_to_strip = ref[j];
	      if (prop_to_strip in props) {
	        delete props[prop_to_strip];
	      }
	    }
	    return DIV({
	      style: {
	        position: 'relative'
	      }
	    }, SPAN({
	      'aria-hidden': true,
	      style: count_style
	    }, this.props.maxLength - this.local.count), SPAN({
	      className: 'hidden'
	    }, translator({
	      id: "engage.character_counter",
	      characters_left: this.props.maxLength - this.local.count
	    }, "{characters_left, plural, one {# character} other {# characters}} left")), TEXTAREA(props));
	  },
	  componentDidMount: function() {
	    if (this.props.focus_on_mount) {
	      return this.refs.input.focus();
	    }
	  }
	});
	
	styles += "\n.wysiwyg_text.focused {\n  outline: 2px solid " + (focus_color()) + ";\n}\n";
	
	window.WysiwygEditor = ReactiveComponent({
	  displayName: 'WysiwygEditor',
	  render: function() {
	    var button, close_if_nothing_in_menu_focused, id, idx, j, len, my_data, subdomain, toolbar_horizontal, toolbar_items, wysiwyg_editor;
	    my_data = fetch(this.props.editor_key);
	    subdomain = fetch('/subdomain');
	    wysiwyg_editor = fetch('wysiwyg_editor');
	    this.supports_Quill = !!Quill;
	    if (!this.local.initialized) {
	      my_data.html = this.props.html;
	      this.local.initialized = true;
	      save(this.local);
	      save(my_data);
	      this.initial_html = this.props.html;
	    }
	    toolbar_horizontal = this.props.horizontal;
	    toolbar_items = [
	      {
	        className: "ql-list fa fa-list-ul",
	        value: 'bullet',
	        title: 'Bulleted list'
	      }, {
	        className: "ql-list fa fa-list-ol",
	        value: 'ordered',
	        title: 'Numbered list'
	      }, {
	        className: "ql-bold fa fa-bold",
	        title: 'Bold selected text'
	      }, {
	        className: "ql-link fa fa-link",
	        title: 'Hyperlink selected text'
	      }
	    ];
	    for (j = 0, len = toolbar_items.length; j < len; j++) {
	      button = toolbar_items[j];
	      button.onClick = function(e) {
	        e.stopPropagation();
	        return e.preventDefault();
	      };
	    }
	    close_if_nothing_in_menu_focused = (function(_this) {
	      return function() {
	        return setTimeout(function() {
	          if (!$$.closest(document.activeElement, "#" + id)) {
	            wysiwyg_editor = fetch('wysiwyg_editor');
	            wysiwyg_editor.showing = false;
	            return save(wysiwyg_editor);
	          }
	        }, 0);
	      };
	    })(this);
	    if (fetch('/current_user').is_admin || this.props.allow_html) {
	      toolbar_items.push({
	        className: 'fa fa-code',
	        title: 'Directly edit HTML',
	        onClick: (function(_this) {
	          return function() {
	            _this.local.edit_code = true;
	            return save(_this.local);
	          };
	        })(this)
	      });
	    }
	    id = this.props.editor_key.replace(/\//g, '__');
	    return DIV({
	      id: id,
	      style: {
	        position: 'relative'
	      },
	      onClick: function(ev) {
	        return ev.stopPropagation();
	      }
	    }, this.local.edit_code || !this.supports_Quill ? AutoGrowTextArea({
	      style: {
	        width: '100%',
	        fontSize: 18
	      },
	      defaultValue: my_data.html,
	      onChange: (function(_this) {
	        return function(e) {
	          my_data = fetch(_this.props.editor_key);
	          my_data.html = e.target.value;
	          return save(my_data);
	        };
	      })(this)
	    }) : DIV(null, Dock({
	      dock_on_zoomed_screens: true,
	      skip_jut: true,
	      dummy: wysiwyg_editor.showing
	    }, DIV({
	      ref: 'toolbar',
	      role: 'toolbar',
	      'title': 'Rich text markup',
	      'aria-orientation': toolbar_horizontal ? 'horizontal' : 'vertical',
	      id: 'toolbar',
	      tabIndex: 0,
	      style: _.defaults({}, this.props.toolbar_style, {
	        position: 'absolute',
	        width: !toolbar_horizontal ? 30 : void 0,
	        left: !toolbar_horizontal ? -32 : void 0,
	        top: toolbar_horizontal ? -25 : 0,
	        display: 'block'
	      }),
	      onFocus: (function(_this) {
	        return function(e) {
	          var ref, ref1;
	          if (!_this.local.focused_toolbar_item) {
	            if ((ref = _this.local.focused_toolbar_item) === (void 0) || ref === null) {
	              _this.local.focused_toolbar_item = 0;
	              save(_this.local);
	            }
	          }
	          if ((ref1 = _this.local.focused_toolbar_item) !== (void 0) && ref1 !== null) {
	            return ReactDOM.findDOMNode(_this.refs["toolbaritem-" + _this.local.focused_toolbar_item]).focus();
	          }
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          var i, ref, ref1;
	          if ((ref = e.which) === 37 || ref === 38 || ref === 39 || ref === 40) {
	            i = _this.local.focused_toolbar_item;
	            if ((ref1 = e.which) === 37 || ref1 === 38) {
	              i--;
	              if (i < 0) {
	                i = toolbar_items.length - 1;
	              }
	            } else {
	              i++;
	              if (i > toolbar_items.length - 1) {
	                i = 0;
	              }
	            }
	            _this.local.focused_toolbar_item = i;
	            save(_this.local);
	            ReactDOM.findDOMNode(_this.refs["toolbaritem-" + i]).focus();
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, (function() {
	      var l, len1, results;
	      results = [];
	      for (idx = l = 0, len1 = toolbar_items.length; l < len1; idx = ++l) {
	        button = toolbar_items[idx];
	        results.push((function(_this) {
	          return function(button, idx) {
	            return BUTTON({
	              key: button.title || idx,
	              ref: "toolbaritem-" + idx,
	              tabIndex: _this.local.focused_toolbar_item === idx ? 0 : -1,
	              className: button.className,
	              'aria-label': button.title,
	              style: _.defaults({}, _this.props.button_style, {
	                fontSize: 14,
	                width: 28,
	                textAlign: 'center',
	                cursor: 'pointer',
	                padding: 2,
	                border: '1px solid #aaa',
	                borderRadius: 3,
	                backgroundColor: 'white',
	                display: toolbar_horizontal ? 'inline-block' : 'block',
	                marginBottom: 4
	              }),
	              title: button.title,
	              value: button.value,
	              onClick: button.onClick
	            });
	          };
	        })(this)(button, idx));
	      }
	      return results;
	    }).call(this))), DIV({
	      style: _.defaults({}, this.props.container_style),
	      className: "wysiwyg_text " + (fetch('wysiwyg_editor').showing === this.props.editor_key ? 'focused' : '')
	    }, DIV({
	      className: 'skiptranslate',
	      id: 'editor',
	      ref: 'editor',
	      dangerouslySetInnerHTML: {
	        __html: this.initial_html
	      },
	      onFocus: (function(_this) {
	        return function(e) {
	          wysiwyg_editor = fetch('wysiwyg_editor');
	          wysiwyg_editor.showing = _this.props.editor_key;
	          return save(wysiwyg_editor);
	        };
	      })(this),
	      onBlur: close_if_nothing_in_menu_focused,
	      style: this.props.style
	    }))));
	  },
	  componentDidMount: function() {
	    var getHTML, keyboard;
	    if (!this.supports_Quill) {
	      return;
	    }
	    getHTML = (function(_this) {
	      return function() {
	        return ReactDOM.findDOMNode(_this).querySelector(".ql-editor").innerHTML;
	      };
	    })(this);
	    this.editor = new Quill(this.refs.editor, {
	      modules: {
	        toolbar: {
	          container: this.refs.toolbar
	        }
	      },
	      styles: true,
	      placeholder: this.props.placeholder
	    });
	    keyboard = this.editor.getModule('keyboard');
	    delete keyboard.bindings[9];
	    this.editor.on('text-change', (function(_this) {
	      return function(delta, old_contents, source) {
	        var my_data, node, removeStyles;
	        my_data = fetch(_this.props.editor_key);
	        my_data.html = getHTML();
	        if (source === 'user' && my_data.html.indexOf(' style') > -1) {
	          removeStyles = function(el) {
	            var child, j, len, ref, results;
	            el.removeAttribute('style');
	            if (el.childNodes.length > 0) {
	              ref = el.childNodes;
	              results = [];
	              for (j = 0, len = ref.length; j < len; j++) {
	                child = ref[j];
	                if (child.nodeType === 1) {
	                  results.push(removeStyles(child));
	                } else {
	                  results.push(void 0);
	                }
	              }
	              return results;
	            }
	          };
	          node = _this.editor.root;
	          removeStyles(node);
	          my_data.html = getHTML();
	        }
	        if (my_data.html === "<p><br></p>") {
	          my_data.html = "";
	        }
	        return save(my_data);
	      };
	    })(this));
	    if (this.props.focus_on_mount) {
	      return this.editor.focus();
	    }
	  }
	});
	
	styles += ".ql-clipboard {display: none;}\nhtml .ql-container{\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  padding: 0;\n  overflow-x: visible;\n  overflow-y: visible;\n}\n.ql-editor {\n  min-height: 120px;\n  outline: none;\n}\n\n\n.ql-editor.ql-blank::before{\n  content: attr(data-placeholder);\n  pointer-events: none;\n  position: absolute;\n  color: rgba(0,0,0,.4);\n  font-weight: 500;\n  width: 100%;\n  height: 100%;\n  transform: translateX(-50%);\n  padding: 0 8px 6px 8px;\n  box-sizing: border-box;\n}\n\n.dark .ql-editor.ql-blank::before{\n  color: rgba(255,255,255,.4);\n}\n\n\n\n.ql-container {\n  box-sizing: border-box;\n  height: 100%;\n  margin: 0px;\n  position: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n  visibility: hidden;\n}\n.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n  pointer-events: none;\n}\n\n.ql-editor {\n  box-sizing: border-box;\n  cursor: text;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  tab-size: 4;\n  -moz-tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0;\n  padding: 0;\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol,\n.ql-editor ul {\n  padding-left: 1.5em;\n}\n.ql-editor ol > li,\n.ql-editor ul > li {\n  list-style-type: none;\n}\n.ql-editor ul[data-checked=true],\n.ql-editor ul[data-checked=false] {\n  pointer-events: none;\n}\n.ql-editor ul[data-checked=true] > li *,\n.ql-editor ul[data-checked=false] > li * {\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before,\n.ql-editor ul[data-checked=false] > li::before {\n  color: #777;\n  cursor: pointer;\n  pointer-events: all;\n}\n.ql-editor li::before {\n  display: inline-block;\n  margin-right: 0.3em;\n  text-align: right;\n  white-space: nowrap;\n  width: 1.2em;\n}\n.ql-editor li:not(.ql-direction-rtl)::before {\n  margin-left: -1.5em;\n}\n.ql-editor ol li,\n.ql-editor ul li {\n  padding-left: 1.5em;\n}\n.ql-editor ol li {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment: list-num;\n}\n.ql-editor ol li:before {\n  content: counter(list-num, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-increment: list-1;\n}\n.ql-editor ol li.ql-indent-1:before {\n  content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-increment: list-2;\n}\n.ql-editor ol li.ql-indent-2:before {\n  content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-increment: list-3;\n}\n.ql-editor ol li.ql-indent-3:before {\n  content: counter(list-3, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-increment: list-4;\n}\n.ql-editor ol li.ql-indent-4:before {\n  content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-increment: list-5;\n}\n.ql-editor ol li.ql-indent-5:before {\n  content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-increment: list-6;\n}\n.ql-editor ol li.ql-indent-6:before {\n  content: counter(list-6, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-reset: list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-increment: list-7;\n}\n.ql-editor ol li.ql-indent-7:before {\n  content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-reset: list-8 list-9;\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-increment: list-8;\n}\n.ql-editor ol li.ql-indent-8:before {\n  content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-reset: list-9;\n}\n.ql-editor ol li.ql-indent-9 {\n  counter-increment: list-9;\n}\n.ql-editor ol li.ql-indent-9:before {\n  content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 28.5em;\n}\n.ql-editor .ql-video {\n  display: block;\n  max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n  background-color: #000;\n}\n.ql-editor .ql-bg-red {\n  background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n  background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n  background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n  background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n  background-color: #93f;\n}\n.ql-editor .ql-color-white {\n  color: #fff;\n}\n.ql-editor .ql-color-red {\n  color: #e60000;\n}\n.ql-editor .ql-color-orange {\n  color: #f90;\n}\n.ql-editor .ql-color-yellow {\n  color: #ff0;\n}\n.ql-editor .ql-color-green {\n  color: #008a00;\n}\n.ql-editor .ql-color-blue {\n  color: #06c;\n}\n.ql-editor .ql-color-purple {\n  color: #93f;\n}\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n  font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n  font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit;\n}\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n.ql-editor .ql-align-right {\n  text-align: right;\n}";
	
	styles += ".wysiwyg_text code, .wysiwyg_text pre {\n  font-family: \"Courier New\",Courier,\"Lucida Sans Typewriter\",\"Lucida Typewriter\",monospace;\n},.wysiwyg_text br, .description_field br {\n  padding-bottom: 0.5em; }\n.wysiwyg_text p, \n.wysiwyg_text ul, \n.description_field ul, \n.wysiwyg_text ol, \n.description_field ol, \n.wysiwyg_text table, \n.description_field p, \n.description_field table {\n  margin-bottom: 0.5em; }\n.wysiwyg_text td, .description_field td {\n  padding: 0 3px; }\n.wysiwyg_text li, .description_field li {\n  list-style: outside; padding-bottom: 8px;}\n.wysiwyg_text ol li {\n  list-style-type: decimal; }  \n.wysiwyg_text ul, .description_field ul,\n.wysiwyg_text ol, .description_field ol {\n  padding-left: 20px;\n  margin-left: 20px; }\n.wysiwyg_text a, .description_field a {\n  text-decoration: underline; \n  font-weight: 700;\n}\n.wysiwyg_text blockquote, .description_field blockquote {\n  opacity: 0.7;\n  padding: 10px 20px; }\n.wysiwyg_text table, .description_field table {\n  padding: 20px 0px; font-size: 11px; \n}\n.wysiwyg_text .ql-editor li, .description_field .ql-editor li {\n  list-style: inside;\n}\n.wysiwyg_text .ql-editor ul, .description_field .ql-editor ol{\n  margin-left: 0;\n}\n.wysiwyg_text .ql-editor ol li {\n  list-style-type: none; }  ";


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var DEVICE_PIXEL_RATIO, HistoAvatars, REGION_SELECTION_VERTICAL_PADDING, SKIP_FRAMES, configure_histo_layout_web_worker, get_histo_positions, get_originating_histogram, hit_region_avatars, hit_region_color_to_user_map, is_histogram_controlling_region_selection, num_layout_tasks_delegated, num_layout_workers;
	
	__webpack_require__(3);
	
	__webpack_require__(18);
	
	__webpack_require__(38);
	
	__webpack_require__(6);
	
	__webpack_require__(1);
	
	window.REGION_SELECTION_WIDTH = .25;
	
	REGION_SELECTION_VERTICAL_PADDING = 30;
	
	window.show_histogram_layout = false;
	
	DEVICE_PIXEL_RATIO = window.devicePixelRatio;
	
	get_originating_histogram = function() {
	  var active, opinion_views, originating_histogram, ref;
	  opinion_views = fetch('opinion_views');
	  active = opinion_views.active_views;
	  originating_histogram = (ref = active.region_selected) != null ? ref.created_by : void 0;
	  return originating_histogram;
	};
	
	is_histogram_controlling_region_selection = function(key) {
	  var opinion_views;
	  opinion_views = fetch('opinion_views');
	  return get_originating_histogram() === key;
	};
	
	window.clear_histogram_managed_opinion_views = function(opinion_views, field) {
	  if (opinion_views == null) {
	    opinion_views = fetch('opinion_views');
	  }
	  if (field) {
	    delete opinion_views.active_views[field];
	  } else {
	    delete opinion_views.active_views.single_opinion_selected;
	    delete opinion_views.active_views.region_selected;
	    delete opinion_views.active_views.point_includers;
	  }
	  return save(opinion_views);
	};
	
	window.select_single_opinion = function(user_opinion, created_by) {
	  var is_deselection, opinion_views, ref;
	  opinion_views = fetch('opinion_views');
	  is_deselection = ((ref = opinion_views.active_views.single_opinion_selected) != null ? ref.opinion : void 0) === user_opinion.key;
	  if (is_deselection) {
	    return clear_histogram_managed_opinion_views(opinion_views);
	  } else {
	    opinion_views.active_views.single_opinion_selected = {
	      created_by: created_by,
	      opinion: user_opinion.key,
	      user: user_opinion.user,
	      opinion_value: user_opinion.stance,
	      get_salience: (function(_this) {
	        return function(u, opinion, proposal) {
	          if ((u.key || u) === user_opinion.user) {
	            return 1;
	          } else {
	            return .1;
	          }
	        };
	      })(this),
	      get_weight: (function(_this) {
	        return function(u, opinion, proposal) {
	          if ((u.key || u) === user_opinion.user) {
	            return 1;
	          } else {
	            return .1;
	          }
	        };
	      })(this)
	    };
	    return clear_histogram_managed_opinion_views(opinion_views, 'region_selected');
	  }
	};
	
	styles += ".histogram {\n  position: relative;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n}\n.histoavatars-container {\n  padding-top: " + REGION_SELECTION_VERTICAL_PADDING + "px;\n  // content-visibility: auto; /* enables browsers to not draw expensive histograms in many situations */\n}";
	
	window.Histogram = ReactiveComponent({
	  displayName: 'Histogram',
	  render: function() {
	    var avg, base, base1, draw_selection_area, enable_individual_selection, exp, flip_id, groups, histo, histo_height, histogram_props, j, labels, len, negative, o, opinion_views, opinions, proposal, ref, ref1, ref2, salience, score, subdomain, weights;
	    subdomain = fetch('/subdomain');
	    proposal = fetch(this.props.proposal);
	    opinion_views = fetch('opinion_views');
	    opinions = this.props.opinions;
	    if (typeof running_timelapse_simulation !== "undefined" && running_timelapse_simulation !== null) {
	      opinions = (function() {
	        var j, len, results;
	        results = [];
	        for (j = 0, len = opinions.length; j < len; j++) {
	          o = opinions[j];
	          if (passes_running_timelapse_simulation(o.created_at || o.updated_at)) {
	            results.push(o);
	          }
	        }
	        return results;
	      })();
	    }
	    ref = compose_opinion_views(opinions, proposal), weights = ref.weights, salience = ref.salience, groups = ref.groups;
	    this.weights = weights;
	    this.salience = salience;
	    this.groups = groups;
	    this.opinions = opinions = get_opinions_for_proposal(opinions, proposal, weights);
	    this.opinions.sort(function(a, b) {
	      return a.stance - b.stance;
	    });
	    if ((base1 = this.props).draw_base_labels == null) {
	      base1.draw_base_labels = true;
	    }
	    enable_individual_selection = this.props.enable_individual_selection && this.opinions.length > 0;
	    this.enable_range_selection = this.props.enable_range_selection && opinions.length > 1;
	    draw_selection_area = this.enable_range_selection && !opinion_views.active_views.single_opinion_selected && !this.props.backgrounded && (opinion_views.active_views.region_selected || (this.local.mouse_opinion_value && !this.local.hovering_over_avatar));
	    histo_height = this.props.height + REGION_SELECTION_VERTICAL_PADDING;
	    this.id = "histo-" + (this.local.key.replace(/\//g, '__'));
	    histogram_props = {
	      id: this.id,
	      key: 'histogram',
	      tabIndex: !this.props.backgrounded ? 0 : void 0,
	      className: 'histogram',
	      'aria-hidden': this.props.backgrounded,
	      'aria-labelledby': !this.props.backgrounded ? "histo-label-" + proposal.id : void 0,
	      'aria-describedby': !this.props.backgrounded ? "histo-description-" + proposal.id : void 0,
	      style: {
	        width: this.props.width,
	        height: histo_height
	      },
	      onKeyDown: (function(_this) {
	        return function(e) {
	          var ref1, ref2;
	          if (e.which === 32) {
	            _this.local.navigating_inside = !_this.local.navigating_inside;
	            save(_this.local);
	            e.preventDefault();
	            if (_this.local.navigating_inside) {
	              return (ref1 = ReactDOM.findDOMNode(_this).querySelector('.avatar')) != null ? ref1.focus() : void 0;
	            } else {
	              return ReactDOM.findDOMNode(_this).focus();
	            }
	          } else if (e.which === 13 && !_this.local.navigating_inside) {
	            _this.local.navigating_inside = true;
	            if ((ref2 = ReactDOM.findDOMNode(_this).querySelector('.avatar')) != null) {
	              ref2.focus();
	            }
	            return save(_this.local);
	          } else if (e.which === 27 && _this.local.navigating_inside) {
	            _this.local.navigating_inside = false;
	            ReactDOM.findDOMNode(_this).focus();
	            return save(_this.local);
	          }
	        };
	      })(this),
	      onBlur: (function(_this) {
	        return function(e) {
	          return setTimeout(function() {
	            if (_this.local.navigating_inside && !$$.closest(document.activeElement, "#" + _this.id)) {
	              _this.local.navigating_inside = false;
	              return save(_this.local);
	            }
	          }, 0);
	        };
	      })(this)
	    };
	    score = 0;
	    for (j = 0, len = opinions.length; j < len; j++) {
	      o = opinions[j];
	      score += o.stance;
	    }
	    avg = score / opinions.length;
	    negative = score < 0;
	    if (negative) {
	      score *= -1;
	    }
	    score = pad(score.toFixed(1), 2);
	    if (avg < -.03) {
	      exp = ((-1 * avg * 100).toFixed(0)) + "% " + (get_slider_label("slider_pole_labels.oppose", this.props.proposal, subdomain));
	    } else if (avg > .03) {
	      exp = ((avg * 100).toFixed(0)) + "% " + (get_slider_label("slider_pole_labels.support", this.props.proposal, subdomain));
	    } else {
	      exp = translator("sliders.feedback-short.neutral", "Neutral");
	    }
	    if (this.enable_range_selection || enable_individual_selection) {
	      _.extend(histogram_props, {
	        onClick: this.onClick,
	        onMouseMove: this.onMouseMove,
	        onMouseLeave: this.onMouseLeave,
	        onMouseDown: this.onMouseDown
	      });
	    }
	    if (this.props.flip) {
	      flip_id = "histogram-" + proposal.key;
	    }
	    histo = DIV(histogram_props, DIV({
	      key: 'accessibility-histo-label',
	      id: "histo-label-" + proposal.id,
	      className: 'hidden'
	    }, translator({
	      id: "engage.histogram.explanation",
	      num_opinions: opinions.length
	    }, "Histogram showing {num_opinions, plural, one {# opinion} other {# opinions}} about this proposal.")), DIV({
	      key: 'accessibility-histo-description',
	      id: "histo-description-" + proposal.id,
	      className: 'hidden'
	    }, translator({
	      id: "engage.histogram.explanation_extended",
	      num_opinions: opinions.length,
	      avg_score: exp,
	      negative_pole: get_slider_label("slider_pole_labels.oppose", this.props.proposal, subdomain),
	      positive_pole: get_slider_label("slider_pole_labels.support", this.props.proposal, subdomain)
	    }, "This histogram displays the opinions of everyone who has given an opinion about this proposal. The \nopinions are given on a spectrum from {negative_pole} to {positive_pole}. In this histogram, \n{num_opinions, plural, one {one person's opinion of} other {# people's opinion, with an average of}} {avg_score} \n   on a spectrum from {negative_pole} to {positive_pole}. ")), DIV({
	      key: 'vert-padding',
	      style: {
	        height: this.local.region_selected_vertical_padding
	      }
	    }), draw_selection_area ? this.drawSelectionArea() : void 0, this.drawAvatars({
	      histo_height: histo_height,
	      enable_individual_selection: enable_individual_selection,
	      onClick: histogram_props.onClick
	    }), this.props.draw_base || this.props.draw_base_labels ? (this.props.draw_base ? base = DIV({
	      key: 'slidergram-base',
	      className: 'slidergram-base',
	      style: {
	        width: '100%',
	        height: ((ref1 = this.props.base_style) != null ? ref1.height : void 0) || 1,
	        backgroundColor: ((ref2 = this.props.base_style) != null ? ref2.color : void 0) || "#999"
	      }
	    }) : base = SPAN(null), this.props.draw_base_labels ? labels = this.drawHistogramLabels(subdomain, proposal) : labels = SPAN(null), this.props.flip ? FLIPPED({
	      inverseFlipId: flip_id,
	      shouldInvert: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }, DIV(null, FLIPPED({
	      flipId: flip_id + 'slidergram-base',
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }, base), labels)) : [base, labels]) : void 0);
	    if (this.props.flip) {
	      return FLIPPED({
	        flipId: flip_id,
	        shouldFlip: this.props.shouldFlip,
	        shouldFlipIgnore: this.props.shouldFlipIgnore,
	        onComplete: this.onAnimationDone,
	        translate: true
	      }, histo);
	    } else {
	      return histo;
	    }
	  },
	  drawAvatars: function(arg) {
	    var enable_individual_selection, histo_height, onClick;
	    histo_height = arg.histo_height, enable_individual_selection = arg.enable_individual_selection, onClick = arg.onClick;
	    return DIV({
	      className: 'histoavatars-container',
	      key: 'histoavatars'
	    }, HistoAvatars({
	      histo_key: this.props.histo_key || this.props.proposal.key || this.props.proposal,
	      weights: this.weights,
	      salience: this.salience,
	      groups: this.groups,
	      enable_individual_selection: enable_individual_selection,
	      enable_range_selection: this.enable_range_selection,
	      height: this.props.height,
	      width: this.props.width,
	      backgrounded: this.props.backgrounded,
	      opinions: this.opinions,
	      navigating_inside: this.local.navigating_inside,
	      layout_params: this.props.layout_params,
	      onClick: onClick,
	      resolution: this.props.resolution
	    }));
	  },
	  drawHistogramLabels: function(subdomain, proposal) {
	    var flip_id, label_style, negative, positive;
	    if (subdomain == null) {
	      subdomain = fetch('/subdomain');
	    }
	    label_style = this.props.label_style || {
	      fontSize: 12,
	      fontWeight: 400,
	      color: '#555',
	      bottom: -19
	    };
	    negative = SPAN({
	      key: 'oppose',
	      style: _.extend({}, label_style, {
	        position: 'absolute',
	        left: 0
	      })
	    }, get_slider_label("slider_pole_labels.oppose", this.props.proposal, subdomain));
	    positive = SPAN({
	      key: 'support',
	      style: _.extend({}, label_style, {
	        position: 'absolute',
	        right: 0
	      })
	    }, get_slider_label("slider_pole_labels.support", this.props.proposal, subdomain));
	    if (this.props.flip) {
	      flip_id = "histogram-" + proposal.key;
	      return [
	        FLIPPED({
	          key: 'negative',
	          flipId: "histogram-" + proposal.key + "-negative-pole",
	          shouldFlip: this.props.shouldFlip,
	          shouldFlipIgnore: this.props.shouldFlipIgnore
	        }, negative), FLIPPED({
	          key: 'positive',
	          flipId: "histogram-" + proposal.key + "-positive-pole",
	          shouldFlip: this.props.shouldFlip,
	          shouldFlipIgnore: this.props.shouldFlipIgnore
	        }, positive)
	      ];
	    } else {
	      return [negative, positive];
	    }
	  },
	  drawSelectionArea: function() {
	    var anchor, base_width, left, opinion_views, ref, ref1, selection_left, selection_width;
	    opinion_views = fetch('opinion_views');
	    anchor = opinion_views.active_views.single_opinion_selected || ((ref = opinion_views.active_views) != null ? (ref1 = ref.region_selected) != null ? ref1.opinion_value : void 0 : void 0) || this.local.mouse_opinion_value;
	    left = ((anchor + 1) / 2 - REGION_SELECTION_WIDTH / 2) * this.props.width;
	    base_width = REGION_SELECTION_WIDTH * this.props.width;
	    selection_width = Math.min(Math.min(base_width, base_width + left), this.props.width - left);
	    selection_left = Math.max(0, left);
	    if ((!is_histogram_controlling_region_selection(this.props.histo_key) && get_originating_histogram()) || fetch('popover').element_in_focus) {
	      return DIV({
	        key: 'selection_label'
	      });
	    }
	    return DIV({
	      key: 'selection_label',
	      'aria-hidden': true,
	      style: {
	        height: this.props.height + REGION_SELECTION_VERTICAL_PADDING + 2,
	        position: 'absolute',
	        width: selection_width,
	        backgroundColor: "rgb(246, 247, 249)",
	        cursor: 'pointer',
	        left: selection_left,
	        top: -2,
	        borderTop: "2px solid",
	        borderTopColor: opinion_views.active_views.region_selected ? focus_color() : 'transparent'
	      }
	    }, !opinion_views.active_views.region_selected ? DIV({
	      style: {
	        fontSize: 12,
	        textAlign: 'center',
	        whiteSpace: 'nowrap',
	        marginTop: -3,
	        marginLeft: -4,
	        userSelect: 'none',
	        MozUserSelect: 'none',
	        WebkitUserSelect: 'none',
	        msUserSelect: 'none',
	        pointerEvents: 'none'
	      }
	    }, TRANSLATE("engage.histogram.select_these_opinions", 'highlight opinions')) : void 0);
	  },
	  onClick: function(ev, user) {
	    var is_clicking_user, is_deselection, max, min, opinion_views, reasons_region_el, some_region_selected, user_key, user_opinion;
	    ev.stopPropagation();
	    opinion_views = fetch('opinion_views');
	    if (this.props.backgrounded) {
	      if (this.props.on_click_when_backgrounded) {
	        return this.props.on_click_when_backgrounded();
	      }
	    } else {
	      if (ev.type === 'touchstart') {
	        this.local.mouse_opinion_value = this.getOpinionValueAtFocus(ev);
	      }
	      is_clicking_user = !!user;
	      if (is_clicking_user) {
	        user_key = user;
	        user_opinion = _.findWhere(this.opinions, {
	          user: user_key
	        });
	        if (this.weights[user_key] === 0 || this.salience[user_key] < 1) {
	          clear_histogram_managed_opinion_views(opinion_views);
	        } else {
	          select_single_opinion(user_opinion, this.props.histo_key);
	        }
	      } else {
	        if (opinion_views.active_views.single_opinion_selected) {
	          clear_histogram_managed_opinion_views(opinion_views);
	          return;
	        }
	        some_region_selected = !!opinion_views.active_views.region_selected;
	        max = this.local.mouse_opinion_value + REGION_SELECTION_WIDTH;
	        min = this.local.mouse_opinion_value - REGION_SELECTION_WIDTH;
	        is_deselection = (is_histogram_controlling_region_selection(this.props.histo_key)) || (some_region_selected && inRange(this.local.mouse_opinion_value, min, max));
	        reasons_region_el = ReactDOM.findDOMNode(this).closest('.OpinionBlock').querySelector('.reasons_region');
	        if (is_deselection) {
	          clear_histogram_managed_opinion_views(opinion_views);
	          if (ev.type === 'touchstart') {
	            this.local.mouse_opinion_value = null;
	          }
	          if (reasons_region_el) {
	            reasons_region_el.style.minHeight = null;
	          }
	        } else if (this.enable_range_selection) {
	          if (reasons_region_el) {
	            reasons_region_el.style.minHeight = ($$.height(reasons_region_el)) + "px";
	          }
	          clear_histogram_managed_opinion_views(opinion_views, 'single_opinion_selected');
	          this.users_in_region = this.getUsersInRegion();
	          opinion_views.active_views.region_selected = {
	            created_by: this.props.histo_key,
	            opinion_value: this.local.mouse_opinion_value,
	            get_salience: (function(_this) {
	              return function(u, opinion, proposal) {
	                if (_this.users_in_region[u.key || u]) {
	                  return 1;
	                } else {
	                  return .1;
	                }
	              };
	            })(this)
	          };
	        }
	      }
	      save(opinion_views);
	      return save(this.local);
	    }
	  },
	  getUsersInRegion: function() {
	    var j, len, max, min, o, ref, salient, users_in_region;
	    min = this.local.mouse_opinion_value - REGION_SELECTION_WIDTH;
	    max = this.local.mouse_opinion_value + REGION_SELECTION_WIDTH;
	    users_in_region = {};
	    ref = this.opinions;
	    for (j = 0, len = ref.length; j < len; j++) {
	      o = ref[j];
	      salient = inRange(o.stance, min, max);
	      if (salient) {
	        users_in_region[o.user] = true;
	      }
	    }
	    return users_in_region;
	  },
	  getOpinionValueAtFocus: function(ev) {
	    var h_w, h_x, m_x;
	    h_x = ReactDOM.findDOMNode(this).getBoundingClientRect().left + window.pageXOffset;
	    h_w = ReactDOM.findDOMNode(this).offsetWidth;
	    m_x = ev.pageX || ev.touches[0].pageX;
	    return translatePixelXToStance(m_x - h_x, h_w);
	  },
	  onMouseMove: function(ev) {
	    var at_pole, mouse_sensitivity, opinion_views, region_selected;
	    if (fetch(namespaced_key('slider', this.props.proposal)).is_moving || this.props.backgrounded || !this.enable_range_selection || (!is_histogram_controlling_region_selection(this.props.histo_key) && get_originating_histogram())) {
	      return;
	    }
	    ev.stopPropagation();
	    this.local.hovering_over_avatar = ev.target.className.indexOf('avatar') !== -1;
	    this.local.mouse_opinion_value = this.getOpinionValueAtFocus(ev);
	    at_pole = false;
	    if (this.local.mouse_opinion_value + REGION_SELECTION_WIDTH >= 1) {
	      this.local.mouse_opinion_value = 1 - REGION_SELECTION_WIDTH;
	      at_pole = true;
	    } else if (this.local.mouse_opinion_value - REGION_SELECTION_WIDTH <= -1) {
	      this.local.mouse_opinion_value = -1 + REGION_SELECTION_WIDTH;
	      at_pole = true;
	    }
	    opinion_views = fetch('opinion_views');
	    region_selected = opinion_views.active_views.region_selected;
	    if (region_selected && this.local.mouse_opinion_value) {
	      mouse_sensitivity = 25;
	      if (at_pole || Math.round(this.local.mouse_opinion_value * mouse_sensitivity) !== Math.round(region_selected.opinion_value * mouse_sensitivity)) {
	        region_selected.opinion_value = this.local.mouse_opinion_value;
	        this.users_in_region = this.getUsersInRegion();
	        save(opinion_views);
	      }
	    }
	    return save(this.local);
	  },
	  onMouseDown: function(ev) {
	    if (fetch(namespaced_key('slider', this.props.proposal)).is_moving) {
	      return;
	    }
	    ev.stopPropagation();
	    return false;
	  },
	  onMouseLeave: function(ev) {
	    if (fetch(namespaced_key('slider', this.props.proposal)).is_moving) {
	      return;
	    }
	    this.local.mouse_opinion_value = null;
	    return save(this.local);
	  }
	});
	
	window.styles += ".histo_avatar.avatar {\n  cursor: pointer;\n  position: absolute;\n  /* top: 0;\n  left: 0; */\n  transform-origin: 0 0;\n}\nimg.histo_avatar.avatar {\n  z-index: 1;\n}\n\n.HistoAvatars .sk-wave {\n  margin: 0;\n}\n\n.AggregatedHistogram .sk-wave {\n  margin: 0;\n}  \n\n\n@keyframes histo-loading-appear {\n  0%   {opacity: 0;}\n  100% {opacity: 1;}\n}\n\n.histo-loading {\n  opacity: 0;\n  animation-name: histo-loading-appear;\n  animation-duration: 100ms; /* Adjust duration as needed */\n  animation-delay: 1s;    /* Adjust delay as needed */\n  animation-fill-mode: forwards;\n}\n";
	
	$$.add_delegated_listener(document.body, 'keydown', '.avatar[data-opinion]', function(e) {
	  var user_opinion;
	  if (e.which === 13 || e.which === 32) {
	    user_opinion = fetch(e.target.getAttribute('data-opinion'));
	    return select_single_opinion(user_opinion, 'keydown');
	  }
	});
	
	hit_region_avatars = {};
	
	hit_region_color_to_user_map = {};
	
	window.last_histogram_position = {};
	
	SKIP_FRAMES = 1;
	
	HistoAvatars = ReactiveComponent({
	  displayName: 'HistoAvatars',
	  render: function() {
	    var base1, histocache_key, proposal, radius, ref;
	    histocache_key = this.histocache_key();
	    if (!((ref = this.local.avatar_sizes) != null ? ref[histocache_key] : void 0)) {
	      if ((base1 = this.local).avatar_sizes == null) {
	        base1.avatar_sizes = {};
	      }
	      if (this.props.resolution === 'auto') {
	        radius = 1;
	        this.resolution = 0;
	        while (radius <= 1) {
	          this.resolution += .5;
	          radius = calculateAvatarRadius(this.props.width * this.resolution, this.props.height * this.resolution, this.props.opinions, this.props.weights, {
	            fill_ratio: this.getFillRatio()
	          });
	        }
	      } else {
	        this.resolution = this.props.resolution || (this.props.opinions.length > 1000 ? 1.5 : 1);
	        radius = calculateAvatarRadius(this.props.width * this.resolution, this.props.height * this.resolution, this.props.opinions, this.props.weights, {
	          fill_ratio: this.getFillRatio()
	        });
	      }
	      this.local.avatar_sizes[histocache_key] = 2 * radius;
	    }
	    this.avatar_size = this.local.avatar_sizes[histocache_key];
	    this.last_key = histocache_key;
	    this.cut_off_buffer = Math.round(this.props.height / 2);
	    this.adjusted_height = Math.round(this.props.height + this.cut_off_buffer);
	    this.adjusted_width = Math.round(this.props.width + 2 * this.cut_off_buffer);
	    proposal = fetch(this.props.histo_key);
	    return DIV({
	      className: 'HistoAvatars',
	      id: histocache_key,
	      key: this.props.histo_key || this.local.key,
	      ref: 'histo',
	      'data-receive-viewport-visibility-updates': 1.5,
	      'data-visibility-name': 'histogram',
	      'data-component': this.local.key,
	      style: {
	        transform: "translateZ(0)",
	        height: this.props.height,
	        width: this.props.width,
	        position: 'relative',
	        cursor: !this.props.backgrounded && this.enable_range_selection ? 'pointer' : void 0
	      }
	    }, !this.ready_to_draw() ? DIV({
	      className: "histo-loading",
	      style: {
	        position: 'absolute',
	        top: this.props.height / 2 - 20,
	        left: this.props.width / 2 - 25
	      }
	    }, LOADING_INDICATOR) : void 0, CANVAS({
	      ref: 'canvas',
	      onClick: this.handleClick,
	      onMouseMove: this.handleMouseMove,
	      onMouseOut: this.handleMouseOut,
	      role: "img",
	      'aria-labelledby': !this.props.backgrounded ? "histo-label-" + proposal.id : void 0,
	      'aria-describedby': !this.props.backgrounded ? "histo-description-" + proposal.id : void 0
	    }));
	  },
	  componentDidMount: function() {
	    this.PhysicsSimulation();
	    schedule_viewport_position_check();
	    return this.updateAvatars();
	  },
	  componentDidUpdate: function() {
	    this.PhysicsSimulation();
	    return this.updateAvatars();
	  },
	  ready_to_draw: function() {
	    var users;
	    users = fetch('/users');
	    return users.users && this.getAvatarPositions();
	  },
	  getAvatarPositions: function() {
	    var current_user, histocache, idx, ref, users;
	    histocache = (ref = this.local.histocache) != null ? ref[this.last_key] : void 0;
	    last_histogram_position[this.props.histo_key] = histocache;
	    if (!!histocache && (histocache.ordered_users == null)) {
	      users = Object.keys(histocache.positions || {});
	      current_user = fetch('/current_user');
	      if (current_user.key && (idx = users.indexOf(current_user.user)) > -1) {
	        users.splice(idx, 1);
	        users.push(current_user.user);
	      }
	      histocache.ordered_users = users;
	    }
	    return histocache;
	  },
	  animate_to: function(sprite, x, y, r, opacity) {
	    sprite.from_x = sprite.x;
	    sprite.from_y = sprite.y;
	    sprite.from_size = sprite.width;
	    sprite.target_x = x;
	    sprite.target_y = y;
	    sprite.target_size = r * 2;
	    sprite.from_opacity = sprite.opacity;
	    sprite.target_opacity = opacity;
	    return this.updates_needed[sprite.key] = 1;
	  },
	  resize_canvas: function(width, height, top, left, animate) {
	    var ani, base1, canv, reset_bounding_rect;
	    canv = this.refs.canvas;
	    if (!canv) {
	      return;
	    }
	    if (animate) {
	      this.resizing_canvas = {
	        width: width,
	        height: height,
	        target_width: width + 50,
	        target_height: height,
	        target_top: top,
	        target_left: left
	      };
	      if ((base1 = this.resize_canvas).ani == null) {
	        base1.ani = 0;
	      }
	      this.resize_canvas.ani += 1;
	      ani = this.resize_canvas.ani;
	      ReactFlipToolkit.spring({
	        config: PROPOSAL_ITEM_SPRING,
	        values: {
	          width: [parseInt(canv.style.width), width + 50],
	          height: [parseInt(canv.style.height), height],
	          top: [this.current_top, top],
	          left: [this.current_left, left]
	        },
	        onUpdate: (function(_this) {
	          return function(ani) {
	            return function(arg) {
	              var height, left, top, width;
	              width = arg.width, height = arg.height, top = arg.top, left = arg.left;
	              if (ani === _this.resize_canvas.ani) {
	                _this.resizing_canvas.width = Math.round(width);
	                _this.resizing_canvas.height = Math.round(height);
	                _this.resizing_canvas.top = Math.round(top);
	                return _this.resizing_canvas.left = Math.round(left);
	              }
	            };
	          };
	        })(this)(ani),
	        onComplete: (function(_this) {
	          return function(ani) {
	            return function() {
	              if (ani === _this.resize_canvas.ani) {
	                return _this.resizing_canvas = false;
	              }
	            };
	          };
	        })(this)(ani)
	      });
	      return this.wake();
	    } else {
	      reset_bounding_rect = false;
	      if (canv.width !== width * DEVICE_PIXEL_RATIO || canv.height !== height * DEVICE_PIXEL_RATIO) {
	        canv.width = width * DEVICE_PIXEL_RATIO;
	        canv.height = height * DEVICE_PIXEL_RATIO;
	        canv.style.width = width + "px";
	        canv.style.height = height + "px";
	        reset_bounding_rect = true;
	      }
	      if (this.current_top !== top || this.current_left !== left) {
	        canv.style.transform = "translate(" + left + "px, " + top + "px)";
	        this.current_top = top;
	        this.current_left = left;
	        reset_bounding_rect = true;
	      }
	      if (reset_bounding_rect) {
	        return this.canvas_bounding_rect = null;
	      }
	    }
	  },
	  updateAvatars: function() {
	    var ani, anonymize_permanently, avatars_loaded, canvas, canvas_resize_needed, colors, group, groups, has_groups, height, histocache, idx, j, len, new_animation_needed, o, opacity, opinion, opinion_views, pos, r, rainbow_group, ref, ref1, sprite, user, users, width, x, y;
	    if (!this.ready_to_draw()) {
	      return;
	    }
	    avatars_loaded = fetch('avatar_loading');
	    if (avatars_loaded.loaded && this.avatars_loaded !== avatars_loaded.loaded) {
	      this.dirty_canvas = true;
	    }
	    this.avatars_loaded = avatars_loaded.loaded;
	    users = fetch('/users');
	    histocache = this.getAvatarPositions();
	    canvas = this.refs.canvas;
	    this.updates_needed || (this.updates_needed = {});
	    this.sprites || (this.sprites = {});
	    if (this.sleeping == null) {
	      this.sleeping = true;
	    }
	    canvas_resize_needed = false;
	    if (!this.ctx) {
	      this.ctx = canvas.getContext('2d');
	      this.resize_canvas(this.adjusted_width, this.adjusted_height, -this.cut_off_buffer, -this.cut_off_buffer);
	      this.dirty_canvas = true;
	    } else if ((canvas.width !== this.adjusted_width * DEVICE_PIXEL_RATIO || canvas.height !== this.adjusted_height * DEVICE_PIXEL_RATIO || this.current_top !== -this.cut_off_buffer || this.current_left !== -this.cut_off_buffer) && (!this.resizing_canvas || this.resizing_canvas.target_width !== this.adjusted_width || this.resizing_canvas.target_height !== this.adjusted_height || this.resizing_canvas.target_top !== -this.cut_off_buffer || this.resizing_canvas.target_left !== -this.cut_off_buffer)) {
	      canvas_resize_needed = true;
	    }
	    opinion_views = fetch('opinion_views');
	    groups = get_user_groups_from_views(this.props.groups);
	    has_groups = !!groups;
	    if (has_groups) {
	      colors = get_color_for_groups(groups);
	    }
	    anonymize_permanently = customization('anonymize_permanently');
	    new_animation_needed = false;
	    this.dirty_canvas || (this.dirty_canvas = this.last_drawn !== histocache.hash);
	    this.last_drawn = histocache.hash;
	    if (this.user_to_opinion_map == null) {
	      this.user_to_opinion_map = {};
	    }
	    ref = this.props.opinions;
	    for (idx = j = 0, len = ref.length; j < len; idx = ++j) {
	      opinion = ref[idx];
	      user = fetch(opinion.user);
	      o = fetch(opinion);
	      this.user_to_opinion_map[user.key] = o.key;
	      pos = histocache != null ? (ref1 = histocache.positions) != null ? ref1[user.key] : void 0 : void 0;
	      if (!pos) {
	        continue;
	      }
	      x = Math.round(pos[0]) / this.resolution + this.cut_off_buffer;
	      y = Math.round(pos[1]) / this.resolution + this.cut_off_buffer;
	      r = Math.round(pos[2]) / this.resolution;
	      width = height = r * 2;
	      opacity = this.props.backgrounded ? 0.1 : this.props.salience[user.key] || 1;
	      if (!(user.key in this.sprites)) {
	        this.sprites[user.key] = {
	          x: x,
	          y: y,
	          r: r,
	          width: width,
	          height: height,
	          opacity: opacity,
	          key: user.key
	        };
	      }
	      sprite = this.sprites[user.key];
	      sprite.img = getCanvasAvatar(user, o.hide_name || arest.key_id(user.key) < 0 || anonymize_permanently);
	      if (has_groups && (this.props.groups[user.key] != null)) {
	        if (this.props.groups[user.key].length === 1) {
	          group = this.props.groups[user.key][0];
	          sprite.img = getGroupIcon(group, colors[group]);
	        } else {
	          rainbow_group = this.props.groups[user.key].join('-');
	          sprite.img = getCompositeGroupIcon(rainbow_group, this.props.groups[user.key], colors);
	        }
	      }
	      if ((sprite.x !== x && sprite.target_x !== x) || (sprite.y !== y && sprite.target_y !== y) || (sprite.width !== r * 2 && sprite.target_size !== r * 2) || (sprite.opacity !== opacity)) {
	        this.animate_to(sprite, x, y, r, opacity);
	        new_animation_needed = true;
	      }
	    }
	    if (new_animation_needed) {
	      if (this.current_ani == null) {
	        this.current_ani = 0;
	      }
	      this.current_ani += 1;
	      ani = this.current_ani;
	      this.dirty_canvas = true;
	      ReactFlipToolkit.spring({
	        config: PROPOSAL_ITEM_SPRING,
	        onUpdate: (function(_this) {
	          return function(ani) {
	            return function(val) {
	              var __, key, ref2, results;
	              if (ani !== _this.current_ani) {
	                return;
	              }
	              ref2 = _this.updates_needed;
	              results = [];
	              for (key in ref2) {
	                __ = ref2[key];
	                sprite = _this.sprites[key];
	                sprite.x = sprite.from_x + (sprite.target_x - sprite.from_x) * val;
	                sprite.y = sprite.from_y + (sprite.target_y - sprite.from_y) * val;
	                sprite.width = sprite.height = sprite.from_size + (sprite.target_size - sprite.from_size) * val;
	                results.push(sprite.opacity = sprite.from_opacity + (sprite.target_opacity - sprite.from_opacity) * val);
	              }
	              return results;
	            };
	          };
	        })(this)(ani),
	        onComplete: (function(_this) {
	          return function(ani) {
	            return function() {
	              var __, key, ref2;
	              if (ani !== _this.current_ani) {
	                return;
	              }
	              ref2 = _this.updates_needed;
	              for (key in ref2) {
	                __ = ref2[key];
	                sprite = _this.sprites[key];
	                sprite.x = sprite.from_x = sprite.target_x;
	                sprite.y = sprite.from_y = sprite.target_y;
	                sprite.width = sprite.height = sprite.from_size = sprite.target_size;
	                sprite.opacity = sprite.from_opacity = sprite.target_opacity;
	              }
	              return _this.updates_needed = {};
	            };
	          };
	        })(this)(ani)
	      });
	    }
	    if (canvas_resize_needed) {
	      this.resize_canvas(this.adjusted_width, this.adjusted_height, -this.cut_off_buffer, -this.cut_off_buffer, true);
	    }
	    return this.wake();
	  },
	  wake: function() {
	    if (this.sleeping) {
	      this.buffered_frame_ready = false;
	      this.sleeping = false;
	      return this.tick();
	    }
	  },
	  prepareNextFrame: function(force) {
	    var histocache, j, key, l, len, len1, ref, ref1, ref2, ref3, sprite, updating_opacity;
	    if (force == null) {
	      force = this.dirty_canvas;
	    }
	    histocache = this.getAvatarPositions();
	    this.skip_frame = !!SKIP_FRAMES && !force;
	    if (SKIP_FRAMES && !force) {
	      ref = (histocache != null ? histocache.ordered_users : void 0) || [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        key = ref[j];
	        sprite = this.sprites[key];
	        if (!sprite) {
	          continue;
	        }
	        updating_opacity = sprite.target_opacity !== sprite.from_opacity || sprite.opacity !== 1;
	        if (updating_opacity) {
	          this.skip_frame = false;
	          break;
	        }
	        if (((sprite.last_render_x == null) || Math.abs(sprite.x - sprite.last_render_x) > SKIP_FRAMES) || ((sprite.last_render_y == null) || Math.abs(sprite.y - sprite.last_render_y) > SKIP_FRAMES) || ((sprite.last_render_size == null) || Math.abs(sprite.width - sprite.last_render_size) > SKIP_FRAMES)) {
	          this.skip_frame = false;
	          break;
	        }
	      }
	    }
	    if (!this.skip_frame && this.buffer && this.refs.canvas) {
	      if (this.buff_ctx == null) {
	        this.buff_ctx = this.buffer.getContext('2d');
	      }
	      this.buffer.width = (((ref1 = this.resizing_canvas) != null ? ref1.width : void 0) || this.refs.canvas.width) * DEVICE_PIXEL_RATIO;
	      this.buffer.height = (((ref2 = this.resizing_canvas) != null ? ref2.height : void 0) || this.refs.canvas.height) * DEVICE_PIXEL_RATIO;
	      ref3 = (histocache != null ? histocache.ordered_users : void 0) || [];
	      for (l = 0, len1 = ref3.length; l < len1; l++) {
	        key = ref3[l];
	        sprite = this.sprites[key];
	        if (!sprite) {
	          continue;
	        }
	        updating_opacity = sprite.target_opacity !== sprite.from_opacity || sprite.opacity !== 1;
	        if (updating_opacity) {
	          this.buff_ctx.save();
	          this.buff_ctx.globalAlpha = sprite.opacity;
	        }
	        this.buff_ctx.drawImage(sprite.img, sprite.x * DEVICE_PIXEL_RATIO, sprite.y * DEVICE_PIXEL_RATIO, sprite.width * DEVICE_PIXEL_RATIO, sprite.height * DEVICE_PIXEL_RATIO);
	        if (updating_opacity) {
	          this.buff_ctx.restore();
	        }
	        sprite.last_render_x = sprite.x;
	        sprite.last_render_y = sprite.y;
	        sprite.last_render_size = sprite.width;
	      }
	      return this.buffered_frame_ready = true;
	    }
	  },
	  updateHitRegion: function() {
	    var histocache, hit_key, j, key, len, ref, ref1, ref2, sprite, user;
	    hit_key = this.last_key + "-" + this.buffer.width + "-" + this.buffer.height;
	    if (this.last_hit_region_key === hit_key) {
	      return;
	    }
	    if (this.hit_region_buffer == null) {
	      this.hit_region_buffer = document.createElement('canvas');
	    }
	    if (this.hit_ctx == null) {
	      this.hit_ctx = this.hit_region_buffer.getContext('2d');
	    }
	    this.hit_region_buffer.width = (((ref = this.resizing_canvas) != null ? ref.width : void 0) || this.refs.canvas.width) * DEVICE_PIXEL_RATIO;
	    this.hit_region_buffer.height = (((ref1 = this.resizing_canvas) != null ? ref1.height : void 0) || this.refs.canvas.height) * DEVICE_PIXEL_RATIO;
	    this.hit_ctx.clearRect(0, 0, this.buffer.width, this.buffer.height);
	    histocache = this.getAvatarPositions();
	    ref2 = (histocache != null ? histocache.ordered_users : void 0) || [];
	    for (j = 0, len = ref2.length; j < len; j++) {
	      key = ref2[j];
	      sprite = this.sprites[key];
	      if (!(key in hit_region_avatars)) {
	        user = fetch(key);
	        hit_region_avatars[key] = createHitRegionAvatar(user);
	        hit_region_color_to_user_map[user.hit_region_color] = key;
	      }
	      this.hit_ctx.drawImage(hit_region_avatars[key], sprite.x * DEVICE_PIXEL_RATIO, sprite.y * DEVICE_PIXEL_RATIO, sprite.width * DEVICE_PIXEL_RATIO, sprite.height * DEVICE_PIXEL_RATIO);
	    }
	    return this.last_hit_region_key = hit_key;
	  },
	  tick: function() {
	    var render_required;
	    render_required = this.dirty_canvas || !!this.resizing_canvas || Object.keys(this.updates_needed).length > 0;
	    if (!render_required) {
	      if (this.skip_frame) {
	        this.prepareNextFrame(true);
	        this.renderScene();
	      }
	      this.sleeping = true;
	      return;
	    }
	    return requestAnimationFrame((function(_this) {
	      return function() {
	        if (_this.buffer == null) {
	          _this.buffer = document.createElement('canvas');
	          _this.prepareNextFrame(true);
	          _this.renderScene();
	          return _this.tick();
	        } else {
	          setTimeout(function() {
	            _this.prepareNextFrame();
	            return _this.tick();
	          });
	          return _this.renderScene();
	        }
	      };
	    })(this));
	  },
	  renderScene: function() {
	    if (!this.buffered_frame_ready || !this.refs.canvas) {
	      return;
	    }
	    if (this.resizing_canvas) {
	      this.resize_canvas(this.resizing_canvas.width, this.resizing_canvas.height, this.resizing_canvas.top, this.resizing_canvas.left);
	    }
	    this.ctx.clearRect(0, 0, this.refs.canvas.width * DEVICE_PIXEL_RATIO, this.refs.canvas.height * DEVICE_PIXEL_RATIO);
	    this.ctx.drawImage(this.buffer, 0, 0);
	    this.dirty_canvas = false;
	    return this.buffered_frame_ready = false;
	  },
	  userAtPosition: function(e) {
	    var canvas, color, pixel, user, x, y;
	    if (!this.buffer) {
	      return;
	    }
	    canvas = this.refs.canvas;
	    this.updateHitRegion();
	    this.canvas_bounding_rect = canvas.getBoundingClientRect();
	    x = (e.clientX - this.canvas_bounding_rect.left) / (this.canvas_bounding_rect.right - this.canvas_bounding_rect.left) * canvas.width;
	    y = (e.clientY - this.canvas_bounding_rect.top) / (this.canvas_bounding_rect.bottom - this.canvas_bounding_rect.top) * canvas.height;
	    pixel = this.hit_ctx.getImageData(x, y, 1, 1).data;
	    color = "rgb(" + pixel[0] + "," + pixel[1] + "," + pixel[2] + ")";
	    user = hit_region_color_to_user_map[color];
	    return user;
	  },
	  handleMouseMove: function(e) {
	    var backgrounded, coords, cursor, histocache, id, opinion, opinionId, opts, pos, ref, user;
	    if (fetch(namespaced_key('slider', this.props.histo_key)).is_moving || fetch('opinion_views').active_views.single_opinion_selected) {
	      return;
	    }
	    user = this.userAtPosition(e);
	    id = null;
	    if (user) {
	      backgrounded = (this.sprites[user].target_opacity || this.sprites[user].opacity) < 1;
	      if (backgrounded) {
	        cursor = 'auto';
	      } else {
	        cursor = 'pointer';
	        id = this.props.histo_key + "-" + user;
	      }
	      e.stopPropagation();
	      e.preventDefault();
	    } else {
	      cursor = 'auto';
	    }
	    if (this.refs.canvas.style.cursor !== cursor) {
	      this.refs.canvas.style.cursor = cursor;
	    }
	    if (fetch('popover').element_in_focus !== id) {
	      if (user && !backgrounded) {
	        histocache = this.getAvatarPositions();
	        pos = histocache != null ? (ref = histocache.positions) != null ? ref[user] : void 0 : void 0;
	        coords = {
	          top: pos[1] / this.resolution + this.canvas_bounding_rect.top + window.pageYOffset - document.documentElement.clientTop + this.cut_off_buffer,
	          left: pos[0] / this.resolution + this.canvas_bounding_rect.left + window.pageXOffset - document.documentElement.clientLeft + pos[2] + this.cut_off_buffer,
	          height: 2 * pos[2] / this.resolution,
	          width: 2 * pos[2] / this.resolution
	        };
	        opinionId = this.user_to_opinion_map[user];
	        opinion = fetch(opinionId);
	        opts = {
	          id: id,
	          user: user,
	          opinion: opinionId,
	          coords: coords
	        };
	      } else {
	        opts = null;
	      }
	      return update_avatar_popover_from_canvas_histo(opts);
	    }
	  },
	  handleMouseOut: function(e) {
	    this.refs.canvas.style.cursor = 'auto';
	    return update_avatar_popover_from_canvas_histo();
	  },
	  handleClick: function(e) {
	    var base1, user;
	    user = this.userAtPosition(e);
	    if (user) {
	      if ((this.sprites[user].target_opacity || this.sprites[user].opacity) < 1) {
	        user = null;
	      }
	    }
	    update_avatar_popover_from_canvas_histo();
	    return typeof (base1 = this.props).onClick === "function" ? base1.onClick(e, user) : void 0;
	  },
	  histocache_key: function() {
	    var key, o;
	    key = (JSON.stringify((function() {
	      var j, len, ref, results;
	      ref = this.props.opinions;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        o = ref[j];
	        results.push(fetch(o.key).stance + (arest.cache[o.key].hide_name ? 'hide' : ''));
	      }
	      return results;
	    }).call(this))) + " " + (JSON.stringify(this.props.weights)) + " " + (JSON.stringify(this.props.groups)) + " " + (JSON.stringify(this.props.salience)) + " (" + this.props.width + ", " + this.props.height + ")";
	    return murmurhash(key, 0);
	  },
	  getFillRatio: function() {
	    var ref;
	    if ((ref = this.props.layout_params) != null ? ref.fill_ratio : void 0) {
	      return this.props.layout_params.fill_ratio;
	    } else if (this.isMultiWeighedHistogram()) {
	      return .75;
	    } else {
	      return 1;
	    }
	  },
	  isMultiWeighedHistogram: function() {
	    var k, multi_weighed, previous, ref, v;
	    multi_weighed = false;
	    previous = null;
	    ref = this.props.weights;
	    for (k in ref) {
	      v = ref[k];
	      if (previous !== null && v !== previous) {
	        multi_weighed = true;
	        break;
	      }
	      previous = v;
	    }
	    return multi_weighed;
	  },
	  PhysicsSimulation: function() {
	    var has_groups, histocache_key, layout_params, o, opinions, proposal;
	    proposal = fetch(this.props.proposal);
	    histocache_key = this.last_key;
	    if (this.local.in_viewport && !(histocache_key in (this.local.histocache || {})) && this.current_request !== histocache_key) {
	      this.current_request = histocache_key;
	      opinions = (function() {
	        var j, len, ref, results;
	        ref = this.props.opinions;
	        results = [];
	        for (j = 0, len = ref.length; j < len; j++) {
	          o = ref[j];
	          if ((this.props.salience == null) || this.props.salience[o.user] === 1) {
	            results.push([o.user, o.stance, this.props.weights[o.user]]);
	          }
	        }
	        return results;
	      }).call(this);
	      if (this.isMultiWeighedHistogram()) {
	        layout_params = _.defaults({}, this.props.layout_params || {}, {
	          fill_ratio: this.getFillRatio(),
	          show_histogram_layout: show_histogram_layout,
	          cleanup_overlap: 2,
	          jostle: 0,
	          rando_order: 0,
	          topple_towers: .05,
	          density_modified_jostle: 0
	        });
	      } else {
	        layout_params = _.defaults({}, this.props.layout_params || {}, {
	          fill_ratio: 1,
	          show_histogram_layout: show_histogram_layout,
	          cleanup_overlap: 1.95,
	          jostle: .4,
	          rando_order: .1,
	          topple_towers: .05,
	          density_modified_jostle: 1
	        });
	      }
	      has_groups = Object.keys(this.props.groups).length > 0;
	      return delegate_layout_task({
	        task: 'layoutAvatars',
	        histo: this.local.key,
	        histo_key: this.props.histo_key,
	        k: histocache_key,
	        r: this.avatar_size / 2,
	        w: (this.props.width || 400) * this.resolution,
	        h: (this.props.height || 70) * this.resolution,
	        o: opinions,
	        groups: has_groups ? this.props.groups : void 0,
	        all_groups: has_groups ? get_user_groups_from_views(this.props.groups) : void 0,
	        layout_params: layout_params
	      });
	    }
	  }
	});
	
	num_layout_workers = 1;
	
	num_layout_tasks_delegated = 0;
	
	get_histo_positions = function(e) {
	  var histocache_key, local, opts, positions, ref, ref1;
	  if ((ref = e.data) != null ? ref.opts : void 0) {
	    ref1 = e.data, opts = ref1.opts, positions = ref1.positions;
	    local = fetch(opts.histo);
	    histocache_key = opts.k;
	    if (local.histocache == null) {
	      local.histocache = {};
	    }
	    local.histocache[histocache_key] = {
	      hash: histocache_key,
	      positions: positions
	    };
	    return save(local);
	  }
	};
	
	window.delegate_layout_task = function(opts) {
	  var after_loaded, intv;
	  if (opts.layout_params.use_global_window) {
	    enqueue_histo_layout(opts);
	    return window.onmessage = get_histo_positions;
	  } else {
	    after_loaded = function() {
	      var histo_layout_worker;
	      histo_layout_worker = histo_layout_workers[num_layout_tasks_delegated % num_layout_workers];
	      histo_layout_worker.postMessage(opts);
	      return num_layout_tasks_delegated += 1;
	    };
	    if (window.histo_layout_workers) {
	      return after_loaded();
	    } else {
	      return intv = setInterval(function() {
	        if (window.histo_layout_workers) {
	          after_loaded();
	          clearInterval(intv);
	        }
	        return configure_histo_layout_web_worker();
	      }, 20);
	    }
	  }
	};
	
	configure_histo_layout_web_worker = function() {
	  var i, j, len, onmessage, ref, results, worker;
	  if (!window.histo_layout_workers && ((ref = arest.cache['/application']) != null ? ref.web_worker : void 0)) {
	    window.histo_layout_workers = (function() {
	      var j, ref1, results;
	      results = [];
	      for (i = j = 0, ref1 = num_layout_workers - 1; 0 <= ref1 ? j <= ref1 : j >= ref1; i = 0 <= ref1 ? ++j : --j) {
	        results.push(new Worker(arest.cache['/application'].web_worker));
	      }
	      return results;
	    })();
	    onmessage = get_histo_positions;
	    results = [];
	    for (j = 0, len = histo_layout_workers.length; j < len; j++) {
	      worker = histo_layout_workers[j];
	      results.push(worker.onmessage = onmessage);
	    }
	    return results;
	  }
	};


/***/ },
/* 38 */
/***/ function(module, exports) {

	var GlobalHistTiming, HistoDetails, LayoutExplorer, LayoutExplorerOptions, histo_layout_explorer_options;
	
	window.HistogramTester = ReactiveComponent({
	  displayName: 'HistogramTester',
	  render: function() {
	    var RenderedHist, cleanup_overlap, common_layout_params, density_modified_jostle, fill_ratio, hist, histo, histos, i, idx, j, jostle, l, layout, layout_params, len, len1, len2, len3, len4, len5, len6, len7, len8, len9, m, n, num_histos, o, p, param, param_hash, param_sets, params, proposal, proposals, proposals_to_show, q, rando_order, ref, ref1, ref2, ref3, ref4, ref5, ref6, resolution, s, size, sizes, start_idx, t, topple_towers, u;
	    num_histos = 30;
	    start_idx = 1;
	    common_layout_params = {
	      show_histogram_layout: false,
	      save_snapshots: false,
	      use_global_window: true,
	      verbose: true,
	      fill_ratio: 1,
	      cleanup_overlap: 1.95,
	      jostle: .4
	    };
	    layout_params = [];
	    ref = [1];
	    for (j = 0, len = ref.length; j < len; j++) {
	      fill_ratio = ref[j];
	      ref1 = [1.95];
	      for (l = 0, len1 = ref1.length; l < len1; l++) {
	        cleanup_overlap = ref1[l];
	        ref2 = [.4];
	        for (m = 0, len2 = ref2.length; m < len2; m++) {
	          jostle = ref2[m];
	          ref3 = [.1];
	          for (n = 0, len3 = ref3.length; n < len3; n++) {
	            rando_order = ref3[n];
	            ref4 = [.05];
	            for (o = 0, len4 = ref4.length; o < len4; o++) {
	              topple_towers = ref4[o];
	              ref5 = [1];
	              for (p = 0, len5 = ref5.length; p < len5; p++) {
	                density_modified_jostle = ref5[p];
	                ref6 = [1, 1.5, 2.1, 10];
	                for (q = 0, len6 = ref6.length; q < len6; q++) {
	                  resolution = ref6[q];
	                  layout_params.push({
	                    resolution: resolution,
	                    density_modified_jostle: density_modified_jostle,
	                    topple_towers: topple_towers,
	                    rando_order: rando_order,
	                    jostle: jostle,
	                    cleanup_overlap: cleanup_overlap,
	                    fill_ratio: fill_ratio
	                  });
	                }
	              }
	            }
	          }
	        }
	      }
	    }
	    param_sets = {};
	    for (s = 0, len7 = layout_params.length; s < len7; s++) {
	      param = layout_params[s];
	      _.defaults(param, common_layout_params);
	      param_hash = JSON.stringify(param);
	      param_sets[param_hash] = _.clone(param);
	      param.param_hash = param_hash;
	    }
	    sizes = [
	      {
	        width: 444,
	        height: 40
	      }
	    ];
	    histos = [];
	    for (t = 0, len8 = layout_params.length; t < len8; t++) {
	      layout = layout_params[t];
	      for (u = 0, len9 = sizes.length; u < len9; u++) {
	        size = sizes[u];
	        histos.push(_.extend({}, size, {
	          layout_params: layout
	        }));
	      }
	    }
	    proposals = fetch('/proposals').proposals;
	    proposals.sort(function(a, b) {
	      return opinionsForProposal(b).length - opinionsForProposal(a).length;
	    });
	    proposals_to_show = proposals.slice(start_idx, start_idx + num_histos);
	    return DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto'
	      }
	    }, OpinionViews(), GlobalHistTiming({
	      param_sets: param_sets
	    }), (function() {
	      var len10, results, z;
	      results = [];
	      for (idx = z = 0, len10 = proposals_to_show.length; z < len10; idx = ++z) {
	        proposal = proposals_to_show[idx];
	        histo = {
	          proposal: proposal,
	          opinions: opinionsForProposal(proposal),
	          enable_individual_selection: false,
	          enable_range_selection: false,
	          draw_base: true,
	          backgrounded: false,
	          draw_base_labels: true,
	          base_style: "2px solid #414141",
	          label_style: {
	            display: 'none'
	          }
	        };
	        results.push(DIV({
	          key: idx,
	          style: {
	            marginTop: 40
	          }
	        }, DIV({
	          style: {
	            fontWeight: 700,
	            fontSize: 28,
	            textAlign: 'center'
	          }
	        }, proposal.name, num_histos > 1 && start_idx === 0 ? " (" + idx + ")" : void 0, DIV(null, (function() {
	          var i1, len11, ref7, results1;
	          results1 = [];
	          for (i = i1 = 0, len11 = histos.length; i1 < len11; i = ++i1) {
	            hist = histos[i];
	            params = _.defaults({
	              histo_key: (namespaced_key('histogram', proposal)) + "-" + i
	            }, histo, hist);
	            params.resolution = (ref7 = params.layout_params) != null ? ref7.resolution : void 0;
	            RenderedHist = Histogram(params);
	            results1.push(DIV({
	              key: RenderedHist.props.histo_key,
	              style: {
	                marginBottom: 20,
	                position: 'relative'
	              }
	            }, RenderedHist, HistoDetails({
	              running_state: RenderedHist.props.histo_key,
	              hist: hist,
	              param_sets: param_sets
	            })));
	          }
	          return results1;
	        })()))));
	      }
	      return results;
	    })());
	  }
	});
	
	histo_layout_explorer_options = fetch('histo_layout_explorer_options');
	
	_.defaults(histo_layout_explorer_options, {
	  show_explorer: true,
	  ms_between_plays: 99999,
	  show_move_log: false,
	  show_occupancy: true,
	  show_openings: true,
	  show_prime_openings: true,
	  circle_around_openings: false,
	  highlight_instability: true,
	  show_neighbor_touchpoints: true,
	  connect_to_xtarget: false,
	  line_from_to: false
	});
	
	save(histo_layout_explorer_options);
	
	LayoutExplorerOptions = ReactiveComponent({
	  displayName: 'LayoutExplorerOptions',
	  render: function() {
	    var k, opts, v;
	    opts = fetch('histo_layout_explorer_options');
	    return DIV({
	      style: {
	        position: 'absolute',
	        left: -260
	      }
	    }, (function() {
	      var results;
	      results = [];
	      for (k in opts) {
	        v = opts[k];
	        if (k !== 'key' && (opts.show_explorer || k === 'show_explorer')) {
	          results.push(DIV({
	            key: k,
	            style: {
	              fontSize: 12
	            }
	          }, (function(_this) {
	            return function(k, v) {
	              return LABEL({
	                style: {
	                  fontSize: 12
	                }
	              }, k === 'ms_between_plays' ? INPUT({
	                type: 'text',
	                value: v,
	                style: {
	                  width: 50
	                },
	                onChange: function(ev) {
	                  var my_time;
	                  my_time = opts.ms_between_plays = parseInt(ev.target.value);
	                  return (function(my_time) {
	                    return setTimeout(function() {
	                      if (opts.ms_between_plays === my_time) {
	                        return save(opts);
	                      }
	                    }, 1000);
	                  })(my_time);
	                }
	              }) : INPUT({
	                type: 'checkbox',
	                checked: v,
	                title: k,
	                onChange: function(ev) {
	                  opts[k] = ev.target.checked;
	                  return save(opts);
	                }
	              }), k.replaceAll('_', ' '));
	            };
	          })(this)(k, v)));
	        }
	      }
	      return results;
	    }).call(this));
	  }
	});
	
	LayoutExplorer = ReactiveComponent({
	  displayName: 'LayoutExplorer',
	  render: function() {
	    var base1, base2, cleanup, has_cleanup, move, opts, running_state, tdat, tick, tick_data, x, x2, y, y2;
	    fetch(this.props.running_state);
	    running_state = fetch(this.props.running_state);
	    cleanup = running_state.cleanup;
	    has_cleanup = (cleanup != null ? cleanup.length : void 0) > 0;
	    if (has_cleanup) {
	      if ((base1 = this.local).ticks == null) {
	        base1.ticks = 0;
	      }
	      if ((base2 = this.local).move == null) {
	        base2.move = 0;
	      }
	      tick_data = cleanup[this.local.ticks][this.local.move];
	      x = tick_data.from.x;
	      y = tick_data.from.y;
	      x2 = tick_data.to.x;
	      y2 = tick_data.to.y;
	    }
	    opts = fetch('histo_layout_explorer_options');
	    return DIV({
	      style: {
	        margin: 'auto'
	      }
	    }, LayoutExplorerOptions(), opts.show_explorer ? DIV({
	      style: {
	        marginTop: 20
	      }
	    }, CANVAS({
	      ref: 'my_canvas',
	      style: {
	        borderBottom: '2px solid black'
	      }
	    }), has_cleanup ? DIV(null, DIV(null, "Move: " + (this.local.move + 1) + " / " + cleanup[this.local.ticks].length + " [" + tick_data.iteration + "]", (function() {
	      var j, ref, results;
	      results = [];
	      for (move = j = 0, ref = cleanup[this.local.ticks].length - 1; 0 <= ref ? j <= ref : j >= ref; move = 0 <= ref ? ++j : --j) {
	        results.push((function(_this) {
	          return function(move) {
	            return BUTTON({
	              style: {
	                marginLeft: 8,
	                fontSize: 10
	              },
	              className: 'like_link',
	              onClick: function(ev) {
	                _this.local.move = move;
	                return save(_this.local);
	              }
	            }, move);
	          };
	        })(this)(move));
	      }
	      return results;
	    }).call(this)), DIV(null, "Tick: " + (this.local.ticks + 1) + " / " + cleanup.length, (function() {
	      var j, ref, results;
	      results = [];
	      for (tick = j = 0, ref = cleanup.length - 1; 0 <= ref ? j <= ref : j >= ref; tick = 0 <= ref ? ++j : --j) {
	        results.push((function(_this) {
	          return function(tick) {
	            return BUTTON({
	              className: 'like_link',
	              style: {
	                marginLeft: 8,
	                fontSize: 10
	              },
	              onClick: function(ev) {
	                _this.local.ticks = tick;
	                _this.local.move = 0;
	                return save(_this.local);
	              }
	            }, tick);
	          };
	        })(this)(tick));
	      }
	      return results;
	    }).call(this)), opts.show_move_log ? DIV(null, tick_data.body.user + " [" + tick_data.body.x_target + "]: (" + x + ", " + y + ") => (" + x2 + ", " + y2 + ")", DIV({
	      style: {
	        fontSize: 13
	      }
	    }, (function() {
	      var j, ref, results;
	      results = [];
	      for (tick = j = 0, ref = cleanup.length - 1; 0 <= ref ? j <= ref : j >= ref; tick = 0 <= ref ? ++j : --j) {
	        results.push(DIV(null, "Tick " + tick, (function() {
	          var l, ref1, results1;
	          results1 = [];
	          for (move = l = 0, ref1 = cleanup[tick].length - 1; 0 <= ref1 ? l <= ref1 : l >= ref1; move = 0 <= ref1 ? ++l : --l) {
	            tdat = cleanup[tick][move];
	            x = tdat.from.x;
	            y = tdat.from.y;
	            x2 = tdat.to.x;
	            y2 = tdat.to.y;
	            results1.push(DIV(null, tdat.body.user + " [" + tdat.body.x_target + "]: (" + x + ", " + y + ") => (" + x2 + ", " + y2 + ")"));
	          }
	          return results1;
	        })()));
	      }
	      return results;
	    })())) : void 0) : void 0) : void 0);
	  },
	  update: function() {
	    var a, angle, b, base, base1, base2, body, canvas, cleanup, col, ctx, d, g, h, has_cleanup, height, i, img, j, l, last_row, len, len1, len2, len3, len4, m, map, n, o, occupancy, opening_this_col, openings, opts, p, prime_positions, q, r, radius, ref, ref1, ref10, ref11, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, results, row, running_state, s, t, tick_data, u, unstable_bodies, unstable_body, w, width, x, x2, y, y2, z;
	    running_state = fetch(this.props.running_state);
	    cleanup = running_state.cleanup;
	    opts = fetch('histo_layout_explorer_options');
	    if (!opts.show_explorer || !running_state.cleanup) {
	      return;
	    }
	    if ((base1 = this.local).ticks == null) {
	      base1.ticks = 0;
	    }
	    if ((base2 = this.local).move == null) {
	      base2.move = 0;
	    }
	    width = this.props.hist.width;
	    height = this.props.hist.height;
	    canvas = this.refs.my_canvas;
	    canvas.width = width;
	    canvas.height = height;
	    ctx = canvas.getContext('2d');
	    ctx.clearRect(0, 0, canvas.width, canvas.height);
	    img = ctx.createImageData(width, height);
	    d = img.data;
	    has_cleanup = (cleanup != null ? cleanup.length : void 0) > 0;
	    if (has_cleanup) {
	      tick_data = cleanup[this.local.ticks][this.local.move];
	      map = tick_data.occupancy;
	      openings = tick_data.openings;
	      if ((this.local.last_advance == null) || Date.now() - this.local.last_advance >= opts.ms_between_plays) {
	        this.local.last_advance = Date.now();
	        setTimeout((function(_this) {
	          return function() {
	            _this.local.move += 1;
	            if (_this.local.move >= cleanup[_this.local.ticks].length) {
	              _this.local.ticks += 1;
	              _this.local.move = 0;
	              if (_this.local.ticks >= cleanup.length) {
	                _this.local.ticks = 0;
	              }
	            }
	            return save(_this.local);
	          };
	        })(this), opts.ms_between_plays);
	      }
	      radius = tick_data.body.radius;
	    } else {
	      map = running_state.occupancy_map;
	      openings = running_state.openings;
	    }
	    for (col = j = 0, ref = width; 0 <= ref ? j <= ref : j >= ref; col = 0 <= ref ? ++j : --j) {
	      opening_this_col = false;
	      for (row = l = ref1 = height - 1, ref2 = 0 - 1; l >= ref2; row = l += -1) {
	        occupancy = map[row * width + col];
	        if (opts.show_occupancy && occupancy > 0) {
	          base = 4 * (row * width + col);
	          a = 255;
	          r = g = b = 150;
	          d[base + 0] = r;
	          d[base + 1] = g;
	          d[base + 2] = b;
	          d[base + 3] = a;
	        } else if (opts.show_openings && !opening_this_col && openings[row * width + col] === 0 && row <= height - radius && col >= radius && col <= width - radius) {
	          for (i = m = 0; m <= 1; i = ++m) {
	            base = 4 * ((row - i) * width + col);
	            d[base + 0] = 128;
	            d[base + 1] = 180;
	            d[base + 2] = 128;
	            d[base + 3] = 255;
	          }
	        }
	      }
	    }
	    if (has_cleanup && opts.show_prime_openings) {
	      prime_positions = tick_data.prime_positions;
	      for (col = n = 0, ref3 = width; 0 <= ref3 ? n <= ref3 : n >= ref3; col = 0 <= ref3 ? ++n : --n) {
	        if (prime_positions[col]) {
	          ref4 = [0];
	          for (o = 0, len = ref4.length; o < len; o++) {
	            w = ref4[o];
	            for (h = p = 0; p <= 4; h = ++p) {
	              base = 4 * ((prime_positions[col] - h) * width + col + w);
	              d[base + 0] = 128;
	              d[base + 1] = 128;
	              d[base + 2] = 255;
	              d[base + 3] = 255;
	            }
	          }
	        }
	      }
	    }
	    ctx.putImageData(img, 0, 0);
	    if (opts.show_neighbor_touchpoints) {
	      ref5 = (has_cleanup ? tick_data.bodies : running_state.bodies);
	      for (q = 0, len1 = ref5.length; q < len1; q++) {
	        a = ref5[q];
	        if (((ref6 = a.neighbors) != null ? ref6.length : void 0) > 0) {
	          ref7 = a.neighbors;
	          for (s = 0, len2 = ref7.length; s < len2; s++) {
	            ref8 = ref7[s], b = ref8[0], angle = ref8[1];
	            x = Math.round(a.x);
	            y = Math.round(a.y);
	            r = a.radius;
	            x2 = x + r * Math.cos(angle);
	            y2 = y + r * Math.sin(angle);
	            ctx.beginPath();
	            ctx.moveTo(x, y);
	            ctx.lineTo(x2, y2);
	            ctx.strokeStyle = '#444444';
	            ctx.closePath();
	            ctx.stroke();
	          }
	        }
	      }
	    }
	    if (!has_cleanup) {
	      return;
	    }
	    if (opts.highlight_instability) {
	      unstable_bodies = tick_data.unstable_bodies;
	      ref9 = unstable_bodies || [];
	      for (t = 0, len3 = ref9.length; t < len3; t++) {
	        unstable_body = ref9[t];
	        ctx.beginPath();
	        ctx.strokeStyle = 'red';
	        ctx.lineWidth = 1;
	        ctx.arc(unstable_body.x, unstable_body.y, unstable_body.radius, 0, 2 * Math.PI);
	        ctx.closePath();
	        ctx.stroke();
	      }
	    }
	    x = tick_data.from.x;
	    y = tick_data.from.y;
	    x2 = tick_data.to.x;
	    y2 = tick_data.to.y;
	    ctx.beginPath();
	    ctx.fillRect(x, y, 1, 1);
	    ctx.fillStyle = 'black';
	    ctx.arc(x, y, tick_data.body.radius, 0, 2 * Math.PI);
	    ctx.closePath();
	    ctx.stroke();
	    ctx.beginPath();
	    ctx.fillRect(x2, y2, 1, 1);
	    ctx.fillStyle = 'black';
	    ctx.arc(x2, y2, tick_data.body.radius, 0, 2 * Math.PI);
	    ctx.closePath();
	    ctx.stroke();
	    if (opts.line_from_to) {
	      ctx.beginPath();
	      ctx.moveTo(x, y);
	      ctx.lineWidth = 3;
	      ctx.lineTo(x2, y2);
	      ctx.strokeStyle = '#FF6666';
	      ctx.closePath();
	      ctx.stroke();
	    }
	    if (opts.connect_to_xtarget) {
	      ref10 = tick_data.bodies;
	      for (u = 0, len4 = ref10.length; u < len4; u++) {
	        body = ref10[u];
	        x2 = body.x;
	        y2 = body.y;
	        ctx.beginPath();
	        ctx.moveTo(x2, y2);
	        ctx.lineWidth = 1;
	        ctx.lineTo(body.x_target, height);
	        ctx.strokeStyle = '#FF6666';
	        ctx.closePath();
	        ctx.stroke();
	      }
	    }
	    if (opts.circle_around_openings) {
	      last_row = -1;
	      prime_positions = tick_data.prime_positions;
	      results = [];
	      for (col = z = 0, ref11 = width; 0 <= ref11 ? z <= ref11 : z >= ref11; col = 0 <= ref11 ? ++z : --z) {
	        row = prime_positions[col];
	        if (row && last_row !== row) {
	          ctx.beginPath();
	          ctx.strokeStyle = '#444444';
	          ctx.lineWidth = 1;
	          ctx.arc(col, row, tick_data.body.radius, 0, 2 * Math.PI);
	          ctx.closePath();
	          ctx.stroke();
	          results.push(last_row = row);
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }
	  },
	  componentDidUpdate: function() {
	    return this.update();
	  },
	  componentDidRender: function() {
	    return this.update();
	  }
	});
	
	HistoDetails = ReactiveComponent({
	  displayName: 'HistoDetails',
	  render: function() {
	    var _checker, colors, hist, i, k, param_hash, param_set, param_sets, params_with_multiple_vals, running_state, v;
	    running_state = fetch(this.props.running_state);
	    hist = this.props.hist;
	    param_sets = this.props.param_sets;
	    params_with_multiple_vals = {};
	    _checker = {};
	    for (param_hash in param_sets) {
	      param_set = param_sets[param_hash];
	      for (k in param_set) {
	        v = param_set[k];
	        if (k in _checker && _checker[k] !== v) {
	          params_with_multiple_vals[k] = true;
	        } else {
	          _checker[k] = v;
	        }
	      }
	    }
	    colors = getNiceRandomHues(Object.keys(params_with_multiple_vals).length);
	    i = -1;
	    return DIV({
	      key: "histo-state-" + running_state.total_ticks,
	      style: {
	        fontSize: 10,
	        position: 'absolute',
	        right: -260,
	        bottom: 0
	      }
	    }, DIV({
	      style: {
	        marginBottom: 10
	      }
	    }, (function() {
	      var ref, results;
	      ref = hist.layout_params;
	      results = [];
	      for (k in ref) {
	        v = ref[k];
	        if (!((k !== 'verbose' && k !== 'show_histogram_layout' && k !== 'param_hash') && params_with_multiple_vals[k])) {
	          continue;
	        }
	        i += 1;
	        results.push(DIV({
	          key: k
	        }, k + " = ", SPAN({
	          style: {
	            color: hsv2rgb(colors[i], .7, .5),
	            fontSize: 18,
	            fontWeight: 'bold'
	          }
	        }, "" + v)));
	      }
	      return results;
	    })()), (function() {
	      var results;
	      results = [];
	      for (k in running_state) {
	        v = running_state[k];
	        if (v && (k !== 'initialized' && k !== 'key' && k !== 'occupancy_map' && k !== 'bodies' && k !== 'openings' && k !== 'cleanup')) {
	          results.push(DIV({
	            key: k
	          }, k + " = " + v));
	        }
	      }
	      return results;
	    })(), running_state.layout_time ? DIV(null, DIV({
	      style: {
	        width: Math.min(200, running_state.layout_time / (hist.layout_params.show_histogram_layout ? 250 : 100)),
	        height: 15,
	        backgroundColor: 'red'
	      }
	    })) : void 0);
	  }
	});
	
	GlobalHistTiming = ReactiveComponent({
	  displayName: 'GlobalHistTiming',
	  render: function() {
	    var _checker, colors, global_running_state, i, k, param_hash, param_set, param_sets, params_with_multiple_vals, td_style, th_style, total_key, totals, v, vals;
	    global_running_state = fetch('histo-timing');
	    param_sets = this.props.param_sets;
	    params_with_multiple_vals = {};
	    _checker = {};
	    totals = {};
	    for (param_hash in param_sets) {
	      param_set = param_sets[param_hash];
	      for (k in param_set) {
	        v = param_set[k];
	        if (k in _checker && _checker[k] !== v) {
	          params_with_multiple_vals[k] = true;
	        } else {
	          _checker[k] = v;
	        }
	      }
	    }
	    for (param_hash in param_sets) {
	      param_set = param_sets[param_hash];
	      for (k in param_set) {
	        v = param_set[k];
	        if (!params_with_multiple_vals[k] || (global_running_state[param_hash] == null)) {
	          continue;
	        }
	        total_key = k + "=" + v;
	        if (total_key in totals) {
	          totals[total_key] = [totals[total_key][0] + 1, totals[total_key][1] + global_running_state[param_hash].tick_time, totals[total_key][2] + global_running_state[param_hash].truth, totals[total_key][3] + global_running_state[param_hash].visibility, totals[total_key][4] + global_running_state[param_hash].stability, totals[total_key][5] + global_running_state[param_hash].cnt];
	        } else {
	          totals[total_key] = [1, global_running_state[param_hash].tick_time, global_running_state[param_hash].truth, global_running_state[param_hash].visibility, global_running_state[param_hash].stability, global_running_state[param_hash].cnt];
	        }
	      }
	    }
	    colors = getNiceRandomHues(Object.keys(params_with_multiple_vals).length);
	    td_style = {
	      padding: "4px 14px",
	      textAlign: 'right'
	    };
	    th_style = _.extend({}, td_style, {
	      fontWeight: 'bold'
	    });
	    return DIV({
	      style: {
	        width: 1400
	      }
	    }, TABLE(null, TBODY(null, TR(null, TH({
	      style: th_style
	    }, 'Param set'), TH({
	      style: th_style
	    }, 'Truth'), TH({
	      style: th_style
	    }, 'Visibility'), TH({
	      style: th_style
	    }, 'Stability'), TH({
	      style: th_style
	    }, 'Time (ms)')), (function() {
	      var results;
	      results = [];
	      for (param_hash in param_sets) {
	        param_set = param_sets[param_hash];
	        vals = global_running_state[param_hash];
	        if (!vals && vals !== 0) {
	          continue;
	        }
	        i = -1;
	        results.push(TR(null, TD({
	          style: td_style
	        }, (function() {
	          var results1;
	          results1 = [];
	          for (k in param_set) {
	            v = param_set[k];
	            if (!params_with_multiple_vals[k]) {
	              continue;
	            }
	            i += 1;
	            results1.push(DIV({
	              style: {
	                color: hsv2rgb(colors[i], .7, .5),
	                fontSize: 14,
	                fontWeight: 'bold'
	              }
	            }, k + " = " + v));
	          }
	          return results1;
	        })()), TD({
	          style: td_style
	        }, (100 * vals.truth / vals.cnt).toFixed(1)), TD({
	          style: td_style
	        }, (100 * vals.visibility / vals.cnt).toFixed(1)), TD({
	          style: td_style
	        }, (100 * vals.stability / vals.cnt).toFixed(1)), TD({
	          style: td_style
	        }, Math.round(vals.tick_time / vals.cnt))));
	      }
	      return results;
	    })())), (function(_this) {
	      return function() {
	        var cnt, keys, param, stability, total_histos, total_run_time, truth, visibility;
	        keys = Object.keys(totals);
	        keys.sort();
	        i = -1;
	        colors = getNiceRandomHues(keys.length);
	        return TABLE({
	          style: {
	            marginTop: 36
	          }
	        }, TBODY(null, TR(null, TH({
	          style: th_style
	        }, 'Param'), TH({
	          style: th_style
	        }, 'Sets'), TH({
	          style: th_style
	        }, 'Truth'), TH({
	          style: th_style
	        }, 'Visibility'), TH({
	          style: th_style
	        }, 'Stability'), TH({
	          style: th_style
	        }, 'Time (ms)')), (function() {
	          var j, len, ref, results;
	          results = [];
	          for (j = 0, len = keys.length; j < len; j++) {
	            param = keys[j];
	            ref = totals[param], cnt = ref[0], total_run_time = ref[1], truth = ref[2], visibility = ref[3], stability = ref[4], total_histos = ref[5];
	            i += 1;
	            results.push(TR({
	              style: {
	                backgroundColor: i % 2 === 1 ? '#f8f8f8' : void 0
	              }
	            }, TD({
	              style: _.extend({}, td_style, {
	                color: hsv2rgb(colors[i], .7, .5)
	              })
	            }, param), TD({
	              style: td_style
	            }, total_histos), TD({
	              style: td_style
	            }, Math.round(100 * truth / total_histos).toFixed(1)), TD({
	              style: td_style
	            }, Math.round(100 * visibility / total_histos).toFixed(1)), TD({
	              style: td_style
	            }, Math.round(100 * stability / total_histos).toFixed(1)), TD({
	              style: td_style
	            }, Math.round(total_run_time / total_histos))));
	          }
	          return results;
	        })()));
	      };
	    })(this)());
	  }
	});


/***/ },
/* 39 */
/***/ function(module, exports) {

	var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	styles += ".AggregatedHistogram {\n  opacity: 1;\n}\n\n.animating-expansion .AggregatedHistogram {\n  opacity: 0;    \n}\n\n";
	
	window.AggregatedHistogram = ReactiveComponent({
	  displayName: 'AggregatedHistogram',
	  render: function() {
	    var all_groups, avg, cnt, colors, fill_ratio, group, group_avatar_style, group_opinions, group_scores, group_weights, groups, h, has_groups, histocache, histokey, i, idx, is_weighted, j, k, l, label_style, legend_color_size, len, len1, len2, max_weight, min_weight, o, opinion_views, opinions, pos, proposal, rating_str, ref, ref1, ref2, ref3, salience, score, separator_inserted, v, view, visible_groups, w, weight, weights, width;
	    opinion_views = fetch('opinion_views');
	    if (!opinion_views.active_views.group_by) {
	      return SPAN(null);
	    }
	    proposal = fetch(this.props.proposal);
	    ref = compose_opinion_views(null, proposal), weights = ref.weights, salience = ref.salience, groups = ref.groups;
	    opinions = get_opinions_for_proposal(opinions, proposal, weights);
	    all_groups = get_user_groups_from_views(groups);
	    all_groups || (all_groups = []);
	    has_groups = !!all_groups;
	    colors = get_color_for_groups(all_groups);
	    legend_color_size = 28;
	    rating_str = "0000 / 00%";
	    group_scores = {};
	    group_opinions = [];
	    group_weights = {};
	    opinion_views = fetch('opinion_views');
	    is_weighted = false;
	    ref1 = opinion_views.active_views;
	    for (v in ref1) {
	      view = ref1[v];
	      is_weighted || (is_weighted = view.view_type === 'weight');
	    }
	    min_weight = 2e308;
	    max_weight = 0;
	    for (i = 0, len = all_groups.length; i < len; i++) {
	      group = all_groups[i];
	      weight = 0;
	      cnt = 0;
	      score = 0;
	      for (j = 0, len1 = opinions.length; j < len1; j++) {
	        o = opinions[j];
	        if (salience[o.user.key || o.user] < 1 || indexOf.call(groups[o.user.key || o.user], group) < 0) {
	          continue;
	        }
	        w = weights[o.user.key || o.user];
	        score += o.stance * w;
	        weight += w;
	        cnt += 1;
	      }
	      if (weight > 0) {
	        avg = score / weight;
	        group_scores[group] = {
	          avg: avg,
	          cnt: cnt
	        };
	        if (cnt < min_weight) {
	          min_weight = cnt;
	        }
	        if (cnt > max_weight) {
	          max_weight = cnt;
	        }
	        group_weights[group] = cnt;
	        group_opinions.push([group, avg, group_weights[group]]);
	      }
	    }
	    if (min_weight < 2e308 && min_weight !== max_weight) {
	      for (k in group_weights) {
	        v = group_weights[k];
	        group_weights[k] = v / ((max_weight - min_weight) / 2);
	      }
	      for (idx = l = 0, len2 = all_groups.length; l < len2; idx = ++l) {
	        group = all_groups[idx];
	        group_opinions[idx][2] = group_weights[group];
	      }
	    }
	    visible_groups = Object.keys(group_scores);
	    visible_groups.sort(function(a, b) {
	      return group_scores[b].avg - group_scores[a].avg;
	    });
	    width = this.props.width;
	    h = this.props.height;
	    histokey = width + "-" + h + "-" + (JSON.stringify(group_opinions)) + "-" + (JSON.stringify(group_weights));
	    histocache = (ref2 = this.local.histocache) != null ? (ref3 = ref2[histokey]) != null ? ref3.positions : void 0 : void 0;
	    if (!histocache) {
	      fill_ratio = .6;
	      delegate_layout_task({
	        task: 'layoutAvatars',
	        histo: this.local.key,
	        k: histokey,
	        r: calculateAvatarRadius(width, h, group_opinions, group_weights, {
	          fill_ratio: fill_ratio
	        }),
	        w: width,
	        h: h,
	        o: group_opinions,
	        layout_params: {
	          fill_ratio: fill_ratio,
	          cleanup_overlap: 2,
	          jostle: 0,
	          rando_order: 0,
	          topple_towers: .05,
	          density_modified_jostle: 0
	        }
	      });
	    }
	    group_avatar_style = {
	      borderRadius: '50%',
	      width: legend_color_size,
	      height: legend_color_size,
	      display: 'inline-block',
	      boxShadow: "0 1px 2px 0 rgba(103,103,103,0.50), inset 0 -1px 2px 0 rgba(0,0,0,0.16)"
	    };
	    separator_inserted = false;
	    label_style = {
	      fontSize: 12,
	      fontWeight: 400,
	      color: '#555',
	      bottom: -13
	    };
	    return FLIPPED({
	      flipId: "aggregated-histo-" + proposal.key,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore,
	      translate: true
	    }, DIV({
	      className: 'AggregatedHistogram histoavatars-container'
	    }, DIV(null, DIV({
	      style: {
	        width: width,
	        height: h,
	        position: 'relative'
	      }
	    }, !histocache ? DIV({
	      style: {
	        position: 'absolute',
	        top: h / 2 - 20,
	        left: width / 2 - 25
	      }
	    }, LOADING_INDICATOR) : void 0, (function() {
	      var len3, m, ref4, results;
	      if (histocache) {
	        results = [];
	        for (m = 0, len3 = visible_groups.length; m < len3; m++) {
	          group = visible_groups[m];
	          pos = histocache[group];
	          if (!pos) {
	            continue;
	          }
	          ref4 = group_scores[group], avg = ref4.avg, cnt = ref4.cnt;
	          results.push(DIV({
	            key: group,
	            "data-popover": proposal.key,
	            "data-group": group,
	            "data-attribute": opinion_views.active_views.group_by.name,
	            "data-stance": (Math.round(100 * avg)) + "% " + (is_weighted ? 'weighted' : '') + " average",
	            "data-opinion-count": cnt,
	            style: _.extend({}, group_avatar_style, {
	              width: pos[2] * 2,
	              height: pos[2] * 2,
	              transform: "translate(" + pos[0] + "px, " + pos[1] + "px)",
	              backgroundColor: colors[group],
	              position: 'absolute'
	            })
	          }));
	        }
	        return results;
	      }
	    })())), DIV({
	      style: {
	        position: 'relative',
	        top: 6
	      }
	    }, SPAN({
	      style: _.extend({}, label_style, {
	        position: 'absolute',
	        left: 0
	      })
	    }, get_slider_label("slider_pole_labels.oppose", proposal)), SPAN({
	      style: _.extend({}, label_style, {
	        position: 'absolute',
	        right: 0
	      })
	    }, get_slider_label("slider_pole_labels.support", proposal)))));
	  }
	});
	
	window.AggregatedGroupPopover = ReactiveComponent({
	  displayName: 'AggregatedGroupPopover',
	  render: function() {
	    var attribute, group, num_opinions, opinion_views, proposal, ref, stance;
	    ref = this.props, proposal = ref.proposal, attribute = ref.attribute, group = ref.group, attribute = ref.attribute, stance = ref.stance, num_opinions = ref.num_opinions;
	    proposal = fetch(proposal);
	    opinion_views = fetch('opinion_views');
	    return DIV({
	      style: {
	        padding: '8px 4px',
	        position: 'relative',
	        maxWidth: "min(80vw, 600px)"
	      }
	    }, DIV({
	      style: {
	        display: 'flex'
	      }
	    }, DIV(null, DIV(null), attribute, DIV({
	      style: {
	        fontWeight: 700,
	        fontSize: 18
	      }
	    }, group), DIV({
	      style: {
	        marginTop: 8
	      }
	    }, num_opinions + " opinions  •  " + stance))));
	  }
	});


/***/ },
/* 40 */
/***/ function(module, exports) {

	window.iconX = function(size, color) {
	  if (size == null) {
	    size = 30;
	  }
	  return SVG({
	    width: size,
	    height: size,
	    viewBox: "-50 -50 200 200",
	    stroke: color,
	    fill: 'none',
	    dangerouslySetInnerHTML: {
	      __html: "<g>\n <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"15\" d=\"M 0 0 L 100 100 M 0 100 L 100 0 Z\"/>\n</g>"
	    }
	  });
	};
	
	window.iconAnonymousMask = function(height, color) {
	  var width;
	  if (color == null) {
	    color = 'black';
	  }
	  width = 1.4 * height;
	  return SVG({
	    width: width,
	    height: height,
	    viewBox: "-350 0 700 200",
	    stroke: color,
	    dangerouslySetInnerHTML: {
	      __html: "\n<g style=\"\">\n  <path fill=\"" + color + "\" style=\"\" d=\"M -7.3 130.8 L 75 150.1 C 69.8 117.1 190.9 87.7 217.7 105 C 252.3 147.9 119.5 270.8 73.8 150 L -2.4 119.5 C -5.6 140.7 -10.6 159.4 0.9 195.4 C 59.3 197.1 67.4 258.4 108.2 280.2 S 193.8 295.9 225.6 294.9 C 263 290.8 284.4 271.3 301 230.8 C 315 187.8 317 154.8 314.3 107.8 C 309.2 73.3 291.1 41.9 264.8 27.6 c -54.7 -31.2 -216.8 15.1 -266.7 15.9 Z\"></path>\n  <path fill=\"" + color + "\" style=\"\" d=\"M -7.3 130.8 L 75 150.1 C 69.8 117.1 190.9 87.7 217.7 105 C 252.3 147.9 119.5 270.8 73.8 150 L -2.4 119.5 C -5.6 140.7 -10.6 159.4 0.9 195.4 C 59.3 197.1 67.4 258.4 108.2 280.2 S 193.8 295.9 225.6 294.9 C 263 290.8 284.4 271.3 301 230.8 C 315 187.8 317 154.8 314.3 107.8 C 309.2 73.3 291.1 41.9 264.8 27.6 c -54.7 -31.2 -216.8 15.1 -266.7 15.9 Z\"\n    transform=\"scale(-1, 1)\"></path>\n</g>"
	    }
	  });
	};
	
	window.closedIcon = function(arg) {
	  var fill, size;
	  size = arg.size, fill = arg.fill;
	  if (fill == null) {
	    fill = 'black';
	  }
	  return SVG({
	    width: size,
	    height: size,
	    viewBox: "0 0 700 700",
	    dangerouslySetInnerHTML: {
	      __html: "\n<g style=\"\">\n  <path fill=\"" + fill + "\" d=\"M 564.996 591.909 C 558.141 591.909 551.293 589.222 546.053 583.981 L 116.152 154.08 C 105.672 143.6 105.672 126.54 116.152 116.06 C 126.632 105.58 143.692 105.58 154.172 116.06 L 584.073 545.961 C 594.553 556.443 594.553 573.501 584.073 583.981 C 578.697 589.222 571.85 591.909 564.996 591.909 Z\" style=\"\"></path>\n  <path fill=\"" + fill + "\" d=\"M 350.052 699.388 C 256.819 699.388 169.093 663.117 103.126 597.018 C 37.032 531.054 0.755 443.334 0.755 350.091 C 0.755 256.848 37.026 169.132 103.126 103.165 C 169.225 37.197 256.809 0.794 350.052 0.794 C 443.295 0.794 531.012 37.065 596.979 103.165 C 662.946 169.264 699.349 256.848 699.349 350.091 C 699.349 443.334 663.078 531.051 596.979 597.018 C 531.015 663.111 443.295 699.388 350.052 699.388 Z M 350.052 54.544 C 187.099 54.544 54.503 187.141 54.503 350.093 C 54.503 513.045 187.101 645.642 350.052 645.642 C 513.005 645.642 645.601 513.044 645.601 350.093 C 645.601 187.14 513.009 54.544 350.052 54.544 Z\" style=\"\"></path>\n</g>"
	    }
	  });
	};
	
	window.ThreeDotsIcon = function(arg) {
	  var fill, size;
	  size = arg.size, fill = arg.fill;
	  if (fill == null) {
	    fill = 'black';
	  }
	  return SVG({
	    width: size,
	    height: size,
	    viewBox: "0 0 700 700",
	    dangerouslySetInnerHTML: {
	      __html: "<g>\n <path fill=\"" + fill + "\" d=\"m419.35 280c0 38.301-31.047 69.348-69.348 69.348s-69.348-31.047-69.348-69.348 31.047-69.348 69.348-69.348 69.348 31.047 69.348 69.348\"/>\n <path fill=\"" + fill + "\" d=\"m419.35 98.512c0 38.301-31.047 69.348-69.348 69.348s-69.348-31.047-69.348-69.348c0-38.297 31.047-69.344 69.348-69.344s69.348 31.047 69.348 69.344\"/>\n <path fill=\"" + fill + "\" d=\"m419.35 461.49c0 38.297-31.047 69.344-69.348 69.344s-69.348-31.047-69.348-69.344c0-38.301 31.047-69.348 69.348-69.348s69.348 31.047 69.348 69.348\"/>\n</g>"
	    }
	  });
	};
	
	window.double_up_icon = function(size) {
	  return SVG({
	    width: size,
	    height: size,
	    viewBox: "0 0 66 66",
	    dangerouslySetInnerHTML: {
	      __html: "<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g transform=\"translate(-869.000000, -2725.000000)\">\n        <g transform=\"translate(870.000000, 2726.000000)\">\n            <circle stroke=\"#D1D1D1\" fill=\"#F0F0F0\" cx=\"32\" cy=\"32\" r=\"32\"></circle>\n            <path d=\"M45.7016044,27.11626 C46.2524214,27.6626885 46.5621531,28.4064037 46.5621531,29.1816368 C46.5621531,29.957456 46.252409,30.7011836 45.7016044,31.2470136 C45.1556622,31.7978306 44.4119595,32.1075624 43.6362276,32.1075624 C42.8608947,32.1075624 42.1171795,31.7978182 41.5708508,31.2470136 L32,21.6469887 L22.4291492,31.2470136 C21.6913187,31.9853304 20.6154925,32.2731566 19.6073652,32.003346 C18.5997366,31.7330492 17.8122852,30.9455479 17.5419884,29.9379692 C17.2721778,28.9298544 17.5600078,27.8540157 18.2983208,27.1161852 L29.9345484,15.4799576 C30.4809768,14.9291406 31.2241933,14.6194089 31.9999252,14.6194089 C32.7756571,14.6194089 33.5189733,14.9291531 34.065302,15.4799576 L45.7016044,27.11626 Z M34.0653768,28.9346232 C33.5189484,28.3838062 32.7757319,28.0740745 32,28.0740745 C31.2242681,28.0740745 30.4809519,28.3838187 29.9346232,28.9346232 L18.2983956,40.5708508 C17.5600789,41.3086813 17.2722527,42.3845075 17.5420632,43.3926348 C17.81236,44.4002634 18.5998613,45.1877148 19.60744,45.4580116 C20.6155548,45.7278222 21.6913935,45.4399922 22.429224,44.7016792 L32.0000748,35.1016543 L41.5709256,44.7016792 C42.1173541,45.2524962 42.8610692,45.562228 43.6363024,45.562228 C44.4121216,45.562228 45.1558492,45.2524838 45.7016792,44.7016792 C46.2524962,44.155737 46.562228,43.4120343 46.562228,42.6363024 C46.562228,41.8609695 46.2524838,41.1172543 45.7016792,40.5709256 L34.0653768,28.9346232 Z\" fill=\"#9D9D9D\"></path>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};
	
	window.plusIcon = function(outline_color, size) {
	  if (size == null) {
	    size = 30;
	  }
	  return SVG({
	    width: size,
	    height: size,
	    fill: outline_color || 'white',
	    viewBox: "50 50 600 450",
	    dangerouslySetInnerHTML: {
	      __html: "<g>\n <path d=\"m350 28c-66.836 0-130.93 26.551-178.19 73.809-47.258 47.258-73.809 111.36-73.809 178.19s26.551 130.93 73.809 178.19c47.258 47.258 111.36 73.809 178.19 73.809s130.93-26.551 178.19-73.809c47.258-47.258 73.809-111.36 73.809-178.19 0-44.234-11.645-87.691-33.762-126-22.117-38.309-53.93-70.121-92.238-92.238-38.309-22.117-81.766-33.762-126-33.762zm0 470.4c-57.922 0-113.47-23.008-154.43-63.965-40.957-40.961-63.965-96.512-63.965-154.43s23.008-113.47 63.965-154.43c40.961-40.957 96.512-63.965 154.43-63.965s113.47 23.008 154.43 63.965c40.957 40.961 63.965 96.512 63.965 154.43s-23.008 113.47-63.965 154.43c-40.961 40.957-96.512 63.965-154.43 63.965z\"/>\n <path d=\"m456.4 257.6h-84v-84h-44.797v84h-84v44.797h84v84h44.797v-84h84z\"/>\n</g>"
	    }
	  });
	};
	
	window.checkmark = function(size, color) {
	  var d;
	  if (size == null) {
	    size = 24;
	  }
	  if (color == null) {
	    color = "currentColor";
	  }
	  return SVG({
	    width: size,
	    height: size,
	    xmlns: "http://www.w3.org/2000/svg",
	    viewBox: "0 0 700 700",
	    fill: color
	  }, PATH({
	    d: d = "m514.59 195.66-34.609-34.551-168.56 168.61-91.559-91.559-34.441 35.727 126 124.99z"
	  }));
	};
	
	window.ChevronRight = function(size) {
	  if (size == null) {
	    size = 24;
	  }
	  return SVG({
	    width: size,
	    height: size,
	    xmlns: "http://www.w3.org/2000/svg",
	    viewBox: "0 0 24 24",
	    stroke: "currentColor"
	  }, PATH({
	    strokeLinecap: "round",
	    strokeLinejoin: "round",
	    strokeWidth: "2",
	    d: "M9 5l7 7-7 7",
	    fill: 'none'
	  }));
	};
	
	window.ChevronLeft = function(size) {
	  if (size == null) {
	    size = 24;
	  }
	  return SVG({
	    width: size,
	    height: size,
	    xmlns: "http://www.w3.org/2000/svg",
	    viewBox: "0 0 24 24",
	    stroke: "currentColor"
	  }, PATH({
	    strokeLinecap: "round",
	    strokeWidth: "2",
	    d: "M15 19l-7-7 7-7",
	    fill: 'none'
	  }));
	};
	
	window.HelpIcon = function(help_text, style) {
	  if (style == null) {
	    style = {};
	  }
	  return BUTTON({
	    "data-tooltip": help_text,
	    style: _.defaults(style || {}, {
	      backgroundColor: 'transparent',
	      border: 'none',
	      padding: 0,
	      display: 'inline-block',
	      width: style.width || 17,
	      height: style.height || 17
	    })
	  }, SVG({
	    width: style.width || 17,
	    height: style.height || 17,
	    viewBox: "0 0 17 17.0000094",
	    style: {
	      pointerEvents: 'none'
	    }
	  }, G({
	    stroke: "none",
	    strokeWidth: "1",
	    fill: "none",
	    fillRule: "evenodd"
	  }, G({
	    transform: "translate(0.000000, 0.000000)",
	    fill: style.color || "#666",
	    fillRule: "nonzero"
	  }, PATH({
	    d: "M8.5,2.833339 C7.71759653,2.833339 7.08333333,3.4676022 7.08333333,4.25000567 C7.08333333,5.03240913 7.71759653,5.66667233 8.5,5.66667233 C9.28240347,5.66667233 9.91666667,5.03240913 9.91666667,4.25000567 C9.91666667,3.4676022 9.28240347,2.833339 8.5,2.833339 Z M6.61111111,6.61111678 L7.55555556,7.55556122 L7.55555556,13.2222279 L6.61111111,13.2222279 L6.61111111,14.1666723 L10.3888889,14.1666723 L10.3888889,13.2222279 L9.44444444,13.2222279 L9.44444444,6.61111678 L7.55555556,6.61111678 L6.61111111,6.61111678 Z"
	  }), PATH({
	    d: "M8.5,2.14741805e-14 C3.81117296,2.14741805e-14 0,3.81117333 0,8.5 C0,13.1888361 3.81117296,17 8.5,17 C13.188827,17 17,13.1888361 17,8.5 C17,3.81117333 13.188827,2.14741805e-14 8.5,2.14741805e-14 Z M8.5,0.944444444 C12.6784115,0.944444444 16.0555556,4.32158889 16.0555556,8.49999056 C16.0555556,12.6784206 12.6784115,16.055565 8.5,16.055565 C4.32158851,16.055565 0.944444444,12.6784206 0.944444444,8.49999056 C0.944444444,4.32158889 4.32158851,0.944444444 8.5,0.944444444 Z"
	  })))));
	};
	
	window.GearIcon = function(opts) {
	  return SVG({
	    height: opts.size || '100px',
	    width: opts.size || '100px',
	    fill: opts.fill || "#888",
	    x: "0px",
	    y: "0px",
	    viewBox: "0 0 100 100",
	    dangerouslySetInnerHTML: {
	      __html: '<path d="M95.784,59.057c1.867,0,3.604-1.514,3.858-3.364c0,0,0.357-2.6,0.357-5.692c0-3.092-0.357-5.692-0.357-5.692  c-0.255-1.851-1.991-3.364-3.858-3.364h-9.648c-1.868,0-3.808-1.191-4.31-2.646s-1.193-6.123,0.128-7.443l6.82-6.82  c1.32-1.321,1.422-3.575,0.226-5.01L80.976,11c-1.435-1.197-3.688-1.095-5.01,0.226l-6.82,6.82c-1.32,1.321-3.521,1.853-4.888,1.183  c-1.368-0.67-5.201-3.496-5.201-5.364V4.217c0-1.868-1.514-3.604-3.364-3.859c0,0-2.6-0.358-5.692-0.358s-5.692,0.358-5.692,0.358  c-1.851,0.254-3.365,1.991-3.365,3.859v9.648c0,1.868-1.19,3.807-2.646,4.31c-1.456,0.502-6.123,1.193-7.444-0.128l-6.82-6.82  C22.713,9.906,20.459,9.804,19.025,11L11,19.025c-1.197,1.435-1.095,3.689,0.226,5.01l6.819,6.82  c1.321,1.321,1.854,3.521,1.183,4.888s-3.496,5.201-5.364,5.201H4.217c-1.868,0-3.604,1.514-3.859,3.364c0,0-0.358,2.6-0.358,5.692  c0,3.093,0.358,5.692,0.358,5.692c0.254,1.851,1.991,3.364,3.859,3.364h9.648c1.868,0,3.807,1.19,4.309,2.646  c0.502,1.455,1.193,6.122-0.128,7.443l-6.819,6.819c-1.321,1.321-1.423,3.575-0.226,5.01L19.025,89  c1.435,1.196,3.688,1.095,5.009-0.226l6.82-6.82c1.321-1.32,3.521-1.853,4.889-1.183c1.368,0.67,5.201,3.496,5.201,5.364v9.648  c0,1.867,1.514,3.604,3.365,3.858c0,0,2.599,0.357,5.692,0.357s5.692-0.357,5.692-0.357c1.851-0.255,3.364-1.991,3.364-3.858v-9.648  c0-1.868,1.19-3.808,2.646-4.31s6.123-1.192,7.444,0.128l6.819,6.82c1.321,1.32,3.575,1.422,5.01,0.226L89,80.976  c1.196-1.435,1.095-3.688-0.227-5.01l-6.819-6.819c-1.321-1.321-1.854-3.521-1.183-4.889c0.67-1.368,3.496-5.201,5.364-5.201H95.784  z M50,68.302c-10.108,0-18.302-8.193-18.302-18.302c0-10.107,8.194-18.302,18.302-18.302c10.108,0,18.302,8.194,18.302,18.302  C68.302,60.108,60.108,68.302,50,68.302z"></path>'
	    }
	  });
	};
	
	window.drag_icon = function(height, color) {
	  var width;
	  width = height * 14 / 20;
	  return SVG({
	    viewBox: "0 0 14 20",
	    stroke: 'none',
	    fill: color,
	    width: width,
	    height: height,
	    dangerouslySetInnerHTML: {
	      __html: "<g>\n    <circle id=\"Oval\" cx=\"2\" cy=\"2\" r=\"2\"></circle>\n    <circle id=\"Oval\" cx=\"2\" cy=\"10\" r=\"2\"></circle>\n    <circle id=\"Oval\" cx=\"2\" cy=\"18\" r=\"2\"></circle>\n    <circle id=\"Oval\" cx=\"12\" cy=\"18\" r=\"2\"></circle>\n    <circle id=\"Oval\" cx=\"12\" cy=\"10\" r=\"2\"></circle>\n    <circle id=\"Oval\" cx=\"12\" cy=\"2\" r=\"2\"></circle>\n</g>"
	    }
	  });
	};
	
	window.edit_icon = function(width, height, color) {
	  return SVG({
	    viewBox: "0 0 24 24",
	    stroke: color,
	    fill: 'none',
	    width: width,
	    height: height,
	    dangerouslySetInnerHTML: {
	      __html: "<path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z\" />"
	    }
	  });
	};
	
	window.trash_icon = function(width, height, color) {
	  return SVG({
	    viewBox: "0 0 24 24",
	    stroke: color,
	    fill: 'none',
	    width: width,
	    height: height,
	    dangerouslySetInnerHTML: {
	      __html: "<path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16\" />"
	    }
	  });
	};
	
	window.filter_icon = function(height) {
	  if (height == null) {
	    height = 27;
	  }
	  return SVG({
	    className: 'opinion_view_class',
	    width: 33 / 27 * height,
	    height: height,
	    viewBox: "0 0 33 27",
	    dangerouslySetInnerHTML: {
	      __html: "<g id=\"final-push,-filters,-weights,-group-by\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"Artboard-Copy-47\" transform=\"translate(-373.000000, -868.000000)\">\n        <g id=\"Group-22\" transform=\"translate(333.000000, 843.000000)\">\n            <g id=\"filter2\" transform=\"translate(40.000000, 25.000000)\">\n                <circle id=\"Oval\" fill-opacity=\"0.491815314\" fill=\"#B0B0B0\" cx=\"4.5\" cy=\"4.5\" r=\"4.5\"></circle>\n                <circle id=\"Oval\" fill-opacity=\"0.491815314\" fill=\"#B0B0B0\" cx=\"15.5\" cy=\"4.5\" r=\"4.5\"></circle>\n                <circle id=\"Oval\" fill=\"#5F5E5E\" cx=\"15.5\" cy=\"22.5\" r=\"4.5\"></circle>\n                <circle id=\"Oval\" fill-opacity=\"0.491815314\" fill=\"#B0B0B0\" cx=\"25.5\" cy=\"4.5\" r=\"4.5\"></circle>\n                <line x1=\"2.1744186\" y1=\"13\" x2=\"31.8255814\" y2=\"13\" id=\"Line\" stroke=\"#757575\" stroke-linecap=\"square\" stroke-dasharray=\"0,2\"></line>\n            </g>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};
	
	window.group_by_icon = function(height) {
	  if (height == null) {
	    height = 19;
	  }
	  return SVG({
	    className: 'opinion_view_class',
	    width: 34 / 19 * height,
	    height: height,
	    viewBox: "0 0 34 19",
	    dangerouslySetInnerHTML: {
	      __html: "<g id=\"final-push,-filters,-weights,-group-by\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"Artboard-Copy-47\" transform=\"translate(-371.000000, -937.000000)\">\n        <g id=\"Group-22\" transform=\"translate(333.000000, 843.000000)\">\n            <g id=\"weigh\" transform=\"translate(39.000000, 94.000000)\">\n                <circle id=\"Oval\" fill=\"#F09552\" cx=\"6.45454545\" cy=\"13.1818182\" r=\"5\"></circle>\n                <circle id=\"Oval\" fill=\"#F09552\" cx=\"16.2727273\" cy=\"13\" r=\"5\"></circle>\n                <circle id=\"Oval\" fill=\"#5E91E9\" cx=\"10.8181818\" cy=\"5\" r=\"5\"></circle>\n                <circle id=\"Oval\" fill=\"#BC62C4\" cx=\"27.8181818\" cy=\"13\" r=\"5\"></circle>\n                <line x1=\"0.228571429\" y1=\"18.4545455\" x2=\"31.7714286\" y2=\"18.4545455\" id=\"Line\" stroke=\"#A7A7A7\" stroke-linecap=\"square\"></line>\n            </g>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};
	
	window.weigh_icon = function(height) {
	  if (height == null) {
	    height = 18;
	  }
	  return SVG({
	    className: 'opinion_view_class',
	    width: height * 34 / 18,
	    height: height,
	    viewBox: "0 0 34 18",
	    dangerouslySetInnerHTML: {
	      __html: "<g id=\"final-push,-filters,-weights,-group-by\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"Artboard-Copy-47\" transform=\"translate(-372.000000, -759.000000)\">\n        <g id=\"Group-22\" transform=\"translate(333.000000, 602.000000)\">\n            <g id=\"weigh\" transform=\"translate(40.000000, 157.000000)\">\n                <circle id=\"Oval\" fill=\"#9C9C9C\" cx=\"4.36363636\" cy=\"13.0909091\" r=\"2.90909091\"></circle>\n                <circle id=\"Oval\" fill=\"#9C9C9C\" cx=\"27.6363636\" cy=\"13.0909091\" r=\"4.36363636\"></circle>\n                <circle id=\"Oval\" fill=\"#9C9C9C\" cx=\"13.8181818\" cy=\"8\" r=\"8\"></circle>\n                <line x1=\"0.228571429\" y1=\"17.4545455\" x2=\"31.7714286\" y2=\"17.4545455\" id=\"Line\" stroke=\"#A7A7A7\" stroke-linecap=\"square\"></line>\n            </g>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};
	
	window.date_icon = function(activated) {
	  return SVG({
	    width: 13,
	    height: 12,
	    viewBox: "0 0 96 86",
	    dangerouslySetInnerHTML: {
	      __html: "\n<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g transform=\"translate(-234.000000, -823.000000)\" fill=\"" + (activated ? '#ffffff' : '#000000') + "\" fill-rule=\"nonzero\">\n        <g transform=\"translate(234.500000, 823.000000)\">\n            <path d=\"M84.3,5.7 L73.1,5.7 L73.1,2.9 C73.1,1.3 71.8,-1.77635684e-15 70.2,-1.77635684e-15 C68.6,-1.77635684e-15 67.3,1.3 67.3,2.9 L67.3,5.7 L50.4,5.7 L50.4,2.9 C50.4,1.3 49.1,-1.77635684e-15 47.5,-1.77635684e-15 C45.9,-1.77635684e-15 44.6,1.3 44.6,2.9 L44.6,5.7 L27.7,5.7 L27.7,2.9 C27.7,1.3 26.4,-1.77635684e-15 24.8,-1.77635684e-15 C23.2,-1.77635684e-15 21.9,1.3 21.9,2.9 L21.9,5.7 L10.7,5.7 C4.8,5.7 0,10.5 0,16.4 L0,75.2 C0,81.1 4.8,85.9 10.7,85.9 L84.4,85.9 C90.3,85.9 95.1,81.1 95.1,75.2 L95.1,16.4 C95,10.5 90.2,5.7 84.3,5.7 Z M89.2,75.1 C89.2,77.8 87,79.9 84.4,79.9 L10.7,79.9 C8,79.9 5.9,77.7 5.9,75.1 L5.9,16.4 C5.9,13.7 8.1,11.6 10.7,11.6 L21.9,11.6 L21.9,14.4 C21.9,16 23.2,17.3 24.8,17.3 C26.4,17.3 27.7,16 27.7,14.4 L27.7,11.6 L44.6,11.6 L44.6,14.4 C44.6,16 45.9,17.3 47.5,17.3 C49.1,17.3 50.4,16 50.4,14.4 L50.4,11.6 L67.3,11.6 L67.3,14.4 C67.3,16 68.6,17.3 70.2,17.3 C71.8,17.3 73.1,16 73.1,14.4 L73.1,11.6 L84.3,11.6 C87,11.6 89.1,13.8 89.1,16.4 L89.1,75.1 L89.2,75.1 Z\" id=\"Shape\"></path>\n            <path d=\"M29.9,27.9 L21.4,27.9 C19.8,27.9 18.6,29.2 18.6,30.7 C18.6,32.3 19.9,33.5 21.4,33.5 L29.9,33.5 C31.5,33.5 32.7,32.2 32.7,30.7 C32.8,29.2 31.5,27.9 29.9,27.9 Z\" id=\"Path\"></path>\n            <path d=\"M73.6,27.9 L65.1,27.9 C63.5,27.9 62.3,29.2 62.3,30.7 C62.3,32.3 63.6,33.5 65.1,33.5 L73.6,33.5 C75.2,33.5 76.4,32.2 76.4,30.7 C76.4,29.2 75.1,27.9 73.6,27.9 Z\" id=\"Path\"></path>\n            <path d=\"M51.7,27.9 L43.2,27.9 C41.6,27.9 40.4,29.2 40.4,30.7 C40.4,32.3 41.7,33.5 43.2,33.5 L51.7,33.5 C53.3,33.5 54.5,32.2 54.5,30.7 C54.6,29.2 53.3,27.9 51.7,27.9 Z\" id=\"Path\"></path>\n            <path d=\"M29.9,45.2 L21.4,45.2 C19.8,45.2 18.6,46.5 18.6,48 C18.6,49.6 19.9,50.8 21.4,50.8 L29.9,50.8 C31.5,50.8 32.7,49.5 32.7,48 C32.8,46.5 31.5,45.2 29.9,45.2 Z\" id=\"Path\"></path>\n            <path d=\"M73.6,45.2 L65.1,45.2 C63.5,45.2 62.3,46.5 62.3,48 C62.3,49.6 63.6,50.8 65.1,50.8 L73.6,50.8 C75.2,50.8 76.4,49.5 76.4,48 C76.4,46.5 75.1,45.2 73.6,45.2 Z\" id=\"Path\"></path>\n            <path d=\"M51.7,45.2 L43.2,45.2 C41.6,45.2 40.4,46.5 40.4,48 C40.4,49.6 41.7,50.8 43.2,50.8 L51.7,50.8 C53.3,50.8 54.5,49.5 54.5,48 C54.6,46.5 53.3,45.2 51.7,45.2 Z\" id=\"Path\"></path>\n            <path d=\"M29.9,62.5 L21.4,62.5 C19.8,62.5 18.6,63.8 18.6,65.3 C18.6,66.9 19.9,68.1 21.4,68.1 L29.9,68.1 C31.5,68.1 32.7,66.8 32.7,65.3 C32.8,63.8 31.5,62.5 29.9,62.5 Z\" id=\"Path\"></path>\n            <path d=\"M73.6,62.5 L65.1,62.5 C63.5,62.5 62.3,63.8 62.3,65.3 C62.3,66.9 63.6,68.1 65.1,68.1 L73.6,68.1 C75.2,68.1 76.4,66.8 76.4,65.3 C76.4,63.8 75.1,62.5 73.6,62.5 Z\" id=\"Path\"></path>\n            <path d=\"M51.7,62.5 L43.2,62.5 C41.6,62.5 40.4,63.8 40.4,65.3 C40.4,66.9 41.7,68.1 43.2,68.1 L51.7,68.1 C53.3,68.1 54.5,66.8 54.5,65.3 C54.6,63.8 53.3,62.5 51.7,62.5 Z\" id=\"Path\"></path>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};
	
	window.google_icon = function(size) {
	  return SVG({
	    width: size + "px",
	    height: size + "px",
	    viewBox: "0 0 39 39",
	    dangerouslySetInnerHTML: {
	      __html: "<g id=\"auth\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"btn_google_light_normal_ios\" transform=\"translate(-24.000000, -23.000000)\">\n        <g id=\"logo_googleg_48dp\" transform=\"translate(24.000000, 23.000000)\">\n            <path d=\"M38.22,19.9431818 C38.22,18.5604546 38.0959091,17.2309091 37.8654545,15.9545454 L19.5,15.9545454 L19.5,23.4975 L29.9945455,23.4975 C29.5425,25.935 28.1686364,28.0002272 26.1034091,29.3829545 L26.1034091,34.2756819 L32.4054545,34.2756819 C36.0927272,30.8809092 38.22,25.8818181 38.22,19.9431818 L38.22,19.9431818 Z\" id=\"Shape\" fill=\"#4285F4\" fill-rule=\"nonzero\"></path>\n            <path d=\"M19.5,39 C24.765,39 29.1790908,37.2538636 32.4054545,34.2756819 L26.1034091,29.3829545 C24.3572728,30.5529545 22.1236364,31.2443181 19.5,31.2443181 C14.4211364,31.2443181 10.1222727,27.8140908 8.58886364,23.205 L2.07409091,23.205 L2.07409091,28.2572728 C5.28272728,34.6302272 11.8772727,39 19.5,39 L19.5,39 Z\" id=\"Shape\" fill=\"#34A853\" fill-rule=\"nonzero\"></path>\n            <path d=\"M8.58886364,23.205 C8.19886364,22.035 7.97727272,20.7852273 7.97727272,19.5 C7.97727272,18.2147727 8.19886364,16.965 8.58886364,15.795 L8.58886364,10.7427273 L2.07409091,10.7427273 C0.753409091,13.3752273 0,16.3534091 0,19.5 C0,22.6465908 0.753409091,25.6247728 2.07409091,28.2572728 L8.58886364,23.205 L8.58886364,23.205 Z\" id=\"Shape\" fill=\"#FBBC05\" fill-rule=\"nonzero\"></path>\n            <path d=\"M19.5,7.75568181 C22.3629545,7.75568181 24.9334092,8.73954545 26.9543181,10.6718182 L32.5472728,5.07886364 C29.1702272,1.93227273 24.7561364,0 19.5,0 C11.8772727,0 5.28272728,4.36977272 2.07409091,10.7427273 L8.58886364,15.795 C10.1222727,11.1859091 14.4211364,7.75568181 19.5,7.75568181 L19.5,7.75568181 Z\" id=\"Shape\" fill=\"#EA4335\" fill-rule=\"nonzero\"></path>\n            <polygon id=\"Shape\" points=\"0 0 39 0 39 39 0 39\"></polygon>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};
	
	window.import_icon = function(size, color) {
	  return SVG({
	    width: size + "px",
	    height: size + "px",
	    viewBox: "0 0 550 550",
	    dangerouslySetInnerHTML: {
	      __html: "<g>\n <path fill=\"" + color + "\" d=\"m534.8 71.68-210.56 210.56v-81.199c0-6-3.1992-11.547-8.3984-14.547-5.1992-3.0039-11.602-3.0039-16.801 0-5.1953 3-8.3984 8.5469-8.3984 14.547v121.52c0.070313 1.1367 0.25781 2.2617 0.55859 3.3633v3.3594l1.1211 1.6797v1.1211-0.003906c1.1953 1.7656 2.7148 3.2852 4.4805 4.4805h1.1211l1.6797 1.1211h129.36c6 0 11.547-3.2031 14.547-8.3984 3.0039-5.1992 3.0039-11.602 0-16.801-3-5.1992-8.5469-8.4023-14.547-8.4023h-81.199l210.56-208.88c3.2617-4.3477 4.2188-10.008 2.5625-15.191-1.6523-5.1797-5.7109-9.2383-10.891-10.891-5.1836-1.6562-10.844-0.69922-15.191 2.5625z\"/>\n <path fill=\"" + color + "\" d=\"m209.44 493.36h242.48c19.305 0 37.824-7.668 51.477-21.32 13.652-13.656 21.32-32.172 21.32-51.48v-146.72c0-6-3.1992-11.547-8.3984-14.551-5.1992-3-11.602-3-16.801 0-5.1992 3.0039-8.3984 8.5508-8.3984 14.551v146.72c0 10.398-4.1328 20.367-11.484 27.719-7.3477 7.3516-17.32 11.484-27.715 11.484h-242.48c-10.398 0-20.367-4.1328-27.719-11.484-7.3516-7.3516-11.484-17.32-11.484-27.719v-242.48c0-10.395 4.1328-20.367 11.484-27.715 7.3516-7.3516 17.32-11.484 27.719-11.484h146.72c6 0 11.547-3.1992 14.551-8.3984 3-5.1992 3-11.602 0-16.801-3.0039-5.1992-8.5508-8.3984-14.551-8.3984h-146.72c-19.309 0-37.824 7.668-51.48 21.32-13.652 13.652-21.32 32.172-21.32 51.477v242.48c0 19.309 7.668 37.824 21.32 51.48 13.656 13.652 32.172 21.32 51.48 21.32z\"/>\n</g>"
	    }
	  });
	};
	
	window.dashboard_icons = {
	  avatar: function(color) {
	    return "<svg fill=\"" + color + "\" x=\"0px\" y=\"0px\" viewBox=\"23 25 53 50\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><path d=\"M25.7,75.2c0,0,0.1,0,0.1,0c1.1-0.1,1.9-1,1.8-2.1c-0.2-2.3,0-6.2,3.1-6.9c10.7-2.7,14.4-6.3,15.6-8.6  c1,0.3,2.1,0.4,3.2,0.4c0,0,0.1,0,0.1,0h0.2c0,0,0.1,0,0.1,0c1.3,0,2.5-0.2,3.7-0.5c1.3,2.4,4.9,6.1,15.6,8.8  c3.1,0.8,3.3,4.7,3.1,6.9c-0.1,1.1,0.7,2,1.8,2.1c0,0,0.1,0,0.1,0c1,0,1.8-0.8,1.9-1.8c0.4-5.9-1.8-9.9-6-11  c-9.6-2.4-12.3-5.4-13-6.7c0.7-0.5,1.3-1,1.9-1.7c4.9-5.5,4.1-14.9,4-15.9c-0.5-9.9-7.3-13.4-13-13.4c-0.1,0-0.2,0-0.3,0  c-0.1,0-0.2,0-0.3,0c-5.7,0-12.5,3.5-13,13.4c-0.1,0.9-0.9,10.4,4,15.9c0.7,0.8,1.4,1.4,2.2,1.9c-0.2,0.3-0.5,0.6-0.9,1  c-1.5,1.5-4.8,3.6-12.1,5.4c-4.2,1.1-6.4,5.1-6,10.9C23.9,74.4,24.7,75.2,25.7,75.2z M40.4,38.5c0,0,0-0.1,0-0.1  c0.4-9.1,7.1-9.8,9.1-9.8c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.2,0c2,0,8.7,0.7,9.1,9.8c0,0,0,0.1,0,0.1  c0.3,2.4,0.2,9.3-3.1,13c-1.5,1.7-3.6,2.6-6.3,2.6c0,0,0,0-0.1,0c0,0,0,0-0.1,0c-2.7,0-4.8-0.9-6.3-2.6  C39.5,47.1,40.4,38.6,40.4,38.5z\"/></svg>";
	  },
	  upload: function(color) {
	    return "<svg fill=\"" + color + "\" viewBox=\"2 4 28 22\" x=\"0px\" y=\"0px\"><g data-name=\"upload cloud\"><path d=\"M30,17.9375a4.3632,4.3632,0,0,0-5.0087-4.327c.0011-.0578.0087-.1151.0087-.173A8.875,8.875,0,0,0,7.8149,10.3218,5.9967,5.9967,0,0,0,8,22.3125h3a1,1,0,0,0,0-2H8a4,4,0,0,1,0-8,4.0947,4.0947,0,0,1,.4268.0225.9464.9464,0,0,0,.118-.0113.9685.9685,0,0,0,.1976-.0188.9517.9517,0,0,0,.1826-.0614.8625.8625,0,0,0,.3111-.214.95.95,0,0,0,.1154-.1378.975.975,0,0,0,.0923-.182.9173.9173,0,0,0,.0523-.1033A6.8771,6.8771,0,0,1,22.86,14.8232a.9958.9958,0,0,0,.1459.7529l.0025.0069a1.0034,1.0034,0,0,0,1.376.3291,2.375,2.375,0,1,1,1.24,4.4h-4.5a1,1,0,0,0,0,2h4.9375a.9931.9931,0,0,0,.3983-.0845A4.38,4.38,0,0,0,30,17.9375Z\"/><path d=\"M20.6,16.6377l-4-3a.996.996,0,0,0-1.1992,0l-4,3a1,1,0,0,0,1.1992,1.6l2.4-1.8v10a1,1,0,0,0,2,0v-10l2.4,1.8a1,1,0,0,0,1.1992-1.6Z\"/></g></svg>";
	  },
	  translate: function(color) {
	    return "<svg fill=\"" + color + "\" x=\"0px\" y=\"0px\" viewBox=\"10 10 60 60\" style=\"enable-background:new 0 0 80 80;\" xml:space=\"preserve\"><g><path d=\"M40,16c0-2.21-1.79-4-4-4H16c-2.21,0-4,1.79-4,4v20c0,2.21,1.79,4,4,4h20c2.21,0,4-1.79,4-4V16z M38,36c0,1.1-0.9,2-2,2H16   c-1.1,0-2-0.9-2-2V16c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2V36z\"/><path d=\"M64,40H44c-2.21,0-4,1.79-4,4v20c0,2.21,1.79,4,4,4h20c2.21,0,4-1.79,4-4V44C68,41.79,66.21,40,64,40z M59.32,59.05   c0.52,0.18,0.8,0.74,0.63,1.27C59.81,60.74,59.42,61,59,61c-0.1,0-0.21-0.02-0.32-0.05c-1.97-0.66-3.5-1.5-4.68-2.4301   c-1.18,0.9301-2.71,1.77-4.68,2.4301C49.21,60.98,49.1,61,49,61c-0.42,0-0.81-0.26-0.95-0.68c-0.17-0.53,0.11-1.09,0.63-1.27   c1.61-0.53,2.87-1.2,3.85-1.93c-2.02-2.27-2.46-4.72-2.54-6.12H49c-0.55,0-1-0.45-1-1s0.45-1,1-1h4v-1c0-0.55,0.45-1,1-1   s1,0.45,1,1v1h4c0.55,0,1,0.45,1,1s-0.45,1-1,1h-0.99c-0.08,1.4-0.52,3.85-2.54,6.12C56.45,57.85,57.71,58.51,59.32,59.05z\"/><path d=\"M54,55.79c1.6-1.82,1.96-3.72,2.02-4.79h-4.05C52.02,52.07,52.38,53.98,54,55.79z\"/><path d=\"M26.9229,19.6152C26.7676,19.2432,26.4033,19,26,19s-0.7676,0.2432-0.9229,0.6152l-2.7814,6.6755   C22.1133,26.4718,22,26.7224,22,27c0,0.0001,0.0001,0.0001,0.0001,0.0002l-1.9229,4.615   c-0.2129,0.5098,0.0283,1.0957,0.5381,1.3076c0.5098,0.2129,1.0947-0.0273,1.3076-0.5381L23.7498,28h4.5004l1.827,4.3848   C30.2373,32.7686,30.6084,33,31,33c0.1289,0,0.2588-0.0244,0.3848-0.0771c0.5098-0.2119,0.751-0.7979,0.5381-1.3076   L26.9229,19.6152z M24.5832,26L26,22.5996L27.4168,26H24.5832z\"/><path d=\"M43.1663,27.5197c0.0552,0.0881,0.1168,0.1675,0.1959,0.2344c0.0154,0.0131,0.0219,0.0335,0.0382,0.0457l4,3   C47.5801,30.9346,47.79,31,47.999,31c0.3047,0,0.6045-0.1377,0.8008-0.4004c0.332-0.4414,0.2422-1.0684-0.2002-1.3994L46.9999,28   H50c0.2861,0,7,0.0908,7,8c0,0.5527,0.4473,1,1,1s1-0.4473,1-1c0-9.8857-8.9102-10-9-10h-3.0001l1.5997-1.2002   c0.4424-0.3311,0.5322-0.958,0.2002-1.3994c-0.3311-0.4434-0.958-0.5322-1.3994-0.2002l-4,3   c-0.0163,0.0122-0.0228,0.0326-0.0382,0.0457c-0.0791,0.0669-0.1408,0.1464-0.196,0.2346   c-0.0216,0.0345-0.0496,0.0624-0.0668,0.0992C43.0391,26.7084,43,26.8484,43,27s0.0391,0.2916,0.0994,0.4203   C43.1166,27.4572,43.1447,27.4851,43.1663,27.5197z\"/><path d=\"M36.834,52.4807c-0.0552-0.0883-0.1171-0.1678-0.1962-0.2347c-0.0154-0.0131-0.0219-0.0335-0.0381-0.0457l-4-3   c-0.4404-0.3301-1.0674-0.2422-1.3994,0.2002c-0.332,0.4414-0.2422,1.0684,0.2002,1.3994L33.0001,52H30c-0.2861,0-7-0.0908-7-8   c0-0.5527-0.4473-1-1-1s-1,0.4473-1,1c0,9.8857,8.9102,10,9,10h3.0001l-1.5997,1.2002c-0.4424,0.3311-0.5322,0.958-0.2002,1.3994   C31.3965,56.8623,31.6963,57,32.001,57c0.209,0,0.4189-0.0654,0.5986-0.2002l4-3c0.0164-0.0122,0.0228-0.0326,0.0382-0.0457   c0.0791-0.0669,0.1409-0.1464,0.196-0.2346c0.0215-0.0345,0.0496-0.0623,0.0668-0.0991C36.9609,53.2917,37,53.1517,37,53   s-0.0391-0.2918-0.0994-0.4205C36.8835,52.5428,36.8555,52.5151,36.834,52.4807z\"/></g></svg>";
	  },
	  bell: function(color) {
	    return "<svg viewBox=\"20 15 60 70\" x=\"0px\" y=\"0px\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g fill-rule=\"nonzero\" fill=\"" + color + "\"><path d=\"M58.9863458,71.5 C58.726905,76.2379945 54.8027842,80 50,80 C45.1972158,80 41.273095,76.2379945 41.0136542,71.5 L27.0025482,71.5 C25.3425883,71.5 24,70.1608104 24,68.5029699 L24,65.5 C24,62.189348 26.688664,59.5 30.0020869,59.5 C29.9981947,59.5 30,47.4992494 30,47.4992494 C30,39.0465921 35.2858464,31.6357065 43,28.7587819 L43,28.4952534 C43,24.6330455 46.138457,21.5 50,21.5 C53.8656855,21.5 57,24.6311601 57,28.4952534 L57,28.7589486 C64.7139633,31.6362562 70,39.0483724 70,47.4992494 L70,59.4982567 C73.3063923,59.5 76,62.1883045 76,65.5 L76,68.5029699 C76,70.1542433 74.6530016,71.5 72.9974518,71.5 L58.9863458,71.5 Z M54.9753124,71.5 L45.0246876,71.5 C45.2755498,74.0266613 47.4073259,76 50,76 C52.5926741,76 54.7244502,74.0266613 54.9753124,71.5 Z M72,67.5 L72,65.5 C72,64.3992101 71.099016,63.5 69.9979131,63.5 C67.7877428,63.5 66,61.7131252 66,59.4982567 L66,47.4992494 C66,40.3240131 61.2358497,34.083713 54.4456568,32.1249199 L53,31.7078857 L53,28.4952534 C53,26.8412012 51.6574476,25.5 50,25.5 C48.3460522,25.5 47,26.8437313 47,28.4952534 L47,31.7078537 L45.5542654,32.1248469 C38.7637896,34.083424 34,40.3222636 34,47.4992494 L34,59.4982567 C34,61.7067825 32.2078843,63.5 30.0020869,63.5 C28.8980308,63.5 28,64.3982593 28,65.5 L28,67.5 L72,67.5 Z\"/></g></g></svg>";
	  },
	  forum: function(color) {
	    return "<svg fill=\"" + color + "\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"6 17 88 65\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><g><path d=\"M84.412,19.068H43.588c-3.916,0-7.177,2.833-7.857,6.557H15.588c-4.408,0-7.994,3.586-7.994,7.993v27.164   c0,4.408,3.586,7.994,7.994,7.994h19.456l12.867,11.518c0.468,0.42,1.065,0.638,1.668,0.638c0.368,0,0.738-0.081,1.083-0.247   c0.912-0.438,1.469-1.383,1.413-2.393l-0.532-9.516h4.868c3.593,0,6.639-2.384,7.642-5.653l11.858,10.614   c0.468,0.42,1.065,0.638,1.668,0.638c0.007,0,0.014-0.001,0.02,0c1.381,0,2.5-1.119,2.5-2.5c0-0.156-0.014-0.309-0.042-0.457   l-0.514-9.198h4.868c4.408,0,7.994-3.586,7.994-7.993V27.063C92.405,22.654,88.819,19.068,84.412,19.068z M56.412,63.776H48.9   c-0.687,0-1.344,0.283-1.816,0.782s-0.718,1.171-0.68,1.857l0.342,6.124l-9.079-8.126c-0.458-0.411-1.052-0.638-1.667-0.638H15.588   c-1.651,0-2.994-1.343-2.994-2.994V33.618c0-1.65,1.343-2.993,2.994-2.993h20.006v23.602c0,4.407,3.586,7.993,7.994,7.993h15.433   C58.511,63.143,57.539,63.776,56.412,63.776z M87.405,54.227c0,1.65-1.343,2.993-2.994,2.993H76.9   c-0.687,0-1.344,0.283-1.816,0.782s-0.718,1.171-0.68,1.857l0.342,6.124l-9.079-8.126C65.209,57.446,64.615,57.22,64,57.22H43.588   c-1.651,0-2.994-1.343-2.994-2.993V28.13c0-0.002,0-0.003,0-0.005s0-0.003,0-0.005v-1.058c0-1.651,1.343-2.994,2.994-2.994h40.823   c1.651,0,2.994,1.343,2.994,2.994V54.227z\"/></g></svg>";
	  },
	  lock: function(color) {
	    return "<svg viewBox=\"0 0 40 40\" version=\"1.1\" x=\"0px\" y=\"0px\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><rect x=\"0\" y=\"0\" width=\"40\" height=\"40\"/><path d=\"M20,20 C20.8817862,20 21.5484529,20 22,20 C30.836556,20 38,27.163444 38,36 L38,37 L36,37 L36,36 C36,28.2680135 29.7319865,22 22,22 C21.5473049,22 20.8806382,22 20,22 L20,22 C20,21.4477153 19.5522847,21 19,21 L19,20 L20,20 Z\" fill=\"" + color + "\" fill-rule=\"nonzero\"/><path d=\"M22,16 C25.3137085,16 28,13.3137085 28,10 C28,6.6862915 25.3137085,4 22,4 C18.6862915,4 16,6.6862915 16,10 C16,13.3137085 18.6862915,16 22,16 Z M22,18 C17.581722,18 14,14.418278 14,10 C14,5.581722 17.581722,2 22,2 C26.418278,2 30,5.581722 30,10 C30,14.418278 26.418278,18 22,18 Z\" fill=\"" + color + "\" fill-rule=\"nonzero\"/><path d=\"M11,32 C11,32.5522847 10.5522847,33 10,33 C9.44771525,33 9,32.5522847 9,32 L9,30.9146471 C8.41740381,30.7087289 8,30.1531094 8,29.5 C8,28.6715729 8.67157288,28 9.5,28 L10.5,28 C11.3284271,28 12,28.6715729 12,29.5 C12,30.1531094 11.5825962,30.7087289 11,30.9146471 L11,32 Z M4,23 L4,20 C4,16.6862915 6.6862915,14 10,14 C13.3137085,14 16,16.6862915 16,20 L16,23 L18,23 L18,38 L2,38 L2,23 L4,23 Z M4,25 L4,36 L16,36 L16,25 L4,25 Z M6,23 L14,23 L14,20 C14,17.790861 12.209139,16 10,16 C7.790861,16 6,17.790861 6,20 L6,23 Z\" fill=\"" + color + "\" fill-rule=\"nonzero\"/></g></svg>";
	  },
	  coding: function(color) {
	    return "<svg fill=\"" + color + "\" viewBox=\"5 5 37 37\" x=\"0px\" y=\"0px\"><g data-name=\"Layer 2\"><path d=\"M41,6H7A1,1,0,0,0,6,7V41a1,1,0,0,0,1,1H41a1,1,0,0,0,1-1V7A1,1,0,0,0,41,6ZM20,11a1,1,0,1,1-1-1A1,1,0,0,1,20,11Zm-4,0a1,1,0,1,1-1-1A1,1,0,0,1,16,11Zm-5-1a1,1,0,1,1-1,1A1,1,0,0,1,11,10ZM40,40H8V16H21a1,1,0,0,0,.71-.29L25.41,12H40Z\"/><path d=\"M17.29,22.29a1,1,0,0,0-1.41,0l-4,4a1,1,0,0,0,0,1.42l4,4a1,1,0,1,0,1.41-1.42L14,27l3.29-3.29A1,1,0,0,0,17.29,22.29Z\"/><path d=\"M30.88,31.71a1,1,0,0,0,1.41,0l4-4a1,1,0,0,0,0-1.42l-4-4a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L34.17,27l-3.29,3.29A1,1,0,0,0,30.88,31.71Z\"/><path d=\"M25.11,22.55l-4,8a1,1,0,0,0,.44,1.34A.93.93,0,0,0,22,32a1,1,0,0,0,.89-.55l4-8a1,1,0,1,0-1.78-.9Z\"/></g></svg>";
	  },
	  moderation: function(color) {
	    return "<svg fill=\"" + color + "\" x=\"0px\" y=\"0px\" viewBox=\"3 3 95 95\" style=\"enable-background:new 0 0 100 100;\" xml:space=\"preserve\"><switch><foreignObject requiredExtensions=\"http://ns.adobe.com/AdobeIllustrator/10.0/\" x=\"0\" y=\"0\" width=\"1\" height=\"1\"/><g i:extraneous=\"self\"><g><path d=\"M95.1,84.8L74,65.7c4.9-6.6,7.9-14.7,7.9-23.6C81.8,20.3,64,2.5,42.2,2.5S2.5,20.3,2.5,42.2s17.8,39.7,39.7,39.7     c8.8,0,17-2.9,23.6-7.9l19.1,21.1c0.2,0.2,0.3,0.4,0.5,0.5c3,2.7,7.6,2.5,10.3-0.5C98.3,92.1,98.1,87.5,95.1,84.8z M11.1,42.2     C11.1,25,25,11.1,42.2,11.1S73.2,25,73.2,42.2S59.3,73.2,42.2,73.2S11.1,59.3,11.1,42.2z\"/><path d=\"M52.6,30.8L38.1,46.5l-6.4-6.9c-1.6-1.7-4.3-1.8-6.1-0.2c-1.7,1.6-1.8,4.3-0.2,6.1l9.5,10.3c0.8,0.9,2,1.4,3.2,1.4     s2.3-0.5,3.2-1.4l17.7-19.1c1.6-1.7,1.5-4.5-0.2-6.1C57,29,54.2,29.1,52.6,30.8z\"/></g></g></switch></svg>";
	  },
	  user_data: function(color) {
	    return "<svg fill=\"" + color + "\" stroke-width=\"0.501\" stroke-linejoin=\"bevel\" fill-rule=\"evenodd\" version=\"1.1\" overflow=\"visible\" viewBox=\"10 20 80 55\" x=\"0px\" y=\"0px\"><g fill=\"none\" stroke=\"black\" transform=\"scale(1 -1)\"><g transform=\"translate(0 -96)\"><g><path d=\"M 8.625,23.701 L 8.625,72.3 C 8.625,73.334 9.465,74.175 10.5,74.175 L 85.501,74.175 C 86.535,74.175 87.376,73.334 87.376,72.3 L 87.376,23.701 C 87.376,22.666 86.535,21.826 85.501,21.826 L 10.5,21.826 C 9.465,21.826 8.625,22.666 8.625,23.701 Z M 83.626,25.576 L 83.626,70.425 L 12.375,70.425 L 12.375,25.576 L 83.626,25.576 Z M 17.778,33.112 L 17.778,34.987 C 17.778,38.826 19.254,41.73 21.775,43.611 C 24.216,45.432 27.432,46.147 30.721,46.147 C 34.008,46.147 37.224,45.432 39.665,43.611 C 42.187,41.728 43.662,38.829 43.662,34.987 L 43.662,33.112 L 17.778,33.112 Z M 37.422,40.605 C 35.856,41.774 33.539,42.397 30.721,42.397 C 27.901,42.397 25.583,41.774 24.017,40.605 C 22.904,39.774 22.06,38.586 21.707,36.869 L 39.733,36.869 C 39.379,38.587 38.536,39.773 37.422,40.605 Z M 49.433,42.366 C 49.433,43.4 50.273,44.241 51.308,44.241 L 67.636,44.241 C 68.67,44.241 69.511,43.4 69.511,42.366 C 69.511,41.331 68.67,40.491 67.636,40.491 L 51.308,40.491 C 50.273,40.491 49.433,41.331 49.433,42.366 Z M 23.246,55.433 C 23.246,59.558 26.593,62.906 30.719,62.906 C 34.844,62.906 38.192,59.558 38.192,55.433 C 38.192,51.307 34.844,47.96 30.719,47.96 C 26.593,47.96 23.246,51.307 23.246,55.433 Z M 49.433,49.866 C 49.433,50.9 50.273,51.741 51.308,51.741 L 75.886,51.741 C 76.92,51.741 77.761,50.9 77.761,49.866 C 77.761,48.831 76.92,47.991 75.886,47.991 L 51.308,47.991 C 50.273,47.991 49.433,48.831 49.433,49.866 Z M 34.442,55.433 C 34.442,57.487 32.773,59.156 30.719,59.156 C 28.664,59.156 26.996,57.487 26.996,55.433 C 26.996,53.378 28.664,51.71 30.719,51.71 C 32.773,51.71 34.442,53.378 34.442,55.433 Z M 49.433,57.366 C 49.433,58.4 50.273,59.241 51.308,59.241 L 75.886,59.241 C 76.92,59.241 77.761,58.4 77.761,57.366 C 77.761,56.331 76.92,55.491 75.886,55.491 L 51.308,55.491 C 50.273,55.491 49.433,56.331 49.433,57.366 Z\" stroke=\"none\" fill=\"#000000\" fill-rule=\"evenodd\" stroke-width=\"0.5\" marker-start=\"none\" marker-end=\"none\" stroke-miterlimit=\"79.8403193612775\"/></g></g></g></svg>";
	  },
	  survey: function(color) {
	    return "<svg viewBox=\"80 0 540 540\"> <g fill=\"" + color + "\" stroke=\"" + color + "\">  <path d=\"m386.96 206.64h114.8c10.641 0 19.039-8.3984 19.039-19.039 0-10.641-8.4023-19.602-19.039-19.602h-114.8c-10.641 0-19.039 8.3984-19.039 19.039 0 10.641 8.3984 19.602 19.039 19.602z\"/>  <path d=\"m386.96 299.04h114.8c10.641 0 19.039-8.3984 19.039-19.039s-8.3984-19.039-19.039-19.039h-114.8c-10.641 0-19.039 8.3984-19.039 19.039s8.3984 19.039 19.039 19.039z\"/>  <path d=\"m386.96 392h114.8c10.641 0 19.039-8.3984 19.039-19.039 0-10.641-8.3984-19.039-19.039-19.039h-114.8c-10.641 0-19.039 8.3984-19.039 19.039 0 10.078 8.3984 19.039 19.039 19.039z\"/>  <path d=\"m189.84 244.16h16.801c6.1602 0 11.199-4.4805 11.762-10.078 2.2383-11.762 9.5195-26.32 33.039-26.32 17.922 0 25.762 9.5195 28.559 15.121 3.9219 8.3984 3.3594 17.922-1.6797 24.641-5.0391 7.2812-10.078 10.641-16.238 14.559-14.559 10.078-26.32 20.719-28.559 50.961 0 3.3594 1.1211 6.7188 3.3594 9.5195 2.2383 2.2383 5.6016 3.9219 8.9609 3.9219h16.801c6.1602 0 11.762-5.0391 12.32-11.199 1.1211-11.762 3.9219-14 11.199-19.602 6.7188-5.0391 16.238-11.199 25.199-24.078 14.559-19.602 16.238-45.922 5.0391-67.762-11.762-23.52-36.398-37.52-64.961-37.52-47.602 0-69.441 34.719-73.922 63.84-0.55859 3.3594 0.55859 6.7188 2.8008 9.5195 2.8008 2.7969 6.1602 4.4766 9.5195 4.4766z\"/>  <path d=\"m278.88 369.04c0 13.609-11.031 24.641-24.641 24.641-13.605 0-24.637-11.031-24.637-24.641 0-13.605 11.031-24.641 24.637-24.641 13.609 0 24.641 11.035 24.641 24.641\"/>  <path d=\"m596.96 72.801h-493.92c-10.641 0-19.039 8.3984-19.039 19.039v376.32c0 10.641 8.3984 19.039 19.039 19.039h493.92c10.641 0 19.039-8.3984 19.039-19.039v-376.32c0-10.641-8.3984-19.039-19.039-19.039zm-19.039 376.32h-455.84v-338.24h455.84z\"/> </g></svg>";
	  }
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var HISTOGRAM_HEIGHT_COLLAPSED, HISTOGRAM_HEIGHT_EXPANDED, ParticipationStatus;
	
	HISTOGRAM_HEIGHT_COLLAPSED = 40;
	
	HISTOGRAM_HEIGHT_EXPANDED = 170;
	
	__webpack_require__(44);
	
	styles += ".OpinionBlock {\n  position: relative;\n}\n\n.is_expanded .OpinionBlock {\n  padding-top: 48px;\n}\n\n.fast-thought {\n  display: flex;\n  flex-direction: row;    \n  position: relative;\n}\n\n.is_expanded .fast-thought {\n  justify-content: center;\n}\n\n.is_expanded .OpinionBlock .proposal-score-spacing {\n  width: 0;\n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .is_expanded .fast-thought .proposal-score-spacing, \n  .is_expanded .fast-thought .proposal-left-spacing, \n  .is_expanded .fast-thought .proposal-left-spacing, \n  .is_expanded .fast-thought .proposal-avatar-wrapper, \n  .is_expanded .fast-thought .proposal-avatar-spacing {\n    display: none;\n  }\n\n}\n\n.OpinionBlock .slidergram_wrapper {\n  display: flex;\n}\n\n.is_expanded .OpinionBlock .slidergram_wrapper {\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n\n.proposal_scores {\n  position: absolute;\n}\n\n.is_collapsed .proposal_scores {\n  left: calc(100% - 80px);\n  top: 23px;    \n}\n\n.is_expanded .proposal_scores {\n  left: calc(50% + var(--ITEM_OPINION_WIDTH) / 2 * 2 + 36px);\n  bottom: 16px;\n}\n\n\n.opinion-views-container {\n  position: relative;\n  z-index: 1;\n  opacity: 0;     \n  margin-bottom: 8px;     \n}\n\n:not(.expanding).is_expanded .opinion-views-container {\n  opacity: 1;\n  transition: opacity " + (6 * ANIMATION_SPEED_ITEM_EXPANSION) + "s ease " + STAGE3_DELAY + "s;              \n}\n\n\n.heading-container {\n  opacity: 0;\n\n}\n\n.is_expanded .heading-container {\n  opacity: 1;\n  transition: opacity " + (2 * ANIMATION_SPEED_ITEM_EXPANSION) + "s linear " + STAGE1_DELAY + "s;              \n}\n\n.is_collapsed .heading-container {\n  overflow: hidden;\n  height: 0;\n  width: var(--ITEM_OPINION_WIDTH);\n}\n\n\n.opinion-heading {\n  font-size: 30px;\n  font-weight: 400;\n  text-align: center;\n  margin-bottom: 8px;\n}\n\n\n@media " + TABLET_MEDIA + " {\n  .opinion-heading {\n    font-size: 24px;\n  }\n}\n\n@media " + PHONE_MEDIA + " {\n  .opinion-heading {\n    font-size: 22px;\n  }\n}\n\n\n\n\n";
	
	window.OpinionBlock = ReactiveComponent({
	  displayName: 'OpinionBlock',
	  render: function() {
	    var current_user, just_you, mode, opinion_views, proposal, ref, ref1, show_proposal_scores, slider_interpretation, subdomain;
	    proposal = fetch(this.props.proposal);
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    this.is_expanded = this.props.is_expanded;
	    mode = getProposalMode(proposal);
	    show_proposal_scores = (!this.is_expanded || mode !== 'crafting') && !this.props.hide_scores && customization('show_proposal_scores', proposal, subdomain) && WINDOW_WIDTH() > 955;
	    opinion_views = fetch('opinion_views');
	    just_you = opinion_views.active_views['just_you'];
	    slider_interpretation = (function(_this) {
	      return function(value) {
	        if (value > .03) {
	          return ((value * 100).toFixed(0)) + "% " + (get_slider_label("slider_pole_labels.support", proposal, subdomain));
	        } else if (value < -.03) {
	          return (-1 * (value * 100).toFixed(0)) + "% " + (get_slider_label("slider_pole_labels.oppose", proposal, subdomain));
	        } else {
	          return translator("sliders.feedback-short.neutral", "Neutral");
	        }
	      };
	    })(this);
	    return DIV({
	      className: 'OpinionBlock'
	    }, FLIPPED({
	      flipId: "participation-status-" + proposal.key,
	      shouldFlipIgnore: this.props.shouldFlipIgnore,
	      shouldFlip: this.props.shouldFlip
	    }, DIV(null, this.is_expanded ? ParticipationStatus({
	      proposal: proposal.key
	    }) : void 0)), FLIPPED({
	      flipId: "proposal_heading-" + proposal.key,
	      shouldFlipIgnore: this.props.shouldFlipIgnore,
	      shouldFlip: this.props.shouldFlip
	    }, DIV({
	      className: 'heading-container'
	    }, (((ref = customization('opinion_callout')) != null ? ref[proposal.cluster] : void 0) || (customization('opinion_callout') && _.isFunction(customization('opinion_callout')))) ? (((ref1 = customization('opinion_callout')) != null ? ref1[proposal.cluster] : void 0) || customization('opinion_callout'))() : H1({
	      className: 'opinion-heading',
	      style: _.defaults({}, customization('list_title_style'))
	    }, mode === 'crafting' || (just_you && current_user.logged_in) ? TRANSLATE({
	      id: "engage.opinion_header"
	    }, 'What do you think?') : list_i18n().opinion_header("list/" + proposal.cluster)))), SECTION({
	      className: 'fast-thought'
	    }, TABLET_SIZE() ? [
	      DIV({
	        key: 'left',
	        className: 'proposal-left-spacing'
	      }), DIV({
	        key: 'avatar',
	        className: 'proposal-avatar-wrapper'
	      }), DIV({
	        key: 'right',
	        className: 'proposal-avatar-spacing'
	      })
	    ] : void 0, DIV({
	      className: 'slidergram_wrapper'
	    }, this.is_expanded && !PHONE_SIZE() ? DIV({
	      className: 'opinion-views-container'
	    }, OpinionViews({
	      ui_key: "opinion-views-" + proposal.key,
	      disable_switching: mode === 'crafting',
	      style: {
	        margin: '8px auto 20px auto',
	        position: 'relative'
	      }
	    }), OpinionViewInteractionWrapper({
	      ui_key: "opinion-views-" + proposal.key,
	      more_views_positioning: 'centered',
	      width: HOMEPAGE_WIDTH()
	    })) : void 0, Slidergram(this.props)), DIV({
	      className: 'proposal-score-spacing'
	    })), this.is_expanded ? Reasons(this.props) : void 0);
	  }
	});
	
	styles += ".Slidergram {\n  position: relative;\n}\n\n.is_collapsed .Slidergram {\n  margin-top: -26px;    \n}";
	
	window.Slidergram = ReactiveComponent({
	  displayName: "Slidergram",
	  render: function() {
	    var backgrounded, can_opine, current_user, draw_slider, just_you, mode, namespaced_slider_key, opinion_focus_elsewhere, opinion_views, opinions, permitted_to_opine, proposal, slider, slider_regions, subdomain, width, your_opinion;
	    this.is_expanded = this.props.is_expanded;
	    proposal = fetch(this.props.proposal);
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    your_opinion = proposal.your_opinion;
	    if (your_opinion.key) {
	      fetch(your_opinion.key);
	    }
	    permitted_to_opine = function() {
	      return canUserOpine(proposal);
	    };
	    can_opine = permitted_to_opine();
	    slider_regions = customization('slider_regions', proposal, subdomain);
	    opinions = opinionsForProposal(proposal);
	    draw_slider = can_opine > 0;
	    mode = getProposalMode(proposal);
	    backgrounded = this.is_expanded && mode === 'crafting';
	    if (draw_slider) {
	      slider = fetch("homepage_slider" + proposal.key);
	    } else {
	      slider = null;
	    }
	    opinion_views = fetch('opinion_views');
	    just_you = opinion_views.active_views['just_you'];
	    width = ITEM_OPINION_WIDTH() * (this.is_expanded && !TABLET_SIZE() ? 2 : 1);
	    namespaced_slider_key = namespaced_key('slider', proposal);
	    opinion_focus_elsewhere = opinion_views.active_views.region_selected || (opinion_views.active_views.single_opinion_selected && !just_you);
	    return DIV({
	      className: 'Slidergram'
	    }, H2({
	      className: 'hidden'
	    }, translator({
	      id: "engage.opinion_spectrum_explanation",
	      negative_pole: get_slider_label("slider_pole_labels.oppose", proposal),
	      positive_pole: get_slider_label("slider_pole_labels.support", proposal),
	      proposal_name: proposal.name
	    }, "Evaluations on spectrum from {negative_pole} to {positive_pole} of the proposal {proposal_name}")), opinion_views.active_views.group_by && fetch('opinion_views_ui').aggregate_into_groups ? AggregatedHistogram({
	      proposal: proposal.key,
	      width: width,
	      height: !this.is_expanded ? HISTOGRAM_HEIGHT_COLLAPSED : HISTOGRAM_HEIGHT_EXPANDED,
	      flip: true,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }) : Histogram({
	      histo_key: "histogram-" + proposal.slug,
	      proposal: proposal.key,
	      opinions: opinions,
	      width: width,
	      height: !this.is_expanded ? HISTOGRAM_HEIGHT_COLLAPSED : HISTOGRAM_HEIGHT_EXPANDED,
	      enable_individual_selection: !this.props.disable_selection && (!PHONE_SIZE() && (!TABLET_SIZE() || this.props.is_expanded)),
	      enable_range_selection: !just_you && !browser.is_mobile && !TABLET_SIZE(),
	      draw_base_labels: !slider_regions,
	      backgrounded: backgrounded,
	      flip: true,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }), OpinionSlider({
	      key: namespaced_slider_key,
	      slider_key: namespaced_slider_key,
	      proposal: this.props.proposal,
	      width: width,
	      your_opinion: your_opinion,
	      focused: this.is_expanded && mode === 'crafting',
	      backgrounded: false,
	      draw_handle: !opinion_focus_elsewhere && (can_opine === Permission.NOT_LOGGED_IN || can_opine > 0),
	      permitted: permitted_to_opine,
	      base_height: !this.is_expanded ? 1 : 2,
	      handle: !this.is_expanded ? slider_handle.triangley : false ? slider_handle.flat : customization('slider_handle', proposal) || slider_handle.flat,
	      handle_height: !this.is_expanded ? 30 : TABLET_SIZE() ? 44 : 36,
	      handle_width: !this.is_expanded ? 33 : void 0,
	      offset: !this.is_expanded,
	      pole_labels: [get_slider_label("slider_pole_labels.oppose", proposal), get_slider_label("slider_pole_labels.support", proposal)],
	      flip: !!this.props.shouldFlip,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore,
	      is_expanded: this.props.is_expanded,
	      show_val_highlighter: !opinion_focus_elsewhere && (can_opine === Permission.NOT_LOGGED_IN || can_opine > 0),
	      show_reasons_callout: (!opinion_focus_elsewhere || TABLET_SIZE()) && !this.props.is_expanded
	    }));
	  }
	});
	
	ParticipationStatus = ReactiveComponent({
	  displayName: 'ParticipationStatus',
	  render: function() {
	    var can_opine;
	    can_opine = canUserOpine(this.props.proposal);
	    if (can_opine > 0 || can_opine === Permission.NOT_LOGGED_IN) {
	      return SPAN(null);
	    }
	    return DIV({
	      style: {
	        textAlign: 'center'
	      }
	    }, DIV({
	      style: {
	        backgroundColor: attention_orange,
	        color: 'white',
	        margin: '0px auto 8px auto',
	        display: 'inline-block',
	        padding: '4px 6px',
	        fontWeight: 700
	      }
	    }, can_opine === Permission.DISABLED ? TRANSLATE({
	      id: 'engage.proposal_closed'
	    }, 'Closed to new contributions.') : can_opine === Permission.INSUFFICIENT_PRIVILEGES ? TRANSLATE({
	      id: 'engage.permissions.read_only'
	    }, "This proposal is read-only. The forum hosts specify who can participate.") : can_opine === Permission.UNVERIFIED_EMAIL ? A({
	      style: {
	        cursor: 'pointer'
	      },
	      onTouchEnd: (function(_this) {
	        return function(e) {
	          return e.stopPropagation();
	        };
	      })(this),
	      onClick: (function(_this) {
	        return function(e) {
	          e.stopPropagation();
	          reset_key('auth', {
	            form: 'verify email',
	            goal: 'To participate, please demonstrate you control this email.'
	          });
	          current_user.trying_to = 'send_verification_token';
	          return save(current_user);
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            reset_key('auth', {
	              form: 'verify email',
	              goal: 'To participate, please demonstrate you control this email.'
	            });
	            current_user.trying_to = 'send_verification_token';
	            return save(current_user);
	          }
	        };
	      })(this)
	    }, translator('engage.permissions.verify_account_to_participate', "Verify your account to participate")) : void 0));
	  }
	});
	
	window.canUserOpine = function(proposal) {
	  var can_opine, your_opinion;
	  proposal = fetch(proposal);
	  your_opinion = proposal.your_opinion;
	  if (your_opinion.key) {
	    can_opine = permit('update opinion', proposal, your_opinion);
	  } else {
	    can_opine = permit('publish opinion', proposal);
	  }
	  return can_opine;
	};
	
	window.couldUserMaybeOpine = function(proposal) {
	  var can_opine;
	  can_opine = canUserOpine(proposal);
	  return can_opine > 0 || (can_opine === Permission.NOT_LOGGED_IN || can_opine === Permission.UNVERIFIED_EMAIL);
	};


/***/ },
/* 42 */
/***/ function(module, exports) {

	var COLLAPSED_MAX_HEIGHT, EXPANDED_MAX_HEIGHT;
	
	COLLAPSED_MAX_HEIGHT = 50;
	
	EXPANDED_MAX_HEIGHT = 500;
	
	styles += "\n:root {\n  --proposal_title_underline_color: #000000;\n}\n\n.ItemText .proposal-title {\n  max-width: 700px;\n}\n\n.ItemText.has-description .proposal-title {\n  margin-bottom: 8px;\n}\n\n.ItemText .proposal-title-text {\n  # transition-property: transform;    \n  transform: scale(1);\n  transform-origin: 0 0;\n\n  cursor: pointer;\n}\n\n.proposal-title-invert-container {\n  position: relative;\n  z-index: 1;\n} \n\n.is_expanded .ItemText .proposal-title-invert-container {\n  position: absolute;\n}\n\n\n.proposal-title-text-inline {\n  border-bottom-width: 2px;\n  border-style: solid;\n  border-color: " + (focus_blue + "ad") + "; /* with some transparency */\n  transition: border-color 1s;\n  font-size: 20px;\n  font-weight: 700;\n  color: #111;    \n}\n\n@media " + PHONE_MEDIA + " {\n  .proposal-title-text-inline {\n    font-size: 17px;\n  }\n}\n\n.proposal-title-text-inline:hover,\n.proposal-title-text-inline:focus-within {\n  border-color: #000;\n}\n\n\n.proposal-description {\n  overflow: hidden;\n\n  font-size: 15px;\n  font-weight: 400;\n\n  // max-height: 50px; /* this value will get overridden to min(estimated_desc_height, PROPOSAL_DESCRIPTION_MAX_HEIGHT_ON_EXPAND) in javascript */\n\n  transition-property: color;\n\n  // padding: 8px 0px;\n\n  color: #555;\n}\n\n.is_collapsed .proposal-description {\n  color: #888;\n}\n\n.is_collapsed .proposal-description.hidden-by-customization {\n  max-height: 0px;\n}\n\n\n.is_expanded .proposal-description {\n  max-height: " + EXPANDED_MAX_HEIGHT + "px;\n}\n\n.is_expanded .proposal-description.fully_expanded {\n  max-height: 9999px;\n}\n\n.proposal-description.wysiwyg_text p {\n  line-height: 1.5;\n}\n\n.is_expanded .proposal-description.wysiwyg_text p {\n  /* max-width: var(--ITEM_TEXT_WIDTH); */\n}\n\n[data-widget=\"ListItems\"]:not(.expansion_event) .is_collapsed .transparency_fade {\n  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%); /* linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 34%, rgba(255,255,255,0) 100%); */\n  bottom: 0px;\n  height: 22px;\n  position: absolute;\n  pointer-events: none;\n  opacity: 1;\n}\n.transparency_fade {\n  opacity: 0;\n  transition: opacity " + ANIMATION_SPEED_ITEM_EXPANSION + "s ease;\n}\n\n[data-widget=\"ListItems\"].flipping .expand_full_text {\n  opacity: 0;\n}\n.expand_full_text {\n  text-decoration: underline;\n  cursor: pointer;\n  padding: 24px 0px 10px 0px;\n  font-weight: 600;\n  text-align: left;\n  border: none;\n  width: 100%;\n  background-color: transparent;\n}\n\n\n.show_list_title .proposal-title-text::before {\n  content: attr(data-list-title);\n  color: var(--list-color);\n  position: absolute;\n  top: -16px;\n  padding: 0;\n  font-size: 12px;\n  height: 16px;\n  overflow: hidden;\n\n  font-style: italic;\n  font-weight: 500;\n\n  /* \n  font-family: IBM Plex mono;\n  */\n}       ";
	
	window.collapsed_height_initialized = {};
	
	window.ItemText = ReactiveComponent({
	  displayName: 'ItemText',
	  toggle_expand: function() {
	    return toggle_expand({
	      proposal: this.props.proposal
	    });
	  },
	  render: function() {
	    var has_description, list_title, list_title_width, proposal, subdomain, tw;
	    proposal = fetch(this.props.proposal);
	    subdomain = fetch('/subdomain');
	    this.is_expanded = this.props.is_expanded;
	    has_description = proposal.description || customization('proposal_description');
	    if (!this.is_expanded && this.local.description_fully_expanded) {
	      this.local.description_fully_expanded = false;
	    }
	    if (this.props.show_list_title) {
	      list_title = get_list_title(get_list_for_proposal(proposal), true);
	      list_title_width = widthWhenRendered(list_title, {
	        fontSize: "12px",
	        fontWeight: "500",
	        fontStyle: "italic"
	      });
	      tw = ITEM_TEXT_WIDTH();
	      if (list_title_width > tw) {
	        list_title = (list_title.substring(0, Math.floor(tw / list_title_width * list_title.length) - 6)) + "...";
	      }
	    }
	    return FLIPPED({
	      flipId: "proposal-title-starter-" + proposal.key,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore,
	      opacity: true,
	      onSpringUpdate: this.props.expansion_state_changed() && LIST_ITEM_EXPANSION_SCALE() !== 1 ? (function(_this) {
	        return function(value) {
	          var end, start;
	          if (_this.props.expansion_state_changed()) {
	            start = _this.is_expanded ? 1 : LIST_ITEM_EXPANSION_SCALE();
	            end = _this.is_expanded ? LIST_ITEM_EXPANSION_SCALE() : 1;
	            if (_this.refs.proposal_title_text) {
	              return _this.refs.proposal_title_text.style.transform = "scale(" + (start + (end - start) * value) + ")";
	            }
	          }
	        };
	      })(this) : void 0
	    }, DIV({
	      id: "proposal-text-" + proposal.id,
	      "data-widget": 'ItemText',
	      className: "ItemText " + (has_description ? 'has-description' : 'no-description'),
	      ref: 'root',
	      'data-visibility-name': 'ItemText',
	      'data-receive-viewport-visibility-updates': 2,
	      'data-component': this.local.key
	    }, STYLE({
	      dangerouslySetInnerHTML: {
	        __html: "\n.is_expanded .ItemText .proposal-title-text {\n  transform: scale(" + (LIST_ITEM_EXPANSION_SCALE()) + ");\n} \n\n.is_collapsed #proposal-text-" + proposal.id + " .proposal-title {\n  height: " + this.local.collapsed_title_height + "px;\n}\n\n.is_expanded #proposal-text-" + proposal.id + " .proposal-title {\n  height: " + (LIST_ITEM_EXPANSION_SCALE() * this.local.collapsed_title_height) + "px;\n}\n\n#proposal-text-" + proposal.id + " .proposal-title-text, .transparency_fade {\n   width: " + (ITEM_TEXT_WIDTH()) + "px;\n}\n\n.is_collapsed #proposal-text-" + proposal.id + " .proposal-description-wrapper {\n   max-width: " + (ITEM_TEXT_WIDTH()) + "px;\n   position: relative; /* for transparency fade */\n}\n.is_expanded #proposal-text-" + proposal.id + " .proposal-description-wrapper {\n   max-width: " + (ITEM_TEXT_WIDTH() * LIST_ITEM_EXPANSION_SCALE()) + "px;\n}\n.is_collapsed .proposal-description {\n   max-height: " + (customization('collapsed_max_height') || COLLAPSED_MAX_HEIGHT) + "px;\n}\n"
	      }
	    }), DIV(null, FLIPPED({
	      flipId: "proposal-title-placer-" + proposal.key,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }, DIV({
	      ref: 'proposal_title',
	      className: "prep_for_flip proposal-title",
	      "data-proposal": proposal.key,
	      onClick: this.toggle_expand,
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            return _this.toggle_expand();
	          }
	        };
	      })(this)
	    }, FLIPPED({
	      inverseFlipId: "proposal-title-placer-" + proposal.key,
	      shouldInvert: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }, DIV({
	      className: 'prep_for_flip proposal-title-invert-container'
	    }, FLIPPED({
	      flipId: "proposal-title-" + proposal.key,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }, DIV({
	      ref: 'proposal_title_text',
	      className: 'proposal-title-text',
	      "data-list-title": this.props.show_list_title ? list_title : void 0,
	      style: !this.props.show_list_title ? {} : {
	        "--list-color": this.props.list_title_color || 'black'
	      }
	    }, SPAN({
	      className: 'proposal-title-text-inline'
	    }, proposal.name))))))), FLIPPED({
	      flipId: "proposal-description-placer-" + proposal.key,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }, DIV({
	      className: 'proposal-description-wrapper prep_for_flip',
	      ref: 'proposal-description-wrapper'
	    }, this.draw_description())), FLIPPED({
	      flipId: "proposal-meta-placer-" + proposal.key,
	      translate: true,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }, DIV({
	      className: 'prep_for_flip'
	    }, this.draw_metadata())))));
	  },
	  waitForFonts: function(cb) {
	    if (!this.fonts_loaded) {
	      this.fonts_loaded = document.fonts.check("14px " + (customization('font').split(',')[0]));
	      if (!this.fonts_loaded && !this.wait_for_fonts) {
	        this.wait_for_fonts = setInterval((function(_this) {
	          return function() {
	            return typeof cb === "function" ? cb() : void 0;
	          };
	        })(this));
	      }
	      if (this.fonts_loaded && this.wait_for_fonts) {
	        clearInterval(this.wait_for_fonts);
	      }
	      return this.fonts_loaded;
	    }
	    return true;
	  },
	  setCollapsedSizes: function() {
	    var base, base1, changed, collapsed_title_height, desc, el, first_height_calc, height, i, len, media_el, proposal, ref, second_height_calc, title_el;
	    if (!this.waitForFonts((function(_this) {
	      return function() {
	        return _this.setCollapsedSizes();
	      };
	    })(this)) || ((this.local.collapsed_title_height != null) && this.sized_at_window_width === WINDOW_WIDTH() && (!this.description_has_media || this.local.media_is_loaded))) {
	      return;
	    }
	    proposal = fetch(this.props.proposal);
	    title_el = this.refs.proposal_title_text;
	    changed = false;
	    if (this.is_expanded) {
	      collapsed_title_height = title_el.getBoundingClientRect().height;
	      if (collapsed_title_height !== this.local.collapsed_title_height) {
	        this.local.collapsed_title_height = collapsed_title_height;
	        changed = true;
	      }
	    } else {
	      first_height_calc = title_el.clientHeight;
	      second_height_calc = title_el.clientHeight;
	      console.assert(first_height_calc === second_height_calc, "First call to title_el.clientHeight was mysteriously wrong. First call: " + first_height_calc + ", Second call: " + second_height_calc);
	      if (this.local.collapsed_title_height !== second_height_calc) {
	        this.local.collapsed_title_height = second_height_calc;
	        changed = true;
	      }
	    }
	    this.sized_at_window_width = WINDOW_WIDTH();
	    if (changed) {
	      save(this.local);
	    }
	    if (proposal.description) {
	      el = document.createElement('div');
	      el.classList.add('proposal-description');
	      this.description_has_media = proposal.description.toLowerCase().indexOf('<img') > -1 || proposal.description.toLowerCase().indexOf('<video') > -1;
	      if (this.description_has_media && !this.local.media_is_loaded) {
	        desc = this.refs.proposal_description;
	        this.local.media_is_loaded = true;
	        ref = desc.querySelectorAll('img,video');
	        for (i = 0, len = ref.length; i < len; i++) {
	          media_el = ref[i];
	          if (media_el.tagName === 'IMG') {
	            (base = this.local).media_is_loaded && (base.media_is_loaded = media_el.complete);
	          } else if (media_el.tagName === 'VIDEO') {
	            (base1 = this.local).media_is_loaded && (base1.media_is_loaded = media_el.readyState >= 3);
	          }
	        }
	        if (!this.local.media_is_loaded) {
	          setTimeout(this.setCollapsedSizes, 100);
	        } else {
	          save(this.local);
	        }
	      }
	      height = heightWhenRendered(proposal.description.replace(/<p><br><\/p>/g, ''), {
	        width: (ITEM_TEXT_WIDTH()) + "px"
	      }, el, this.description_has_media);
	      this.exceeds_collapsed_description_height = height >= customization('collapsed_max_height') || COLLAPSED_MAX_HEIGHT;
	      if (LIST_ITEM_EXPANSION_SCALE() !== 1) {
	        height = heightWhenRendered(proposal.description, {
	          width: (ITEM_TEXT_WIDTH() * LIST_ITEM_EXPANSION_SCALE()) + "px"
	        }, el, this.description_has_media);
	      }
	      this.super_long_description = height >= EXPANDED_MAX_HEIGHT;
	    }
	    return collapsed_height_initialized[proposal.key] = true;
	  },
	  componentDidMount: function() {
	    return requestAnimationFrame((function(_this) {
	      return function() {
	        var loc;
	        loc = fetch('location');
	        return _this.setCollapsedSizes();
	      };
	    })(this));
	  },
	  componentDidUpdate: function() {
	    return requestAnimationFrame((function(_this) {
	      return function() {
	        var loc;
	        loc = fetch('location');
	        return _this.setCollapsedSizes();
	      };
	    })(this));
	  },
	  draw_description: function() {
	    var cust_desc, proposal, result;
	    proposal = fetch(this.props.proposal);
	    cust_desc = customization('proposal_description');
	    if (!proposal.description && !cust_desc) {
	      return DIV(null);
	    }
	    if (cust_desc) {
	      if (typeof cust_desc === 'function') {
	        result = cust_desc(proposal);
	      } else if (cust_desc[proposal.cluster]) {
	        result = cust_desc[proposal.cluster]({
	          proposal: proposal
	        });
	        if (typeof result === 'function' && /^function \(props, children\)/.test(Function.prototype.toString.call(result))) {
	          result = cust_desc[proposal.cluster]()({
	            proposal: proposal
	          });
	        } else {
	          result;
	        }
	      } else {
	        result = DIV({
	          dangerouslySetInnerHTML: {
	            __html: proposal.description
	          }
	        });
	      }
	    } else {
	      result = DIV({
	        dangerouslySetInnerHTML: {
	          __html: proposal.description.replace(/<p><br><\/p>/g, '')
	        }
	      });
	    }
	    return DIV(null, DIV({
	      className: "proposal-description wysiwyg_text proposal_item_animation " + (this.local.description_fully_expanded ? 'fully_expanded' : '') + " " + (customization('hide_collapsed_proposal_description') ? 'hidden-by-customization' : ''),
	      ref: 'proposal_description',
	      onClick: this.exceeds_collapsed_description_height && !this.is_expanded ? this.toggle_expand : void 0
	    }, DIV({
	      style: {
	        position: 'relative'
	      }
	    }, FLIPPED({
	      inverseFlipId: "proposal-description-placer-" + proposal.key,
	      scale: true,
	      shouldInvert: this.shouldFlip,
	      shouldFlipIgnore: this.shouldFlipIgnore
	    }, result)), this.exceeds_collapsed_description_height || cust_desc ? DIV({
	      className: 'transparency_fade'
	    }) : void 0), this.super_long_description && this.props.is_expanded && !this.local.description_fully_expanded && !embedded_demo() ? BUTTON({
	      className: 'expand_full_text',
	      onMouseDown: (function(_this) {
	        return function() {
	          _this.local.description_fully_expanded = true;
	          return save(_this.local);
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            _this.local.description_collapsed = true;
	            e.preventDefault();
	            document.activeElement.blur();
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }, TRANSLATE({
	      id: 'engage.show_full_proposal_description'
	    }, 'Show full text')) : void 0);
	  },
	  draw_metadata: function() {
	    var YOUR_OPINION_BUTTON_COLOR, YOUR_OPINION_BUTTON_SIZE, editor, groups, icons, is_closed, o, opinion_prompt, opinion_publish_permission, opinions, overall_cnt, proposal, read_only, ref, salience, show_author_name_in_meta_data, show_cluster, show_discussion_info, show_timestamp, subdomain, toggleExpandPreferPersonal, weights, you_have_opinion, your_opinion;
	    proposal = fetch(this.props.proposal);
	    subdomain = fetch('/subdomain');
	    icons = customization('show_proposer_icon', proposal, subdomain);
	    opinion_publish_permission = permit('publish opinion', proposal, subdomain);
	    opinion_prompt = getOpinionPrompt({
	      proposal: proposal
	    });
	    you_have_opinion = Boolean(proposal != null ? (ref = proposal.your_opinion) != null ? ref.key : void 0 : void 0);
	    toggleExpandPreferPersonal = function() {
	      return toggle_expand({
	        proposal: proposal,
	        prefer_personal_view: true
	      });
	    };
	    YOUR_OPINION_BUTTON_SIZE = 18;
	    YOUR_OPINION_BUTTON_COLOR = '#444';
	    return DIV({
	      className: 'proposal-metadata'
	    }, (function() {
	      var i, len, ref1, ref2;
	      if (customization('proposal_meta_data', null, subdomain) != null) {
	        return customization('proposal_meta_data', null, subdomain)(proposal);
	      } else if (!this.props.hide_metadata && customization('show_proposal_meta_data', null, subdomain)) {
	        show_author_name_in_meta_data = !icons && (editor = proposal_editor(proposal)) && editor === proposal.user && !customization('anonymize_everything');
	        show_timestamp = !screencasting() && subdomain.name !== 'galacticfederation';
	        show_discussion_info = customization('discussion_enabled', proposal, subdomain);
	        show_cluster = this.props.show_list_title && proposal.cluster;
	        is_closed = opinion_publish_permission === Permission.DISABLED;
	        read_only = opinion_publish_permission === Permission.INSUFFICIENT_PRIVILEGES;
	        ref1 = compose_opinion_views(null, proposal), weights = ref1.weights, salience = ref1.salience, groups = ref1.groups;
	        opinions = get_opinions_for_proposal(opinions, proposal, weights);
	        overall_cnt = 0;
	        for (i = 0, len = opinions.length; i < len; i++) {
	          o = opinions[i];
	          if (salience[o.user.key || o.user] < 1) {
	            continue;
	          }
	          overall_cnt += 1;
	        }
	        return [
	          show_timestamp ? SPAN({
	            key: 'date',
	            className: 'separated monospaced metadata-piece',
	            style: {
	              borderBottom: 'none'
	            }
	          }, prettyDate(proposal.created_at)) : void 0, show_author_name_in_meta_data ? SPAN({
	            key: 'author name',
	            className: 'separated monospaced metadata-piece',
	            style: {
	              borderBottom: 'none'
	            }
	          }, TRANSLATE({
	            id: 'engage.proposal_author',
	            name: (ref2 = fetch(editor)) != null ? ref2.name : void 0
	          }, " by {name}")) : void 0, BUTTON({
	            key: 'opinion-count',
	            className: 'opinion-count metadata-piece separated like_link monospaced',
	            onClick: (function(_this) {
	              return function() {
	                return toggle_expand({
	                  proposal: proposal,
	                  prefer_personal_view: false
	                });
	              };
	            })(this),
	            onKeyPress: (function(_this) {
	              return function(e) {
	                if (e.which === 32 || e.which === 13) {
	                  return toggle_expand({
	                    proposal: proposal,
	                    prefer_personal_view: false
	                  });
	                }
	              };
	            })(this)
	          }, TRANSLATE({
	            id: "engage.proposal_score_summary",
	            num_opinions: overall_cnt
	          }, "{num_opinions, plural, =0 {no opinions} one {# opinion} other {# opinions} }")), show_discussion_info ? BUTTON({
	            key: 'proposal-link',
	            className: 'pros_cons_count metadata-piece separated like_link monospaced',
	            onClick: (function(_this) {
	              return function() {
	                return toggle_expand({
	                  proposal: proposal
	                });
	              };
	            })(this),
	            onKeyPress: (function(_this) {
	              return function(e) {
	                if (e.which === 32 || e.which === 13) {
	                  return toggle_expand({
	                    proposal: proposal
	                  });
	                }
	              };
	            })(this)
	          }, TRANSLATE({
	            id: "engage.point_count",
	            cnt: proposal.point_count
	          }, "{cnt, plural, one {# pro or con} other {# pros & cons}}")) : void 0, (you_have_opinion && permit('update opinion', proposal, proposal.your_opinion) > 0) || permit('publish opinion', proposal) > 0 ? SPAN({
	            key: 'yourOpinion',
	            className: 'separated monospaced metadata-piece',
	            style: {
	              border: 'solid 1px #dddddd',
	              borderRadius: '8px',
	              padding: '3px 10px',
	              backgroundColor: '#f8f8f8'
	            }
	          }, opinion_prompt ? [
	            BUTTON({
	              key: 'edit-opinion-text',
	              className: 'monospaced',
	              style: {
	                border: 'none',
	                backgroundColor: 'rgba(0,0,0,0)',
	                padding: 0
	              },
	              onClick: toggleExpandPreferPersonal,
	              onKeyPress: (function(_this) {
	                return function(e) {
	                  if (e.which === 32 || e.which === 13) {
	                    return toggleExpandPreferPersonal();
	                  }
	                };
	              })(this)
	            }, you_have_opinion ? translator('engage.your_opinion_section_label', 'Your opinion') : opinion_prompt), you_have_opinion && !TABLET_SIZE() ? BUTTON({
	              key: 'edit-opinion-button',
	              id: "edit-opinion-" + proposal.key,
	              "aria-label": translator('engage.edit_opinion_button', 'Edit your opinion'),
	              "data-tooltip": translator('engage.edit_opinion_button', 'Edit your opinion'),
	              className: 'metadata-piece',
	              style: {
	                border: 'none',
	                verticalAlign: 'bottom',
	                marginBottom: '-3px',
	                marginLeft: '10px'
	              },
	              onClick: toggleExpandPreferPersonal,
	              onKeyPress: (function(_this) {
	                return function(e) {
	                  if (e.which === 32 || e.which === 13) {
	                    return toggleExpandPreferPersonal();
	                  }
	                };
	              })(this)
	            }, edit_icon(YOUR_OPINION_BUTTON_SIZE, YOUR_OPINION_BUTTON_SIZE, YOUR_OPINION_BUTTON_COLOR)) : void 0
	          ] : void 0, (your_opinion = proposal.your_opinion) && your_opinion.key && permit('update opinion', proposal, your_opinion) > 0 ? [
	            BUTTON({
	              key: 'anonymize_opinion',
	              role: 'checkbox',
	              "aria-checked": Boolean(your_opinion.hide_name),
	              "aria-label": your_opinion_i18n.anonymize_opinion_button(),
	              "data-tooltip": your_opinion_i18n.anonymize_opinion_button(),
	              className: 'metadata-piece',
	              style: {
	                border: 'none',
	                verticalAlign: 'bottom',
	                marginBottom: '-1px',
	                marginLeft: '15px',
	                display: customization('anonymize_permanently') ? 'none' : void 0
	              },
	              onClick: function() {
	                return toggle_anonymize_opinion(your_opinion);
	              }
	            }, iconAnonymousMask(YOUR_OPINION_BUTTON_SIZE, your_opinion.hide_name ? focus_blue : '#888888')), BUTTON({
	              key: 'remove_opinion',
	              "aria-label": your_opinion_i18n.remove_opinion_button(),
	              "data-tooltip": your_opinion_i18n.remove_opinion_button(),
	              className: 'metadata-piece',
	              style: {
	                border: 'none',
	                verticalAlign: 'bottom',
	                marginBottom: '-3px',
	                marginLeft: '15px'
	              },
	              onClick: function() {
	                return remove_opinion(your_opinion);
	              }
	            }, iconX(YOUR_OPINION_BUTTON_SIZE, YOUR_OPINION_BUTTON_COLOR))
	          ] : void 0) : void 0
	        ];
	      }
	    }).call(this), is_closed ? SPAN({
	      style: {
	        position: 'relative',
	        top: 2
	      },
	      "data-tooltip": translator('engage.proposal_closed', 'Closed to new contributions.')
	    }, closedIcon({
	      size: 12,
	      fill: 'rgb(158, 35, 35)'
	    })) : read_only ? SPAN({
	      style: {
	        position: 'relative',
	        top: 2
	      },
	      "data-tooltip": translator("engage.proposal_read_only.short", 'read-only')
	    }, closedIcon({
	      size: 12,
	      fill: 'rgb(158, 78, 35)'
	    })) : void 0);
	  }
	});
	
	window.your_opinion_i18n = {
	  anonymize_proposal_button: function() {
	    return translator('engage.anonymize_proposal_button', 'Anonymize your proposal and opinion');
	  },
	  deanonymize_proposal_button: function() {
	    return translator('engage.deanonymize_proposal_button', 'Your proposal and opinion is anonymized');
	  },
	  anonymize_opinion_button: function() {
	    return translator('engage.anonymize_opinion_button', 'Anonymize your opinion and pro/con comments about this proposal.');
	  },
	  deanonymize_opinion_button: function() {
	    return translator('engage.deanonymize_opinion_button', 'Your opinion and pro/con comments are anonymized');
	  },
	  remove_opinion_button: function() {
	    return translator('engage.remove_opinion_button', 'Delete your opinion and pro/con comments about this proposal');
	  },
	  anon_assurance: function() {
	    return translator('engage.anon_assurance', 'anonymized to others');
	  },
	  anonymize: function() {
	    return translator('engage.anonymize', 'anonymize');
	  }
	};
	
	window.toggle_anonymize_opinion = function(your_opinion) {
	  var turn_off_anon, turn_on_anon;
	  turn_on_anon = translator("This will anonymize your whole opinion about the proposal, including your icon in \nthe histogram and all pros and cons you have written. Are you sure you wish to anonymize?");
	  turn_off_anon = translator("This will display your account name and avatar for your opinion, any pros and cons \nyou wrote, and any comments. Are you sure you wish to remove anonymization?");
	  if (your_opinion.hide_name || confirm(turn_on_anon)) {
	    your_opinion.hide_name = !your_opinion.hide_name;
	    return save(your_opinion);
	  }
	};
	
	window.remove_opinion = function(your_opinion) {
	  if (confirm(translator('This will remove your opinion about the proposal, including your icon in the histogram, and all the pros and cons and comments that you have written for this proposal. Are you sure you wish to remove?'))) {
	    your_opinion.stance = 0;
	    your_opinion.point_inclusions = [];
	    your_opinion.published = false;
	    return save(your_opinion);
	  }
	};
	
	window.getOpinionPrompt = function(arg) {
	  var discussion_enabled, no_opinion, perhaps_can_opinine, prefer_drag_prompt, proposal, ref, your_opinion;
	  proposal = arg.proposal, prefer_drag_prompt = arg.prefer_drag_prompt;
	  proposal = fetch(proposal);
	  perhaps_can_opinine = canUserOpine(proposal);
	  if (!(perhaps_can_opinine === Permission.NOT_LOGGED_IN || perhaps_can_opinine > 0)) {
	    return null;
	  }
	  your_opinion = proposal.your_opinion;
	  no_opinion = !fetch('/current_user').logged_in || !your_opinion.key;
	  discussion_enabled = customization('discussion_enabled', proposal, fetch('/subdomain'));
	  if (no_opinion || !discussion_enabled) {
	    if (!prefer_drag_prompt || !discussion_enabled) {
	      return translator("engage.give_your_opinion_button", 'Give your Opinion');
	    } else {
	      return translator("sliders.slide_prompt", 'Slide Your Overall Opinion');
	    }
	  } else if (((ref = your_opinion.point_inclusions) != null ? ref.length : void 0) > 0) {
	    return translator("engage.update_your_opinion_button", 'Update your Reasons');
	  } else {
	    return translator("engage.give_your_reasons_button", 'Give your Reasons');
	  }
	};
	
	styles += ".ItemText .proposal-metadata  {\n  margin-top: 8px;\n}\n\n\n.ItemText .proposal-metadata .separated {\n  padding-right: 0px;\n  margin-right: 14px;\n  font-weight: 400;\n}\n\n.ItemText .proposal-metadata .separated.give-your-opinion {\n  text-decoration: none;\n  background-color: #f7f7f7;\n  border-radius: 8px;\n  padding: 4px 10px;\n  border: 1px solid #eee;\n  box-shadow: 0 1px 1px rgba(160,160,160,.8);\n  white-space: nowrap;\n}\n\n\n.proposal-metadata .metadata-piece {\n  font-size: 12px;\n  color: #666;\n\n  padding: 0;\n  border-width: 0 0 1px 0;\n  background: transparent;\n  border-style: solid;\n  border-color: #aaa;\n  white-space: nowrap;\n  transition: border-color 1s;\n  cursor: pointer;\n  text-decoration: none;\n} \n.proposal-metadata .metadata-piece:hover,\n.proposal-metadata .metadata-piece:focus-within {\n  border-color: #444;\n}\n\n/* \n.proposal-metadata .small-give-your-opinion {\n  color: white;\n  background-color: " + (focus_color()) + ";\n  font-weight: 600;\n  cursor: pointer;\n  font-family: " + (customization('font')) + ";\n  border-radius: 8px;\n  padding: 4px 12px;\n  font-size: 10px;\n} */\n\n.is_expanded .proposal-metadata .small-give-your-opinion {\n  display: none;\n}\n\n";


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var AccessControlled, AccessDenied, Permission, matchEmail, matchSomeRole, permit,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(4);
	
	__webpack_require__(2);
	
	Permission = {
	  PERMITTED: 1,
	  DISABLED: -1,
	  UNVERIFIED_EMAIL: -2,
	  NOT_LOGGED_IN: -3,
	  INSUFFICIENT_INFORMATION: -5,
	  INSUFFICIENT_PRIVILEGES: -4
	};
	
	permit = function(action) {
	  var arg, can_add_to_list, comment, current_user, i, len, list_key, opinion, phase, point, proposal, subdomain;
	  subdomain = null;
	  for (i = 0, len = arguments.length; i < len; i++) {
	    arg = arguments[i];
	    if (arg.customizations) {
	      subdomain = arg;
	      break;
	    }
	  }
	  current_user = fetch('/current_user');
	  phase = customization('contribution_phase', null, subdomain);
	  if (phase === 'frozen' && (action !== 'read proposal' && action !== 'access forum' && action !== 'configure paid feature')) {
	    return Permission.DISABLED;
	  }
	  switch (action) {
	    case 'read proposal':
	    case 'access forum':
	      if (subdomain == null) {
	        subdomain = fetch('/subdomain');
	      }
	      if (!current_user.is_admin && !matchSomeRole(subdomain.roles, ['visitor'])) {
	        if (!current_user.logged_in) {
	          return Permission.NOT_LOGGED_IN;
	        } else {
	          return Permission.INSUFFICIENT_PRIVILEGES;
	        }
	      } else if (subdomain.roles.visitor.indexOf('*') === -1 && !current_user.verified) {
	        return Permission.UNVERIFIED_EMAIL;
	      }
	      break;
	    case 'create proposal':
	      if (subdomain == null) {
	        subdomain = fetch('/subdomain');
	      }
	      if (arguments[1]) {
	        list_key = arguments[1];
	        list_key = list_key.key || list_key;
	        if (!list_key.startsWith('list/')) {
	          list_key = "list/" + list_key;
	        }
	        can_add_to_list = customization('list_permit_new_items', list_key, subdomain);
	      } else {
	        can_add_to_list = true;
	      }
	      if (phase === 'opinions-only') {
	        can_add_to_list = false;
	      }
	      if (!current_user.is_admin && (!matchEmail(subdomain.roles.proposer) || !can_add_to_list)) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      break;
	    case 'update proposal':
	    case 'delete proposal':
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      proposal = fetch(arguments[1]);
	      if (!current_user.is_admin && (proposal.key === 'new_proposal' || !matchEmail(proposal.roles.editor))) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'publish opinion':
	      proposal = fetch(arguments[1]);
	      if (phase === 'ideas-only') {
	        return Permission.DISABLED;
	      }
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'participant'])) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      if (!current_user.completed_host_questions) {
	        return Permission.INSUFFICIENT_INFORMATION;
	      }
	      break;
	    case 'update opinion':
	      proposal = fetch(arguments[1]);
	      if (!arguments[2]) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      opinion = fetch(arguments[2]);
	      if (opinion.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'create point':
	      proposal = fetch(arguments[1]);
	      if (phase === 'ideas-only' || !proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'participant'])) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'update point':
	      point = fetch(arguments[1]);
	      if (!current_user.is_admin && point.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'delete point':
	      point = fetch(arguments[1]);
	      if (!current_user.is_admin) {
	        if (point.user !== fetch('/current_user').user) {
	          return Permission.INSUFFICIENT_PRIVILEGES;
	        }
	        if (point.includers.length > 1 || (point.includers.length === 1 && point.includers[0] !== current_user.user)) {
	          return Permission.DISABLED;
	        }
	      }
	      break;
	    case 'create comment':
	      proposal = fetch(arguments[1]);
	      if (phase === 'ideas-only') {
	        return Permission.DISABLED;
	      }
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'participant'])) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'update comment':
	      comment = fetch(arguments[1]);
	      if (!current_user.is_admin && comment.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'configure paid feature':
	      if (subdomain == null) {
	        subdomain = fetch('/subdomain');
	      }
	      if (!((current_user.is_admin && subdomain.plan) || current_user.is_super_admin)) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    default:
	      console.error("Unrecognized action to permit: " + action);
	  }
	  return Permission.PERMITTED;
	};
	
	matchEmail = function(permission_list) {
	  var allowed_domain, email_or_key, i, len, ref, ref1, user;
	  user = fetch('/current_user');
	  if (indexOf.call(permission_list, '*') >= 0) {
	    return true;
	  }
	  if (ref = user.user, indexOf.call(permission_list, ref) >= 0) {
	    return true;
	  }
	  if (ref1 = user.email, indexOf.call(permission_list, ref1) >= 0) {
	    return true;
	  }
	  for (i = 0, len = permission_list.length; i < len; i++) {
	    email_or_key = permission_list[i];
	    if (email_or_key.indexOf('*') > -1) {
	      if (user.email) {
	        allowed_domain = email_or_key.split('@')[1];
	        if (user.email.split('@')[1] === allowed_domain) {
	          return true;
	        }
	      }
	    }
	  }
	  return false;
	};
	
	matchSomeRole = function(roles, accepted_roles) {
	  var i, len, role;
	  for (i = 0, len = accepted_roles.length; i < len; i++) {
	    role = accepted_roles[i];
	    if (matchEmail(roles[role])) {
	      return true;
	    }
	  }
	  return false;
	};
	
	window.recourse = function(permission, goal) {
	  var auth, current_user, loc;
	  loc = fetch('location');
	  auth = fetch('auth');
	  if (goal == null) {
	    goal = "To access this " + (is_a_dialogue_page() ? 'forum' : 'page') + ",";
	  }
	  switch (permission) {
	    case Permission.INSUFFICIENT_PRIVILEGES:
	      if (loc.url !== '/') {
	        return loadPage('/');
	      }
	      break;
	    case Permission.NOT_LOGGED_IN:
	      if (!auth.form) {
	        return reset_key('auth', {
	          form: 'login',
	          goal: goal + " please introduce yourself below"
	        });
	      }
	      break;
	    case Permission.UNVERIFIED_EMAIL:
	      if (auth.form !== 'verify email') {
	        reset_key('auth', {
	          form: 'verify email',
	          goal: goal + " please demonstrate you control this email."
	        });
	        current_user = fetch('/current_user');
	        current_user.trying_to = 'send_verification_token';
	        return save(current_user);
	      }
	  }
	};
	
	AccessControlled = {
	  accessGranted: function() {
	    var access_attrs, current_user, local_but_not_component_unique, page, permission_denied;
	    current_user = fetch('/current_user');
	    page = get_page();
	    local_but_not_component_unique = fetch("local-" + page.key);
	    access_attrs = ['verified', 'logged_in', 'email'];
	    permission_denied = page.permission_denied;
	    if (local_but_not_component_unique._last_current_user && permission_denied) {
	      if (this._relevant_current_user_values_have_changed(access_attrs)) {
	        delete page.permission_denied;
	        arest.serverFetch(page.key);
	      }
	    }
	    if (permission_denied && permission_denied < 0) {
	      recourse(permission_denied);
	    }
	    if (this._relevant_current_user_values_have_changed(access_attrs)) {
	      local_but_not_component_unique._last_current_user = _.map(access_attrs, function(attr) {
	        return current_user[attr];
	      });
	      save(local_but_not_component_unique);
	    }
	    return !permission_denied || permission_denied > 0;
	  },
	  _relevant_current_user_values_have_changed: function(access_attrs) {
	    var current_user, el, i, idx, last_values, len, reduced_user;
	    current_user = fetch('/current_user');
	    last_values = fetch("local-" + (get_page().key));
	    reduced_user = _.map(access_attrs, function(attr) {
	      return current_user[attr];
	    });
	    for (idx = i = 0, len = reduced_user.length; i < len; idx = ++i) {
	      el = reduced_user[idx];
	      if (!last_values._last_current_user || el !== last_values._last_current_user[idx]) {
	        return true;
	      }
	    }
	    return false;
	  }
	};
	
	AccessDenied = function() {
	  var user;
	  user = fetch('/current_user');
	  return DIV({
	    style: {
	      position: 'relative',
	      padding: 50
	    }
	  }, ProfileMenu(), DIV({
	    style: {
	      width: HOMEPAGE_WIDTH(),
	      margin: 'auto',
	      padding: '50px 100px',
	      backgroundColor: focus_color(),
	      color: 'white',
	      fontSize: 22
	    }
	  }, H1({
	    style: {
	      fontSize: 36,
	      color: 'white',
	      paddingBottom: 40
	    }
	  }, TRANSLATE({
	    id: "permissions.access_denied",
	    email: user.email
	  }, "We're sorry, but {email} doesn't have access to this private forum.")), DIV(null, TRANSLATE({
	    id: "permissions.access_denied.recourse"
	  }, "If you think you should have access, please contact the person who invited you. \nSometimes they will have granted access to a different email address. You will \neither have to create an account using that other email address, or the forum \nadministrator will have to grant this email address access.")), DIV({
	    style: {
	      marginTop: 40
	    }
	  }, TRANSLATE({
	    id: "permissions.contact_for_help",
	    link: {
	      component: A,
	      args: {
	        href: 'mailto:support@consider.it?subject=I am having trouble accessing a private forum',
	        style: {
	          textDecoration: 'underline'
	        }
	      }
	    }
	  }, "Contact us at <link>support@consider.it</link> if you need help."))));
	};
	
	window.AccessControlled = AccessControlled;
	
	window.permit = permit;
	
	window.Permission = Permission;
	
	window.AccessDenied = AccessDenied;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var GroupSelectionRegion, buildPointsList, points_for_proposal, stored_points_order,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(21);
	
	__webpack_require__(3);
	
	__webpack_require__(17);
	
	__webpack_require__(25);
	
	window.CRAFTING_TRANSITION_SPEED = 700;
	
	fetch('decisionboard', {
	  docked: false
	});
	
	window.get_selected_point = function() {
	  return fetch('location').query_params.selected;
	};
	
	window.getProposalMode = function(proposal) {
	  var local_state;
	  local_state = fetch(shared_local_key(proposal));
	  return local_state.mode;
	};
	
	window.update_proposal_mode = function(proposal, proposal_mode, triggered_by) {
	  var can_opine, local_state;
	  can_opine = canUserOpine(proposal);
	  proposal = fetch(proposal);
	  if (proposal_mode === 'crafting' && !((can_opine === Permission.PERMITTED || can_opine === Permission.UNVERIFIED_EMAIL || can_opine === Permission.NOT_LOGGED_IN || can_opine === Permission.INSUFFICIENT_INFORMATION) || (can_opine === Permission.DISABLED && your_opinion.key))) {
	    proposal_mode = 'results';
	  }
	  local_state = fetch(shared_local_key(proposal));
	  if (local_state.mode !== proposal_mode) {
	    local_state.mode = proposal_mode;
	    return save(local_state);
	  }
	};
	
	responsive_style_registry.push(function(responsive_vars) {
	  var content_width, decision_board_width, doc_gutter, phone_size, w, whitespace;
	  content_width = responsive_vars.CONTENT_WIDTH;
	  doc_gutter = responsive_vars.DOC_GUTTER;
	  w = responsive_vars.WINDOW_WIDTH;
	  phone_size = responsive_vars.PHONE_SIZE;
	  whitespace = Math.max(100, w / 10);
	  decision_board_width = Math.min(700, content_width - 2 * doc_gutter - 2 * whitespace + 4);
	  return {
	    DECISION_BOARD_WIDTH: decision_board_width,
	    POINT_FONT_SIZE: phone_size ? 14 : 15
	  };
	});
	
	styles += ".slow-thought {\n}\n\n@media " + LAPTOP_MEDIA + " {\n  .slow-thought {\n    --POINT_COLUMN_MARGIN: 16px;\n    --SLOW_WHITESPACE: max(100px, 10vw);\n    --DECISION_BOARD_WIDTH: min(700px, var(--BODY_WIDTH) + 4px);\n    --REASONS_AREA_WIDTH: calc( var(--OPINION_BLOCK_WRAPPER_WIDTH) );\n    --REASONS_AREA_LEFT: calc(  (var(--HOMEPAGE_WIDTH) + var(--LIST_PADDING_RIGHT) + var(--LIST_PADDING_LEFT) - var(--REASONS_AREA_WIDTH)) / 2   );               \n  }\n\n  .results .slow-thought {\n    --BODY_WIDTH: calc(2 * var(--ITEM_OPINION_WIDTH));\n    --POINT_WIDTH: calc(var(--BODY_WIDTH) / 2 - 2 * var(--POINT_COLUMN_MARGIN) );    \n  }\n\n  .crafting .slow-thought {\n    --BODY_WIDTH: calc(var(--CONTENT_WIDTH) - 2 * var(--DOC_GUTTER) - 2 * var(--SLOW_WHITESPACE));\n    --POINT_WIDTH: calc(var(--DECISION_BOARD_WIDTH) / 2 - 30px);\n  }\n\n  .crafting .points_by_community {\n    --POINT_WIDTH: calc( ( var(--OPINION_BLOCK_WRAPPER_WIDTH) - var(--DECISION_BOARD_WIDTH)) / 2 - 5 * var(--POINT_COLUMN_MARGIN)  );\n  }\n\n}\n\n\n@media " + TABLET_MEDIA + " {\n  .slow-thought {\n    --POINT_COLUMN_MARGIN: 9px;\n    --BODY_WIDTH: var(--ITEM_OPINION_WIDTH);      \n    --POINT_WIDTH: calc(var(--BODY_WIDTH) / 2 - 2 * var(--POINT_COLUMN_MARGIN) );\n  }\n}\n\n@media " + PHONE_MEDIA + " {\n\n  .slow-thought {\n    --POINT_COLUMN_MARGIN: 6px;      \n    --BODY_WIDTH: calc(100vw - 2 * var(--POINT_COLUMN_MARGIN));\n    --POINT_WIDTH: calc(var(--BODY_WIDTH) / 2 - 1 * var(--POINT_COLUMN_MARGIN) );\n  }\n}\n\n";
	
	styles += "\n.slow-thought {\n  position: relative;\n  z-index: 1;\n  opacity: 1;        \n}\n\n:not(.expanding).is_expanded .slow-thought {\n  transition: opacity " + ANIMATION_SPEED_ITEM_EXPANSION + "s linear " + STAGE1_DELAY + "s;    \n  opacity: 1;\n}\n\n.reasons_region {\n  position: relative;\n  padding-bottom: 4em; /* padding instead of margin for docking */\n  display: flex; \n  align-items: center;\n  flex-direction: column;\n}\n\n@media " + LAPTOP_MEDIA + " {\n  width: var(--REASONS_AREA_WIDTH);\n  left: var(--REASONS_AREA_LEFT);\n  transition: width " + CRAFTING_TRANSITION_SPEED + "ms, left " + CRAFTING_TRANSITION_SPEED + "ms;    \n}\n\n.points_by_community {\n  display: inline-block;\n  vertical-align: top;\n  margin-top: 38px;\n  padding: 0 var(--POINT_COLUMN_MARGIN) 0 var(--POINT_COLUMN_MARGIN);\n  position: relative;\n}\n\n\n@media " + PHONE_MEDIA + " {\n  .pros_by_community {\n    padding-right: 0;\n  }\n\n  .cons_by_community {\n    padding-left: 0;\n  }\n\n}\n\n.points_heading_label {\n  font-size: 27px;\n  text-align: center;\n  padding-bottom: 24px;\n  padding-top: 7px;\n\n}\n\n@media " + TABLET_MEDIA + " {\n  .points_heading_label {\n    font-size: 24px;\n  }\n}\n\n@media " + PHONE_MEDIA + " {\n  .points_heading_label {\n    font-size: 22px;\n  }\n}\n\n\n.points_by_community .points_heading_label {\n  font-weight: 400;\n  position: relative;\n}\n\n.DecisionBoard .points_heading_label {\n  color: " + (focus_color()) + ";\n  font-weight: 700;\n}\n\n\n.points_by_community .points_heading_label, .empty-list-callout, .reasons_region .point, .give_a_point {\n  opacity: 0;\n}\n\n:not(.expanding).is_expanded .points_by_community .points_heading_label, :not(.expanding).is_expanded .empty-list-callout, :not(.expanding).is_expanded .reasons_region .point, :not(.expanding).is_expanded .give_a_point {\n  transition: opacity " + ANIMATION_SPEED_ITEM_EXPANSION + "s ease " + STAGE1_DELAY + "s;    \n  opacity: 1;\n}\n\n\n/* for collapsed => summary transition */\n:not(.expanding).is_expanded .reasons_region :nth-child(1).point {\n  transition-delay: " + STAGE1_DELAY + "s;\n}\n\n:not(.expanding).is_expanded .reasons_region :nth-child(2).point {\n  transition-delay: " + (STAGE1_DELAY + 1 * ANIMATION_SPEED_ITEM_EXPANSION) + "s;\n}\n\n:not(.expanding).is_expanded .reasons_region :nth-child(3).point {\n  transition-delay: " + (STAGE1_DELAY + 1.5 * ANIMATION_SPEED_ITEM_EXPANSION) + "s;\n}\n\n:not(.expanding).is_expanded .reasons_region .point {\n  transition-delay: " + (STAGE1_DELAY + 2 * ANIMATION_SPEED_ITEM_EXPANSION) + "s;\n}\n\n\n\n\n\n\n\n.slow-thought .DecisionBoard {\n  opacity: 0;        \n}\n\n:not(.expanding).is_expanded .slow-thought .DecisionBoard {\n  opacity: 1;\n  transition-property: opacity; \n  transition-timing-function: ease;    \n  transition-duration: " + (3 * ANIMATION_SPEED_ITEM_EXPANSION) + "s;\n  transition-delay: 0; \n}\n\n:not(.expanding).is_expanded .slow-thought.summary .DecisionBoard {\n  transition-delay: " + STAGE2_DELAY + "s;    \n}\n";
	
	window.Reasons = ReactiveComponent({
	  displayName: "Reasons",
	  render: function() {
	    var adjustments, can_opine, col, community_points, current_user, draw_handle, edit_mode, has_community_points, has_focus, has_selection, i, included_points, just_you, len, local_proposal, minheight, mode, opinion_views, pc, pnt, point_cols, proposal, ref, show_all_points, your_opinion;
	    current_user = fetch('/current_user');
	    proposal = fetch(this.props.proposal);
	    your_opinion = proposal.your_opinion;
	    if (your_opinion.key) {
	      fetch(your_opinion);
	    }
	    opinion_views = fetch('opinion_views');
	    just_you = opinion_views != null ? opinion_views.active_views['just_you'] : void 0;
	    adjustments = fetch('reasons_height_adjustment');
	    minheight = 100 + (adjustments.opinion_region_height || 0);
	    if (get_selected_point()) {
	      minheight += adjustments.open_point_height || 0;
	    }
	    if (adjustments.edit_point_height) {
	      minheight += adjustments.edit_point_height || 0;
	    }
	    can_opine = canUserOpine(proposal);
	    draw_handle = can_opine !== Permission.INSUFFICIENT_PRIVILEGES && (can_opine !== Permission.DISABLED || your_opinion.published) && !(!current_user.logged_in && indexOf.call(proposal.roles.participant, '*') < 0);
	    mode = getProposalMode(proposal);
	    community_points = (function() {
	      var i, len, ref, ref1, results;
	      ref = fetch("/page/" + proposal.slug).points || [];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        pnt = ref[i];
	        if (((ref1 = pnt.includers) != null ? ref1.length : void 0) > 0) {
	          results.push(pnt);
	        }
	      }
	      return results;
	    })();
	    if (mode === 'crafting') {
	      included_points = your_opinion.point_inclusions || [];
	      community_points = (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = community_points.length; i < len; i++) {
	          pnt = community_points[i];
	          if (!_.contains(included_points, pnt.key)) {
	            results.push(pnt);
	          }
	        }
	        return results;
	      })();
	    }
	    has_community_points = community_points.length > 0;
	    if (get_selected_point() && !this.local.show_all_points) {
	      this.local.show_all_points = true;
	      save(this.local);
	    }
	    has_selection = opinion_views.active_views.single_opinion_selected || opinion_views.active_views.region_selected;
	    show_all_points = this.local.show_all_points || mode === 'crafting' || community_points.length < 8 || has_selection;
	    point_cols = ['your_con_points', 'your_pro_points', 'community_cons', 'community_pros'];
	    edit_mode = false;
	    for (i = 0, len = point_cols.length; i < len; i++) {
	      pc = point_cols[i];
	      col = fetch(pc);
	      if (col.adding_new_point || ((ref = col.editing_points) != null ? ref.length : void 0) > 0) {
	        edit_mode = pc;
	        break;
	      }
	    }
	    local_proposal = fetch(shared_local_key(proposal));
	    has_focus = get_selected_point() ? 'point' : edit_mode ? 'edit point' : "opinion";
	    if (local_proposal.has_focus !== has_focus) {
	      local_proposal.has_focus = has_focus;
	      save(local_proposal);
	    }
	    return DIV({
	      className: "slow-thought " + (mode === 'crafting' ? 'crafting' : 'summary'),
	      style: {
	        position: 'relative',
	        top: -8,
	        minHeight: mode === 'crafting' ? 440 : 220
	      },
	      "data-receive-viewport-visibility-updates": 1,
	      "data-visibility-name": "reasons",
	      "data-component": this.local.key
	    }, SECTION({
	      className: "reasons_region",
	      style: {
	        minHeight: show_all_points ? minheight : void 0,
	        padding: (draw_handle && !TABLET_SIZE() ? '24px' : '0') + " 0 0 0",
	        display: !customization('discussion_enabled', proposal) ? 'none' : void 0,
	        overflowY: !show_all_points ? 'hidden' : void 0,
	        overflowX: !show_all_points ? 'auto' : void 0
	      }
	    }, H2({
	      className: 'hidden'
	    }, translator({
	      id: "engage.reasons_section_explanation"
	    }, 'Why people think what they do about the proposal')), this.props.is_expanded ? GroupSelectionRegion({
	      proposal: this.props.proposal
	    }) : void 0, !TABLET_SIZE() && customization('discussion_enabled', proposal) ? Dock({
	      key: 'decisionboard-dock',
	      dock_key: 'decisionboard-dock',
	      docked_key: 'decisionboard',
	      constraints: ['slider-dock'],
	      dock_on_zoomed_screens: true,
	      dockable: (function(_this) {
	        return function() {
	          return _this.props.is_expanded && mode === 'crafting' && can_opine > 0;
	        };
	      })(this),
	      dummy: this.props.is_expanded,
	      dummy2: WINDOW_WIDTH(),
	      dummy3: mode,
	      dummy4: can_opine,
	      start: 0,
	      stop: function() {
	        var reasons_region;
	        reasons_region = document.querySelector('.reasons_region');
	        return $$.offset(reasons_region).top + reasons_region.offsetHeight - 20;
	      },
	      style: {
	        position: 'absolute',
	        width: DECISION_BOARD_WIDTH(),
	        zIndex: 2,
	        display: 'inline-block',
	        verticalAlign: 'top',
	        left: '50%',
	        marginLeft: -DECISION_BOARD_WIDTH() / 2
	      }
	    }, DecisionBoard({
	      key: 'decisionboard',
	      proposal: proposal.key
	    })) : void 0, DIV({
	      style: {
	        height: !show_all_points ? 750 : void 0
	      }
	    }, PointsList({
	      key: 'community_cons',
	      proposal: proposal.key,
	      reasons_key: 'community_cons',
	      rendered_as: 'community_point',
	      points_editable: TABLET_SIZE(),
	      valence: 'cons',
	      points_draggable: mode === 'crafting',
	      drop_target: false,
	      points: buildPointsList(proposal, 'cons', (mode === 'results' ? 'score' : 'last_inclusion'), mode === 'crafting' && !TABLET_SIZE(), mode === 'crafting' || TABLET_SIZE() || (just_you && mode === 'results')),
	      style: {
	        visibility: !TABLET_SIZE() && mode === 'crafting' && !has_community_points ? 'hidden' : void 0
	      },
	      in_viewport: this.local.in_viewport
	    }), PointsList({
	      key: 'community_pros',
	      proposal: proposal.key,
	      reasons_key: 'community_pros',
	      rendered_as: 'community_point',
	      points_editable: TABLET_SIZE(),
	      valence: 'pros',
	      points_draggable: mode === 'crafting',
	      drop_target: false,
	      points: buildPointsList(proposal, 'pros', (mode === 'results' ? 'score' : 'last_inclusion'), mode === 'crafting' && !TABLET_SIZE(), mode === 'crafting' || TABLET_SIZE() || (just_you && mode === 'results')),
	      style: {
	        visibility: !TABLET_SIZE() && mode === 'crafting' && !has_community_points ? 'hidden' : void 0
	      },
	      in_viewport: this.local.in_viewport
	    }))), !show_all_points ? BUTTON({
	      id: "show_all_reasons",
	      style: {
	        backgroundColor: "#eee",
	        padding: '12px 0',
	        fontSize: 24,
	        textAlign: 'center',
	        textDecoration: 'underline',
	        border: 'none',
	        cursor: 'pointer',
	        display: 'block',
	        width: "var(--BODY_WIDTH)",
	        margin: 'auto',
	        position: 'relative',
	        zIndex: 1
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_all_points = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, TRANSLATE({
	      id: "engage.show_all_thoughts"
	    }, "Show All Reasons")) : void 0);
	  }
	});
	
	styles += "\n.save_opinion_button {\n  display: none;\n  background-color: " + (focus_color()) + ";\n  width: 100%;\n  margin-top: 14px;\n  border-radius: 16px;\n  font-size: 24px;\n}        \n\n.crafting .save_opinion_button {\n  display: block;\n}    \n\n.summary .give_opinion_button {\n  background-color: " + (focus_color()) + ";\n  display: block;\n  color: white;\n  padding: .25em 18px;\n  margin: 0;\n  font-size: 16px;\n  width: 100%;\n  border-radius: 16px;\n  box-shadow: none;\n}\n\n.crafting .give_opinion_button {\n  visibility: hidden;\n}\n\n\n.DecisionBoard.transitioning .give_opinion_button {\n  visibility: hidden;\n}\n.DecisionBoard.transitioning .your_points, .DecisionBoard.transitioning .save_opinion_button, .DecisionBoard.transitioning .below_save {\n  display: none;\n}\n\n.below_save {  text-align:center;  }\n.below_save .btn {\n  margin: 10px;\n  border: solid 1px #ddd;\n  border-radius: 15px;\n  font-weight: lighter;\n  font-size: 0.9em;\n  background-color: #eee;\n  color: black;\n}\n.below_save .btn svg {  margin-left:20px;  }\n\n\n.decision_board_body {\n  border-radius: 16px;\n  border-style: dashed;\n  border-width: 3px;\n}\n\n.crafting .decision_board_body {\n  transform: translate(0, 10px);\n  background-color: white;\n}\n\n.results .decision_board_body {\n  border-style: solid;\n  background-color: " + (focus_color()) + ";\n  cursor: pointer;\n  min-height: 32px;\n}\n\n\n/* Drag & drop styles */\n.community-point-is-being-dragged .decision_board_body {\n  border-style: solid;\n}\n\n.DecisionBoard [data-widget=\"SliderBubblemouth\"] path {\n  stroke-dasharray: 25, 10;\n}\n\n.community-point-is-being-dragged .DecisionBoard [data-widget=\"SliderBubblemouth\"] path {\n  stroke-dasharray: none;\n}\n\n";
	
	window.DecisionBoard = ReactiveComponent({
	  displayName: 'DecisionBoard',
	  render: function() {
	    var YOUR_OPINION_BUTTON_SIZE, anonymize_button_text, anonymize_button_tooltip, are_points_in_wings, can_opine, current_user, decision_board_style, enable_opining, give_opinion_button_width, has_selection, included_points, mode, opinion_prompt, opinion_region_x, opinion_views, p, pnt, proposal, register_dependency, slider, subdomain, wing_points, your_opinion;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    proposal = fetch(this.props.proposal);
	    your_opinion = proposal.your_opinion;
	    if (your_opinion.key) {
	      fetch(your_opinion);
	    }
	    YOUR_OPINION_BUTTON_SIZE = 18;
	    can_opine = canUserOpine(proposal);
	    opinion_views = fetch('opinion_views');
	    has_selection = opinion_views.active_views.single_opinion_selected || opinion_views.active_views.region_selected;
	    enable_opining = can_opine !== Permission.INSUFFICIENT_PRIVILEGES && (can_opine !== Permission.DISABLED || your_opinion.published) && !has_selection && !(!current_user.logged_in && indexOf.call(proposal.roles.participant, '*') < 0);
	    if (!enable_opining) {
	      return DIV(null);
	    }
	    register_dependency = fetch(namespaced_key('slider', proposal)).value;
	    wing_points = fetch("/page/" + proposal.slug).points || [];
	    included_points = your_opinion.point_inclusions || [];
	    wing_points = (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = wing_points.length; i < len; i++) {
	        pnt = wing_points[i];
	        if (!_.contains(included_points, pnt.key)) {
	          results.push(pnt);
	        }
	      }
	      return results;
	    })();
	    are_points_in_wings = wing_points.length > 0;
	    mode = getProposalMode(proposal);
	    decision_board_style = {
	      borderColor: focus_color(),
	      transition: this.last_proposal_mode !== mode || this.transitioning ? ("transform " + CRAFTING_TRANSITION_SPEED + "ms, ") + ("width " + CRAFTING_TRANSITION_SPEED + "ms, ") + ("min-height " + CRAFTING_TRANSITION_SPEED + "ms") : 'none'
	    };
	    if (mode === 'results') {
	      give_opinion_button_width = 232;
	      slider = fetch(namespaced_key('slider', proposal));
	      opinion_region_x = get_opinion_x_pos_projection({
	        slider_val: slider.value,
	        from_width: ITEM_OPINION_WIDTH() * (!TABLET_SIZE() ? 2 : 1),
	        to_width: DECISION_BOARD_WIDTH(),
	        x_min: 60,
	        x_max: 60
	      });
	      _.extend(decision_board_style, {
	        transform: "translate(" + (opinion_region_x - give_opinion_button_width / 2) + "px, -10px)",
	        width: give_opinion_button_width
	      });
	    } else {
	      _.extend(decision_board_style, {
	        minHeight: are_points_in_wings ? 275 : 170,
	        width: DECISION_BOARD_WIDTH()
	      });
	    }
	    opinion_prompt = getOpinionPrompt({
	      proposal: proposal
	    });
	    return SECTION({
	      ref: 'DecisionBoard',
	      className: 'DecisionBoard',
	      style: {
	        width: DECISION_BOARD_WIDTH()
	      }
	    }, H3({
	      className: 'hidden',
	      style: {
	        display: !TABLET_SIZE() && mode === 'results' ? 'none' : void 0
	      }
	    }, translator({
	      id: "engage.opinion_crafting_explanation",
	      proposal_name: proposal.name
	    }, "Craft your opinion using pros and cons about {proposal_name}")), SliderBubblemouth({
	      proposal: proposal.key,
	      width: 34,
	      height: 24,
	      top: -24 + 18 + 3
	    }), DIV({
	      'aria-live': 'polite',
	      key: 'body',
	      className: 'decision_board_body',
	      style: decision_board_style,
	      onClick: (function(_this) {
	        return function() {
	          if (mode === 'results') {
	            can_opine = canUserOpine(proposal);
	            if (can_opine > 0) {
	              return update_proposal_mode(proposal, 'crafting', 'give_opinion_button');
	            } else {
	              return reset_key('auth', {
	                form: 'create account',
	                goal: 'To participate, please introduce yourself.',
	                after: function() {
	                  can_opine = canUserOpine(proposal);
	                  if (can_opine > 0) {
	                    return update_proposal_mode(proposal, 'crafting', 'give_opinion_button');
	                  }
	                }
	              });
	            }
	          }
	        };
	      })(this)
	    }, DIV(null, mode === 'crafting' ? DIV({
	      className: 'your_points',
	      style: {
	        padding: '0 18px',
	        marginTop: -3
	      }
	    }, PointsList({
	      key: 'your_pro_points',
	      proposal: proposal.key,
	      reasons_key: 'your_pro_points',
	      valence: 'pros',
	      rendered_as: 'decision_board_point',
	      points_editable: true,
	      points_draggable: true,
	      drop_target: are_points_in_wings,
	      points: (function() {
	        var i, len, ref, results;
	        ref = your_opinion.point_inclusions || [];
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          p = ref[i];
	          if (fetch(p).is_pro) {
	            results.push(p);
	          }
	        }
	        return results;
	      })()
	    }), PointsList({
	      key: 'your_con_points',
	      proposal: proposal.key,
	      reasons_key: 'your_con_points',
	      valence: 'cons',
	      rendered_as: 'decision_board_point',
	      points_editable: true,
	      points_draggable: true,
	      drop_target: are_points_in_wings,
	      points: (function() {
	        var i, len, ref, results;
	        ref = your_opinion.point_inclusions || [];
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          p = ref[i];
	          if (!fetch(p).is_pro) {
	            results.push(p);
	          }
	        }
	        return results;
	      })()
	    }), DIV({
	      style: {
	        clear: 'both'
	      }
	    })) : void 0, opinion_prompt ? BUTTON({
	      className: 'give_opinion_button btn',
	      onClick: (function(_this) {
	        return function(e) {
	          if (mode !== 'results') {
	            e.stopPropagation();
	            return update_proposal_mode(proposal, 'crafting', 'give_opinion_button');
	          }
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            if (mode !== 'results') {
	              e.stopPropagation();
	              return update_proposal_mode(proposal, 'crafting', 'give_opinion_button');
	            }
	          }
	        };
	      })(this)
	    }, opinion_prompt) : void 0)), DIV({
	      key: 'footer',
	      style: {
	        width: DECISION_BOARD_WIDTH()
	      }
	    }, BUTTON({
	      className: 'save_opinion_button btn',
	      onClick: (function(_this) {
	        return function() {
	          return update_proposal_mode(proposal, 'results', 'save_button');
	        };
	      })(this),
	      'aria-label': translator('engage.update_opinion_button', 'Show everyone\'s opinion')
	    }, translator('engage.update_opinion_button', 'Show everyone\'s opinion')), !your_opinion.key || (your_opinion.key && permit('update opinion', proposal, your_opinion) < 0) ? DIV({
	      className: 'below_save',
	      style: {
	        display: 'none'
	      }
	    }, BUTTON({
	      className: 'cancel_opinion_button primary_cancel_button',
	      onClick: (function(_this) {
	        return function() {
	          return update_proposal_mode(proposal, 'results', 'cancel_button');
	        };
	      })(this)
	    })) : void 0, your_opinion.key && permit('update opinion', proposal, your_opinion) > 0 && mode === 'crafting' ? (your_opinion.hide_name ? (anonymize_button_tooltip = your_opinion_i18n.deanonymize_opinion_button(), anonymize_button_text = your_opinion_i18n.anon_assurance()) : (anonymize_button_tooltip = your_opinion_i18n.anonymize_opinion_button(), anonymize_button_text = your_opinion_i18n.anonymize()), DIV({
	      className: 'below_save',
	      style: {
	        display: customization('anonymize_permanently') ? 'flex' : void 0,
	        justifyContent: customization('anonymize_permanently') ? 'center' : void 0
	      }
	    }, DIV({
	      style: {
	        textAlign: 'center',
	        color: '#383838',
	        margin: "16px 0 4px 0",
	        fontSize: 14,
	        fontWeight: 300
	      }
	    }, translator('engage.below_save_opinion_buttons', 'Your opinion and comments about this proposal:')), DIV(null, BUTTON({
	      key: 'anonymize opinion button',
	      className: 'btn',
	      style: {
	        backgroundColor: (your_opinion.hide_name ? focus_blue : null),
	        display: customization('anonymize_permanently') ? 'none' : void 0
	      },
	      "data-tooltip": anonymize_button_tooltip,
	      "aria-label": anonymize_button_tooltip,
	      onClick: function() {
	        return toggle_anonymize_opinion(your_opinion);
	      }
	    }, SPAN({
	      key: 'anonymize opinion label',
	      style: {
	        textTransform: 'capitalize',
	        color: your_opinion.hide_name ? 'white' : void 0,
	        fontWeight: your_opinion.hide_name ? 600 : void 0
	      }
	    }, anonymize_button_text), !TABLET_SIZE() ? SPAN({
	      key: 'anonymize opinion icon',
	      style: {
	        height: '22px',
	        display: 'inline-block',
	        verticalAlign: 'bottom'
	      }
	    }, iconAnonymousMask(YOUR_OPINION_BUTTON_SIZE, your_opinion.hide_name ? '#FFFFFF' : '#888888')) : void 0), BUTTON({
	      key: 'remove opinion button',
	      className: 'btn',
	      "data-tooltip": your_opinion_i18n.remove_opinion_button(),
	      "aria-label": your_opinion_i18n.remove_opinion_button(),
	      onClick: function() {
	        return remove_opinion(your_opinion);
	      }
	    }, SPAN({
	      key: 'remove opinion label',
	      style: {
	        textTransform: 'capitalize'
	      }
	    }, translator('engage.delete_button', 'delete')), !TABLET_SIZE() ? SPAN({
	      key: 'remove opinion icon',
	      style: {
	        height: '20px',
	        display: 'inline-block',
	        verticalAlign: 'bottom'
	      }
	    }, iconX(YOUR_OPINION_BUTTON_SIZE, '#444444')) : void 0)))) : void 0));
	  },
	  componentDidUpdate: function() {
	    return this.transition();
	  },
	  componentDidMount: function() {
	    return this.transition();
	  },
	  componentWillUnmount: function() {
	    return this.dismounting = true;
	  },
	  update_reasons_height: function() {
	    var h, s;
	    s = fetch('reasons_height_adjustment');
	    h = $$.height(ReactDOM.findDOMNode(this));
	    if (h !== s.opinion_region_height) {
	      s.opinion_region_height = h;
	      return save(s);
	    }
	  },
	  transition: function() {
	    var mode, speed;
	    if (this.is_waiting()) {
	      return;
	    }
	    speed = !this.last_proposal_mode ? 0 : CRAFTING_TRANSITION_SPEED;
	    mode = getProposalMode(this.props.proposal);
	    if (this.last_proposal_mode !== mode) {
	      if (speed > 0) {
	        this.transitioning = true;
	        this.refs.DecisionBoard.classList.add('transitioning');
	        _.delay((function(_this) {
	          return function() {
	            if (!_this.dismounting) {
	              _this.transitioning = false;
	              _this.refs.DecisionBoard.classList.remove('transitioning');
	              return _this.update_reasons_height();
	            }
	          };
	        })(this), speed + 200);
	      } else if (!this.transitioning) {
	        this.update_reasons_height();
	      }
	      return this.last_proposal_mode = mode;
	    }
	  }
	});
	
	points_for_proposal = function(proposal) {
	  return fetch("/page/" + proposal.slug).points || [];
	};
	
	stored_points_order = {};
	
	buildPointsList = function(proposal, valence, sort_field, filter_included, show_all_points) {
	  var active_views, filtered, groups, i, included_points, j, key, len, len1, o, opinion_views, opinions, pnt, point, point_inclusions_per_point, points, ref, results, salience, sort, sort_key, view, weights;
	  if (!proposal.slug) {
	    return [];
	  }
	  sort_field = sort_field || 'score';
	  points = points_for_proposal(proposal);
	  opinions = fetch(proposal).opinions;
	  if (!show_all_points) {
	    filtered = true;
	    opinions = get_opinions_for_proposal(opinions, proposal);
	  }
	  if (typeof running_timelapse_simulation !== "undefined" && running_timelapse_simulation !== null) {
	    opinions = (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = opinions.length; i < len; i++) {
	        o = opinions[i];
	        if (passes_running_timelapse_simulation(o.created_at || o.updated_at)) {
	          results.push(o);
	        }
	      }
	      return results;
	    })();
	  }
	  points = (function() {
	    var i, len, results;
	    results = [];
	    for (i = 0, len = points.length; i < len; i++) {
	      pnt = points[i];
	      if (pnt.is_pro === (valence === 'pros')) {
	        results.push(pnt);
	      }
	    }
	    return results;
	  })();
	  included_points = proposal.your_opinion.point_inclusions || [];
	  if (filter_included) {
	    points = (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = points.length; i < len; i++) {
	        pnt = points[i];
	        if (!_.contains(included_points, pnt.key)) {
	          results.push(pnt);
	        }
	      }
	      return results;
	    })();
	  } else {
	    for (i = 0, len = included_points.length; i < len; i++) {
	      pnt = included_points[i];
	      point = fetch(pnt);
	      if (pnt.is_pro !== (valence === 'pros')) {
	        continue;
	      }
	      if (points.indexOf(point) === -1) {
	        points.push(point);
	      }
	    }
	  }
	  opinion_views = fetch('opinion_views');
	  if (opinion_views.active_views.single_opinion_selected) {
	    opinions = [opinion_views.active_views.single_opinion_selected.opinion];
	    filtered = true;
	  } else if (opinion_views.active_views.region_selected || ((function() {
	    var ref, results;
	    ref = opinion_views.active_views;
	    results = [];
	    for (key in ref) {
	      view = ref[key];
	      if (view.view_type === 'filter' && key !== 'just_you') {
	        results.push(key);
	      }
	    }
	    return results;
	  })()).length > 0) {
	    ref = compose_opinion_views(opinions, proposal), weights = ref.weights, salience = ref.salience, groups = ref.groups;
	    opinions = (function() {
	      var j, len1, results;
	      results = [];
	      for (j = 0, len1 = opinions.length; j < len1; j++) {
	        o = opinions[j];
	        if (salience[o.user.key || o.user] === 1) {
	          results.push(o);
	        }
	      }
	      return results;
	    })();
	    filtered = true;
	  }
	  point_inclusions_per_point = {};
	  _.each(opinions, (function(_this) {
	    return function(opinion_key) {
	      var j, len1, opinion, ref1, results;
	      opinion = fetch(opinion_key);
	      if (opinion.point_inclusions) {
	        ref1 = opinion.point_inclusions;
	        results = [];
	        for (j = 0, len1 = ref1.length; j < len1; j++) {
	          point = ref1[j];
	          point_inclusions_per_point[point] || (point_inclusions_per_point[point] = 0);
	          results.push(point_inclusions_per_point[point] += 1);
	        }
	        return results;
	      }
	    };
	  })(this));
	  active_views = _.without(Object.keys(opinion_views.active_views), 'point_includers');
	  sort_key = JSON.stringify({
	    proposal: proposal.key,
	    valence: valence,
	    sort_field: sort_field,
	    filter_included: filter_included,
	    show_all_points: show_all_points,
	    views: active_views,
	    pnts: (function() {
	      var j, len1, results;
	      results = [];
	      for (j = 0, len1 = points.length; j < len1; j++) {
	        pnt = points[j];
	        results.push(pnt.key);
	      }
	      return results;
	    })()
	  });
	  if (sort_key in stored_points_order && opinion_views.active_views.point_includers) {
	    points = stored_points_order[sort_key];
	  } else {
	    points = (function() {
	      var j, len1, ref1, results;
	      results = [];
	      for (j = 0, len1 = points.length; j < len1; j++) {
	        pnt = points[j];
	        if ((pnt.key in point_inclusions_per_point) || (TABLET_SIZE() && (ref1 = pnt.key, indexOf.call(included_points, ref1) >= 0))) {
	          results.push(pnt);
	        }
	      }
	      return results;
	    })();
	    sort = function(pnt) {
	      if (filtered || (typeof running_timelapse_simulation !== "undefined" && running_timelapse_simulation !== null)) {
	        return -point_inclusions_per_point[pnt.key];
	      } else {
	        return -pnt[sort_field];
	      }
	    };
	    points = _.sortBy(points, sort);
	    stored_points_order[sort_key] = points;
	  }
	  results = [];
	  for (j = 0, len1 = points.length; j < len1; j++) {
	    pnt = points[j];
	    results.push(pnt.key);
	  }
	  return results;
	};
	
	styles += ".point_list {\n  width: var(--POINT_WIDTH);\n}\n";
	
	window.PointsList = ReactiveComponent({
	  displayName: 'PointsList',
	  render: function() {
	    var HEADING, get_heading, header_height, header_prefix, heading, mode, none_given, opinion_views, other_heading, pnt, point, points, proposal, wrap, wrapper, your_points;
	    points = (function() {
	      var i, len, ref, results;
	      ref = this.props.points;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        pnt = ref[i];
	        results.push(fetch(pnt));
	      }
	      return results;
	    }).call(this);
	    your_points = fetch(this.props.reasons_key);
	    proposal = fetch(this.props.proposal);
	    mode = getProposalMode(proposal);
	    if (this.props.points_editable && !your_points.editing_points) {
	      _.extend(your_points, {
	        editing_points: [],
	        adding_new_point: false
	      });
	      save(your_points);
	    }
	    if (this.props.rendered_as === 'community_point') {
	      header_prefix = mode === 'results' ? 'top' : "other";
	      wrapper = this.drawCommunityPoints;
	    } else {
	      header_prefix = 'your';
	      wrapper = this.drawYourPoints;
	    }
	    get_heading = (function(_this) {
	      return function(valence) {
	        var heading, heading_t, plural_point, point_labels;
	        point_labels = customization("point_labels", proposal);
	        heading = point_labels[header_prefix + "_header"];
	        plural_point = get_point_label(valence, proposal);
	        heading_t = translator({
	          id: "point_labels.header_" + header_prefix + "." + heading,
	          local: !point_labels.translate,
	          "arguments": capitalize(plural_point)
	        }, heading);
	        return heading_t;
	      };
	    })(this);
	    heading = get_heading(this.props.valence);
	    other_heading = get_heading(this.props.valence === 'pros' ? 'cons' : 'pros');
	    wrap = (function(_this) {
	      return function(headd) {
	        return "<div class='" + (_this.props.rendered_as === 'community_point' ? 'points_by_community' : 'DecisionBoard') + "'> <div class='points_heading_label'>" + headd + "</div> </div>";
	      };
	    })(this);
	    header_height = Math.max(heightWhenRendered(wrap(heading)), heightWhenRendered(wrap(other_heading)));
	    if (this.props.rendered_as === 'community_point') {
	      header_height -= 38;
	    }
	    HEADING = this.props.rendered_as === 'community_point' ? H3 : H4;
	    return wrapper([
	      HEADING({
	        key: 'point_list_heading',
	        id: this.local.key.replace(/\//g, '-'),
	        className: 'points_heading_label',
	        style: {
	          height: header_height
	        }
	      }, heading), UL({
	        key: 'points_list',
	        'aria-labelledby': this.local.key.replace(/\//g, '-')
	      }, (function() {
	        var i, len, ref, results;
	        if (points.length > 0 || this.props.rendered_as === 'decision_board_point') {
	          results = [];
	          for (i = 0, len = points.length; i < len; i++) {
	            point = points[i];
	            if (!passes_running_timelapse_simulation(point.created_at)) {
	              continue;
	            }
	            if (this.props.points_editable && (ref = point.key, indexOf.call(your_points.editing_points, ref) >= 0)) {
	              results.push(EditPoint({
	                key: point.key,
	                point: point.key,
	                proposal: this.props.proposal,
	                fresh: false,
	                valence: this.props.valence,
	                your_points_key: this.props.reasons_key,
	                in_viewport: this.props.in_viewport
	              }));
	            } else {
	              results.push(Point({
	                key: point.key,
	                point: point.key,
	                rendered_as: this.props.rendered_as,
	                your_points_key: this.props.reasons_key,
	                enable_dragging: this.props.points_draggable,
	                in_viewport: this.props.in_viewport
	              }));
	            }
	          }
	          return results;
	        } else if (points.length === 0 && this.props.rendered_as === 'community_point' && mode === "results") {
	          opinion_views = fetch('opinion_views');
	          none_given = opinion_views.active_views.single_opinion_selected || opinion_views.active_views.region_selected;
	          return DIV({
	            className: 'empty-list-callout',
	            style: {
	              fontStyle: 'italic',
	              textAlign: 'center',
	              color: '#777',
	              display: WINDOW_WIDTH() < 430 ? 'none' : void 0
	            }
	          }, none_given ? translator({
	            id: 'engage.no_pro_or_con_given',
	            pros_or_cons: get_point_label(this.props.valence.substring(0, this.props.valence.length - 1) + 's', proposal)
	          }, "No {pros_or_cons} given") : translator({
	            id: 'engage.first_to_add',
	            pro_or_con: get_point_label(this.props.valence.substring(0, this.props.valence.length - 1), proposal)
	          }, "Be the first to add a {pro_or_con}"));
	        }
	      }).call(this)), this.props.drop_target && permit('create point', proposal) > 0 ? this.drawDropTarget() : void 0, this.props.points_editable && permit('create point', proposal) > 0 ? this.drawAddNewPoint() : void 0
	    ]);
	  },
	  columnStandsOut: function() {
	    var contains_selection, is_editing, your_points;
	    your_points = fetch(this.props.reasons_key);
	    contains_selection = get_selected_point() && fetch(get_selected_point()).is_pro === (this.props.valence === 'pros');
	    is_editing = this.props.points_editable && (your_points.editing_points.length > 0 || your_points.adding_new_point);
	    return contains_selection || is_editing;
	  },
	  drawCommunityPoints: function(children) {
	    var mode, proposal, x_pos;
	    proposal = fetch(this.props.proposal);
	    mode = getProposalMode(proposal);
	    if (mode === 'crafting') {
	      x_pos = this.props.valence === 'cons' ? "calc( -1 * var(--DECISION_BOARD_WIDTH) / 2 )" : "calc( var(--DECISION_BOARD_WIDTH) / 2  )";
	    } else {
	      x_pos = 0;
	    }
	    return SECTION({
	      key: 'community_points',
	      className: "point_list points_by_community " + this.props.valence + "_by_community",
	      style: _.defaults(this.props.style || {}, {
	        minHeight: (points_for_proposal(proposal).length > 4 && mode === 'crafting' ? window.innerHeight : 100),
	        zIndex: this.columnStandsOut() ? 6 : 1,
	        transition: "transform " + CRAFTING_TRANSITION_SPEED + "ms, width " + CRAFTING_TRANSITION_SPEED + "ms",
	        transform: "translate(" + x_pos + ", 0)"
	      })
	    }, mode === 'crafting' && !TABLET_SIZE() ? [
	      A({
	        key: 'skip to',
	        className: 'hidden',
	        href: "#" + this.props.valence + "_on_decision_board",
	        'data-nojax': true,
	        onClick: (function(_this) {
	          return function(e) {
	            var ref;
	            e.stopPropagation();
	            if ((ref = document.activeElement) != null) {
	              ref.blur();
	            }
	            return document.querySelector("[name='" + _this.props.valence + "_on_decision_board']").focus();
	          };
	        })(this)
	      }, "Skip to Your points."), A({
	        key: 'anchor',
	        name: this.props.valence + "_by_community"
	      })
	    ] : void 0, children);
	  },
	  drawYourPoints: function(children) {
	    return SECTION({
	      className: "point_list points_on_decision_board " + this.props.valence + "_on_decision_board",
	      style: _.defaults(this.props.style || {}, {
	        display: 'inline-block',
	        verticalAlign: 'top',
	        marginTop: 28,
	        position: 'relative',
	        zIndex: this.columnStandsOut() ? 6 : 1,
	        float: this.props.valence === 'pros' ? 'right' : 'left'
	      })
	    }, A({
	      name: this.props.valence + "_on_decision_board"
	    }), children);
	  },
	  drawAddNewPoint: function() {
	    var can_add_new_point, hist_selection, noun, opinion_views, proposal, your_points;
	    proposal = fetch(this.props.proposal);
	    your_points = fetch(this.props.reasons_key);
	    can_add_new_point = permit('create point', proposal);
	    opinion_views = fetch('opinion_views');
	    hist_selection = opinion_views.active_views.single_opinion_selected || opinion_views.active_views.region_selected;
	    if (can_add_new_point !== Permission.INSUFFICIENT_PRIVILEGES && !hist_selection) {
	      if (!your_points.adding_new_point) {
	        return DIV({
	          key: 'draw add new point'
	        }, DIV({
	          onClick: (function(_this) {
	            return function() {
	              if (can_add_new_point === Permission.NOT_LOGGED_IN) {
	                reset_key('auth', {
	                  form: 'create account',
	                  goal: 'To access this forum, please introduce yourself below.'
	                });
	              } else if (can_add_new_point === Permission.UNVERIFIED_EMAIL) {
	                reset_key('auth', {
	                  form: 'verify email',
	                  goal: 'To participate, please demonstrate you control this email.'
	                });
	                save(auth);
	                current_user.trying_to = 'send_verification_token';
	                save(current_user);
	              } else {
	                your_points.adding_new_point = true;
	                save(your_points);
	              }
	              return writeToLog({
	                what: 'click new point'
	              });
	            };
	          })(this)
	        }, this.props.rendered_as === 'decision_board_point' ? this.drawAddNewPointInDecisionBoard() : this.drawAddNewPointInCommunityCol()), this.props.rendered_as === 'decision_board_point' ? (this.props.valence === 'pros' ? noun = get_point_label('pro', proposal) : noun = get_point_label('con', proposal), noun = capitalize(noun), A({
	          className: 'hidden',
	          href: "#" + this.props.valence + "_by_community",
	          'data-nojax': true,
	          onClick: (function(_this) {
	            return function(e) {
	              var ref;
	              e.stopPropagation();
	              if ((ref = document.activeElement) != null) {
	                ref.blur();
	              }
	              return document.querySelector("[name='" + _this.props.valence + "_by_community']").focus();
	            };
	          })(this)
	        }, "Skip to " + noun + " points by others to vote on important ones.")) : void 0);
	      } else {
	        return EditPoint({
	          key: "new_point_" + this.props.valence,
	          proposal: this.props.proposal,
	          fresh: true,
	          valence: this.props.valence,
	          your_points_key: this.props.reasons_key
	        });
	      }
	    }
	  },
	  drawAddNewPointInCommunityCol: function() {
	    var button_text, point_label, proposal;
	    proposal = fetch(this.props.proposal);
	    if (this.props.valence === 'pros') {
	      point_label = get_point_label('pro', proposal);
	    } else {
	      point_label = get_point_label('con', proposal);
	    }
	    button_text = translator({
	      id: "engage.add_a_point",
	      pro_or_con: point_label
	    }, "Add a new {pro_or_con}");
	    return DIV({
	      id: "add-point-" + this.props.valence,
	      className: 'give_a_point',
	      style: {
	        cursor: 'pointer',
	        marginTop: 20
	      }
	    }, this.drawGhostedPoint({
	      text: button_text,
	      is_left: this.props.valence === 'cons',
	      style: {},
	      text_style: {
	        textDecoration: 'underline'
	      }
	    }));
	  },
	  drawAddNewPointInDecisionBoard: function() {
	    var point_label, proposal, your_points;
	    proposal = fetch(this.props.proposal);
	    your_points = fetch(this.props.reasons_key);
	    if (this.props.valence === 'pros') {
	      point_label = get_point_label('pro', proposal);
	    } else {
	      point_label = get_point_label('con', proposal);
	    }
	    return DIV({
	      className: "point-in-decision-board " + (this.props.drop_target ? 'with-drop-target' : ''),
	      style: {
	        textAlign: 'center',
	        marginTop: '1em',
	        marginLeft: 0,
	        fontSize: POINT_FONT_SIZE()
	      }
	    }, this.props.drop_target ? STYLE({
	      dangerouslySetInnerHTML: {
	        __html: ".point-in-decision-board.with-drop-target .write_" + this.props.valence + "::before {\n  content: \"" + (translator('or', 'or')) + "\";\n  position: absolute;\n  left: -25px;\n  top: 5px;\n  font-weight: " + (browser.high_density_display ? 300 : 400) + ";\n  color: black;\n}"
	      }
	    }) : void 0, BUTTON({
	      className: "write_" + this.props.valence + " btn",
	      style: {
	        marginLeft: 8,
	        backgroundColor: focus_color(),
	        position: 'relative',
	        opacity: fetch(shared_local_key(proposal)).has_focus === 'edit point' ? .1 : void 0
	      }
	    }, TRANSLATE({
	      id: "engage.add_a_point",
	      pro_or_con: point_label
	    }, "Add a new {pro_or_con}")));
	  },
	  drawDropTarget: function() {
	    var drop_target_text, left_or_right, local_proposal, point_label, proposal;
	    proposal = fetch(this.props.proposal);
	    left_or_right = this.props.valence === 'pros' ? 'right' : 'left';
	    if (this.props.valence === 'pros') {
	      point_label = get_point_label('pro', proposal);
	    } else {
	      point_label = get_point_label('con', proposal);
	    }
	    drop_target_text = TRANSLATE({
	      id: "engage.drag_point." + left_or_right,
	      pro_or_con: point_label,
	      left_or_right: left_or_right
	    }, "Drag a {pro_or_con} from the " + left_or_right);
	    local_proposal = fetch(shared_local_key(proposal));
	    return DIV({
	      key: 'drop-target',
	      'aria-hidden': true
	    }, this.drawGhostedPoint({
	      text: drop_target_text,
	      is_left: this.props.valence === 'cons',
	      style: {
	        opacity: local_proposal.has_focus === 'edit point' ? .1 : void 0
	      },
	      text_style: {}
	    }));
	  },
	  drawGhostedPoint: function(props) {
	    var h, is_left, local_proposal, mouth_style, padding_x, padding_y, proposal, s_h, s_w, stroke_width, style, text, text_height, text_style, width_calc;
	    proposal = fetch(this.props.proposal);
	    text_style = props.text_style || {};
	    style = props.style || {};
	    text = props.text;
	    is_left = props.is_left;
	    padding_x = 18;
	    padding_y = 12;
	    stroke_width = 1;
	    width_calc = "calc( 100% - " + (2 * stroke_width) + "px )";
	    text_height = heightWhenRendered(text, {
	      fontSize: (POINT_FONT_SIZE()) + "px",
	      width: width_calc
	    });
	    h = Math.max(text_height + 2 * padding_y, 85);
	    s_w = 8;
	    s_h = 6;
	    mouth_style = {
	      top: 8,
	      position: 'absolute'
	    };
	    if (is_left) {
	      mouth_style['transform'] = 'rotate(270deg) scaleX(-1)';
	      mouth_style['left'] = -POINT_MOUTH_WIDTH + stroke_width + 1;
	    } else {
	      mouth_style['transform'] = 'rotate(90deg)';
	      mouth_style['right'] = -POINT_MOUTH_WIDTH + stroke_width + 2;
	    }
	    local_proposal = fetch(shared_local_key(proposal));
	    return DIV({
	      style: _.defaults(style, {
	        position: 'relative',
	        opacity: local_proposal.has_focus === 'edit point' ? .1 : void 0
	      })
	    }, SVG({
	      width: "100%",
	      height: h
	    }, DEFS(null, PATTERN({
	      id: "drop-stripes-" + is_left + "-" + s_w + "-" + s_h,
	      width: s_w,
	      height: s_h,
	      patternUnits: "userSpaceOnUse"
	    }, RECT({
	      key: 'rect',
	      width: '100%',
	      height: '100%',
	      fill: 'white'
	    }), (function(_this) {
	      return function() {
	        var cross_hatch, i, idx, len, ref, results, x1, x2, y1, y2;
	        if (is_left) {
	          cross_hatch = [[-s_w / 2, 0, s_w, 1.5 * s_h], [0, -s_h / 2, 1.5 * s_w, s_h]];
	        } else {
	          cross_hatch = [[1.5 * s_w, 0, 0, 1.5 * s_h], [s_w, -s_h / 2, -s_w / 2, s_h]];
	        }
	        results = [];
	        for (idx = i = 0, len = cross_hatch.length; i < len; idx = ++i) {
	          ref = cross_hatch[idx], x1 = ref[0], y1 = ref[1], x2 = ref[2], y2 = ref[3];
	          results.push(LINE({
	            key: idx,
	            x1: x1,
	            y1: y1,
	            x2: x2,
	            y2: y2,
	            stroke: focus_color(),
	            strokeWidth: 1,
	            strokeOpacity: .2
	          }));
	        }
	        return results;
	      };
	    })(this)())), RECT({
	      width: "99%",
	      height: h - 2 * stroke_width,
	      x: stroke_width,
	      y: stroke_width,
	      rx: 16,
	      ry: 16,
	      fill: "url(#drop-stripes-" + is_left + "-" + s_w + "-" + s_h + ")",
	      stroke: focus_color(),
	      strokeWidth: stroke_width,
	      strokeDasharray: '4, 3'
	    })), SPAN({
	      style: _.defaults({}, text_style, {
	        fontSize: POINT_FONT_SIZE(),
	        position: 'absolute',
	        top: padding_y,
	        left: padding_x,
	        width: "calc(100% - 2 * " + padding_x + "px)"
	      })
	    }, text), Bubblemouth({
	      apex_xfrac: 0,
	      width: POINT_MOUTH_WIDTH,
	      height: POINT_MOUTH_WIDTH,
	      fill: '#F9FBFD',
	      stroke: focus_color(),
	      stroke_width: 6,
	      dash_array: '24, 18',
	      style: mouth_style
	    }));
	  }
	});
	
	GroupSelectionRegion = ReactiveComponent({
	  displayName: 'GroupSelectionRegion',
	  render: function() {
	    var avatar_height, h, has_histogram_focus, histocache, left, margin, name, name_style, name_width, opinion_views, ref, ref1, region_selected, single_opinion_selected, slidergram_width, stance, title, user, w, wrapper_padding, wrapper_width;
	    opinion_views = fetch('opinion_views');
	    single_opinion_selected = opinion_views.active_views.single_opinion_selected;
	    region_selected = opinion_views.active_views.region_selected;
	    has_histogram_focus = single_opinion_selected || region_selected;
	    if (!has_histogram_focus) {
	      return SPAN(null);
	    }
	    w = 36;
	    h = 24;
	    slidergram_width = ITEM_OPINION_WIDTH() * (!TABLET_SIZE() ? 2 : 1);
	    wrapper_padding = 300;
	    wrapper_width = slidergram_width + wrapper_padding;
	    margin = wrapper_width - slidergram_width;
	    stance = (region_selected || single_opinion_selected).opinion_value;
	    if (!region_selected) {
	      histocache = last_histogram_position[this.props.proposal];
	      if (!histocache || !((ref = histocache.positions) != null ? (ref1 = ref[single_opinion_selected.user]) != null ? ref1[2] : void 0 : void 0)) {
	        return SPAN(null);
	      }
	      avatar_height = 2 * histocache.positions[single_opinion_selected.user][2];
	    }
	    left = get_opinion_x_pos_projection({
	      slider_val: stance,
	      from_width: slidergram_width,
	      to_width: slidergram_width,
	      x_min: 0,
	      x_max: 0
	    });
	    left += wrapper_padding / 2;
	    return DIV({
	      style: {
	        width: wrapper_width,
	        border: !PHONE_SIZE() ? "3px solid " + (get_selected_point() ? '#eee' : focus_color()) : void 0,
	        height: '100%',
	        position: 'absolute',
	        borderRadius: 32,
	        left: "calc(50% - " + (wrapper_width / 2) + "px)",
	        top: 4
	      }
	    }, !PHONE_SIZE() ? DIV({
	      style: cssTriangle('top', (get_selected_point() ? '#eee' : focus_color()), w, h, {
	        position: 'relative',
	        top: -26,
	        left: left - w / 2
	      })
	    }, DIV({
	      style: cssTriangle('top', 'white', w - 1, h - 1, {
	        position: 'relative',
	        left: -(w - 2) / 2,
	        top: 6
	      })
	    })) : void 0, single_opinion_selected ? (name_style = {
	      fontSize: (PHONE_SIZE() ? 18 : 30) + "px",
	      fontWeight: 600,
	      whiteSpace: 'nowrap'
	    }, user = fetch(fetch(single_opinion_selected.opinion).user), name = user.name || anonymous_label(), title = name + "'" + (name[name.length - 1] !== 's' ? 's' : '') + " Opinion", name_width = widthWhenRendered(title, name_style), DIV({
	      style: _.extend(name_style, {
	        position: 'absolute',
	        top: -(avatar_height + 172),
	        color: focus_color(),
	        left: "min(" + (wrapper_width - name_width) + "px, max(0px, calc(" + left + "px - " + (name_width / 2) + "px)))"
	      })
	    }, title)) : void 0);
	  }
	});


/***/ },
/* 45 */
/***/ function(module, exports) {

	var stripeSVG;
	
	styles += "[data-widget=\"UpgradeForumBanner\"], [data-widget=\"HostHeader\"].forum_editor {\n  background-color: #456ae4;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23003f99' fill-opacity='0.49' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E\");\n  width: 100%;\n}\n\n[data-widget=\"HostHeader\"].forum_editor.not-fixed {\n  position: relative;\n}\n\n\n[data-widget=\"HostHeader\"].forum_editor.fixed {\n  position: fixed;\n  z-index: 99998;\n}\n\n\n#DASHBOARD-main [data-widget=\"UpgradeForumButton\"] .btn.big, [data-widget=\"UpgradeForumButton\"] .btn.big {\n  text-transform: capitalize;\n  padding: 8px 24px;\n  font-size: 14px;\n  margin-left: 0px;\n  margin-bottom: 24px;\n  box-shadow: 0 1px 1px rgb(8 81 114);\n}\n\n#DASHBOARD-main [data-widget=\"UpgradeForumButton\"] .btn, [data-widget=\"UpgradeForumButton\"] .btn {\n  margin-left: 8px;\n  background-color: " + upgrade_color + ";\n  font-size: 10px;\n  padding: 4px 6px;\n  text-transform: lowercase;\n}";
	
	window.UpgradeForumButton = ReactiveComponent({
	  displayName: 'UpgradeForumButton',
	  render: function() {
	    var TAG;
	    TAG = this.props.tag || BUTTON;
	    return SPAN(null, TAG({
	      className: "btn " + (this.props.big ? 'big' : ''),
	      style: this.props.style || {},
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, this.props.text || "upgrade"), this.local.show_payment_form ? ModalStripePayment({
	      cancel_payment: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = false;
	          return save(_this.local);
	        };
	      })(this)
	    }) : void 0);
	  }
	});
	
	window.UpgradeForumBanner = ReactiveComponent({
	  displayName: 'UpgradeForumBanner',
	  render: function() {
	    return DIV({
	      style: {
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        padding: 4
	      }
	    }, BUTTON({
	      className: 'btn',
	      style: {
	        marginRight: 24,
	        backgroundColor: upgrade_color,
	        boxShadow: '0 1px 2px rgba(0,0,0,.5)'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Upgrade forum"), SPAN({
	      style: {
	        fontSize: 13,
	        color: 'white',
	        fontWeight: 700
	      }
	    }, WINDOW_WIDTH() < 956 ? "$625 one-time fee" : "$625 one-time fee to unlock data export, sign-up questions, tab-based organization, and more.", A({
	      href: "https://" + (fetch('/application').base_domain) + "/pricing",
	      target: '_blank',
	      style: {
	        textDecoration: 'underline',
	        paddingLeft: 12,
	        color: 'white',
	        fontWeight: 700,
	        fontSize: 15
	      }
	    }, "Learn more")), this.local.show_payment_form ? ModalStripePayment({
	      cancel_payment: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = false;
	          return save(_this.local);
	        };
	      })(this)
	    }) : void 0);
	  }
	});
	
	window.UpgradeForumCompact = ReactiveComponent({
	  displayName: 'UpgradeForumCompact',
	  render: function() {
	    return DIV({
	      style: {
	        position: 'absolute'
	      }
	    }, BUTTON({
	      className: 'btn',
	      title: "$625 one-time fee to unlock data export, sign-up questions, tab-based organization, and more.",
	      style: {
	        backgroundColor: upgrade_color,
	        boxShadow: '0 1px 2px rgba(0,0,0,.5)'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Upgrade forum"), A({
	      href: "https://" + (fetch('/application').base_domain) + "/pricing",
	      target: '_blank',
	      style: {
	        textDecoration: 'underline',
	        color: 'white',
	        fontWeight: 600,
	        fontSize: 13,
	        marginLeft: 24
	      }
	    }, "Learn more about our plans"), this.local.show_payment_form ? ModalStripePayment({
	      cancel_payment: (function(_this) {
	        return function() {
	          _this.local.show_payment_form = false;
	          return save(_this.local);
	        };
	      })(this)
	    }) : void 0);
	  }
	});
	
	styles += "[data-widget=\"ModalStripePayment\"] #modal-body {\n  background-color: white;\n  padding: 64px 0 48px 0;\n}\n[data-widget=\"ModalStripePayment\"] #modal-body #payment-form {\n  box-shadow: none;\n  padding: 0;\n}";
	
	window.ModalStripePayment = ReactiveComponent({
	  displayName: 'ModalStripePayment',
	  mixins: [Modal],
	  render: function() {
	    var cancel_payment;
	    cancel_payment = (function(_this) {
	      return function() {
	        var base;
	        return typeof (base = _this.props).cancel_payment === "function" ? base.cancel_payment() : void 0;
	      };
	    })(this);
	    return wrap_in_modal(Math.min(700, HOMEPAGE_WIDTH()), cancel_payment, DIV(null, STRIPE_PAYMENT(this.props), this.props.cancel_payment != null ? BUTTON({
	      className: 'like_link',
	      style: {
	        opacity: .7,
	        textAlign: 'center',
	        display: 'block',
	        margin: '24px auto 0 auto'
	      },
	      onClick: cancel_payment
	    }, 'cancel') : void 0));
	  }
	});
	
	stripeSVG = function(props) {
	  var base_height, base_width, style;
	  base_width = 150;
	  base_height = 34;
	  svg.setSize(base_width, base_height, props);
	  style = props.style || {};
	  return SVG({
	    width: props.width,
	    height: props.height,
	    viewBox: "0 0 " + base_width + " " + base_height,
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg",
	    style: style,
	    dangerouslySetInnerHTML: {
	      __html: "<g fill=\"#635bff\"><path d=\"m146 0h-142.27a3.73 3.73 0 0 0 -3.73 3.73v26.54a3.73 3.73 0 0 0 3.73 3.73h142.27a4 4 0 0 0 4-4v-26a4 4 0 0 0 -4-4zm3 30a3 3 0 0 1 -3 3h-142.27a2.74 2.74 0 0 1 -2.73-2.73v-26.54a2.74 2.74 0 0 1 2.73-2.73h142.27a3 3 0 0 1 3 3z\"/><path d=\"m17.07 11.24h-4.3v10.76h1.92v-4.16h2.38c2.4 0 3.9-1.16 3.9-3.3s-1.5-3.3-3.9-3.3zm-.1 5h-2.28v-3.3h2.31c1.38 0 2.11.59 2.11 1.65s-.76 1.6-2.11 1.6z\"/><path d=\"m25.1 14a3.77 3.77 0 0 0 -3.8 4.09 3.81 3.81 0 1 0 7.59 0 3.76 3.76 0 0 0 -3.79-4.09zm0 6.67c-1.22 0-2-1-2-2.58s.76-2.58 2-2.58 2 1 2 2.58-.79 2.57-2 2.57z\"/><path d=\"m36.78 19.35-1.41-5.22h-1.48l-1.4 5.22-1.42-5.22h-1.85l2.37 7.88h1.56l1.44-5.16 1.44 5.16h1.56l2.37-7.88h-1.78z\"/><path d=\"m44 14a3.83 3.83 0 0 0 -3.75 4.09 3.79 3.79 0 0 0 3.83 4.09 3.47 3.47 0 0 0 3.41-2.18l-1.49-.62a1.78 1.78 0 0 1 -1.83 1.26 2.12 2.12 0 0 1 -2.17-2.17h5.52v-.6c.02-2.16-1.2-3.87-3.52-3.87zm-1.93 3.13a1.92 1.92 0 0 1 1.93-1.63 1.56 1.56 0 0 1 1.69 1.62z\"/><path d=\"m50.69 15.3v-1.17h-1.8v7.87h1.8v-4.13a1.89 1.89 0 0 1 2-2 4.68 4.68 0 0 1 .66 0v-1.8c-.14 0-.3 0-.51 0a2.29 2.29 0 0 0 -2.15 1.23z\"/><path d=\"m57.48 14a3.83 3.83 0 0 0 -3.75 4.09 3.79 3.79 0 0 0 3.83 4.09 3.47 3.47 0 0 0 3.37-2.18l-1.54-.59a1.78 1.78 0 0 1 -1.83 1.26 2.12 2.12 0 0 1 -2.1-2.17h5.54v-.6c0-2.19-1.24-3.9-3.52-3.9zm-1.93 3.13a1.92 1.92 0 0 1 1.92-1.62 1.56 1.56 0 0 1 1.69 1.62z\"/><path d=\"m67.56 15a2.85 2.85 0 0 0 -2.26-1c-2.21 0-3.47 1.85-3.47 4.09s1.26 4.09 3.47 4.09a2.82 2.82 0 0 0 2.26-1v.82h1.8v-10.76h-1.8zm0 3.35a2 2 0 0 1 -2 2.28c-1.31 0-2-1-2-2.52s.7-2.52 2-2.52c1.11 0 2 .81 2 2.29z\"/><path d=\"m79.31 14a2.88 2.88 0 0 0 -2.31 1v-3.76h-1.8v10.76h1.8v-.83a2.86 2.86 0 0 0 2.27 1c2.2 0 3.46-1.86 3.46-4.09s-1.22-4.08-3.42-4.08zm-.31 6.6a2 2 0 0 1 -2-2.28v-.47c0-1.48.84-2.29 2-2.29 1.3 0 2 1 2 2.52s-.75 2.52-2 2.52z\"/><path d=\"m86.93 19.66-1.93-5.53h-1.9l2.9 7.59-.3.74a1 1 0 0 1 -1.14.79 4.12 4.12 0 0 1 -.6 0v1.51a4.62 4.62 0 0 0 .73.05 2.67 2.67 0 0 0 2.78-2l3.24-8.62h-1.89z\"/><path d=\"m125 12.43a3 3 0 0 0 -2.13.87l-.14-.69h-2.39v12.92l2.72-.59v-3.13a3 3 0 0 0 1.93.7c1.94 0 3.72-1.59 3.72-5.11 0-3.22-1.8-4.97-3.71-4.97zm-.65 7.63a1.61 1.61 0 0 1 -1.28-.52v-4.11a1.64 1.64 0 0 1 1.3-.55c1 0 1.68 1.13 1.68 2.58s-.69 2.6-1.7 2.6z\"/><path d=\"m133.73 12.43c-2.62 0-4.21 2.26-4.21 5.11 0 3.37 1.88 5.08 4.56 5.08a6.12 6.12 0 0 0 3-.73v-2.25a5.79 5.79 0 0 1 -2.7.62c-1.08 0-2-.39-2.14-1.7h5.38c0-.15 0-.74 0-1 .09-2.87-1.27-5.13-3.89-5.13zm-1.47 4.07c0-1.26.77-1.79 1.45-1.79s1.4.53 1.4 1.79z\"/><path d=\"m113 13.36-.17-.82h-2.32v9.71h2.68v-6.58a1.87 1.87 0 0 1 2.05-.58v-2.55a1.8 1.8 0 0 0 -2.24.82z\"/><path d=\"m99.46 15.46c0-.44.36-.61.93-.61a5.9 5.9 0 0 1 2.7.72v-2.63a7 7 0 0 0 -2.7-.51c-2.21 0-3.68 1.18-3.68 3.16 0 3.1 4.14 2.6 4.14 3.93 0 .52-.44.69-1 .69a6.78 6.78 0 0 1 -3-.9v2.69a7.38 7.38 0 0 0 3 .64c2.26 0 3.82-1.15 3.82-3.16-.05-3.36-4.21-2.76-4.21-4.02z\"/><path d=\"m107.28 10.24-2.65.58v8.93a2.77 2.77 0 0 0 2.82 2.87 4.16 4.16 0 0 0 1.91-.37v-2.25c-.35.15-2.06.66-2.06-1v-4h2.06v-2.34h-2.06z\"/><path d=\"m116.25 11.7 2.73-.57v-2.16l-2.73.57z\"/><path d=\"m116.25 12.61h2.73v9.64h-2.73z\"/></g></svg>"
	    }
	  });
	};
	
	window.STRIPE_PAYMENT = ReactiveComponent({
	  displayName: 'STRIPE_PAYMENT',
	  componentDidMount: function() {
	    return this.configurePayment();
	  },
	  componentDidUpdate: function() {
	    return this.configurePayment();
	  },
	  render: function() {
	    return DIV(null, DIV({
	      style: {
	        marginBottom: 48,
	        color: 'black'
	      }
	    }, H1({
	      style: {
	        fontSize: 32,
	        textAlign: 'center'
	      }
	    }, "Upgrade to a Premium Forum"), DIV({
	      style: {
	        fontSize: 13,
	        margin: "12px auto",
	        maxWidth: 500
	      }
	    }, "$625 one-time fee to unlock data export, sign-up questions, and tab-based organization. Contact", A({
	      href: 'mailto:help@consider.it?subject=Consider.it alternative payment',
	      style: {
	        textDecoration: 'underline',
	        padding: "0px 4px",
	        fontWeight: 600
	      }
	    }, 'help@consider.it'), "to pay using a different method.")), stripeSVG({
	      height: 24,
	      style: {
	        position: 'absolute',
	        right: 90,
	        bottom: 48
	      }
	    }), DIV({
	      style: {
	        display: 'flex',
	        justifyContent: 'center'
	      }
	    }, FORM({
	      id: "payment-form",
	      ref: "payment_form"
	    }, DIV({
	      id: "payment-element"
	    }, this.local.loading ? LOADING_INDICATOR : void 0), BUTTON({
	      id: "submit"
	    }, DIV({
	      className: "spinner hidden",
	      id: "spinner"
	    }), SPAN({
	      id: 'button-text'
	    }, "Pay now")), DIV({
	      id: "payment-message",
	      className: "hidden"
	    }))));
	  },
	  configurePayment: function() {
	    var appearance, checkStatus, elements, intent, paymentElement, payment_form, pub, setLoading, showMessage, stripe_script_loaded;
	    stripe_script_loaded = lazyLoadJavascript("https://js.stripe.com/v3/", {
	      onload: (function(_this) {
	        return function() {
	          _this.local.loading = false;
	          return save(_this.local);
	        };
	      })(this),
	      onerror: (function(_this) {
	        return function() {
	          _this.local.error = true;
	          _this.local.loading = false;
	          return save(_this.local);
	        };
	      })(this)
	    });
	    if (!stripe_script_loaded && !this.local.error) {
	      this.local.loading = true;
	      save(this.local);
	      return;
	    }
	    if (typeof Stripe === "undefined" || Stripe === null) {
	      return setTimeout(this.configurePayment, 20);
	    }
	    if (!window.stripe) {
	      pub = fetch('/payments/public_key');
	      if (!pub.public_key) {
	        return;
	      }
	      window.stripe = Stripe(pub.public_key);
	    }
	    if (!this.intent) {
	      intent = fetch('/payments/payment_intent');
	      if (!intent.secret) {
	        return;
	      }
	      this.intent = intent.secret;
	    }
	    if (!this.mounted) {
	      appearance = {
	        theme: 'stripe'
	      };
	      elements = stripe.elements({
	        appearance: appearance,
	        clientSecret: this.intent
	      });
	      paymentElement = elements.create("payment", {
	        business: {
	          name: "Consider.it"
	        }
	      });
	      paymentElement.mount("#payment-element");
	      this.mounted = true;
	      payment_form = this.refs.payment_form;
	      setLoading = function(isLoading) {
	        if (isLoading) {
	          payment_form.querySelector("#submit").disabled = true;
	          payment_form.querySelector("#spinner").classList.remove("hidden");
	          return payment_form.querySelector("#button-text").classList.add("hidden");
	        } else {
	          payment_form.querySelector("#submit").disabled = false;
	          payment_form.querySelector("#spinner").classList.add("hidden");
	          return payment_form.querySelector("#button-text").classList.remove("hidden");
	        }
	      };
	      showMessage = (function(_this) {
	        return function(messageText) {
	          var messageContainer;
	          messageContainer = payment_form.querySelector("#payment-message");
	          messageContainer.classList.remove("hidden");
	          messageContainer.textContent = messageText;
	          return setTimeout(function() {
	            messageContainer.classList.add("hidden");
	            return messageText.textContent = "";
	          }, 4000);
	        };
	      })(this);
	      checkStatus = (function(_this) {
	        return function() {
	          return stripe.retrievePaymentIntent(_this.intent).then(function(arg) {
	            var paymentIntent;
	            paymentIntent = arg.paymentIntent;
	            switch (paymentIntent.status) {
	              case "succeeded":
	                showMessage("Payment succeeded!");
	                break;
	              case "processing":
	                showMessage("Your payment is processing.");
	                break;
	              case "requires_payment_method":
	                showMessage("Your payment was not successful, please try again.");
	                break;
	              default:
	                showMessage("Something went wrong.");
	                break;
	            }
	          });
	        };
	      })(this);
	      return payment_form.addEventListener("submit", (function(_this) {
	        return function(e) {
	          var promise, url;
	          e.preventDefault();
	          setLoading(true);
	          promise = stripe.confirmPayment({
	            elements: elements,
	            confirmParams: {
	              return_url: _this.props.create_forum_after_payment ? (url = location.origin + "/payments/successful?create_forum=" + _this.props.create_forum_after_payment, _this.props.copy_from ? url += "&copy_from=" + _this.props.copy_from : void 0, url) : (url = new URL(window.location.href), fetch('edit_forum').editing ? url.searchParams.set('edit_forum', 'true') : void 0, url.searchParams.set('flash', translator('admin.thanks-for-upgrading', 'Thank you for upgrading!')), location.origin + "/payments/successful?redirect_to=" + (encodeURIComponent(url.href)))
	            }
	          });
	          return promise.then(function(arg) {
	            var error;
	            error = arg.error;
	            if (error.type === "card_error" || error.type === "validation_error") {
	              showMessage(error.message);
	            } else {
	              showMessage("An unexpected error occured.");
	            }
	            return setLoading(false);
	          });
	        };
	      })(this));
	    }
	  }
	});
	
	styles += "#payment-form {\n  width: 30vw;\n  min-width: 500px;\n  align-self: center;\n  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\n    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\n  border-radius: 7px;\n  padding: 40px;\n  background-color: white;\n}\n\n#payment-form * {\n  box-sizing: border-box;\n}\n\n#payment-form body {\n  font-family: -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 16px;\n  -webkit-font-smoothing: antialiased;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  height: 100vh;\n  width: 100vw;\n}\n\n#payment-form .hidden {\n  display: none;\n}\n\n#payment-message {\n  color: rgb(105, 115, 134);\n  font-size: 16px;\n  line-height: 20px;\n  padding-top: 12px;\n  text-align: center;\n}\n\n#payment-element {\n  margin-bottom: 24px;\n}\n\n/* Buttons and links */\n#payment-form button {\n  background: #5469d4;\n  font-family: Arial, sans-serif;\n  color: #ffffff;\n  border-radius: 4px;\n  border: 0;\n  padding: 12px 16px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  display: block;\n  transition: all 0.2s ease;\n  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);\n  width: 100%;\n}\n#payment-form button:hover,\n#payment-form button:focus-within {\n  filter: contrast(115%);\n}\n#payment-form button:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* spinner/processing state, errors */\n#payment-form .spinner,\n#payment-form .spinner:before,\n#payment-form .spinner:after {\n  border-radius: 50%;\n}\n#payment-form .spinner {\n  color: #ffffff;\n  font-size: 22px;\n  text-indent: -99999px;\n  margin: 0px auto;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  box-shadow: inset 0 0 0 2px;\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  transform: translateZ(0);\n}\n#payment-form .spinner:before,\n#payment-form .spinner:after {\n  position: absolute;\n  content: \"\";\n}\n#payment-form .spinner:before {\n  width: 10.4px;\n  height: 20.4px;\n  background: #5469d4;\n  border-radius: 20.4px 0 0 20.4px;\n  top: -0.2px;\n  left: -0.2px;\n  -webkit-transform-origin: 10.4px 10.2px;\n  transform-origin: 10.4px 10.2px;\n  -webkit-animation: payment-loading 2s infinite ease 1.5s;\n  animation: payment-loading 2s infinite ease 1.5s;\n}\n#payment-form .spinner:after {\n  width: 10.4px;\n  height: 10.2px;\n  background: #5469d4;\n  border-radius: 0 10.2px 10.2px 0;\n  top: -0.1px;\n  left: 10.2px;\n  -webkit-transform-origin: 0px 10.2px;\n  transform-origin: 0px 10.2px;\n  -webkit-animation: payment-loading 2s infinite ease;\n  animation: payment-loading 2s infinite ease;\n}\n\n@-webkit-keyframes payment-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes payment-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 600px) {\n  #payment-form form {\n    width: 80vw;\n    min-width: initial;\n  }\n}\n\n\n";


/***/ },
/* 46 */
/***/ function(module, exports) {

	styles += "\n[data-widget=\"DropMenu\"] .dropmenu-wrapper {\n  position: relative;\n}\n\n[data-widget=\"DropMenu\"] .dropMenu-anchor {\n  position: relative;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: inherit;\n}\n\n[data-widget=\"DropMenu\"] .dropmenu-menu {\n  list-style: none;\n  position: absolute;\n  z-index: 999999;\n}\n\n[data-widget=\"DropMenu\"] .menu-item {\n  cursor: pointer;\n  outline: none;\n  text-decoration: none;\n}\n\n";
	
	window.DropMenu = ReactiveComponent({
	  displayName: 'DropMenu',
	  render: function() {
	    var active_option_style, anchor_style, anchor_when_open_style, base, close_menu, id, idx, menu_style, menu_when_open_style, open_menu_on, option, option_style, options, render_anchor, render_option, set_active, trigger, wrapper_style;
	    if ((base = this.local).active_option == null) {
	      base.active_option = -1;
	    }
	    open_menu_on = this.props.open_menu_on || 'focus';
	    wrapper_style = this.props.wrapper_style || {};
	    anchor_style = this.props.anchor_style || {};
	    anchor_when_open_style = _.defaults({}, this.props.anchor_open_style || {}, anchor_style);
	    menu_style = this.props.menu_style || {};
	    menu_when_open_style = _.defaults({}, this.props.menu_when_open_style || {}, menu_style);
	    option_style = this.props.option_style || {};
	    active_option_style = _.defaults({}, this.props.active_option_style || {}, option_style);
	    options = this.props.options;
	    render_anchor = this.props.render_anchor;
	    render_option = this.props.render_option;
	    set_active = (function(_this) {
	      return function(idx) {
	        if (idx == null) {
	          idx = -1;
	        }
	        if (_this.local.active_option !== idx) {
	          _this.local.active_option = idx;
	          save(_this.local);
	          if (idx !== -1) {
	            return setTimeout(function() {
	              if (idx === _this.local.active_option && (_this.refs["menuitem-" + idx] != null)) {
	                return ReactDOM.findDOMNode(_this.refs["menuitem-" + idx]).focus();
	              }
	            }, 0);
	          }
	        }
	      };
	    })(this);
	    trigger = (function(_this) {
	      return function(e) {
	        var base1, selection;
	        selection = options[_this.local.active_option];
	        if (typeof (base1 = _this.props).selection_made_callback === "function") {
	          base1.selection_made_callback(selection);
	        }
	        if (selection.href) {
	          e.currentTarget.click();
	        }
	        close_menu(e);
	        e.stopPropagation();
	        return e.preventDefault();
	      };
	    })(this);
	    close_menu = (function(_this) {
	      return function(e) {
	        var base1;
	        document.activeElement.blur();
	        _this.local.show_menu = false;
	        save(_this.local);
	        if (typeof (base1 = _this.props).close_callback === "function") {
	          base1.close_callback();
	        }
	        return e != null ? e.stopPropagation() : void 0;
	      };
	    })(this);
	    id = "drop-menu-" + (this.local.key.replace(/\//g, '__'));
	    return DIV({
	      id: id,
	      className: "dropmenu-wrapper " + (this.props.className ? this.props.className : void 0),
	      ref: 'menu_wrap',
	      key: 'dropmenu-wrapper',
	      style: wrapper_style,
	      onMouseLeave: (function(_this) {
	        return function(e) {
	          return close_menu(e);
	        };
	      })(this),
	      onBlur: (function(_this) {
	        return function(e) {
	          return setTimeout(function() {
	            var el;
	            el = document.getElementById(id);
	            if (el && !$$.closest(document.activeElement, "#" + id)) {
	              return close_menu(e);
	            }
	          }, 0);
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          var active_option, base1;
	          if (typeof (base1 = _this.props).onKeyDown === "function") {
	            base1.onKeyDown(e);
	          }
	          if (e.which === 13 || e.which === 32 || e.which === 27) {
	            close_menu(e);
	            return e.preventDefault();
	          } else if (e.which === 38 || e.which === 40) {
	            active_option = _this.local.active_option;
	            if (active_option == null) {
	              active_option = -1;
	            }
	            if (e.which === 38) {
	              active_option--;
	              if (active_option < 0) {
	                active_option = options.length - 1;
	              }
	            } else {
	              active_option++;
	              if (active_option > options.length - 1) {
	                active_option = 0;
	              }
	            }
	            set_active(active_option);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, BUTTON({
	      key: 'drop-anchor',
	      tabIndex: 0,
	      'aria-haspopup': "true",
	      'aria-owns': "dropMenu-" + this.local.key,
	      style: this.local.show_menu ? anchor_when_open_style : anchor_style,
	      className: "dropMenu-anchor " + (this.props.anchor_class_name ? this.props.anchor_class_name : ''),
	      onMouseEnter: open_menu_on === 'focus' && !browser.touch ? (function(_this) {
	        return function(e) {
	          _this.local.show_menu = true;
	          set_active(-1);
	          return save(_this.local);
	        };
	      })(this) : void 0,
	      onClick: open_menu_on !== 'focus' || browser.touch ? (function(_this) {
	        return function(e) {
	          if (fetch('tooltip').tip) {
	            clear_tooltip();
	          }
	          _this.local.show_menu = !_this.local.show_menu;
	          if (_this.local.show_menu) {
	            set_active(-1);
	          }
	          save(_this.local);
	          e.stopPropagation();
	          return e.preventDefault();
	        };
	      })(this) : void 0,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            _this.local.show_menu = !_this.local.show_menu;
	            if (_this.local.show_menu) {
	              set_active(0);
	            }
	            save(_this.local);
	            e.preventDefault();
	            return e.stopPropagation();
	          }
	        };
	      })(this),
	      "data-tooltip": this.props.anchor_tooltip
	    }, render_anchor(this.local.show_menu)), UL({
	      key: 'dropMenu-menu',
	      className: "dropmenu-menu " + (this.local.show_menu ? 'dropmenu-menu-open' : void 0),
	      id: "dropMenu-" + this.local.key,
	      role: "menu",
	      'aria-hidden': !this.local.show_menu,
	      hidden: !this.local.show_menu,
	      style: this.local.show_menu ? menu_when_open_style : menu_style
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = options.length; i < len; idx = ++i) {
	        option = options[idx];
	        results.push((function(_this) {
	          return function(option, idx) {
	            return LI({
	              key: option.label + "-" + idx,
	              role: "presentation"
	            }, A({
	              ref: "menuitem-" + idx,
	              role: "menuitem",
	              tabIndex: _this.local.active_option === idx ? 0 : -1,
	              href: option.href,
	              key: option.label + "-activate",
	              'data-action': option['data-action'],
	              className: "menu-item " + (_this.local.active_option === idx ? 'active-menu-item' : void 0),
	              style: _this.local.active_option === idx ? active_option_style : option_style,
	              onClick: function(e) {
	                if (_this.local.active_option !== idx) {
	                  set_active(idx);
	                }
	                return trigger(e);
	              },
	              onTouchEnd: function(e) {
	                if (_this.local.active_option !== idx) {
	                  set_active(idx);
	                }
	                return trigger(e);
	              },
	              onKeyDown: function(e) {
	                if (e.which === 13 || e.which === 32) {
	                  return trigger(e);
	                }
	              },
	              onFocus: function(e) {
	                if (_this.local.active_option !== idx) {
	                  set_active(idx);
	                }
	                return e.stopPropagation();
	              },
	              onMouseEnter: function() {
	                if (_this.local.active_option !== idx) {
	                  return set_active(idx);
	                }
	              },
	              onBlur: function(e) {
	                if (_this.local.active_option === idx) {
	                  _this.local.active_option = -1;
	                  return save(_this.local);
	                }
	              },
	              onMouseLeave: function(e) {
	                _this.local.active_option = -1;
	                save(_this.local);
	                return e.stopPropagation();
	              }
	            }, render_option(option, _this.local.active_option === idx)));
	          };
	        })(this)(option, idx));
	      }
	      return results;
	    }).call(this)));
	  }
	});
	
	styles += ".default_drop[data-widget=\"DropMenu\"] {\n  display: inline-block;\n  min-width: 170px;\n}\n.default_drop[data-widget=\"DropMenu\"] .dropMenu-anchor {\n  display: flex;\n}\n\n.default_drop[data-widget=\"DropMenu\"] .dropmenu-menu {\n  left: -9999px;\n  top: 26px;\n  border-radius: 8px;\n  overflow: hidden;\n  font-style: normal;\n  width: 280px;\n  box-shadow: 0 2px 8px rgba(0,0,0,.7);\n  background-color: rgb(238, 238, 238);\n  padding: 8px 0;\n}\n\n.default_drop[data-widget=\"DropMenu\"] .dropmenu-menu.dropmenu-menu-open {\n  left: 0;\n}\n\n.default_drop[data-widget=\"DropMenu\"] .menu-item {\n  padding: 8px 20px;\n  display: block;\n  font-weight: 600;\n  font-size: 18px;\n  text-transform: capitalize;\n  color: " + focus_blue + ";\n}\n\n.default_drop[data-widget=\"DropMenu\"] .menu-item.active-menu-item {\n  /* background-color: #eee; */\n  color: black;\n}";


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var ApplyFilters, FilterProposalsMenu, ManualProposalResort, ProposalSort, SortProposalsMenu, filter_options, opined_on, proposal_sort_keys, regexes, rnd_order, set_default_sort, sort_options;
	
	__webpack_require__(1);
	
	__webpack_require__(2);
	
	__webpack_require__(46);
	
	regexes = {};
	
	ApplyFilters = ReactiveComponent({
	  displayName: 'ApplyFilters',
	  render: function() {
	    var editor, filter, filter_out, filters, i, j, l, len, len1, len2, new_filter_out, passes, proposal, proposals, ref, ref1, ref2, text;
	    filters = fetch('filters');
	    filter_out = fetch('filtered');
	    filter_out.proposals || (filter_out.proposals = {});
	    proposals = fetch('/proposals');
	    new_filter_out = {};
	    ref = filters.for_proposals || [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      filter = ref[i];
	      if (!regexes[filter]) {
	        regexes[filter] = new RegExp(filter, 'i');
	      }
	    }
	    ref1 = proposals.proposals;
	    for (j = 0, len1 = ref1.length; j < len1; j++) {
	      proposal = ref1[j];
	      proposal = fetch(proposal);
	      editor = proposal_editor(proposal);
	      if (editor) {
	        editor = fetch(editor).name;
	      } else {
	        editor = "";
	      }
	      text = editor + " " + proposal.name + " " + proposal.description + " " + (prettyDate(proposal.created_at));
	      passes = true;
	      ref2 = filters.for_proposals || [];
	      for (l = 0, len2 = ref2.length; l < len2; l++) {
	        filter = ref2[l];
	        passes && (passes = !!text.match(regexes[filter]));
	      }
	      if (!passes) {
	        new_filter_out[proposal.key] = 1;
	      }
	    }
	    if (JSON.stringify(new_filter_out) !== JSON.stringify(filter_out.proposals)) {
	      filter_out.proposals = new_filter_out;
	      save(filter_out);
	    }
	    return SPAN(null);
	  }
	});
	
	proposal_sort_keys = {};
	
	window.stale_sort_order = function(sort_key) {
	  return fetch(sort_key).stale;
	};
	
	window.invalidate_proposal_sorts = function() {
	  var __, results, sort_key, v;
	  results = [];
	  for (sort_key in proposal_sort_keys) {
	    __ = proposal_sort_keys[sort_key];
	    v = fetch(sort_key);
	    v.force_resort = true;
	    results.push(save(v));
	  }
	  return results;
	};
	
	window.sorted_proposals = function(proposals, sort_key, require_force) {
	  var cached_order, dict_proposals, filter_out, filtered, i, j, k, keys, l, len, len1, len2, order, p, proposal, ref, sort, sorted;
	  if (!(sort_key in proposal_sort_keys)) {
	    proposal_sort_keys[sort_key] = true;
	  }
	  sort = fetch('sort_and_filter_proposals');
	  if (sort.name == null) {
	    set_default_sort();
	  }
	  proposals = (proposals || []).slice();
	  filter_out = fetch('filtered');
	  if (filter_out.proposals) {
	    filtered = [];
	    for (i = 0, len = proposals.length; i < len; i++) {
	      proposal = proposals[i];
	      if (filter_out.proposals[proposal.key]) {
	        filtered.push(proposal);
	      }
	    }
	    for (j = 0, len1 = filtered.length; j < len1; j++) {
	      proposal = filtered[j];
	      proposals.splice(proposals.indexOf(proposal), 1);
	    }
	  }
	  if ((sort.filter != null) && ((ref = sort.filter) != null ? ref.name : void 0) !== 'Show all') {
	    proposals = (function() {
	      var l, len2, results;
	      results = [];
	      for (l = 0, len2 = proposals.length; l < len2; l++) {
	        p = proposals[l];
	        if (sort.filter.passes(p)) {
	          results.push(p);
	        }
	      }
	      return results;
	    })();
	  }
	  proposals = sort.order(proposals);
	  if (require_force) {
	    keys = (function() {
	      var l, len2, ref1, results;
	      ref1 = proposals || [];
	      results = [];
	      for (l = 0, len2 = ref1.length; l < len2; l++) {
	        p = ref1[l];
	        results.push(p.key);
	      }
	      return results;
	    })();
	    order = JSON.stringify(keys);
	    sorted = fetch(sort_key);
	    if (!sorted.cache) {
	      cached_order = null;
	      _.extend(sorted, {
	        cache: [],
	        stale: true,
	        force_resort: true
	      });
	      save(sorted);
	    } else {
	      cached_order = JSON.stringify(sorted.cache);
	    }
	    if (cached_order === order) {
	      if (sorted.stale || sorted.force_resort) {
	        sorted.force_resort = false;
	        sorted.stale = false;
	        save(sorted);
	      }
	    } else if (sorted.force_resort || proposals.length !== sorted.cache.length) {
	      sorted.force_resort = false;
	      sorted.stale = false;
	      sorted.cache = keys;
	      save(sorted);
	    } else {
	      if (!sorted.stale) {
	        sorted.stale = true;
	        save(sorted);
	      }
	      dict_proposals = {};
	      for (l = 0, len2 = proposals.length; l < len2; l++) {
	        p = proposals[l];
	        dict_proposals[p.key] = p;
	      }
	      proposals = (function() {
	        var len3, m, ref1, results;
	        ref1 = sorted.cache;
	        results = [];
	        for (m = 0, len3 = ref1.length; m < len3; m++) {
	          k = ref1[m];
	          results.push(dict_proposals[k]);
	        }
	        return results;
	      })();
	    }
	  }
	  return proposals;
	};
	
	rnd_order = {};
	
	sort_options = [
	  {
	    key: 'total_score',
	    name: 'Total Score',
	    description: "Each proposal is scored by the sum of all opinions, where each opinion expresses a score on a spectrum from -1 to 1. ",
	    order: function(proposals) {
	      var cache, opinion_views, val;
	      cache = {};
	      opinion_views = fetch('opinion_views');
	      val = function(proposal) {
	        var groups, i, len, opinion, opinions, ref, salience, sum, w, weights;
	        if (!(proposal.key in cache)) {
	          opinions = fetch(proposal).opinions || [];
	          ref = compose_opinion_views(opinions, proposal, opinion_views), weights = ref.weights, salience = ref.salience, groups = ref.groups;
	          sum = 0;
	          for (i = 0, len = opinions.length; i < len; i++) {
	            opinion = opinions[i];
	            if (salience[opinion.user] < 1) {
	              continue;
	            }
	            w = weights[opinion.user];
	            sum += opinion.stance * w;
	          }
	          cache[proposal.key] = sum;
	        }
	        return cache[proposal.key];
	      };
	      return proposals.sort(function(a, b) {
	        return val(b) - val(a);
	      });
	    }
	  }, {
	    key: 'trending',
	    name: 'Trending',
	    description: "Same as 'Total Score', except newer proposals and opinions are weighed more heavily.",
	    order: function(proposals) {
	      var RECENCY_SENSITIVITY, cache, date_filter, filters_for_proposals, groups, i, j, last_activity, latest_timestamp, len, len1, n, o, opinion_views, opinions, ov, prop, ref, salience, val, weights;
	      cache = {};
	      n = Date.now();
	      ov = function(o) {
	        var ot;
	        ot = new Date(o.updated_at).getTime();
	        return o.stance / (1 + Math.pow((n - ot) / 100000, 2));
	      };
	      opinion_views = fetch('opinion_views');
	      filters_for_proposals = {};
	      last_activity = "0";
	      for (i = 0, len = proposals.length; i < len; i++) {
	        prop = proposals[i];
	        opinions = prop.opinions || fetch(prop).opinions || [];
	        filters_for_proposals[prop.key] = {
	          opinions: opinions,
	          views: compose_opinion_views(opinions, prop, opinion_views)
	        };
	        ref = filters_for_proposals[prop.key].views, weights = ref.weights, salience = ref.salience, groups = ref.groups;
	        for (j = 0, len1 = opinions.length; j < len1; j++) {
	          o = opinions[j];
	          if (salience[o.user] < 1 || weights[o.user] === 0) {
	            continue;
	          }
	          if (o.updated_at > last_activity) {
	            last_activity = o.updated_at;
	          }
	        }
	        if (prop.created_at > last_activity) {
	          last_activity = prop.created_at;
	        }
	      }
	      latest_timestamp = new Date(last_activity).getTime();
	      date_filter = fetch('opinion-date-filter');
	      if (date_filter.end) {
	        latest_timestamp = Math.min(date_filter.end, latest_timestamp);
	      }
	      RECENCY_SENSITIVITY = 100;
	      val = function(proposal) {
	        var l, len2, opinion, pt, ref1, sum, w;
	        if (!(proposal.key in cache)) {
	          opinions = filters_for_proposals[proposal.key].opinions;
	          ref1 = filters_for_proposals[proposal.key].views, weights = ref1.weights, salience = ref1.salience, groups = ref1.groups;
	          sum = 0;
	          for (l = 0, len2 = opinions.length; l < len2; l++) {
	            opinion = opinions[l];
	            if (salience[opinion.user] < 1) {
	              continue;
	            }
	            w = weights[opinion.user];
	            sum += opinion.stance * w;
	          }
	          pt = new Date(proposal.created_at).getTime();
	          if (sum < 0) {
	            cache[proposal.key] = sum * (1 + (latest_timestamp - pt) / RECENCY_SENSITIVITY);
	          } else {
	            cache[proposal.key] = sum / (1 + (latest_timestamp - pt) / RECENCY_SENSITIVITY);
	          }
	        }
	        return cache[proposal.key];
	      };
	      return proposals.sort(function(a, b) {
	        return val(b) - val(a);
	      });
	    }
	  }, {
	    key: 'recency',
	    order: function(proposals) {
	      return proposals.sort(function(a, b) {
	        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
	      });
	    },
	    name: 'Date: Most recent first',
	    description: "The proposals submitted most recently are shown first."
	  }, {
	    key: 'earliest',
	    order: function(proposals) {
	      return proposals.sort(function(a, b) {
	        return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
	      });
	    },
	    name: 'Date: Earliest first',
	    description: "The proposals submitted first are shown first."
	  }, {
	    key: 'unifying',
	    name: 'Most unifying first',
	    description: "The proposals on which participants are most united for or against are shown first.",
	    order: function(proposals) {
	      var i, j, len, len1, less_than_one, more_than_one, opinions, proposal, sort, sorted;
	      for (i = 0, len = sort_options.length; i < len; i++) {
	        sort = sort_options[i];
	        if (sort.name === 'Most polarizing first') {
	          sorted = sort.order(proposals);
	          sorted.reverse();
	          more_than_one = [];
	          less_than_one = [];
	          for (j = 0, len1 = sorted.length; j < len1; j++) {
	            proposal = sorted[j];
	            opinions = fetch(proposal).opinions || [];
	            if (opinions.length > 1) {
	              more_than_one.push(proposal);
	            } else {
	              less_than_one.push(proposal);
	            }
	          }
	          return more_than_one.concat(less_than_one);
	        }
	      }
	      return [];
	    }
	  }, {
	    key: 'polarizing',
	    name: 'Most polarizing first',
	    description: "The proposals on which participants are most split are shown highest.",
	    order: function(proposals) {
	      var cache, opinion_views, val;
	      cache = {};
	      opinion_views = fetch('opinion_views');
	      val = function(proposal) {
	        var avg, differences, groups, i, j, len, len1, opinion, opinions, ref, salience, std_dev, sum, w, weight, weights;
	        if (!(proposal.key in cache)) {
	          opinions = fetch(proposal).opinions || [];
	          ref = compose_opinion_views(opinions, proposal, opinion_views), weights = ref.weights, salience = ref.salience, groups = ref.groups;
	          sum = 0;
	          weight = 0;
	          for (i = 0, len = opinions.length; i < len; i++) {
	            opinion = opinions[i];
	            if (salience[opinion.user] < 1) {
	              continue;
	            }
	            w = weights[opinion.user];
	            sum += opinion.stance * w;
	            weight += w;
	          }
	          avg = sum / weight;
	          differences = 0;
	          weight = 0;
	          for (j = 0, len1 = opinions.length; j < len1; j++) {
	            opinion = opinions[j];
	            if (salience[opinion.user] < 1) {
	              continue;
	            }
	            w = weights[opinion.user];
	            differences += w * (opinion.stance - avg) * (opinion.stance - avg);
	            weight += w;
	          }
	          std_dev = Math.sqrt(differences / weight);
	          if (opinions.length > 1) {
	            cache[proposal.key] = std_dev * Math.log(opinions.length + 1);
	          } else {
	            cache[proposal.key] = -1;
	          }
	        }
	        return cache[proposal.key];
	      };
	      return proposals.sort(function(a, b) {
	        return val(b) - val(a);
	      });
	    }
	  }, {
	    key: 'average_score',
	    name: 'Average Score',
	    description: "Each proposal is scored by the average opinion, where each opinion expresses a score on a spectrum from -1 to 1. ",
	    order: function(proposals) {
	      var cache, opinion_views, val;
	      cache = {};
	      opinion_views = fetch('opinion_views');
	      val = function(proposal) {
	        var groups, i, len, opinion, opinions, ref, salience, sum, w, weight, weights;
	        if (!(proposal.key in cache)) {
	          opinions = fetch(proposal).opinions || [];
	          ref = compose_opinion_views(opinions, proposal, opinion_views), weights = ref.weights, salience = ref.salience, groups = ref.groups;
	          sum = 0;
	          weight = 0;
	          for (i = 0, len = opinions.length; i < len; i++) {
	            opinion = opinions[i];
	            if (salience[opinion.user] < 1) {
	              continue;
	            }
	            w = weights[opinion.user];
	            sum += opinion.stance * w;
	            weight += w;
	          }
	          cache[proposal.key] = sum / weight;
	        }
	        return cache[proposal.key];
	      };
	      return proposals.sort(function(a, b) {
	        return val(b) - val(a);
	      });
	    }
	  }, {
	    key: 'alphabetical',
	    name: 'Alphabetical order',
	    order: function(proposals) {
	      return proposals.sort(function(a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    description: "Sort alphabetically by the item's title"
	  }, {
	    key: 'random',
	    name: 'Randomized',
	    description: "Item order is randomized on each page load.",
	    order: function(proposals) {
	      return proposals.sort(function(a, b) {
	        var name1, name2;
	        rnd_order[name1 = a.key] || (rnd_order[name1] = Math.round(Math.random() * 99999) + 1);
	        rnd_order[name2 = b.key] || (rnd_order[name2] = Math.round(Math.random() * 99999) + 1);
	        return rnd_order[a.key] - rnd_order[b.key];
	      });
	    }
	  }
	];
	
	window.set_sort_order = function(name) {
	  var i, len, s, sort;
	  sort = fetch('sort_and_filter_proposals');
	  for (i = 0, len = sort_options.length; i < len; i++) {
	    s = sort_options[i];
	    if (s.name === name) {
	      _.extend(sort, s || sort_options[1]);
	      save(sort);
	      return;
	    }
	  }
	};
	
	set_default_sort = function() {
	  var def, def_sort, found, i, j, len, len1, loc, ref, ref1, s, sort;
	  sort = fetch('sort_and_filter_proposals');
	  if (sort.name == null) {
	    found = false;
	    loc = fetch('location');
	    if ((ref = loc.query_params) != null ? ref.sort_by : void 0) {
	      for (i = 0, len = sort_options.length; i < len; i++) {
	        s = sort_options[i];
	        if ((ref1 = loc.query_params.sort_by.replace('_', ' ')) === s.name || ref1 === s.key) {
	          _.extend(sort, s || sort_options[1]);
	          found = true;
	          break;
	        }
	      }
	    }
	    if (!found) {
	      if (def_sort = customization('default_proposal_sort_order')) {
	        def = null;
	        for (j = 0, len1 = sort_options.length; j < len1; j++) {
	          s = sort_options[j];
	          if (s.key === def_sort || s.name === def_sort) {
	            def = s;
	            break;
	          }
	        }
	        _.extend(sort, def || sort_options[1]);
	      } else {
	        _.extend(sort, sort_options[1]);
	      }
	    }
	    return save(sort);
	  }
	};
	
	ProposalSort = ReactiveComponent({
	  displayName: 'ProposalSort',
	  render: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (!subdomain.name) {
	      return SPAN(null);
	    }
	    return SPAN({
	      style: _.defaults(this.props.style || {})
	    }, DIV({
	      style: {
	        display: 'inline-block',
	        paddingRight: 12
	      }
	    }, SortProposalsMenu()));
	  }
	});
	
	opined_on = function(proposal) {
	  var ref;
	  return ((ref = proposal.your_opinion) != null ? ref.published : void 0) !== false;
	};
	
	filter_options = [
	  {
	    name: "All",
	    description: "All proposals shown.",
	    passes: function(proposal) {
	      return true;
	    }
	  }, {
	    name: "Completed",
	    description: "Only show proposals on which you've expressed an opinion.",
	    passes: function(proposal) {
	      return opined_on(proposal);
	    }
	  }, {
	    name: "Incomplete",
	    description: "Show proposals that you have not yet expressed an opinion about.",
	    passes: function(proposal) {
	      return !opined_on(proposal);
	    }
	  }
	];
	
	FilterProposalsMenu = ReactiveComponent({
	  displayName: 'FilterProposalsMenu',
	  render: function() {
	    var sort_and_filter_state;
	    sort_and_filter_state = fetch('sort_and_filter_proposals');
	    if (sort_and_filter_state.filter == null) {
	      sort_and_filter_state.filter = _.extend({}, filter_options[0]);
	    }
	    return DIV({
	      style: {
	        position: 'relative',
	        paddingLeft: 12
	      }
	    }, DropMenu({
	      className: 'default_drop bluedrop',
	      options: filter_options,
	      anchor_class_name: 'sort_proposals',
	      open_menu_on: 'activation',
	      selection_made_callback: function(option) {
	        invalidate_proposal_sorts();
	        _.extend(sort_and_filter_state.filter, option);
	        return save(sort_and_filter_state);
	      },
	      render_anchor: function() {
	        var current_filter;
	        current_filter = translator("engage.filter." + sort_and_filter_state.filter.name, sort_and_filter_state.filter.name);
	        if (current_filter.indexOf(':') > -1) {
	          current_filter = current_filter.split(':')[1];
	        }
	        return [
	          TRANSLATE("engage.filter_by", "show"), ": ", SPAN({
	            key: 'filter_name',
	            style: {
	              fontWeight: 700,
	              paddingLeft: 8
	            }
	          }, current_filter, SPAN({
	            style: _.extend(cssTriangle('bottom', 'white', 8, 5, {
	              display: 'inline-block',
	              marginLeft: 4,
	              marginBottom: 2
	            }))
	          }))
	        ];
	      },
	      render_option: function(option, is_active) {
	        return [
	          SPAN({
	            key: 'option-name',
	            "data-filter": option.name,
	            style: {
	              fontSize: 16,
	              marginBottom: 2
	            }
	          }, translator("engage.filter." + option.name, option.name)), !browser.is_mobile ? SPAN({
	            key: 'help icon',
	            style: {
	              float: 'right'
	            }
	          }, HelpIcon(translator("engage.filter." + option.name + ".description", option.description), {
	            color: 'black'
	          })) : void 0
	        ];
	      }
	    }));
	  }
	});
	
	SortProposalsMenu = ReactiveComponent({
	  displayName: 'SortProposalsMenu',
	  render: function() {
	    var sort;
	    sort = fetch('sort_and_filter_proposals');
	    if (sort.name == null) {
	      set_default_sort();
	    }
	    return DIV({
	      style: {
	        position: 'relative'
	      }
	    }, DropMenu({
	      className: 'default_drop bluedrop',
	      options: sort_options,
	      open_menu_on: 'activation',
	      selection_made_callback: function(option) {
	        invalidate_proposal_sorts();
	        _.extend(sort, option);
	        return save(sort);
	      },
	      render_anchor: function() {
	        var current_sort;
	        current_sort = translator("engage.sort_order." + sort.name, sort.name);
	        if (current_sort.indexOf(':') > -1) {
	          current_sort = current_sort.split(':')[1];
	        }
	        return [
	          TRANSLATE("engage.sort_by", "sort"), ": ", SPAN({
	            key: 'sort name',
	            style: {
	              fontWeight: 700,
	              paddingLeft: 8
	            }
	          }, current_sort, SPAN({
	            style: _.extend(cssTriangle('bottom', 'white', 8, 5, {
	              display: 'inline-block',
	              marginLeft: 4,
	              marginBottom: 2
	            }))
	          }))
	        ];
	      },
	      render_option: function(option, is_active) {
	        return [
	          SPAN({
	            key: 'sort name',
	            "data-sort": option.name,
	            style: {
	              fontSize: 16,
	              marginBottom: 2
	            }
	          }, translator("engage.sort_order." + option.name, option.name)), !browser.is_mobile ? SPAN({
	            key: 'help-icon',
	            style: {
	              float: 'right'
	            }
	          }, HelpIcon(translator("engage.sort_order." + option.name + ".description", option.description))) : void 0
	        ];
	      }
	    }));
	  }
	});
	
	ManualProposalResort = ReactiveComponent({
	  displayName: 'ManualProposalResort',
	  render: function() {
	    var sort;
	    sort = fetch('sort_and_filter_proposals');
	    if (!stale_sort_order(this.props.sort_key) || TABLET_SIZE()) {
	      return SPAN(null);
	    }
	    if (typeof running_timelapse_simulation !== "undefined" && running_timelapse_simulation !== null) {
	      invalidate_proposal_sorts();
	      return SPAN(null);
	    }
	    return DIV({
	      style: {
	        position: 'relative'
	      }
	    }, SPAN({
	      style: {
	        color: '#888',
	        fontSize: 10,
	        position: 'absolute',
	        top: -16,
	        left: 9,
	        width: 175
	      }
	    }, translator("engage.sort_order.out-of-order", "Proposals are out of order")), BUTTON({
	      style: {
	        color: 'white',
	        fontWeight: 800,
	        backgroundColor: selected_color,
	        textAlign: 'center',
	        fontSize: 12,
	        padding: '3px 16px',
	        border: 'none',
	        borderRadius: 8,
	        display: 'flex',
	        alignItems: 'center'
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          invalidate_proposal_sorts();
	          e.stopPropagation();
	          return e.preventDefault();
	        };
	      })(this)
	    }, SVG({
	      width: 17,
	      height: 20,
	      viewBox: "0 0 17 20",
	      dangerouslySetInnerHTML: {
	        __html: "<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g transform=\"translate(-318.000000, -564.000000)\" fill=\"#FFFFFF\" fill-rule=\"nonzero\">\n        <g transform=\"translate(318.000000, 564.000000)\">\n            <g transform=\"translate(0.000000, 0.000000)\">\n                <path d=\"M8.25687555,19.6225181 C8.33853565,19.7047747 8.47091122,19.7047747 8.55257132,19.6225181 L11.3646601,16.7891261 C11.4244669,16.7288791 11.4423691,16.6382674 11.4100203,16.5595369 C11.3776715,16.4808064 11.301441,16.4294337 11.2168695,16.4294337 L5.59257699,16.4294337 C5.5079845,16.4294337 5.4317111,16.4807419 5.39933258,16.559483 C5.36695405,16.6382241 5.38484894,16.7288641 5.44467062,16.7891261 L8.25687555,19.6225181 Z\" id=\"Path\"></path>\n                <path d=\"M16.7908878,13.4735403 L0.209108553,13.4735403 C0.0936262631,13.4735437 3.72626523e-16,13.5678642 3.72626523e-16,13.6842191 L3.72626523e-16,14.7154119 C3.72626523e-16,14.8317733 0.0936197098,14.9261042 0.209108553,14.9261075 L16.7908878,14.9261075 C16.906378,14.9261062 17,14.8317748 17,14.7154119 L17,13.6842191 C17,13.5678628 16.9063715,13.4735416 16.7908878,13.4735403 L16.7908878,13.4735403 Z\" id=\"Path\"></path>\n                <path d=\"M16.7908878,10.5683891 L0.209108553,10.5683891 C0.0936197098,10.5683925 3.72626523e-16,10.6627233 3.72626523e-16,10.7790848 L3.72626523e-16,11.8102776 C3.72626523e-16,11.926639 0.0936197098,12.0209699 0.209108553,12.0209732 L16.7908878,12.0209732 C16.906378,12.0209719 17,11.9266405 17,11.8102776 L17,10.7790848 C17,10.6627219 16.906378,10.5683904 16.7908878,10.5683891 Z\" id=\"Path\"></path>\n                <path d=\"M16.7908878,9.11580508 C16.9063715,9.11580379 17,9.02148266 17,8.90512636 L17,7.87393354 C17,7.75757065 16.906378,7.66323921 16.7908878,7.66323792 L0.209108553,7.66323792 C0.0936197098,7.66324127 3.72626523e-16,7.7575721 3.72626523e-16,7.87393354 L3.72626523e-16,8.90512636 C3.72626523e-16,9.02148121 0.0936262631,9.11580173 0.209108553,9.11580508 L16.7908878,9.11580508 Z\" id=\"Path\"></path>\n                <path d=\"M16.7908878,4.75810362 L0.209108553,4.75810362 C0.0936197098,4.75810697 3.72626523e-16,4.8524378 3.72626523e-16,4.96879924 L3.72626523e-16,5.99997515 C3.72626523e-16,6.1163366 0.0936197098,6.21066743 0.209108553,6.21067077 L16.7908878,6.21067077 C16.906378,6.21066949 17,6.11633805 17,5.99997515 L17,4.96879924 C17,4.85243635 16.906378,4.75810491 16.7908878,4.75810362 L16.7908878,4.75810362 Z\" id=\"Path\"></path>\n                <path d=\"M8.25687555,0.0616930268 L5.44467146,2.89508497 C5.38486178,2.95534863 5.36697453,3.04598071 5.39935153,3.12471442 C5.43172853,3.20344812 5.50799272,3.25476054 5.59257783,3.25476054 L11.2168707,3.25476054 C11.3014348,3.25476054 11.3776561,3.20338365 11.4100034,3.12466053 C11.4423507,3.04593741 11.4244561,2.95533361 11.3646613,2.89508497 L8.55257249,0.0616930268 C8.47091226,-0.0205643423 8.33853578,-0.0205643423 8.25687555,0.0616930268 L8.25687555,0.0616930268 Z\" id=\"Path\"></path>\n            </g>\n        </g>\n    </g>\n</g>"
	      }
	    }), SPAN({
	      style: {
	        padding: "2px 0 2px 8px",
	        whiteSpace: 'nowrap'
	      }
	    }, translator("engage.sort_order.resort", 'Re-sort'))));
	  }
	});
	
	window.ProposalSort = ProposalSort;
	
	window.SortProposalsMenu = SortProposalsMenu;
	
	window.FilterProposalsMenu = FilterProposalsMenu;
	
	window.ManualProposalResort = ManualProposalResort;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var CustomizeBackground, CustomizeDescription, CustomizeGoogleTranslate, CustomizeLogo, CustomizeTextBlock, CustomizeTitle, DEFAULT_TEXT_BLOCK_COLOR, DEFAULT_TEXT_BLOCK_OPACITY, UploadBackgroundImageSVG, UploadFileSVG, UploadableLogo;
	
	__webpack_require__(26);
	
	window.DEFAULT_BACKGROUND_COLOR = focus_blue;
	
	styles += ".toggle_switch_label {\n  padding: 4px 12px;\n  cursor: pointer;\n  margin-left: 12px;\n}\n.toggle_switch_label div {\n  font-size: 14px;\n}\n";
	
	CustomizeGoogleTranslate = ReactiveComponent({
	  displayName: 'CustomizeGoogleTranslate',
	  mixins: [SubdomainSaveRateLimiter],
	  componentDidUpdate: function() {
	    return this.save_customization_with_rate_limit({
	      fields: ['google_translate_style'],
	      config: fetch('/subdomain').customizations
	    });
	  },
	  render: function() {
	    var base, edit_forum, is_admin, is_light, ref, subdomain, trns;
	    if (customization('disable_google_translate')) {
	      return SPAN(null);
	    }
	    is_light = is_light_background();
	    subdomain = fetch('/subdomain');
	    if (subdomain.customizations.google_translate_style) {
	      if ((base = this.local).google_translate_style == null) {
	        base.google_translate_style = JSON.parse(JSON.stringify(subdomain.customizations.google_translate_style));
	      }
	    }
	    edit_forum = fetch('edit_forum');
	    is_admin = fetch('/current_user').is_admin;
	    trns = subdomain.customizations.google_translate_style;
	    return DIV({
	      style: {
	        paddingTop: (trns != null ? trns.callout : void 0) && !edit_forum.editing ? 24 : void 0
	      }
	    }, is_admin && edit_forum.editing ? DIV({
	      style: {
	        display: 'flex',
	        justifyContent: 'center',
	        paddingTop: !subdomain.customizations.banner.background_image_url ? 48 : void 0
	      }
	    }, LABEL({
	      className: 'toggle_switch'
	    }, INPUT({
	      id: 'enable_google_translate',
	      type: 'checkbox',
	      name: 'enable_google_translate',
	      checked: !!this.local.google_translate_style && this.local.google_translate_style !== '*delete*',
	      onChange: (function(_this) {
	        return function(ev) {
	          if (ev.target.checked) {
	            _this.local.google_translate_style = {
	              prominent: true,
	              callout: "¿No hablas ingles? Elige tu idioma:",
	              textAlign: "center"
	            };
	            return save(_this.local);
	          } else {
	            _this.local.google_translate_style = '*delete*';
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }), SPAN({
	      className: 'toggle_switch_circle'
	    })), LABEL({
	      className: 'toggle_switch_label',
	      style: {
	        backgroundColor: is_light ? 'rgba(255,255,255,.4)' : 'rgba(0,0,0,.4)'
	      },
	      htmlFor: 'enable_google_translate'
	    }, B(null, 'Enable Google Translate.'), DIV(null, "Helps support multi-lingual forums."))) : void 0, (trns != null ? trns.prominent : void 0) ? DIV({
	      className: "translator"
	    }, trns.callout != null ? DIV({
	      style: {
	        marginBottom: 16,
	        textAlign: 'center',
	        color: 'black'
	      }
	    }, edit_forum.editing ? AutoGrowTextArea({
	      className: 'banner_title',
	      defaultValue: (ref = this.local.google_translate_style) != null ? ref.callout : void 0,
	      style: {
	        color: 'inherit',
	        fontSize: 'inherit',
	        backgroundColor: 'transparent',
	        border: 'none',
	        width: '100%'
	      },
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.google_translate_style.callout = e.target.value;
	          return save(_this.local);
	        };
	      })(this)
	    }) : trns.callout) : void 0, DIV({
	      className: 'google-translate-candidate-container'
	    })) : void 0);
	  }
	});
	
	styles += "\n.CustomizeTitle > .banner_title {\n  display: block;\n  border: none;\n  background-color: transparent;\n  color: inherit;\n  width: 100%;\n  padding: 0px;\n  line-height: 1.4;\n}\n.CustomizeTitle > .banner_title::placeholder {\n  color: rgba(0,0,0,.4);\n}\n.dark .CustomizeTitle > .banner_title::placeholder, .with-image .CustomizeTitle > .banner_title::placeholder {\n  color: rgb(255,255,255,.6);\n}";
	
	CustomizeTitle = ReactiveComponent({
	  displayName: 'CustomizeTitle',
	  mixins: [SubdomainSaveRateLimiter],
	  componentDidUpdate: function() {
	    return this.save_customization_with_rate_limit({
	      fields: ['title'],
	      config: fetch('/subdomain').customizations.banner
	    });
	  },
	  render: function() {
	    var banner_config, base, edit_forum, is_admin, subdomain, title;
	    subdomain = fetch('/subdomain');
	    edit_forum = fetch('edit_forum');
	    if ((base = subdomain.customizations).banner == null) {
	      base.banner = {};
	    }
	    banner_config = subdomain.customizations.banner;
	    title = banner_config.title || this.props.title;
	    is_admin = fetch('/current_user').is_admin;
	    return DIV({
	      className: 'CustomizeTitle'
	    }, is_admin && edit_forum.editing ? AutoGrowTextArea({
	      id: 'banner_primary_input',
	      className: 'banner_title',
	      defaultValue: title,
	      style: this.props.style,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.title = e.target.value;
	          return save(_this.local);
	        };
	      })(this),
	      placeholder: translator('banner.title.placeholder', 'A headline for your forum')
	    }) : DIV({
	      className: 'banner_title',
	      style: this.props.style,
	      dangerouslySetInnerHTML: {
	        __html: title || subdomain.name
	      },
	      onDoubleClick: is_admin ? (function(_this) {
	        return function() {
	          var int;
	          edit_forum.editing = true;
	          save(edit_forum);
	          return int = setInterval(function() {
	            var textarea;
	            textarea = document.getElementById('banner_primary_input');
	            if (textarea) {
	              textarea.focus();
	              textarea.setSelectionRange(-1, -1);
	              return clearInterval(int);
	            }
	          }, 10);
	        };
	      })(this) : void 0
	    }));
	  }
	});
	
	styles += ".single-line.banner_description, .single-line.banner_description .ql-editor {\n  text-align: center;\n}\n\n#forum-description .ql-editor.ql-blank::before {\n  text-align: left;\n}\n\n.banner_description.wysiwyg_text, .banner_description #editor {\n  padding: 6px 8px;\n  min-height: 20px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n#edit_banner_description .ql-editor {\n  min-height: 48px;\n}\n.wrapper.with-image .CustomizeDescription .ql-editor.ql-blank::before {\n  color: rgba(255,255,255,.4);\n} \n\n";
	
	CustomizeDescription = ReactiveComponent({
	  displayName: 'CustomizeDescription',
	  mixins: [SubdomainSaveRateLimiter],
	  componentDidMount: function() {
	    return this.setAlignment();
	  },
	  componentDidUpdate: function() {
	    this.local.description = fetch("forum-description").html;
	    this.save_customization_with_rate_limit({
	      fields: ['description'],
	      config: fetch('/subdomain').customizations.banner
	    });
	    return this.setAlignment();
	  },
	  setAlignment: function() {
	    var edit_forum, height, is_admin, single_line;
	    if (!this.refs.description) {
	      return;
	    }
	    edit_forum = fetch('edit_forum');
	    is_admin = fetch('/current_user').is_admin;
	    height = this.refs.description.clientHeight;
	    single_line = height < (edit_forum.editing && is_admin ? 65 : 50);
	    if (single_line) {
	      return this.refs.description.classList.add('single-line');
	    } else {
	      return this.refs.description.classList.remove('single-line');
	    }
	  },
	  render: function() {
	    var description, edit_forum, focus_on_mount, has_description, is_admin, is_light, ref;
	    edit_forum = fetch('edit_forum');
	    is_admin = fetch('/current_user').is_admin;
	    description = (ref = customization('banner')) != null ? ref.description : void 0;
	    has_description = (description != null ? description.trim().length : void 0) > 0 && description.trim() !== '<p><br></p>';
	    is_light = is_light_background();
	    focus_on_mount = this.local.focus_on_mount;
	    this.local.focus_on_mount = false;
	    WINDOW_WIDTH();
	    if (is_admin && edit_forum.editing) {
	      return DIV({
	        id: 'edit_banner_description',
	        className: "banner_description CustomizeDescription",
	        ref: "description"
	      }, WysiwygEditor({
	        editor_key: "forum-description",
	        style: this.props.style,
	        horizontal: true,
	        html: description,
	        placeholder: translator("banner.description.label", "Describe your forum. What is being discussed? Who is it for, and who are the hosts? How long will it be open?"),
	        focus_on_mount: focus_on_mount,
	        button_style: {
	          backgroundColor: 'white'
	        }
	      }));
	    } else {
	      return DIV(null, has_description ? DIV({
	        className: "banner_description wysiwyg_text",
	        ref: "description",
	        dangerouslySetInnerHTML: {
	          __html: description
	        },
	        onDoubleClick: is_admin ? (function(_this) {
	          return function() {
	            edit_forum.editing = true;
	            _this.local.focus_on_mount = true;
	            save(edit_forum);
	            return setTimeout(function() {
	              var ref1, ref2;
	              if ((ref1 = _this.refs.primary_input) != null) {
	                ref1.focus();
	              }
	              return (ref2 = _this.refs.primary_input) != null ? ref2.setSelectionRange(-1, -1) : void 0;
	            });
	          };
	        })(this) : void 0
	      }) : this.props.opts.supporting_text ? this.props.opts.supporting_text() : void 0);
	    }
	  }
	});
	
	UploadFileSVG = function(opts) {
	  return SVG({
	    dangerouslySetInnerHTML: {
	      __html: '<g><path d="M89.4,46.5c-2.3,0-4.1,1.8-4.1,4.1v28.2H14.6V50.5c0-2.3-1.8-4.1-4.1-4.1c-2.3,0-4.1,1.8-4.1,4.1v32.4   c0,2.3,1.8,4.1,4.1,4.1h78.9c2.3,0,4.1-1.8,4.1-4.1V50.5C93.5,48.3,91.7,46.5,89.4,46.5z"></path><path d="M52.7,14.2c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1,0-0.1-0.1-0.3-0.2c-0.6-0.5-1.4-0.7-2.2-0.7c-0.5,0-1.1,0.1-1.6,0.3   c-0.5,0.2-1,0.5-1.4,0.8L26.8,34.3c-0.8,0.8-1.2,1.9-1.2,3c0,1.1,0.5,2,1.2,2.7c0.8,0.8,1.7,1.2,2.9,1.2s2.2-0.4,2.9-1.2l13-13.1   v41.6c0,2.3,1.8,4.1,4.1,4.1c2.3,0,4.1-1.8,4.1-4.1V26.9L67.1,40c0.8,0.8,1.7,1.2,2.9,1.2s2.2-0.4,2.9-1.2c0.8-0.8,1.2-1.9,1.2-3   c0-1.1-0.5-2-1.2-2.7L52.7,14.2z"></path></g>'
	    },
	    height: opts.height || 100,
	    width: opts.height || 100,
	    fill: opts.fill || '#fff',
	    x: 0,
	    y: 0,
	    viewBox: "0 0 100 100",
	    style: {
	      enableBackground: "new 0 0 100 100"
	    }
	  });
	};
	
	UploadableLogo = function(opts) {
	  var delete_size, edit_forum, editing, has_logo, icon_height, is_light, ref, ref1, wrapper_style;
	  edit_forum = fetch('edit_forum');
	  editing = edit_forum.editing;
	  has_logo = (ref = customization('banner')) != null ? (ref1 = ref.logo) != null ? ref1.url : void 0 : void 0;
	  icon_height = 50;
	  wrapper_style = {};
	  is_light = is_light_background();
	  if (editing) {
	    wrapper_style = {
	      position: 'relative',
	      minWidth: !has_logo ? 100 : void 0,
	      minHeight: !has_logo ? 100 : void 0,
	      height: '100%',
	      width: '100%'
	    };
	  }
	  return DIV({
	    style: wrapper_style
	  }, has_logo ? IMG({
	    style: opts.image_style,
	    src: opts.src
	  }) : void 0, editing && has_logo ? (delete_size = 30, BUTTON({
	    style: {
	      width: delete_size,
	      height: delete_size,
	      position: 'absolute',
	      right: 4,
	      top: 4,
	      border: 'none',
	      background: 'none',
	      cursor: 'pointer',
	      padding: 0,
	      zIndex: 1
	    },
	    onClick: function() {
	      return document.querySelector(opts.trigger_delete).click();
	    }
	  }, SVG({
	    height: delete_size,
	    width: delete_size,
	    fill: '#fff',
	    x: 0,
	    y: 0,
	    viewBox: "0 0 511.995 511.995",
	    style: {
	      enableBackground: "new 0 0 511.995 511.995"
	    },
	    dangerouslySetInnerHTML: {
	      __html: "<g>\n  <path d=\"M437.126,74.939c-99.826-99.826-262.307-99.826-362.133,0C26.637,123.314,0,187.617,0,256.005\n    s26.637,132.691,74.993,181.047c49.923,49.923,115.495,74.874,181.066,74.874s131.144-24.951,181.066-74.874\n    C536.951,337.226,536.951,174.784,437.126,74.939z M409.08,409.006c-84.375,84.375-221.667,84.375-306.042,0\n    c-40.858-40.858-63.37-95.204-63.37-153.001s22.512-112.143,63.37-153.021c84.375-84.375,221.667-84.355,306.042,0\n    C493.435,187.359,493.435,324.651,409.08,409.006z\"/>\n  <path d=\"M341.525,310.827l-56.151-56.071l56.151-56.071c7.735-7.735,7.735-20.29,0.02-28.046\n    c-7.755-7.775-20.31-7.755-28.065-0.02l-56.19,56.111l-56.19-56.111c-7.755-7.735-20.31-7.755-28.065,0.02\n    c-7.735,7.755-7.735,20.31,0.02,28.046l56.151,56.071l-56.151,56.071c-7.755,7.735-7.755,20.29-0.02,28.046\n    c3.868,3.887,8.965,5.811,14.043,5.811s10.155-1.944,14.023-5.792l56.19-56.111l56.19,56.111\n    c3.868,3.868,8.945,5.792,14.023,5.792c5.078,0,10.175-1.944,14.043-5.811C349.28,331.117,349.28,318.562,341.525,310.827z\"/>\n</g>"
	    }
	  }))) : void 0, editing && !has_logo ? DIV({
	    style: {
	      height: icon_height,
	      width: icon_height,
	      position: 'absolute',
	      left: '50%',
	      top: '50%',
	      marginLeft: -icon_height / 2,
	      marginTop: -icon_height / 2,
	      cursor: 'pointer',
	      zIndex: 1
	    },
	    onClick: function() {
	      return document.querySelector(opts.trigger_upload).click();
	    }
	  }, UploadFileSVG({
	    height: icon_height,
	    fill: is_light ? 'black' : 'white'
	  })) : void 0);
	};
	
	styles += "\n@media " + NOT_LAPTOP_MEDIA + " {\n  .CustomizeLogo {\n    position: relative;\n  }\n  .CustomizeLogo img {\n    margin: auto;\n    display: block;\n  }\n}";
	
	CustomizeLogo = ReactiveComponent({
	  displayName: 'CustomizeLogo',
	  mixins: [SubdomainSaveRateLimiter],
	  componentDidUpdate: function() {
	    return this.save_customization_with_rate_limit({
	      fields: ['height', 'left', 'top'],
	      config: fetch('/subdomain').customizations.banner.logo
	    });
	  },
	  render: function() {
	    var edit_banner, edit_forum, h, has_logo, has_masthead, height, is_light, onMouseDown, onMouseDownResize, onMouseMove, onMouseMoveResize, onMouseUp, ref, ref1, ref10, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, src, style;
	    edit_forum = fetch('edit_forum');
	    edit_banner = fetch('edit_banner');
	    has_logo = edit_banner.logo_preview !== '*delete*' && (edit_banner.logo_preview || ((ref = customization('banner')) != null ? (ref1 = ref.logo) != null ? ref1.url : void 0 : void 0));
	    has_masthead = edit_banner.masthead_preview !== '*delete*' && (edit_banner.masthead_preview || ((ref2 = customization('banner')) != null ? ref2.background_image_url : void 0));
	    if (!has_logo && !edit_forum.editing) {
	      return SPAN(null);
	    }
	    if (!fetch('/subdomain').name) {
	      return SPAN(null);
	    }
	    src = edit_banner.logo_preview || ((ref3 = customization('banner')) != null ? (ref4 = ref3.logo) != null ? ref4.url : void 0 : void 0);
	    if (has_logo) {
	      h = this.local.height || ((ref5 = customization('banner')) != null ? (ref6 = ref5.logo) != null ? ref6.height : void 0 : void 0) || 150;
	      height = parseInt(h);
	    } else {
	      height = 150;
	    }
	    is_light = is_light_background();
	    style = _.defaults({}, this.props.style, {
	      cursor: edit_forum.editing ? 'move' : void 0,
	      height: height + 2,
	      width: !has_logo ? 150 : void 0,
	      zIndex: this.local.moving || this.local.resizing ? '999' : void 0,
	      overflow: 'hidden'
	    });
	    if (!TABLET_SIZE()) {
	      _.extend(style, {
	        left: this.local.left || ((ref7 = customization('banner')) != null ? (ref8 = ref7.logo) != null ? ref8.left : void 0 : void 0) || 50,
	        top: this.local.top || ((ref9 = customization('banner')) != null ? (ref10 = ref9.logo) != null ? ref10.top : void 0 : void 0) || 68,
	        position: 'absolute'
	      });
	    }
	    onMouseDown = (function(_this) {
	      return function(ev) {
	        var el, l, t;
	        t = 0;
	        l = 0;
	        el = ev.target;
	        while (el) {
	          t += el.offsetTop;
	          l += el.offsetLeft;
	          el = el.offsetParent;
	        }
	        _this.local.start_left = ev.pageX - l;
	        _this.local.start_top = ev.pageY - t;
	        _this.local.moving = true;
	        save(_this.local);
	        document.addEventListener("mouseup", onMouseUp);
	        document.addEventListener("mousemove", onMouseMove);
	        ev.preventDefault();
	        return ev.stopPropagation();
	      };
	    })(this);
	    onMouseUp = (function(_this) {
	      return function(ev) {
	        _this.local.moving = _this.local.resizing = false;
	        save(_this.local);
	        document.removeEventListener("mouseup", onMouseUp);
	        document.removeEventListener("mousemove", onMouseMove);
	        return document.removeEventListener("mousemove", onMouseMoveResize);
	      };
	    })(this);
	    onMouseMove = (function(_this) {
	      return function(ev) {
	        var banner_top, el;
	        if (_this.local.moving) {
	          el = document.querySelector('#banner');
	          banner_top = 0;
	          while (el) {
	            banner_top += el.offsetTop;
	            el = el.offsetParent;
	          }
	          _this.local.left = Math.max(0, ev.pageX - _this.local.start_left);
	          if (isNaN(_this.local.left)) {
	            _this.local.left = 50;
	          }
	          _this.local.top = Math.max(0, ev.pageY - banner_top - _this.local.start_top);
	          if (isNaN(_this.local.top)) {
	            _this.local.top = 50;
	          }
	          save(_this.local);
	          ev.stopPropagation();
	          return ev.preventDefault();
	        }
	      };
	    })(this);
	    onMouseDownResize = (function(_this) {
	      return function(ev) {
	        _this.local.startY = ev.pageY;
	        _this.local.start_height = height;
	        _this.local.resizing = true;
	        save(_this.local);
	        document.addEventListener("mouseup", onMouseUp);
	        document.addEventListener("mousemove", onMouseMoveResize);
	        ev.preventDefault();
	        return ev.stopPropagation();
	      };
	    })(this);
	    onMouseMoveResize = (function(_this) {
	      return function(ev) {
	        if (_this.local.resizing) {
	          _this.local.height = _this.local.start_height + (ev.pageY - _this.local.startY);
	          save(_this.local);
	          ev.stopPropagation();
	          return ev.preventDefault();
	        }
	      };
	    })(this);
	    if (edit_forum.editing) {
	      _.extend(style, {
	        borderStyle: !has_logo ? 'dashed' : 'solid',
	        borderColor: is_light ? "rgba(0,0,0,.7)" : 'rgba(255,255,255,.7)',
	        borderWidth: 1,
	        left: style.left - 1,
	        top: style.top - 1
	      });
	    }
	    return DIV({
	      className: 'CustomizeLogo',
	      style: _.defaults({}, style, {
	        opacity: !has_logo ? 1 : void 0
	      }),
	      onMouseUp: edit_forum.editing ? onMouseUp : void 0,
	      onMouseDown: edit_forum.editing ? onMouseDown : void 0,
	      onMouseMove: edit_forum.editing ? onMouseMove : void 0
	    }, has_logo || edit_forum.editing ? UploadableLogo({
	      trigger_upload: 'input#logo',
	      trigger_delete: 'button#delete_logo',
	      src: src,
	      image_style: {
	        height: height
	      }
	    }) : void 0, edit_forum.editing ? DIV({
	      style: {
	        position: 'absolute',
	        fontSize: 14,
	        color: is_light ? 'rgba(0,0,0)' : 'rgba(255,255,255)',
	        zIndex: 1,
	        bottom: 0,
	        marginTop: 60,
	        width: '100%',
	        textAlign: 'center'
	      }
	    }, !has_logo ? translator('banner.logo_label', 'Logo (optional)') : BUTTON({
	      style: {
	        color: 'inherit',
	        border: 'none',
	        textDecoration: 'underline',
	        padding: 0,
	        backgroundColor: !is_light ? 'rgba(0,0,0,.3)' : 'rgba(255,255,255,.3)'
	      },
	      onClick: function() {
	        return document.querySelector('input#logo').click();
	      }
	    }, translator('banner.change_logo', 'change'))) : void 0, edit_forum.editing ? DIV({
	      style: {
	        backgroundColor: has_masthead && !has_logo ? (!is_light ? 'rgba(0,0,0,.4)' : 'rgba(255,255,255,.4)') : void 0,
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        pointerEvents: 'none'
	      }
	    }) : void 0, has_logo && edit_forum.editing ? DIV({
	      onMouseDown: edit_forum.editing ? onMouseDownResize : void 0,
	      onMouseMove: edit_forum.editing ? onMouseMoveResize : void 0,
	      style: {
	        backgroundColor: is_light ? "black" : "white",
	        height: 17 * 2,
	        width: 17 * 2,
	        position: 'absolute',
	        bottom: -17,
	        right: -17,
	        cursor: 'nwse-resize',
	        transform: 'rotate(45deg)',
	        zIndex: 2
	      }
	    }) : void 0);
	  }
	});
	
	DEFAULT_TEXT_BLOCK_COLOR = "#000000";
	
	DEFAULT_TEXT_BLOCK_OPACITY = 255 * .8;
	
	CustomizeTextBlock = ReactiveComponent({
	  displayName: 'CustomizeTextBlock',
	  mixins: [SubdomainSaveRateLimiter],
	  componentDidUpdate: function() {
	    return this.save_customization_with_rate_limit({
	      fields: ['text_background_css', 'text_background_css_opacity'],
	      config: fetch('/subdomain').customizations.banner
	    });
	  },
	  render: function() {
	    var edit_forum, has_masthead, ref, ref1, ref2;
	    edit_forum = fetch('edit_forum');
	    has_masthead = (ref = customization('banner')) != null ? ref.background_image_url : void 0;
	    if (!edit_forum.editing || !has_masthead) {
	      return SPAN(null);
	    }
	    return DIV({
	      style: {
	        width: 80,
	        position: 'absolute',
	        right: 5,
	        bottom: 0
	      }
	    }, INPUT({
	      id: 'text_background_css',
	      type: 'color',
	      name: 'text_background_css',
	      defaultValue: ((ref1 = customization('banner')) != null ? ref1.text_background_css : void 0) || DEFAULT_TEXT_BLOCK_COLOR,
	      style: {
	        width: '100%',
	        display: 'block'
	      },
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.text_background_css = e.target.value;
	          return save(_this.local);
	        };
	      })(this)
	    }), INPUT({
	      id: 'text_background_css_opacity',
	      type: 'range',
	      min: 0,
	      step: 1,
	      max: 255,
	      name: 'text_background_css_opacity',
	      defaultValue: ((ref2 = customization('banner')) != null ? ref2.text_background_css_opacity : void 0) || DEFAULT_TEXT_BLOCK_OPACITY,
	      style: {
	        width: '100%',
	        display: 'block'
	      },
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.text_background_css_opacity = e.target.value;
	          return save(_this.local);
	        };
	      })(this)
	    }));
	  }
	});
	
	UploadBackgroundImageSVG = function(opts) {
	  return SVG({
	    dangerouslySetInnerHTML: {
	      __html: '<g><path d="M64.3,53.9l-7.4-10.4c-0.6-0.8-1.7-0.9-2.4-0.2l-4.2,4.1c-0.7,0.7-1.8,0.6-2.4-0.2L37.5,33.3c-0.7-0.9-2-0.8-2.6,0.1     L17.9,60.3c-0.7,1,0.1,2.4,1.4,2.4H58C59.4,59.3,61.6,56.3,64.3,53.9z"></path><circle cx="59.3" cy="30.5" r="5.9"></circle><path d="M84.6,54V13.1c0-1.4-1.1-2.6-2.6-2.6H5.1c-1.4,0-2.6,1.1-2.6,2.6v60.7c0,1.4,1.2,2.6,2.6,2.6h57c2.2,7.5,9.1,13,17.3,13     c10,0,18.1-8.1,18.1-18.1C97.5,63.1,92,56.2,84.6,54z M7.6,15.7h71.8v37.6c0,0,0,0,0,0c-10,0-18.1,8.1-18.1,18.1H7.6V15.7z      M79.4,84.3c-7.1,0-13-5.8-13-13c0-7.1,5.8-13,13-13c7.1,0,13,5.8,13,13C92.4,78.5,86.6,84.3,79.4,84.3z"></path><path d="M84.9,68.8L81,63.6c-0.4-0.5-1-0.8-1.6-0.8c0,0,0,0,0,0c-0.6,0-1.2,0.3-1.6,0.8l-3.9,5.2c-0.5,0.6-0.5,1.4-0.2,2.1     c0.3,0.7,1,1.1,1.8,1.1h1.6v5.9c0,1.3,1,2.3,2.3,2.3c1.3,0,2.3-1,2.3-2.3V72h1.6c0.8,0,1.4-0.4,1.8-1.1     C85.5,70.2,85.4,69.4,84.9,68.8L84.9,68.8z"></path></g></g></g>'
	    },
	    height: opts.height || 100,
	    width: opts.width || opts.height || 100,
	    fill: opts.fill || '#fff',
	    x: "0px",
	    y: "0px",
	    viewBox: "0 0 100 100"
	  });
	};
	
	CustomizeBackground = ReactiveComponent({
	  displayName: 'CustomizeBackground',
	  mixins: [SubdomainSaveRateLimiter],
	  componentDidUpdate: function() {
	    return this.save_customization_with_rate_limit({
	      fields: ['background_css'],
	      config: fetch('/subdomain').customizations.banner,
	      wait_for: 10
	    });
	  },
	  render: function() {
	    var color, compressed, edit_banner, edit_forum, editing, has_masthead, icon_height, is_light, ref, ref1, src;
	    edit_forum = fetch('edit_forum');
	    edit_banner = fetch('edit_banner');
	    src = edit_banner.masthead_preview || ((ref = customization('banner')) != null ? ref.background_image_url : void 0);
	    has_masthead = edit_banner.masthead_preview !== '*delete*' && src;
	    editing = edit_forum.editing;
	    if (!editing) {
	      return SPAN(null);
	    }
	    is_light = is_light_background();
	    icon_height = 50;
	    color = is_light ? 'rgba(0,0,0,1)' : 'rgba(255,255,255,1)';
	    compressed = CONTENT_WIDTH() < 1036;
	    return DIV({
	      style: {
	        textAlign: compressed ? 'right' : void 0
	      }
	    }, DIV({
	      style: {
	        position: 'relative',
	        float: !compressed ? 'right' : void 0,
	        backgroundColor: is_light ? 'rgba(255,255,255,.4)' : 'rgba(0,0,0,.4)',
	        padding: '12px 24px',
	        zIndex: 9,
	        marginTop: compressed ? 12 : has_masthead && !compressed ? -120 : -100,
	        display: 'inline-block'
	      }
	    }, DIV({
	      style: {
	        display: 'flex',
	        flexDirection: 'column'
	      }
	    }, DIV({
	      style: {
	        cursor: 'pointer',
	        display: 'flex',
	        alignItems: 'center',
	        flexDirection: 'column',
	        padding: 4,
	        border: "1px dashed " + (is_light ? 'black' : 'white'),
	        borderRadius: 4
	      },
	      onClick: function() {
	        return document.querySelector('input#masthead').click();
	      }
	    }, DIV({
	      style: {
	        margin: 'auto',
	        height: icon_height,
	        width: icon_height
	      }
	    }, UploadBackgroundImageSVG({
	      height: icon_height,
	      fill: is_light ? 'black' : 'white'
	    })), DIV({
	      style: {
	        fontSize: 14,
	        color: color,
	        marginBottom: 4
	      }
	    }, has_masthead ? DIV({
	      style: {
	        display: 'flex'
	      }
	    }, BUTTON({
	      className: 'like_link',
	      style: {
	        color: color,
	        fontSize: 12
	      }
	    }, 'change'), SPAN({
	      style: {
	        padding: '0px 4px'
	      }
	    }, '•'), BUTTON({
	      className: 'like_link',
	      style: {
	        cursor: 'pointer',
	        zIndex: 1,
	        color: color,
	        fontSize: 12
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          e.stopPropagation();
	          e.preventDefault();
	          _this.local.background_css = DEFAULT_BACKGROUND_COLOR;
	          save(_this.local);
	          return document.querySelector('button#delete_masthead').click();
	        };
	      })(this)
	    }, 'remove')) : translator('banner.upload_background_label', 'Set background pic'))), DIV({
	      style: {
	        fontSize: 14,
	        position: 'relative'
	      }
	    }, has_masthead ? LABEL({
	      style: {
	        color: color,
	        marginRight: 4,
	        display: 'flex',
	        marginTop: 4,
	        justifyContent: 'center'
	      },
	      htmlFor: "background_color"
	    }, SELECT({
	      id: 'background_color',
	      type: 'dropdown',
	      name: 'background_color',
	      value: is_light,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.background_css = e.target.value === 'true' ? "rgb(255,255,255)" : 'rgb(0,0,0)';
	          return save(_this.local);
	        };
	      })(this)
	    }, OPTION({
	      value: true
	    }, 'background is light'), OPTION({
	      value: false
	    }, 'background is dark'))) : LABEL({
	      style: {
	        color: color,
	        marginRight: 8,
	        display: 'flex',
	        marginTop: 4,
	        alignItems: 'center',
	        justifyContent: 'center'
	      },
	      htmlFor: "background_color"
	    }, translator("banner.background_css.label", "...or set to color") + ':', INPUT({
	      id: 'background_color',
	      type: 'color',
	      style: {
	        marginLeft: 4
	      },
	      name: 'background_color',
	      value: this.local.background_css || ((ref1 = customization('banner')) != null ? ref1.background_css : void 0) || DEFAULT_BACKGROUND_COLOR,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.background_css = e.target.value;
	          return save(_this.local);
	        };
	      })(this)
	    }))))));
	  }
	});
	
	window.EditBanner = ReactiveComponent({
	  displayName: 'EditBanner',
	  render: function() {
	    var current_user, delete_logo, delete_masthead, edit_banner, edit_forum, is_light, ref, ref1, subdomain;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    edit_banner = fetch('edit_banner');
	    edit_forum = fetch('edit_forum');
	    if (!current_user.is_admin) {
	      return DIV(null);
	    }
	    is_light = is_light_background();
	    delete_masthead = (function(_this) {
	      return function(e) {
	        edit_banner.masthead_preview = '*delete*';
	        _this.refs.masthead_file_input.value = '';
	        _this.delete_masthead = true;
	        return save(edit_banner);
	      };
	    })(this);
	    delete_logo = (function(_this) {
	      return function(e) {
	        edit_banner.logo_preview = '*delete*';
	        _this.refs.logo_file_input.value = '';
	        _this.delete_logo = true;
	        return save(edit_banner);
	      };
	    })(this);
	    return DIV(null, !edit_forum.editing ? EditForum() : void 0, this.local.file_errors ? DIV({
	      style: {
	        color: 'red'
	      }
	    }, this.local.file_errors) : void 0, FORM({
	      id: 'banner_files',
	      action: '/update_images_hack',
	      style: {
	        display: 'none'
	      }
	    }, INPUT({
	      id: 'logo',
	      type: 'file',
	      name: 'logo',
	      accept: "image/jpg, image/jpeg, image/pjpeg, image/png, image/x-png, image/gif, image/webp",
	      ref: 'logo_file_input',
	      onChange: (function(_this) {
	        return function(ev) {
	          edit_banner.logo_preview = URL.createObjectURL(ev.target.files[0]);
	          _this.delete_logo = false;
	          return save(edit_banner);
	        };
	      })(this)
	    }), INPUT({
	      id: 'masthead',
	      type: 'file',
	      accept: "image/jpg, image/jpeg, image/pjpeg, image/png, image/x-png, image/gif, image/webp",
	      name: 'masthead',
	      ref: 'masthead_file_input',
	      onChange: (function(_this) {
	        return function(ev) {
	          var canvas, ctx, files, fr, img, tgt;
	          edit_banner.masthead_preview = URL.createObjectURL(ev.target.files[0]);
	          _this.delete_masthead = false;
	          img = document.createElement('img');
	          img.crossOrigin = "Anonymous";
	          tgt = ev.target;
	          files = tgt.files;
	          canvas = document.createElement("canvas");
	          ctx = canvas.getContext("2d");
	          if (FileReader && files && files.length) {
	            fr = new FileReader();
	            fr.onload = function() {
	              img.onload = function() {
	                var image_data;
	                canvas.width = img.width;
	                canvas.height = img.height;
	                ctx.drawImage(img, 0, 0, img.width, img.height);
	                image_data = ctx.getImageData(0, 0, img.width, img.height).data;
	                is_light = is_image_mostly_light(image_data, img.width, img.height);
	                if (is_light) {
	                  subdomain.customizations.banner.background_css = 'rgb(255,255,255)';
	                } else {
	                  subdomain.customizations.banner.background_css = 'rgb(0,0,0)';
	                }
	                return save(subdomain);
	              };
	              return img.src = fr.result;
	            };
	            fr.readAsDataURL(files[0]);
	          }
	          return save(edit_banner);
	        };
	      })(this)
	    })), BUTTON({
	      onClick: delete_masthead,
	      id: 'delete_masthead',
	      style: {
	        display: 'none '
	      }
	    }), edit_banner.logo_preview !== '*delete*' && (edit_banner.logo_preview || ((ref = customization('banner')) != null ? (ref1 = ref.logo) != null ? ref1.url : void 0 : void 0)) ? BUTTON({
	      id: 'delete_logo',
	      onClick: delete_logo,
	      style: {
	        display: 'none'
	      }
	    }) : void 0);
	  },
	  exit_edit: function() {
	    var edit_banner, k, v, wysiwyg_description;
	    edit_banner = fetch('edit_banner');
	    for (k in edit_banner) {
	      v = edit_banner[k];
	      if (k !== 'key') {
	        delete edit_banner[k];
	      }
	    }
	    wysiwyg_description = fetch("forum-description");
	    wysiwyg_description.html = null;
	    save(wysiwyg_description);
	    return save(edit_banner);
	  },
	  componentDidUpdate: function() {
	    var ref, ref1, ref2, ref3, submit_logo, submit_masthead;
	    submit_masthead = ((ref = this.refs.masthead_file_input) != null ? (ref1 = ref.files) != null ? ref1.length : void 0 : void 0) > 0;
	    submit_logo = ((ref2 = this.refs.logo_file_input) != null ? (ref3 = ref2.files) != null ? ref3.length : void 0 : void 0) > 0;
	    if (submit_masthead || submit_logo || this.delete_logo || this.delete_masthead) {
	      return this.submit_files();
	    }
	  },
	  submit_files: function(cb) {
	    var data, subdomain;
	    subdomain = fetch('/subdomain');
	    data = {
	      authenticity_token: arest.csrf()
	    };
	    if (this.delete_logo) {
	      data.logo = '*delete*';
	    }
	    if (this.delete_masthead) {
	      data.masthead = '*delete*';
	    }
	    return ajax_submit_files_in_form({
	      form: '#banner_files',
	      type: 'PUT',
	      additional_data: data,
	      success: (function(_this) {
	        return function(response) {
	          var i, len, obj, ref, ref1, resp;
	          _this.delete_logo = false;
	          _this.delete_masthead = false;
	          if ((ref = _this.refs.masthead_file_input) != null) {
	            ref.value = null;
	          }
	          if ((ref1 = _this.refs.logo_file_input) != null) {
	            ref1.value = null;
	          }
	          try {
	            resp = JSON.parse(response);
	          } catch (error) {
	            console.error("Could not parse server response", response);
	            resp = [];
	          }
	          for (i = 0, len = resp.length; i < len; i++) {
	            obj = resp[i];
	            arest.updateCache(obj);
	          }
	          return typeof cb === "function" ? cb(true) : void 0;
	        };
	      })(this),
	      error: (function(_this) {
	        return function(response) {
	          var ref, ref1;
	          response = JSON.parse(response.response);
	          _this.local.file_errors = response.error || 'Error uploading files!';
	          save(_this.local);
	          alert(_this.local.file_errors);
	          if ((ref = _this.refs.masthead_file_input) != null) {
	            ref.value = null;
	          }
	          if ((ref1 = _this.refs.logo_file_input) != null) {
	            ref1.value = null;
	          }
	          return typeof cb === "function" ? cb(false) : void 0;
	        };
	      })(this)
	    });
	  }
	});
	
	window.PhotoBanner = function(opts) {
	  var background_color, banner_config, convert_opacity, description, edit_banner, edit_forum, has_description, has_image_background, has_title, has_translation_callout, homepage, is_dark_theme, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, subdomain, tab_background_color, text_block_background, text_block_color, text_block_is_dark, text_block_opacity, text_color;
	  if (opts == null) {
	    opts = {};
	  }
	  homepage = is_a_dialogue_page();
	  subdomain = fetch('/subdomain');
	  edit_banner = fetch('edit_banner');
	  edit_forum = fetch('edit_forum');
	  if (!subdomain.name) {
	    return SPAN(null);
	  }
	  tab_background_color = (edit_forum.editing ? edit_banner.text_background_css : void 0) || ((ref = customization('banner')) != null ? ref.text_background_css : void 0) || '#666';
	  if (!homepage) {
	    return DIV({
	      style: {
	        backgroundColor: 'white'
	      }
	    }, DIV({
	      style: {
	        margin: 'auto',
	        fontSize: 43,
	        padding: '10px 20px'
	      }
	    }, back_to_homepage_button({
	      fontSize: 32
	    }, translator('engage.back_to_homepage', 'Homepage'))));
	  }
	  has_image_background = edit_banner.masthead_preview !== '*delete*' && (edit_banner.masthead_preview || ((ref1 = customization('banner')) != null ? ref1.background_image_url : void 0));
	  convert_opacity = function(value) {
	    if (!value) {
	      return '00';
	    } else {
	      return parseInt(value).toString(16);
	    }
	  };
	  banner_config = subdomain.customizations.banner;
	  description = fetch("forum-description").html || (banner_config != null ? banner_config.description : void 0) || opts.supporting_text;
	  has_description = opts.supporting_text || ((description != null ? description.trim().length : void 0) > 0 && description.trim() !== '<p><br></p>');
	  has_title = ((ref2 = banner_config.title || opts.title || subdomain.name) != null ? ref2.length : void 0) > 0;
	  has_translation_callout = (ref3 = subdomain.customizations.google_translate_style) != null ? ref3.callout : void 0;
	  background_color = ((ref4 = customization('banner')) != null ? ref4.background_css : void 0) || DEFAULT_BACKGROUND_COLOR;
	  is_dark_theme = !is_light_background();
	  if (has_image_background) {
	    text_block_color = edit_banner.text_background_css || ((ref5 = customization('banner')) != null ? ref5.text_background_css : void 0) || DEFAULT_TEXT_BLOCK_COLOR;
	    text_block_opacity = parseInt(edit_banner.text_background_css_opacity || ((ref6 = customization('banner')) != null ? ref6.text_background_css_opacity : void 0) || DEFAULT_TEXT_BLOCK_OPACITY);
	    text_block_background = ("" + text_block_color + (convert_opacity(text_block_opacity))) || 'rgba(0, 0, 0, .8)';
	    if (text_block_opacity > 126) {
	      text_block_is_dark = !is_light_background(text_block_color);
	    } else {
	      text_block_is_dark = is_dark_theme;
	    }
	    text_color = text_block_is_dark ? 'white' : 'black';
	  } else {
	    text_color = is_light_background(background_color) ? 'black' : 'white';
	  }
	  return DIV({
	    id: 'banner',
	    className: "PhotoBanner"
	  }, STYLE({
	    dangerouslySetInnerHTML: {
	      __html: ".PhotoBanner {\n  position: relative;\n  color: black;\n  padding-top: " + (edit_forum.editing ? '54px' : '0px') + ";\n}\n.dark .PhotoBanner {\n  color: white;\n}\n.PhotoBanner > .wrapper.with-image {\n  background-image: url(" + (edit_banner.masthead_preview || ((ref7 = customization('banner')) != null ? ref7.background_image_url : void 0)) + ");\n  background-size: cover;\n  background-position: center;\n  padding-top: 120px;           \n}\n.PhotoBanner > .wrapper.no-image {\n  background: " + background_color + ";\n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .PhotoBanner > .wrapper {\n    padding-top: 64px;\n  }\n}\n\n.PhotoBanner > .wrapper.with-image.with-translation-callout {\n  padding-top: 64px;\n}\n\n.PhotoBanner > .wrapper .translator {\n  padding: 16px;\n  max-width: 380px;\n  margin: 0 auto; \n  background-color: rgba(255,255,255,.8);\n  position: relative; \n}\n\n.PhotoBanner > .wrapper > .text_block {\n  padding: 64px 48px 48px 48px;\n  width: " + (HOMEPAGE_WIDTH()) + "px;\n  max-width: " + (720 + 48 * 2) + "px;\n  margin: auto;\n  color: " + text_color + ";\n  position: relative;\n  top: 0;          \n} \n\n.PhotoBanner > .wrapper.with-image > .text_block {\n  background-color: " + text_block_background + ";\n} \n\n\n// .dark .PhotoBanner > .wrapper > .text_block, .PhotoBanner > .wrapper.with-image > .text_block {\n//  color: black;\n// }\n\n.PhotoBanner > .wrapper .CustomizeTitle .banner_title {\n  font-size: 50px;\n  font-weight: 700;\n  font-family: " + (header_font()) + ";\n  text-align: center;\n  margin-bottom: " + (has_description || edit_forum.editing ? 28 : 0) + "px;\n  text-shadow: 0px 1px 2px rgba(0,0,0,.4);\n}\n\n@media " + TABLET_MEDIA + " {\n  .PhotoBanner > .wrapper .CustomizeTitle .banner_title {\n    font-size: 36px;\n  }        \n  .PhotoBanner > .wrapper > .text_block {\n    padding: 48px 32px 32px 32px;\n  }\n\n}  \n@media " + PHONE_MEDIA + " {\n  .PhotoBanner > .wrapper .CustomizeTitle .banner_title {\n    font-size: 24px;\n  }        \n  .PhotoBanner > .wrapper > .text_block {\n    padding: 36px 24px 24px 24px;\n  }\n}  \n\n\n.PhotoBanner #tabs {\n  margin-top: 100px;\n  top: 0;\n  z-index: 0;\n}\n\n.PhotoBanner > .wrapper.no-image #tabs {\n  margin-top: 48px;\n  top: 0;\n}\n\n\n\n.PhotoBanner #tabs > ul {\n}\n.PhotoBanner #tabs > ul > li {\n  margin: 2px 6px 0px 6px;\n  background-color: " + tab_background_color + ";          \n}          \n.PhotoBanner #tabs > ul > li.selected {\n  background-color: " + main_background_color + ";\n}\n.PhotoBanner #tabs > ul > li > h4 {\n  //text-transform: uppercase;\n  font-family: " + (header_font()) + ";\n  font-weight: 600;\n  font-size: 17px;\n  padding: 10px 16px 4px;\n}\n.dark .PhotoBanner #tabs > ul > li > h4 {\n}\n.PhotoBanner #tabs > ul > li.selected > h4, .PhotoBanner #tabs > ul > li.selected > h4 {\n  // color: black;        \n}"
	    }
	  }), DIV({
	    className: "wrapper " + (has_image_background ? 'with-image' : 'no-image') + " " + (has_translation_callout ? 'with-translation-callout' : 'no-translation-callout')
	  }, CustomizeLogo(), CustomizeGoogleTranslate(), has_description || has_title || edit_forum.editing ? DIV({
	    className: 'text_block',
	    style: opts.header_style
	  }, CustomizeTextBlock(), CustomizeTitle({
	    title: opts.header,
	    style: opts.header_text_style
	  }), CustomizeDescription({
	    key: 'editable_description',
	    opts: opts,
	    style: {
	      border: !has_description ? (has_image_background || is_dark_theme ? '1px solid rgba(255,255,255,.5)' : '1px solid rgba(0,0,0,.5)') : void 0
	    }
	  })) : void 0, CustomizeBackground(), HomepageTabs(opts)));
	};
	
	window.MediaBanner = function() {
	  var bg, convert_opacity, edit_banner, has_image_background, homepage, ref, ref1, subdomain;
	  homepage = is_a_dialogue_page();
	  subdomain = fetch('/subdomain');
	  edit_banner = fetch('edit_banner');
	  if (!subdomain.name) {
	    return SPAN(null);
	  }
	  if (!homepage) {
	    return DIV({
	      style: {
	        backgroundColor: 'white'
	      }
	    }, DIV({
	      style: {
	        margin: 'auto',
	        fontSize: 43,
	        padding: '10px 20px'
	      }
	    }, back_to_homepage_button({
	      fontSize: 32
	    }, translator('engage.back_to_homepage', 'Homepage'))));
	  }
	  has_image_background = edit_banner.masthead_preview !== '*delete*' && (edit_banner.masthead_preview || ((ref = customization('banner')) != null ? ref.background_image_url : void 0));
	  if (has_image_background) {
	    bg = edit_banner.masthead_preview || ((ref1 = customization('banner')) != null ? ref1.background_image_url : void 0);
	  }
	  convert_opacity = function(value) {
	    if (!value) {
	      return '00';
	    } else {
	      return parseInt(value).toString(16);
	    }
	  };
	  return DIV({
	    id: 'banner',
	    className: "MediaBanner"
	  }, STYLE({
	    dangerouslySetInnerHTML: {
	      __html: "\n.MediaBanner {\n  position: relative;\n  color: black;\n  background-color: #eee;\n  padding: 0px 2px;\n  border-bottom: 1px solid black;\n} .dark .MediaBanner {\n  color: white;\n}\n.MediaBanner > .upper_wrapper {\n  padding-top: 28px;\n  background-color: white;\n}\n\n.MediaBanner > .upper_wrapper .CustomizeTitle .banner_title {\n  font-size: 60px;\n  font-weight: 700;\n  font-family: " + (header_font()) + ";\n  text-align: left;\n  margin-left: 36px;\n  margin-bottom: 22px;\n}\n.MediaBanner > .image_wrapper {\n  padding: 20px 36px;\n} \n.MediaBanner > .image_wrapper > img {\n  object-fit: cover;\n  display: block;\n  height: 260px;\n  width: 100%;\n}\n.MediaBanner #tabs {\n  margin-top: 0;\n  top: 0;\n  border-top: 1px solid #ccc;\n  box-shadow: 0 1px 3px rgba(0,0,0,.15);\n}\n.MediaBanner #tabs > ul {\n  text-align: left;\n  width: 100%;\n  padding-left: 20px;          \n}\n.MediaBanner #tabs > ul > li {\n  background-color: transparent;\n  margin: 0px 6px;          \n}          \n.MediaBanner #tabs > ul > li > h4 {\n  text-transform: uppercase;\n  font-family: " + (customization('font')) + ";\n  font-weight: 600;\n  font-size: 16px;\n  padding: 16px 8px 24px;\n  color: black;\n}\n.dark .MediaBanner #tabs > ul > li > h4 {\n  color: white;\n}\n\n.MediaBanner #tabs > ul > li.selected > h4, \n.MediaBanner #tabs > ul > li:hover > h4 {\n  color: black;\n  text-decoration: underline;\n}\n.dark .MediaBanner #tabs > ul > li.selected > h4, \n.dark .MediaBanner #tabs > ul > li:hover > h4 {\n  color: white;\n}"
	    }
	  }), DIV({
	    className: 'upper_wrapper'
	  }, CustomizeGoogleTranslate(), CustomizeTitle(), CustomizeBackground(), HomepageTabs()), has_image_background ? DIV({
	    className: 'image_wrapper'
	  }, IMG({
	    src: bg
	  })) : void 0);
	};
	
	window.ImageHeader = function(opts) {
	  var is_light, loc, ref, ref1, ref2, subdomain;
	  subdomain = fetch('/subdomain');
	  loc = fetch('location');
	  if (!subdomain.name) {
	    return SPAN(null);
	  }
	  opts || (opts = {});
	  _.defaults(opts, {
	    background_color: ((ref = customization('banner')) != null ? ref.background_css : void 0) || DEFAULT_BACKGROUND_COLOR,
	    background_image_url: (ref1 = customization('banner')) != null ? ref1.background_image_url : void 0,
	    text: (ref2 = customization('banner')) != null ? ref2.title : void 0,
	    external_link: subdomain.external_project_url
	  });
	  is_light = is_light_background();
	  return DIV({
	    style: {
	      backgroundColor: opts.background_color
	    }
	  }, IMG({
	    alt: opts.background_image_alternative_text,
	    src: opts.background_image_url,
	    style: {
	      width: '100%'
	    }
	  }), opts.text ? H1({
	    style: {
	      textAlign: 'center',
	      color: 'white',
	      margin: 'auto',
	      fontSize: 60,
	      fontWeight: 700,
	      position: 'relative',
	      paddingTop: 30
	    }
	  }, opts.text) : void 0, CustomizeBackground(), HomepageTabs(opts));
	};
	
	window.ShortHeader = function(opts) {
	  var background_is_light, homepage, loc, ref, ref1, ref2, subdomain;
	  subdomain = fetch('/subdomain');
	  loc = fetch('location');
	  if (!subdomain.name) {
	    return SPAN(null);
	  }
	  homepage = is_a_dialogue_page();
	  opts || (opts = {});
	  _.defaults(opts, customization('forum_header') || {}, {
	    text: ((ref = customization('banner')) != null ? ref.title : void 0) || subdomain.name,
	    external_link: subdomain.external_project_url,
	    logo_src: (ref1 = customization('banner')) != null ? (ref2 = ref1.logo) != null ? ref2.url : void 0 : void 0,
	    logo_height: 50,
	    min_height: 70,
	    padding: '8px 0',
	    padding_left_icon: 20
	  });
	  opts.background = 'transparent';
	  background_is_light = true;
	  return DIV({
	    style: {
	      background: opts.background
	    }
	  }, DIV({
	    style: {
	      position: 'relative',
	      padding: opts.padding,
	      minHeight: opts.min_height,
	      display: 'flex',
	      flexDirection: 'row',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      width: homepage ? HOMEPAGE_WIDTH() : void 0,
	      margin: homepage ? 'auto' : void 0
	    }
	  }, DIV({
	    style: {
	      paddingLeft: !homepage ? opts.padding_left_icon : 0,
	      paddingRight: 20,
	      height: opts.logo_height ? opts.logo_height : void 0,
	      display: 'flex',
	      alignItems: 'center'
	    }
	  }, opts.logo_src ? A({
	    href: !homepage ? '/' : opts.external_link,
	    style: {
	      fontSize: 0,
	      cursor: !homepage && !opts.external_link ? 'default' : void 0,
	      verticalAlign: 'middle',
	      display: 'block'
	    }
	  }, IMG({
	    src: opts.logo_src,
	    alt: subdomain.name + " logo",
	    style: {
	      height: opts.logo_height
	    }
	  })) : void 0, !homepage ? DIV({
	    style: {
	      paddingRight: 18,
	      position: opts.logo_src ? 'absolute' : void 0,
	      bottom: opts.logo_src ? -30 : void 0,
	      left: opts.logo_src ? 7 : void 0
	    }
	  }, back_to_homepage_button({
	    color: !background_is_light && !opts.logo_src ? 'white' : void 0,
	    fontSize: 18,
	    fontWeight: 600
	  }, TRANSLATE("engage.navigate_back_to_homepage", 'homepage'))) : void 0), opts.text ? H2({
	    style: {
	      color: !background_is_light ? 'white' : void 0,
	      marginLeft: opts.logo_src ? 35 : void 0,
	      paddingRight: 90,
	      fontSize: 32,
	      fontWeight: 400
	    }
	  }, opts.text) : void 0));
	};
	
	window.HawaiiHeader = function(opts) {
	  var background_color, homepage, is_light, ref, ref1, ref2, ref3, subdomain, subtitle_is_html;
	  homepage = is_a_dialogue_page();
	  subdomain = fetch('/subdomain');
	  if (!subdomain.name) {
	    return SPAN(null);
	  }
	  background_color = opts.background_color || ((ref = customization('banner')) != null ? ref.background_css : void 0) || DEFAULT_BACKGROUND_COLOR;
	  is_light = is_light_background(background_color);
	  opts || (opts = {});
	  _.defaults(opts, {
	    background_color: background_color,
	    background_image_url: opts.background_image_url || ((ref1 = customization('banner')) != null ? ref1.background_image_url : void 0),
	    logo: (ref2 = customization('banner')) != null ? (ref3 = ref2.logo) != null ? ref3.url : void 0 : void 0,
	    logo_width: 200,
	    title: '<title is required>',
	    subtitle: null,
	    title_style: {},
	    subtitle_style: {},
	    tab_style: {},
	    homepage_button_style: {}
	  });
	  _.defaults(opts.title_style, {
	    fontSize: 47,
	    color: is_light ? 'black' : 'white',
	    fontWeight: 300,
	    display: 'inline-block'
	  });
	  _.defaults(opts.subtitle_style, {
	    position: 'relative',
	    fontSize: 22,
	    color: is_light ? 'black' : 'white',
	    marginTop: 0,
	    opacity: .7,
	    textAlign: 'center'
	  });
	  _.defaults(opts.homepage_button_style, {
	    display: 'inline-block',
	    color: is_light ? 'black' : 'white',
	    position: 'absolute',
	    left: -80,
	    fontSize: opts.title_style.fontSize,
	    fontWeight: 400,
	    paddingLeft: 25,
	    paddingRight: 25,
	    cursor: fetch('location').url !== '/' ? 'pointer' : void 0
	  });
	  return DIV({
	    style: {
	      position: 'relative',
	      padding: "30px 0",
	      backgroundPosition: 'center',
	      backgroundSize: 'cover',
	      backgroundImage: "url(" + opts.background_image_url + ")",
	      backgroundColor: opts.background_color
	    }
	  }, STYLE(null, '.profile_anchor.login {font-size: 26px; padding-top: 16px;}\np {margin-bottom: 1em}'), DIV({
	    style: {
	      margin: 'auto',
	      width: HOMEPAGE_WIDTH(),
	      position: 'relative',
	      textAlign: homepage ? 'center' : void 0
	    }
	  }, back_to_homepage_button(opts.homepage_button_style), homepage && opts.logo ? IMG({
	    alt: opts.logo_alternative_text,
	    src: opts.logo,
	    style: {
	      width: opts.logo_width,
	      display: 'block',
	      margin: 'auto',
	      paddingTop: 20
	    }
	  }) : void 0, H1({
	    style: opts.title_style
	  }, opts.title), homepage && opts.subtitle ? (subtitle_is_html = opts.subtitle.indexOf('<') > -1 && opts.subtitle.indexOf('>') > -1, DIV({
	    style: opts.subtitle_style,
	    dangerouslySetInnerHTML: subtitle_is_html ? {
	      __html: opts.subtitle
	    } : void 0
	  }, !subtitle_is_html ? opts.subtitle : void 0)) : void 0, homepage ? DIV({
	    style: {
	      position: 'relative',
	      margin: get_tabs() ? '62px auto 0 auto' : void 0,
	      width: HOMEPAGE_WIDTH()
	    }
	  }, HomepageTabs({
	    tab_style: opts.tab_style,
	    tab_wrapper_style: _.defaults({}, opts.tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color,
	      margin: '0 6px'
	    }),
	    active_style: _.defaults({}, opts.tab_active_style || {}, {
	      backgroundColor: 'white',
	      color: 'black'
	    }),
	    active_tab_wrapper_style: _.defaults({}, opts.active_tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color
	    }),
	    wrapper_style: _.defaults({}, opts.tabs_wrapper_style || {}, {
	      marginTop: 80,
	      top: 0
	    }),
	    list_style: opts.tabs_list_style || {}
	  })) : void 0));
	};
	
	window.SeattleHeader = function(opts) {
	  var HEADING, active_style, external_link_style, homepage, idx, paragraph, paragraph_style, quote_style, ref, section, section_heading_style, subdomain;
	  homepage = is_a_dialogue_page();
	  subdomain = fetch('/subdomain');
	  if (!subdomain.name) {
	    return SPAN(null);
	  }
	  opts || (opts = {});
	  _.defaults(opts, {
	    external_link: subdomain.external_project_url,
	    background_color: '#fff',
	    background_image_url: (ref = customization('banner')) != null ? ref.background_image_url : void 0,
	    external_link_style: {},
	    quote_style: {},
	    paragraph_style: {},
	    section_heading_style: {}
	  });
	  paragraph_style = _.defaults(opts.paragraph_style, {
	    fontSize: 18,
	    color: '#444',
	    paddingTop: 10,
	    display: 'block'
	  });
	  quote_style = _.defaults(opts.quote_style, {
	    fontStyle: 'italic',
	    margin: 'auto',
	    padding: "40px 40px",
	    fontSize: paragraph_style.fontSize,
	    color: paragraph_style.color
	  });
	  section_heading_style = _.defaults(opts.section_heading_style, {
	    display: 'block',
	    fontWeight: 400,
	    fontSize: 28,
	    color: 'black'
	  });
	  external_link_style = _.defaults(opts.external_link_style, {
	    display: 'block',
	    position: 'absolute',
	    top: 22,
	    left: 20,
	    color: "#0B4D92"
	  });
	  if (!homepage) {
	    return DIV({
	      style: {
	        backgroundColor: 'white'
	      }
	    }, DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto',
	        fontSize: 43,
	        padding: '10px 0'
	      }
	    }, A({
	      href: '/'
	    }, '< ', SPAN({
	      style: {
	        fontSize: 32,
	        position: 'relative',
	        left: 5
	      }
	    }, 'Homepage'))));
	  }
	  return DIV({
	    style: {
	      position: 'relative'
	    }
	  }, opts.external_link ? A({
	    href: opts.external_link,
	    target: '_blank',
	    style: opts.external_link_style
	  }, I({
	    className: 'fa fa-chevron-left',
	    style: {
	      display: 'inline-block',
	      marginRight: 5
	    }
	  }), opts.external_link_anchor || opts.external_link) : void 0, opts.background_image_url ? IMG({
	    alt: opts.background_image_alternative_text,
	    style: _.defaults({}, opts.image_style, {
	      width: '100%',
	      display: 'block'
	    }),
	    src: opts.background_image_url
	  }) : void 0, DIV({
	    style: {
	      padding: '20px 0'
	    }
	  }, DIV({
	    style: {
	      width: HOMEPAGE_WIDTH(),
	      margin: 'auto'
	    }
	  }, opts.quote ? DIV({
	    style: quote_style
	  }, "“" + opts.quote.what + "”", opts.quote.who ? DIV({
	    style: {
	      paddingLeft: '70%',
	      paddingTop: 10
	    }
	  }, "– " + opts.quote.who) : void 0) : void 0, DIV(null, (function() {
	    var i, len, ref1, results;
	    ref1 = opts.sections;
	    results = [];
	    for (idx = i = 0, len = ref1.length; i < len; idx = ++i) {
	      section = ref1[idx];
	      results.push(DIV({
	        style: {
	          marginBottom: 20
	        }
	      }, section.label ? (HEADING = idx === 0 ? H1 : DIV, HEADING({
	        style: _.defaults({}, section.label_style || {}, section_heading_style)
	      }, section.label)) : void 0, DIV(null, (function() {
	        var j, len1, ref2, results1;
	        ref2 = section.paragraphs || [];
	        results1 = [];
	        for (j = 0, len1 = ref2.length; j < len1; j++) {
	          paragraph = ref2[j];
	          results1.push(SPAN({
	            style: paragraph_style,
	            dangerouslySetInnerHTML: {
	              __html: paragraph
	            }
	          }));
	        }
	        return results1;
	      })())));
	    }
	    return results;
	  })()), opts.salutation ? DIV({
	    style: _.extend({}, paragraph_style, {
	      marginTop: 10
	    })
	  }, opts.salutation.text ? DIV({
	    style: {
	      marginBottom: 18
	    }
	  }, opts.salutation.text) : void 0, A({
	    href: opts.external_link ? opts.external_link : void 0,
	    target: '_blank',
	    style: {
	      display: 'block',
	      marginBottom: 8
	    }
	  }, opts.salutation.image ? IMG({
	    src: opts.salutation.image,
	    alt: '',
	    style: {
	      height: 70
	    }
	  }) : opts.salutation.from), opts.salutation.after ? DIV({
	    style: _.extend({}, paragraph_style, {
	      margin: 0
	    }),
	    dangerouslySetInnerHTML: {
	      __html: opts.salutation.after
	    }
	  }) : void 0) : void 0, opts.login_callout ? AuthCallout() : void 0, opts.closed ? DIV({
	    style: {
	      marginTop: 40,
	      backgroundColor: "#F06668",
	      color: 'white',
	      fontSize: 28,
	      textAlign: 'center',
	      padding: "30px 42px"
	    }
	  }, "The comment period is now closed. Thank you for your input!") : void 0), true ? (active_style = _.defaults({}, opts.tab_active_style || {}, {
	    opacity: 1,
	    borderColor: named_colors.teal,
	    backgroundColor: 'white'
	  }), DIV({
	    style: {
	      borderBottom: get_tabs() ? "1px solid " + active_style.borderColor : void 0
	    }
	  }, DIV({
	    style: {
	      width: HOMEPAGE_WIDTH(),
	      margin: 'auto'
	    }
	  }, HomepageTabs({
	    tab_style: _.defaults({}, opts.tab_style || {}, {
	      padding: '10px 30px 0px 30px',
	      color: named_colors.teal,
	      border: '1px solid',
	      borderBottom: 'none',
	      borderColor: 'transparent',
	      fontSize: 18,
	      fontWeight: 700,
	      opacity: 0.3
	    }),
	    tab_wrapper_style: _.defaults({}, opts.tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color
	    }),
	    active_style: active_style,
	    active_tab_wrapper_style: _.defaults({}, opts.active_tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color
	    }),
	    wrapper_style: _.defaults({}, opts.tabs_wrapper_style || {}),
	    list_style: opts.tabs_list_style || {}
	  })))) : void 0));
	};


/***/ },
/* 49 */
/***/ function(module, exports) {

	window.Comment = ReactiveComponent({
	  displayName: 'Comment',
	  render: function() {
	    var anonymous, comment, comment_action_style, commentor_name, commentor_opinion, current_user, point, proposal;
	    comment = fetch(this.props.comment);
	    current_user = fetch('/current_user');
	    point = fetch(comment.point);
	    proposal = fetch(point.proposal);
	    commentor_name = fetch(comment.user).name;
	    commentor_opinion = _.findWhere(proposal.opinions, {
	      user: comment.user
	    });
	    anonymous = (commentor_opinion != null ? commentor_opinion.hide_name : void 0) || comment.hide_name;
	    if ((anonymous || customization('anonymize_permanently')) && current_user.user === comment.user) {
	      commentor_name += " [" + (your_opinion_i18n.anon_assurance()) + "]";
	    }
	    if (comment.editing) {
	      return EditComment({
	        fresh: false,
	        point: comment.point,
	        key: comment.key,
	        proposal: proposal
	      });
	    } else {
	      return DIV({
	        key: comment.key,
	        "data-id": comment.key,
	        className: 'comment_entry'
	      }, DIV({
	        className: 'comment_entry_name'
	      }, commentor_name + ':'), Avatar({
	        key: comment.user,
	        anonymous: anonymous,
	        hide_popover: true,
	        set_bg_color: true,
	        style: {
	          position: 'absolute',
	          width: 50,
	          height: 50
	        }
	      }), DIV({
	        className: 'comment_entry_body'
	      }, splitParagraphs(comment.body)), current_user.user === comment.user ? permit('update comment', comment) > 0 ? (comment_action_style = {
	        color: '#444',
	        textDecoration: 'underline',
	        cursor: 'pointer',
	        padding: '0 10px 0 0',
	        backgroundColor: 'transparent',
	        border: 'none'
	      }, DIV({
	        style: {
	          marginLeft: 60
	        }
	      }, BUTTON({
	        'data-action': 'delete-comment',
	        style: comment_action_style,
	        onClick: (function(_this) {
	          return function(key) {
	            return function(e) {
	              e.stopPropagation();
	              if (confirm('Delete this comment forever?')) {
	                return destroy(key);
	              }
	            };
	          };
	        })(this)(comment.key)
	      }, translator('engage.delete_button', 'delete')), BUTTON({
	        style: comment_action_style,
	        onClick: (function(_this) {
	          return function(key) {
	            return function(e) {
	              e.stopPropagation();
	              comment.editing = true;
	              return save(comment);
	            };
	          };
	        })(this)(comment.key)
	      }, translator('engage.edit_button', 'edit')))) : void 0 : void 0);
	    }
	  }
	});
	
	styles += ".comment_entry {\n  margin-bottom: 25px;\n  min-height: 60px;\n  position: relative; }\n\n.comment_entry_name {\n  font-weight: 600;\n  color: #666666; \n  margin-bottom: 4px;\n}\n\n.comment_entry_body {\n  margin-left: 60px;\n  word-wrap: break-word;\n  position: relative; }\n  .comment_entry_body a {\n    text-decoration: underline; }\n  .comment_entry_body strong {\n    font-weight: 600; }\n  .comment_entry_body p {\n    margin-bottom: 1em; }";
	
	window.Discussion = ReactiveComponent({
	  displayName: 'Discussion',
	  render: function() {
	    var HEADING, close_point, comment, comments, discussion_style, in_wings, is_pro, mouth_style, point, point_included, proposal, ref, side, trans_func, your_opinion;
	    point = fetch(this.props.point);
	    proposal = fetch(point.proposal);
	    is_pro = point.is_pro;
	    your_opinion = proposal.your_opinion;
	    if (your_opinion.key) {
	      fetch(your_opinion);
	    }
	    if (your_opinion.point_inclusions == null) {
	      your_opinion.point_inclusions = [];
	    }
	    point_included = _.contains(your_opinion.point_inclusions, point.key);
	    in_wings = getProposalMode(proposal) === 'crafting' && !point_included;
	    comments = fetch(this.props.comments).comments;
	    comments.sort(function(a, b) {
	      return a.created_at > b.created_at;
	    });
	    discussion_style = {
	      width: "var(--BODY_WIDTH)",
	      border: "3px solid " + (focus_color()),
	      position: 'absolute',
	      zIndex: 100,
	      padding: '20px 40px',
	      borderRadius: 16,
	      backgroundColor: 'white',
	      outline: 'none',
	      boxShadow: this.local.has_focus ? "0 0 7px " + (focus_color()) : void 0
	    };
	    side = is_pro ? 'right' : 'left';
	    if (in_wings) {
	      discussion_style[side] = "calc(var(--POINT_WIDTH) + 13px)";
	      discussion_style['top'] = 20;
	    } else {
	      discussion_style[side] = PHONE_SIZE() ? 0 : is_pro ? -23 : -30;
	      discussion_style['marginTop'] = 18;
	    }
	    mouth_style = {
	      position: 'absolute'
	    };
	    if (in_wings) {
	      mouth_style[side] = -29;
	      trans_func = 'rotate(270deg)';
	      if (is_pro) {
	        trans_func += ' scaleY(-1)';
	      }
	      _.extend(mouth_style, {
	        transform: trans_func,
	        top: 19
	      });
	    } else {
	      _.extend(mouth_style, {
	        top: -28,
	        transform: !is_pro ? 'scaleX(-1)' : void 0
	      });
	      if (is_pro) {
	        mouth_style.right = 100;
	      } else {
	        mouth_style.left = 100;
	      }
	    }
	    close_point = function(e) {
	      var loc;
	      loc = fetch('location');
	      delete loc.query_params.selected;
	      save(loc);
	      e.preventDefault();
	      return e.stopPropagation();
	    };
	    HEADING = this.props.rendered_as !== 'decision_board_point' ? H4 : H5;
	    return SECTION({
	      id: 'open_point',
	      style: discussion_style,
	      tabIndex: 0,
	      onClick: function(e) {
	        return e.stopPropagation();
	      },
	      onTouchEnd: function(e) {
	        return e.stopPropagation();
	      },
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 27) {
	            return close_point(e);
	          }
	        };
	      })(this),
	      onBlur: (function(_this) {
	        return function(e) {
	          _this.local.has_focus = false;
	          return save(_this.local);
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function(e) {
	          _this.local.has_focus = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, DIV({
	      style: mouth_style
	    }, Bubblemouth({
	      apex_xfrac: 1.1,
	      width: 36,
	      height: 28,
	      fill: 'white',
	      stroke: focus_color(),
	      stroke_width: 11
	    })), BUTTON({
	      'aria-label': 'close point',
	      onClick: close_point,
	      style: {
	        position: 'absolute',
	        right: 8,
	        top: 8,
	        fontSize: 24,
	        color: '#aaa',
	        backgroundColor: 'transparent',
	        border: 'none'
	      }
	    }, 'x'), ((ref = point.text) != null ? ref.length : void 0) > 0 ? SECTION({
	      style: {
	        marginBottom: 24,
	        marginTop: 10
	      }
	    }, HEADING({
	      style: {
	        textAlign: 'left',
	        fontSize: 24,
	        color: focus_color(),
	        fontWeight: 600,
	        marginBottom: 10
	      }
	    }, translator('engage.author_explanation', 'Author’s Explanation')), DIV({
	      className: 'point_details'
	    }, splitParagraphs(point.text))) : void 0, !customization('disable_comments') ? SECTION(null, HEADING({
	      style: {
	        textAlign: 'left',
	        fontSize: 24,
	        color: focus_color(),
	        marginBottom: 25,
	        marginTop: 10,
	        fontWeight: 600
	      }
	    }, translator("engage.point_details_heading", 'Discuss this Point')), DIV({
	      className: 'comments'
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = comments.length; i < len; i++) {
	        comment = comments[i];
	        results.push(Comment({
	          key: comment.key,
	          comment: comment.key
	        }));
	      }
	      return results;
	    })()), EditComment({
	      key: "fresh-comment-" + comments.length,
	      fresh: true,
	      point: arest.key_id(this.props.comments),
	      proposal: proposal.key
	    })) : void 0);
	  },
	  componentDidUpdate: function() {
	    return this.setHeight();
	  },
	  componentDidMount: function() {
	    return this.setHeight();
	  },
	  setHeight: function() {
	    var dist_from_parent, el, open_point_height, s;
	    s = fetch('reasons_height_adjustment');
	    el = ReactDOM.findDOMNode(this);
	    dist_from_parent = $$.offset(el).top - $$.offset(document.querySelector('.reasons_region')).top;
	    open_point_height = $$.height(el) + dist_from_parent;
	    if (s.open_point_height !== open_point_height) {
	      s.open_point_height = open_point_height;
	      return save(s);
	    }
	  }
	});


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	
	styles += "\n.AllYourForums h1 {\n  margin: 36px 0px 18px 0px;\n  font-size: 24px;\n}\n\n.AllYourForums .forum {\n  list-style: none;\n  align-items: center;\n  display: flex;\n  padding: 18px 0;\n  min-height: 70px;\n  width: 100%;\n}\n\n.AllYourForums .forum.odd {\n  background-color: #fcfcfc;\n}\n\n\n.AllYourForums .logo {\n  width: 120px;\n  text-align: right;\n\n  margin-right: 24px;\n}\n\n.AllYourForums .text {\n\n}\n\n.AllYourForums .forum_title {\n  display: block;\n  font-size: 18px;\n  text-decoration: none;\n}\n\n.AllYourForums .forum_link {\n  color: #888;\n  font-weight: 400;\n  font-size: 15px;\n}\n\n.AllYourForums .host-row {\n  margin-left: 24px;\n  visibility: hidden;\n}\n\n.AllYourForums .forum:hover .host-row,\n.AllYourForums .forum:focus-within .host-row {\n  visibility: visible;\n}\n";
	
	window.AllYourForums = ReactiveComponent({
	  displayName: 'AllYourForums',
	  drawForums: function(forums, is_host) {
	    var forum, idx;
	    return UL(null, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = forums.length; i < len; idx = ++i) {
	        forum = forums[idx];
	        results.push((function(_this) {
	          return function(forum) {
	            return LI({
	              className: "forum " + (idx % 2 ? 'odd' : 'even')
	            }, DIV({
	              className: 'logo'
	            }, forum.logo ? IMG({
	              src: forum.logo,
	              style: {
	                maxWidth: 120,
	                maxHeight: 70
	              }
	            }) : DIV({
	              style: {
	                border: '1px dashed #ccc',
	                borderRadius: 8,
	                width: 120,
	                height: 70
	              }
	            })), DIV({
	              className: 'text'
	            }, A({
	              className: 'forum_title',
	              href: "https://" + forum.name + ".consider.it"
	            }, forum.title || forum.name), A({
	              className: 'forum_link',
	              href: "https://" + forum.name + ".consider.it"
	            }, "https://" + forum.name + ".consider.it")), is_host ? DIV({
	              className: 'host-row'
	            }, BUTTON({
	              style: {
	                backgroundColor: 'transparent',
	                border: 'none',
	                cursor: 'pointer',
	                padding: '4px'
	              },
	              'data-tooltip': "Import Configuration from " + forum.name + " to this forum",
	              onKeyPress: function(e) {
	                if (e.which === 32 || e.which === 13) {
	                  return e.currentTarget.click();
	                }
	              },
	              onClick: function() {
	                var cb, frm, xhr;
	                if (confirm("Are you sure you want to import this configuration? It will overwrite the configuration of this forum.")) {
	                  frm = new FormData();
	                  frm.append("authenticity_token", arest.csrf());
	                  frm.append("subdomain_to_import_configuration", forum.id);
	                  cb = function() {
	                    return location.reload();
	                  };
	                  xhr = new XMLHttpRequest;
	                  xhr.addEventListener('readystatechange', cb, false);
	                  xhr.open('PUT', '/import_configuration_from_subdomain', true);
	                  return xhr.send(frm);
	                }
	              }
	            }, import_icon(18, '#444')), BUTTON({
	              style: {
	                backgroundColor: 'transparent',
	                border: 'none',
	                cursor: 'pointer',
	                padding: '4px'
	              },
	              'data-tooltip': 'Delete forum',
	              onKeyPress: function(e) {
	                if (e.which === 32 || e.which === 13) {
	                  return e.currentTarget.click();
	                }
	              },
	              onClick: function() {
	                var cb, frm, xhr;
	                if (confirm("Are you sure you want to delete this entire forum? You cannot undo it.")) {
	                  frm = new FormData();
	                  frm.append("authenticity_token", arest.csrf());
	                  frm.append("subdomain_to_destroy", forum.id);
	                  cb = function() {
	                    return arest.serverFetch('/your_forums');
	                  };
	                  xhr = new XMLHttpRequest;
	                  xhr.addEventListener('readystatechange', cb, false);
	                  xhr.open('DELETE', '/destroy_forum', true);
	                  return xhr.send(frm);
	                }
	              }
	            }, trash_icon(18, 18, '#888'))) : void 0);
	          };
	        })(this)(forum));
	      }
	      return results;
	    }).call(this));
	  },
	  render: function() {
	    var current_user, forums, hosted, participated_in, subdomain;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    forums = fetch('/your_forums');
	    hosted = forums.hosted;
	    participated_in = forums.participated_in;
	    if ((hosted == null) || (participated_in == null)) {
	      return SPAN(null);
	    }
	    return DIV({
	      className: 'AllYourForums'
	    }, H1(null, 'Forums you\'ve hosted'), hosted.length > 0 ? this.drawForums(hosted, true) : DIV(null, "You have not yet hosted a forum. ", A({
	      href: "https://" + (fetch('/application').base_domain) + "/create_forum"
	    }, 'Create your own'), " if you wish."), H1(null, 'Forums you\'ve participated in'), participated_in.length > 0 ? this.drawForums(participated_in, false) : "You have not yet participated in a forum");
	  }
	});


/***/ },
/* 51 */
/***/ function(module, exports) {

	var AnalyticsTabs, GraphSection, ResponsiveAnalyticsDataset, _PieChart, color50scheme, comments_data, getForumParticipants, get_analytics_tab_data, get_forum_time_domain, opinions_data, participation_data, visitation_data, visitor_segment_labels,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	styles += ".DataAnalytics {\n  position: relative;\n}\n";
	
	window.DataAnalytics = ReactiveComponent({
	  displayName: 'DataAnalytics',
	  mixins: [LoadScripts],
	  js_dependencies: ['d3.v7.min.js'],
	  componentDidMount: function() {
	    this.setWidth();
	    return this.loadScripts();
	  },
	  componentDidUpdate: function() {
	    this.setWidth();
	    return this.loadScripts();
	  },
	  setWidth: function() {
	    var el, w;
	    el = document.querySelector('#DASHBOARD-title');
	    if (!el) {
	      return;
	    }
	    w = el.clientWidth;
	    if (this.local.width !== w) {
	      this.local.width = w;
	      return save(this.local);
	    }
	  },
	  render: function() {
	    var analytics_data_loaded, analytics_state, attr, default_value, label, option, props;
	    if (!this.local.loaded) {
	      return ResponsiveAnalyticsDataset();
	    }
	    analytics_state = fetch('analytics');
	    analytics_data_loaded = fetch('analytics_data_loaded');
	    if (!analytics_state.expanded) {
	      analytics_state.expanded = 'VisitAnalytics';
	      save(analytics_state);
	    }
	    props = {
	      name: analytics_state.expanded,
	      width: this.local.width,
	      cumulative: this.local.cumulative
	    };
	    return DIV({
	      className: "DataAnalytics"
	    }, ResponsiveAnalyticsDataset(), this.local.loaded ? DIV({
	      style: {
	        display: !analytics_data_loaded.data_loaded ? 'none' : void 0
	      }
	    }, AnalyticsTabs(), DIV({
	      style: {
	        position: 'relative'
	      }
	    }, DIV({
	      className: 'options_area'
	    }, (function() {
	      var j, len, ref, results;
	      ref = [
	        {
	          attr: 'cumulative',
	          label: 'cumulative',
	          default_value: false
	        }
	      ];
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        option = ref[j];
	        label = option.label, attr = option.attr, default_value = option.default_value;
	        if (this.local[attr] == null) {
	          this.local[attr] = default_value;
	        }
	        results.push(LABEL({
	          key: label,
	          className: 'toggle'
	        }, LABEL({
	          className: 'toggle_switch'
	        }, INPUT({
	          type: 'checkbox',
	          defaultChecked: default_value,
	          onChange: (function(_this) {
	            return function(ev) {
	              _this.local[attr] = !_this.local[attr];
	              return save(_this.local);
	            };
	          })(this)
	        }), SPAN({
	          className: 'toggle_switch_circle'
	        })), SPAN(null, label)));
	      }
	      return results;
	    }).call(this))), (function() {
	      switch (analytics_state.expanded) {
	        case 'VisitAnalytics':
	          return VisitAnalytics(props);
	        case 'ParticipantAnalytics':
	          return ParticipantAnalytics(props);
	        case 'OpinionGraphAnalytics':
	          return OpinionGraphAnalytics(props);
	        case 'CommentsAnalytics':
	          return CommentsAnalytics(props);
	      }
	    })()) : void 0);
	  }
	});
	
	styles += ".AnalyticsTabs {\n  margin-bottom: 40px;\n}\n.AnalyticsTabs ul {\n  list-style: none;\n  display: flex;\n  justify-content: center;\n}\n\n.AnalyticsTabs li {\n  display: inline-block;\n  padding: 0 18px;\n  border-left: 1px solid #f4f4f4;\n  border-right: 1px solid #f4f4f4;\n}\n\n.AnalyticsTabs li:first-child {\n  border-left: none;\n}\n\n.AnalyticsTabs li:last-child {\n  border-right: none;\n}\n\n.AnalyticsTabs li button {\n  background-color: transparent;\n  border: none;\n}\n\n.AnalyticsTabs.free-forum li button {\n  cursor: default;\n}\n\n\n#DASHBOARD-main .AnalyticsTabs [data-widget=\"UpgradeForumButton\"] .btn.big {\n  margin-bottom: 0px;\n}\n";
	
	AnalyticsTabs = ReactiveComponent({
	  displayName: 'AnalyticsTabs',
	  render: function() {
	    var analytics_pages, analytics_state, is_premium_forum, name;
	    analytics_state = fetch('analytics');
	    analytics_pages = ['VisitAnalytics', 'ParticipantAnalytics', 'OpinionGraphAnalytics', 'CommentsAnalytics'];
	    is_premium_forum = (fetch('/subdomain').plan > 0) || fetch('/current_user').is_super_admin;
	    return DIV({
	      className: "AnalyticsTabs " + (!is_premium_forum ? 'free-forum' : void 0)
	    }, !is_premium_forum ? DIV({
	      style: {
	        position: 'absolute',
	        left: 'calc(50% - 80px)',
	        zIndex: 99,
	        top: 24,
	        display: 'flex',
	        alignItems: 'center'
	      }
	    }, UpgradeForumButton({
	      text: 'Upgrade Forum',
	      big: true
	    }), SPAN({
	      style: {
	        paddingLeft: 14
	      }
	    }, " to access more data.")) : void 0, UL(null, (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = analytics_pages.length; j < len; j++) {
	        name = analytics_pages[j];
	        results.push((function(_this) {
	          return function(name) {
	            var active, args;
	            active = analytics_state.expanded === name;
	            args = get_analytics_tab_data(name);
	            if (args) {
	              return LI({
	                key: name,
	                style: {
	                  opacity: !is_premium_forum && name !== 'VisitAnalytics' ? 0.7 : void 0
	                }
	              }, BUTTON({
	                onClick: is_premium_forum ? function() {
	                  analytics_state.expanded = name;
	                  return save(analytics_state);
	                } : void 0
	              }, DIV({
	                key: 'graph_padding',
	                className: 'graph_padding'
	              }, H1({
	                style: {
	                  fontSize: 16,
	                  textTransform: 'uppercase',
	                  color: active ? focus_color() : '#999',
	                  textDecoration: active ? 'underline' : void 0
	                }
	              }, args.heading), DIV({
	                style: {
	                  filter: !is_premium_forum && name !== 'VisitAnalytics' ? "blur(4px)" : void 0
	                }
	              }, DIV({
	                style: {
	                  fontSize: 22,
	                  fontWeight: 600
	                }
	              }, args.data[0][1]), args.data[1] ? DIV({
	                key: args.data[1][0],
	                style: {
	                  marginBottom: 12,
	                  fontSize: 13,
	                  fontWeight: 400
	                }
	              }, args.data[1][0] + ": " + args.data[1][1]) : void 0))));
	            }
	          };
	        })(this)(name));
	      }
	      return results;
	    }).call(this)));
	  }
	});
	
	get_analytics_tab_data = function(name) {
	  var all_comments, args, opinions, participants, per_day, segments, total_visits, visitors, visits_per_day;
	  switch (name) {
	    case 'VisitAnalytics':
	      if (!fetch('visitation_data').dummy) {
	        return null;
	      }
	      visitors = visitation_data.visitors, visits_per_day = visitation_data.visits_per_day, segments = visitation_data.segments, total_visits = visitation_data.total_visits;
	      args = {
	        heading: "Unique Visitors",
	        data: [["Total", Object.keys(visitors).length], ["Total visits", "" + total_visits]]
	      };
	      break;
	    case 'ParticipantAnalytics':
	      if (!fetch('visitation_data').dummy || !fetch('participation_data').dummy) {
	        return null;
	      }
	      visitors = visitation_data.visitors, visits_per_day = visitation_data.visits_per_day, segments = visitation_data.segments, total_visits = visitation_data.total_visits;
	      per_day = participation_data.per_day, participants = participation_data.participants, segments = participation_data.segments;
	      args = {
	        heading: "Participants",
	        data: [["Total", participants.length], ["Conversion rate", ((participants.length / Object.keys(visitors).length * 100).toFixed(1)) + "%"]]
	      };
	      break;
	    case 'OpinionGraphAnalytics':
	      if (!fetch('opinion_data').dummy) {
	        return null;
	      }
	      opinions = fetch('/opinions').opinions;
	      per_day = opinions_data.per_day, participants = opinions_data.participants, segments = opinions_data.segments;
	      args = {
	        heading: "Opinions",
	        data: [["Total", opinions.length], ["Avg. per participant", (opinions.length / participants.length).toFixed(1)]]
	      };
	      break;
	    case 'CommentsAnalytics':
	      if (!fetch('comment_data').dummy) {
	        return null;
	      }
	      per_day = comments_data.per_day, participants = comments_data.participants, segments = comments_data.segments, all_comments = comments_data.all_comments;
	      args = {
	        heading: 'Comments',
	        data: [["Total", all_comments.length], ["Avg. per participant", (all_comments.length / participants.length).toFixed(1)]]
	      };
	  }
	  return args;
	};
	
	color50scheme = ["#1b70fc", "#fd1105", "#28e207", "#fc90fd", "#74755a", "#29d6e0", "#f6aa0b", "#c8128d", "#c5bab6", "#a62afd", "#a0aefd", "#149103", "#0d8995", "#9b7b9f", "#f4808b", "#b9660b", "#6fb985", "#9a9823", "#a6585e", "#ec07fb", "#10aceb", "#899da8", "#64749d", "#b68b6f", "#27865e", "#bc81fa", "#fa2b71", "#ff7227", "#c0c178", "#d969b2", "#c1a7cf", "#adc80a", "#f6a679", "#846ffe", "#a44ca8", "#9ec7c0", "#1ead9f", "#8a6f10", "#c14024", "#60b636", "#8f9b82", "#90c6ea", "#64787a", "#f1a1c8", "#0fdcb1", "#8263b2", "#5e7f37", "#836c72", "#8f8bc5", "#c68f2d"];
	
	styles += ".DataAnalytics {\n  min-height: 2000px;\n}\n.analytics_section {\n  position: relative;\n}\n.graph_padding {\n  position: relative;\n}\n\n.segments-container {\n  margin-bottom: 36px;\n  display: flex;\n  justify-content: center;\n}\n\n.segments-container label {\n  margin-right: 16px;\n  font-size: 12px;\n}\n.segments-container ul {\n  list-style: none;\n  padding: 0;\n  display: inline;\n  margin: 0;\n}\n\n.segments-container li {\n  display: inline-block;\n  margin: 4px;\n}\n\n.segments-container li button {\n  display: inline-block;\n  font-size: 14px;\n  border-radius: 8px;\n  padding: 4px 12px;\n  font-weight: 400;\n  background-color: #eaeaea;\n  color: #333;\n  border: 1px solid #dadada;\n}\n\n.segment_grid {\n  display: grid; \n  grid-template-columns: 10% 65% 25%;\n  grid-row-gap: 8px;\n}\n\n.grid-row-wrapper {\n  display: contents;\n}\n\n.grid-row-wrapper > div {\n  padding-left: 18px;\n}\n\n.segment_val_name {\n  overflow-wrap: anywhere;\n}\n.segment_val_amount {\n  text-align: right;\n  padding-right: 12px;\n}\n\n.options_area {\n  position: absolute;\n  right: 28px;\n  top: -24px;\n} \n\n.toggle {\n  display: flex;   \n  padding-bottom: 8px; \n}\n\n.toggle > span {\n  font-size: 11px;\n  margin-left: 8px;           \n}\n\n.toggle .toggle_switch {\n  width: 36px;\n  height: 16px;\n}\n.toggle .toggle_switch .toggle_switch_circle:before {\n  height: 12px; \n  width: 12px;\n  bottom: 2px;\n}\n\n.toggle input:checked + .toggle_switch_circle:before {\n  transform: translateX(18px);\n}\n\n.analytics_section .notice {\n  margin-bottom: 14px;\n  text-align: center\n}\n.analytics_section .notice > span {\n  background-color: #fffadb;\n  font-size: 13px;\n}\n";
	
	GraphSection = {
	  review_state: function(segments) {
	    var analytics_state;
	    analytics_state = fetch('analytics_state');
	    if (!(analytics_state.segment_by in segments)) {
	      return analytics_state.segment_by = null;
	    }
	  },
	  get_color: function(vals) {
	    var color;
	    vals.sort();
	    color = d3.scaleOrdinal(vals, color50scheme);
	    return color;
	  },
	  drawSegments: function(arg) {
	    var analytics_state, color, current_segment, labels, notice, segment, segment_by, total;
	    segment_by = arg.segment_by, current_segment = arg.current_segment, color = arg.color, notice = arg.notice, labels = arg.labels, total = arg.total;
	    if (segment_by.length === 0) {
	      return SPAN({
	        key: 'segments'
	      });
	    }
	    analytics_state = fetch('analytics_state');
	    return DIV({
	      className: 'segments graph_padding'
	    }, DIV({
	      className: 'segments-container'
	    }, UL(null, (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = segment_by.length; j < len; j++) {
	        segment = segment_by[j];
	        results.push((function(_this) {
	          return function(segment) {
	            return LI({
	              key: segment
	            }, BUTTON({
	              onClick: function(e) {
	                if (analytics_state.segment_by === segment) {
	                  analytics_state.segment_by = null;
	                } else {
	                  analytics_state.segment_by = segment;
	                }
	                return save(analytics_state);
	              },
	              onKeyPress: function(e) {
	                if (e.which === 13 || e.which === 32) {
	                  e.target.click();
	                  e.stopPropagation();
	                  return e.preventDefault();
	                }
	              },
	              style: {
	                backgroundColor: analytics_state.segment_by === segment ? focus_blue : '#eaeaea',
	                color: analytics_state.segment_by === segment ? 'white' : '#444'
	              }
	            }, (labels != null ? labels[segment] : void 0) || segment));
	          };
	        })(this)(segment));
	      }
	      return results;
	    }).call(this))), notice ? DIV({
	      className: 'notice'
	    }, SPAN(null, notice)) : void 0, analytics_state.segment_by ? this.drawSegment((labels != null ? labels[analytics_state.segment_by] : void 0) || analytics_state.segment_by, current_segment, color, total) : void 0);
	  },
	  drawSegment: function(name, segment, colors, total) {
	    var color_vals, incidents, j, len, ref, seg_count, segment_vals, val;
	    segment_vals = Object.entries(segment);
	    segment_vals.sort(function(a, b) {
	      return b[1].length - a[1].length;
	    });
	    if (total == null) {
	      total = 0;
	      for (j = 0, len = segment_vals.length; j < len; j++) {
	        ref = segment_vals[j], val = ref[0], incidents = ref[1];
	        if (val === 'Eventually registered') {
	          seg_count = participation_data.participants.length;
	        } else {
	          seg_count = incidents.length;
	        }
	        total += seg_count;
	      }
	    }
	    color_vals = [];
	    return DIV({
	      style: {
	        display: 'flex'
	      }
	    }, DIV({
	      style: {
	        width: '50%'
	      }
	    }, H3({
	      style: {
	        marginLeft: 'calc(18px + 10%)',
	        marginBottom: 8
	      }
	    }, name), DIV({
	      className: 'segment_grid'
	    }, (function() {
	      var l, len1, ref1, results;
	      results = [];
	      for (l = 0, len1 = segment_vals.length; l < len1; l++) {
	        ref1 = segment_vals[l], val = ref1[0], incidents = ref1[1];
	        color_vals.push(colors(val) + '66');
	        if (val === 'Eventually registered') {
	          seg_count = participation_data.participants.length;
	        } else {
	          seg_count = incidents.length;
	        }
	        results.push(DIV({
	          key: val,
	          className: 'grid-row-wrapper'
	        }, DIV({
	          style: {
	            backgroundColor: colors(val)
	          }
	        }), DIV({
	          className: 'segment_val_name',
	          style: {
	            backgroundColor: colors(val) + '66'
	          }
	        }, val === 'null' ? '(unknown)' : val), DIV({
	          className: 'segment_val_amount',
	          style: {
	            backgroundColor: colors(val) + '66'
	          }
	        }, seg_count, seg_count > 0 && total > 0 ? DIV({
	          style: {
	            fontSize: 15
	          }
	        }, ((seg_count / total * 100).toFixed(1)) + "%") : void 0)));
	      }
	      return results;
	    })())), DIV({
	      style: {
	        width: '48%'
	      }
	    }, PieChart({
	      key: name,
	      data: segment_vals,
	      colors: color_vals
	    })));
	  }
	};
	
	visitor_segment_labels = {
	  'new_vs_returning': 'New vs. Returning',
	  'registered_vs_unregistered': 'Registered vs Unregistered',
	  'referring_domain': 'Referring Domain',
	  'device_type': 'Device Type',
	  'browser': 'Browser'
	};
	
	window.VisitAnalytics = ReactiveComponent({
	  displayName: 'VisitAnalytics',
	  mixins: [GraphSection],
	  defaultZ: 'Unique Visitors',
	  render: function() {
	    var analytics_state, color, notice, segment_by, segments, time_domain, total_visits, visitors, visits_per_day, zDomain;
	    if (!fetch('visitation_data').dummy) {
	      return SPAN(null);
	    }
	    analytics_state = fetch('analytics_state');
	    visitors = visitation_data.visitors, visits_per_day = visitation_data.visits_per_day, segments = visitation_data.segments, total_visits = visitation_data.total_visits;
	    this.review_state(segments);
	    zDomain = analytics_state.segment_by ? Object.keys(segments[analytics_state.segment_by]) : [this.defaultZ];
	    time_domain = get_forum_time_domain();
	    color = this.get_color(zDomain);
	    segment_by = Object.keys(visitor_segment_labels);
	    if (time_domain.earliest_visit < time_domain.earliest_opinion) {
	      notice = "* This forum started before Consider.it started tracking visits, so only a subset of visits is represented here.";
	    } else {
	      notice = null;
	    }
	    return DIV({
	      className: 'VisitAnalytics analytics_section'
	    }, DIV(null, TimeSeriesAreaGraph({
	      key: "visitors-" + analytics_state.segment_by + "-" + this.props.cumulative,
	      time_format: "%Y-%m-%d",
	      width: this.props.width,
	      log: 'linear',
	      yLabel: '',
	      cumulative: this.props.cumulative,
	      name: 'Unique Visitors',
	      segment_by: (function(_this) {
	        return function(d) {
	          if (analytics_state.segment_by) {
	            return d[analytics_state.segment_by];
	          } else {
	            return 'Unique Visitors';
	          }
	        };
	      })(this),
	      data: visits_per_day,
	      zDomain: zDomain,
	      color: color
	    }), this.drawSegments({
	      segment_by: segment_by,
	      current_segment: segments[analytics_state.segment_by],
	      color: color,
	      notice: notice,
	      labels: visitor_segment_labels
	    })));
	  }
	});
	
	getForumParticipants = function(additional_items) {
	  var ___, i, j, k, len, opinions_by_user, participants, ref;
	  opinions_by_user = get_opinions_by_users();
	  ref = additional_items || [];
	  for (j = 0, len = ref.length; j < len; j++) {
	    i = ref[j];
	    if (!(i.user in opinions_by_user)) {
	      opinions_by_user[i.user] = 1;
	    }
	  }
	  participants = (function() {
	    var results;
	    results = [];
	    for (k in opinions_by_user) {
	      ___ = opinions_by_user[k];
	      results.push({
	        u: k
	      });
	    }
	    return results;
	  })();
	  return participants;
	};
	
	window.ParticipantAnalytics = ReactiveComponent({
	  displayName: 'ParticipantAnalytics',
	  mixins: [GraphSection],
	  defaultZ: 'First Opinion Given',
	  render: function() {
	    var analytics_state, attr, attributes, color, multi_valued_segment, notice, participants, per_day, ref, segment_by, segment_data, segments, zDomain;
	    if (!fetch('participation_data').dummy) {
	      return SPAN(null);
	    }
	    per_day = participation_data.per_day, participants = participation_data.participants, segments = participation_data.segments;
	    this.review_state(segments);
	    analytics_state = fetch('analytics_state');
	    if (analytics_state.segment_by) {
	      ref = segments[analytics_state.segment_by], multi_valued_segment = ref.multi_valued_segment, zDomain = ref.zDomain, segment_data = ref.segment_data;
	    } else {
	      zDomain = [this.defaultZ];
	      segment_data = {};
	      multi_valued_segment = false;
	    }
	    color = this.get_color(zDomain);
	    attributes = get_participant_attributes();
	    segment_by = (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = attributes.length; j < len; j++) {
	        attr = attributes[j];
	        results.push(attr.name || attr.key);
	      }
	      return results;
	    })();
	    if (multi_valued_segment) {
	      notice = "* This attribute is multi-valued. Some participants are counted in multiple categories.";
	    } else {
	      notice = null;
	    }
	    return DIV({
	      className: 'ParticipantAnalytics analytics_section'
	    }, DIV(null, TimeSeriesAreaGraph({
	      key: "participants-" + analytics_state.segment_by + "-" + this.props.cumulative,
	      time_format: "%Y-%m-%d",
	      width: this.props.width,
	      log: 'linear',
	      yLabel: '',
	      name: 'New Participants',
	      cumulative: this.props.cumulative,
	      segment_by: (function(_this) {
	        return function(d) {
	          if (analytics_state.segment_by) {
	            return d[analytics_state.segment_by];
	          } else {
	            return _this.defaultZ;
	          }
	        };
	      })(this),
	      data: per_day,
	      zDomain: zDomain,
	      color: color
	    }), this.drawSegments({
	      segment_by: segment_by,
	      current_segment: segment_data,
	      color: color,
	      notice: notice,
	      total: participants.length
	    })));
	  }
	});
	
	window.OpinionGraphAnalytics = ReactiveComponent({
	  displayName: 'OpinionGraphAnalytics',
	  mixins: [GraphSection],
	  defaultZ: 'Opinions',
	  render: function() {
	    var analytics_state, attr, attributes, color, multi_valued_segment, notice, opinions, participants, per_day, ref, segment_by, segment_data, segments, zDomain;
	    opinions = fetch('/opinions').opinions;
	    if (!fetch('opinion_data').dummy) {
	      return SPAN(null);
	    }
	    analytics_state = fetch('analytics_state');
	    per_day = opinions_data.per_day, participants = opinions_data.participants, segments = opinions_data.segments;
	    this.review_state(segments);
	    if (analytics_state.segment_by) {
	      ref = segments[analytics_state.segment_by], multi_valued_segment = ref.multi_valued_segment, zDomain = ref.zDomain, segment_data = ref.segment_data;
	    } else {
	      zDomain = [this.defaultZ];
	      segment_data = {};
	      multi_valued_segment = false;
	    }
	    color = this.get_color(zDomain);
	    attributes = get_participant_attributes();
	    segment_by = (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = attributes.length; j < len; j++) {
	        attr = attributes[j];
	        results.push(attr.name || attr.key);
	      }
	      return results;
	    })();
	    if (multi_valued_segment) {
	      notice = "* This attribute is multi-valued. Some participants are counted in multiple categories.";
	    } else {
	      notice = null;
	    }
	    return DIV({
	      className: 'ParticipantAnalytics analytics_section'
	    }, DIV(null, TimeSeriesAreaGraph({
	      key: "opinions-" + analytics_state.segment_by + "-" + this.props.cumulative,
	      time_format: "%Y-%m-%d",
	      width: this.props.width,
	      log: 'linear',
	      name: 'Opinions',
	      yLabel: '',
	      cumulative: this.props.cumulative,
	      segment_by: (function(_this) {
	        return function(d) {
	          if (analytics_state.segment_by) {
	            return d[analytics_state.segment_by];
	          } else {
	            return _this.defaultZ;
	          }
	        };
	      })(this),
	      data: per_day,
	      zDomain: zDomain,
	      color: color
	    }), this.drawSegments({
	      segment_by: segment_by,
	      current_segment: segment_data,
	      color: color,
	      notice: notice,
	      total: opinions.length
	    })));
	  }
	});
	
	window.CommentsAnalytics = ReactiveComponent({
	  displayName: 'CommentsAnalytics',
	  mixins: [GraphSection],
	  defaultZ: 'Comments',
	  render: function() {
	    var all_comments, analytics_state, attr, attributes, color, multi_valued_segment, notice, participants, per_day, ref, segment_by, segment_data, segments, zDomain;
	    if (!fetch('comment_data').dummy) {
	      return SPAN(null);
	    }
	    per_day = comments_data.per_day, participants = comments_data.participants, segments = comments_data.segments, all_comments = comments_data.all_comments;
	    this.review_state(segments);
	    analytics_state = fetch('analytics_state');
	    if (analytics_state.segment_by) {
	      ref = segments[analytics_state.segment_by], multi_valued_segment = ref.multi_valued_segment, zDomain = ref.zDomain, segment_data = ref.segment_data;
	    } else {
	      zDomain = [this.defaultZ];
	      segment_data = {};
	      multi_valued_segment = false;
	    }
	    color = this.get_color(zDomain);
	    attributes = get_participant_attributes();
	    segment_by = (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = attributes.length; j < len; j++) {
	        attr = attributes[j];
	        results.push(attr.name || attr.key);
	      }
	      return results;
	    })();
	    segment_by.push('Comment Type');
	    if (multi_valued_segment) {
	      notice = "* This attribute is multi-valued. Some participants are counted in multiple categories.";
	    } else {
	      notice = null;
	    }
	    return DIV({
	      className: 'CommentAnalytics analytics_section'
	    }, DIV(null, TimeSeriesAreaGraph({
	      key: "comments-" + analytics_state.segment_by + "-" + this.props.cumulative + "-" + this.local.exclude_hosts + "-" + this.local.include_proposals + "-" + this.local.include_points + "-" + this.local.include_comments + "-" + all_comments.length,
	      time_format: "%Y-%m-%d",
	      width: this.props.width,
	      log: 'linear',
	      yLabel: '',
	      name: 'Comments',
	      cumulative: this.props.cumulative,
	      segment_by: (function(_this) {
	        return function(d) {
	          if (analytics_state.segment_by) {
	            return d[analytics_state.segment_by];
	          } else {
	            return _this.defaultZ;
	          }
	        };
	      })(this),
	      data: per_day,
	      zDomain: zDomain,
	      color: color
	    }), this.drawSegments({
	      segment_by: segment_by,
	      current_segment: segment_data,
	      color: color,
	      notice: notice,
	      total: all_comments.length
	    })));
	  }
	});
	
	styles += ".d3-tooltip {\n  position: absolute;\n  text-align: center;\n  padding: 6px 12px;\n  font: 16px sans-serif;\n  background: #000000cc;\n  border: none;\n  border-radius: 4px;\n  pointer-events: none;\n  color: white;\n}\n\n\n.d3-tooltip .date {\n  font-size: 14px;\n}\n\n.d3-tooltip .quantity .amount {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.d3-tooltip .quantity .type {\n  padding-left: 8px;\n  font-size: 16px;  \n  # font-weight: 700;\n}\n\n.d3-tooltip .multi_lines {\n  margin-top: 8px;\n}\n\n.d3-tooltip .multi_lines .stack-line {\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n\n}\n\n.d3-tooltip .multi_lines .stack-line .amount {\n  padding-right: 6px;\n  flex-shrink: 0;\n}\n\n.d3-tooltip .multi_lines .stack-line .type {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.d3-tooltip .multi_lines .stack-color {\n  width: 10px;\n  height: 10px;\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 6px;\n  flex-shrink: 0;\n}\n\n";
	
	window.TimeSeriesAreaGraph = ReactiveComponent({
	  displayName: 'TimeSeriesAreaGraph',
	  render: function() {
	    return DIV({
	      ref: 'container'
	    });
	  },
	  componentDidMount: function() {
	    var area, color, container, data, day, end, entry, first_day, formatDate, g, height, i1, id, idx, incident, j, l, last_day, len, len1, len2, len3, len4, len5, len6, len7, len8, m, margin, measure, n, p, q, ref, ref1, ref2, ref3, ref4, ref5, s, segment, segment_val, series, start, starting_val, svg, t, tooltip, totals, values, width, x, xAxis, y, yAxis, y_area, y_areas, y_max, y_min, yy, z, zDomain;
	    data = this.props.data;
	    margin = {
	      top: 10,
	      right: 28,
	      bottom: 50,
	      left: 48
	    };
	    width = this.props.width - margin.left - margin.right;
	    height = 400 - margin.top - margin.bottom;
	    x = d3.scaleTime().range([0, width]);
	    y = d3.scaleLinear().range([height, 0]);
	    formatDate = d3.timeParse(this.props.time_format || "%d-%b-%y");
	    first_day = d3.min([data], function(c) {
	      return d3.min(c, function(d) {
	        return formatDate(d[1]);
	      });
	    });
	    last_day = d3.max([data], function(c) {
	      return d3.max(c, function(d) {
	        return formatDate(d[1]);
	      });
	    });
	    last_day.setHours(3, 0, 0);
	    x.domain([first_day, last_day]);
	    y_areas = [];
	    y_min = 2e308;
	    y_max = -2e308;
	    zDomain = this.props.zDomain;
	    if (!zDomain) {
	      zDomain = {};
	      for (j = 0, len = data.length; j < len; j++) {
	        day = data[j];
	        ref = day[2];
	        for (l = 0, len1 = ref.length; l < len1; l++) {
	          incident = ref[l];
	          zDomain[this.props.segment_by(incident)] = 1;
	        }
	      }
	      zDomain = Object.keys(zDomain);
	    }
	    color = this.props.color || d3.scaleOrdinal(zDomain, d3.schemeTableau10);
	    series = {};
	    for (idx = m = 0, len2 = data.length; m < len2; idx = ++m) {
	      day = data[idx];
	      for (n = 0, len3 = zDomain.length; n < len3; n++) {
	        segment = zDomain[n];
	        if (series[segment] == null) {
	          series[segment] = [];
	        }
	        starting_val = 0;
	        if (this.props.cumulative && idx > 0) {
	          starting_val = series[segment][idx - 1][1];
	        } else {
	          starting_val = 0;
	        }
	        series[segment].push([day[1], starting_val]);
	      }
	      ref1 = day[2];
	      for (p = 0, len4 = ref1.length; p < len4; p++) {
	        incident = ref1[p];
	        segment_val = this.props.segment_by(incident);
	        series[segment_val][idx][1] += 1;
	      }
	    }
	    series = Object.entries(series);
	    totals = {};
	    for (q = 0, len5 = series.length; q < len5; q++) {
	      ref2 = series[q], id = ref2[0], values = ref2[1];
	      y_area = [];
	      totals[id] = 0;
	      for (entry = s = 0, len6 = values.length; s < len6; entry = ++s) {
	        ref3 = values[entry], t = ref3[0], yy = ref3[1];
	        totals[id] += yy;
	      }
	    }
	    series.sort(function(a, b) {
	      return totals[b[0]] - totals[a[0]];
	    });
	    idx = 0;
	    for (z = 0, len7 = series.length; z < len7; z++) {
	      ref4 = series[z], id = ref4[0], values = ref4[1];
	      y_area = [];
	      for (entry = i1 = 0, len8 = values.length; i1 < len8; entry = ++i1) {
	        ref5 = values[entry], t = ref5[0], yy = ref5[1];
	        if (idx === 0) {
	          start = 0;
	        } else {
	          start = y_areas[idx - 1].values[entry][2];
	        }
	        end = start + yy;
	        if (end > y_max) {
	          y_max = end;
	        }
	        if (start < y_min) {
	          y_min = start;
	        }
	        y_area.push([t, start, end, idx, entry]);
	      }
	      y_areas.push({
	        id: id,
	        values: y_area
	      });
	      idx += 1;
	    }
	    y_areas.reverse();
	    y.domain([y_min, y_max]);
	    xAxis = d3.axisBottom(x);
	    yAxis = d3.axisLeft(y).ticks(Math.min(height / 40, y_max - y_min));
	    area = d3.area().x(function(d) {
	      return x(formatDate(d[0]));
	    }).y0(function(d) {
	      return y(d[1]);
	    }).y1(function(d) {
	      return y(d[2]);
	    });
	    container = d3.select(ReactDOM.findDOMNode(this));
	    svg = container.append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom);
	    g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	    g.append('g').attr('class', 'x axis').attr('transform', 'translate(0,' + height + ')').call(xAxis);
	    g.append('g').attr('class', 'y axis').call(yAxis);
	    g.append("g").call(yAxis).call(function(g) {
	      return g.select(".domain").remove();
	    }).call(function(g) {
	      return g.selectAll(".tick line").clone().attr("x2", width).attr("stroke-opacity", 0.1);
	    }).call((function(_this) {
	      return function(g) {
	        return g.append("text").attr("font-size", 16).attr("x", 0).attr("y", -10).attr("fill", "currentColor").attr("text-anchor", "start").text("" + _this.props.yLabel);
	      };
	    })(this));
	    measure = g.selectAll('.measure').data(y_areas).enter().append('g').attr('class', 'measure');
	    measure.append('path').attr('class', 'line').style('stroke', function(d) {
	      return color(d.id);
	    }).style('fill', function(d) {
	      return color(d.id) + '66';
	    }).attr('d', function(d) {
	      return area(d.values);
	    }).attr('data-tooltip', function(d) {
	      return d.id;
	    }).append("title").text(function(d) {
	      return d.id;
	    });
	    tooltip = d3.select('body').append('div').attr('class', 'd3-tooltip').style('opacity', 0);
	    return g.append('rect').attr('width', width).attr('height', height).attr('fill', 'none').attr('pointer-events', 'all').on('mousemove', (function(_this) {
	      return function(event) {
	        var closest_date, colr, current_x, current_y, d, j1, k1, l1, len10, len11, len9, multi_lines, pnt, r, ref6, search_date, series_idx, stack, stack_name, stacks, tooltip_date, tooltip_html, val, xPos, yPos;
	        ref6 = d3.pointer(event), xPos = ref6[0], yPos = ref6[1];
	        closest_date = x.invert(xPos);
	        search_date = d3.timeFormat(_this.props.time_format || "%d-%b-%y")(closest_date);
	        tooltip_date = d3.timeFormat("%A %B %e, %Y")(closest_date);
	        for (series_idx = j1 = 0, len9 = data.length; j1 < len9; series_idx = ++j1) {
	          d = data[series_idx];
	          if (d[1] === search_date) {
	            pnt = d;
	            break;
	          }
	        }
	        g.selectAll('.data-point').remove();
	        stacks = [];
	        closest_date.setHours(0, 0, 0, 0);
	        current_x = x(closest_date);
	        current_y = 0;
	        for (k1 = 0, len10 = series.length; k1 < len10; k1++) {
	          stack = series[k1];
	          colr = color(stack[0]);
	          val = stack[1][series_idx][1];
	          current_y += val;
	          if (val === 0 && series.length > 1) {
	            continue;
	          }
	          r = 4;
	          g.append('circle').attr('class', 'data-point').attr('cx', current_x).attr('cy', y(current_y)).attr('r', r).style('fill', colr);
	          stacks.push([(stack[0] === 'null' ? '(unknown)' : stack[0]), val, colr]);
	        }
	        multi_lines = null;
	        if (stacks.length > 1) {
	          multi_lines = "<div class='multi_lines'>";
	          for (l1 = 0, len11 = stacks.length; l1 < len11; l1++) {
	            stack = stacks[l1];
	            if (stack[1] > 0) {
	              stack_name = stack[0];
	              if (stack_name.length > 40) {
	                stack_name = stack_name.substring(0, 38) + '...';
	              }
	              multi_lines += "<div class=\"stack-line\">\n  <span class='stack-color' style='background-color: " + stack[2] + "'></span>\n  <span class='amount'>" + stack[1] + "</span>\n  <span class='type'>" + stack_name + "</span>\n</div>";
	            }
	          }
	          multi_lines += '</div>';
	        }
	        tooltip_html = "<div class=\"analytics_tooltip\">\n<div class=\"date\">" + tooltip_date + "</div>\n<div class=\"quantity\"><span class=\"amount\">" + current_y + "</span><span class=\"type\">" + _this.props.name + " " + (_this.props.cumulative ? ' to date' : '') + "</span></div>\n" + (multi_lines ? multi_lines : '') + "\n</div>";
	        tooltip.transition().duration(200).style('opacity', .9);
	        return tooltip.html(tooltip_html).style('left', (event.pageX + 24) + 'px').style('top', (event.pageY - 64) + 'px');
	      };
	    })(this)).on('mouseleave', function() {
	      tooltip.transition().duration(500).style('opacity', 0);
	      return g.selectAll('.data-point').remove();
	    });
	  }
	});
	
	window.PieChart = ReactiveComponent({
	  displayName: 'PieChart',
	  render: function() {
	    return DIV({
	      ref: 'container'
	    });
	  },
	  componentDidMount: function() {
	    return _PieChart(this.props.data, this.refs.container, this.props);
	  },
	  componentDidUpdate: function() {
	    return _PieChart(this.props.data, this.refs.container, this.props);
	  }
	});
	
	_PieChart = function(data, container, args) {
	  var I, N, O, T, V, arc, arcLabel, arcs, color, colors, format, formatValue, height, innerRadius, labelRadius, name, names, outerRadius, padAngle, stroke, strokeLinejoin, strokeWidth, svg, title, value, width;
	  if (args == null) {
	    args = {};
	  }
	  title = args.title;
	  names = args.names;
	  colors = args.colors;
	  name = args.name || function(arg) {
	    var x, y;
	    x = arg[0], y = arg[1];
	    return x;
	  };
	  value = args.value || function(arg) {
	    var x, y;
	    x = arg[0], y = arg[1];
	    if (Array.isArray(y)) {
	      return y.length;
	    } else {
	      return y;
	    }
	  };
	  width = args.width || 640;
	  height = args.height || 400;
	  innerRadius = args.innerRadius || 0;
	  outerRadius = args.outerRadius || Math.min(width, height) / 2;
	  labelRadius = args.labelRadius || (innerRadius * 0.2 + outerRadius * 0.8);
	  format = args.format || ",";
	  stroke = args.stroke || (innerRadius > 0 ? "none" : "white");
	  strokeWidth = args.strokeWidth || 1;
	  strokeLinejoin = args.strokeLinejoin || "round";
	  padAngle = args.padAngle || (stroke === "none" ? 1 / outerRadius : 0);
	  N = d3.map(data, name);
	  V = d3.map(data, value);
	  I = d3.range(N.length).filter(function(i) {
	    return !isNaN(V[i]);
	  });
	  if (names == null) {
	    names = N;
	  }
	  names = new d3.InternSet(names);
	  if (colors == null) {
	    colors = d3.schemeSpectral[names.size];
	  }
	  if (colors == null) {
	    colors = d3.quantize((function(t) {
	      return d3.interpolateSpectral(t * 0.8 + 0.1);
	    }), names.size);
	  }
	  color = d3.scaleOrdinal(names, colors);
	  if (title == null) {
	    formatValue = d3.format(format);
	    title = function(i) {
	      return N[i] + "\n" + (formatValue(V[i]));
	    };
	  } else {
	    O = d3.map(data, function(d) {
	      return d;
	    });
	    T = title;
	    title = function(i) {
	      return T(O[i], i, data);
	    };
	  }
	  arcs = d3.pie().padAngle(padAngle).sort(null).value(function(i) {
	    return V[i];
	  })(I);
	  arc = d3.arc().innerRadius(innerRadius).outerRadius(outerRadius);
	  arcLabel = d3.arc().innerRadius(labelRadius).outerRadius(labelRadius);
	  container = d3.select(ReactDOM.findDOMNode(container));
	  svg = container.append("svg").attr("width", width).attr("height", height).attr("viewBox", [-width / 2, -height / 2, width, height]).attr("style", "max-width: 100%; height: auto; height: intrinsic;");
	  svg.append("g").attr("stroke", stroke).attr("stroke-width", strokeWidth).attr("stroke-linejoin", strokeLinejoin).selectAll("path").data(arcs).join("path").attr("fill", function(d) {
	    return color(N[d.data]);
	  }).attr("d", arc).append("title").text(function(d) {
	    return title(d.data);
	  });
	  if (args.draw_labels) {
	    svg.append("g").attr("font-family", "sans-serif").attr("font-size", 14).attr("text-anchor", "middle").selectAll("text").data(arcs).join("text").attr("transform", function(d) {
	      return "translate(" + (arcLabel.centroid(d)) + ")";
	    }).selectAll("tspan").data(function(d) {
	      var lines;
	      lines = title(d.data).split(/\n/);
	      if ((d.endAngle - d.startAngle) > 0.25) {
	        return lines;
	      } else {
	        return lines.slice(0, 1);
	      }
	    }).join("tspan").attr("x", 0).attr("y", function(_, i) {
	      return (i * 1.1) + "em";
	    }).attr("font-weight", function(_, i) {
	      if (i) {
	        return null;
	      } else {
	        return "bold";
	      }
	    }).text(function(d) {
	      return d;
	    });
	  }
	  return Object.assign(svg.node(), {
	    scales: {
	      color: color
	    }
	  });
	};
	
	get_forum_time_domain = function() {
	  return fetch('forum_time_domain');
	};
	
	comments_data = {};
	
	participation_data = {};
	
	opinions_data = {};
	
	visitation_data = {};
	
	ResponsiveAnalyticsDataset = ReactiveComponent({
	  displayName: 'ResponsiveAnalyticsDataset',
	  render: function() {
	    var analytics_data_loaded, j, len, req, requirements, requirements_loaded;
	    requirements_loaded = true;
	    fetch('/proposals?all_points=true');
	    requirements = [fetch('/subdomain').name, fetch('/visits').visits, fetch('/opinions').opinions, fetch('/all_comments').comments, fetch('/users').users, arest.cache['/proposals'].proposals];
	    for (j = 0, len = requirements.length; j < len; j++) {
	      req = requirements[j];
	      requirements_loaded && (requirements_loaded = req);
	    }
	    if (!requirements_loaded) {
	      return SPAN(null);
	    }
	    this.setForumTimeDomain();
	    this.setVisitationData();
	    this.setParticipationData();
	    this.setOpinionsData();
	    this.setCommentsData();
	    analytics_data_loaded = fetch('analytics_data_loaded');
	    if (!analytics_data_loaded.data_loaded) {
	      analytics_data_loaded.data_loaded = true;
	      save(analytics_data_loaded);
	    }
	    return SPAN(null);
	  },
	  setForumTimeDomain: function() {
	    var data_state, days_ago, earliest_opinion, earliest_visit, j, l, latest_opinion, latest_visit, len, len1, len2, m, now, o, opinions, proposals, ref, ref1, ref2, ref3, ref4, subdomain, u, visit, visits;
	    if (!arest.cache['forum_time_domain']) {
	      opinions = fetch('/opinions');
	      visits = fetch('/visits');
	      proposals = fetch('/proposals');
	      subdomain = fetch('/subdomain');
	      earliest_visit = 0;
	      latest_visit = 2e308;
	      now = Date.now();
	      ref = visits.visits;
	      for (j = 0, len = ref.length; j < len; j++) {
	        visit = ref[j];
	        days_ago = Math.round((now - new Date(visit.started_at).getTime()) / 1000 / 60 / 60 / 24);
	        if (earliest_visit < days_ago) {
	          earliest_visit = days_ago;
	        }
	        if (latest_visit > days_ago) {
	          latest_visit = days_ago;
	        }
	      }
	      earliest_opinion = 0;
	      latest_opinion = 2e308;
	      ref1 = opinions.opinions;
	      for (l = 0, len1 = ref1.length; l < len1; l++) {
	        o = ref1[l];
	        u = fetch(o.user);
	        if ((ref2 = u.key, indexOf.call(subdomain.roles.admin, ref2) >= 0) || (ref3 = u.key, indexOf.call(customization('organizational_account') || [], ref3) >= 0)) {
	          continue;
	        }
	        days_ago = Math.round((now - new Date(o.created_at).getTime()) / 1000 / 60 / 60 / 24);
	        if (earliest_opinion < days_ago) {
	          earliest_opinion = days_ago;
	        }
	        if (latest_opinion > days_ago) {
	          latest_opinion = days_ago;
	        }
	      }
	      ref4 = proposals.proposals;
	      for (m = 0, len2 = ref4.length; m < len2; m++) {
	        o = ref4[m];
	        days_ago = Math.round((now - new Date(o.created_at).getTime()) / 1000 / 60 / 60 / 24);
	        if (earliest_opinion < days_ago) {
	          earliest_opinion = days_ago;
	        }
	        if (latest_opinion > days_ago) {
	          latest_opinion = days_ago;
	        }
	      }
	      data_state = {
	        key: 'forum_time_domain'
	      };
	      _.extend(data_state, {
	        earliest_visit: earliest_visit,
	        latest_visit: latest_visit,
	        earliest_opinion: earliest_opinion,
	        latest_opinion: latest_opinion,
	        earliest: earliest_opinion,
	        latest: latest_opinion
	      });
	      return save(data_state);
	    }
	  },
	  setVisitationData: function() {
	    var base, current_user, data_state, date_str, day, days_ago, is_premium_forum, j, l, len, len1, len2, len3, len4, len5, m, n, name1, name2, name3, now, p, q, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, s, seg_users, seg_visits, segment, segment_by, segments, subdomain, time_domain, time_series, user, user_visits, users, users_seen, v, val, visit, visitors, visits, visits_on_day_by_user, visits_per_day, visits_this_day, z;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    visits = fetch('/visits');
	    users = fetch('/users');
	    segment_by = Object.keys(visitor_segment_labels);
	    segments = {};
	    for (j = 0, len = segment_by.length; j < len; j++) {
	      segment = segment_by[j];
	      segments[segment] = {};
	    }
	    visitors = {};
	    time_series = [];
	    is_premium_forum = (subdomain.plan > 0) || fetch('/current_user').is_super_admin;
	    if (!is_premium_forum && 'registered_vs_unregistered' in visitor_segment_labels) {
	      delete visitor_segment_labels.registered_vs_unregistered;
	    }
	    users_seen = {};
	    ref = visits.visits;
	    for (l = 0, len1 = ref.length; l < len1; l++) {
	      visit = ref[l];
	      days_ago = Math.round((Date.now() - new Date(visit.started_at).getTime()) / 1000 / 60 / 60 / 24);
	      if (time_series[days_ago] == null) {
	        time_series[days_ago] = {
	          visits: [],
	          visits_on_day_by_user: {}
	        };
	      }
	      time_series[days_ago].visits.push(visit);
	      for (m = 0, len2 = segment_by.length; m < len2; m++) {
	        segment = segment_by[m];
	        if (segment === 'referring_domain' && !visit.referring_domain && visit.utm_source === 'digest') {
	          visit.referring_domain = 'Consider.it activity digest email';
	        } else if (segment === 'new_vs_returning') {
	          visit.new_vs_returning = visit.user in users_seen ? 'Returning Visitor' : 'New Visitor';
	          users_seen[visit.user] = 1;
	        } else if (segment === 'registered_vs_unregistered') {
	          visit.registered_vs_unregistered = visit.user in arest.cache ? 'Eventually registered' : 'Never registered';
	          users_seen[visit.user] = 1;
	        }
	        if ((base = segments[segment])[name1 = visit[segment]] == null) {
	          base[name1] = [];
	        }
	        segments[segment][visit[segment]].push(visit);
	      }
	      if (visitors[name2 = visit.user] == null) {
	        visitors[name2] = [];
	      }
	      visitors[visit.user].push(visit);
	    }
	    for (n = 0, len3 = segment_by.length; n < len3; n++) {
	      segment = segment_by[n];
	      ref1 = segments[segment];
	      for (val in ref1) {
	        seg_visits = ref1[val];
	        seg_users = {};
	        for (p = 0, len4 = seg_visits.length; p < len4; p++) {
	          v = seg_visits[p];
	          seg_users[v.user] = 1;
	        }
	        segments[segment][val] = Object.keys(seg_users);
	      }
	    }
	    time_domain = get_forum_time_domain();
	    for (days_ago = q = ref2 = time_domain.latest, ref3 = time_domain.earliest_visit; ref2 <= ref3 ? q <= ref3 : q >= ref3; days_ago = ref2 <= ref3 ? ++q : --q) {
	      if (time_series[days_ago] == null) {
	        time_series[days_ago] = {
	          visits: [],
	          visits_on_day_by_user: {}
	        };
	      }
	      if (time_series[days_ago].visits.length > 0) {
	        visits_on_day_by_user = time_series[days_ago].visits_on_day_by_user;
	        ref4 = time_series[days_ago].visits;
	        for (s = 0, len5 = ref4.length; s < len5; s++) {
	          v = ref4[s];
	          if (visits_on_day_by_user[name3 = v.user] == null) {
	            visits_on_day_by_user[name3] = [];
	          }
	          visits_on_day_by_user[v.user].push(v);
	        }
	      }
	    }
	    visits_per_day = [];
	    now = Date.now();
	    for (days_ago = z = ref5 = time_domain.latest, ref6 = time_domain.earliest_visit; ref5 <= ref6 ? z <= ref6 : z >= ref6; days_ago = ref5 <= ref6 ? ++z : --z) {
	      visits_this_day = [];
	      ref7 = time_series[days_ago].visits_on_day_by_user;
	      for (user in ref7) {
	        user_visits = ref7[user];
	        visits_this_day.push(user_visits[0]);
	      }
	      day = new Date(now - days_ago * 24 * 60 * 60 * 1000);
	      date_str = day.toISOString().split('T')[0];
	      visits_per_day.push([days_ago, date_str, visits_this_day]);
	    }
	    visits_per_day.reverse();
	    data_state = {
	      key: 'visitation_data',
	      dummy: Math.random()
	    };
	    visitation_data = {
	      visitors: visitors,
	      visits_per_day: visits_per_day,
	      segments: segments,
	      total_visits: visits.visits.length
	    };
	    return save(data_state);
	  },
	  setParticipationData: function() {
	    var attr, attributes, base, base1, checklist_phantoms, current_segment, current_user, data_state, date_str, day, days_ago, first_opinion_given, idx, j, k, l, len, len1, len2, len3, len4, len5, m, n, name, now, o, opinions_by_user, option, p, participants, per_day, q, ref, ref1, ref2, ref3, s, segments, subdomain, time_domain, time_series, u, user, uu, v, val, vals;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    opinions_by_user = get_opinions_by_users();
	    participants = getForumParticipants();
	    attributes = get_participant_attributes();
	    segments = {};
	    for (j = 0, len = attributes.length; j < len; j++) {
	      attr = attributes[j];
	      name = attr.name || attr.key;
	      current_segment = segments[name] = {
	        zDomain: {
	          '(unknown)': 1
	        },
	        segment_data: {},
	        multi_valued_segment: false
	      };
	      checklist_phantoms = [];
	      for (l = 0, len1 = participants.length; l < len1; l++) {
	        u = participants[l];
	        vals = [];
	        if (u.key !== '/user/-1') {
	          ref = attr.options;
	          for (m = 0, len2 = ref.length; m < len2; m++) {
	            option = ref[m];
	            current_segment.zDomain[option] = 1;
	            if (((attr.pass != null) && attr.pass(u.u, option)) || (!attr.pass && attribute_passes(u.u, attr, [option]))) {
	              vals.push(option);
	              if ((base = current_segment.segment_data)[option] == null) {
	                base[option] = [];
	              }
	              current_segment.segment_data[option].push(u);
	            }
	          }
	        }
	        if (vals.length === 0) {
	          option = '(unknown)';
	          vals.push(option);
	          if ((base1 = current_segment.segment_data)[option] == null) {
	            base1[option] = [];
	          }
	          current_segment.segment_data[option].push(u);
	        }
	        for (idx = n = 0, len3 = vals.length; n < len3; idx = ++n) {
	          val = vals[idx];
	          if (idx > 0) {
	            uu = {};
	            for (k in u) {
	              v = u[k];
	              uu[k] = v;
	            }
	            checklist_phantoms.push(uu);
	          } else {
	            uu = u;
	          }
	          uu[name] = val;
	        }
	      }
	      current_segment.zDomain = Object.keys(current_segment.zDomain);
	      if (checklist_phantoms.length > 0) {
	        current_segment.multi_valued_segment = true;
	      }
	    }
	    time_series = {};
	    time_domain = get_forum_time_domain();
	    now = Date.now();
	    for (p = 0, len4 = participants.length; p < len4; p++) {
	      user = participants[p];
	      first_opinion_given = null;
	      ref1 = opinions_by_user[user.u];
	      for (q = 0, len5 = ref1.length; q < len5; q++) {
	        o = ref1[q];
	        if (!first_opinion_given || o.created_at < first_opinion_given) {
	          first_opinion_given = o.created_at;
	        }
	      }
	      days_ago = Math.round((now - new Date(first_opinion_given).getTime()) / 1000 / 60 / 60 / 24);
	      if (time_series[days_ago] == null) {
	        time_series[days_ago] = [];
	      }
	      time_series[days_ago].push(user);
	    }
	    per_day = [];
	    for (days_ago = s = ref2 = time_domain.latest_opinion, ref3 = time_domain.earliest; ref2 <= ref3 ? s <= ref3 : s >= ref3; days_ago = ref2 <= ref3 ? ++s : --s) {
	      day = new Date(now - days_ago * 24 * 60 * 60 * 1000);
	      date_str = day.toISOString().split('T')[0];
	      per_day.push([days_ago, date_str, time_series[days_ago] || []]);
	    }
	    per_day.reverse();
	    data_state = {
	      key: 'participation_data',
	      dummy: Math.random()
	    };
	    participation_data = {
	      per_day: per_day,
	      participants: participants,
	      segments: segments
	    };
	    return save(data_state);
	  },
	  setOpinionsData: function() {
	    var by_user, current_user, data_state, j, len, o, opinions, participants, per_day, ref, ref1, segments, subdomain, user;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    by_user = {};
	    ref = get_opinions_by_users();
	    for (user in ref) {
	      opinions = ref[user];
	      by_user[user] = [];
	      for (j = 0, len = opinions.length; j < len; j++) {
	        o = opinions[j];
	        by_user[user].push({
	          key: o.key,
	          o: o,
	          u: user
	        });
	      }
	    }
	    participants = getForumParticipants();
	    ref1 = this.parseUserContributionsAndSegment(participants, by_user), segments = ref1.segments, per_day = ref1.per_day;
	    data_state = {
	      key: 'opinion_data',
	      dummy: Math.random()
	    };
	    opinions_data = {
	      per_day: per_day,
	      participants: participants,
	      segments: segments
	    };
	    return save(data_state);
	  },
	  setCommentsData: function() {
	    var all_comments, by_user, comment, current_segment, current_user, data_state, h, hosts, include_item, j, l, len, len1, len2, len3, len4, len5, m, n, name, p, participants, per_day, point, proposal, proposals, q, ref, ref1, ref2, ref3, ref4, ref5, ref6, segments, subdomain;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    proposals = fetch('/proposals');
	    hosts = {};
	    ref = subdomain.roles.admin || [];
	    for (j = 0, len = ref.length; j < len; j++) {
	      h = ref[j];
	      hosts[h] = 1;
	    }
	    ref1 = subdomain.customizations.organizational_account || [];
	    for (l = 0, len1 = ref1.length; l < len1; l++) {
	      h = ref1[l];
	      hosts[h] = 1;
	    }
	    by_user = {};
	    include_item = function(item, type, type_label) {
	      var name1;
	      if (by_user[name1 = item.user] == null) {
	        by_user[name1] = [];
	      }
	      by_user[item.user].push({
	        key: item.key,
	        u: item.user,
	        o: item,
	        'Comment Type': type_label
	      });
	      item['Comment Type'] = type_label;
	      return all_comments.push(item);
	    };
	    all_comments = [];
	    ref2 = proposals.proposals || [];
	    for (m = 0, len2 = ref2.length; m < len2; m++) {
	      proposal = ref2[m];
	      proposal = fetch(proposal);
	      include_item(proposal, 'proposal', 'Proposals');
	      ref3 = proposal.points || [];
	      for (n = 0, len3 = ref3.length; n < len3; n++) {
	        point = ref3[n];
	        point = fetch(point);
	        include_item(point, 'point', 'Pro or Con Points');
	      }
	    }
	    ref5 = ((ref4 = fetch("/all_comments")) != null ? ref4.comments : void 0) || [];
	    for (p = 0, len4 = ref5.length; p < len4; p++) {
	      comment = ref5[p];
	      comment = fetch(comment);
	      include_item(comment, 'comment', 'Replies to a Point');
	    }
	    participants = getForumParticipants(all_comments);
	    ref6 = this.parseUserContributionsAndSegment(participants, by_user), segments = ref6.segments, per_day = ref6.per_day;
	    name = 'Comment Type';
	    current_segment = segments[name] = {
	      segment_data: {
	        'Replies to a Point': [],
	        'Pro or Con Points': [],
	        'Proposals': []
	      },
	      multi_valued_segment: false
	    };
	    current_segment.zDomain = Object.keys(current_segment.segment_data);
	    for (q = 0, len5 = all_comments.length; q < len5; q++) {
	      comment = all_comments[q];
	      current_segment.segment_data[comment['Comment Type']].push(comment);
	    }
	    data_state = {
	      key: 'comment_data',
	      dummy: Math.random()
	    };
	    comments_data = {
	      per_day: per_day,
	      participants: participants,
	      segments: segments,
	      all_comments: all_comments
	    };
	    return save(data_state);
	  },
	  parseUserContributionsAndSegment: function(participants, by_user) {
	    var attr, attributes, base, base1, checklist_phantoms, current_segment, date_str, day, days_ago, i1, idx, items, j, k, l, len, len1, len2, len3, len4, len5, len6, len7, m, n, name, now, o, oo, option, p, per_day, q, ref, ref1, ref2, ref3, s, segments, time_domain, time_series, u, user, v, val, vals, z;
	    attributes = get_participant_attributes();
	    segments = {};
	    for (j = 0, len = attributes.length; j < len; j++) {
	      attr = attributes[j];
	      name = attr.name || attr.key;
	      current_segment = segments[name] = {
	        zDomain: {
	          '(unknown)': 1
	        },
	        segment_data: {},
	        multi_valued_segment: false
	      };
	      checklist_phantoms = [];
	      for (l = 0, len1 = participants.length; l < len1; l++) {
	        u = participants[l];
	        vals = [];
	        if (u.key !== '/user/-1') {
	          ref = attr.options;
	          for (m = 0, len2 = ref.length; m < len2; m++) {
	            option = ref[m];
	            current_segment.zDomain[option] = 1;
	            if (((attr.pass != null) && attr.pass(u.u, option)) || (!attr.pass && attribute_passes(u.u, attr, [option]))) {
	              vals.push(option);
	            }
	          }
	        }
	        if (vals.length === 0) {
	          option = '(unknown)';
	          vals.push(option);
	        }
	        items = by_user[u.u] || [];
	        for (idx = n = 0, len3 = vals.length; n < len3; idx = ++n) {
	          val = vals[idx];
	          if (idx > 0) {
	            for (p = 0, len4 = items.length; p < len4; p++) {
	              o = items[p];
	              oo = {};
	              for (k in o) {
	                v = o[k];
	                oo[k] = v;
	              }
	              oo[name] = val;
	              if ((base = current_segment.segment_data)[val] == null) {
	                base[val] = [];
	              }
	              current_segment.segment_data[val].push(oo);
	              checklist_phantoms.push(oo);
	            }
	          } else {
	            for (q = 0, len5 = items.length; q < len5; q++) {
	              o = items[q];
	              o[name] = val;
	              if ((base1 = current_segment.segment_data)[val] == null) {
	                base1[val] = [];
	              }
	              current_segment.segment_data[val].push(o);
	            }
	          }
	        }
	      }
	      current_segment.zDomain = Object.keys(current_segment.zDomain);
	      if (checklist_phantoms.length > 0) {
	        current_segment.multi_valued_segment = true;
	      }
	    }
	    time_series = {};
	    time_domain = get_forum_time_domain();
	    now = Date.now();
	    for (s = 0, len6 = participants.length; s < len6; s++) {
	      user = participants[s];
	      ref1 = by_user[user.u] || [];
	      for (z = 0, len7 = ref1.length; z < len7; z++) {
	        o = ref1[z];
	        days_ago = Math.round((now - new Date(o.o.created_at).getTime()) / 1000 / 60 / 60 / 24);
	        if (time_series[days_ago] == null) {
	          time_series[days_ago] = [];
	        }
	        time_series[days_ago].push(o);
	      }
	    }
	    per_day = [];
	    for (days_ago = i1 = ref2 = time_domain.latest_opinion, ref3 = time_domain.earliest; ref2 <= ref3 ? i1 <= ref3 : i1 >= ref3; days_ago = ref2 <= ref3 ? ++i1 : --i1) {
	      day = new Date(now - days_ago * 24 * 60 * 60 * 1000);
	      date_str = day.toISOString().split('T')[0];
	      per_day.push([days_ago, date_str, time_series[days_ago] || []]);
	    }
	    per_day.reverse();
	    return {
	      participants: participants,
	      segments: segments,
	      per_day: per_day
	    };
	  }
	});


/***/ },
/* 52 */
/***/ function(module, exports) {

	var CodeMirrorTextArea, JSONEditorTextArea;
	
	styles += "[data-name=\"/dashboard/customizations\"] #DASHBOARD-main {\n  max-width: 85vw;\n}";
	
	window.CustomizationsDash = ReactiveComponent({
	  displayName: 'CustomizationsDash',
	  render: function() {
	    var base, base1, base2, code_properties, compare_to, current_user, cust, error, forum, i, js, k, len, other_subs, ref, sub, subdomain, subdomains, v;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    subdomains = fetch('/subdomains');
	    if (this.local.compare_to == null) {
	      this.local.compare_to = '';
	      save(this.local);
	    }
	    other_subs = [];
	    ref = subdomains.subs;
	    for (i = 0, len = ref.length; i < len; i++) {
	      sub = ref[i];
	      if (!(sub.customizations && sub.name !== subdomain.name)) {
	        continue;
	      }
	      other_subs.push([sub.name.toLowerCase(), sub.customizations]);
	      if (sub.name.toLowerCase() === this.local.compare_to) {
	        compare_to = sub.customizations || "{}";
	      }
	    }
	    other_subs.sort(function(a, b) {
	      if (a[0] < b[0]) {
	        return -1;
	      } else if (a[0] > b[0]) {
	        return 1;
	      } else {
	        return 0;
	      }
	    });
	    if (!subdomain.name || !current_user.is_super_admin || !subdomains.subs) {
	      return SPAN(null);
	    }
	    if (typeof CodeMirror === "undefined" || CodeMirror === null) {
	      location.reload();
	      return SPAN(null);
	    }
	    if ((base = this.local).stringified_current_value == null) {
	      base.stringified_current_value = JSON.stringify(subdomain.customizations || "\n\n\n\n\n\n\n", null, 2);
	    }
	    if ((base1 = this.local).customization_filter == null) {
	      base1.customization_filter = '';
	    }
	    if ((base2 = this.local).property_changes == null) {
	      base2.property_changes = {};
	    }
	    try {
	      code_properties = (function() {
	        var ref1, results;
	        ref1 = subdomain.customizations;
	        results = [];
	        for (k in ref1) {
	          v = ref1[k];
	          if (typeof v === 'string' && v.startsWith(FUNCTION_IDENTIFIER)) {
	            results.push([k, v]);
	          }
	        }
	        return results;
	      })();
	    } catch (error1) {
	      error = error1;
	      code_properties = [];
	      console.error(error);
	    }
	    return DIV({
	      className: 'customizations'
	    }, STYLE({
	      dangerouslySetInnerHTML: {
	        __html: ".customizations .CodeMirror {\n  height: 500px;\n  font-size: 14px;\n  border: 1px solid #ddd;\n}\n"
	      }
	    }), DIV({
	      className: 'input_group'
	    }, DIV({
	      style: {
	        display: 'inline-block',
	        width: this.local.compare_to !== '' ? '58%' : '75%',
	        verticalAlign: 'top'
	      }
	    }, DIV(null, JSONEditorTextArea({
	      id: 'json',
	      key: md5(subdomain.customizations),
	      json: subdomain.customizations,
	      onChange: (function(_this) {
	        return function(val) {
	          return _this.local.stringified_current_value = val;
	        };
	      })(this)
	    })), DIV({
	      className: 'input_group'
	    }, BUTTON({
	      className: 'btn',
	      onClick: (function(_this) {
	        return function() {
	          return _this.submit();
	        };
	      })(this),
	      style: {
	        backgroundColor: focus_color(),
	        marginTop: 18
	      }
	    }, 'Save')), this.local.save_complete ? DIV({
	      style: {
	        color: 'green'
	      }
	    }, 'Saved.') : void 0, this.local.errors ? this.local.errors && this.local.errors.length > 0 ? DIV({
	      style: {
	        borderRadius: 8,
	        margin: 20,
	        padding: 20,
	        backgroundColor: '#FFE2E2'
	      }
	    }, H1({
	      style: {
	        fontSize: 18
	      }
	    }, 'Ooops!'), (function() {
	      var j, len1, ref1, results;
	      ref1 = this.local.errors;
	      results = [];
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        error = ref1[j];
	        results.push(DIV({
	          style: {
	            marginTop: 10
	          }
	        }, error));
	      }
	      return results;
	    }).call(this)) : void 0 : void 0), DIV({
	      style: {
	        display: 'inline-block',
	        width: this.local.compare_to === '' ? '22%' : '38%',
	        verticalAlign: 'top',
	        marginLeft: '2%'
	      }
	    }, INPUT({
	      style: {
	        width: '100%'
	      },
	      placeholder: 'Filter to forums with customization containing...',
	      type: 'text',
	      defaultValue: '',
	      onKeyUp: (function(_this) {
	        return function(e) {
	          _this.local.customization_filter = e.target.value;
	          return save(_this.local);
	        };
	      })(this)
	    }), DIV(null, "Compare to ", SELECT({
	      value: this.local.compare_to,
	      style: {
	        width: 80
	      },
	      onChange: (function(_this) {
	        return function(ev) {
	          _this.local.compare_to = ev.target.value;
	          return save(_this.local);
	        };
	      })(this)
	    }, (function() {
	      var j, len1, ref1, results;
	      results = [];
	      for (j = 0, len1 = other_subs.length; j < len1; j++) {
	        ref1 = other_subs[j], forum = ref1[0], cust = ref1[1];
	        if (this.local.customization_filter.length === 0 || JSON.stringify(cust).toLowerCase().indexOf(this.local.customization_filter.toLowerCase()) > -1) {
	          if (this.local.customization_filter.length > 0) {
	            console.log(JSON.stringify(cust).toLowerCase(), this.local.customization_filter.toLowerCase(), JSON.stringify(cust).toLowerCase().indexOf(this.local.customization_filter.toLowerCase()) > -1);
	          }
	          results.push(OPTION({
	            value: forum
	          }, forum));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }).call(this)), ".consider.it:"), !!compare_to ? JSONEditorTextArea({
	      id: 'json',
	      key: JSON.stringify(compare_to),
	      json: compare_to,
	      onChange: function(val) {
	        return false;
	      }
	    }) : void 0)), code_properties.length > 0 ? DIV({
	      style: {
	        marginTop: 50
	      }
	    }, H2({
	      style: {
	        fontSize: 36
	      }
	    }, "Easier code-editing sections"), (function() {
	      var ref1, results;
	      ref1 = subdomain.customizations;
	      results = [];
	      for (k in ref1) {
	        v = ref1[k];
	        if (typeof v === 'string' && v.startsWith(FUNCTION_IDENTIFIER)) {
	          js = v.substring(FUNCTION_IDENTIFIER.length);
	          results.push(DIV(null, H3({
	            style: {
	              fontSize: 24,
	              marginTop: 36
	            }
	          }, k), DIV(null, CodeMirrorTextArea({
	            key: (md5(subdomain.customizations)) + "-" + k,
	            default_value: js,
	            onChange: (function(_this) {
	              return function(k) {
	                return function(val) {
	                  _this.local.property_changes[k] = val;
	                  return save(_this.local);
	                };
	              };
	            })(this)(k)
	          })), DIV({
	            className: 'input_group'
	          }, BUTTON({
	            className: 'btn',
	            onClick: (function(_this) {
	              return function(k) {
	                return function() {
	                  if (k in _this.local.property_changes) {
	                    return _this.submit_change(k, _this.local.property_changes[k], true);
	                  }
	                };
	              };
	            })(this)(k),
	            style: {
	              backgroundColor: focus_color(),
	              opacity: !(k in this.local.property_changes) ? .5 : void 0,
	              cursor: !(k in this.local.property_changes) ? 'default' : void 0,
	              marginTop: 18
	            },
	            disabled: !(k in this.local.property_changes) ? true : void 0
	          }, 'Save'))));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }).call(this)) : void 0, DIV(null, DIV({
	      style: {
	        marginTop: 20,
	        marginBottom: 5,
	        cursor: 'pointer',
	        fontWeight: 600,
	        color: '#666',
	        textDecoration: 'underline'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_shared = !_this.local.show_shared;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Shared code and variables to use in customizations"), this.local.show_shared ? CodeMirrorTextArea({
	      key: 'shared_code',
	      default_value: subdomain.shared_code
	    }) : void 0), DIV(null, DIV({
	      style: {
	        marginTop: 20,
	        marginBottom: 5,
	        cursor: 'pointer',
	        fontWeight: 600,
	        color: '#666',
	        textDecoration: 'underline'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_doc = !_this.local.show_doc;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Variable documentation"), this.local.show_doc ? DIV({
	      style: {
	        marginTop: 10
	      }
	    }, A({
	      href: "https://docs.google.com/spreadsheets/d/1gn1PuF98i4eD8x0E4YHmtBAcEdau9W13cJ7fh6MF3u8/edit#gid=0",
	      target: '_blank',
	      style: {
	        display: 'block',
	        textDecoration: 'underline',
	        color: focus_color(),
	        marginBottom: 5
	      }
	    }, "Load documentation in own tab"), ".", IFRAME({
	      width: '100%',
	      height: 1500,
	      src: "https://docs.google.com/spreadsheets/d/1gn1PuF98i4eD8x0E4YHmtBAcEdau9W13cJ7fh6MF3u8/pubhtml?widget=true&amp;headers=false"
	    })) : void 0));
	  },
	  submit_change: function(property, value, is_javascript) {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (is_javascript) {
	      value = "" + FUNCTION_IDENTIFIER + value;
	    }
	    subdomain.customizations[property] = value;
	    return this._save_changes();
	  },
	  submit: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    subdomain.customizations = JSON.parse(this.local.stringified_current_value);
	    return this._save_changes();
	  },
	  _save_changes: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    this.local.save_complete = false;
	    save(this.local);
	    return save(subdomain, (function(_this) {
	      return function() {
	        if (subdomain.errors) {
	          _this.local.errors = subdomain.errors;
	        }
	        _this.local.save_complete = true;
	        return save(_this.local);
	      };
	    })(this));
	  }
	});
	
	JSONEditorTextArea = ReactiveComponent({
	  displayName: 'JSONEditorTextArea',
	  render: function() {
	    return DIV({
	      ref: 'json_editor',
	      style: {
	        height: '100vh'
	      }
	    });
	  },
	  componentDidMount: function() {
	    var editor;
	    editor = new JSONEditor(ReactDOM.findDOMNode(this), {
	      mode: 'code',
	      modes: ['tree', 'code'],
	      onChange: (function(_this) {
	        return function() {
	          var base, e;
	          try {
	            return typeof (base = _this.props).onChange === "function" ? base.onChange(editor.getText()) : void 0;
	          } catch (error1) {
	            e = error1;
	            return console.log('Got error', e);
	          }
	        };
	      })(this)
	    });
	    return editor.set(this.props.json);
	  }
	});
	
	CodeMirrorTextArea = ReactiveComponent({
	  displayName: 'CodeMirrorTextArea',
	  render: function() {
	    return TEXTAREA({
	      id: this.props.id,
	      name: this.props.id,
	      ref: 'field',
	      defaultValue: this.props.default_value
	    });
	  },
	  componentDidMount: function() {
	    var betterTab;
	    betterTab = function(cm) {
	      var o;
	      if (cm.somethingSelected()) {
	        return cm.indentSelection('add');
	      } else {
	        o = cm.getOption("indentWithTabs") ? "\t" : Array(cm.getOption("indentUnit") + 1).join(" ");
	        return cm.replaceSelection(o, "end", "+input");
	      }
	    };
	    this.m = CodeMirror.fromTextArea(this.refs.field, _.defaults(this.props.opts || {}, {
	      lineNumbers: true,
	      matchBrackets: true,
	      indentUnit: 2,
	      mode: 'javascript',
	      extraKeys: {
	        Tab: betterTab
	      }
	    }));
	    if (this.props.onChange) {
	      return this.m.on('change', (function(_this) {
	        return function() {
	          return _this.props.onChange(_this.m.getValue());
	        };
	      })(this));
	    }
	  },
	  componentWillUnmount: function() {
	    return this.m.getTextArea().remove();
	  }
	});


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var get_dash_title, get_dash_widget;
	
	__webpack_require__(36);
	
	__webpack_require__(1);
	
	__webpack_require__(54);
	
	__webpack_require__(60);
	
	__webpack_require__(61);
	
	__webpack_require__(62);
	
	__webpack_require__(8);
	
	__webpack_require__(56);
	
	__webpack_require__(59);
	
	__webpack_require__(55);
	
	__webpack_require__(52);
	
	__webpack_require__(57);
	
	__webpack_require__(50);
	
	__webpack_require__(51);
	
	__webpack_require__(58);
	
	window.styles += "#DASHBOARD-flex-container {\n  display: flex;\n  flex-wrap: nowrap;\n  border-top: 1px solid #EEEEEE;\n}\n#DASHBOARD-menu {\n  /* width: 265px; */\n  flex-grow: 0;\n  background: rgb(246,246,246);\n  background: linear-gradient(180deg, rgba(246,246,246,1) 88%, rgba(255,255,255,1) 100%);\n  padding-bottom: 70px;\n  border: 1px solid #ddd;\n}\n\n#DASHBOARD-menu a {\n  text-decoration: none;\n  color: black;\n  padding: 8px 24px;\n  display: block;\n  font-weight: 400;\n  white-space: nowrap;\n  font-size: 14px;  \n} #DASHBOARD-menu a.active {\n   background-color: " + selected_color + ";\n   color: white;\n} \n\n\n#DASHBOARD-menu a .label {\n  vertical-align: middle;\n}\n#DASHBOARD-menu a .icon {\n  vertical-align: middle;\n  padding-right: 18px;\n  width: 36px;\n  display: inline-block;\n}\n#DASHBOARD-menu div {\n  text-transform: uppercase;\n  padding: 25px 24px 8px 24px;\n  font-weight: 600;\n  opacity: .5;\n  font-size: 0px;\n  visibility: hidden;    \n}  \n#DASHBOARD-main {\n  flex: 1;\n  padding: 30px 0 30px 72px;\n  max-width: 1050px;\n}\n#DASHBOARD-title {\n  font-weight: 700;\n  font-size: 36px;\n  color: " + selected_color + ";\n  margin-bottom: 36px;\n}\n\n#DASHBOARD-main .explanation {\n  font-size: 14px;\n  margin: 8px 0;\n  color: #444;\n}\n\n#DASHBOARD-main .explanation p {\n  margin-bottom: 6px;\n}\n\n#DASHBOARD-main .input_group.checkbox .indented {\n  flex: 1;\n  padding-left: 18px;\n  cursor: pointer;\n}\n\n#DASHBOARD-main .btn {\n  background-color: " + selected_color + ";\n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  #DASHBOARD-main {\n    padding: 30px 24px;\n  }\n  #DASHBOARD-menu {\n    display: none;\n  }\n}\n";
	
	get_dash_widget = function(url) {
	  switch (url) {
	    case '/dashboard/edit_profile':
	      return EditProfile;
	    case '/dashboard/email_notifications':
	      return Notifications;
	    case '/dashboard/data_import_export':
	      return DataDash;
	    case '/dashboard/moderate':
	      return ModerationDash;
	    case '/dashboard/application':
	      return ForumSettingsDash;
	    case '/dashboard/customizations':
	      return CustomizationsDash;
	    case '/dashboard/intake_questions':
	      return IntakeQuestions;
	    case '/dashboard/roles':
	      return SubdomainRoles;
	    case '/dashboard/tags':
	      return UserTags;
	    case '/dashboard/translations':
	      return TranslationsDash;
	    case '/dashboard/all_forums':
	      return AllYourForums;
	    case '/dashboard/analytics':
	      return DataAnalytics;
	    case '/dashboard/meanies':
	      return Meanies;
	    default:
	      return null;
	  }
	};
	
	get_dash_title = function(url) {
	  var title;
	  switch (url) {
	    case '/dashboard/edit_profile':
	      title = 'Your Profile';
	      break;
	    case '/dashboard/email_notifications':
	      title = 'Notifications';
	      break;
	    case '/dashboard/data_import_export':
	      title = 'Data Import & Export';
	      break;
	    case '/dashboard/moderate':
	      title = 'Moderation';
	      break;
	    case '/dashboard/application':
	      title = 'Forum Settings';
	      break;
	    case '/dashboard/customizations':
	      title = 'Customizations';
	      break;
	    case '/dashboard/intake_questions':
	      title = 'Sign-up Questions';
	      break;
	    case '/dashboard/roles':
	      title = 'Permissions & Roles';
	      break;
	    case '/dashboard/tags':
	      title = 'User Tags';
	      break;
	    case '/dashboard/translations':
	      title = 'Language Translation';
	      break;
	    case '/dashboard/all_forums':
	      title = 'All Your Consider.it Forums';
	      break;
	    case '/dashboard/analytics':
	      title = 'Analytics';
	      break;
	    case '/dashboard/meanies':
	      title = 'Sniffing for Suspicious Activity';
	      break;
	    default:
	      null;
	  }
	  return title;
	};
	
	window.Dashboard = ReactiveComponent({
	  displayName: 'Dashboard',
	  render: function() {
	    var Widget, current_user, draw_menu_option, draw_menu_separator, is_admin, is_moderator, is_super, loc, title;
	    current_user = fetch('/current_user');
	    is_admin = current_user.is_admin;
	    is_moderator = current_user.is_moderator;
	    is_super = current_user.is_super_admin;
	    loc = fetch('location');
	    title = get_dash_title(loc.url);
	    if (title === null) {
	      return DIV(null, "No Dashboard at " + loc.url);
	    }
	    Widget = get_dash_widget(loc.url);
	    draw_menu_option = function(opts) {
	      var active;
	      active = opts.href === loc.url;
	      return A({
	        key: opts.href,
	        className: active ? 'active' : void 0,
	        href: opts.href
	      }, opts.icon && false ? SPAN({
	        className: 'icon',
	        dangerouslySetInnerHTML: {
	          __html: dashboard_icons[opts.icon](active ? 'white' : 'black')
	        }
	      }) : void 0, SPAN({
	        className: 'label'
	      }, translator("user_menu.option." + opts.label, opts.label)), opts.paid && permit('configure paid feature') < 0 ? UpgradeForumButton({
	        tag: SPAN,
	        style: {
	          backgroundColor: '#666'
	        }
	      }) : void 0);
	    };
	    draw_menu_separator = function(title) {
	      return DIV({
	        key: title
	      }, translator("dashboard.section_title." + title, title));
	    };
	    return DIV({
	      id: "DASHBOARD-flex-container",
	      "data-name": loc.url,
	      style: {
	        width: DASHBOARD_WIDTH()
	      }
	    }, DIV({
	      id: "DASHBOARD-menu"
	    }, draw_menu_separator('settings'), draw_menu_option({
	      href: '/dashboard/edit_profile',
	      label: 'Edit Profile',
	      icon: 'avatar'
	    }), draw_menu_option({
	      href: '/dashboard/email_notifications',
	      label: 'Email Settings',
	      icon: 'bell'
	    }), is_admin ? [
	      draw_menu_separator("forum setup"), draw_menu_option({
	        href: '/dashboard/application',
	        label: 'Forum Settings',
	        icon: 'forum'
	      }), draw_menu_option({
	        href: '/dashboard/roles',
	        label: 'Permissions & Roles',
	        icon: 'lock'
	      }), draw_menu_option({
	        href: '/dashboard/intake_questions',
	        label: 'Sign-up Questions',
	        icon: 'survey',
	        paid: true
	      })
	    ] : void 0, is_super ? draw_menu_option({
	      href: '/dashboard/customizations',
	      label: 'Customizations',
	      icon: 'coding'
	    }) : void 0, is_admin ? [
	      draw_menu_separator("administration"), draw_menu_option({
	        href: '/dashboard/moderate',
	        label: 'Moderate',
	        icon: 'moderation'
	      }), draw_menu_option({
	        href: '/dashboard/analytics',
	        label: 'Analytics'
	      }), draw_menu_option({
	        href: '/dashboard/data_import_export',
	        label: 'Import / Export Data',
	        icon: 'upload',
	        paid: true
	      })
	    ] : void 0, is_super ? draw_menu_option({
	      href: '/dashboard/tags',
	      label: 'User Tags',
	      icon: 'user_data'
	    }) : void 0, draw_menu_separator('other'), draw_menu_option({
	      href: '/dashboard/translations',
	      label: 'Language Translation',
	      icon: 'translate'
	    }), current_user.logged_in ? draw_menu_option({
	      href: '/dashboard/all_forums',
	      label: 'All Your Forums'
	    }) : void 0), DIV({
	      id: "DASHBOARD-main"
	    }, H1({
	      id: "DASHBOARD-title"
	    }, TRANSLATE("dashboard." + title + ".header", title)), typeof Widget === "function" ? Widget({
	      key: "/page" + loc.url
	    }) : void 0));
	  }
	});
	
	window.styles += "#modal #DASHBOARD-main {\n  padding: 0px;\n}";
	
	window.ModalDash = ReactiveComponent({
	  displayName: 'ModalDash',
	  mixins: [Modal],
	  render: function() {
	    var Widget, title;
	    Widget = get_dash_widget(this.props.url);
	    title = get_dash_title(this.props.url);
	    return wrap_in_modal(null, this.props.done_callback, DIV({
	      id: 'DASHBOARD-main'
	    }, H1({
	      style: {
	        fontSize: 28,
	        marginBottom: 36
	      }
	    }, translator("dashboard.section_title." + title, title)), Widget(), BUTTON({
	      className: 'btn',
	      style: {
	        marginTop: 36
	      },
	      onClick: this.props.done_callback
	    }, 'Done')));
	  }
	});
	
	if (!browser.is_mobile) {
	  window.styles += ".radio_group input[type='radio']{\n  -webkit-appearance: button;\n  -moz-appearance: button;\n  appearance: button;\n  border: 4px solid #ccc;\n  border-top-color: #bbb;\n  border-left-color: #bbb;\n  background: #fff;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  position: absolute;\n  left: -36px;\n  margin-top: 0;\n}\n.radio_group input[type='radio']:checked{\n  border: 10px solid " + focus_blue + ";\n}\n\n.radio_group {\n  position: relative;\n  margin-left: 36px;    \n}";
	}
	
	window.styles += "\n/* From https://www.w3schools.com/howto/howto_css_switch.asp */\n/* The switch - the box around the slider */\n\n.toggle_switch {\n  position: relative;\n  display: inline-block;\n  width: 52px;\n  height: 26px;\n}\n\n/* Hide default HTML checkbox */\n.toggle_switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* The slider */\n.toggle_switch .toggle_switch_circle {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: .4s;\n  transition: .4s;\n  border-radius: 34px;\n  box-shadow: 0 1px 2px rgb(0 0 0 / 40%);\n\n}\n\n.toggle_switch .toggle_switch_circle:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n  border-radius: 50%;\n  box-shadow: 0 1px 2px rgb(0 0 0 / 20%)\n}\n\ninput:checked + .toggle_switch_circle {\n  background-color: " + selected_color + ";\n}\n\n# input:focus + .toggle_switch_circle {\n#   box-shadow: 0 0 1px " + selected_color + ";\n# }\n\ninput:checked + .toggle_switch_circle:before {\n  transform: translateX(26px);\n}";


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	
	__webpack_require__(5);
	
	__webpack_require__(8);
	
	window.styles += "#EDITPROFILE label.AUTH_field_label {\n  color: #8F8F8F;\n  text-transform: uppercase;\n  margin-bottom: 2px;\n  margin-top: 8px;\n}\n#EDITPROFILE input.AUTH_text_input {\n  display: block;\n  margin-bottom: 16px;\n}\n\n#EDITPROFILE #SHOWHOSTQUESTIONS {\n  padding: 12px 0 0 33px;\n  background-color: transparent;\n}\n\n@media " + PHONE_MEDIA + " {\n  #EDITPROFILE #SHOWHOSTQUESTIONS {\n    padding: 0 18px;\n  }    \n}";
	
	window.EditProfile = ReactiveComponent({
	  displayName: 'EditProfile',
	  mixins: [AuthForm],
	  render: function() {
	    var current_user, i18n, is_SSO, on_submit;
	    current_user = fetch('/current_user');
	    i18n = this.i18n();
	    is_SSO = fetch('/subdomain').SSO_domain;
	    if (this.local.saved_successfully && is_SSO) {
	      loadPage('/');
	    }
	    on_submit = (function(_this) {
	      return function(ev) {
	        return _this.Submit(ev, {
	          action: 'edit profile',
	          has_host_questions: true,
	          has_avatar_upload: true
	        });
	      };
	    })(this);
	    return DIV({
	      id: 'EDITPROFILE'
	    }, !is_SSO ? [
	      this.RenderInput({
	        type: 'email',
	        name: 'email',
	        label: i18n.email_label,
	        on_submit: on_submit
	      }), this.RenderInput({
	        type: 'password',
	        name: 'password',
	        label: i18n.new_password_label,
	        on_submit: on_submit
	      }), this.local.updates.password !== current_user.password || this.local.updates.email !== current_user.email ? this.RenderInput({
	        type: 'password',
	        name: 'old_password',
	        label: i18n.old_password_label,
	        on_submit: on_submit
	      }) : void 0
	    ] : void 0, this.RenderInput({
	      name: 'name',
	      label: i18n.name_label,
	      on_submit: on_submit
	    }), DIV({
	      className: 'AUTH_field_wrapper',
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL({
	      className: 'AUTH_field_label'
	    }, i18n.pic_prompt), AvatarInput()), forum_has_host_questions() ? DIV({
	      style: {
	        backgroundColor: considerit_gray,
	        marginBottom: 24,
	        marginTop: 52
	      }
	    }, H4({
	      style: {
	        marginBottom: 12,
	        padding: '24px 36px 8px 36px',
	        fontSize: 22,
	        fontWeight: 400
	      }
	    }, translator('auth.additional_info.heading', 'Questions from your host')), ShowHostQuestions({
	      disable_unchecking_required_booleans: true
	    })) : void 0, BUTTON({
	      className: "btn " + (this.local.submitting ? 'disabled' : ''),
	      onClick: on_submit
	    }, translator('shared.save_changes_button', 'Save changes')), this.local.saved_successfully ? DIV({
	      style: {
	        backgroundColor: 'white',
	        color: '#888'
	      }
	    }, i18n.successful_update) : void 0, this.ShowErrors(), DIV({
	      style: {
	        marginTop: 80
	      }
	    }, FORM({
	      id: 'delete_account_form'
	    }, INPUT({
	      type: 'submit',
	      value: translator('auth.delete_account', 'Delete your account'),
	      style: {
	        color: '#b74e4e',
	        fontWeight: 600,
	        padding: '10px 18px',
	        borderRadius: 8,
	        border: 'none',
	        backgroundColor: '#efefef',
	        boxShadow: '0 1px 2px rgba(0,0,0,.2)'
	      },
	      onClick: (function(_this) {
	        return function(ev) {
	          var error_msg;
	          ev.preventDefault();
	          if (confirm(translator('auth.delete_account_confirmation', "We're sorry to see you go! Just to check first, though: this will irreversibly delete your account and any material you have contributed to this or any other Consider.it forums with be removed or anonymized. Do you still want to proceed?"))) {
	            error_msg = "Something went wrong trying to delete your account. Please contact help@consider.it and we'll get it done. If you've created a Consider.it forum in the past, that is the most likely cause.";
	            return ajax_submit_files_in_form({
	              uri: '/current_user',
	              type: 'delete',
	              form: '#delete_account_form',
	              additional_data: {
	                authenticity_token: arest.csrf()
	              },
	              success: function(resp) {
	                var ref;
	                if (resp.length > 0 && (((ref = JSON.parse(resp)) != null ? ref.error : void 0) != null)) {
	                  _this.local.errors = [translator('auth.delete_account_contact_us', error_msg)];
	                  return save(_this.local);
	                } else {
	                  return window.location.href = location.origin;
	                }
	              },
	              error: function(results) {
	                _this.local.errors = [translator('auth.delete_account_contact_us', error_msg)];
	                return save(_this.local);
	              }
	            });
	          }
	        };
	      })(this)
	    })), FORM({
	      id: 'delete_data_form'
	    }, INPUT({
	      type: 'submit',
	      value: translator('auth.delete_data', 'Delete your data on this forum'),
	      style: {
	        marginTop: 18,
	        color: '#b74e4e',
	        fontWeight: 600,
	        padding: '10px 18px',
	        borderRadius: 8,
	        border: 'none',
	        backgroundColor: '#efefef',
	        boxShadow: '0 1px 2px rgba(0,0,0,.2)'
	      },
	      onClick: (function(_this) {
	        return function(ev) {
	          var error_msg;
	          ev.preventDefault();
	          if (confirm(translator('auth.delete_data_confirmation', "Your opinions, comments, and other data associated with this forum will be irreversibly deleted or anonymized. Your Consider.it account will remain active. Do you still want to proceed?"))) {
	            error_msg = "Something went wrong trying to delete your data. Please contact help@consider.it and we'll get it done.";
	            return ajax_submit_files_in_form({
	              uri: '/delete_data_for_forum',
	              type: 'delete',
	              form: '#delete_data_form',
	              additional_data: {
	                authenticity_token: arest.csrf()
	              },
	              success: function(resp) {
	                var ref;
	                if (resp.length > 0 && (((ref = JSON.parse(resp)) != null ? ref.error : void 0) != null)) {
	                  _this.local.errors = [translator('auth.delete_data_contact_us', error_msg)];
	                  return save(_this.local);
	                } else {
	                  return window.location.href = location.origin;
	                }
	              },
	              error: function(results) {
	                _this.local.errors = [translator('auth.delete_data_contact_us', error_msg)];
	                return save(_this.local);
	              }
	            });
	          }
	        };
	      })(this)
	    }))), DIV({
	      style: {
	        marginTop: 36
	      }
	    }, TRANSLATE({
	      id: 'contact.about_data_export',
	      LINK: {
	        component: A,
	        args: {
	          href: 'mailto:help@consider.it',
	          treat_as_external_link: true
	        }
	      }
	    }, "Please contact us at <LINK>help@consider.it</LINK> if you would like an export of your data from this forum.")));
	  }
	});


/***/ },
/* 55 */
/***/ function(module, exports) {

	window.styles += ".FORUM_SETTINGS { \n  font-size: 16px;\n  max-width: 650px;\n}\n.FORUM_SETTINGS input[type=\"text\"], .FORUM_SETTINGS textarea { \n  border: 1px solid #aaa; \n  display: block; \n  font-size: 18px; \n  padding: 4px 8px; \n} \n.FORUM_SETTINGS .input_group { \n  margin-bottom: 24px; \n}\n\n.FORUM_SETTINGS_section {\n  margin-top: 36px;\n}\n.FORUM_SETTINGS_section h4 {\n  font-size: 18px; \n  font-weight: 600;\n}\n\n.FORUM_SETTINGS .radio_group {\n  margin-top: 24px;\n  display: flex;\n  align-items: flex-start;\n}\n.FORUM_SETTINGS .radio_group label {\n  margin-left: 12px;\n  margin-top: -2px;\n}\n\n.FORUM_SETTINGS .radio_group input[type=\"radio\"] {\n  margin-top: 0;\n}\n\n#DASHBOARD-main .FORUM_SETTINGS .field_explanation {\n  margin-left: 48px;\n}\n \n.FORUM_SETTINGS .input_group.checkbox {\n  display: flex;\n}\n\n.FORUM_SETTINGS .input_group.checkbox .toggle_switch {\n  margin-top: 6px;\n}\n\n.FORUM_SETTINGS .input_group.checkbox .toggle_switch.disabled{\n  opacity: 0.3;\n}\n";
	
	window.ForumSettingsDash = ReactiveComponent({
	  displayName: 'ForumSettingsDash',
	  render: function() {
	    var current_user, option, subdomain;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    if (!subdomain.name) {
	      return SPAN(null);
	    }
	    return DIV({
	      className: 'FORUM_SETTINGS'
	    }, this.drawAnonymitySettings(), this.drawContributionPhaseSettings(), this.drawModerationSettings(), this.drawMiscSettings(), current_user.is_super_admin ? DIV({
	      className: 'FORUM_SETTINGS_section input_group'
	    }, H4(null, 'Forum Plan Type'), FIELDSET(null, (function() {
	      var i, len, ref, results;
	      ref = [
	        {
	          label: 'Free Forum',
	          value: 0
	        }, {
	          label: 'Premium Forum',
	          value: 1
	        }, {
	          label: 'Enterprise Forum',
	          value: 2
	        }
	      ];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        option = ref[i];
	        results.push(DIV({
	          key: option.label
	        }, DIV({
	          className: 'radio_group',
	          style: {
	            cursor: 'pointer'
	          },
	          onClick: (function(_this) {
	            return function(option) {
	              return function() {
	                subdomain.plan = option.value;
	                return save(subdomain);
	              };
	            };
	          })(this)(option)
	        }, INPUT({
	          style: {
	            cursor: 'pointer'
	          },
	          type: 'radio',
	          name: "plan",
	          id: "plan_" + option.value,
	          defaultChecked: subdomain.plan === option.value
	        }), LABEL({
	          style: {
	            cursor: 'pointer',
	            display: 'block'
	          },
	          htmlFor: "plan_" + option.value
	        }, option.label))));
	      }
	      return results;
	    }).call(this))) : void 0, current_user.is_super_admin ? FORM({
	      id: 'rename_forum',
	      action: '/rename_forum',
	      method: 'post',
	      style: {
	        marginTop: 40
	      }
	    }, LABEL({
	      htmlFor: 'name'
	    }, 'Rename forum to: '), INPUT({
	      id: 'name',
	      name: 'name',
	      type: 'text',
	      style: {
	        width: 300
	      }
	    }), INPUT({
	      type: 'hidden',
	      name: 'authenticity_token',
	      value: arest.csrf()
	    }), INPUT({
	      type: 'submit',
	      onSubmit: (function(_this) {
	        return function() {
	          return confirm("Are you sure you want to rename this forum?");
	        };
	      })(this)
	    })) : void 0);
	  },
	  drawMiscSettings: function() {
	    var current_user, lang, not_english, subdomain;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    lang = this.local.language || subdomain.lang || 'en';
	    not_english = (lang != null) && lang !== 'en';
	    return DIV({
	      className: 'FORUM_SETTINGS_section input_group'
	    }, H4(null, 'Other Settings'), DIV({
	      className: 'explanation'
	    }), DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'lang'
	    }, 'Primary Language'), SELECT({
	      id: 'lang',
	      type: 'text',
	      name: 'lang',
	      value: lang,
	      onChange: (function(_this) {
	        return function(ev) {
	          subdomain.lang = ev.target.value;
	          return save(subdomain, function() {
	            return location.reload();
	          });
	        };
	      })(this),
	      style: {
	        fontSize: 18,
	        marginLeft: 12,
	        display: 'inline-block'
	      }
	    }, (function(_this) {
	      return function() {
	        var abbrev, available_languages, label, results;
	        available_languages = Object.assign({}, fetch('/supported_languages').available_languages || {});
	        if (current_user.is_super_admin) {
	          available_languages['pseudo-en'] = "Pseudo English (for testing)";
	        }
	        results = [];
	        for (abbrev in available_languages) {
	          label = available_languages[abbrev];
	          results.push(OPTION({
	            key: abbrev,
	            value: abbrev
	          }, label));
	        }
	        return results;
	      };
	    })(this)()), not_english ? DIV({
	      className: 'explanation'
	    }, TRANSLATE({
	      id: "translations.link",
	      percent_complete: Math.round(translation_progress(lang) * 100),
	      language: (fetch('/supported_languages').available_languages || {})[lang],
	      link: {
	        component: A,
	        args: {
	          href: "/dashboard/translations",
	          style: {
	            textDecoration: 'underline',
	            color: focus_color(),
	            fontWeight: 700
	          }
	        }
	      }
	    }, "Translations for {language} are {percent_complete}% completed. Help improve the translations <link>here</link>.")) : void 0, DIV({
	      className: 'explanation'
	    }, "Is your preferred language not available? Email us at ", A({
	      href: "mailto:hello@consider.it?subject=New language request",
	      style: {
	        textDecoration: 'underline',
	        fontWeight: 600
	      }
	    }, "hello@consider.it"), " to help us create a translation.")), DIV({
	      className: 'input_group checkbox'
	    }, LABEL({
	      className: 'toggle_switch'
	    }, INPUT({
	      id: 'email_notifications_disabled',
	      type: 'checkbox',
	      name: 'email_notifications_disabled',
	      defaultChecked: customization('email_notifications_disabled'),
	      onChange: function(ev) {
	        subdomain.customizations || (subdomain.customizations = {});
	        subdomain.customizations.email_notifications_disabled = ev.target.checked;
	        return save(subdomain);
	      }
	    }), SPAN({
	      className: 'toggle_switch_circle'
	    })), LABEL({
	      className: 'indented',
	      htmlFor: 'email_notifications_disabled'
	    }, B(null, 'Disable email notifications.'), DIV({
	      className: 'explanation'
	    }, " Participants will not be notified via email about activity on this forum."))), (function(_this) {
	      return function() {
	        var key, question_index;
	        key = subdomain.name + "-pledge_taken";
	        question_index = function() {
	          var i, idx, len, ref, tag;
	          ref = subdomain.customizations.user_tags || [];
	          for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	            tag = ref[idx];
	            if (tag.key === key) {
	              return idx;
	            }
	          }
	          return null;
	        };
	        return DIV({
	          className: 'input_group checkbox'
	        }, LABEL({
	          className: 'toggle_switch'
	        }, INPUT({
	          id: 'enable_civility_pledge',
	          type: 'checkbox',
	          name: 'enable_civility_pledge',
	          defaultChecked: question_index() !== null,
	          onChange: function(ev) {
	            var base, idx, pledge;
	            subdomain.customizations || (subdomain.customizations = {});
	            if ((base = subdomain.customizations).user_tags == null) {
	              base.user_tags = [];
	            }
	            if (ev.target.checked) {
	              pledge = {
	                key: key,
	                no_opinion_view: true,
	                visibility: "host-only",
	                participation_pledge: true,
	                view_name: 'participation_pledge',
	                self_report: {
	                  input: "boolean",
	                  question: 'I pledge to be civil and to use only one account',
	                  required: true
	                }
	              };
	              subdomain.customizations.user_tags.push(pledge);
	            } else {
	              idx = question_index();
	              if (idx !== null) {
	                subdomain.customizations.user_tags.splice(idx, 1);
	                if (subdomain.customizations.user_tags.length === 0) {
	                  delete subdomain.customizations.user_tags;
	                }
	              }
	            }
	            return save(subdomain);
	          }
	        }), SPAN({
	          className: 'toggle_switch_circle'
	        })), LABEL({
	          className: 'indented',
	          htmlFor: 'enable_civility_pledge'
	        }, B(null, 'Enable civility pledge.'), DIV({
	          className: 'explanation'
	        }, 'Newly registered participants must agree to be civil and to use only one account.')));
	      };
	    })(this)(), DIV({
	      className: 'input_group checkbox'
	    }, LABEL({
	      className: 'toggle_switch'
	    }, INPUT({
	      id: 'enable_google_translate',
	      type: 'checkbox',
	      name: 'enable_google_translate',
	      defaultChecked: !customization('disable_google_translate'),
	      onChange: function(ev) {
	        subdomain.customizations || (subdomain.customizations = {});
	        subdomain.customizations.disable_google_translate = !ev.target.checked;
	        return save(subdomain);
	      }
	    }), SPAN({
	      className: 'toggle_switch_circle'
	    })), LABEL({
	      className: 'indented',
	      htmlFor: 'enable_google_translate'
	    }, B(null, 'Enable Google Translate.'), SUP({
	      style: {
	        fontSize: 10
	      }
	    }, "Not recommended for EU forums or private forums"), DIV({
	      className: 'explanation'
	    }, "The Google Translate widget allows participants to select a different language. The entire \nforum, including other participants\' comments, will then be translated to that target language.\nIf you are running a private forum or a forum in the EU, you should disable this functionality because\nall text to be translated is sent to Google's servers and retained there to train the language model."))), current_user.is_super_admin ? DIV({
	      className: 'input_group checkbox'
	    }, LABEL({
	      className: 'toggle_switch'
	    }, INPUT({
	      id: 'enable_plausible',
	      type: 'checkbox',
	      name: 'enable_plausible',
	      defaultChecked: customization('enable_plausible_analytics'),
	      onChange: function(ev) {
	        subdomain.customizations || (subdomain.customizations = {});
	        subdomain.customizations.enable_plausible_analytics = ev.target.checked;
	        return save(subdomain);
	      }
	    }), SPAN({
	      className: 'toggle_switch_circle'
	    })), LABEL({
	      className: 'indented',
	      htmlFor: 'enable_plausible'
	    }, B(null, 'Collect Advanced Visitation Data.'), DIV({
	      className: 'explanation'
	    }, 'Plausible Analytics for this forum.'))) : void 0);
	  },
	  drawAnonymitySettings: function() {
	    var allow_change_anon, allow_change_perm_anon, subdomain, theme;
	    subdomain = fetch('/subdomain');
	    allow_change_anon = !subdomain.customizations.anonymize_permanently;
	    allow_change_perm_anon = subdomain.customizations.anonymize_everything && (!subdomain.customizations.anonymize_permanently);
	    return DIV({
	      className: 'FORUM_SETTINGS_section input_group'
	    }, H4(null, 'Identity and Content Visibility'), DIV({
	      className: 'explanation'
	    }, "These settings control the level of anonymity and visibility of participant identities and opinions in the forum, \nranging from hiding the opinions of others to complete anonymization of authors' identities."), DIV({
	      style: {
	        marginTop: 32
	      }
	    }, DIV({
	      className: 'input_group checkbox'
	    }, LABEL({
	      className: 'toggle_switch'
	    }, INPUT({
	      id: 'hide_opinions',
	      type: 'checkbox',
	      name: 'hide_opinions',
	      defaultChecked: customization('hide_opinions'),
	      onChange: function(ev) {
	        subdomain.customizations || (subdomain.customizations = {});
	        subdomain.customizations.hide_opinions = ev.target.checked;
	        return save(subdomain, function() {
	          return arest.serverFetch('/users');
	        });
	      }
	    }), SPAN({
	      className: 'toggle_switch_circle'
	    })), LABEL({
	      className: 'indented',
	      htmlFor: 'hide_opinions'
	    }, B(null, 'Hide the opinions of others.'), DIV({
	      className: 'explanation'
	    }, ' The authors of proposals, points, and comments are still shown, but opinions of others are hidden. Hosts, like you, however, will be able to see the opinions of everyone.'))), DIV({
	      className: 'input_group checkbox'
	    }, LABEL({
	      className: 'toggle_switch' + (allow_change_anon ? '' : ' disabled')
	    }, INPUT({
	      id: 'anonymize_everything',
	      type: 'checkbox',
	      name: 'anonymize_everything',
	      defaultChecked: customization('anonymize_everything'),
	      disabled: !allow_change_anon,
	      onChange: function(ev) {
	        subdomain.customizations || (subdomain.customizations = {});
	        subdomain.customizations.anonymize_everything = ev.target.checked;
	        return save(subdomain, function() {
	          return location.reload();
	        });
	      }
	    }), SPAN({
	      className: 'toggle_switch_circle'
	    })), LABEL({
	      className: 'indented',
	      htmlFor: 'anonymize_everything'
	    }, B(null, 'Conceal identities.'), DIV({
	      className: 'explanation'
	    }, "The authors of opinions, points, proposals, and comments will be hidden. Participants still need to be registered. The real identity of authors will still be accessible via the data export. This setting is reversible."))), DIV({
	      className: 'input_group checkbox',
	      style: {
	        paddingLeft: 70
	      }
	    }, LABEL({
	      className: 'toggle_switch' + (allow_change_perm_anon ? '' : ' disabled'),
	      onClick: function(ev) {
	        var confirmed, now;
	        if (!allow_change_perm_anon) {
	          ev.stopPropagation();
	          ev.preventDefault();
	          return;
	        }
	        now = new Date();
	        confirmed = this.lastConfirmTime && (now - this.lastConfirmTime < 100);
	        if (confirmed) {
	          return confirmed;
	        }
	        confirmed = confirm('This makes anonymization of this forum permanent. You will not be able to revert. Are you certain?');
	        if (confirmed) {
	          return this.lastConfirmTime = new Date();
	        } else {
	          ev.stopPropagation();
	          return ev.preventDefault();
	        }
	      }
	    }, INPUT({
	      id: 'anonymize_permanently',
	      type: 'checkbox',
	      name: 'anonymize_permanently',
	      defaultChecked: customization('anonymize_permanently'),
	      disabled: !allow_change_perm_anon,
	      onChange: function(ev) {
	        subdomain.customizations || (subdomain.customizations = {});
	        if (ev.target.checked) {
	          subdomain.customizations.anonymize_everything = true;
	        }
	        subdomain.customizations.anonymize_permanently = ev.target.checked;
	        return save(subdomain, function() {
	          return arest.serverFetch('/users');
	        });
	      }
	    }), SPAN({
	      className: 'toggle_switch_circle'
	    })), LABEL({
	      className: 'indented',
	      htmlFor: 'anonymize_permanently'
	    }, B(null, 'Anonymize permanently.'), DIV({
	      className: 'explanation'
	    }, "Permanently hide the identities of participants. You will never see the identities of participants. Data export will not reveal the identity of participants. This is irreversible."))), customization('anonymize_everything') ? DIV({
	      className: 'input_group',
	      style: {
	        paddingLeft: 70
	      }
	    }, DIV(null, LABEL({
	      htmlFor: 'anonymization_theme',
	      style: {
	        marginRight: 18
	      }
	    }, 'Anonymization theme'), SELECT({
	      id: 'anonymization_theme',
	      defaultValue: customization('anonymization_theme'),
	      style: {
	        fontSize: 18
	      },
	      onChange: (function(_this) {
	        return function(e) {
	          subdomain.customizations.anonymization_theme = e.target.value;
	          return save(subdomain, function() {
	            return location.reload();
	          });
	        };
	      })(this)
	    }, (function() {
	      var i, len, ref, results;
	      ref = [
	        {
	          value: null,
	          label: 'Default'
	        }, {
	          value: 'playful',
	          label: 'Cat Masks'
	        }, {
	          value: 'wrestling_masks',
	          label: 'Wrestling Masks'
	        }, {
	          value: 'sea_creatures',
	          label: 'Sea Creatures'
	        }
	      ];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        theme = ref[i];
	        results.push(OPTION({
	          key: theme.value,
	          value: theme.value
	        }, theme.label));
	      }
	      return results;
	    })())), DIV({
	      className: 'explanation'
	    }, "Anonymous names and avatars will be assigned to participants, following a specific theme. These \nthemes help enhance the livliness of the forum. By default, generic gray avatars are used and each \nparticipant is labeled 'Anonymous'.")) : void 0));
	  },
	  drawContributionPhaseSettings: function() {
	    var current_value, option, phases, subdomain;
	    subdomain = fetch('/subdomain');
	    phases = [
	      {
	        label: "Default",
	        value: 0,
	        explanation: ""
	      }, {
	        label: "Frozen",
	        value: 'frozen',
	        explanation: "No one can add or update anything they have said."
	      }, {
	        label: "Ideas only",
	        value: "ideas-only",
	        explanation: "People can only contribute new proposals at this time, and only in places you've allowed it."
	      }, {
	        label: "Opinions only",
	        value: "opinions-only",
	        explanation: "People can only add opinions at this time. They can drag sliders and write pro/con points, but no new proposals."
	      }
	    ];
	    current_value = customization('contribution_phase') || 0;
	    return DIV({
	      className: 'FORUM_SETTINGS_section input_group'
	    }, H4(null, 'Dialogue State'), DIV({
	      className: 'explanation'
	    }, "Control the state of your dialogue. This setting gives you the ability to override your configuration elsewhere. \nFor example, if you select \"opinions only\", no one will be allowed to add new proposals to any of your open-ended questions,\neven if you allowed it when creating your questions. Your settings can be restored by returning to the \ndefault state. "), FIELDSET(null, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = phases.length; i < len; i++) {
	        option = phases[i];
	        results.push(DIV({
	          key: option.value
	        }, DIV({
	          className: 'radio_group',
	          style: {
	            cursor: 'pointer'
	          },
	          onChange: (function(option) {
	            return function(ev) {
	              subdomain.customizations || (subdomain.customizations = {});
	              subdomain.customizations.contribution_phase = option.value;
	              return save(subdomain);
	            };
	          })(option)
	        }, INPUT({
	          style: {
	            cursor: 'pointer'
	          },
	          type: 'radio',
	          name: "contribution_phase",
	          id: "contribution_phase_" + option.value,
	          defaultChecked: current_value === option.value
	        }), LABEL({
	          style: {
	            cursor: 'pointer',
	            display: 'block'
	          },
	          htmlFor: "contribution_phase_" + option.value
	        }, option.label)), option.explanation ? DIV({
	          className: 'explanation field_explanation'
	        }, option.explanation) : void 0));
	      }
	      return results;
	    })()));
	  },
	  drawModerationSettings: function() {
	    var moderatable_models, option, subdomain;
	    subdomain = fetch('/subdomain');
	    moderatable_models = ['points', 'comments', 'proposals'];
	    return DIV({
	      className: 'FORUM_SETTINGS_section input_group'
	    }, H4(null, 'Your Content Moderation Policy'), DIV({
	      className: 'explanation'
	    }, "Sometimes people post content detrimental to the forum, such as spam or \nattacks on other participants. Detrimental posts are much rarer than many \nhosts fear. Yet even if you do not experience detrimental posts, moderating \ncontent can help hosts keep a pulse on the dialogue. And it usually takes \nless time than expected."), FIELDSET(null, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = moderation_options.length; i < len; i++) {
	        option = moderation_options[i];
	        results.push(DIV({
	          key: option.value
	        }, DIV({
	          className: 'radio_group',
	          style: {
	            cursor: 'pointer'
	          },
	          onClick: (function(_this) {
	            return function(option) {
	              return function() {
	                subdomain.moderation_policy = option.value;
	                return save(subdomain, function() {
	                  return arest.serverFetch('/page/dashboard/moderate');
	                });
	              };
	            };
	          })(this)(option)
	        }, INPUT({
	          style: {
	            cursor: 'pointer'
	          },
	          type: 'radio',
	          name: "moderation_policy",
	          id: "moderation_policy_" + option.value,
	          defaultChecked: subdomain.moderation_policy === option.value
	        }), LABEL({
	          style: {
	            cursor: 'pointer',
	            display: 'block'
	          },
	          htmlFor: "moderation_policy_" + option.value
	        }, option.label)), option.explanation ? DIV({
	          className: 'explanation field_explanation'
	        }, option.explanation) : void 0));
	      }
	      return results;
	    }).call(this)));
	  }
	});


/***/ },
/* 56 */
/***/ function(module, exports) {

	styles += ".dangerzone button {\n  background-color: #c31d1d;\n  padding: 8px 24px;\n  color: white;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;    \n}\n";
	
	window.DataDash = ReactiveComponent({
	  displayName: 'DataDash',
	  successful_import_cb: function(data) {
	    data = JSON.parse(data);
	    if (data[0].errors) {
	      this.local.successes = null;
	      this.local.errors = data[0].errors;
	      return save(this.local);
	    } else {
	      $$.setStyles('html, #submit_import', {
	        cursor: ''
	      });
	      arest.clear_matching_objects(function(key) {
	        return key.match(/\/page\//);
	      });
	      this.local.errors = null;
	      this.local.successes = data[0];
	      return save(this.local);
	    }
	  },
	  failed_import_cb: function(result) {
	    $$.setStyles('html, #submit_import', {
	      cursor: ''
	    });
	    this.local.successes = null;
	    this.local.errors = ['Unknown error parsing the files. Email help@consider.it.'];
	    return save(this.local);
	  },
	  render: function() {
	    var current_user, error, paid, query, subdomain, success, successes, table, tables, user_tags, v;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    if (current_user.is_super_admin) {
	      tables = ['Users', 'Proposals', 'Opinions', 'Points', 'Comments'];
	    } else {
	      tables = ['Proposals'];
	    }
	    paid = permit('configure paid feature') > 0;
	    query = '';
	    user_tags = customization('user_tags');
	    if (user_tags) {
	      query = "?" + (((function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = user_tags.length; i < len; i++) {
	          v = user_tags[i];
	          results.push(v.key);
	        }
	        return results;
	      })()).join('=1&'));
	    }
	    return DIV(null, !paid ? UpgradeForumButton({
	      big: true,
	      text: "Upgrade to enable data import and export"
	    }) : void 0, FORM({
	      action: "/dashboard/export" + query,
	      method: 'post',
	      style: {
	        pointerEvents: !paid ? 'none' : void 0,
	        opacity: !paid ? .4 : void 0
	      }
	    }, INPUT({
	      type: 'hidden',
	      name: 'authenticity_token',
	      value: arest.csrf()
	    }), H4({
	      style: {
	        fontSize: 20,
	        marginBottom: 12
	      }
	    }, "Export data from your forum"), DIV({
	      className: 'explanation'
	    }, "A download will begin in a couple seconds after hitting export. The zip file contains four spreadsheets: opinions, points, proposals, and users.", DIV({
	      style: {
	        backgroundColor: '#f2f2f2',
	        padding: "8px 12px",
	        marginTop: 24
	      }
	    }, "Learn more about the export in the ", A({
	      href: '/docs/data/data_export'
	    }, 'data export documentation'), '.')), INPUT({
	      type: 'submit',
	      className: 'btn',
	      style: {
	        marginTop: 18,
	        fontSize: 20
	      },
	      onClick: (function(_this) {
	        return function() {
	          return show_flash(translator('admin.flashes.export_started', "Your export has started. It can take a little while."));
	        };
	      })(this),
	      value: 'Export'
	    })), AnonymizationCheckForSigninQuestions(), DIV({
	      style: {
	        marginTop: 24,
	        pointerEvents: !paid ? 'none' : void 0,
	        opacity: !paid ? .4 : void 0
	      }
	    }, H4({
	      style: {
	        fontSize: 20,
	        marginBottom: 12
	      }
	    }, "Import data to your forum"), DIV({
	      className: 'explanation'
	    }, P({
	      style: {
	        marginBottom: 6
	      }
	    }, "Your proposal import spreadsheet file should be in CSV format. Importing the same spreadsheet multiple times is okay. Here is an ", A({
	      style: {
	        textDecoration: 'underline',
	        fontWeight: 700
	      },
	      href: "/example_import_csvs/proposals.csv",
	      'data-nojax': true
	    }, 'example .csv file'), ".")), FORM({
	      id: 'import_data',
	      action: '/dashboard/data_import_export'
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = tables.length; i < len; i++) {
	        table = tables[i];
	        results.push(DIV({
	          key: table,
	          style: {
	            display: 'flex',
	            flexDirection: PHONE_SIZE() ? 'column' : 'row',
	            alignItems: 'center'
	          }
	        }, current_user.is_super_admin ? DIV({
	          style: {
	            paddingTop: 20,
	            textAlign: !PHONE_SIZE() ? 'right' : 'center',
	            width: 150
	          }
	        }, LABEL({
	          style: {
	            whiteSpace: 'nowrap'
	          },
	          htmlFor: table + "-file"
	        }, table + " (.csv)"), DIV(null, A({
	          style: {
	            textDecoration: 'underline',
	            fontSize: 12
	          },
	          href: "/example_import_csvs/" + (table.toLowerCase()) + ".csv",
	          'data-nojax': true
	        }, 'Example'))) : void 0, DIV({
	          style: {
	            padding: '20px 20px 0 20px'
	          }
	        }, INPUT({
	          id: table + "-file",
	          name: (table.toLowerCase()) + "-file",
	          type: 'file',
	          style: {
	            backgroundColor: selected_color,
	            color: 'white',
	            fontWeight: 700,
	            borderRadius: 8,
	            padding: 6
	          }
	        }))));
	      }
	      return results;
	    })(), current_user.is_super_admin ? [
	      DIV({
	        key: 'generate_inclusions',
	        style: {
	          padding: '20px 0 20px 20px'
	        }
	      }, INPUT({
	        type: 'checkbox',
	        name: 'generate_inclusions',
	        id: 'generate_inclusions'
	      }), LABEL({
	        htmlFor: 'generate_inclusions'
	      }, "Generate opinions & inclusions of points?\nIt requires a proposal file; for each proposal in the file, this option will increase by \n2x the number of existing opinions. Each simulated opinion will include two points. \nStances and inclusions will not be assigned randomly, but rather following a \nrich-get-richer model. You can use this option multiple times. This option is only good for demos.")), DIV({
	        key: 'assign_pics',
	        style: {
	          padding: '20px 0 20px 20px'
	        }
	      }, INPUT({
	        type: 'checkbox',
	        name: 'assign_pics',
	        id: 'assign_pics'
	      }), LABEL({
	        htmlFor: 'assign_pics'
	      }, "Assign a random profile picture for users without an avatar url"))
	    ] : void 0, BUTTON({
	      id: 'submit_import',
	      className: 'btn',
	      style: {
	        marginTop: 36,
	        fontSize: 20
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          e.preventDefault();
	          $$.setStyles('html, #submit_import', {
	            cursor: 'wait'
	          });
	          return ajax_submit_files_in_form({
	            form: '#import_data',
	            type: 'POST',
	            additional_data: {
	              authenticity_token: arest.csrf(),
	              trying_to: 'update_avatar_hack'
	            },
	            success: _this.successful_import_cb,
	            error: _this.failed_import_cb
	          });
	        };
	      })(this)
	    }, 'Import Data')), current_user.is_super_admin ? [this.drawArgdownImport(), this.drawArgdownExport()] : void 0, this.local.errors && this.local.errors.length > 0 ? DIV({
	      style: {
	        borderRadius: 8,
	        margin: 20,
	        padding: 20,
	        backgroundColor: '#FFE2E2'
	      }
	    }, H1({
	      style: {
	        fontSize: 18
	      }
	    }, 'Ooops! There are errors in the uploaded files:'), (function() {
	      var i, len, ref, results;
	      ref = this.local.errors;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        error = ref[i];
	        results.push(DIV({
	          style: {
	            marginTop: 10
	          }
	        }, error));
	      }
	      return results;
	    }).call(this)) : void 0, this.local.successes ? DIV({
	      style: {
	        borderRadius: 8,
	        margin: 20,
	        padding: 20,
	        backgroundColor: '#E2FFE2'
	      }
	    }, H1({
	      style: {
	        fontSize: 18
	      }
	    }, 'Success! Here\'s what happened:'), (function() {
	      var ref, results;
	      ref = this.local.successes;
	      results = [];
	      for (table in ref) {
	        successes = ref[table];
	        results.push((function() {
	          var i, len, results1;
	          results1 = [];
	          for (i = 0, len = successes.length; i < len; i++) {
	            success = successes[i];
	            results1.push(DIV({
	              style: {
	                display: 'block',
	                marginTop: 10
	              }
	            }, success));
	          }
	          return results1;
	        })());
	      }
	      return results;
	    }).call(this)) : void 0), DIV({
	      className: 'dangerzone',
	      style: {
	        marginTop: 24
	      }
	    }, H4({
	      style: {
	        fontSize: 20,
	        marginBottom: 12
	      }
	    }, "Danger Zone"), current_user.is_admin ? DIV({
	      style: {
	        marginBottom: 24
	      }
	    }, BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          var cb, frm, xhr;
	          if (confirm("Are you sure you want to delete all proposals, opinions, and comments on this forum?")) {
	            frm = new FormData();
	            frm.append("authenticity_token", arest.csrf());
	            cb = function() {
	              return location.reload();
	            };
	            xhr = new XMLHttpRequest;
	            xhr.addEventListener('readystatechange', cb, false);
	            xhr.open('PUT', '/nuke_everything', true);
	            return xhr.send(frm);
	          }
	        };
	      })(this)
	    }, "Delete all data on this forum")) : void 0, current_user.is_admin ? DIV({
	      style: {
	        marginBottom: 24
	      }
	    }, BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          var cb, frm, xhr;
	          if (confirm("Are you sure you want to entirely delete this forum? In addition to removing all content, the forum and all its configuration will be removed.")) {
	            frm = new FormData();
	            frm.append("authenticity_token", arest.csrf());
	            frm.append("subdomain_to_destroy", subdomain.id);
	            cb = function() {
	              return console.log('done');
	            };
	            xhr = new XMLHttpRequest;
	            xhr.addEventListener('readystatechange', cb, false);
	            xhr.open('DELETE', '/destroy_forum', true);
	            console.log('DELETE');
	            return xhr.send(frm);
	          }
	        };
	      })(this)
	    }, "Delete this forum entirely")) : void 0));
	  },
	  drawArgdownImport: function() {
	    return FORM({
	      id: 'import_argdown',
	      action: '/dashboard/data_import_argdown',
	      style: {
	        marginTop: 72,
	        borderTop: '1px dotted #ddd'
	      }
	    }, H2({
	      style: {
	        fontSize: 20,
	        margin: "16px 0"
	      }
	    }, 'Argdown-like Import', SUP({
	      style: {
	        color: '#999',
	        fontSize: 12,
	        fontWeight: 400,
	        paddingLeft: 4
	      }
	    }, 'Experimental')), INPUT({
	      id: "argdown-file",
	      name: "argdown-file",
	      type: 'file'
	    }), BUTTON({
	      id: 'submit_import_argdown',
	      className: 'btn',
	      style: {
	        display: 'block',
	        marginTop: 24,
	        fontSize: 16
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          e.preventDefault();
	          $$.setStyles('html, #import_argdown', {
	            cursor: 'wait'
	          });
	          return ajax_submit_files_in_form({
	            form: '#import_argdown',
	            type: 'POST',
	            additional_data: {
	              authenticity_token: arest.csrf(),
	              trying_to: 'update_avatar_hack'
	            },
	            success: _this.successful_import_cb,
	            error: _this.failed_import_cb
	          });
	        };
	      })(this)
	    }, 'Import'));
	  },
	  drawArgdownExport: function() {
	    return FORM({
	      className: "argdown-export",
	      action: "/dashboard/export_argdown",
	      method: 'post'
	    }, STYLE({
	      dangerouslySetInnerHTML: {
	        __html: ".argdown-export label {\n  display: flex;\n}\n.argdown-export input[type='checkbox'] {\n  margin-right: 12px;\n}\n.argdown-export .options {\n  margin-bottom: 24px;\n}\n\n"
	      }
	    }), INPUT({
	      type: 'hidden',
	      name: 'authenticity_token',
	      value: arest.csrf()
	    }), H2({
	      style: {
	        fontSize: 20,
	        margin: "16px 0"
	      }
	    }, 'Argdown-like Export', SUP({
	      style: {
	        color: '#999',
	        fontSize: 12,
	        fontWeight: 400,
	        paddingLeft: 4
	      }
	    }, 'Experimental')), DIV({
	      className: 'options'
	    }, LABEL(null, INPUT({
	      type: 'checkbox',
	      defaultChecked: false,
	      name: 'exclude_metadata'
	    }), "Exclude metadata"), LABEL(null, INPUT({
	      type: 'checkbox',
	      defaultChecked: false,
	      name: 'exclude_comments'
	    }), "Exclude comments"), LABEL(null, INPUT({
	      type: 'checkbox',
	      defaultChecked: false,
	      name: 'exclude_points'
	    }), "Exclude points"), LABEL(null, INPUT({
	      type: 'checkbox',
	      defaultChecked: false,
	      name: 'exclude_proposals'
	    }), "Exclude proposals"), LABEL(null, INPUT({
	      type: 'checkbox',
	      defaultChecked: false,
	      name: 'exclude_descriptions'
	    }), "Exclude descriptions"), LABEL(null, INPUT({
	      type: 'checkbox',
	      defaultChecked: false,
	      name: 'use_indexes'
	    }), "Use indexes")), INPUT({
	      type: 'submit',
	      className: 'btn',
	      style: {
	        fontSize: 16
	      },
	      onClick: (function(_this) {
	        return function() {
	          return show_flash(translator('admin.flashes.export_started', "Your export has started. It can take a little while."));
	        };
	      })(this),
	      value: 'Export Argdown'
	    }));
	  }
	});


/***/ },
/* 57 */
/***/ function(module, exports) {

	var delete_question, move_question, question_index;
	
	styles += ".INTAKE_QUESTIONS .intake-question {\n  background-color: #F1F1F1;\n  border: 1px solid #DDDDDD;\n  padding: 18px 10px 18px 38px;\n  border-radius: 8px;\n  margin: 8px 0;\n}\n\n.INTAKE_QUESTIONS .intake-question.open {\n  display: flex;\n  align-items: start;\n  position: relative;\n}\n\n\n.INTAKE_QUESTIONS .intake-question.open button {\n  flex-shrink: 0;\n  flex-grow: 0;\n  display: inline-block;\n  margin-left: 24px;\n  background-color: transparent;\n  border: none;\n}\n\n.INTAKE_QUESTIONS .intake-question.open svg {\n}\n\n\n.INTAKE_QUESTIONS .intake-question.open .name {\n  font-size: 16px; \n  font-weight: 500;\n  padding-right: 60px;\n  flex-grow: 1;\n}\n\n.INTAKE_QUESTIONS button.new_question {\n  padding: \"8px 8px\";\n  margin-top: 12px;\n}\n\n\n\n\n";
	
	question_index = function(question) {
	  var i, idx, len, q, qidx, ref, ref1, ref2, subdomain;
	  subdomain = fetch('/subdomain');
	  qidx = null;
	  ref = subdomain.customizations.user_tags || [];
	  for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	    q = ref[idx];
	    if (((ref1 = q.self_report) != null ? ref1.question : void 0) === ((ref2 = question.self_report) != null ? ref2.question : void 0)) {
	      qidx = idx;
	      break;
	    }
	  }
	  return qidx;
	};
	
	delete_question = function(question) {
	  var delete_idx, subdomain;
	  if (confirm("Are you sure you want to delete this question?")) {
	    subdomain = fetch('/subdomain');
	    delete_idx = question_index(question);
	    if (delete_idx !== null) {
	      subdomain.customizations.user_tags.splice(delete_idx, 1);
	      return save(subdomain);
	    }
	  }
	};
	
	move_question = function(from, to) {
	  var moving, q, questions, subdomain, uneditable_tags;
	  subdomain = fetch('/subdomain');
	  uneditable_tags = (function() {
	    var i, len, ref, results;
	    ref = subdomain.customizations.user_tags;
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      q = ref[i];
	      if (!q.self_report) {
	        results.push(q);
	      }
	    }
	    return results;
	  })();
	  questions = (function() {
	    var i, len, ref, results;
	    ref = subdomain.customizations.user_tags;
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      q = ref[i];
	      if (q.self_report) {
	        results.push(q);
	      }
	    }
	    return results;
	  })();
	  moving = questions[from];
	  questions.splice(from, 1);
	  questions.splice(to, 0, moving);
	  questions.concat(uneditable_tags);
	  subdomain.customizations.user_tags = questions;
	  return save(subdomain);
	};
	
	window.AnonymizationCheckForSigninQuestions = function() {
	  var message, q, questions, subdomain;
	  subdomain = fetch('/subdomain');
	  if (subdomain.customizations.anonymize_permanently && !subdomain.customizations.anonymization_safe_opinion_filters) {
	    questions = (function() {
	      var i, len, ref, results;
	      ref = subdomain.customizations.user_tags;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        q = ref[i];
	        if (q.self_report && q.key.indexOf('pledge_taken') === -1) {
	          results.push(q);
	        }
	      }
	      return results;
	    })();
	    if (questions.length > 0) {
	      message = {
	        style: {
	          backgroundColor: '#d1d08d',
	          color: 'black'
	        },
	        img: 'venetian-mask.png',
	        label: "You have permanently set participation to anonymous. The answers to any sign-in questions you ask will not be available to you. If the questions you are asking are not personally revealing for participants, please contact help@consider.it to whitelist your questions."
	      };
	      return DIV({
	        key: message,
	        style: _.defaults({}, message.style || {}, {
	          backgroundColor: "rgb(184 226 187)",
	          borderRadius: 12,
	          padding: '4px 24px',
	          maxWidth: 700,
	          margin: "0 auto 16px auto",
	          fontSize: 14,
	          display: 'flex',
	          alignItems: 'center',
	          minHeight: 44
	        })
	      }, message.img ? DIV({
	        style: {
	          minWidth: 40,
	          paddingRight: 24
	        }
	      }, IMG({
	        style: {
	          maxWidth: 34
	        },
	        src: (fetch('/application').asset_host) + "/images/" + message.img
	      })) : void 0, message.label);
	    }
	  }
	  return SPAN(null);
	};
	
	window.IntakeQuestions = ReactiveComponent({
	  displayName: 'IntakeQuestions',
	  render: function() {
	    var base, current_user, idx, intake_q_state, q, questions, ref, subdomain;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    intake_q_state = fetch('intake-questions');
	    if ((base = subdomain.customizations).user_tags == null) {
	      base.user_tags = [];
	    }
	    questions = (function() {
	      var i, len, ref, results;
	      ref = subdomain.customizations.user_tags;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        q = ref[i];
	        if (q.self_report) {
	          results.push(q);
	        }
	      }
	      return results;
	    })();
	    return DIV({
	      className: 'INTAKE_QUESTIONS'
	    }, AnonymizationCheckForSigninQuestions(), P(null, "Sign-up questions enable you to collect information from new participants during account \nregistration (e.g. demographics). This information is then available to you in exploratory \ndata analysis, as well as in data export. "), P({
	      style: {
	        fontStyle: 'italic',
	        marginTop: 18
	      }
	    }, "Recommendation: Each question makes the registration process take longer. Only ask questions \nyou are confident will be important in your analysis. Aim for five or fewer questions."), P({
	      style: {
	        fontStyle: 'italic',
	        marginTop: 18
	      }
	    }, "Recommendation: Use the Preamble to describe why you're collecting this \ninformation and, for sensitive data, how you will protect it. If \nyou have a privacy policy, the preamble is a good place for a link to it."), permit('configure paid feature') < 0 ? UpgradeForumButton({
	      big: true,
	      text: "Upgrade to enable sign-up questions"
	    }) : void 0, DIV({
	      style: {
	        marginTop: 36,
	        pointerEvents: permit('configure paid feature') < 0 ? 'none' : void 0,
	        opacity: permit('configure paid feature') < 0 ? .4 : void 0
	      }
	    }, H2({
	      style: {
	        fontSize: 22
	      }
	    }, "Questions"), UL({
	      style: {
	        listStyle: 'none'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = questions.length; i < len; idx = ++i) {
	        q = questions[idx];
	        results.push((function(_this) {
	          return function(q) {
	            return LI({
	              key: q.view_name || q.self_report.question,
	              "data-idx": idx,
	              className: "intake-question open",
	              draggable: true
	            }, SPAN({
	              className: 'name'
	            }, q.view_name || q.self_report.question), BUTTON({
	              style: {
	                cursor: 'pointer'
	              },
	              onClick: function() {
	                intake_q_state.editing = q;
	                return save(intake_q_state);
	              }
	            }, edit_icon(23, 23, '#888')), BUTTON({
	              style: {
	                cursor: 'move'
	              }
	            }, drag_icon(23, '#888')), BUTTON({
	              style: {
	                position: 'absolute',
	                right: -36,
	                cursor: 'pointer'
	              },
	              onClick: function() {
	                return delete_question(q);
	              }
	            }, trash_icon(23, 23, '#888')));
	          };
	        })(this)(q));
	      }
	      return results;
	    }).call(this)), BUTTON({
	      className: 'new_question btn',
	      onClick: function() {
	        intake_q_state.new_question = true;
	        return save(intake_q_state);
	      }
	    }, "+ question")), DIV({
	      style: {
	        marginTop: 36,
	        pointerEvents: permit('configure paid feature') < 0 ? 'none' : void 0,
	        opacity: permit('configure paid feature') < 0 ? .4 : void 0
	      }
	    }, LABEL({
	      style: {}
	    }, H2({
	      style: {
	        display: 'inline-block',
	        fontSize: 22
	      }
	    }, "Preamble"), SPAN({
	      style: {
	        fontSize: 16,
	        fontWeight: 400,
	        paddingLeft: 6
	      }
	    }, "optional"), TEXTAREA({
	      style: {
	        width: '100%',
	        padding: '6px 8px',
	        fontSize: 17
	      },
	      defaultValue: (ref = subdomain.customizations) != null ? ref.host_questions_framing : void 0,
	      onChange: function(ev) {
	        subdomain.customizations.host_questions_framing = ev.target.value;
	        return save(subdomain);
	      },
	      rows: 3
	    })), DIV({
	      style: {
	        fontSize: 14
	      }
	    }, "Message shown to participants before they answer your sign-up questions."), intake_q_state.editing || intake_q_state.new_question ? EditIntakeQuestion() : void 0));
	  },
	  componentDidMount: function() {
	    return this.makeQuestionsDraggable();
	  },
	  componentDidUpdate: function() {
	    return this.makeQuestionsDraggable();
	  },
	  makeQuestionsDraggable: function() {
	    var i, len, question, ref, results;
	    if (this.onDragOver == null) {
	      this.onDragOver = (function(_this) {
	        return function(e) {
	          e.preventDefault();
	          return _this.draggedOver = e.currentTarget.getAttribute('data-idx');
	        };
	      })(this);
	    }
	    if (this.onDragStart == null) {
	      this.onDragStart = (function(_this) {
	        return function(e) {
	          return _this.dragging = e.currentTarget.getAttribute('data-idx');
	        };
	      })(this);
	    }
	    if (this.onDrop == null) {
	      this.onDrop = (function(_this) {
	        return function(e) {
	          return move_question(_this.dragging, _this.draggedOver);
	        };
	      })(this);
	    }
	    ref = ReactDOM.findDOMNode(this).querySelectorAll('.intake-question.open');
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      question = ref[i];
	      question.removeEventListener('dragstart', this.onDragStart);
	      question.removeEventListener('dragover', this.onDragOver);
	      question.removeEventListener('drop', this.onDrop);
	      question.addEventListener('dragstart', this.onDragStart);
	      question.addEventListener('dragover', this.onDragOver);
	      results.push(question.addEventListener('drop', this.onDrop));
	    }
	    return results;
	  }
	});
	
	styles += "\n[data-widget=\"EditIntakeQuestion\"] .field {\n  margin-bottom: 24px;\n}\n\n[data-widget=\"EditIntakeQuestion\"] label {\n  display: block;\n\n}\n\n[data-widget=\"EditIntakeQuestion\"] .field label {\n  font-size: 13px;\n  font-weight: 500;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n  // color: #666;\n}\n\n[data-widget=\"EditIntakeQuestion\"] .field label .required {\n  font-size: 12px;\n  vertical-align: super;\n}\n\n[data-widget=\"EditIntakeQuestion\"] input[type=\"text\"], [data-widget=\"EditIntakeQuestion\"] textarea {\n  padding: 6px 8px;\n  width: 100%;\n  font-size: 16px;\n  border: 1px solid #d1d1d1;\n}\n";
	
	window.EditIntakeQuestion = ReactiveComponent({
	  displayName: "EditIntakeQuestion",
	  mixins: [Modal],
	  render: function() {
	    var close_modal, idx, intake_q_state, question, question_types, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, save_question, subdomain, typ, validated;
	    subdomain = fetch('/subdomain');
	    intake_q_state = fetch('intake-questions');
	    question = intake_q_state.editing;
	    _.defaults(this.local, {
	      input_type: (question != null ? (ref = question.self_report) != null ? ref.input : void 0 : void 0) || 'dropdown',
	      view_name: question != null ? question.view_name : void 0,
	      question: question != null ? (ref1 = question.self_report) != null ? ref1.question : void 0 : void 0,
	      options: question != null ? (ref2 = question.self_report) != null ? (ref3 = ref2.options) != null ? ref3.join('\n') : void 0 : void 0 : void 0,
	      required: intake_q_state.new_question ? true : question != null ? (ref4 = question.self_report) != null ? ref4.required : void 0 : void 0,
	      visibility: intake_q_state.new_question ? 'host-only' : question != null ? question.visibility : void 0
	    });
	    if (intake_q_state.editing) {
	      idx = question_index(question);
	    }
	    save_question = (function(_this) {
	      return function() {
	        var base, ref5, ref6, ref7, ref8;
	        if (intake_q_state.new_question) {
	          question = {
	            key: subdomain.name + "-" + (slugify(_this.local.question)),
	            view_name: _this.local.view_name,
	            visibility: _this.local.visibility,
	            self_report: {
	              question: _this.local.question,
	              input: _this.local.input_type,
	              options: _this.local.input_type !== 'text' ? (ref5 = _this.local.options) != null ? ref5.split('\n') : void 0 : null,
	              required: _this.local.required
	            }
	          };
	          if (((ref6 = question.self_report.options) != null ? ref6.indexOf('Other') : void 0) > -1) {
	            question.self_report.open_text_option = 'Other';
	          }
	          if ((base = subdomain.customizations).user_tags == null) {
	            base.user_tags = [];
	          }
	          subdomain.customizations.user_tags.push(question);
	          save(subdomain);
	        } else {
	          _.extend(question, {
	            view_name: _this.local.view_name,
	            visibility: _this.local.visibility
	          });
	          _.extend(question.self_report, {
	            question: _this.local.question,
	            input: _this.local.input_type,
	            options: _this.local.input_type !== 'text' ? (ref7 = _this.local.options) != null ? ref7.split('\n') : void 0 : null,
	            required: _this.local.required
	          });
	          if (((ref8 = question.self_report.options) != null ? ref8.indexOf('Other') : void 0) > -1) {
	            question.self_report.open_text_option = 'Other';
	          }
	          subdomain.customizations.user_tags.splice(idx, 1, question);
	          save(subdomain);
	        }
	        return close_modal();
	      };
	    })(this);
	    close_modal = function() {
	      intake_q_state.editing = intake_q_state.new_question = false;
	      return save(intake_q_state);
	    };
	    question_types = [
	      {
	        name: 'dropdown',
	        description: 'select one option'
	      }, {
	        name: 'checklist',
	        description: 'select one or more options'
	      }, {
	        name: 'text',
	        description: 'open-ended response'
	      }
	    ];
	    validated = ((ref5 = this.local.view_name) != null ? ref5.length : void 0) > 0 && ((ref6 = this.local.question) != null ? ref6.length : void 0) > 0 && ((ref7 = this.local.input_type) != null ? ref7.length : void 0) > 0 && (this.local.input_type === 'boolean' || this.local.input_type === 'text' || ((ref8 = this.local.options) != null ? ref8.length : void 0) > 0);
	    return wrap_in_modal(null, close_modal, DIV(null, DIV({
	      className: 'field'
	    }, LABEL({
	      htmlFor: "#name"
	    }, 'Name', SPAN({
	      className: 'required'
	    }, '*')), INPUT({
	      id: '#name',
	      type: 'text',
	      defaultValue: this.local.view_name,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.view_name = e.target.value;
	          return save(_this.local);
	        };
	      })(this)
	    })), DIV({
	      className: 'field'
	    }, LABEL({
	      htmlFor: "#question"
	    }, 'Your Question', SPAN({
	      className: 'required'
	    }, '*')), INPUT({
	      id: '#question',
	      type: 'text',
	      defaultValue: this.local.question,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.question = e.target.value;
	          return save(_this.local);
	        };
	      })(this)
	    })), question && !question.participation_pledge ? DIV({
	      className: 'field'
	    }, LABEL({
	      htmlFor: "#question_type"
	    }, 'Question type', SPAN({
	      className: 'required'
	    }, '*')), SELECT({
	      id: '#question_type',
	      type: 'text',
	      defaultValue: this.local.input_type,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.input_type = e.target.value;
	          return save(_this.local);
	        };
	      })(this),
	      style: {
	        fontSize: 16
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = question_types.length; i < len; i++) {
	        typ = question_types[i];
	        results.push(OPTION({
	          key: typ.name,
	          value: typ.name
	        }, typ.name + " – " + typ.description));
	      }
	      return results;
	    })())) : void 0, (ref9 = this.local.input_type) === 'dropdown' || ref9 === 'checklist' ? DIV({
	      className: 'field'
	    }, LABEL({
	      htmlFor: "#responses"
	    }, 'Response options (1 per line)'), AutoGrowTextArea({
	      id: '#responses',
	      defaultValue: this.local.options,
	      min_height: 60,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.options = e.target.value;
	          return save(_this.local);
	        };
	      })(this)
	    }), DIV({
	      style: {
	        fontSize: 12,
	        color: '#373737'
	      }
	    }, 'It is best practice to enable a “Prefer not to answer” option for nonessential questions.', BR(null), 'To enable an open-ended response option, include a response named “Other”')) : void 0, this.local.input_type !== 'text' && (!question || !question.participation_pledge) ? DIV({
	      style: {
	        marginBottom: 24
	      }
	    }, LABEL({
	      htmlFor: 'required',
	      style: {
	        marginBottom: 8
	      }
	    }, "Who can see responses to this question?"), LABEL({
	      style: {
	        display: 'flex',
	        marginBottom: 8
	      }
	    }, INPUT({
	      name: 'required',
	      type: 'radio',
	      defaultChecked: this.local.visibility === 'host-only',
	      className: 'bigger',
	      onChange: (function(_this) {
	        return function(e) {
	          return _this.local.visibility = 'host-only';
	        };
	      })(this)
	    }), SPAN({
	      style: {
	        paddingLeft: 12,
	        fontSize: 14
	      }
	    }, "Only forum hosts. Responses should not be visible to other participants.")), LABEL({
	      style: {
	        display: 'flex'
	      }
	    }, INPUT({
	      name: 'required',
	      type: 'radio',
	      defaultChecked: this.local.visibility === 'open',
	      className: 'bigger',
	      onChange: (function(_this) {
	        return function(e) {
	          return _this.local.visibility = 'open';
	        };
	      })(this)
	    }), SPAN({
	      style: {
	        paddingLeft: 12,
	        fontSize: 14
	      }
	    }, "Hosts and participants. Responses can be used by anyone for opinion filtering."))) : void 0, !question || !question.participation_pledge ? LABEL({
	      style: {
	        display: 'flex'
	      }
	    }, INPUT({
	      className: 'bigger',
	      type: 'checkbox',
	      defaultChecked: this.local.required,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.required = e.target.checked;
	          return save(_this.local);
	        };
	      })(this)
	    }), SPAN({
	      style: {
	        paddingLeft: 12
	      }
	    }, "Participants are ", B(null, "required"), " to answer this question")) : void 0, DIV({
	      style: {
	        display: 'flex',
	        marginTop: 36
	      }
	    }, BUTTON({
	      className: 'btn',
	      onClick: save_question,
	      disabled: !validated,
	      style: {
	        marginRight: 12,
	        backgroundColor: !validated ? '#aaa' : void 0,
	        cursor: !validated ? 'not-allowed' : void 0
	      }
	    }, 'Save'), BUTTON({
	      className: 'like_link',
	      onClick: close_modal
	    }, 'cancel'))));
	  }
	});


/***/ },
/* 58 */
/***/ function(module, exports) {

	var jaccardSimilarity;
	
	styles += ".meanie-grid-table {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 1px;\n  border: 1px solid #ccc;\n  max-width: 800px;\n  margin: 40px auto;\n}\n\n.meanie-header,\n.meanie-cell {\n  padding: 10px;\n}\n\n.meanie-header {\n  font-weight: bold;\n  background-color: #f2f2f2;\n  border: 1px solid #ccc;\n}\n\n.meanie-cell {\n  border: 1px solid #ccc;\n  background-color: #fff;\n}\n\n";
	
	window.Meanies = ReactiveComponent({
	  displayName: 'Meanies',
	  mixins: [LoadScripts],
	  js_dependencies: ['d3.v7.min.js', 'd3-force.js'],
	  componentDidMount: function() {
	    return this.loadScripts();
	  },
	  componentDidUpdate: function() {
	    return this.loadScripts();
	  },
	  render: function() {
	    var SIMILARITY_THRESHOLD, __, base, base1, base2, by_ip, by_user, cells, cluster, cluster_name, flagged_group, high_matches, i, ip, ip_clusters, j, k, len, len1, name, name1, o, opinions, opinions_by_user, other, s, sim, similar_users, similarities, similarity, similarity_clusters, stripped, true_clusters, u, user, user_cells, users, v, visit, visit_node, visited, visits;
	    users = fetch('/users').users;
	    visits = fetch('/visits').visits;
	    opinions = fetch('/opinions').opinions;
	    if (!users || !visits || !opinions) {
	      return ProposalsLoading();
	    }
	    if ((base = this.local).by_ip == null) {
	      base.by_ip = true;
	    }
	    if ((base1 = this.local).close_in_time == null) {
	      base1.close_in_time = false;
	    }
	    if ((base2 = this.local).single_opinion_only == null) {
	      base2.single_opinion_only = false;
	    }
	    by_user = {};
	    by_ip = {};
	    for (i = 0, len = visits.length; i < len; i++) {
	      visit = visits[i];
	      if (visit.user in arest.cache) {
	        ip = this.local.by_ip ? visit.ip : 'All IPs';
	        if (by_ip[ip] == null) {
	          by_ip[ip] = {};
	        }
	        by_ip[ip][visit.user] = true;
	        if (by_user[name = visit.user] == null) {
	          by_user[name] = {};
	        }
	        by_user[visit.user][visit.ip] = 1;
	      }
	    }
	    opinions_by_user = {};
	    for (j = 0, len1 = opinions.length; j < len1; j++) {
	      o = opinions[j];
	      if (by_user[o.user] && !arest.cache[o.user].verified && (!this.local.by_ip || true || Object.keys(by_user[o.user]).length === 1)) {
	        if (opinions_by_user[name1 = o.user] == null) {
	          opinions_by_user[name1] = {};
	        }
	        opinions_by_user[o.user][o.proposal] = o.stance;
	      }
	    }
	    ip_clusters = {};
	    for (k in by_ip) {
	      v = by_ip[k];
	      if (Object.keys(v).length > 1) {
	        ip_clusters[k] = {};
	        for (user in v) {
	          __ = v[user];
	          if (opinions_by_user[user] && (!this.local.single_opinion_only || Object.keys(opinions_by_user[user]).length === 1)) {
	            ip_clusters[k][user] = opinions_by_user[user];
	          }
	        }
	        if (Object.keys(ip_clusters[k]).length < 2) {
	          delete ip_clusters[k];
	        }
	      }
	    }
	    high_matches = [];
	    SIMILARITY_THRESHOLD = 1;
	    similarity_clusters = {};
	    for (ip in ip_clusters) {
	      cluster = ip_clusters[ip];
	      similarity = jaccardSimilarity(cluster, function(a, b) {
	        return Math.abs(a - b) < 0.025;
	      });
	      for (user in similarity) {
	        similarities = similarity[user];
	        stripped = {};
	        for (other in similarities) {
	          sim = similarities[other];
	          if (sim >= SIMILARITY_THRESHOLD && (!this.local.close_in_time || Math.abs(new Date(arest.cache[other].created_at).getTime() - new Date(arest.cache[user].created_at).getTime()) < 1000 * 60 * 60 * 24)) {
	            stripped[other] = sim;
	          }
	        }
	        if (Object.keys(stripped).length > 0) {
	          similarity[user] = stripped;
	        } else {
	          delete similarity[user];
	        }
	      }
	      if (Object.keys(similarity).length > 0) {
	        similarity_clusters[ip] = similarity;
	      }
	    }
	    true_clusters = [];
	    for (ip in similarity_clusters) {
	      cluster = similarity_clusters[ip];
	      visited = {};
	      visit_node = function(node, group) {
	        var ref, similar_user, val;
	        if (node in visited) {
	          return;
	        }
	        group.push(node);
	        visited[node] = true;
	        ref = cluster[user];
	        for (similar_user in ref) {
	          val = ref[similar_user];
	          visit_node(similar_user, group);
	        }
	        return group;
	      };
	      for (user in cluster) {
	        similar_users = cluster[user];
	        if (!visited[user]) {
	          true_clusters.push([ip + " #" + true_clusters.length, visit_node(user, []), cluster]);
	        }
	      }
	    }
	    user_cells = [
	      DIV({
	        className: "meanie-header"
	      }, "Name"), DIV({
	        className: "meanie-header"
	      }, "Email"), DIV({
	        className: "meanie-header"
	      }, "Registration Date"), DIV({
	        className: "meanie-header"
	      }, "# Similar Accounts"), DIV({
	        className: "meanie-header"
	      }, "Max Similarity")
	    ];
	    return DIV(null, LABEL(null, INPUT({
	      type: 'checkbox',
	      defaultChecked: this.local.by_ip,
	      onChange: (function(_this) {
	        return function() {
	          _this.local.by_ip = !_this.local.by_ip;
	          return save(_this.local);
	        };
	      })(this)
	    }), "Group by IP Address prefix"), LABEL(null, INPUT({
	      type: 'checkbox',
	      defaultChecked: this.local.close_in_time,
	      onChange: (function(_this) {
	        return function() {
	          _this.local.close_in_time = !_this.local.close_in_time;
	          return save(_this.local);
	        };
	      })(this)
	    }), "Filter to accounts created within a day of each other"), LABEL(null, INPUT({
	      type: 'checkbox',
	      defaultChecked: this.local.single_opinion_only,
	      onChange: (function(_this) {
	        return function() {
	          _this.local.single_opinion_only = !_this.local.single_opinion_only;
	          return save(_this.local);
	        };
	      })(this)
	    }), "Filter to accounts that only added one opinion"), (function() {
	      var l, len2, len3, m, results;
	      results = [];
	      for (l = 0, len2 = true_clusters.length; l < len2; l++) {
	        flagged_group = true_clusters[l];
	        cluster_name = flagged_group[0], users = flagged_group[1], cluster = flagged_group[2];
	        cells = user_cells;
	        for (m = 0, len3 = users.length; m < len3; m++) {
	          user = users[m];
	          similarities = cluster[user];
	          user = fetch(user);
	          cells = cells.concat([
	            DIV({
	              className: "meanie-cell"
	            }, user.name), DIV({
	              className: "meanie-cell"
	            }, user.email), DIV({
	              className: "meanie-cell"
	            }, user.created_at), DIV({
	              className: "meanie-cell"
	            }, Object.keys(similarities).length), DIV({
	              className: "meanie-cell"
	            }, Math.max.apply(null, (function() {
	              var results1;
	              results1 = [];
	              for (u in similarities) {
	                s = similarities[u];
	                results1.push(s);
	              }
	              return results1;
	            })()))
	          ]);
	        }
	        console.log({
	          cells: cells,
	          users: users
	        });
	        results.push(DIV({
	          key: cluster_name
	        }, H2({
	          style: {
	            marginTop: 32,
	            fontSize: 24,
	            textAlign: 'center'
	          }
	        }, cluster_name), DIV({
	          className: "meanie-grid-table",
	          key: ip
	        }, cells)));
	      }
	      return results;
	    })());
	  }
	});
	
	jaccardSimilarity = function(votingData, voteComparisonCallback) {
	  var calculateIntersection, calculateUnion, intersection, similarities, union, user1, user2, votes1, votes2;
	  calculateIntersection = function(votes1, votes2) {
	    var intersection, proposal, vote1;
	    intersection = 0;
	    for (proposal in votes1) {
	      vote1 = votes1[proposal];
	      if (proposal in votes2) {
	        if (voteComparisonCallback(vote1, votes2[proposal])) {
	          intersection += 1;
	        }
	      }
	    }
	    return intersection;
	  };
	  calculateUnion = function(votes1, votes2) {
	    var _, proposal, union;
	    union = {};
	    for (proposal in votes1) {
	      _ = votes1[proposal];
	      union[proposal] = true;
	    }
	    for (proposal in votes2) {
	      _ = votes2[proposal];
	      union[proposal] = true;
	    }
	    return Object.keys(union).length;
	  };
	  similarities = {};
	  for (user1 in votingData) {
	    votes1 = votingData[user1];
	    similarities[user1] = {};
	    for (user2 in votingData) {
	      votes2 = votingData[user2];
	      if (user1 !== user2) {
	        intersection = calculateIntersection(votes1, votes2);
	        union = calculateUnion(votes1, votes2);
	        similarities[user1][user2] = intersection / union;
	      }
	    }
	  }
	  return similarities;
	};


/***/ },
/* 59 */
/***/ function(module, exports) {

	var BanHammer, DirectMessage, ModalDirectMessage, ModerateItem, default_fail_message, default_quarantine_message, delayed_fetch_after_moderation_judgment, delayed_fetch_timer,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	window.moderation_options = [
	  {
	    label: "No moderation",
	    value: 0
	  }, {
	    label: "Do not publicly post content until after approval",
	    value: 1,
	    explanation: "Suggested only for extremely adversarial or sensitive forums. Hosts will receive email notifications when there is content to review. To keep the conversation flowing, hosts should be extremely responsive to reviewing new posts."
	  }, {
	    label: "Post content immediately, but withhold email notifications until after approval",
	    value: 2,
	    explanation: "Suggested for most public engagement. All content is posted immediately, but won’t trigger email notifications, nor will the new posts be present in any email summary of recent activity. After review, they will be part of recent activity summaries. This policy will avoid the worst consequence of detrimental content: an enthusiastic participant getting an email linking them to a nasty attack on them, while at the same time lessening the pressure on moderators to review content promptly."
	  }, {
	    label: "Post content immediately, review later",
	    value: 3,
	    explanation: "Use this if you’re not very concerned about detrimental posts and/or you don’t have capacity to review new content in a timely fashion. Hosts will receive email notifications when there is content to review. Suggested for most engagement amongst people who have formal or communal ties."
	  }
	];
	
	styles += "\n.moderation { \n  font-weight: 600; \n  display: inline-block; \n  margin-right: 10px; \n  font-size: 22px;\n  padding: 0;\n  box-shadow: 0px 1px 2px rgba(0,0,0,.4);  \n  border-radius: 8px;         \n}\n.moderation label {\n  display: inline-block;\n  padding: 18px 24px; \n}\n.moderation label, .moderation input { \n  font-size: 22px; \n  cursor: pointer;            \n}\n\n.moderation.btn input {\n  display: none;\n}\n\n.moderation.btn {\n  /* padding: 8px 18px; */\n}\n\n.moderate-item-wrapper {\n  cursor: auto;\n  padding: 8px 14px;\n  max-width: 700px;\n  margin-bottom: 20px;\n}\n\n.moderate-item-bubble-wrapper {\n  margin-left: 70px;\n  position: relative;\n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .moderation-content-wrapper {\n\n  }\n  .moderation.btn {\n  }\n\n  .moderation.btn label {\n    font-size: 18px;\n    padding: 8px 12px;    \n  }\n\n  .moderate-item-wrapper {\n    padding: 8px 0px;\n  }\n\n  .moderate-item-bubble-wrapper {\n    margin-left: 36px;\n  }\n\n}";
	
	default_quarantine_message = null;
	
	default_fail_message = null;
	
	window.ModerationDash = ReactiveComponent({
	  displayName: 'ModerationDash',
	  render: function() {
	    var all_items, base, base1, category, dash, definition, failed, i, item, items, j, k, l, len, len1, len2, model, models, moderation_enabled, moderation_policy, moderations, option, passed, quarantined, ref, reviewable, select_class, subdomain;
	    moderations = this.data().moderations;
	    subdomain = fetch('/subdomain');
	    dash = fetch('moderation_dash');
	    if (default_quarantine_message == null) {
	      default_quarantine_message = subdomain.customizations.moderation_default_quarantine_message;
	    }
	    if (default_fail_message == null) {
	      default_fail_message = subdomain.customizations.moderation_default_fail_message;
	    }
	    if ((base = this.local).model == null) {
	      base.model = 'Proposal';
	    }
	    models = ['Point', 'Comment', 'Proposal'];
	    all_items = {};
	    moderation_enabled = subdomain.moderation_policy > 0;
	    if (!moderation_enabled) {
	      DIV(null, "Moderation is disabled. You can turn on content moderation in the ", A({
	        href: '/dashboard/application',
	        style: {
	          textDecoration: 'underline',
	          fontWeight: 700
	        }
	      }, "forum settings"), ".");
	    } else {
	      for (j = 0, len = moderation_options.length; j < len; j++) {
	        option = moderation_options[j];
	        if (option.value === subdomain.moderation_policy) {
	          moderation_policy = option;
	        }
	      }
	    }
	    for (k = 0, len1 = models.length; k < len1; k++) {
	      model = models[k];
	      passed = [];
	      reviewable = [];
	      quarantined = [];
	      failed = [];
	      moderations[model] || (moderations[model] = []);
	      moderations[model].sort(function(a, b) {
	        return new Date(fetch(b.moderatable).created_at) - new Date(fetch(a.moderatable).created_at);
	      });
	      ref = moderations[model];
	      for (l = 0, len2 = ref.length; l < len2; l++) {
	        i = ref[l];
	        fetch(i.key);
	        if ((i.status == null) || i.updated_since_last_evaluation) {
	          reviewable.push(i);
	        } else if (i.status === 1) {
	          passed.push(i);
	        } else if (i.status === 0) {
	          failed.push(i);
	        } else if (i.status === 2) {
	          quarantined.push(i);
	        }
	      }
	      all_items[model] = {
	        pending: {
	          name: 'pending',
	          items: reviewable
	        },
	        quarantined: {
	          name: 'quarantined',
	          items: quarantined
	        },
	        failed: {
	          name: 'failed',
	          items: failed
	        },
	        passed: {
	          name: 'passed',
	          items: passed
	        }
	      };
	    }
	    items = all_items[this.local.model];
	    this.items = items;
	    if ((base1 = this.local).show_category == null) {
	      base1.show_category = items.pending.name;
	    }
	    return DIV(null, DIV({
	      style: {
	        marginBottom: 12,
	        fontSize: 20
	      }
	    }, SELECT({
	      style: {
	        fontSize: 20,
	        maxWidth: '80vw'
	      },
	      defaultValue: subdomain.moderation_policy,
	      onChange: function(ev) {
	        subdomain.moderation_policy = ev.target.value;
	        return save(subdomain, function() {
	          return arest.serverFetch('/page/dashboard/moderate');
	        });
	      }
	    }, (function() {
	      var len3, m, results;
	      results = [];
	      for (m = 0, len3 = moderation_options.length; m < len3; m++) {
	        option = moderation_options[m];
	        results.push(OPTION({
	          key: option.value,
	          value: option.value
	        }, option.label));
	      }
	      return results;
	    })())), !screencasting() ? DIV({
	      style: {
	        marginBottom: 24,
	        fontStyle: 'italic',
	        fontSize: 14
	      }
	    }, "Visit the ", A({
	      href: '/dashboard/application',
	      style: {
	        textDecoration: 'underline',
	        fontWeight: 700
	      }
	    }, "forum settings"), " for an explanation of these moderation policies.") : void 0, UL({
	      className: 'moderation_tabs',
	      style: {
	        listStyle: 'none',
	        marginTop: 48
	      }
	    }, (function() {
	      var len3, m, ref1, results;
	      ref1 = ['Proposal', 'Point', 'Comment', 'Ban'];
	      results = [];
	      for (m = 0, len3 = ref1.length; m < len3; m++) {
	        model = ref1[m];
	        select_class = (function(_this) {
	          return function(model) {
	            _this.local.model = model;
	            return save(_this.local);
	          };
	        })(this);
	        results.push((function(_this) {
	          return function(model) {
	            var active, ref2, ref3;
	            active = _this.local.model === model;
	            return LI({
	              key: model,
	              style: {
	                display: 'inline-block'
	              }
	            }, BUTTON({
	              "data-model": model,
	              style: {
	                backgroundColor: active ? 'white' : '#f0f0f0',
	                color: 'black',
	                fontSize: 18,
	                marginLeft: 12,
	                marginRight: 12,
	                marginBottom: active ? -1 : void 0,
	                border: '1px solid #bbb',
	                borderBottom: 'none',
	                borderRadius: '4px 4px 0 0px',
	                padding: "6px 14px " + (active ? 3 : 2) + "px 14px"
	              },
	              onClick: function() {
	                return select_class(model);
	              }
	            }, "" + (model === 'Proposal' ? 'Review ' : '') + model + "s", model !== 'Ban' ? SPAN({
	              style: {
	                fontSize: 12,
	                verticalAlign: 'top',
	                paddingLeft: 8
	              }
	            }, "[" + (((ref2 = all_items[model].pending) != null ? (ref3 = ref2.items) != null ? ref3.length : void 0 : void 0) || 0) + "]") : void 0));
	          };
	        })(this)(model));
	      }
	      return results;
	    }).call(this)), this.local.model === 'Ban' ? DIV({
	      style: {
	        borderTop: '1px solid #bbb'
	      }
	    }, BanHammer({
	      all_items: all_items
	    })) : DIV({
	      style: {
	        borderTop: '1px solid #bbb'
	      }
	    }, UL({
	      style: {
	        listStyle: 'none',
	        margin: '12px 0 12px 10px'
	      }
	    }, (function() {
	      var results;
	      results = [];
	      for (category in items) {
	        definition = items[category];
	        results.push((function(_this) {
	          return function(definition) {
	            var active, ref1;
	            active = category === _this.local.show_category;
	            return LI({
	              key: category,
	              style: {
	                display: 'inline',
	                marginLeft: 18
	              }
	            }, BUTTON({
	              className: 'like_link',
	              style: {
	                fontSize: 14,
	                fontWeight: active ? 700 : void 0,
	                color: active ? 'black' : '#666'
	              },
	              onClick: function() {
	                _this.local.show_category = definition.name;
	                return save(_this.local);
	              }
	            }, category), SPAN({
	              style: {
	                fontSize: 10,
	                paddingLeft: 4,
	                color: '#666'
	              }
	            }, "[" + (((ref1 = definition.items) != null ? ref1.length : void 0) || 0) + "]"));
	          };
	        })(this)(definition));
	      }
	      return results;
	    }).call(this)), UL({
	      className: 'moderation-content-wrapper',
	      style: {
	        marginLeft: 0
	      }
	    }, (function() {
	      var len3, m, ref1, results;
	      ref1 = items[this.local.show_category].items;
	      results = [];
	      for (m = 0, len3 = ref1.length; m < len3; m++) {
	        item = ref1[m];
	        results.push(ModerateItem({
	          key: item.key,
	          item: item.key
	        }));
	      }
	      return results;
	    }).call(this))));
	  }
	});
	
	delayed_fetch_timer = null;
	
	delayed_fetch_after_moderation_judgment = function() {
	  if (!delayed_fetch_timer) {
	    return delayed_fetch_timer = setInterval(function() {
	      if (is_a_dialogue_page()) {
	        live_update();
	        clearInterval(delayed_fetch_timer);
	        return delayed_fetch_timer = null;
	      }
	    }, 250);
	  }
	};
	
	ModerateItem = ReactiveComponent({
	  displayName: 'ModerateItem',
	  render: function() {
	    var MESSAGE_WIDGET, author, class_name, comment, comments, current_user, default_message, details, header, href, item, judge, list_key, moderatable, point, proposal, tease;
	    item = fetch(this.props.item);
	    class_name = item.moderatable_type;
	    moderatable = fetch(item.moderatable);
	    author = moderatable.user ? fetch(moderatable.user) : null;
	    if (class_name === 'Point') {
	      point = moderatable;
	      proposal = fetch(moderatable.proposal);
	      tease = (moderatable.nutshell.substring(0, 120)) + "...";
	      header = moderatable.nutshell;
	      details = moderatable.text;
	      href = "/" + proposal.slug + "?selected=" + point.key;
	    } else if (class_name === 'Comment') {
	      point = fetch(moderatable.point);
	      proposal = fetch(point.proposal);
	      comments = fetch("/comments/" + point.id);
	      tease = (moderatable.body.substring(0, 120)) + "...";
	      header = moderatable.body;
	      details = '';
	      href = "/" + proposal.slug + "?selected=" + point.key;
	    } else if (class_name === 'Proposal') {
	      proposal = moderatable;
	      tease = (proposal.name.substring(0, 120)) + "...";
	      header = proposal.name;
	      details = moderatable.description;
	      href = "/" + proposal.slug;
	    }
	    current_user = fetch('/current_user');
	    judge = (function(_this) {
	      return function(e, immediate_with_message) {
	        if (parseInt(e.target.value) === 1) {
	          item.status = e.target.value;
	          return save(item, delayed_fetch_after_moderation_judgment);
	        } else {
	          _this.local.messaging = {
	            from_prompt: true,
	            ultimate_judgment: parseInt(e.target.value),
	            moderatable: moderatable,
	            send_immediately: immediate_with_message
	          };
	          return save(_this.local);
	        }
	      };
	    })(this);
	    return LI({
	      'data-id': item.key,
	      key: item.key,
	      style: {
	        position: 'relative',
	        listStyle: 'none'
	      }
	    }, DIV({
	      className: 'moderate-item-wrapper'
	    }, DIV({
	      className: 'moderate-item-bubble-wrapper'
	    }, DIV(null, class_name === 'Comment' ? DIV({
	      class_name: 'context',
	      style: {
	        opacity: .5
	      }
	    }, BUBBLE_WRAP({
	      key: point.key,
	      title: point.nutshell,
	      user: point.user,
	      body: point.text,
	      width: 'min(100%, 700px)',
	      avatar_style: TABLET_SIZE() ? {
	        width: 32,
	        height: 32,
	        left: -44
	      } : void 0
	    }), (function() {
	      var j, len, ref, results;
	      ref = _.uniq(_.map(comments.comments, function(c) {
	        return c.key;
	      }).concat(moderatable.key));
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        comment = ref[j];
	        if (comment !== moderatable.key) {
	          results.push(BUBBLE_WRAP({
	            key: comment,
	            title: fetch(comment).body,
	            user: fetch(comment).user,
	            width: 'min(100%, 700px)',
	            avatar_style: TABLET_SIZE() ? {
	              width: 32,
	              height: 32,
	              left: -44
	            } : void 0
	          }));
	        }
	      }
	      return results;
	    })()) : class_name === 'Point' ? DIV({
	      class_name: 'context',
	      style: {
	        opacity: .5
	      }
	    }, BUBBLE_WRAP({
	      key: proposal.key,
	      title: proposal.name,
	      user: proposal.user,
	      body: proposal.description,
	      width: 'min(100%, 700px)',
	      avatar_style: TABLET_SIZE() ? {
	        width: 32,
	        height: 32,
	        left: -44
	      } : void 0
	    })) : class_name === 'Proposal' ? (list_key = get_list_for_proposal(proposal), DIV({
	      class_name: 'context',
	      style: {
	        opacity: .5
	      }
	    }, BUBBLE_WRAP({
	      key: list_key,
	      title: get_list_title(list_key),
	      body: customization('list_description', list_key),
	      width: 'min(100%, 700px)'
	    }))) : void 0, DIV({
	      style: {
	        position: 'relative'
	      }
	    }, class_name === 'Point' ? DIV({
	      style: {
	        position: 'absolute',
	        left: "calc(100% + 16px)",
	        top: 4,
	        fontSize: 12,
	        zIndex: 999
	      }
	    }, point.is_pro ? translator('point_labels.pro', 'pro') : translator('point_labels.con', 'con')) : void 0, BUBBLE_WRAP({
	      title: header,
	      body: moderatable.description,
	      user: moderatable.user,
	      width: 'min(100%, 700px)',
	      avatar_style: TABLET_SIZE() ? {
	        width: 32,
	        height: 32,
	        left: -44
	      } : void 0
	    })), DIV(null, "by " + ((author != null ? author.name : void 0) || anonymous_label()), A({
	      style: {
	        textDecoration: 'underline',
	        padding: '0 8px'
	      },
	      target: '_blank',
	      href: href,
	      'data-nojax': true
	    }, "View " + class_name), author && arest.key_id(author.key) >= 0 && !this.local.messaging ? BUTTON({
	      style: {
	        marginLeft: 8,
	        textDecoration: 'underline',
	        backgroundColor: 'transparent',
	        border: 'none'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.messaging = {
	            moderatable: moderatable,
	            from_prompt: false
	          };
	          return save(_this.local);
	        };
	      })(this)
	    }, 'Message author') : void 0)), this.local.messaging ? (MESSAGE_WIDGET = DirectMessage, default_message = null, this.local.messaging.from_prompt ? (default_message = parseInt(this.local.messaging.ultimate_judgment) === 0 ? default_fail_message : default_quarantine_message, MESSAGE_WIDGET = ModalDirectMessage) : void 0, MESSAGE_WIDGET({
	      to: this.local.messaging.moderatable.user,
	      parent: this.local,
	      sender_mask: 'Moderator',
	      default_message: default_message,
	      cancel_button_label: this.local.messaging.from_prompt ? "skip message" : void 0,
	      title: this.local.messaging.from_prompt ? "Inform author about moderation decision" : void 0,
	      send_immediately: this.local.messaging.send_immediately,
	      callback: (function(_this) {
	        return function(message) {
	          var is_failure, is_quarantine, judgment, subdomain;
	          if (_this.local.messaging.ultimate_judgment != null) {
	            judgment = parseInt(_this.local.messaging.ultimate_judgment);
	            if (message) {
	              is_quarantine = judgment === 2;
	              is_failure = judgment === 0;
	              subdomain = fetch('/subdomain');
	              if (is_failure && !subdomain.customizations.moderation_default_fail_message) {
	                default_fail_message = {
	                  subject: message.subject,
	                  body: message.body
	                };
	              } else if (is_quarantine && !subdomain.customizations.moderation_default_quarantine_message) {
	                default_quarantine_message = {
	                  subject: message.subject,
	                  body: message.body
	                };
	              }
	            }
	            item.status = judgment;
	            save(item, delayed_fetch_after_moderation_judgment);
	          }
	          _this.local.messaging = null;
	          return save(_this.local);
	        };
	      })(this)
	    })) : void 0), class_name === 'Proposal' ? DIV({
	      style: {
	        marginTop: 8,
	        marginLeft: TABLET_SIZE() ? 36 : 63
	      }
	    }, SELECT({
	      style: {
	        fontSize: 18,
	        maxWidth: '60vw'
	      },
	      value: proposal.cluster || '',
	      ref: 'category',
	      onChange: (function(_this) {
	        return function(e) {
	          proposal.cluster = e.target.value;
	          return save(proposal);
	        };
	      })(this)
	    }, (function() {
	      var j, len, ref, results;
	      ref = get_all_lists();
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        list_key = ref[j];
	        results.push(OPTION({
	          key: list_key,
	          value: list_key.substring(5)
	        }, get_list_title(list_key, true)));
	      }
	      return results;
	    })())) : void 0, DIV({
	      style: {
	        margin: '10px 0px 20px 63px',
	        marginLeft: TABLET_SIZE() ? 36 : 63,
	        position: 'relative'
	      }
	    }, SPAN({
	      className: 'moderation btn',
	      style: {
	        backgroundColor: '#81c765'
	      }
	    }, LABEL({
	      htmlFor: "pass-" + this.props.item
	    }, INPUT({
	      name: 'moderation',
	      type: 'button',
	      id: "pass-" + this.props.item,
	      value: 1,
	      onClick: judge
	    }), 'Pass')), SPAN({
	      className: 'moderation btn',
	      style: {
	        backgroundColor: '#ffc92a'
	      }
	    }, LABEL({
	      htmlFor: "quar-" + this.props.item
	    }, INPUT({
	      name: 'moderation',
	      type: 'button',
	      id: "quar-" + this.props.item,
	      value: 2,
	      onClick: judge
	    }), 'Quarantine')), SPAN({
	      className: 'moderation btn',
	      style: {
	        backgroundColor: '#f94747'
	      }
	    }, LABEL({
	      htmlFor: "fail-" + this.props.item
	    }, INPUT({
	      name: 'moderation',
	      type: 'button',
	      id: "fail-" + this.props.item,
	      value: 0,
	      onClick: judge
	    }), 'Fail')), fetch('/subdomain').customizations.moderation_default_fail_message ? SPAN({
	      style: {
	        position: 'relative'
	      }
	    }, SPAN({
	      className: 'moderation btn',
	      style: {
	        backgroundColor: '#f94747',
	        minWidth: 150,
	        display: 'inline-block'
	      }
	    }, LABEL({
	      htmlFor: "failm-" + this.props.item
	    }, INPUT({
	      name: 'moderation',
	      type: 'button',
	      id: "failm-" + this.props.item,
	      value: 0,
	      onClick: (function(_this) {
	        return function(e) {
	          return judge(e, true);
	        };
	      })(this)
	    }), 'Fail')), BR(null), SPAN({
	      style: {
	        fontSize: 13,
	        position: 'absolute',
	        right: 19,
	        marginTop: 4
	      }
	    }, "& send default message")) : void 0), DIV({
	      style: {
	        marginLeft: TABLET_SIZE() ? 36 : 63,
	        fontStyle: 'italic'
	      }
	    }, item.updated_since_last_evaluation ? SPAN({
	      style: {}
	    }, "Updated since last moderation") : item.status === 1 ? SPAN({
	      style: {}
	    }, "Passed by " + (item.user ? fetch(item.user).name : 'Unknown') + " on " + (new Date(item.updated_at).toDateString())) : item.status === 2 ? SPAN({
	      style: {}
	    }, "Quarantined by " + (item.user ? fetch(item.user).name : 'Unknown') + " on " + (new Date(item.updated_at).toDateString())) : item.status === 0 ? SPAN({
	      style: {}
	    }, "Failed by " + (item.user ? fetch(item.user).name : 'Unknown') + " on " + (new Date(item.updated_at).toDateString())) : void 0)));
	  }
	});
	
	styles += ".grid-table {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  padding: 1rem;\n}\n\n.grid-table-header {\n  background-color: #aaa;\n  padding: 1rem;\n  font-weight: bold;\n}\n\n.row {\n  background-color: #eee;\n  padding: 1rem;\n}\n\n.row.alt {\n  background-color: #ddd;\n}\n\n\n";
	
	BanHammer = ReactiveComponent({
	  displayName: 'BanHammer',
	  render: function() {
	    var alt_row, ban_explanation, ban_user, bans, categories, failed, failed_content_by_user, item, items, j, len, model, moderation_status, participant, ref, ref1, subdomain, u, users;
	    users = fetch('/users');
	    subdomain = fetch('/subdomain');
	    bans = subdomain.customizations.shadow_bans || [];
	    console.log(bans);
	    failed_content_by_user = {};
	    ref = this.props.all_items;
	    for (model in ref) {
	      categories = ref[model];
	      for (moderation_status in categories) {
	        items = categories[moderation_status];
	        if (moderation_status === 'failed') {
	          ref1 = items.items;
	          for (j = 0, len = ref1.length; j < len; j++) {
	            item = ref1[j];
	            u = fetch(item.moderatable).user;
	            if (failed_content_by_user[u] == null) {
	              failed_content_by_user[u] = [];
	            }
	            failed_content_by_user[u].push(item);
	          }
	        }
	      }
	    }
	    ban_user = (function(_this) {
	      return function(user) {
	        var ref2, results;
	        bans = (function() {
	          var k, len1, results;
	          results = [];
	          for (k = 0, len1 = bans.length; k < len1; k++) {
	            u = bans[k];
	            results.push(u.key || u);
	          }
	          return results;
	        })();
	        bans.push(user.key);
	        subdomain.customizations.shadow_bans = bans;
	        save(subdomain);
	        ref2 = _this.props.all_items;
	        results = [];
	        for (model in ref2) {
	          categories = ref2[model];
	          results.push((function() {
	            var results1;
	            results1 = [];
	            for (moderation_status in categories) {
	              items = categories[moderation_status];
	              if (moderation_status !== 'failed') {
	                results1.push((function() {
	                  var k, len1, ref3, results2;
	                  ref3 = items.items;
	                  results2 = [];
	                  for (k = 0, len1 = ref3.length; k < len1; k++) {
	                    item = ref3[k];
	                    if (fetch(item.moderatable).user === user.key) {
	                      item.status = 0;
	                      results2.push(save(item, delayed_fetch_after_moderation_judgment));
	                    } else {
	                      results2.push(void 0);
	                    }
	                  }
	                  return results2;
	                })());
	              }
	            }
	            return results1;
	          })());
	        }
	        return results;
	      };
	    })(this);
	    ban_explanation = "If you are having insurmountable difficulties with a particular registered account, you can shadow ban them.\nA shadow ban will not prevent them from accessing the forum, nor will it block them from leaving opinions.\nIt will automatically fail all their existing posts as well as any they might make in the future (e.g. new proposals, pro/con points, and comments).\nTheir posts will not show up in activity digest emails. \nIt is a \"shadow\" ban because it will appear to them as if their posts are being publicly posted, when in reality the posts are only visible\nto them (unless they log out or access the forum from a different device). Shadow banning helps reduce the chance you will get into an \nescalating conflict. ";
	    alt_row = true;
	    return DIV(null, DIV({
	      style: {
	        position: 'relative',
	        padding: '18px 0px',
	        marginTop: 24
	      }
	    }, DIV({
	      className: 'grid-table'
	    }, DIV({
	      className: 'grid-table-header'
	    }, 'Accounts with failed posts'), DIV({
	      className: 'grid-table-header'
	    }, '# Failed'), DIV({
	      className: 'grid-table-header'
	    }, 'Ban hammer'), (function() {
	      var ref2, results;
	      if (Object.keys(failed_content_by_user).length === 0) {
	        return I(null, "No posts have been failed.");
	      } else {
	        results = [];
	        for (participant in failed_content_by_user) {
	          failed = failed_content_by_user[participant];
	          alt_row = !alt_row;
	          participant = fetch(participant);
	          results.push([
	            DIV({
	              className: "row " + (alt_row ? 'alt' : void 0),
	              style: {
	                display: 'flex'
	              }
	            }, Avatar({
	              key: participant.key,
	              style: {
	                width: 35,
	                height: 35,
	                marginRight: 6
	              }
	            }), participant.name), DIV({
	              className: "row " + (alt_row ? 'alt' : void 0)
	            }, failed.length), DIV({
	              className: "row " + (alt_row ? 'alt' : void 0)
	            }, (ref2 = participant.key, indexOf.call(bans, ref2) >= 0) ? 'Banned' : BUTTON({
	              className: 'btn',
	              onClick: (function(participant) {
	                return function() {
	                  if (confirm("Are you sure you want to shadow ban this account? Banning is irreversable.")) {
	                    return ban_user(participant);
	                  }
	                };
	              })(participant)
	            }, 'Ban'))
	          ]);
	        }
	        return results;
	      }
	    })())), DIV({
	      style: {
	        fontSize: 16,
	        maxWidth: 600,
	        marginTop: 36,
	        marginLeft: 24
	      }
	    }, ban_explanation));
	  }
	});
	
	DirectMessage = ReactiveComponent({
	  displayName: 'DirectMessage',
	  render: function() {
	    var body, ref, subject, text_style, user, wrapper_style;
	    if (!this.props.to) {
	      return SPAN(null);
	    }
	    user = fetch(this.props.to);
	    if (this.props.default_message) {
	      ref = this.props.default_message, body = ref.body, subject = ref.subject;
	    } else {
	      body = subject = null;
	    }
	    text_style = {
	      width: "min(550px, 70vw)",
	      fontSize: 16,
	      display: 'block',
	      padding: '4px 8px'
	    };
	    wrapper_style = {
	      width: "min(590px, calc(70vw + 40px))"
	    };
	    if (!this.props.title) {
	      _.defaults(wrapper_style, {
	        margin: '18px 0',
	        padding: '15px 20px',
	        backgroundColor: 'white',
	        backgroundColor: considerit_gray,
	        boxShadow: "0 2px 4px rgba(0,0,0,.4)"
	      });
	    }
	    return DIV({
	      style: wrapper_style
	    }, this.props.title ? H2({
	      style: {
	        fontSize: 24,
	        marginBottom: 18
	      }
	    }, this.props.title) : void 0, DIV({
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL(null, 'To: ', user.name)), DIV({
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL({
	      htmlFor: 'message_subject'
	    }, 'Subject'), AutoGrowTextArea({
	      id: 'message_subject',
	      className: 'message_subject',
	      placeholder: 'Subject line',
	      min_height: 25,
	      style: text_style,
	      defaultValue: subject
	    })), DIV({
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL({
	      htmlFor: 'message_body'
	    }, 'Body'), AutoGrowTextArea({
	      id: 'message_body',
	      className: 'message_body',
	      placeholder: 'Email message',
	      min_height: 75,
	      style: text_style,
	      defaultValue: body
	    })), BUTTON({
	      className: "btn",
	      onClick: this.submitMessage
	    }, 'Send'), BUTTON({
	      style: {
	        marginLeft: 8,
	        backgroundColor: 'transparent',
	        border: 'none'
	      },
	      onClick: (function(_this) {
	        return function() {
	          var base;
	          return typeof (base = _this.props).callback === "function" ? base.callback() : void 0;
	        };
	      })(this)
	    }, this.props.cancel_button_label || 'cancel'));
	  },
	  componentDidMount: function() {
	    if (this.props.send_immediately) {
	      return this.submitMessage();
	    }
	  },
	  submitMessage: function() {
	    var el, new_message;
	    el = ReactDOM.findDOMNode(this);
	    new_message = {
	      key: '/dashboard/message',
	      recipient: this.props.to,
	      subject: el.querySelector('#message_subject').value,
	      body: el.querySelector('#message_body').value,
	      sender_mask: this.props.sender_mask || fetch('/current_user').name
	    };
	    return save(new_message, (function(_this) {
	      return function() {
	        var base;
	        return typeof (base = _this.props).callback === "function" ? base.callback(new_message) : void 0;
	      };
	    })(this));
	  }
	});
	
	ModalDirectMessage = ReactiveComponent({
	  displayName: 'ModalDirectMessage',
	  mixins: [Modal],
	  render: function() {
	    return wrap_in_modal(HOMEPAGE_WIDTH(), this.props.done_callback, DIV(null, DirectMessage(this.props)));
	  }
	});


/***/ },
/* 60 */
/***/ function(module, exports) {

	window.styles += "#NOTIFICATIONS {\n  font-size: 18px;\n}\n#NOTIFICATIONS .toggle_switch {\n  top: -1px;\n}\n";
	
	window.Notifications = ReactiveComponent({
	  displayName: 'Notifications',
	  render: function() {
	    var current_user, data, loc, prefs, ref, settings, subdomain;
	    data = this.data();
	    settings = {};
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    prefs = current_user.subscriptions;
	    loc = fetch('location');
	    if ((ref = loc.query_params) != null ? ref.unsubscribe : void 0) {
	      if (current_user.subscriptions['send_emails']) {
	        current_user.subscriptions['send_emails'] = null;
	        save(current_user);
	        this.local.watched_proposals = true;
	        save(this.local);
	      }
	      delete loc.query_params.unsubscribe;
	      save(loc);
	    }
	    return DIV({
	      id: 'NOTIFICATIONS'
	    }, this.local.watched_proposals && !current_user.subscriptions['send_emails'] ? DIV({
	      style: {
	        border: "1px solid " + logo_red,
	        color: logo_red,
	        padding: '4px 8px'
	      }
	    }, TRANSLATE({
	      id: "email_notifications.watched_proposals_ack"
	    }, "You are unsubscribed from summary emails from this forum")) : void 0, customization('email_notifications_disabled') ? DIV({
	      style: {
	        margin: "18px 0 36px 0",
	        fontStyle: 'italic'
	      }
	    }, TRANSLATE({
	      id: "email_notifications.disabled"
	    }, "The forum host has disabled email summaries")) : void 0, DIV({
	      className: 'input_group checkbox'
	    }, LABEL({
	      className: 'toggle_switch'
	    }, INPUT({
	      id: 'enable_email',
	      type: 'checkbox',
	      name: 'enable_email',
	      defaultChecked: !!prefs['send_emails'],
	      onChange: (function(_this) {
	        return function(e) {
	          if (current_user.subscriptions['send_emails']) {
	            current_user.subscriptions['send_emails'] = false;
	          } else {
	            current_user.subscriptions['send_emails'] = settings['default_subscription'];
	          }
	          save(current_user);
	          return e.stopPropagation();
	        };
	      })(this)
	    }), SPAN({
	      className: 'toggle_switch_circle'
	    })), LABEL({
	      className: 'indented',
	      htmlFor: 'enable_email',
	      style: {
	        fontSize: 18
	      }
	    }, B(null, TRANSLATE("email_notifications.send_digests", 'Send me email summaries of relevant forum activity'))), prefs['send_emails'] ? DIV(null, this.drawEmailSettings(), this.drawWatched()) : void 0));
	  },
	  drawEmailSettings: function() {
	    var current_user, email_triggers, settings, trigger, u;
	    current_user = fetch('/current_user');
	    email_triggers = [
	      {
	        name: 'new_proposal',
	        label: 'A new proposal is added',
	        events: ['new_proposal']
	      }, {
	        name: 'responds_to_you',
	        label: 'Someone responds to something you wrote',
	        events: ['new_comment:point_authored', 'new_point:proposal_authored', 'new_opinion:proposal_authored']
	      }, {
	        name: 'followed_proposal_activity',
	        label: 'Activity on a proposal you are following',
	        events: ['new_comment:point_engaged', 'new_comment', 'new_opinion', 'new_point']
	      }
	    ];
	    if (current_user.is_admin) {
	      email_triggers.unshift({
	        name: 'content_to_moderate',
	        label: 'When there is new content to help moderate',
	        events: ['content_to_moderate']
	      });
	    }
	    settings = current_user.subscriptions;
	    return DIV({
	      style: {
	        marginTop: 20
	      }
	    }, LABEL({
	      htmlFor: 'send_digests_at_most',
	      style: {
	        marginRight: 10,
	        display: 'inline-block'
	      }
	    }, TRANSLATE("email_notifications.digest_timing", "Send email summaries at most")), SELECT({
	      id: 'send_digests_at_most',
	      style: {
	        width: 120,
	        fontSize: 18
	      },
	      value: settings['send_emails'],
	      onChange: (function(_this) {
	        return function(e) {
	          current_user.subscriptions['send_emails'] = e.target.value;
	          return save(current_user);
	        };
	      })(this)
	    }, (function() {
	      var i, len, ref, results;
	      ref = ['hour', 'day', 'week', 'month'];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        u = ref[i];
	        results.push(OPTION({
	          key: u,
	          value: "1_" + u
	        }, u === 'day' ? translator("email_notifications.frequency.daily", 'daily') : translator("email_notifications.frequency." + u + "ly", u + "ly")));
	      }
	      return results;
	    })()), DIV({
	      style: {
	        marginTop: 20
	      }
	    }, DIV({
	      style: {
	        marginBottom: 10
	      }
	    }, TRANSLATE('email_notifications.notable_events', "When should an email summary be triggered?")), UL({
	      style: {
	        listStyle: 'none',
	        marginLeft: 62
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = email_triggers.length; i < len; i++) {
	        trigger = email_triggers[i];
	        results.push((function(_this) {
	          return function(trigger) {
	            var checked, evnt, j, len1, ref;
	            checked = false;
	            ref = trigger.events;
	            for (j = 0, len1 = ref.length; j < len1; j++) {
	              evnt = ref[j];
	              checked || (checked = settings[evnt].email_trigger);
	            }
	            return LI({
	              key: trigger.name,
	              style: {
	                display: 'block',
	                padding: '10px 0'
	              }
	            }, SPAN({
	              style: {
	                display: 'inline-block',
	                verticalAlign: 'top',
	                position: 'relative'
	              }
	            }, INPUT({
	              id: trigger.name + "_input",
	              name: trigger.name + "_input",
	              type: 'checkbox',
	              className: 'bigger',
	              checked: checked,
	              style: {
	                position: 'absolute',
	                left: -30,
	                top: 1
	              },
	              onChange: function() {
	                var l, len2, ref1;
	                ref1 = trigger.events;
	                for (l = 0, len2 = ref1.length; l < len2; l++) {
	                  evnt = ref1[l];
	                  settings[evnt].email_trigger = !checked;
	                }
	                return save(current_user);
	              }
	            })), LABEL({
	              htmlFor: trigger.name + "_input",
	              style: {
	                display: 'inline-block',
	                verticalAlign: 'top',
	                fontSize: 15
	              }
	            }, TRANSLATE("email_notifications.event." + trigger.name, trigger.label)));
	          };
	        })(this)(trigger));
	      }
	      return results;
	    }).call(this))));
	  },
	  drawWatched: function() {
	    var current_user, k, proposal, ref, v, watched_proposals;
	    current_user = fetch('/current_user');
	    watched_proposals = [];
	    ref = current_user.subscriptions;
	    for (k in ref) {
	      v = ref[k];
	      if (v === 'watched' && k.match(/\/proposal\//)) {
	        proposal = fetch(k);
	        if (proposal.name) {
	          watched_proposals.push(proposal);
	        }
	      }
	    }
	    if (watched_proposals.length > 0) {
	      return DIV({
	        style: {
	          marginTop: 20
	        }
	      }, H4({
	        style: {
	          fontSize: 18,
	          marginBottom: 32,
	          fontWeight: 400
	        }
	      }, TRANSLATE("email_notifications.watched_proposals", 'Proposals you are following')), UL({
	        key: 'follows-list',
	        style: {
	          position: 'relative',
	          marginLeft: 32
	        }
	      }, (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = watched_proposals.length; i < len; i++) {
	          proposal = watched_proposals[i];
	          if (proposal.name) {
	            results.push((function(_this) {
	              return function(proposal) {
	                return LI({
	                  style: {
	                    display: 'flex',
	                    marginBottom: 32,
	                    position: 'relative'
	                  }
	                }, LABEL({
	                  key: 'unfollow-area',
	                  htmlFor: "unfollow-" + proposal.name
	                }, SPAN({
	                  style: {
	                    display: 'none'
	                  }
	                }, translator("email_notifications.unfollow_proposal", "Unfollow this proposal")), INPUT({
	                  key: "unfollow-" + proposal.key,
	                  id: "unfollow-" + proposal.name,
	                  className: 'bigger',
	                  style: {
	                    marginTop: 4
	                  },
	                  type: 'checkbox',
	                  defaultChecked: true,
	                  "data-tooltip": "Stop receiving updates about this proposal",
	                  onChange: function() {
	                    if (!current_user.subscriptions[proposal.key]) {
	                      current_user.subscriptions[proposal.key] = 'watched';
	                    } else {
	                      delete current_user.subscriptions[proposal.key];
	                    }
	                    return save(current_user);
	                  }
	                }), SPAN({
	                  style: {
	                    marginLeft: 18,
	                    fontSize: 15
	                  }
	                }, proposal.name)));
	              };
	            })(this)(proposal));
	          }
	        }
	        return results;
	      }).call(this)));
	    }
	  }
	});


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var AddRolesAndInvite, ModalAddRolesAndInvite, RadioWildcardRolesSection, SubdomainRoles, UserWithRole, UsersWithRole, proposal_roles;
	
	__webpack_require__(2);
	
	__webpack_require__(36);
	
	__webpack_require__(1);
	
	proposal_roles = function() {
	  var all, con_label, pro_label;
	  pro_label = get_point_label('pro');
	  con_label = get_point_label('con');
	  all = [
	    {
	      name: 'editor',
	      label: 'Editors',
	      description: 'Can modify the description of the proposal, as well as ' + 'write, comment, and opine.',
	      wildcard: {
	        label: 'Any registered user can edit',
	        "default": false
	      }
	    }, {
	      hide: true,
	      name: 'participant',
	      label: 'Participants',
	      description: "",
	      wildcard: {
	        label: 'Any registered user who can observe can participate',
	        "default": true
	      }
	    }, {
	      hide: true,
	      name: 'observer',
	      label: 'Observers',
	      description: 'Can access this proposal. But that\'s it.',
	      wildcard: {
	        label: "Public. Anyone can view",
	        "default": true
	      }
	    }
	  ];
	  all = _.compact(all);
	  return all;
	};
	
	window.InitializeProposalRoles = function(proposal) {
	  var current_user, ref, subdomain;
	  current_user = fetch('/current_user');
	  subdomain = fetch('/subdomain');
	  return proposal.roles = {
	    editor: ((ref = proposal.roles) != null ? ref.editor : void 0) || ["/user/" + current_user.id]
	  };
	};
	
	window.styles += ".ROLES_label {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 8px;\n  display: block;\n}";
	
	SubdomainRoles = ReactiveComponent({
	  displayName: 'SubdomainRoles',
	  render: function() {
	    var roles, subdomain;
	    subdomain = fetch('/subdomain');
	    roles = {
	      admin: {
	        name: 'admin',
	        label: 'Forum Hosts',
	        description: 'Can configure everything related to this forum.'
	      },
	      proposer: {
	        hide: false,
	        name: 'proposer',
	        label: 'Proposers',
	        description: 'Can add new proposals.',
	        wildcard: {
	          label: 'Any registered user can post new proposals. Can be overridden on a list-by-list basis.',
	          "default": true
	        }
	      },
	      participant: {
	        hide: false,
	        name: 'participant',
	        label: 'Participants',
	        description: 'Can participate by dragging opinion sliders and adding pro / con comments to proposals.',
	        wildcard: {
	          label: 'Any registered user can participate.',
	          "default": true
	        }
	      },
	      visitor: {
	        name: 'visitor',
	        label: 'People who can access forum',
	        description: 'If unchecked, you have a private forum. Invite specific people to join below.',
	        wildcard: {
	          label: 'Public forum. Anyone with a link can see all proposals.',
	          "default": true
	        }
	      }
	    };
	    return DIV({
	      id: 'ROLES'
	    }, DIV({
	      className: 'ROLES_section'
	    }, LABEL({
	      className: 'ROLES_label'
	    }, 'Who are the hosts of this forum?'), DIV({
	      className: 'ROLES_text',
	      style: {
	        marginBottom: 24
	      }
	    }, 'Hosts can configure everything related to this forum, and moderate content.'), UsersWithRole({
	      key: 'admin',
	      target: subdomain,
	      role: roles.admin
	    }), AddRolesAndInvite({
	      key: 'admin_roles_and_invite',
	      target: subdomain,
	      role: roles.admin,
	      add_button: 'Add new hosts'
	    })), RadioWildcardRolesSection({
	      role: roles.visitor,
	      section_label: 'Who can access this forum?',
	      open_label: 'This is an <b>open forum</b>. Anyone with the link can access the forum.',
	      restricted_label: 'This is a <b>private forum</b>. Only invited participants can access it.',
	      add_button: 'Add new visitors'
	    }), RadioWildcardRolesSection({
	      role: roles.participant,
	      section_label: 'Who can participate in this forum?',
	      open_label: 'Anyone who registers an account can participate.',
	      restricted_label: 'This is a <b>read-only forum</b> where only some people can participate but everyone can see the conversation.',
	      add_button: 'Add new participants'
	    }));
	  }
	});
	
	window.styles += "\n.ROLES_section {\n  margin-bottom: 44px;\n  position: relative;\n}\n\n.ROLES_section .ROLES_label {\n  margin-bottom: 18px;\n  display: block;\n}\n\n.ROLES_section .radio_group {\n  margin-bottom: 30px;   \n  display: flex;\n  align-items: flex-start; \n}\n\n.ROLES_section .radio_group label {\n  margin-left: 12px;\n  margin-top: -2px;\n}\n\n.ROLES_section .radio_group label b {\n  font-style: italic;\n}\n\n";
	
	RadioWildcardRolesSection = function(opts) {
	  var role, subdomain;
	  role = opts.role;
	  subdomain = fetch('/subdomain');
	  return DIV({
	    className: 'ROLES_section'
	  }, LABEL({
	    className: 'ROLES_label'
	  }, opts.section_label), DIV({
	    className: 'ROLES_text',
	    onChange: (function(_this) {
	      return function(e) {
	        if (e.target.id === ("forum_open_" + role.name)) {
	          subdomain.roles[role.name] = ['*'];
	        } else {
	          subdomain.roles[role.name] = [];
	        }
	        return save(subdomain);
	      };
	    })(this)
	  }, DIV({
	    className: 'radio_group'
	  }, INPUT({
	    id: "forum_open_" + role.name,
	    type: 'radio',
	    name: "radio_" + role.name,
	    checked: subdomain.roles[role.name].indexOf('*') > -1,
	    readOnly: true
	  }), LABEL({
	    htmlFor: "forum_open_" + role.name,
	    dangerouslySetInnerHTML: {
	      __html: opts.open_label
	    }
	  })), DIV({
	    className: 'radio_group'
	  }, INPUT({
	    id: "forum_restricted_" + role.name,
	    type: 'radio',
	    name: "radio_" + role.name,
	    checked: subdomain.roles[role.name].indexOf('*') === -1,
	    readOnly: true
	  }), LABEL({
	    htmlFor: "forum_restricted_" + role.name,
	    dangerouslySetInnerHTML: {
	      __html: opts.restricted_label
	    }
	  }))), subdomain.roles[role.name].indexOf('*') === -1 ? [
	    UsersWithRole({
	      key: 'admin',
	      target: subdomain,
	      role: role
	    }), AddRolesAndInvite({
	      key: 'admin_roles_and_invite',
	      target: subdomain,
	      role: role,
	      add_button: opts.add_button
	    })
	  ] : void 0);
	};
	
	AddRolesAndInvite = ReactiveComponent({
	  displayName: 'Invite',
	  mixins: [Modal],
	  render: function() {
	    return DIV({
	      style: {
	        position: 'relative',
	        padding: this.local.expanded ? '18px 24px' : void 0,
	        border: this.local.expanded ? '1px solid #ccc' : '1px solid transparent'
	      }
	    }, !this.local.expanded ? BUTTON({
	      className: 'btn',
	      onClick: (function(_this) {
	        return function(e) {
	          _this.local.expanded = true;
	          save(_this.local);
	          e.preventDefault();
	          return e.stopPropagation();
	        };
	      })(this)
	    }, this.props.add_button) : ModalAddRolesAndInvite({
	      target: this.props.target,
	      role: this.props.role,
	      add_button: this.props.add_button,
	      done_callback: (function(_this) {
	        return function() {
	          console.log("done callback");
	          _this.local.expanded = false;
	          return save(_this.local);
	        };
	      })(this)
	    }));
	  }
	});
	
	ModalAddRolesAndInvite = ReactiveComponent({
	  displayName: 'Invite',
	  mixins: [Modal],
	  render: function() {
	    var base, filtered_users, idx, processNewFolks, target, user_key, users;
	    target = fetch(this.props.target);
	    users = fetch('/users');
	    if ((base = this.local).added == null) {
	      base.added = [];
	    }
	    processNewFolks = (function(_this) {
	      return function() {
	        var $filter, candidate_email, candidates, i, len;
	        $filter = document.getElementById('filter');
	        candidates = $filter.value;
	        if (candidates) {
	          candidates = candidates.split(',');
	          for (i = 0, len = candidates.length; i < len; i++) {
	            candidate_email = candidates[i];
	            candidate_email = candidate_email.trim();
	            if (candidate_email.indexOf(' ') < 0 && candidate_email.indexOf('@') > 0 && candidate_email.indexOf('.') > 0) {
	              _this.local.added.push(candidate_email);
	            }
	          }
	          save(_this.local);
	        }
	        return $filter.value = '';
	      };
	    })(this);
	    filtered_users = _.filter(users.users, (function(_this) {
	      return function(u) {
	        return target.roles[_this.props.role.name].indexOf(u.key) < 0 && _this.local.added.indexOf(u.key) < 0 && (!_this.local.filtered || (u.name + " <" + u.email + ">").indexOf(_this.local.filtered) > -1);
	      };
	    })(this));
	    return wrap_in_modal(null, this.props.done_callback, DIV(null, H1({
	      style: {
	        marginBottom: 24,
	        fontSize: 24
	      }
	    }, this.props.add_button), SPAN(null, DropMenu({
	      options: filtered_users,
	      open_menu_on: 'activation',
	      selection_made_callback: (function(_this) {
	        return function(user) {
	          _this.local.added.push(user.key);
	          processNewFolks();
	          _this.local.filtered = null;
	          return save(_this.local);
	        };
	      })(this),
	      render_anchor: (function(_this) {
	        return function(menu_showing) {
	          return INPUT({
	            key: 'filter',
	            id: 'filter',
	            type: 'text',
	            style: {
	              fontSize: 18,
	              width: 350,
	              padding: '3px 6px'
	            },
	            autoComplete: 'off',
	            placeholder: "Name or email...",
	            onChange: function() {
	              _this.local.filtered = document.getElementById('filter').value;
	              return save(_this.local);
	            },
	            onKeyDown: function(e) {
	              if (e.which === 13) {
	                e.preventDefault();
	                return processNewFolks();
	              }
	            }
	          });
	        };
	      })(this),
	      render_option: function(user) {
	        return [
	          SPAN({
	            key: 'name',
	            style: {
	              fontWeight: 600
	            }
	          }, user.name), SPAN({
	            key: 'email',
	            style: {
	              opacity: .7,
	              paddingLeft: 8
	            }
	          }, user.email)
	        ];
	      },
	      wrapper_style: {
	        display: 'inline-block'
	      },
	      menu_style: {
	        backgroundColor: '#ddd',
	        border: '1px solid #ddd'
	      },
	      option_style: {
	        padding: '4px 12px',
	        fontSize: 18,
	        cursor: 'pointer',
	        display: 'block'
	      },
	      active_option_style: {
	        backgroundColor: '#eee'
	      }
	    }), this.local.filtered && this.local.filtered.length > 0 ? BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          return processNewFolks();
	        };
	      })(this),
	      style: {
	        display: 'inline-block'
	      }
	    }, 'add') : void 0), this.local.added.length > 0 ? DIV({
	      style: {
	        marginTop: 18
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = this.local.added;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        user_key = ref[idx];
	        results.push(UserWithRole(user_key, (function(_this) {
	          return function(user_key) {
	            _this.local.added = _.without(_this.local.added, user_key);
	            return save(_this.local);
	          };
	        })(this)));
	      }
	      return results;
	    }).call(this)) : void 0, DIV({
	      style: {
	        marginTop: 20
	      }
	    }, LABEL({
	      htmlFor: 'send_email_invite'
	    }, INPUT({
	      type: 'checkbox',
	      id: 'send_email_invite',
	      name: 'send_email_invite',
	      className: 'bigger',
	      style: {
	        position: 'relative',
	        top: 1,
	        marginRight: 14
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.send_email_invite = !_this.local.send_email_invite;
	          return save(_this.local);
	        };
	      })(this)
	    }), 'Send email invitation'), this.local.send_email_invite ? DIV({
	      style: {
	        marginLeft: 20,
	        marginTop: 10
	      }
	    }, AutoGrowTextArea({
	      id: 'custom_email_message',
	      name: 'custom_email_message',
	      ref: 'custom_email_message',
	      placeholder: '(optional) custom message',
	      style: {
	        width: '90%',
	        fontSize: 18,
	        padding: '8px 14px'
	      }
	    })) : void 0), DIV({
	      style: {
	        marginTop: 36
	      }
	    }, BUTTON({
	      className: 'btn',
	      disabled: this.local.added.length === 0,
	      style: {
	        backgroundColor: focus_color(),
	        cursor: this.local.added.length === 0 ? 'default' : void 0,
	        opacity: this.local.added.length === 0 ? 0.5 : void 0
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          var invitation, role;
	          if (_this.local.added.length > 0) {
	            role = _this.props.role.name;
	            target.roles[role] = target.roles[role].concat(_this.local.added);
	            if (_this.local.send_email_invite) {
	              if (!target.invitations) {
	                target.invitations = [];
	              }
	              invitation = {
	                role: role,
	                keys_or_emails: _this.local.added
	              };
	              invitation.message = ReactDOM.findDOMNode(_this.refs.custom_email_message).value;
	              target.invitations.push(invitation);
	            }
	            _this.local.added = [];
	            save(target);
	            save(_this.local);
	          }
	          return _this.props.done_callback();
	        };
	      })(this)
	    }, "Add"), BUTTON({
	      className: 'like_link',
	      style: {
	        color: '#333',
	        marginLeft: 24,
	        position: 'relative',
	        top: 2
	      },
	      onClick: this.props.done_callback
	    }, 'cancel'))));
	  }
	});
	
	UsersWithRole = ReactiveComponent({
	  displayName: 'UsersWithRole',
	  render: function() {
	    var role, target, user_key;
	    target = fetch(this.props.target);
	    role = this.props.role;
	    return DIV({
	      style: {
	        marginLeft: -4,
	        marginBottom: 12
	      }
	    }, (function() {
	      var i, len, ref, results;
	      if (target.roles[role.name]) {
	        ref = target.roles[role.name];
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          user_key = ref[i];
	          if (user_key !== '*') {
	            results.push(UserWithRole(user_key, (function(_this) {
	              return function(user_key) {
	                var invite, j, len1, ref1;
	                target.roles[role.name] = _.without(target.roles[role.name], user_key);
	                if (target.invitations) {
	                  ref1 = target.invitations;
	                  for (j = 0, len1 = ref1.length; j < len1; j++) {
	                    invite = ref1[j];
	                    if (invite.role === role.name) {
	                      invite.keys_or_emails = _.without(invite.keys_or_emails, user_key);
	                    }
	                  }
	                }
	                return save(target);
	              };
	            })(this)));
	          } else {
	            results.push(void 0);
	          }
	        }
	        return results;
	      }
	    }).call(this));
	  }
	});
	
	UserWithRole = function(user_key, on_remove_from_role) {
	  var user;
	  return DIV({
	    key: user_key,
	    style: {
	      display: 'inline-block',
	      padding: '6px 4px 6px 12px',
	      fontSize: 13,
	      backgroundColor: '#ddd',
	      color: 'black',
	      borderRadius: 8,
	      margin: 4
	    }
	  }, DIV({
	    style: {
	      display: 'inline-block'
	    }
	  }, user_key && user_key[0] === '/' ? (user = fetch(user_key), SPAN(null, user.avatar_file_name ? Avatar({
	    key: user_key,
	    hide_popover: true,
	    style: {
	      width: user.name ? 35 : 20,
	      height: user.name ? 35 : 20,
	      marginRight: 12
	    }
	  }) : void 0, DIV({
	    style: {
	      display: 'inline-block'
	    }
	  }, user.name ? DIV({
	    style: {
	      fontSize: 16
	    }
	  }, user.name) : void 0, DIV({
	    style: {
	      color: user.name ? '#888' : void 0
	    }
	  }, user.email)))) : user_key), BUTTON({
	    'aria-label': "Remove " + ((user != null ? user.name : void 0) || user_key) + " from role",
	    style: {
	      cursor: 'pointer',
	      marginLeft: 8,
	      border: 'none',
	      backgroundColor: 'transparent',
	      verticalAlign: 'top'
	    },
	    onClick: function() {
	      if (on_remove_from_role) {
	        return on_remove_from_role(user_key);
	      }
	    }
	  }, 'x'));
	};
	
	window.SubdomainRoles = SubdomainRoles;


/***/ },
/* 62 */
/***/ function(module, exports) {

	var UserTags,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	UserTags = ReactiveComponent({
	  displayName: 'UserTags',
	  render: function() {
	    var all_tags, available_users, base, change_selected_user, i, idx, j, k, l, len, len1, len2, len3, len4, m, my_vals, n, option, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, selected_user, show_all, subdomain, tag, tag_names, tags, tags_config, user, users, v, val, vals;
	    subdomain = fetch('/subdomain');
	    users = fetch('/users');
	    selected_user = this.local.selected_user ? fetch(this.local.selected_user) : void 0;
	    change_selected_user = (function(_this) {
	      return function(new_user) {
	        var k, v;
	        _this.local.new_tags = {};
	        _this.local.selected_user = new_user;
	        selected_user = _this.local.selected_user ? fetch(_this.local.selected_user) : void 0;
	        if (selected_user) {
	          for (k in all_tags) {
	            v = all_tags[k];
	            if (k !== 'no tags') {
	              if (selected_user.tags[k] == null) {
	                _this.local.new_tags[k] = "";
	              }
	            }
	          }
	        }
	        return save(_this.local);
	      };
	    })(this);
	    tags_config = customization('user_tags');
	    all_tags = {};
	    tag_names = {};
	    for (i = 0, len = tags_config.length; i < len; i++) {
	      vals = tags_config[i];
	      tag = vals.key;
	      all_tags[tag] = {
	        not_answered: []
	      };
	      tag_names[tag] = vals.view_name || ((ref = vals.self_report) != null ? ref.question : void 0) || tag;
	      if (vals.self_report) {
	        if (vals.self_report.options) {
	          ref1 = vals.self_report.options;
	          for (j = 0, len1 = ref1.length; j < len1; j++) {
	            option = ref1[j];
	            all_tags[tag][option] = [];
	          }
	        } else if (vals.self_report.input === 'boolean') {
	          all_tags[tag][true] = [];
	          all_tags[tag][false] = [];
	        }
	      }
	    }
	    ref2 = users.users;
	    for (l = 0, len2 = ref2.length; l < len2; l++) {
	      user = ref2[l];
	      user = fetch(user.key || user);
	      for (m = 0, len3 = tags_config.length; m < len3; m++) {
	        vals = tags_config[m];
	        tag = vals.key;
	        if (!(tag in user.tags) || user.tags[tag] === "" || user.tags[tag] === 'undefined') {
	          all_tags[tag].not_answered.push(user);
	        }
	      }
	      ref3 = user.tags;
	      for (tag in ref3) {
	        val = ref3[tag];
	        console.log(tag, val, user);
	        if ((val != null ? (ref4 = val.self_report) != null ? ref4.input : void 0 : void 0) === 'checklist') {
	          my_vals = val.split(',');
	        } else if ((val != null ? (ref5 = val.self_report) != null ? ref5.input : void 0 : void 0) === 'boolean' && (typeof val === 'string') && ((ref6 = val.toLowerCase()) === "no" || ref6 === "false" || ref6 === "yes" || ref6 === "true")) {
	          if ((ref7 = val.toLowerCase()) === "no" || ref7 === "false") {
	            my_vals = [false];
	          } else {
	            my_vals = [true];
	          }
	        } else {
	          my_vals = [val];
	        }
	        for (n = 0, len4 = my_vals.length; n < len4; n++) {
	          v = my_vals[n];
	          if ((base = all_tags[tag])[v] == null) {
	            base[v] = [];
	          }
	          all_tags[tag][v].push(user);
	        }
	      }
	    }
	    if (all_tags['considerit_terms']) {
	      delete all_tags['considerit_terms'];
	    }
	    return DIV({
	      style: {
	        paddingTop: 50
	      }
	    }, DIV({
	      style: {
	        marginBottom: 12
	      }
	    }, H1({
	      style: {
	        fontSize: 48
	      }
	    }, "Custom Participant Data")), DIV(null, INPUT({
	      id: 'filter',
	      type: 'text',
	      style: {
	        fontSize: 18,
	        width: 350,
	        padding: '3px 6px'
	      },
	      autoComplete: 'off',
	      'aria-label': "Name or email...",
	      placeholder: "Name or email...",
	      value: selected_user ? selected_user.name : "",
	      onChange: (function(_this) {
	        return function(ev) {
	          var ref8;
	          _this.local.filtered = (ref8 = ev.target.value) != null ? ref8.toLowerCase() : void 0;
	          change_selected_user(null);
	          return save(_this.local);
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            e.preventDefault();
	            change_selected_user(_this.local.hovered_user);
	            return save(_this.local);
	          }
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function(e) {
	          _this.local.selecting = true;
	          save(_this.local);
	          e.stopPropagation();
	          e.preventDefault();
	          if (_this.handle_click == null) {
	            _this.handle_click = function(e) {
	              if (e.target.id !== 'filter') {
	                _this.local.selecting = false;
	                save(_this.local);
	                return document.removeEventListener('click', _this.handle_click);
	              }
	            };
	          }
	          return document.addEventListener('click', _this.handle_click);
	        };
	      })(this)
	    })), this.local.selecting ? (available_users = _.filter(users.users, (function(_this) {
	      return function(u) {
	        return u.key !== _this.local.selected_user && (!_this.local.filtered || (u.name + " <" + u.email + ">").toLowerCase().indexOf(_this.local.filtered) > -1);
	      };
	    })(this)), available_users.length > 0 ? UL({
	      style: {
	        width: 500,
	        position: 'absolute',
	        zIndex: 99,
	        listStyle: 'none',
	        backgroundColor: '#fff',
	        border: '1px solid #eee'
	      }
	    }, (function() {
	      var len5, o, results;
	      results = [];
	      for (idx = o = 0, len5 = available_users.length; o < len5; idx = ++o) {
	        user = available_users[idx];
	        results.push((function(_this) {
	          return function(user) {
	            return LI({
	              key: user.key,
	              className: 'invite_menu_item',
	              style: {
	                padding: '2px 12px',
	                fontSize: 18,
	                cursor: 'pointer',
	                borderBottom: '1px solid #fafafa'
	              },
	              onMouseEnter: function(e) {
	                _this.local.hovered_user = user.key;
	                return save(_this.local);
	              },
	              onMouseLeave: function(e) {
	                _this.local.hovered_user = null;
	                return save(_this.local);
	              },
	              onClick: function(e) {
	                change_selected_user(_this.local.hovered_user);
	                return e.stopPropagation();
	              }
	            }, user.name + " <" + user.email + ">");
	          };
	        })(this)(user));
	      }
	      return results;
	    }).call(this)) : void 0) : void 0, selected_user ? DIV({
	      style: {
	        marginTop: 20
	      }
	    }, (function() {
	      var len5, o, ref8, results;
	      ref8 = [selected_user.tags, this.local.new_tags];
	      results = [];
	      for (o = 0, len5 = ref8.length; o < len5; o++) {
	        tags = ref8[o];
	        results.push((function() {
	          var results1;
	          results1 = [];
	          for (k in tags) {
	            v = tags[k];
	            results1.push((function(_this) {
	              return function(k, v, tags) {
	                var editing;
	                editing = _this.local.editing === k;
	                return DIV({
	                  key: k + "-" + v,
	                  style: {},
	                  onFocus: function(e) {
	                    _this.local.editing = k;
	                    return save(_this.local);
	                  },
	                  onBlur: function(e) {
	                    _this.local.editing = null;
	                    return save(_this.local);
	                  }
	                }, INPUT({
	                  ref: k,
	                  style: {
	                    fontWeight: 600,
	                    padding: '5px 10px',
	                    marginRight: 18,
	                    display: 'inline-block',
	                    border: "1px solid " + (editing ? '#bbb' : 'transparent'),
	                    fontSize: 18,
	                    width: 400
	                  },
	                  defaultValue: k
	                }), INPUT({
	                  ref: k + "-val",
	                  style: {
	                    padding: '5px 10px',
	                    display: 'inline-block',
	                    border: "1px solid " + (editing ? '#bbb' : 'transparent'),
	                    fontSize: 18,
	                    width: 400
	                  },
	                  defaultValue: v
	                }));
	              };
	            })(this)(k, v, tags));
	          }
	          return results1;
	        }).call(this));
	      }
	      return results;
	    }).call(this), DIV({
	      style: {}
	    }, LABEL({
	      style: {}
	    }, INPUT({
	      type: 'checkbox',
	      checked: (ref8 = selected_user.key, indexOf.call(customization('organizational_account') || [], ref8) >= 0),
	      onChange: function(e) {
	        var orgs, ref9;
	        orgs = customization('organizational_account') || [];
	        if (ref9 = selected_user.key, indexOf.call(orgs, ref9) >= 0) {
	          orgs = _.without(orgs, selected_user.key);
	        } else {
	          orgs.push(selected_user.key);
	        }
	        subdomain.customizations['organizational_account'] = orgs;
	        return save(subdomain);
	      }
	    }), "Designate as organizational account")), DIV({
	      style: {
	        marginTop: 12
	      }
	    }, INPUT({
	      type: 'submit',
	      style: {
	        backgroundColor: focus_color(),
	        border: 'none',
	        color: 'white',
	        padding: '5px 10px',
	        borderRadius: 8,
	        fontSize: 18
	      },
	      onClick: (function(_this) {
	        return function() {
	          var len5, new_k, new_v, o, ref9, update;
	          update = {};
	          ref9 = [selected_user.tags, _this.local.new_tags];
	          for (o = 0, len5 = ref9.length; o < len5; o++) {
	            tags = ref9[o];
	            for (k in tags) {
	              v = tags[k];
	              new_k = _this.refs[k].value;
	              new_v = _this.refs[k + "-val"].value;
	              if ((new_k != null ? new_k.length : void 0) > 0) {
	                update[new_k] = new_v;
	              }
	            }
	          }
	          selected_user.tags = update;
	          save(selected_user);
	          _this.local.new_tags = {};
	          return save(_this.local);
	        };
	      })(this),
	      value: 'Update'
	    }))) : void 0, DIV({
	      key: 'all users',
	      style: {
	        marginTop: 12
	      }
	    }, (function() {
	      var ref9, results;
	      results = [];
	      for (tag in all_tags) {
	        vals = all_tags[tag];
	        show_all = Object.keys(vals).length < 15 || !!((ref9 = this.local.show_all) != null ? ref9[tag] : void 0);
	        results.push(DIV({
	          key: tag
	        }, H2({
	          style: {
	            fontSize: 36,
	            marginTop: 36
	          },
	          dangerouslySetInnerHTML: {
	            __html: tag_names[tag]
	          }
	        }), (function() {
	          var results1;
	          if (!show_all) {
	            return DIV(null, DIV(null, SPAN({
	              style: {
	                fontStyle: 'italic'
	              }
	            }, "Lots of values."), BUTTON({
	              style: {
	                backgroundColor: 'none',
	                border: 'none',
	                padding: 0,
	                color: focus_color(),
	                textDecoration: 'underline',
	                marginLeft: 12
	              },
	              onClick: (function(_this) {
	                return function(tag) {
	                  return function() {
	                    var base1;
	                    if ((base1 = _this.local).show_all == null) {
	                      base1.show_all = {};
	                    }
	                    _this.local.show_all[tag] = true;
	                    return save(_this.local);
	                  };
	                };
	              })(this)(tag)
	            }, "Break out by value")), (function() {
	              var results1;
	              results1 = [];
	              for (v in vals) {
	                users = vals[v];
	                results1.push(UL({
	                  key: v,
	                  style: {
	                    listStyle: 'none',
	                    display: 'inline',
	                    fontSize: 0,
	                    lineHeight: 0
	                  }
	                }, (function() {
	                  var len5, o, results2;
	                  results2 = [];
	                  for (o = 0, len5 = users.length; o < len5; o++) {
	                    user = users[o];
	                    results2.push((function(_this) {
	                      return function(user) {
	                        return Avatar({
	                          key: user.key,
	                          style: {
	                            width: 40,
	                            height: 40,
	                            cursor: 'pointer'
	                          },
	                          alt: "<user>: " + v,
	                          onClick: function() {
	                            return change_selected_user(user.key);
	                          }
	                        });
	                      };
	                    })(this)(user));
	                  }
	                  return results2;
	                }).call(this)));
	              }
	              return results1;
	            }).call(this));
	          } else {
	            results1 = [];
	            for (v in vals) {
	              users = vals[v];
	              results1.push((function(_this) {
	                return function(tag, v) {
	                  return DIV({
	                    key: v + "-" + tag,
	                    style: {
	                      marginBottom: 18
	                    },
	                    onKeyDown: function(e) {
	                      if (e.which === 18) {
	                        return _this.local.control_depressed = true;
	                      }
	                    },
	                    onKeyUp: function(e) {
	                      return _this.local.control_depressed = false;
	                    },
	                    onDragEnter: function(e) {
	                      if (_this.local.control_depressed) {
	                        return e.preventDefault();
	                      }
	                    },
	                    onDragOver: function(e) {
	                      if (_this.local.control_depressed) {
	                        return e.preventDefault();
	                      }
	                    },
	                    onDragLeave: function(e) {
	                      if (_this.local.control_depressed) {
	                        return e.preventDefault();
	                      }
	                    },
	                    onDrop: function(e) {
	                      if (_this.local.control_depressed) {
	                        e.preventDefault();
	                        user = fetch(e.dataTransfer.getData("text/plain"));
	                        user.tags[tag] = v;
	                        return save(user);
	                      }
	                    }
	                  }, DIV({
	                    style: {
	                      fontWeight: 700,
	                      marginRight: 8
	                    }
	                  }, v), UL({
	                    style: {
	                      listStyle: 'none',
	                      display: 'inline',
	                      fontSize: 0,
	                      lineHeight: 0
	                    }
	                  }, (function() {
	                    var len5, o, results2;
	                    results2 = [];
	                    for (o = 0, len5 = users.length; o < len5; o++) {
	                      user = users[o];
	                      results2.push((function(_this) {
	                        return function(user) {
	                          return SPAN({
	                            key: user.key,
	                            draggable: true,
	                            onDragStart: function(ev) {
	                              if (_this.local.control_depressed) {
	                                return ev.dataTransfer.setData("text/plain", user.key);
	                              }
	                            },
	                            style: {
	                              width: 40,
	                              height: 40,
	                              cursor: 'move'
	                            }
	                          }, Avatar({
	                            key: user.key,
	                            style: {
	                              width: 40,
	                              height: 40
	                            },
	                            alt: "<user>: " + v,
	                            hide_popover: _this.local.control_depressed,
	                            onClick: function(e) {
	                              if (!_this.local.control_depressed) {
	                                change_selected_user(user.key);
	                                e.stopPropagation();
	                                return e.preventDefault();
	                              }
	                            }
	                          }));
	                        };
	                      })(this)(user));
	                    }
	                    return results2;
	                  }).call(_this)));
	                };
	              })(this)(tag, v));
	            }
	            return results1;
	          }
	        }).call(this)));
	      }
	      return results;
	    }).call(this)));
	  }
	});
	
	window.UserTags = UserTags;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var Development;
	
	__webpack_require__(1);
	
	Development = ReactiveComponent({
	  displayName: 'Development',
	  render: function() {
	    var base, hues, idx, s, sub, subdomains;
	    if (!this.local.search) {
	      this.local.search = '';
	    }
	    if ((base = this.local).only_with_activity == null) {
	      base.only_with_activity = true;
	    }
	    if (location.hostname === 'localhost' && this.local.hover_top) {
	      subdomains = fetch('/subdomains').subs;
	      if (this.is_waiting()) {
	        return SPAN(null);
	      }
	      subdomains = (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = subdomains.length; i < len; i++) {
	          s = subdomains[i];
	          if ((!this.local.only_with_activity || s.activity) && (!this.local.highlight_customized || s.customizations)) {
	            results.push(s);
	          }
	        }
	        return results;
	      }).call(this);
	      hues = getNiceRandomHues(subdomains.length);
	      subdomains.sort(function(a, b) {
	        return b.activity - a.activity;
	      });
	    }
	    if (screencasting()) {
	      return DIV(null);
	    }
	    return DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 9999,
	        left: 0,
	        top: 0,
	        opacity: this.local.hover_top ? 1 : 0,
	        backgroundColor: 'black',
	        color: 'white',
	        padding: 15
	      },
	      tabIndex: 0,
	      onTouchEnd: (function(_this) {
	        return function(e) {
	          _this.local.hover_top = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseEnter: (function(_this) {
	        return function(e) {
	          ReactDOM.findDOMNode(_this).focus();
	          _this.local.hover_top = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function(e) {
	          _this.local.search = '';
	          _this.local.hover_top = _this.local.hover_second = false;
	          return save(_this.local);
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 27) {
	            _this.local.search = '';
	            _this.local.hover_top = _this.local.hover_second = false;
	            save(_this.local);
	          } else if (e.which === 8 || e.which === 46) {
	            _this.local.search = _this.local.search.substring(0, _this.local.search.length - 1);
	          } else if (e.which === 9) {
	            _this.local.only_with_activity = !_this.local.only_with_activity;
	          } else if (e.which === 32) {
	            _this.local.highlight_customized = !_this.local.highlight_customized;
	          } else if (e.key.length === 1 && /[a-zA-Z0-9-_ ]/.test(e.key)) {
	            _this.local.search += e.key;
	          }
	          save(_this.local);
	          return e.preventDefault();
	        };
	      })(this)
	    }, this.local.hover_top ? DIV(null, UL({
	      style: {
	        listStyle: 'none',
	        display: 'inline-block'
	      }
	    }, LI({
	      style: {
	        paddingLeft: 20,
	        backgroundColor: 'black',
	        color: 'white',
	        display: 'inline-block'
	      }
	    }, this.local.search)), DIV({
	      style: {
	        width: '100%'
	      }
	    }, UL(null, (function() {
	      var i, len, ref, results;
	      ref = subdomains || [];
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        sub = ref[idx];
	        results.push(LI({
	          style: {
	            display: 'inline-block',
	            listStyle: 'none'
	          }
	        }, A({
	          href: "/change_subdomain/" + sub.name,
	          'data-nojax': false,
	          style: {
	            padding: "4px 8px",
	            fontSize: 18,
	            backgroundColor: hsv2rgb(hues[idx], .7, .5),
	            color: 'white',
	            display: 'inline-block',
	            opacity: this.local.search.length > 0 && sub.name.toLowerCase().indexOf(this.local.search.toLowerCase()) === -1 ? .3 : void 0
	          }
	        }, sub.name)));
	      }
	      return results;
	    }).call(this)))) : void 0);
	  },
	  componentDidMount: function() {
	    return document.addEventListener("keypress", function(e) {
	      var cur_idx, i, idx, key, len, next_idx, ref, sub, subdomain, subdomains;
	      key = (e && e.keyCode) || e.keyCode;
	      if (key === 14) {
	        subdomains = fetch('/subdomains');
	        subdomain = fetch('/subdomain');
	        cur_idx = -1;
	        ref = subdomains.subs;
	        for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	          sub = ref[idx];
	          if (sub.id === subdomain.id) {
	            cur_idx = idx;
	          }
	        }
	        next_idx = cur_idx + 1;
	        if (next_idx >= subdomains.subs.length) {
	          next_idx = 0;
	        }
	        return window.location = "/change_subdomain/" + subdomains.subs[next_idx].name;
	      }
	    });
	  }
	});
	
	window.Development = Development;


/***/ },
/* 64 */
/***/ function(module, exports) {

	var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	window.EditComment = ReactiveComponent({
	  displayName: 'EditComment',
	  render: function() {
	    var anonymous, commentor_opinion, current_user, error, name, permitted, proposal, ref;
	    proposal = fetch(this.props.proposal);
	    permitted = permit('create comment', proposal);
	    current_user = fetch('/current_user');
	    commentor_opinion = _.findWhere(proposal.opinions, {
	      user: current_user.user
	    });
	    anonymous = (commentor_opinion != null ? commentor_opinion.hide_name : void 0) || customization('anonymize_everything');
	    if (!this.props.fresh) {
	      anonymous || (anonymous = this.data().hide_name);
	    }
	    name = current_user.name || 'You';
	    if ((commentor_opinion != null ? commentor_opinion.hide_name : void 0) || customization('anonymize_permanently')) {
	      name += " [" + (your_opinion_i18n.anon_assurance()) + "]";
	    }
	    return DIV({
	      className: 'comment_entry',
	      onKeyDown: function(e) {
	        if (e.which === 32 || e.which === 13) {
	          return e.stopPropagation();
	        }
	      }
	    }, DIV({
	      className: 'comment_entry_name'
	    }, name + ':'), avatar(current_user.user, {
	      style: {
	        position: 'absolute',
	        width: 50,
	        height: 50,
	        backgroundColor: permitted < 0 ? 'transparent' : void 0,
	        border: permitted < 0 ? '1px dashed grey' : void 0
	      },
	      key: current_user.user,
	      hide_popover: true,
	      anonymous: !!anonymous
	    }), permitted === Permission.DISABLED ? SPAN({
	      style: {
	        position: 'absolute',
	        margin: '14px 0 0 70px'
	      }
	    }, translator('engage.comment_period_closed', 'Comments closed')) : permitted === Permission.INSUFFICIENT_PRIVILEGES ? SPAN({
	      style: {
	        position: 'absolute',
	        margin: '14px 0 0 70px'
	      }
	    }, translator('engage.permissions.read_only', 'This proposal is read-only for you')) : permitted < 0 ? A({
	      style: {
	        position: 'absolute',
	        margin: '14px 0 0 70px',
	        cursor: 'pointer',
	        zIndex: 1
	      },
	      onTouchEnd: (function(_this) {
	        return function(e) {
	          return e.stopPropagation();
	        };
	      })(this),
	      onClick: (function(_this) {
	        return function(e) {
	          e.stopPropagation();
	          if (permitted === Permission.NOT_LOGGED_IN) {
	            return reset_key('auth', {
	              form: 'create account',
	              goal: ''
	            });
	          } else if (permitted === Permission.UNVERIFIED_EMAIL) {
	            reset_key('auth', {
	              form: 'verify email',
	              goal: 'To participate, please demonstrate you control this email.'
	            });
	            current_user.trying_to = 'send_verification_token';
	            return save(current_user);
	          }
	        };
	      })(this)
	    }, permitted === Permission.NOT_LOGGED_IN ? DIV(null, BUTTON({
	      style: {
	        textDecoration: 'underline',
	        color: focus_color(),
	        fontSize: browser.is_mobile ? 18 : void 0,
	        backgroundColor: 'transparent',
	        padding: 0,
	        border: 'none'
	      }
	    }, translator('engage.permissions.login_to_participate', 'Create an account to participate')), indexOf.call(proposal.roles.participant, '*') < 0 ? DIV({
	      style: {
	        fontSize: 11
	      }
	    }, translator('engage.permissions.only_some_participate', 'Only some accounts are authorized to participate.')) : void 0) : permitted === Permission.UNVERIFIED_EMAIL ? DIV(null, translator('engage.permissions.verify_account_to_participate', "Verify your account to participate")) : void 0) : void 0, DIV({
	      style: {
	        marginLeft: 60
	      }
	    }, AutoGrowTextArea({
	      id: 'comment_input',
	      name: 'new comment',
	      'aria-label': permitted > 0 ? translator('engage.comment_input_placeholder', 'Write a comment') : '',
	      placeholder: permitted > 0 ? translator('engage.comment_input_placeholder', 'Write a comment') : '',
	      disabled: permitted < 0,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.new_comment = e.target.value;
	          return save(_this.local);
	        };
	      })(this),
	      defaultValue: this.props.fresh ? null : this.data().body,
	      min_height: 80,
	      style: {
	        width: '100%',
	        lineHeight: 1.4,
	        fontSize: 16,
	        border: permitted < 0 ? 'dashed 1px' : void 0
	      }
	    })), ((ref = this.local.errors) != null ? ref.length : void 0) > 0 ? DIV({
	      role: 'alert',
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10,
	        marginBottom: 10,
	        marginLeft: 60
	      }
	    }, (function() {
	      var i, len, ref1, results;
	      ref1 = this.local.errors;
	      results = [];
	      for (i = 0, len = ref1.length; i < len; i++) {
	        error = ref1[i];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    }).call(this)) : void 0, permitted > 0 ? BUTTON({
	      className: "btn",
	      style: {
	        marginLeft: 60,
	        padding: '8px 16px'
	      },
	      'data-action': 'save-comment',
	      onClick: (function(_this) {
	        return function(e) {
	          var comment;
	          e.stopPropagation();
	          if (_this.props.fresh) {
	            comment = {
	              key: '/new/comment',
	              body: _this.local.new_comment,
	              user: fetch('/current_user').user,
	              point: "/point/" + _this.props.point
	            };
	          } else {
	            comment = _this.data();
	            comment.body = _this.local.new_comment;
	            comment.editing = false;
	          }
	          if (!comment.body || comment.body.length === 0) {
	            _this.local.errors = ["Comment can't be empty"];
	            return save(_this.local);
	          } else {
	            return save(comment, function() {
	              var ref1;
	              if (((ref1 = comment.errors) != null ? ref1.length : void 0) > 0) {
	                _this.local.errors = comment.errors;
	              } else {
	                show_flash(translator('engage.flashes.comment_saved', "Your comment has been saved"));
	              }
	              _this.local.new_comment = null;
	              return save(_this.local);
	            });
	          }
	        };
	      })(this)
	    }, translator("engage.save_comment_button", 'Post comment')) : void 0);
	  }
	});


/***/ },
/* 65 */
/***/ function(module, exports) {

	window.stop_editing_forum = function() {
	  var edit_forum, i, key, len, ref;
	  edit_forum = fetch('edit_forum');
	  ref = Object.keys(edit_forum);
	  for (i = 0, len = ref.length; i < len; i++) {
	    key = ref[i];
	    if (key !== 'key') {
	      delete edit_forum[key];
	    }
	  }
	  return save(edit_forum);
	};
	
	styles += "[data-widget=\"EditForum\"] button {\n  border: none;\n  background-color: " + selected_color + "; \n  color: white; \n  font-weight: 700;\n  padding: 10px 22px; \n  border-radius: 8px;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(0,0,0,.4);\n}\n";
	
	window.EditForum = ReactiveComponent({
	  displayName: 'EditForum',
	  render: function() {
	    var current_user, edit_forum, enter_edit, error, is_light, ref, show_dash_modal, subdomain;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    edit_forum = fetch('edit_forum');
	    if (!current_user.is_admin) {
	      return DIV(null);
	    }
	    enter_edit = function(e) {
	      edit_forum.editing = true;
	      return save(edit_forum);
	    };
	    is_light = is_light_background();
	    show_dash_modal = fetch('show_dash_modal');
	    if (show_dash_modal.showing) {
	      return SPAN(null);
	    }
	    if (!edit_forum.editing) {
	      return DIV({
	        style: {
	          position: 'absolute',
	          left: TABLET_SIZE() ? 24 : "50%",
	          top: 17,
	          zIndex: 99999,
	          marginLeft: !TABLET_SIZE() ? -152 : void 0
	        }
	      }, BUTTON({
	        onClick: enter_edit
	      }, PHONE_SIZE() ? translator('forum.edit_button_short', 'Edit Banner') : translator('forum.edit_button', 'Edit Banner & Forum Structure')));
	    } else {
	      return DIV(null, BUTTON({
	        style: {
	          boxShadow: '0 1px 2px rgba(0,0,0,.5)'
	        },
	        onClick: stop_editing_forum
	      }, translator('shared.done_editing', 'Done Editing Forum')), ((ref = subdomain.errors) != null ? ref.length : void 0) > 0 ? DIV({
	        style: {
	          borderRadius: 8,
	          margin: 20,
	          padding: 20,
	          backgroundColor: '#FFE2E2'
	        }
	      }, H1({
	        style: {
	          fontSize: 18
	        }
	      }, 'Ooops!'), (function() {
	        var i, len, ref1, results;
	        ref1 = subdomain.errors;
	        results = [];
	        for (i = 0, len = ref1.length; i < len; i++) {
	          error = ref1[i];
	          results.push(DIV({
	            style: {
	              marginTop: 10
	            }
	          }, error));
	        }
	        return results;
	      })()) : void 0);
	    }
	  }
	});


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(26);
	
	styles += "[data-widget=\"EditPage\"] .input_group {\n  margin: 36px 0;\n}\n[data-widget=\"EditPage\"] .input_group fieldset {\n  padding-left: 30px;\n}\n[data-widget=\"EditPage\"] .radio_group {\n  margin-top: 16px;\n  margin-left: 0px;\n}\n[data-widget=\"EditPage\"] .field_explanation {\n  font-size: 14px;\n  margin-top: 6px;\n  color: #444;\n}\n\n[data-widget=\"EditPage\"] .radio_group label {\n}\n\n\n[data-widget=\"EditPage\"] .draggable-list {\n  padding: 12px 24px 24px 12px;\n  margin: 12px 0; \n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n\n[data-widget=\"EditPage\"] [data-widget=\"NewList\"] {\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n\n[data-widget=\"EditPage\"] .draggable-list[draggable=\"true\"] {\n  cursor: move;\n}\n\n[data-widget=\"EditPage\"] .draggable-list.dragging {\n  height: 6px;\n  padding: 0;\n  border: none;\n}\n\n[data-widget=\"EditPage\"] .draggable-list.dragging * {\n  display: none;\n}\n\n\n[data-widget=\"EditPage\"] .draggable-wrapper::after, [data-widget=\"EditPage\"] .draggable-wrapper::before {\n  // border: 2px dotted #888;\n  border-radius: 16px;\n  // padding-bottom: 60px;\n  height: 0px;\n  display: block;\n  content: \"\";\n  margin: 0;\n  transition: height 1s;\n}\n\n[data-widget=\"EditPage\"] .draggable-wrapper.draggedOver.from_above::after, [data-widget=\"EditPage\"] .draggable-wrapper.draggedOver.from_below::before {\n  height: 60px;\n  outline: 1px dotted #888;\n\n}\n\n\n[data-widget=\"EditPage\"] .wildcard .draggable-list {\n  background-color: #E3EDE0;\n  border: 1px solid #CEDACA;\n}\n\n[data-widget=\"EditPage\"] .draggable-list button {\n  flex-shrink: 0;\n  flex-grow: 0;\n  display: inline-block;\n  background-color: transparent;\n  border: none;\n}\n[data-widget=\"EditPage\"] .draggable-list .LIST-title {\n  /* font-size: 16px; \n  font-weight: 500; */\n  padding-left: 24px;\n  flex-grow: 1;\n}\n\n[data-widget=\"EditPage\"] H2.list_header {\n  font-size: 22px;\n}\n[data-widget=\"EditPage\"] button.add_new_list {\n  border: none;\n  background-color: transparent;\n  margin-top: 12px;\n  padding: 8px 16px;\n  font-size: 24px;\n  margin-left: 26px;\n}\n\n[data-widget=\"EditPage\"] button.convert_page {\n  padding: 8px 16px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  margin-top: 12px;\n}\n\n[data-widget=\"EditPage\"] .action_explanation {\n  font-size: 14px;\n  margin-top: 3px;\n}\n\n.not-editing.draggable-source--is-dragging {\n  opacity: .5;\n}\n\n.not-editing.draggable-mirror {\n  z-index: 99999;\n  background-color: rgba(255,255,255,.7) !important;\n}\n\n\n";
	
	window.PAGE_TYPES = {
	  ABOUT: 'about',
	  ALL: 'all',
	  DEFAULT: 'default'
	};
	
	window.EditPage = ReactiveComponent({
	  displayName: "EditPage",
	  mixins: [SubdomainSaveRateLimiter],
	  drawAboutPage: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (this.props.page_name !== get_current_tab_name()) {
	      return DIV(null);
	    }
	    return DIV(null, I(null, "This is an About page."), this.renderPreamble(), this.renderPageType(), this.renderMakeDefaultPage());
	  },
	  drawShowAllPage: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (this.props.page_name !== get_current_tab_name()) {
	      return DIV(null);
	    }
	    return DIV(null, I(null, "This page displays all proposal lists shown on other pages throughout this forum."), this.renderSortOrder(), this.renderPreamble(), this.renderPageType(), this.renderMakeDefaultPage());
	  },
	  drawDefaultPage: function() {
	    var base, current_list_sort_method, drag_capabilities, drag_enabled, edit_forum, idx, is_a_tab, lst, ref, ref1, subdomain;
	    subdomain = fetch('/subdomain');
	    is_a_tab = !!get_tabs();
	    edit_forum = fetch("edit_forum");
	    if (is_a_tab) {
	      this.ordered_lists = (ref = get_tab(this.props.page_name)) != null ? ref.lists : void 0;
	      if (!this.ordered_lists) {
	        console.error("No lists for tab. Returning");
	        return DIV(null);
	      }
	    } else {
	      if ((base = subdomain.customizations).lists == null) {
	        base.lists = get_all_lists();
	      }
	      this.ordered_lists = subdomain.customizations.lists;
	    }
	    if (this.props.page_name !== get_current_tab_name()) {
	      return DIV(null);
	    }
	    current_list_sort_method = get_list_sort_method(this.props.page_name);
	    drag_capabilities = "";
	    if (this.ordered_lists.length > 1 && current_list_sort_method === 'fixed') {
	      drag_capabilities += "Drag lists to reorder them. ";
	    }
	    drag_enabled = ((ref1 = get_tabs()) != null ? ref1.length : void 0) > 1;
	    if (drag_enabled) {
	      drag_capabilities += "Lists can be dragged to a different tab to move them.";
	    }
	    return DIV({
	      style: {
	        position: 'relative'
	      }
	    }, DIV({
	      style: {
	        marginTop: 36,
	        marginBottom: 24
	      }
	    }, UL({
	      ref: 'draggable-list-wrapper',
	      style: {
	        marginTop: 24,
	        listStyle: 'none'
	      }
	    }, (function() {
	      var i, len, ref2, results;
	      ref2 = this.ordered_lists;
	      results = [];
	      for (idx = i = 0, len = ref2.length; i < len; idx = ++i) {
	        lst = ref2[idx];
	        results.push((function(_this) {
	          return function(lst, idx) {
	            var ag_lst, disaggregate_wildcard, lists_to_add, wildcard;
	            wildcard = lst === '*' || lst === '*-';
	            if (wildcard) {
	              lists_to_add = (function() {
	                var j, len1, ref3, results1;
	                ref3 = get_all_lists();
	                results1 = [];
	                for (j = 0, len1 = ref3.length; j < len1; j++) {
	                  ag_lst = ref3[j];
	                  if (indexOf.call(this.ordered_lists, ag_lst) < 0) {
	                    results1.push(ag_lst);
	                  }
	                }
	                return results1;
	              }).call(_this);
	            }
	            return LI({
	              key: lst,
	              "data-idx": idx,
	              "data-list-key": lst,
	              className: "draggable-wrapper " + (wildcard ? 'wildcard' : '') + " " + (lst === _this.local.edit_list ? 'editing' : 'not-editing')
	            }, lst === _this.local.edit_list ? EditNewList({
	              list: _this.local.edit_list,
	              fresh: false,
	              combines_these_lists: _this.props.combines_these_lists,
	              done_callback: function() {
	                _this.local.edit_list = false;
	                return save(_this.local);
	              }
	            }) : DIV({
	              className: "draggable-list"
	            }, drag_capabilities.length > 0 ? BUTTON({
	              "data-tooltip": drag_capabilities,
	              style: {
	                cursor: 'move',
	                position: 'relative',
	                left: 7
	              }
	            }, drag_icon(15, '#888')) : DIV({
	              style: {
	                width: 22
	              }
	            }), DIV({
	              className: 'LIST-title'
	            }, wildcard ? SPAN({
	              style: {
	                fontStyle: 'italic'
	              }
	            }, "All of the rest (" + lists_to_add.length + " total)") : get_list_title(lst, true, subdomain)), wildcard ? lists_to_add.length > 0 ? (disaggregate_wildcard = function() {
	              var j, len1;
	              for (j = 0, len1 = lists_to_add.length; j < len1; j++) {
	                ag_lst = lists_to_add[j];
	                _this.ordered_lists.splice(idx, 0, ag_lst);
	              }
	              return save(edit_forum);
	            }, BUTTON({
	              className: 'disaggregate like_link',
	              onClick: disaggregate_wildcard
	            }, 'disaggregate')) : void 0 : void 0, !wildcard ? BUTTON({
	              style: {
	                cursor: 'pointer'
	              },
	              "data-tooltip": "Edit",
	              onClick: function(e) {
	                e.preventDefault();
	                e.stopPropagation();
	                _this.local.edit_list = lst;
	                return save(_this.local);
	              }
	            }, edit_icon(18, 18, '#888')) : void 0, !wildcard ? BUTTON({
	              style: {
	                position: 'absolute',
	                right: -36,
	                cursor: 'pointer'
	              },
	              "data-tooltip": "Delete",
	              onClick: function(e) {
	                _this.ordered_lists.splice(_this.ordered_lists.indexOf(lst), 1);
	                return delete_list(lst);
	              }
	            }, trash_icon(23, 23, '#888')) : void 0));
	          };
	        })(this)(lst, idx));
	      }
	      return results;
	    }).call(this)), !this.local.edit_list ? NewList({
	      wrapper_clss: 'draggable-list'
	    }) : void 0), DIV({
	      style: {
	        marginTop: 36
	      }
	    }, !this.local.show_all_options ? BUTTON({
	      className: 'like_link',
	      style: {
	        textDecoration: 'underline',
	        fontWeight: 700,
	        color: '#666'
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          _this.local.show_all_options = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, 'Advanced settings for this page') : FIELDSET({
	      style: {
	        marginLeft: 0,
	        marginTop: 42,
	        border: "1px solid #ccc",
	        padding: "0px 48px 48px 48px",
	        borderRadius: 8
	      }
	    }, LABEL({
	      className: "main_background",
	      style: {
	        fontSize: 17,
	        marginTop: 36,
	        marginBottom: 24,
	        padding: "4px 8px",
	        position: 'relative',
	        top: -12,
	        color: '#333'
	      }
	    }, "Advanced settings for this page"), DIV(null, this.renderSortOrder(), this.renderPreamble(), this.renderPageType(), this.renderMakeDefaultPage()))));
	  },
	  renderPageType: function() {
	    var is_a_tab, option, page_types;
	    is_a_tab = !!get_tabs();
	    if (!is_a_tab) {
	      return SPAN(null);
	    }
	    page_types = [
	      {
	        id: PAGE_TYPES.DEFAULT,
	        label: "Standard page",
	        description: "Displays the proposal lists configured above."
	      }, {
	        id: PAGE_TYPES.ABOUT,
	        label: 'Background page',
	        description: "Give supplementary background information about the engagement."
	      }, {
	        id: PAGE_TYPES.ALL,
	        label: '"Show all" page',
	        description: "Aggregate and show all proposal lists from other pages."
	      }
	    ];
	    return DIV({
	      className: 'FORUM_SETTINGS_section input_group'
	    }, B({
	      style: {
	        fontSize: 17
	      }
	    }, 'This page is a...'), DIV({
	      className: 'explanation'
	    }, "        "), FIELDSET(null, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = page_types.length; i < len; i++) {
	        option = page_types[i];
	        results.push(DIV({
	          key: option.id
	        }, DIV({
	          className: 'radio_group',
	          style: {
	            cursor: 'pointer'
	          },
	          onChange: (function(_this) {
	            return function(option) {
	              return function(ev) {
	                var idx, j, l, len1, ref, ref1;
	                if (_this.ordered_lists == null) {
	                  _this.ordered_lists = (ref = get_tab(_this.props.page_name)) != null ? ref.lists : void 0;
	                }
	                if (option.id === PAGE_TYPES.DEFAULT) {
	                  _this.local.type = PAGE_TYPES.DEFAULT;
	                  idx = _this.ordered_lists.indexOf('*');
	                  if (idx > -1) {
	                    if (_this.ordered_lists.length > 1) {
	                      _this.ordered_lists.splice(idx, 1);
	                    } else {
	                      _this.ordered_lists.splice(0, _this.ordered_lists.length);
	                      ref1 = get_all_lists_not_configured_for_a_page();
	                      for (j = 0, len1 = ref1.length; j < len1; j++) {
	                        l = ref1[j];
	                        _this.ordered_lists.push(l);
	                      }
	                    }
	                  }
	                } else {
	                  if (_this.ordered_lists.length === 0 || confirm("Are you sure you want to convert this page? You may want to move the existing lists to a different page first. You can do that by dragging them to a different tab above.")) {
	                    _this.ordered_lists.splice(0, _this.ordered_lists.length);
	                    if (option.id === PAGE_TYPES.ALL) {
	                      _this.ordered_lists.push('*');
	                    }
	                    _this.local.type = option.id;
	                  }
	                }
	                return save(_this.local);
	              };
	            };
	          })(this)(option)
	        }, INPUT({
	          style: {
	            cursor: 'pointer'
	          },
	          type: 'radio',
	          name: "page_type",
	          id: "page_type" + option.id,
	          defaultChecked: this.local.type === option.id
	        }), LABEL({
	          style: {
	            cursor: 'pointer',
	            display: 'block'
	          },
	          htmlFor: "page_type" + option.id
	        }, option.label)), option.description ? DIV({
	          className: 'explanation field_explanation'
	        }, option.description) : void 0));
	      }
	      return results;
	    }).call(this)));
	  },
	  renderSortOrder: function() {
	    var current_list_sort_method, groups_sorts, list_orderings, option;
	    current_list_sort_method = get_list_sort_method(this.props.page_name);
	    groups_sorts = {
	      newest: {
	        value: 'newest_item',
	        label: 'By most recent activity',
	        explanation: 'The proposal lists with the most recent activity are shown first.'
	      },
	      randomized: {
	        value: 'randomized',
	        label: 'Randomized',
	        explanation: 'Proposal lists are show in a random order on page load.'
	      },
	      fixed: {
	        value: 'fixed',
	        label: 'Fixed order',
	        explanation: 'Proposal lists will be ordered as specified above.'
	      },
	      fixed_by_tab: {
	        value: 'by_tab',
	        label: 'Fixed order',
	        explanation: 'Proposal lists ordered as they are in the other pages.'
	      }
	    };
	    if (this.local.type === PAGE_TYPES.DEFAULT) {
	      list_orderings = [groups_sorts.fixed, groups_sorts.newest, groups_sorts.randomized];
	    } else if (this.local.type === PAGE_TYPES.ALL) {
	      list_orderings = [groups_sorts.fixed_by_tab, groups_sorts.newest, groups_sorts.randomized];
	    } else {
	      list_orderings = null;
	    }
	    return FIELDSET({
	      style: {
	        marginLeft: 0,
	        marginTop: 32
	      }
	    }, LABEL({
	      style: {
	        fontSize: 17,
	        fontWeight: 700
	      }
	    }, "Order of the proposal lists" + (this.local.type !== PAGE_TYPES.ALL ? " defined above" : '')), SELECT({
	      defaultValue: current_list_sort_method,
	      style: {
	        fontSize: 18,
	        display: 'block',
	        marginTop: 4
	      },
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.list_sort_method = e.target.value;
	          return save(_this.local);
	        };
	      })(this)
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = list_orderings.length; i < len; i++) {
	        option = list_orderings[i];
	        results.push(OPTION({
	          key: option.value,
	          value: option.value
	        }, option.label));
	      }
	      return results;
	    })()), (function() {
	      var i, len, results;
	      if (option.explanation) {
	        results = [];
	        for (i = 0, len = list_orderings.length; i < len; i++) {
	          option = list_orderings[i];
	          if (option.value === (this.local.list_sort_method || current_list_sort_method)) {
	            results.push(DIV({
	              key: option.value,
	              className: 'explanation field_explanation'
	            }, option.explanation));
	          } else {
	            results.push(void 0);
	          }
	        }
	        return results;
	      }
	    }).call(this));
	  },
	  renderPreamble: function() {
	    var current_preamble, preamble_text;
	    current_preamble = get_page_preamble(this.props.page_name);
	    preamble_text = fetch(this.props.page_name + "-preamble");
	    if ((preamble_text.html != null) && preamble_text.html !== this.local.page_preamble) {
	      this.local.page_preamble = preamble_text.html;
	      save(this.local);
	    }
	    return FIELDSET({
	      style: {
	        marginTop: 36
	      }
	    }, B({
	      style: {
	        display: 'inline-block',
	        fontSize: 17
	      }
	    }, this.local.type === PAGE_TYPES.ABOUT ? "Background Information" : "Preamble"), SPAN({
	      style: {
	        fontSize: 14,
	        fontWeight: 400,
	        paddingLeft: 6
	      }
	    }, "optional"), WysiwygEditor({
	      key: this.props.page_name + "-preamble",
	      editor_key: this.props.page_name + "-preamble",
	      horizontal: true,
	      html: current_preamble,
	      allow_html: true,
	      toolbar_style: {
	        right: 0
	      },
	      container_style: {
	        borderRadius: 8,
	        minHeight: 42,
	        width: '100%',
	        border: '1px solid #ccc',
	        marginTop: 4,
	        padding: '8px 12px',
	        backgroundColor: 'white'
	      },
	      style: {
	        fontSize: 16
	      }
	    }), DIV({
	      className: 'action_explanation'
	    }, this.local.type !== PAGE_TYPES.ABOUT ? "The preamble is displayed at the top of the page. " : void 0, SPAN({
	      dangerouslySetInnerHTML: {
	        __html: "To use HTML, click <span class='monospaced'>&lt;/&gt;</span> in the upper right. \n<span class='monospaced'>&lt;script&gt;</span>, <span class='monospaced'>&lt;iframe&gt;</span> and \n<span class='monospaced'>&lt;style&gt;</span> tags are not allowed. \nUse inline styles instead."
	      }
	    }), this.local.type === PAGE_TYPES.ABOUT ? " If you need to embed a video, please contact help@consider.it." : void 0));
	  },
	  renderMakeDefaultPage: function() {
	    var default_tab, ref, tab;
	    default_tab = customization('homepage_default_tab');
	    if (!get_tabs()) {
	      return SPAN(null);
	    }
	    return DIV(null, FIELDSET({
	      style: {
	        marginLeft: 0,
	        marginTop: 32
	      }
	    }, LABEL({
	      style: {
	        fontSize: 17,
	        marginTop: 36,
	        fontWeight: 700,
	        marginRight: 12,
	        marginBottom: 6,
	        display: 'block'
	      }
	    }, "Default landing page"), SELECT({
	      defaultValue: default_tab,
	      style: {
	        fontSize: 18,
	        display: 'block'
	      },
	      onChange: (function(_this) {
	        return function(e) {
	          var subdomain;
	          subdomain = fetch('/subdomain');
	          subdomain.customizations.homepage_default_tab = e.target.value;
	          return save(subdomain);
	        };
	      })(this)
	    }, (function() {
	      var i, len, ref, results;
	      ref = get_tabs();
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        tab = ref[i];
	        results.push(OPTION({
	          key: tab.name,
	          value: tab.name
	        }, tab.name));
	      }
	      return results;
	    })()), DIV({
	      className: 'explanation field_explanation'
	    }, "When someone arrives at " + location.origin + " they will be shown the '" + (default_tab || ((ref = get_tabs()[0]) != null ? ref.name : void 0)) + "' page by default.")));
	  },
	  render: function() {
	    var base, ref;
	    if ((base = this.local).type == null) {
	      base.type = ((ref = get_tab(this.props.page_name)) != null ? ref.type : void 0) || PAGE_TYPES.DEFAULT;
	    }
	    console.assert(!get_tabs() || this.props.page_name, this.props.page_name, this.local);
	    if (this.local.type === PAGE_TYPES.DEFAULT) {
	      return this.drawDefaultPage();
	    } else if (this.local.type === PAGE_TYPES.ALL) {
	      return this.drawShowAllPage();
	    } else if (this.local.type === PAGE_TYPES.ABOUT) {
	      return this.drawAboutPage();
	    }
	  },
	  saveIfChanged: function() {
	    var changed_here, config, customizations, fields;
	    customizations = fetch('/subdomain').customizations;
	    fields = ['list_sort_method', 'page_preamble'];
	    changed_here = false;
	    if (get_tabs()) {
	      config = get_tab(this.props.page_name);
	      if (!config) {
	        console.error("Config not found, can't save subdomain");
	        return;
	      }
	      if ((config.type || this.local.type !== 'default') && this.local.type !== config.type) {
	        config.type = this.local.type;
	        changed_here = true;
	      }
	    } else {
	      config = customizations;
	    }
	    if (!config) {
	      console.error("Could not find a config, and thus could not save possible page changes " + this.props.page_name);
	      return;
	    }
	    return this.save_customization_with_rate_limit({
	      fields: fields,
	      config: config,
	      force_save: changed_here
	    });
	  },
	  componentDidUpdate: function() {
	    this.makeListsDraggable();
	    return this.saveIfChanged();
	  },
	  componentDidMount: function() {
	    return this.makeListsDraggable();
	  },
	  makeListsDraggable: function() {
	    var active_page, last_mouse_over_target, reassign_list_to_page, ref, reorder_list_position;
	    active_page = this.props.page_name === get_current_tab_name();
	    if (active_page && this.lists_sortable) {
	      this.lists_sortable = false;
	      if ((ref = this.sortable) != null) {
	        ref.destroy();
	      }
	    }
	    if (!active_page || this.lists_sortable) {
	      return;
	    }
	    this.lists_sortable = true;
	    last_mouse_over_target = null;
	    reorder_list_position = (function(_this) {
	      return function(from, to) {
	        var edit_forum, moving;
	        edit_forum = fetch('edit_forum');
	        moving = _this.ordered_lists[from];
	        _this.ordered_lists.splice(from, 1);
	        _this.ordered_lists.splice(to, 0, moving);
	        save(edit_forum);
	        return save(fetch('/subdomain'));
	      };
	    })(this);
	    reassign_list_to_page = (function(_this) {
	      return function(source, target, dragging) {
	        var list_key, source_lists, subdomain, target_lists;
	        subdomain = fetch('/subdomain');
	        dragging = parseInt(dragging);
	        source_lists = get_tab(source).lists;
	        target_lists = get_tab(target).lists;
	        list_key = source_lists[dragging];
	        if (source_lists && target_lists) {
	          source_lists.splice(dragging, 1);
	          if (target_lists.indexOf(list_key) === -1) {
	            target_lists.push(list_key);
	          }
	          return save(subdomain);
	        } else {
	          return console.error("Could not move list " + list_key + " from " + source + " to " + target);
	        }
	      };
	    })(this);
	    this.sortable = new Draggable.Sortable(this.refs['draggable-list-wrapper'], {
	      draggable: '.not-editing',
	      distance: 1
	    });
	    this.sortable.on('sortable:start', (function(_this) {
	      return function() {
	        return document.body.classList.add('dragging-list');
	      };
	    })(this));
	    this.sortable.on('drag:move', (function(_this) {
	      return function(evt) {
	        var current_target, ref1;
	        current_target = (ref1 = evt.sensorEvent.target) != null ? ref1.closest('[data-accepts-lists="true"]') : void 0;
	        if (last_mouse_over_target !== current_target) {
	          if (last_mouse_over_target) {
	            last_mouse_over_target.classList.remove('draggedOver-by_list');
	          }
	          if (current_target) {
	            current_target.classList.add('draggedOver-by_list');
	          }
	        }
	        return last_mouse_over_target = current_target;
	      };
	    })(this));
	    return this.sortable.on('sortable:stop', (function(_this) {
	      return function(arg) {
	        var data, from, to;
	        data = arg.data;
	        document.body.classList.remove('dragging-list');
	        from = data.oldIndex;
	        if (last_mouse_over_target) {
	          return reassign_list_to_page(_this.props.page_name, last_mouse_over_target.getAttribute('data-page-name'), from);
	        } else {
	          to = data.newIndex;
	          return reorder_list_position(from, to);
	        }
	      };
	    })(this));
	  },
	  componentWillUnmount: function() {
	    if (this.lists_sortable) {
	      this.lists_sortable = false;
	      return this.sortable.destroy();
	    }
	  }
	});


/***/ },
/* 67 */
/***/ function(module, exports) {

	window.EditPoint = ReactiveComponent({
	  displayName: 'EditPoint',
	  render: function() {
	    var error, opinion, point, proposal, ref, style, textarea_style;
	    proposal = fetch(this.props.proposal);
	    point = fetch(this.props.point);
	    opinion = proposal.your_opinion;
	    if (typeof opinion === 'string' || opinion.key) {
	      opinion = fetch(opinion);
	    }
	    if (this.local.sign_name == null) {
	      _.defaults(this.local, {
	        sign_name: !opinion.hide_name,
	        add_details: false
	      });
	    }
	    textarea_style = {
	      width: '100%',
	      overflow: 'hidden',
	      fontSize: 14,
	      padding: '4px 6px'
	    };
	    style = {
	      position: 'relative',
	      fontSize: 14,
	      zIndex: 1,
	      marginTop: TABLET_SIZE() ? 40 : void 0,
	      marginBottom: 15
	    };
	    return DIV({
	      className: 'edit_point',
	      style: style,
	      'aria-describedby': 'tips_for_new_point'
	    }, DIV({
	      style: {
	        position: 'relative'
	      }
	    }, this.drawTips(), CharacterCountTextInput({
	      id: 'nutshell',
	      ref: 'nutshell',
	      maxLength: 180,
	      name: 'nutshell',
	      pattern: '^.{3,}',
	      'aria-label': translator('engage.point_summary_placeholder', 'A succinct summary of your point.'),
	      placeholder: translator('engage.point_summary_placeholder', 'A succinct summary of your point.'),
	      required: 'required',
	      defaultValue: this.props.fresh ? null : point.nutshell,
	      style: _.extend({}, textarea_style, {
	        minHeight: 75
	      }),
	      count_style: {
	        position: 'absolute',
	        right: 0,
	        top: -21
	      }
	    }), INPUT({
	      id: 'is_pro',
	      name: 'is_pro',
	      type: 'hidden',
	      value: "" + (this.props.valence === 'pros')
	    })), DIV(null, AutoGrowTextArea({
	      id: 'text',
	      name: 'fulltext',
	      'aria-label': translator('engage.point_description_placeholder', 'Add background or evidence.'),
	      placeholder: translator('engage.point_description_placeholder', 'Add background or evidence.'),
	      min_height: 80,
	      defaultValue: this.props.fresh ? null : point.text,
	      style: textarea_style,
	      onHeightChange: (function(_this) {
	        return function() {
	          var s;
	          s = fetch('reasons_height_adjustment');
	          s.edit_point_height = $$.height(ReactDOM.findDOMNode(_this));
	          return save(s);
	        };
	      })(this)
	    })), ((ref = this.local.errors) != null ? ref.length : void 0) > 0 ? DIV({
	      role: 'alert',
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10
	      }
	    }, (function() {
	      var i, len, ref1, results;
	      ref1 = this.local.errors;
	      results = [];
	      for (i = 0, len = ref1.length; i < len; i++) {
	        error = ref1[i];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    }).call(this)) : void 0, DIV({
	      style: {
	        marginTop: 3,
	        marginBottom: '.5em'
	      }
	    }, !proposal.active ? DIV({
	      style: {
	        color: '#777',
	        fontSize: 12
	      }
	    }, translator('engage.no_new_points', 'New points disabled for this proposal')) : BUTTON({
	      className: 'btn',
	      ref: 'submit_point',
	      'data-action': 'submit-point',
	      onClick: this.savePoint,
	      style: {
	        backgroundColor: focus_color()
	      }
	    }, translator('engage.done_button', 'Done')), BUTTON({
	      onTouchEnd: this.done,
	      onClick: this.done,
	      className: 'like_link',
	      style: {
	        color: '#888888',
	        top: 2,
	        marginLeft: 10,
	        position: 'relative',
	        padding: 0
	      }
	    }, translator('shared.cancel_button', 'cancel')), DIV({
	      style: {
	        clear: 'both'
	      }
	    })), proposal.active ? DIV({
	      style: {
	        position: 'relative'
	      }
	    }, opinion.hide_name || customization('anonymize_permanently') ? DIV({
	      style: {
	        color: focus_color()
	      }
	    }, translator('engage.post_anonymously', 'Posting anonymously')) : DIV({
	      style: {
	        display: 'flex'
	      }
	    }, INPUT({
	      className: 'newpoint-anonymous',
	      type: 'checkbox',
	      id: "sign_name-" + this.props.valence,
	      name: "sign_name-" + this.props.valence,
	      checked: !this.local.sign_name,
	      style: {
	        verticalAlign: 'middle',
	        marginRight: 8
	      },
	      onChange: (function(_this) {
	        return function() {
	          if (!_this.local.sign_name || confirm(translator('This will anonymize your whole opinion about this proposal, including your icon in the histogram and all pros and cons you have written. Are you sure you wish to anonymize?'))) {
	            _this.local.sign_name = !_this.local.sign_name;
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }), LABEL({
	      htmlFor: "sign_name-" + this.props.valence
	    }, your_opinion_i18n.anonymize_opinion_button()))) : void 0);
	  },
	  componentDidMount: function() {
	    var proposal, s;
	    proposal = fetch(this.props.proposal);
	    if (proposal.active) {
	      ReactDOM.findDOMNode(this.refs.nutshell).querySelector('#nutshell').focus();
	      $$.ensureInView(ReactDOM.findDOMNode(this.refs.submit_point), {
	        scroll: false,
	        position: 'bottom'
	      });
	      s = fetch('reasons_height_adjustment');
	      s.edit_point_height = $$.height(ReactDOM.findDOMNode(this));
	      return save(s);
	    }
	  },
	  componentWillUnmount: function() {
	    var s;
	    s = fetch('reasons_height_adjustment');
	    s.edit_point_height = 0;
	    return save(s);
	  },
	  drawTips: function() {
	    var plural, proposal, singular;
	    proposal = fetch(this.props.proposal);
	    singular = this.props.valence === 'pros' ? get_point_label('pro', proposal) : get_point_label('con', proposal);
	    plural = get_point_label(this.props.valence, proposal);
	    return DIV({
	      id: 'tips_for_new_point',
	      style: {
	        position: 'absolute',
	        left: this.props.valence === 'pros' ? "calc(-100% - 4px)" : "calc(100% + 4px)",
	        width: "100%",
	        color: 'white',
	        zIndex: 1,
	        backgroundColor: focus_color()
	      }
	    }, DIV({
	      style: {
	        padding: '14px 18px',
	        position: 'relative'
	      }
	    }, SPAN({
	      style: {
	        fontWeight: 600
	      }
	    }, translator({
	      id: 'engage.write_point_header',
	      pro_or_con: capitalize(singular)
	    }, "Write a new {pro_or_con}")), UL({
	      style: {
	        listStylePosition: 'outside',
	        marginLeft: 16,
	        marginTop: 5
	      }
	    }, (function() {
	      var i, len, results, tip, tips;
	      tips = [
	        translator({
	          id: "engage.point_authoring.tip_single",
	          pros_or_cons: capitalize(plural)
	        }, "Make only one point. Add multiple {pros_or_cons} if you have more."), translator("engage.point_authoring.tip_direct", "Be direct. The summary is your main point."), translator("engage.point_authoring.tip_attacks", "No personal attacks.")
	      ];
	      results = [];
	      for (i = 0, len = tips.length; i < len; i++) {
	        tip = tips[i];
	        results.push(LI({
	          key: tip,
	          style: {
	            paddingBottom: 3
	          }
	        }, tip));
	      }
	      return results;
	    })())));
	  },
	  done: function() {
	    var your_points;
	    your_points = fetch(this.props.your_points_key);
	    if (this.props.fresh) {
	      your_points.adding_new_point = false;
	    } else {
	      your_points.editing_points = _.without(your_points.editing_points, this.props.point);
	    }
	    return save(your_points);
	  },
	  savePoint: function(ev) {
	    var current_user, form, hide_name, nutshell, point, proposal, text;
	    proposal = fetch(this.props.proposal);
	    form = ReactDOM.findDOMNode(this);
	    nutshell = form.querySelector('#nutshell').value;
	    text = form.querySelector('#text').value;
	    hide_name = !this.local.sign_name;
	    if (!this.props.fresh) {
	      point = fetch(this.props.point);
	      point.nutshell = nutshell;
	      point.text = text;
	    } else {
	      current_user = fetch('/current_user').user;
	      point = {
	        key: '/new/point',
	        is_pro: this.props.valence === 'pros',
	        user: current_user,
	        comment_count: 0,
	        includers: [current_user],
	        proposal: proposal.key,
	        nutshell: nutshell,
	        text: text
	      };
	    }
	    point.errors = [];
	    return save(point, (function(_this) {
	      return function() {
	        var opinion, ref;
	        if (((ref = point.errors) != null ? ref.length : void 0) === 0) {
	          _this.done();
	          show_flash(translator('engage.flashes.point_saved', "Your point has been saved"));
	          proposal = fetch(_this.props.proposal);
	          opinion = fetch(proposal.your_opinion);
	          if (opinion.hide_name !== hide_name) {
	            opinion.hide_name = hide_name;
	            return save(opinion);
	          }
	        } else {
	          _this.local.errors = point.errors;
	          return save(_this.local);
	        }
	      };
	    })(this));
	  }
	});


/***/ },
/* 68 */
/***/ function(module, exports) {

	styles += "[data-widget=\"EditProposal\"] #modal-body {\n\n}\n\n[data-widget=\"EditProposal\"] input:checked + .toggle_switch_circle {\n  background-color: " + focus_blue + ";\n}\n\n[data-widget=\"EditProposal\"] label:not(.toggle_switch):not(.toggle_label){\n  font-size: 20px;\n  font-weight: 600;\n  padding-right: 24px;\n  display: inline-block;\n  color: " + focus_blue + ";\n  margin-bottom: 3px;\n  text-transform: capitalize;\n}\n\n[data-widget=\"EditProposal\"] .toggle_label {\n  padding-left: 18px;\n  color: " + focus_blue + ";\n  font-weight: 600;\n  font-size: 18px;\n}\n\n[data-widget=\"EditProposal\"] .block{\n  padding: 2px 0;\n  margin-bottom: 24px;\n  position: relative;\n}\n\n[data-widget=\"EditProposal\"] form {\n  margin-top: 8px;\n}";
	
	window.EditProposal = ReactiveComponent({
	  displayName: 'EditProposal',
	  mixins: [Modal],
	  render: function() {
	    var available_lists, category, current_user, description_field_style, error, explanation_style, input_style, list_key, loc, local, operation_style, permitted, proposal, ref, subdomain;
	    current_user = fetch('/current_user');
	    proposal = fetch(this.props.proposal);
	    subdomain = fetch('/subdomain');
	    permitted = this.props.fresh ? permit('create proposal') : permit('update proposal', proposal);
	    if (permitted < 0) {
	      recourse(permitted, 'To participate,');
	      return DIV(null);
	    }
	    description_field_style = {
	      fontSize: 18,
	      width: '100%',
	      padding: 12,
	      marginBottom: 8,
	      border: '1px solid #ccc'
	    };
	    input_style = _.extend({}, description_field_style, {
	      display: 'block'
	    });
	    operation_style = {
	      color: '#aaa',
	      textDecoration: 'underline',
	      fontSize: 14,
	      cursor: 'pointer',
	      display: 'block',
	      backgroundColor: 'transparent',
	      padding: 0,
	      border: 'none'
	    };
	    explanation_style = {
	      fontSize: 16,
	      color: '#333',
	      marginBottom: 6
	    };
	    if (this.props.fresh) {
	      loc = fetch('location');
	      category = loc.query_params.category || '';
	    } else {
	      category = proposal.cluster;
	    }
	    available_lists = lists_current_user_can_add_to(get_all_lists());
	    local = this.local;
	    return wrap_in_modal(HOMEPAGE_WIDTH(), this.props.done_callback, DIV(null, DIV({
	      style: {
	        position: 'relative'
	      }
	    }, DIV({
	      className: 'block'
	    }, LABEL({
	      htmlFor: 'name'
	    }, translator("engage.edit_proposal.summary_label", "Summary")), INPUT({
	      id: 'name',
	      name: 'name',
	      pattern: '^.{3,}',
	      placeholder: translator('engage.proposal_name_placeholder', 'Clear and concise summary'),
	      required: 'required',
	      defaultValue: this.props.fresh ? null : proposal.name,
	      style: input_style
	    })), DIV({
	      className: 'block'
	    }, LABEL({
	      htmlFor: "description-" + proposal.key
	    }, translator("engage.edit_proposal.description_label", "Details")), WysiwygEditor({
	      editor_key: "description-" + proposal.key,
	      style: _.extend({}, input_style, {
	        minHeight: 20
	      }),
	      html: this.props.fresh ? null : proposal.description
	    })), DIV({
	      className: 'block'
	    }, LABEL({
	      htmlFor: 'category'
	    }, translator('category')), SELECT({
	      ref: 'category',
	      id: "category",
	      name: "category",
	      style: {
	        fontSize: 16,
	        maxWidth: '100%'
	      },
	      defaultValue: category,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.category = e.target.value;
	          return save(_this.local);
	        };
	      })(this)
	    }, [
	      current_user.is_admin ? [
	        OPTION({
	          key: 'new-cat',
	          style: {
	            fontStyle: 'italic'
	          },
	          value: 'new category'
	        }, 'Create new category'), OPTION({
	          key: 'nothing',
	          disabled: "disabled"
	        }, '--------')
	      ] : void 0, (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = available_lists.length; i < len; i++) {
	          list_key = available_lists[i];
	          results.push(OPTION({
	            key: list_key,
	            value: list_key.substring(5)
	          }, get_list_title(list_key, true)));
	        }
	        return results;
	      })()
	    ]), current_user.is_admin && this.local.category === 'new category' ? INPUT({
	      type: 'text',
	      ref: 'new_category',
	      style: {
	        fontSize: 16,
	        padding: '4px 6px',
	        marginTop: 4,
	        display: 'block'
	      }
	    }) : void 0), DIV({
	      className: 'block',
	      style: {
	        display: !current_user.is_admin ? 'none' : 'flex',
	        alignItems: 'center'
	      }
	    }, LABEL({
	      className: 'toggle_switch'
	    }, INPUT({
	      id: 'open_for_discussion',
	      name: 'open_for_discussion',
	      type: 'checkbox',
	      defaultChecked: this.props.fresh ? true : proposal.active
	    }), SPAN({
	      className: 'toggle_switch_circle'
	    })), LABEL({
	      className: 'toggle_label',
	      htmlFor: 'open_for_discussion'
	    }, translator("engage.edit_proposal.open_for_discussion", 'Open for discussion'))), current_user.is_admin ? FORM({
	      id: 'proposal_pic_files',
	      action: '/update_proposal_pic_hack'
	    }, DIV({
	      className: 'input_group block'
	    }, DIV(null, LABEL({
	      htmlFor: 'pic'
	    }, 'Icon'), DIV({
	      style: explanation_style
	    }, "A custom icon to associate with this proposal, rather than the author's avatar.")), INPUT({
	      id: 'pic',
	      type: 'file',
	      name: 'pic',
	      accept: "image/jpg, image/jpeg, image/pjpeg, image/png, image/x-png, image/gif, image/webp",
	      onChange: (function(_this) {
	        return function(ev) {
	          return _this.submit_pic = true;
	        };
	      })(this)
	    }))) : void 0, ((ref = this.local.errors) != null ? ref.length : void 0) > 0 ? DIV({
	      role: 'alert',
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10
	      }
	    }, (function() {
	      var i, len, ref1, results;
	      ref1 = this.local.errors;
	      results = [];
	      for (i = 0, len = ref1.length; i < len; i++) {
	        error = ref1[i];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    }).call(this)) : void 0, DIV(null, BUTTON({
	      className: 'btn',
	      style: {
	        marginTop: 35
	      },
	      onClick: this.saveProposal
	    }, this.props.fresh ? translator('Publish') : translator('Update')), BUTTON({
	      className: 'like_link',
	      style: {
	        fontSize: 20,
	        color: '#777',
	        position: 'relative',
	        top: 20,
	        marginLeft: 12
	      },
	      onClick: this.props.done_callback
	    }, translator('shared.cancel_button', 'cancel'))), this.local.file_errors ? DIV({
	      style: {
	        color: 'red'
	      }
	    }, 'Error uploading files!') : void 0)));
	  },
	  saveProposal: function() {
	    var active, after_save, category, current_user, description, name, proposal;
	    current_user = fetch('/current_user');
	    proposal = fetch(this.props.proposal);
	    name = document.getElementById("name").value;
	    description = fetch("description-" + proposal.key).html;
	    category = this.refs.category.value;
	    if (current_user.is_admin && category === 'new category') {
	      category = this.refs.new_category.value;
	    }
	    if (category === '') {
	      category = null;
	    }
	    active = document.getElementById('open_for_discussion').checked;
	    if (this.props.fresh) {
	      proposal = {
	        key: '/new/proposal',
	        name: name,
	        description: description,
	        cluster: category,
	        active: active
	      };
	    } else {
	      _.extend(proposal, {
	        cluster: category,
	        name: name,
	        description: description,
	        active: active
	      });
	    }
	    if (proposal.roles) {
	      InitializeProposalRoles(proposal);
	    }
	    proposal.errors = [];
	    this.local.errors = [];
	    save(this.local);
	    after_save = (function(_this) {
	      return function() {
	        var ref;
	        if (((ref = proposal.errors) != null ? ref.length : void 0) === 0) {
	          return _this.props.done_callback();
	        } else {
	          _this.local.errors = proposal.errors;
	          return save(_this.local);
	        }
	      };
	    })(this);
	    return save_proposal(proposal, (function(_this) {
	      return function() {
	        var form_to_upload;
	        if (_this.submit_pic) {
	          form_to_upload = document.getElementById('proposal_pic_files');
	          return ajax_submit_files_in_form({
	            form: '#proposal_pic_files',
	            type: 'PUT',
	            additional_data: {
	              authenticity_token: arest.csrf(),
	              id: proposal.id
	            },
	            success: after_save,
	            error: function() {
	              _this.local.file_errors = true;
	              return save(_this.local);
	            }
	          });
	        } else {
	          return after_save();
	        }
	      };
	    })(this));
	  }
	});
	
	window.save_proposal = function(proposal, cb) {
	  var k, stripped_proposal, v;
	  if (proposal.opinions) {
	    stripped_proposal = {};
	    for (k in proposal) {
	      v = proposal[k];
	      if (k !== 'opinions') {
	        stripped_proposal[k] = v;
	      }
	    }
	    proposal = stripped_proposal;
	  }
	  return save(proposal, cb);
	};


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var clear_flash, current_flash_message;
	
	__webpack_require__(1);
	
	styles += "#flash-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  z-index: 9999999;\n  position: fixed;\n  font-size: 15px;\n}\n#flash {\n  color: white;\n  background-color: rgba(0, 0, 0, 0.88);\n  border-radius: 3px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  cursor: default;\n  max-width: 400px;\n  display: flex;\n  font-weight: 600;\n}\n\n#flash.error {\n  background-color: rgba(216, 62, 62, 0.9);\n}\n\n#flash .flash-message {\n  padding: 8px 18px;\n  border-right: 1px solid rgba(255,255,255,.5);\n}\n\n#flash .flash-close {\n}\n\n#flash .flash-close button {\n  background-color: transparent;\n  color: white;\n  border: none;\n  padding: 8px 18px;\n}\n\n\n@keyframes flashfadein {\n  from {bottom: 0; opacity: 0;}\n  to {bottom: 12px; opacity: 1;}\n}\n\n@keyframes flashfadeout {\n  from {bottom: 12px; opacity: 1;}\n  to {bottom: 0; opacity: 0;}\n}\n\n";
	
	clear_flash = function() {
	  var flash;
	  flash = fetch('flash');
	  flash.message = flash.time = flash.args = null;
	  return save(flash);
	};
	
	window.show_flash_error = function(message, time_in_ms) {
	  if (time_in_ms == null) {
	    time_in_ms = 999999;
	  }
	  return show_flash(message, time_in_ms, {
	    error: true
	  });
	};
	
	current_flash_message = null;
	
	window.show_flash = function(message, time_in_ms, args) {
	  var flash;
	  if (time_in_ms == null) {
	    time_in_ms = 3000;
	  }
	  flash = fetch('flash');
	  flash.message = message;
	  flash.time = time_in_ms;
	  flash.args = args;
	  save(flash);
	  if (current_flash_message) {
	    clearTimeout(current_flash_message);
	  }
	  return current_flash_message = setTimeout(function() {
	    return clear_flash();
	  }, time_in_ms);
	};
	
	window.Flash = ReactiveComponent({
	  displayName: 'Flash',
	  render: function() {
	    var flash, is_error, ref;
	    flash = fetch('flash');
	    is_error = (ref = flash.args) != null ? ref.error : void 0;
	    return DIV({
	      id: "flash-container",
	      style: {
	        animation: flash.message ? "flashfadein 500ms, flashfadeout 500ms " + (flash.time - 500) + "ms" : void 0,
	        visibility: flash.message ? 'visible' : 'hidden',
	        opacity: flash.message ? 1 : 0,
	        bottom: flash.message ? 12 : 0
	      }
	    }, DIV({
	      id: 'flash',
	      className: is_error ? 'error' : void 0,
	      'aria-live': "off",
	      role: 'status',
	      tabIndex: -1
	    }, DIV({
	      className: 'flash-message',
	      dangerouslySetInnerHTML: flash.message ? {
	        __html: flash.message
	      } : void 0
	    }), DIV({
	      className: 'flash-close'
	    }, BUTTON({
	      onClick: clear_flash
	    }, 'x'))));
	  }
	});


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var big_button;
	
	__webpack_require__(1);
	
	__webpack_require__(2);
	
	window.Footer = ReactiveComponent({
	  displayName: 'Footer',
	  render: function() {
	    if (embedded_demo()) {
	      return SPAN(null);
	    }
	    return FOOTER({
	      style: {
	        position: 'relative',
	        zIndex: 0
	      }
	    }, (customization('SiteFooter') || DefaultFooter)());
	  }
	});
	
	styles += ".footer_wrapper {\n  padding: 65px 0 15px 0;\n  background-color: #4f4f4f; /* " + selected_color + "; */\n  position: relative;\n  z-index: 3;\n  color: white;\n}\n\n.Footer .primary_info {\n  margin-top: 18px;\n  margin-bottom: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.Footer .considerit-link {\n  text-decoration: underline;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.Footer .create-forum {\n  text-decoration: underline;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.Footer .more-info {\n  font-size: 12px;\n  text-align: center;\n  margin-top: 20px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;    \n}\n\n.Footer .more-info > div {\n  padding: 12px 20px;\n}\n\n@media " + NOT_PHONE_MEDIA + " {\n  .footer_wrapper {\n    padding: 65px 0 15px 0;\n  }\n\n  .Footer .primary_info {\n    flex-direction: row;\n  }\n\n  .Footer .create-forum {\n    display: inline-block;\n    padding-left: 24px;\n  }\n\n  .Footer .more-info {\n    flex-direction: row;\n  }\n\n}\n\n@media " + PHONE_MEDIA + " {\n  .footer_wrapper {\n    padding: 36px 0 15px 0;\n  }\n\n  .Footer .primary_info {\n    flex-direction: column;\n  }\n  .Footer .more-info {\n    flex-direction: column;\n  }\n  .bug_reports {\n    display: none;\n  }\n}\n";
	
	big_button = function() {
	  return {
	    backgroundColor: logo_red,
	    boxShadow: "0 1px 2px 0 rgb(0 0 0 / 50%)",
	    fontWeight: 700,
	    color: 'white',
	    padding: '6px 60px',
	    display: 'inline-block',
	    fontSize: 24,
	    border: 'none',
	    borderRadius: 12,
	    borderBottom: "1px solid black"
	  };
	};
	
	window.DefaultFooter = ReactiveComponent({
	  displayName: 'Footer',
	  render: function() {
	    var footer_bonus, separator, subdomain;
	    subdomain = fetch('/subdomain');
	    separator = SPAN({
	      style: {
	        padding: '0 6px',
	        color: '#ccc'
	      }
	    }, '|');
	    footer_bonus = customization('footer_bonus');
	    return DIV({
	      className: "Footer"
	    }, footer_bonus != null ? DIV({
	      className: 'main_background'
	    }, typeof footer_bonus === "function" ? footer_bonus() : DIV({
	      dangerouslySetInnerHTML: {
	        __html: footer_bonus
	      }
	    })) : void 0, DIV({
	      className: 'footer_wrapper'
	    }, DIV({
	      key: 'back2top',
	      dangerouslySetInnerHTML: WINDOW_WIDTH() > 760 ? {
	        __html: "<style>\n.custom-shape-divider-top-1651729272 {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    overflow: hidden;\n    line-height: 0;\n}\n\n.custom-shape-divider-top-1651729272 svg {\n    position: relative;\n    display: block;\n    width: calc(100% + 1.3px);\n    height: 75px;\n}\n\n.custom-shape-divider-top-1651729272 .shape-fill {\n    fill: " + (fetch('location').url.indexOf('/dashboard') > -1 || TABLET_SIZE() ? 'white' : main_background_color) + ";\n}\n</style>\n<div class=\"custom-shape-divider-top-1651729272\">\n    <svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 120\" preserveAspectRatio=\"none\">\n        <path d=\"M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z\" class=\"shape-fill\"></path>\n    </svg>\n</div>  "
	      } : void 0
	    }), DIV({
	      style: {
	        margin: 'auto'
	      }
	    }, DIV({
	      style: {
	        textAlign: 'center'
	      }
	    }, TechnologyByConsiderit({
	      size: PHONE_SIZE() ? 18 : 26,
	      color: 'white'
	    }), BR(null), DIV({
	      className: 'primary_info'
	    }, A({
	      className: 'considerit-link',
	      key: 'considerit-link',
	      href: 'https://github.com/Considerit/ConsiderIt',
	      target: '_blank'
	    }, "Consider.it is Open Source", IMG({
	      width: 18,
	      height: 18,
	      src: asset('product_page/github_logo_white.png'),
	      style: {
	        height: 18,
	        marginLeft: 6,
	        verticalAlign: 'middle'
	      }
	    })), A({
	      className: 'create-forum',
	      key: 'create-forum',
	      href: "https://" + (fetch('/application').base_domain)
	    }, translator({
	      id: "footer.created_your_own_forum"
	    }, 'Create your own forum')))), DIV({
	      className: 'more-info',
	      key: 'more_info'
	    }, DIV({
	      key: 'privacy & terms'
	    }, SPAN({
	      key: 'copyright'
	    }, '© Consider.it LLC. All rights reserved. '), TRANSLATE({
	      id: 'footer.policies',
	      privacy_link: {
	        component: A,
	        args: {
	          key: 'privacy_link',
	          href: '/docs/legal/privacy_policy',
	          style: {
	            textDecoration: 'underline'
	          }
	        }
	      },
	      terms_link: {
	        key: 'terms',
	        component: A,
	        args: {
	          key: 'terms_link',
	          href: '/docs/legal/terms_of_service',
	          style: {
	            textDecoration: 'underline'
	          }
	        }
	      }
	    }, "<privacy_link>Privacy</privacy_link> and <terms_link>Terms</terms_link>.")), DIV({
	      className: 'bug_reports',
	      key: 'bug reports'
	    }, TRANSLATE({
	      id: "footer.bug_reports",
	      link: {
	        component: A,
	        args: {
	          key: 'mailto',
	          style: {
	            textDecoration: 'underline'
	          },
	          href: 'mailto:help@consider.it'
	        }
	      }
	    }, "Report bugs to <link>help@consider.it</link>")), DIV({
	      className: 'region',
	      key: 'region'
	    }, translator('server.region_hosted', "Hosted in"), " ", get_region_name())), !customization('google_translate_style') || fetch('location').url !== '/' ? DIV({
	      className: 'google-translate-candidate-container'
	    }) : void 0)));
	  }
	});
	
	__webpack_require__(20);
	
	window.TechnologyByConsiderit = ReactiveComponent({
	  displayName: 'TechnologyByConsiderit',
	  render: function() {
	    var color, size;
	    size = this.props.size || 20;
	    color = this.props.color || logo_red;
	    return DIV({
	      style: {
	        textAlign: 'left',
	        display: 'inline-block',
	        fontSize: size
	      }
	    }, "Technology by ", A({
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.hover = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.hover = false;
	          return save(_this.local);
	        };
	      })(this),
	      href: "https://" + (fetch('/application').base_domain),
	      target: '_blank',
	      title: 'Consider.it\'s homepage',
	      style: {
	        position: 'relative',
	        top: 6,
	        left: 3
	      }
	    }, drawLogo({
	      height: size + 5,
	      main_text_color: color,
	      o_text_color: color,
	      clip: false,
	      draw_line: true,
	      line_color: color,
	      i_dot_x: this.local.hover ? 252 : 142,
	      transition: true
	    })));
	  }
	});


/***/ },
/* 71 */
/***/ function(module, exports) {

	styles += ".google-translate-candidate-container {\n  height: 25px;\n  min-width: 190px;\n}\n.translation_consent {\n  white-space: nowrap;\n  border-radius: 8px;\n  border: none;\n  padding: 4px 12px;\n  font-size: 14px;\n  box-shadow: 0 1px 3px rgb(0 0 0 / 60%);    \n}";
	
	window.GoogleTranslate = ReactiveComponent({
	  displayName: 'GoogleTranslate',
	  render: function() {
	    var base, s, style;
	    if (embedded_demo() || customization('disable_google_translate')) {
	      return SPAN(null);
	    }
	    style = customization('google_translate_style') && is_a_dialogue_page() ? (s = JSON.parse(JSON.stringify(customization('google_translate_style'))), s.prominent ? delete s.prominent : void 0, s.callout ? delete s.callout : void 0, s) : _.defaults({}, this.props.style, {
	      textAlign: 'center'
	    });
	    if ((base = this.local).left == null) {
	      base.left = -9999;
	    }
	    return DIV({
	      style: {
	        position: 'absolute',
	        left: this.local.left,
	        top: this.local.top,
	        zIndex: 9
	      }
	    }, STYLE({
	      dangerouslySetInnerHTML: {
	        __html: ""
	      }
	    }), DIV({
	      key: "google_translate_element_" + this.local.key,
	      id: "google_translate_element_" + this.local.key,
	      ref: 'translation_el',
	      style: style
	    }, !this.local.show_google_translate ? BUTTON({
	      className: 'translation_consent',
	      onClick: (function(_this) {
	        return function() {
	          var confirmation;
	          confirmation = "Loading Google Translate will add third-party cookies to facilitate the language translation. Press Ok if you consent.\r\n\r\n\nCargar Google Translate agregará cookies de terceros para facilitar la traducción del idioma. Presiona Ok si estás de acuerdo.\r\n \r\n\nLe chargement de Google Traduction ajoutera des cookies tiers pour faciliter la traduction de la langue. Appuyez sur OK si vous êtes d'accord.";
	          if (confirm(translator("translation.google_translate_consent", confirmation))) {
	            _this.local.show_google_translate = true;
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }, translator("translation.enable_language_translation", "Load Language Translator")) : void 0));
	  },
	  downloadGoogleTranslate: function() {
	    return lazyLoadJavascript("https://translate.google.com/translate_a/element.js", {
	      onload: (function(_this) {
	        return function() {
	          return _this.int = setInterval(function() {
	            var ref;
	            if ((typeof google !== "undefined" && google !== null ? (ref = google.translate) != null ? ref.TranslateElement : void 0 : void 0) != null) {
	              _this.insertTranslationWidget();
	              _this.setPosition();
	              return clearInterval(_this.int);
	            }
	          }, 20);
	        };
	      })(this)
	    });
	  },
	  insertTranslationWidget: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    return new google.translate.TranslateElement({
	      pageLanguage: subdomain.lang,
	      layout: google.translate.TranslateElement.InlineLayout[WINDOW_WIDTH() < 1180 ? 'VERTICAL' : 'SIMPLE'],
	      multilanguagePage: true
	    }, "google_translate_element_" + this.local.key);
	  },
	  setPosition: function() {
	    var observer, ref, set_coords, translate_el, wrapper;
	    wrapper = document.querySelector('.google-translate-candidate-container');
	    translate_el = typeof google !== "undefined" && google !== null ? (ref = google.translate) != null ? ref.TranslateElement : void 0 : void 0;
	    if (!wrapper || customization('disable_google_translate')) {
	      return;
	    }
	    set_coords = (function(_this) {
	      return function(coords) {
	        var left, top;
	        left = coords.left + coords.width / 2 - _this.refs.translation_el.clientWidth / 2;
	        top = coords.top;
	        if (document.body.style.top === "40px") {
	          top -= 40;
	        }
	        if (_this.local.left !== left || top !== _this.local.top) {
	          _this.local.left = left;
	          _this.local.top = top;
	          return save(_this.local);
	        }
	      };
	    })(this);
	    observer = new IntersectionObserver((function(_this) {
	      return function(entries) {
	        var coords, entry, i, len;
	        for (i = 0, len = entries.length; i < len; i++) {
	          entry = entries[i];
	          coords = entry.boundingClientRect;
	          coords.left += window.pageXOffset;
	          coords.top += window.pageYOffset;
	          set_coords({
	            left: coords.left + window.pageXOffset,
	            top: coords.top + window.pageYOffset,
	            width: coords.width
	          });
	        }
	        return observer.disconnect();
	      };
	    })(this));
	    return observer.observe(wrapper);
	  },
	  componentDidMount: function() {
	    if (customization('disable_google_translate')) {
	      return;
	    }
	    return this.placer_int = setInterval((function(_this) {
	      return function() {
	        return requestAnimationFrame(_this.setPosition);
	      };
	    })(this), 500);
	  },
	  componentDidUpdate: function() {
	    if (customization('disable_google_translate')) {
	      return;
	    }
	    if (this.local.show_google_translate && !this.translate_loaded) {
	      this.translate_loaded = true;
	      return this.downloadGoogleTranslate();
	    }
	  },
	  componentWillUnmount: function() {
	    if (this.int || this.placer_int) {
	      clearInterval(this.int);
	      return clearInterval(this.placer_int);
	    }
	  }
	});


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(78);
	
	__webpack_require__(2);
	
	__webpack_require__(48);
	
	window.Header = ReactiveComponent({
	  displayName: 'Header',
	  render: function() {
	    var current_user, header_bonus, homepage, light_bg, loc, ref, ref1, ref2, ref3, root, subdomain;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    root = fetch('root');
	    if (!subdomain.name) {
	      return SPAN(null);
	    }
	    loc = fetch('location');
	    homepage = is_a_dialogue_page();
	    light_bg = is_light_background();
	    header_bonus = customization('header_bonus');
	    return HEADER({
	      style: {
	        position: 'relative',
	        zIndex: fetch('edit_forum').editing ? 1 : void 0
	      },
	      className: !light_bg ? 'dark' : void 0
	    }, current_user.is_admin ? HostHeader() : void 0, header_bonus != null ? typeof header_bonus === "function" ? header_bonus() : DIV({
	      dangerouslySetInnerHTML: {
	        __html: header_bonus
	      }
	    }) : void 0, DIV({
	      style: {
	        margin: '0 auto',
	        position: 'relative'
	      }
	    }, ProfileMenu(), customization('google_translate_style') && !customization('google_translate_style').prominent && is_a_dialogue_page() ? DIV({
	      className: 'google-translate-candidate-container',
	      style: {
	        position: 'absolute',
	        left: 40,
	        zIndex: 2
	      }
	    }) : void 0, homepage ? EditBanner() : void 0, homepage ? (customization('HomepageHeader') || customization('SiteHeader') || PhotoBanner).apply(this) : ShortHeader({
	      background: 'white',
	      text: '',
	      logo_src: false
	    }), homepage && ((ref = subdomain.customizations) != null ? (ref1 = ref.banner) != null ? ref1.masthead_copyright_notice : void 0 : void 0) ? DIV({
	      style: {
	        position: 'absolute',
	        right: 4,
	        bottom: 4,
	        color: light_bg ? 'black' : 'white',
	        fontSize: 14
	      },
	      target: '_blank',
	      dangerouslySetInnerHTML: {
	        __html: (ref2 = subdomain.customizations) != null ? (ref3 = ref2.banner) != null ? ref3.masthead_copyright_notice : void 0 : void 0
	      }
	    }) : void 0, DIV({
	      style: {
	        backgroundColor: '#eee',
	        color: '#f00',
	        padding: '5px 20px',
	        display: root.server_error ? 'block' : 'none'
	      }
	    }, translator("engage.server_error", 'Warning: there was a server error!'))));
	  }
	});
	
	window.HostHeader = ReactiveComponent({
	  displayName: 'HostHeader',
	  render: function() {
	    var edit_forum, free_forum, loc;
	    loc = fetch('location');
	    edit_forum = fetch('edit_forum');
	    free_forum = permit('configure paid feature') < 0;
	    if (edit_forum.editing) {
	      return DIV({
	        className: 'forum_editor fixed',
	        style: {
	          padding: 8,
	          textAlign: 'center'
	        }
	      }, (window.UpgradeForumCompact != null) && free_forum ? UpgradeForumCompact() : void 0, EditForum());
	    } else if (loc.url.startsWith('/dashboard') && (window.UpgradeForumBanner != null) && free_forum) {
	      return DIV({
	        className: 'forum_editor not-fixed'
	      }, UpgradeForumBanner());
	    } else {
	      return DIV(null);
	    }
	  }
	});


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	
	__webpack_require__(2);
	
	__webpack_require__(43);
	
	__webpack_require__(3);
	
	__webpack_require__(4);
	
	__webpack_require__(47);
	
	__webpack_require__(21);
	
	__webpack_require__(4);
	
	__webpack_require__(75);
	
	__webpack_require__(25);
	
	__webpack_require__(26);
	
	styles += "\n#homepagetab {\n  position: relative;    \n}\n\n.Homepage {\n  overflow: hidden;\n}\n\n@media " + LAPTOP_MEDIA + " {\n  .main_background {\n    background-color: " + main_background_color + ";\n  }\n  #homepagetab {\n    width: calc(var(--HOMEPAGE_WIDTH) + var(--LIST_PADDING_RIGHT) + var(--LIST_PADDING_LEFT));\n    padding: 24px 0px 140px 0;\n    margin: 0px auto;\n  }\n\n  .embedded-demo #homepagetab {\n    padding-top: 0;\n  }\n\n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .main_background {\n    background-color: white;\n  }\n}\n\n\n@media " + TABLET_MEDIA + " {\n  :root {\n    --homepagetab_left_padding: 0px; /* 20px; */\n  }\n  #homepagetab {\n    padding: 24px 0px 140px var(--homepagetab_left_padding);\n  }\n}\n\n\n@media " + PHONE_MEDIA + " {\n  :root {\n    --homepagetab_left_padding: 0px; /* 8px; */\n  }    \n  #homepagetab {\n    padding: 24px 0px 140px var(--homepagetab_left_padding);\n  }\n}\n\n\n.sized_for_homepage {\n  margin: auto;\n  /* width: var(--HOMEPAGE_WIDTH); */\n  padding: 0px var(--LIST_PADDING_RIGHT) 0px var(--LIST_PADDING_LEFT);\n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .sized_for_homepage {\n    width: var(--ITEM_TEXT_WIDTH);\n  }\n}\n\n\n";
	
	window.Homepage = ReactiveComponent({
	  displayName: 'Homepage',
	  render: function() {
	    var doc, message, messages, page, phase, preamble, proposal_editing, ref, strong_privacy, subdomain, title, tmp, weak_privacy;
	    doc = fetch('document');
	    subdomain = fetch('/subdomain');
	    if (!subdomain.name) {
	      return SPAN(null);
	    }
	    title = ((ref = customization('banner')) != null ? ref.title : void 0) || (subdomain.name + " considerit forum");
	    if (title.indexOf('<') > -1) {
	      tmp = document.createElement("DIV");
	      tmp.innerHTML = title;
	      title = tmp.textContent || tmp.innerText || title;
	    }
	    if (doc.title !== title) {
	      doc.title = title;
	      save(doc);
	    }
	    messages = [];
	    phase = customization('contribution_phase');
	    if (phase === 'frozen') {
	      messages.push({
	        style: {
	          backgroundColor: '#2e98c0',
	          color: 'white'
	        },
	        img: 'snowflake.png',
	        label: translator("engage.frozen_message", "The forum host has frozen this forum so no changes can be made.")
	      });
	    } else if (phase === 'ideas-only') {
	      messages.push({
	        style: {
	          backgroundColor: '#fcde04',
	          color: 'black'
	        },
	        img: 'lightning.png',
	        label: translator("engage.ideas_only_message", "The forum host has set this forum to be ideas only. No opinions for now.")
	      });
	    } else if (phase === 'opinions-only') {
	      messages.push({
	        style: {
	          backgroundColor: '#c1ccd0',
	          color: 'black'
	        },
	        img: 'magnifying_glass.png',
	        label: translator("engage.opinions_only_message", "The forum host has set this forum to be opinions only. No new ideas for now.")
	      });
	    }
	    if (customization('anonymize_everything')) {
	      if (customization('anonymize_permanently')) {
	        strong_privacy = TRANSLATE({
	          id: "engage.anonymize_permanently_message",
	          privacy_link: {
	            component: A,
	            args: {
	              key: 'privacy_link',
	              href: '/docs/legal/privacy_policy',
	              style: {
	                textDecoration: 'underline',
	                fontWeight: 400
	              }
	            }
	          },
	          b: {
	            component: B
	          }
	        }, "<b>The host has permanently anonymized this forum</b>. The forum host will never have access to the \nidentity of participants. Identity information will continue to be stored on the Consider.it server, but as always, \nwill <privacy_link>never be provided to third-parties</privacy_link>. You can delete your identity information at \nany time in your account settings.");
	        messages.push({
	          style: {
	            backgroundColor: '#d1d08d',
	            color: 'black'
	          },
	          img: 'venetian-mask.png',
	          label: strong_privacy
	        });
	      } else {
	        weak_privacy = TRANSLATE({
	          id: "engage.anonymize_message",
	          italic: {
	            component: I
	          },
	          mask: {
	            render: function() {
	              return iconAnonymousMask(16);
	            }
	          }
	        }, "The forum host has concealed the identities of others. No one except the hosts can currently see who \nis saying what <italic>at this time</italic>. To ensure your identity is never revealed, anonymize your opinion on each proposal using \nthe <mask> </mask> button.");
	        messages.push({
	          style: {
	            backgroundColor: '#b88dd1',
	            color: 'black'
	          },
	          img: 'venetian-mask.png',
	          label: weak_privacy
	        });
	      }
	    }
	    if (customization('hide_opinions')) {
	      messages.push({
	        style: {
	          backgroundColor: '#faa199',
	          color: 'black'
	        },
	        img: 'hiding.png',
	        label: translator("engage.hide_opinions_message", "The forum host has hidden the opinions of other participants for the time being.")
	      });
	    }
	    return DIV({
	      key: "homepage_" + subdomain.name,
	      className: "Homepage main_background " + (TABLET_SIZE() ? 'one-col' : '') + " " + (embedded_demo() ? 'embedded-demo' : '')
	    }, DIV({
	      id: 'homepagetab',
	      role: get_tabs() ? "tabpanel" : void 0
	    }, (function() {
	      var i, len, ref1, results;
	      if (fetch('edit_forum').editing) {
	        ref1 = get_tabs() || [
	          {
	            name: null
	          }
	        ];
	        results = [];
	        for (i = 0, len = ref1.length; i < len; i++) {
	          page = ref1[i];
	          results.push(EditPage({
	            key: (page != null ? page.name : void 0) + "-" + (!!get_tabs()),
	            page_name: page != null ? page.name : void 0
	          }));
	        }
	        return results;
	      } else {
	        return DIV(null, DIV({
	          className: 'sized_for_homepage'
	        }, customization('auth_callout') ? DIV({
	          style: {
	            marginBottom: 36
	          }
	        }, AuthCallout()) : void 0, NewForumOnBoarding(), (function() {
	          var j, len1, results1;
	          results1 = [];
	          for (j = 0, len1 = messages.length; j < len1; j++) {
	            message = messages[j];
	            results1.push(DIV({
	              key: message,
	              style: _.defaults({}, message.style || {}, {
	                backgroundColor: "rgb(184 226 187)",
	                borderRadius: 12,
	                padding: '4px 24px',
	                maxWidth: 700,
	                margin: "0 auto 16px auto",
	                fontSize: 14,
	                display: 'flex',
	                alignItems: 'center',
	                minHeight: 44
	              })
	            }, message.img ? DIV({
	              style: {
	                minWidth: 40,
	                paddingRight: 36
	              }
	            }, IMG({
	              style: {
	                maxWidth: 34
	              },
	              src: (fetch('/application').asset_host) + "/images/" + message.img
	            })) : void 0, SPAN(null, message.label)));
	          }
	          return results1;
	        })(), (preamble = get_page_preamble()) ? DIV({
	          style: {
	            marginBottom: 24
	          },
	          dangerouslySetInnerHTML: {
	            __html: preamble
	          }
	        }) : void 0), (proposal_editing = fetch('proposal_editing')).editing ? EditProposal({
	          proposal: proposal_editing.editing,
	          done_callback: (function(_this) {
	            return function(e) {
	              proposal_editing.editing = null;
	              if (proposal_editing.callback) {
	                proposal_editing.callback();
	                delete proposal_editing.callback;
	              }
	              return save(proposal_editing);
	            };
	          })(this)
	        }) : void 0, get_current_tab_view(), get_tabs() && !embedded_demo() ? DIV({
	          style: {
	            paddingTop: 68,
	            paddingRight: TABLET_SIZE() ? 36 : void 0
	          }
	        }, DIV({
	          style: {
	            textAlign: 'center',
	            color: selected_color,
	            fontWeight: 600
	          }
	        }, translator('tabs.footer_label', "Find more proposals on a different page:")), HomepageTabs({
	          go_to_hash: 'active_tab',
	          active_style: {
	            backgroundColor: '#666',
	            color: 'white'
	          },
	          tab_style: {
	            backgroundColor: 'transparent',
	            margin: 4,
	            padding: "8px 20px",
	            color: '#555'
	          }
	        })) : void 0);
	      }
	    }).call(this)));
	  },
	  typeset: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (subdomain.name === 'RANDOM2015' && !document.querySelector('.MathJax')) {
	      return MathJax.Hub.Queue(["Typeset", MathJax.Hub, ".proposal_homepage_name"]);
	    }
	  },
	  componentDidMount: function() {
	    return this.typeset();
	  },
	  componentDidUpdate: function() {
	    return this.typeset();
	  }
	});
	
	window.proposal_editor = function(proposal) {
	  var e, editor, editors;
	  editors = (function() {
	    var i, len, ref, results;
	    ref = proposal.roles.editor;
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      e = ref[i];
	      if (e !== '*') {
	        results.push(e);
	      }
	    }
	    return results;
	  })();
	  if (proposal.user) {
	    editors.push(proposal.user);
	  }
	  editor = editors.length > 0 && editors[0];
	  return editor !== '-' && editor;
	};
	
	window.TagHomepage = ReactiveComponent({
	  displayName: 'TagHomepage',
	  render: function() {
	    var aggregate_list_key, current_user, p, proposals;
	    current_user = fetch('/current_user');
	    aggregate_list_key = "list/" + (get_current_tab_name());
	    proposals = fetch('/proposals').proposals;
	    return DIV(null, List({
	      key: aggregate_list_key,
	      combines_these_lists: get_all_lists(),
	      list: {
	        key: aggregate_list_key,
	        name: aggregate_list_key,
	        proposals: proposals ? (function() {
	          var i, len, results;
	          results = [];
	          for (i = 0, len = proposals.length; i < len; i++) {
	            p = proposals[i];
	            results.push(fetch(p));
	          }
	          return results;
	        })() : void 0
	      }
	    }));
	  }
	});
	
	window.SimpleHomepage = ReactiveComponent({
	  displayName: 'SimpleHomepage',
	  render: function() {
	    var current_tab, current_user, index, list_key, lists, ref, ref1;
	    current_user = fetch('/current_user');
	    current_tab = get_current_tab_name();
	    lists = get_lists_for_page(current_tab);
	    return DIV(null, (function() {
	      var i, len, ref, results;
	      ref = lists || [];
	      results = [];
	      for (index = i = 0, len = ref.length; i < len; index = ++i) {
	        list_key = ref[index];
	        results.push(List({
	          key: list_key,
	          list: list_key
	        }));
	      }
	      return results;
	    })(), current_user.is_admin && (current_tab !== 'About' && current_tab !== 'FAQ') && ((ref = (ref1 = get_tab(current_tab)) != null ? ref1.type : void 0) !== PAGE_TYPES.ABOUT && ref !== PAGE_TYPES.ALL) ? NewList() : void 0);
	  }
	});
	
	window.ProposalsLoading = ReactiveComponent({
	  displayName: 'ProposalLoading',
	  render: function() {
	    var negative;
	    if (this.cnt == null) {
	      this.cnt = 0;
	    }
	    negative = Math.floor(this.cnt / 284) % 2 === 1;
	    return DIV({
	      style: {
	        margin: 'auto',
	        padding: '60px 0px',
	        textAlign: 'center',
	        fontStyle: 'italic',
	        fontSize: 24
	      }
	    }, DIV({
	      ref: 'wrapper',
	      style: {
	        position: 'relative',
	        top: 6,
	        left: 3
	      }
	    }, drawLogo({
	      height: 50,
	      main_text_color: logo_red,
	      o_text_color: logo_red,
	      clip: false,
	      draw_line: true,
	      line_color: logo_red,
	      i_dot_x: negative ? 284 - this.cnt % 284 : this.cnt % 284,
	      transition: false
	    })), translator("loading_indicator", "Loading...there is much to consider!"));
	  },
	  componentDidMount: function() {
	    var circle;
	    circle = this.refs.wrapper.querySelector('circle');
	    return this.int = setInterval((function(_this) {
	      return function() {
	        var negative;
	        negative = Math.floor(_this.cnt / 284) % 2 === 1;
	        circle.setAttribute('cx', negative ? 284 - _this.cnt % 284 : _this.cnt % 284);
	        return _this.cnt += 1;
	      };
	    })(this), 25);
	  },
	  componentWillUnmount: function() {
	    return clearInterval(this.int);
	  }
	});


/***/ },
/* 74 */
/***/ function(module, exports) {

	var ConfettiCelebration;
	
	styles += "#NewForumOnBoarding {\n  background: #FFFFFF;\n  box-shadow: 0 4px 6px 0 rgba(0,0,0,0.13);\n  border-radius: 0 0 8px 8px;   \n  max-width: 780px;\n  margin: 48px auto 60px auto;\n  padding: 24px 64px;\n  border-top: 14px solid " + selected_color + ";\n  position: relative;\n}\n\n\n\n#NewForumOnBoarding .header_wrapper {\n  margin-bottom: 36px;\n}\n\n#NewForumOnBoarding h1 {\n  color: " + selected_color + ";\n  font-weight: 700;\n  font-size: 26px;\n\n}\n\n#NewForumOnBoarding .header_subtitle {\n  font-size: 18px;\n  color: #5D5C5C;\n}\n\n#NewForumOnBoarding ul {\n  list-style: none;\n  padding: none;\n}\n\n#NewForumOnBoarding .onboard_item {\n  display: flex;\n  margin-bottom: 18px;\n  position: relative;\n}\n\n#NewForumOnBoarding .onboard_item .checkbox {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  border: 2px solid transparent;\n  border-radius: 50%;\n  flex-shrink: 0;\n} \n\n#NewForumOnBoarding .onboard_item.complete .checkbox {\n  border-color: #69BD8D;\n  background-color: #69BD8D;\n}\n\n#NewForumOnBoarding .onboard_item.complete .checkbox:after {\n  content: \"✓\";\n  color: white;\n  font-size: 18px;\n  position: relative;\n  top: -2px;\n  left: 3px;\n}\n\n\n\n#NewForumOnBoarding .onboard_item.incomplete .checkbox {\n  border-color: #C5C5C5;\n}\n\n#NewForumOnBoarding .onboard_item .label {\n  margin-left: 24px;\n  font-size: 17px;\n}\n\n#NewForumOnBoarding .close_checklist {\n  position: absolute;\n  right: 20px;\n  top: 10px;\n  color: " + selected_color + ";\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 20px;\n}\n\n#NewForumOnBoarding button.done_onboarding {\n  margin-top: 0px;\n  color: white;\n  background-color: " + selected_color + ";\n  border: none;\n  padding: 8px 24px;\n  font-weight: 700;\n  border-radius: 8px;\n}\n\n";
	
	window.NewForumOnBoarding = ReactiveComponent({
	  displayName: 'NewForumOnBoarding',
	  render: function() {
	    var all_lists, complete_onboarding, current_user, has_initial_list, k, list_count, onboard_item, ref, subdomain, task_one_complete, task_three_complete, task_two_complete, tasks_completed, v;
	    current_user = fetch('/current_user');
	    if (!current_user.is_admin || screencasting()) {
	      return SPAN(null);
	    }
	    subdomain = fetch('/subdomain');
	    if (subdomain.customizations.onboarding_complete) {
	      return SPAN(null);
	    }
	    has_initial_list = subdomain.customizations['list/initial'];
	    all_lists = (function() {
	      var ref, results;
	      ref = subdomain.customizations;
	      results = [];
	      for (k in ref) {
	        v = ref[k];
	        if (k.match(/list\//)) {
	          results.push(k);
	        }
	      }
	      return results;
	    })();
	    list_count = all_lists.length;
	    task_one_complete = ((ref = subdomain.customizations.banner.title) != null ? ref.length : void 0) > 0;
	    task_two_complete = !has_initial_list;
	    task_three_complete = (list_count >= 1 && !has_initial_list) || list_count >= 2;
	    tasks_completed = task_one_complete && task_two_complete && task_three_complete;
	    onboard_item = function(label, completed) {
	      return LI({
	        className: "onboard_item " + (completed ? 'complete' : 'incomplete')
	      }, SPAN({
	        className: 'checkbox',
	        "data-tooltip": !completed ? "This will be checked automatically when you complete the item" : void 0
	      }), SPAN({
	        className: 'label',
	        dangerouslySetInnerHTML: {
	          __html: label
	        }
	      }));
	    };
	    complete_onboarding = function() {
	      subdomain.customizations.onboarding_complete = true;
	      return save(subdomain);
	    };
	    return DIV({
	      id: 'NewForumOnBoarding'
	    }, BUTTON({
	      className: 'close_checklist like_link',
	      onClick: complete_onboarding
	    }, 'x'), DIV({
	      className: 'header_wrapper'
	    }, H1(null, !tasks_completed ? "Welcome to your new forum!" : "Congrats!"), DIV({
	      className: 'header_subtitle'
	    }, !tasks_completed ? 'A checklist to get started:' : "When you’re ready, you can invite your community to participate. There are also more settings \naccessible via the menu in the upper right.")), tasks_completed ? DIV(null, ConfettiCelebration(), BUTTON({
	      className: 'done_onboarding',
	      onClick: complete_onboarding
	    }, "done")) : UL(null, onboard_item("Edit the Banner to introduce people to your forum.", task_one_complete), onboard_item("Experiment with the Ice Cream question below. Delete it when you’re done.", task_two_complete), onboard_item("Create a New Focus.", task_three_complete)), DIV({
	      style: {
	        fontSize: 18,
	        color: '#5D5C5C',
	        marginTop: 36
	      }
	    }, 'Learn more about the ', A({
	      href: "https://" + (fetch('/application').base_domain) + "/tour#basics",
	      target: '_blank',
	      style: {
	        fontWeight: 400
	      }
	    }, 'lifecycle of a Consider.it forum'), '.'));
	  }
	});
	
	styles += ".confetti {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    z-index: 1000;\n    pointer-events: none;\n    top: 0;\n    left: 0;\n}\n.confetti-piece {\n    position: absolute;\n    width: 10px;\n    height: 30px;\n    background: #ffd300;\n    top: 0;\n    opacity: 0;\n}\n.confetti-piece:nth-child(1) {\n    left: 7%;\n    transform: rotate(-40deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 182ms;\n    animation-duration: 1116ms;\n}\n.confetti-piece:nth-child(2) {\n    left: 14%;\n    transform: rotate(4deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 161ms;\n    animation-duration: 1076ms;\n}\n.confetti-piece:nth-child(3) {\n    left: 21%;\n    transform: rotate(-51deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 481ms;\n    animation-duration: 1103ms;\n}\n.confetti-piece:nth-child(4) {\n    left: 28%;\n    transform: rotate(61deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 334ms;\n    animation-duration: 708ms;\n}\n.confetti-piece:nth-child(5) {\n    left: 35%;\n    transform: rotate(-52deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 302ms;\n    animation-duration: 776ms;\n}\n.confetti-piece:nth-child(6) {\n    left: 42%;\n    transform: rotate(38deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 180ms;\n    animation-duration: 1168ms;\n}\n.confetti-piece:nth-child(7) {\n    left: 49%;\n    transform: rotate(11deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 395ms;\n    animation-duration: 1200ms;\n}\n.confetti-piece:nth-child(8) {\n    left: 56%;\n    transform: rotate(49deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 14ms;\n    animation-duration: 887ms;\n}\n.confetti-piece:nth-child(9) {\n    left: 63%;\n    transform: rotate(-72deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 149ms;\n    animation-duration: 805ms;\n}\n.confetti-piece:nth-child(10) {\n    left: 70%;\n    transform: rotate(10deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 351ms;\n    animation-duration: 1059ms;\n}\n.confetti-piece:nth-child(11) {\n    left: 77%;\n    transform: rotate(4deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 307ms;\n    animation-duration: 1132ms;\n}\n.confetti-piece:nth-child(12) {\n    left: 84%;\n    transform: rotate(42deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 464ms;\n    animation-duration: 776ms;\n}\n.confetti-piece:nth-child(13) {\n    left: 91%;\n    transform: rotate(-72deg);\n    animation: makeItRain 1000ms infinite ease-out;\n    animation-delay: 429ms;\n    animation-duration: 818ms;\n}\n.confetti-piece:nth-child(odd) {\n    background: #7431e8;\n}\n.confetti-piece:nth-child(even) {\n    z-index: 1;\n}\n.confetti-piece:nth-child(4n) {\n    width: 5px;\n    height: 12px;\n    animation-duration: 2000ms;\n}\n.confetti-piece:nth-child(3n) {\n    width: 3px;\n    height: 10px;\n    animation-duration: 2500ms;\n    animation-delay: 1000ms;\n}\n.confetti-piece:nth-child(4n-7) {\n  background: red;\n}\n@keyframes makeItRain {\n    from {opacity: 0;}\n    50% {opacity: 1;}\n    to {transform: translateY(350px);}\n}\n";
	
	ConfettiCelebration = function() {
	  return DIV({
	    className: "confetti",
	    dangerouslySetInnerHTML: {
	      __html: "<div class=\"confetti-piece\"></div>\n<div class=\"confetti-piece\"></div>\n<div class=\"confetti-piece\"></div>\n<div class=\"confetti-piece\"></div>\n<div class=\"confetti-piece\"></div>\n<div class=\"confetti-piece\"></div>\n<div class=\"confetti-piece\"></div>\n<div class=\"confetti-piece\"></div>\n<div class=\"confetti-piece\"></div>\n<div class=\"confetti-piece\"></div>\n<div class=\"confetti-piece\"></div>\n<div class=\"confetti-piece\"></div>\n<div class=\"confetti-piece\"></div>"
	    }
	  });
	};


/***/ },
/* 75 */
/***/ function(module, exports) {

	styles += "button.add_new_proposal {\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  padding: 0; \n  border-radius: 8px;\n  color: white;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  margin-top: 30px;\n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  button.add_new_proposal {\n    margin-left: 0;\n  }\n}\n\n@media " + PHONE_MEDIA + " {\n  button.add_new_proposal {\n    padding: 0;\n  }\n}\n\n.feedback-for-hosts {\n  font-size: 12px;\n  color: #888;\n  font-weight: 400;\n}\n\n";
	
	window.NewProposal = ReactiveComponent({
	  displayName: 'NewProposal',
	  render: function() {
	    var adding, additional_field, available_lists, current_user, editor, error, label_style, list_key, list_name, list_state, loc, lst, needs_to_login, permitted, proposal_fields, ref, showing_proposer, w;
	    list_key = this.props.list_key;
	    list_name = list_key.substring(5);
	    list_state = fetch(list_key);
	    loc = fetch('location');
	    current_user = fetch('/current_user');
	    adding = list_state.adding_new_proposal === list_key;
	    if (this.props.combines_these_lists) {
	      available_lists = (function() {
	        var i, len, ref, results;
	        ref = lists_current_user_can_add_to(this.props.combines_these_lists);
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          lst = ref[i];
	          if (lst !== list_key) {
	            results.push(lst);
	          }
	        }
	        return results;
	      }).call(this);
	      permitted = available_lists.length;
	    } else {
	      permitted = permit('create proposal', list_key);
	    }
	    needs_to_login = permitted === Permission.NOT_LOGGED_IN;
	    permitted = permitted > 0;
	    if (!permitted && !needs_to_login) {
	      return SPAN(null);
	    }
	    if (!adding) {
	      return BUTTON({
	        name: "new_" + list_name,
	        className: 'ProposalItem add_new_proposal proposal-title-text',
	        onClick: (function(_this) {
	          return function(e) {
	            if (permitted) {
	              list_state.adding_new_proposal = list_key;
	              return save(list_state);
	            } else {
	              e.stopPropagation();
	              return reset_key('auth', {
	                form: 'create account',
	                goal: 'Introduce yourself to share a response'
	              });
	            }
	          };
	        })(this)
	      }, DIV({
	        className: 'proposal-left-spacing'
	      }), plusIcon(focus_color(), AVATAR_SIZE()), DIV({
	        className: 'proposal-avatar-spacing'
	      }), DIV({
	        style: {
	          textAlign: 'left'
	        }
	      }, SPAN({
	        className: 'proposal-title-text-inline',
	        style: {
	          color: focus_color()
	        }
	      }, permitted ? list_i18n().new_response_label(list_key) : translator("engage.login_to_add_new_proposal", 'Create an account to share a response')), current_user.is_admin ? DIV({
	        className: 'feedback-for-hosts'
	      }, customization('list_permit_new_items', list_key) ? translator('engage.anyone-can-propose', "Any registered participant can add a new proposal") : translator('engage.hosts-can-propose', "Only forum hosts can add a new proposal")) : void 0));
	    } else {
	      label_style = {
	        fontWeight: 400,
	        fontSize: 14,
	        display: 'block'
	      };
	      w = ITEM_TEXT_WIDTH();
	      showing_proposer = customization('show_proposer_icon', list_key);
	      proposal_fields = customization('new_proposal_fields', list_key)();
	      return DIV({
	        style: {
	          position: 'relative',
	          padding: '16px 0px'
	        }
	      }, customization('new_proposal_tips', list_key) ? this.drawTips(customization('new_proposal_tips', list_key)) : void 0, DIV({
	        style: {
	          display: 'flex',
	          alignItems: 'flex-start'
	        }
	      }, showing_proposer && adding ? (editor = current_user.user, Avatar({
	        key: editor,
	        user: editor,
	        img_size: 'large',
	        anonymous: this.local.hide_name,
	        style: {
	          height: PROPOSAL_AUTHOR_AVATAR_SIZE,
	          width: PROPOSAL_AUTHOR_AVATAR_SIZE,
	          marginRight: "var(--PROPOSAL_AUTHOR_AVATAR_GUTTER)",
	          borderRadius: 0,
	          backgroundColor: '#ddd',
	          flexGrow: 0,
	          flexShrink: 0
	        }
	      })) : SVG({
	        width: 8,
	        viewBox: '0 0 200 200',
	        style: {
	          marginRight: 7 + (!adding ? 6 : 0),
	          marginLeft: 6,
	          position: 'relative',
	          top: 17,
	          left: -5,
	          flexGrow: 0,
	          flexShrink: 0
	        }
	      }, CIRCLE({
	        cx: 100,
	        cy: 100,
	        r: 80,
	        fill: '#000000'
	      })), DIV({
	        style: {
	          position: 'relative',
	          display: 'inline-block'
	        }
	      }, LABEL({
	        style: _.extend({}, label_style, {
	          position: 'absolute',
	          left: 8,
	          top: -18
	        }),
	        htmlFor: list_name + "-name"
	      }, proposal_fields.name), CharacterCountTextInput({
	        id: list_name + "-name",
	        maxLength: 240,
	        name: 'name',
	        pattern: '^.{3,}',
	        'aria-label': translator("engage.edit_proposal.summary.placeholder", 'Clear and concise summary'),
	        placeholder: translator("engage.edit_proposal.summary.placeholder", 'Clear and concise summary'),
	        required: 'required',
	        focus_on_mount: true,
	        count_style: {
	          position: 'absolute',
	          right: 0,
	          top: -18,
	          fontSize: 14
	        },
	        style: {
	          fontSize: 20,
	          width: w,
	          border: "1px solid #ccc",
	          outline: 'none',
	          padding: '6px 8px',
	          fontWeight: 600,
	          color: '#000',
	          minHeight: 75,
	          resize: 'vertical'
	        }
	      }))), DIV({
	        style: {
	          position: 'relative',
	          marginLeft: showing_proposer ? "var(--AVATAR_SIZE_AND_GUTTER)" : 21,
	          width: w
	        }
	      }, DIV(null, LABEL({
	        style: _.extend({}, label_style, {
	          marginLeft: 8
	        }),
	        htmlFor: list_name + "-details"
	      }, proposal_fields.description), WysiwygEditor({
	        id: list_name + "-details",
	        editor_key: "description-new-proposal-" + list_name,
	        'aria-label': translator("engage.edit_proposal.description.placeholder", 'Add details here'),
	        container_style: {
	          padding: '6px 8px',
	          border: '1px solid #ccc'
	        },
	        style: {
	          fontSize: 16,
	          width: w - 8 * 2,
	          marginBottom: 8,
	          minHeight: 120
	        }
	      })), (function() {
	        var i, len, ref, results;
	        ref = proposal_fields.additional_fields;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          additional_field = ref[i];
	          results.push(DIV(null, LABEL({
	            style: _.extend({}, label_style, {
	              marginLeft: 8
	            }),
	            htmlFor: list_name + "-" + additional_field
	          }, proposal_fields[additional_field]), WysiwygEditor({
	            id: list_name + "-" + additional_field,
	            editor_key: additional_field + "-new-proposal-" + list_name,
	            'aria-label': proposal_fields[additional_field],
	            container_style: {
	              padding: '6px 8px',
	              border: '1px solid #ccc'
	            },
	            style: {
	              fontSize: 16,
	              width: w - 8 * 2,
	              marginBottom: 8,
	              minHeight: 120
	            }
	          })));
	        }
	        return results;
	      })(), this.props.combines_these_lists && available_lists.length > 0 ? DIV({
	        style: {
	          marginTop: 12
	        }
	      }, LABEL({
	        htmlFor: 'category'
	      }, translator('category')), SELECT({
	        ref: 'category',
	        id: "category",
	        name: "category",
	        style: {
	          fontSize: 18,
	          display: 'block'
	        },
	        defaultValue: available_lists[0]
	      }, (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = available_lists.length; i < len; i++) {
	          list_key = available_lists[i];
	          results.push(OPTION({
	            value: list_key
	          }, get_list_title(list_key, true)));
	        }
	        return results;
	      })())) : void 0, DIV({
	        style: {
	          position: 'relative'
	        }
	      }, DIV({
	        style: {
	          display: 'flex'
	        }
	      }, INPUT({
	        type: 'checkbox',
	        id: "anonymize_proposal",
	        name: "anonymize_proposal",
	        checked: !!this.local.hide_name,
	        style: {
	          verticalAlign: 'middle',
	          marginRight: 8
	        },
	        onChange: (function(_this) {
	          return function() {
	            _this.local.hide_name = !_this.local.hide_name;
	            return save(_this.local);
	          };
	        })(this)
	      }), LABEL({
	        htmlFor: "anonymize_proposal"
	      }, your_opinion_i18n.anonymize_proposal_button()))), ((ref = this.local.errors) != null ? ref.length : void 0) > 0 ? DIV({
	        role: 'alert',
	        style: {
	          fontSize: 18,
	          color: 'darkred',
	          backgroundColor: '#ffD8D8',
	          padding: 10,
	          marginTop: 10
	        }
	      }, (function() {
	        var i, len, ref1, results;
	        ref1 = this.local.errors;
	        results = [];
	        for (i = 0, len = ref1.length; i < len; i++) {
	          error = ref1[i];
	          results.push(DIV(null, I({
	            className: 'fa fa-exclamation-circle',
	            style: {
	              paddingRight: 9
	            }
	          }), SPAN(null, error)));
	        }
	        return results;
	      }).call(this)) : void 0, DIV({
	        style: {
	          marginTop: 14
	        }
	      }, BUTTON({
	        className: 'btn',
	        disabled: this.local.submitting,
	        style: {
	          backgroundColor: focus_color()
	        },
	        onClick: (function(_this) {
	          return function() {
	            var active, category, description, field, fields, i, len, name, proposal, ref1;
	            name = document.getElementById(list_name + "-name").value;
	            fields = {
	              description: fetch("description-new-proposal-" + list_name).html
	            };
	            ref1 = proposal_fields.additional_fields;
	            for (i = 0, len = ref1.length; i < len; i++) {
	              field = ref1[i];
	              fields[field] = fetch(field + "-new-proposal-" + list_name).html;
	            }
	            description = proposal_fields.create_description(fields);
	            active = true;
	            if (_this.props.combines_these_lists && _this.refs.category) {
	              category = _this.refs.category.value;
	            } else {
	              category = list_key;
	            }
	            category = category.substring(5);
	            proposal = {
	              key: '/new/proposal',
	              name: name,
	              description: description,
	              cluster: category,
	              active: active,
	              hide_name: _this.local.hide_name
	            };
	            InitializeProposalRoles(proposal);
	            proposal.errors = [];
	            _this.local.errors = [];
	            _this.local.submitting = true;
	            save(_this.local);
	            return save(proposal, function() {
	              var ref2;
	              if (((ref2 = proposal.errors) != null ? ref2.length : void 0) === 0) {
	                list_state.adding_new_proposal = null;
	                list_state.show_all_proposals = true;
	                save(list_state);
	                set_sort_order('Date: Earliest first');
	                show_flash(translator('engage.flashes.response-saved', "Your response has been added"));
	                $$.ensure_in_viewport_when_appears("[data-name=\"" + (slugify(proposal.name)) + "\"]");
	              } else {
	                _this.local.errors = proposal.errors;
	              }
	              _this.local.submitting = false;
	              save(_this.local);
	              delete proposal.hide_name;
	              return delete arest.cache[proposal.key].hide_name;
	            });
	          };
	        })(this)
	      }, translator('engage.done_button', 'Done')), BUTTON({
	        className: 'like_link',
	        style: {
	          color: '#777',
	          position: 'relative',
	          top: 2,
	          marginLeft: 12
	        },
	        onClick: (function(_this) {
	          return function() {
	            list_state.adding_new_proposal = null;
	            return save(list_state);
	          };
	        })(this)
	      }, translator('shared.cancel_button', 'cancel')))));
	    }
	  },
	  drawTips: function(tips) {
	    var guidelines_h, guidelines_w, mobile;
	    mobile = browser.is_mobile;
	    if (mobile) {
	      return SPAN(null);
	    }
	    guidelines_w = mobile ? 'auto' : 330;
	    guidelines_h = 300;
	    return DIV({
	      style: {
	        position: mobile ? 'relative' : 'absolute',
	        right: -guidelines_w - 20,
	        width: guidelines_w,
	        color: focus_color(),
	        zIndex: 1,
	        marginBottom: mobile ? 20 : void 0,
	        backgroundColor: mobile ? 'rgba(255,255,255,.85)' : void 0,
	        fontSize: 14
	      }
	    }, !mobile ? SVG({
	      width: guidelines_w + 28,
	      height: guidelines_h,
	      viewBox: "-4 0 " + (guidelines_w + 20 + 9) + " " + guidelines_h,
	      style: {
	        position: 'absolute',
	        transform: 'scaleX(-1)',
	        left: -20
	      }
	    }, PATH({
	      stroke: focus_color(),
	      strokeWidth: 1,
	      fill: "#FFF",
	      d: "M" + guidelines_w + ",33\nL" + guidelines_w + ",0\nL1,0\nL1," + guidelines_h + " \nL" + guidelines_w + "," + guidelines_h + " \nL" + guidelines_w + ",58\nL" + (guidelines_w + 20) + ",48\nL" + guidelines_w + ",33 \nZ"
	    })) : void 0, DIV({
	      style: {
	        padding: !mobile ? '14px 18px' : void 0,
	        position: 'relative',
	        marginLeft: 5
	      }
	    }, SPAN({
	      style: {
	        fontWeight: 600,
	        fontSize: 24
	      }
	    }, "Tips"), UL({
	      style: {
	        listStylePosition: 'outside',
	        marginLeft: 16,
	        marginTop: 5
	      }
	    }, (function() {
	      var i, len, results, tip;
	      tips = customization('new_proposal_tips');
	      results = [];
	      for (i = 0, len = tips.length; i < len; i++) {
	        tip = tips[i];
	        results.push(LI({
	          style: {
	            paddingBottom: 3
	          }
	        }, tip));
	      }
	      return results;
	    })())));
	  }
	});


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(11);
	
	__webpack_require__(1);
	
	__webpack_require__(2);
	
	styles += ".OpinionSlider {\n  position: relative;\n}\n\n.add_reasons_callout {\n  --ADD_REASONS_CALLOUT_BUTTON_WIDTH: 130px;\n\n  background-color: " + (focus_color()) + ";\n  color: white;\n  font-weight: 600;\n  font-size: 10px;\n  border-radius: 8px;\n  border: none;\n  padding: 4px 12px;\n  position: absolute;\n  opacity: 0;\n  transition: opacity .4s ease;\n\n  width: var(--ADD_REASONS_CALLOUT_BUTTON_WIDTH);\n  top: 32px;\n}\n\n.ProposalItem:hover .add_reasons_callout, \n.ProposalItem:focus-within .add_reasons_callout,\n.one-col .ProposalItem .add_reasons_callout {\n  opacity: 1;\n}\n\n.collapsing.ProposalItem:hover .add_reasons_callout,\n.collapsing.ProposalItem:focus-within .add_reasons_callout {\n  opacity: 0;\n  display: none;\n}  \n\n.add_reasons_callout.slide_prompt {\n  --ADD_REASONS_CALLOUT_BUTTON_WIDTH: 160px;\n\n  background-color: transparent;\n  color: " + (focus_color()) + ";\n}\n";
	
	window.OpinionSlider = ReactiveComponent({
	  displayName: 'OpinionSlider',
	  render: function() {
	    var could_possibly_opine, current_user, mode, proposal, rtrn, show_handle, slider, slider_interpretation, your_opinion;
	    proposal = fetch(this.props.proposal);
	    slider = fetch(this.props.slider_key);
	    current_user = fetch('/current_user');
	    your_opinion = this.props.your_opinion;
	    if (this.props.your_opinion.key) {
	      your_opinion = fetch(this.props.your_opinion);
	    }
	    show_handle = this.props.draw_handle;
	    mode = getProposalMode(proposal);
	    if (slider.value !== your_opinion.stance && (!slider.has_moved || this.opinion_key !== your_opinion.key)) {
	      slider.value = your_opinion.stance;
	      if (your_opinion.stance) {
	        slider.has_moved = true;
	      }
	      save(slider);
	      this.opinion_key = your_opinion.key;
	    }
	    slider_interpretation = (function(_this) {
	      return function(value) {
	        if (value > .03) {
	          return ((value * 100).toFixed(0)) + "% " + (get_slider_label("slider_pole_labels.support", proposal, subdomain));
	        } else if (value < -.03) {
	          return (-1 * (value * 100).toFixed(0)) + "% " + (get_slider_label("slider_pole_labels.oppose", proposal, subdomain));
	        } else {
	          return translator("sliders.feedback-short.neutral", "Neutral");
	        }
	      };
	    })(this);
	    could_possibly_opine = couldUserMaybeOpine(proposal);
	    rtrn = DIV({
	      className: 'OpinionSlider',
	      style: {
	        width: this.props.width,
	        filter: this.props.backgrounded ? 'grayscale(100%)' : void 0
	      }
	    }, Slider({
	      slider_key: this.props.slider_key,
	      readable_text: slider_interpretation,
	      width: this.props.width,
	      base_height: this.props.base_height || 2,
	      base_color: mode === 'crafting' ? 'rgb(175, 215, 255)' : 'rgb(153, 153, 153)',
	      regions: customization('slider_regions', proposal),
	      polarized: true,
	      draw_helpers: this.props.focused && !slider.has_moved,
	      handle: this.props.handle || slider_handle.flat,
	      handle_height: this.props.handle_height,
	      handle_width: this.props.handle_width,
	      handle_props: {
	        color: this.props.backgrounded ? '#ccc' : focus_color(),
	        detail: this.props.focused
	      },
	      handle_style: {
	        transition: "transform " + CRAFTING_TRANSITION_SPEED + "ms",
	        transform: "scale(" + (!this.props.focused ? 1 : 1.75) + ")",
	        visibility: !show_handle ? 'hidden' : void 0
	      },
	      onMouseUpCallback: this.handleMouseUp,
	      respond_to_click: false,
	      offset: this.props.offset,
	      label: translator({
	        id: "sliders.instructions-with-proposal",
	        negative_pole: this.props.pole_labels[0],
	        positive_pole: this.props.pole_labels[1],
	        proposal_name: proposal.name
	      }, "Express your opinion on a slider from {negative_pole} to {positive_pole} about {proposal_name}"),
	      readable_text: (function(_this) {
	        return function(value) {
	          if (value > .03) {
	            return ((value * 100).toFixed(0)) + "% " + _this.props.pole_labels[1];
	          } else if (value < -.03) {
	            return (-1 * (value * 100).toFixed(0)) + "% " + _this.props.pole_labels[0];
	          } else {
	            return translator("sliders.feedback-short.neutral", "Neutral");
	          }
	        };
	      })(this),
	      show_val_highlighter: this.props.show_val_highlighter,
	      flip: !!this.props.shouldFlip,
	      shouldFlip: this.props.shouldFlip,
	      shouldFlipIgnore: this.props.shouldFlipIgnore
	    }), could_possibly_opine && (this.props.focused || (TABLET_SIZE() && this.props.is_expanded)) && show_handle ? this.drawFeedback() : void 0, this.props.show_reasons_callout ? this.showReasonsCallout() : void 0);
	    if (this.props.flip) {
	      return FLIPPED({
	        flipId: "Opinion-slider-" + this.props.slider_key,
	        shouldFlip: this.props.shouldFlip,
	        shouldFlipIgnore: this.props.shouldFlipIgnore
	      }, rtrn);
	    } else {
	      return rtrn;
	    }
	  },
	  showReasonsCallout: function() {
	    var opinion_prompt, proposal, slide_prompt, slider, your_opinion;
	    your_opinion = this.props.your_opinion;
	    proposal = this.props.proposal;
	    slide_prompt = !fetch('/current_user').logged_in || !your_opinion.key;
	    opinion_prompt = getOpinionPrompt({
	      proposal: proposal,
	      prefer_drag_prompt: true
	    });
	    slider = fetch(namespaced_key('slider', proposal));
	    if (!opinion_prompt) {
	      return SPAN(null);
	    }
	    return BUTTON({
	      className: "add_reasons_callout " + (slide_prompt ? 'slide_prompt' : ''),
	      style: {
	        left: "calc( " + ((slider.value + 1) / 2) + " * var(--ITEM_OPINION_WIDTH) - var(--ADD_REASONS_CALLOUT_BUTTON_WIDTH) / 2)"
	      },
	      onClick: (function(_this) {
	        return function() {
	          return toggle_expand({
	            proposal: proposal,
	            prefer_personal_view: true
	          });
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            return toggle_expand({
	              proposal: proposal,
	              prefer_personal_view: true
	            });
	          }
	        };
	      })(this)
	    }, opinion_prompt, !slide_prompt ? SliderBubblemouth({
	      proposal: proposal,
	      left: "calc(50% - " + ((slider.value + 1) / 2 * 10) + "px - 10px)",
	      width: 20,
	      height: 8,
	      top: 15
	    }) : void 0);
	  },
	  drawFeedback: function() {
	    var default_feedback, feedback_left, feedback_style, feedback_width, func, labels, proposal, slider, slider_feedback;
	    proposal = fetch(this.props.proposal);
	    slider = fetch(this.props.slider_key);
	    default_feedback = function(value) {
	      if (Math.abs(value) < 0.02) {
	        return translator("sliders.feedback.neutral", "You are neutral");
	      } else {
	        return (Math.round(value * 100)) + "%";
	      }
	    };
	    labels = customization('slider_pole_labels', proposal);
	    slider_feedback = !slider.has_moved ? translator("sliders.slide_prompt", 'Slide Your Overall Opinion') : (func = labels.slider_feedback || default_feedback) ? (typeof func === "string" ? func = window[func] : void 0, func(slider.value, proposal)) : TABLET_SIZE() ? translator("sliders.slide_feedback_short", "Your opinion") : '';
	    if (slider_feedback === '') {
	      return SPAN(null);
	    }
	    feedback_style = {
	      pointerEvents: 'none',
	      fontSize: TABLET_SIZE() ? "22px" : "30px",
	      fontWeight: !TABLET_SIZE() ? 700 : void 0,
	      color: this.props.backgrounded ? '#eee' : focus_color(),
	      textAlign: 'center'
	    };
	    feedback_left = this.props.width * (slider.value + 1) / 2;
	    feedback_width = widthWhenRendered(slider_feedback, feedback_style) + 10;
	    if (slider.value > 0) {
	      feedback_left = Math.min(this.props.width - feedback_width / 2, feedback_left);
	    } else {
	      feedback_left = Math.max(feedback_width / 2, feedback_left);
	    }
	    _.extend(feedback_style, {
	      position: 'absolute',
	      top: !TABLET_SIZE() ? -80 : 37,
	      left: feedback_left,
	      marginLeft: -feedback_width / 2,
	      width: feedback_width
	    });
	    return DIV({
	      className: 'slider_feedback',
	      'aria-hidden': true,
	      style: feedback_style
	    }, slider_feedback);
	  },
	  handleMouseUp: function(e) {
	    var can_opine, finish_mouseup, mode, proposal, slider, transition, your_opinion;
	    slider = fetch(this.props.slider_key);
	    your_opinion = this.props.your_opinion;
	    mode = getProposalMode(this.props.proposal);
	    proposal = fetch(this.props.proposal);
	    e.stopPropagation();
	    transition = this.props.is_expanded && personal_view_available(proposal) && slider.value === your_opinion.stance;
	    finish_mouseup = (function(_this) {
	      return function() {
	        var can_opine, new_page;
	        can_opine = _this.props.permitted() > 0;
	        if (your_opinion.stance !== slider.value) {
	          if (can_opine) {
	            your_opinion.stance = slider.value;
	            your_opinion.published = true;
	            if (your_opinion.key == null) {
	              your_opinion.key = "/new/opinion";
	            }
	            save(your_opinion, function() {
	              var update;
	              show_flash(translator('engage.flashes.opinion_saved', "Your opinion has been saved"));
	              update = fetch('homepage_you_updated_proposal');
	              update.dummy = !update.dummy;
	              return save(update);
	            });
	            window.writeToLog({
	              what: 'move slider',
	              details: {
	                stance: slider.value
	              }
	            });
	          } else {
	            slider.value = 0;
	            save(slider);
	          }
	        }
	        if (transition) {
	          new_page = mode === 'results' ? 'crafting' : 'results';
	          return update_proposal_mode(proposal, new_page, 'click_slider');
	        }
	      };
	    })(this);
	    can_opine = this.props.permitted() > 0;
	    if (can_opine > 0) {
	      return finish_mouseup();
	    } else {
	      return reset_key('auth', {
	        form: 'create account',
	        goal: 'To participate, please introduce yourself.',
	        after: finish_mouseup
	      });
	    }
	  }
	});
	
	styles += ".slider_feedback {\n  //opacity: 0;\n  display: none;\n}\n:not(.expanding).is_expanded .slider_feedback {\n  display: block;\n}\n";
	
	window.get_opinion_x_pos_projection = function(arg) {
	  var from_width, slider_val, stance_position, to_width, x, x_max, x_min;
	  slider_val = arg.slider_val, from_width = arg.from_width, to_width = arg.to_width, x_min = arg.x_min, x_max = arg.x_max;
	  if (x_min == null) {
	    x_min = 0;
	  }
	  if (x_max == null) {
	    x_max = 0;
	  }
	  from_width = from_width - x_min - x_max;
	  stance_position = (slider_val + 1) / 2;
	  x = from_width * stance_position + (to_width - from_width) / 2;
	  x = Math.min(x, to_width - x_max);
	  x = Math.max(x, x_min);
	  return x;
	};
	
	__webpack_require__(7);
	
	window.SliderBubblemouth = ReactiveComponent({
	  displayName: 'SliderBubblemouth',
	  render: function() {
	    var fill, h, left, mode, proposal, slider, stroke_width, top, transform, w, x;
	    proposal = fetch(this.props.proposal);
	    slider = fetch(namespaced_key('slider', proposal));
	    w = this.props.width;
	    h = this.props.height;
	    top = this.props.top;
	    stroke_width = 11;
	    if (!this.props.left) {
	      x = get_opinion_x_pos_projection({
	        slider_val: slider.value,
	        from_width: ITEM_OPINION_WIDTH() * (!TABLET_SIZE() ? 2 : 1),
	        to_width: DECISION_BOARD_WIDTH(),
	        x_min: this.props.x_min || 20,
	        x_max: this.props.x_max || 20
	      });
	      left = x - w / 2;
	    } else {
	      left = this.props.left;
	    }
	    mode = getProposalMode(proposal);
	    if (mode === 'crafting') {
	      transform = "translate(0, -4px) scale(1,.7)";
	      fill = 'white';
	    } else {
	      transform = "translate(0, -22px) scale(.6,.6) ";
	      fill = focus_color();
	    }
	    return DIV({
	      key: 'slider_bubblemouth',
	      style: {
	        left: left,
	        top: top,
	        position: 'absolute',
	        width: w,
	        height: h,
	        zIndex: 10,
	        transition: "transform " + CRAFTING_TRANSITION_SPEED + "ms",
	        transform: transform
	      }
	    }, Bubblemouth({
	      apex_xfrac: (slider.value + 1) / 2,
	      width: w,
	      height: h,
	      fill: fill,
	      stroke: focus_color(),
	      stroke_width: mode === 'crafting' ? stroke_width : 0
	    }));
	  }
	});


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(49);
	
	window.Point = ReactiveComponent({
	  displayName: 'Point',
	  render: function() {
	    var append, can_opine, current_user, draw_all_includers, expand_to_see_details, includePoint, included, includers_style, ioffset, is_selected, left_or_right, mouth_style, point, point_content_style, proposal, renderIncluders, right, side, sty, your_opinion;
	    point = fetch(this.props.point);
	    if (!point.proposal) {
	      return SPAN(null);
	    }
	    proposal = fetch(point.proposal);
	    is_selected = get_selected_point() === this.props.point;
	    current_user = fetch('/current_user');
	    renderIncluders = (function(_this) {
	      return function(draw_all_includers) {
	        var anonymous, curr_column, i, includer, includer_opinion, includers, left_right, s, side_offset, style, top_offset;
	        if (point.includers) {
	          if (draw_all_includers) {
	            includers = _this.buildIncluders();
	          } else {
	            includers = [point.user];
	          }
	          s = {
	            rows: 8,
	            dx: 2,
	            dy: 5,
	            col_gap: 8
	          };
	          if (includers.length === 0) {
	            includers = [point.user];
	          }
	          i = includers.length;
	          return DIV(null, (function() {
	            var j, len, results;
	            results = [];
	            for (j = 0, len = includers.length; j < len; j++) {
	              includer = includers[j];
	              i -= 1;
	              curr_column = Math.floor(i / s.rows);
	              side_offset = curr_column * s.col_gap + i * s.dx;
	              top_offset = (i % s.rows) * s.dy;
	              left_right = point.is_pro ? 'left' : 'right';
	              style = {
	                top: top_offset,
	                position: 'absolute'
	              };
	              style[left_right] = side_offset;
	              includer_opinion = _.findWhere(proposal.opinions, {
	                user: includer
	              });
	              anonymous = (includer_opinion != null ? includer_opinion.hide_name : void 0) || (point.hide_name && point.user === includer);
	              results.push(avatar(includer, {
	                key: includer,
	                className: "point_includer_avatar",
	                style: style,
	                set_bg_color: true,
	                anonymous: anonymous
	              }));
	            }
	            return results;
	          })());
	        }
	      };
	    })(this);
	    point_content_style = {};
	    if (is_selected) {
	      _.extend(point_content_style, {
	        borderColor: focus_color(),
	        backgroundColor: 'white'
	      });
	    } else if (this.local.has_focus) {
	      _.extend(point_content_style, {
	        borderColor: '#999',
	        backgroundColor: 'white'
	      });
	    }
	    expand_to_see_details = !!point.text;
	    includers_style = {
	      position: 'absolute',
	      height: 25,
	      width: 25,
	      top: 0
	    };
	    left_or_right = point.is_pro && this.props.rendered_as !== 'decision_board_point' ? 'right' : 'left';
	    ioffset = -50;
	    includers_style[left_or_right] = ioffset;
	    draw_all_includers = this.props.rendered_as === 'community_point' || TABLET_SIZE();
	    if (expand_to_see_details && !is_selected) {
	      append = SPAN({
	        key: 1,
	        style: {
	          fontSize: 10,
	          color: '#888'
	        }
	      }, " (" + (translator({
	        id: "engage.read_more"
	      }, "read more")) + ")");
	    } else {
	      append = null;
	    }
	    return LI({
	      key: "point-" + point.id,
	      'data-id': this.props.point,
	      className: "point " + this.props.rendered_as + " " + (point.is_pro ? 'pro' : 'con') + " " + (customization('disable_comments') && !expand_to_see_details ? 'commenting-disabled' : '') + " " + (is_selected ? 'is-selected' : ''),
	      onClick: this.selectPoint,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if ((is_selected && e.which === 27) || e.which === 13 || e.which === 32) {
	            _this.selectPoint(e);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, this.props.rendered_as === 'decision_board_point' ? DIV({
	      style: {
	        position: 'absolute',
	        left: 0,
	        top: -2
	      }
	    }, point.is_pro ? '•' : '•') : void 0, DIV({
	      ref: 'point_content',
	      className: 'point_content',
	      style: point_content_style,
	      tabIndex: 0,
	      onBlur: (function(_this) {
	        return function(e) {
	          _this.local.has_focus = false;
	          return save(_this.local);
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function(e) {
	          _this.local.has_focus = true;
	          return save(_this.local);
	        };
	      })(this),
	      draggable: this.props.enable_dragging,
	      "data-point": point.key
	    }, this.props.rendered_as !== 'decision_board_point' && !PHONE_SIZE() ? (side = point.is_pro ? 'right' : 'left', mouth_style = {
	      top: 8,
	      position: 'absolute'
	    }, mouth_style[side] = -POINT_MOUTH_WIDTH + (is_selected || this.local.has_focus ? 3 : 1), !point.is_pro ? mouth_style['transform'] = 'rotate(270deg) scaleX(-1)' : mouth_style['transform'] = 'rotate(90deg)', DIV({
	      'role': 'presentation',
	      key: 'community_point_mouth',
	      style: mouth_style
	    }, PointBubblemouth({
	      apex_xfrac: 0,
	      width: POINT_MOUTH_WIDTH,
	      height: POINT_MOUTH_WIDTH,
	      fill: considerit_gray,
	      stroke: is_selected ? focus_color() : this.local.has_focus ? '#888' : 'transparent',
	      stroke_width: is_selected || this.local.has_focus ? 20 : 0
	    }))) : void 0, DIV({
	      style: {
	        wordWrap: 'break-word',
	        fontSize: POINT_FONT_SIZE()
	      }
	    }, DIV({
	      className: 'point_nutshell'
	    }, splitParagraphs(point.nutshell, append)), DIV({
	      id: "point-aria-interaction-" + point.id,
	      className: 'hidden'
	    }, translator({
	      id: "engage.point_explanation",
	      author: point.hide_name ? anonymous_label() : fetch(point.user).name,
	      num_inclusions: point.includers.length,
	      comment_count: point.comment_count
	    }, "By {author}. \n{ num_inclusions, plural, =0 {} one {Important to one person.} other {Important to # people.} } \n{comment_count, plural, =0 {} one {Has received one comment.} other {Has received # comments.} }\nPress ENTER or SPACE for details or discussion.")), DIV({
	      'aria-hidden': true,
	      className: "point_details" + (is_selected ? '' : '_tease'),
	      style: {
	        wordWrap: 'break-word',
	        marginTop: '0.5em',
	        fontSize: POINT_FONT_SIZE()
	      }
	    }, DIV({
	      style: {
	        fontSize: 12,
	        color: '#666'
	      }
	    }, !PHONE_SIZE() && !screencasting() && !embedded_demo() && fetch('/subdomain').name !== 'galacticfederation' ? [
	      prettyDate(point.created_at), SPAN({
	        key: 'padding',
	        style: {
	          paddingLeft: 8
	        }
	      })
	    ] : void 0, !customization('disable_comments') ? SPAN({
	      key: 2,
	      style: {
	        whiteSpace: 'nowrap'
	      }
	    }, A({
	      className: 'select_point'
	    }, translator({
	      id: 'engage.link_to_comments',
	      comment_count: point.comment_count
	    }, "{comment_count, plural, one {# comment} other {# comments}}"))) : void 0, PHONE_SIZE() ? SPAN({
	      key: 3,
	      style: {
	        float: 'right'
	      }
	    }, "+" + point.includers.length) : void 0))), current_user.user === point.user ? DIV(null, permit('update point', point) > 0 && (this.props.rendered_as === 'decision_board_point' || TABLET_SIZE()) ? BUTTON({
	      style: {
	        fontSize: browser.is_mobile ? 24 : 14,
	        color: focus_color(),
	        padding: '3px 12px 3px 0',
	        backgroundColor: 'transparent',
	        border: 'none'
	      },
	      onTouchEnd: function(e) {
	        return e.stopPropagation();
	      },
	      onClick: ((function(_this) {
	        return function(e) {
	          var points;
	          e.stopPropagation();
	          points = fetch(_this.props.your_points_key);
	          points.editing_points.push(_this.props.point);
	          return save(points);
	        };
	      })(this))
	    }, translator('engage.edit_button', 'edit')) : void 0, permit('delete point', point) > 0 && (this.props.rendered_as === 'decision_board_point' || TABLET_SIZE()) ? BUTTON({
	      'data-action': 'delete-point',
	      style: {
	        fontSize: browser.is_mobile ? 24 : 14,
	        color: focus_color(),
	        padding: '3px 8px',
	        backgroundColor: 'transparent',
	        border: 'none'
	      },
	      onTouchEnd: function(e) {
	        return e.stopPropagation();
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          e.stopPropagation();
	          if (confirm('Delete this point forever?')) {
	            return destroy(_this.props.point);
	          }
	        };
	      })(this)
	    }, translator('engage.delete_button', 'delete')) : void 0) : void 0), this.props.rendered_as !== 'decision_board_point' && !PHONE_SIZE() && this.props.in_viewport ? DIV({
	      'aria-hidden': true,
	      className: 'includers',
	      onMouseEnter: this.highlightIncluders,
	      onMouseLeave: this.unHighlightIncluders,
	      style: includers_style
	    }, renderIncluders(draw_all_includers)) : void 0, TABLET_SIZE() || (!TABLET_SIZE() && this.props.enable_dragging) ? (your_opinion = proposal.your_opinion, your_opinion.key ? fetch(your_opinion) : void 0, can_opine = canUserOpine(proposal), included = this.included(), includePoint = (function(_this) {
	      return function(e) {
	        e.stopPropagation();
	        e.preventDefault();
	        if (!(e.type !== 'click' || (!browser.is_android_browser && e.type === 'click'))) {
	          return;
	        }
	        if (!included) {
	          return _this.include();
	        } else {
	          return _this.remove();
	        }
	      };
	    })(this), !TABLET_SIZE() && this.props.enable_dragging ? (right = (included && point.is_pro) || (!included && !point.is_pro), right ? sty = {
	      right: !this.local.focused_include ? 20 : included ? -20 : -40
	    } : sty = {
	      left: !this.local.focused_include ? 20 : included ? -20 : -40
	    }, BUTTON({
	      'aria-label': included ? translator('engage.uninclude_explanation', 'Mark this point as unimportant and move to next point') : translator('engage.include_explanation', 'Mark this point as important and move to next point'),
	      style: _.extend(sty, {
	        position: 'absolute',
	        top: 20,
	        opacity: !this.local.focused_include ? 0 : void 0,
	        padding: 0,
	        backgroundColor: 'transparent',
	        border: 'none',
	        display: get_selected_point() ? 'none' : void 0
	      }),
	      onFocus: (function(_this) {
	        return function(e) {
	          _this.local.focused_include = true;
	          return save(_this.local);
	        };
	      })(this),
	      onBlur: (function(_this) {
	        return function(e) {
	          _this.local.focused_include = false;
	          return save(_this.local);
	        };
	      })(this),
	      onTouchEnd: includePoint,
	      onClick: includePoint,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          var next, valence;
	          if (e.which === 13 || e.which === 32) {
	            includePoint(e);
	            valence = point.is_pro ? 'pros' : 'cons';
	            next = $$.closest(e.target, '.point').nextElementSibling.querySelector('.point_content');
	            next.focus();
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, I({
	      style: {
	        fontSize: included ? 25 : 40,
	        color: focus_color()
	      },
	      className: "fa fa-long-arrow-" + (!right ? 'left' : 'right')
	    }))) : BUTTON({
	      style: {
	        border: "1px solid " + (included || this.local.hover_important ? focus_color() : '#414141'),
	        borderTopColor: included ? focus_color() : 'transparent',
	        color: included ? 'white' : this.local.hover_important ? focus_color() : "#414141",
	        position: 'relative',
	        top: -13,
	        padding: '8px 5px',
	        textAlign: 'center',
	        borderRadius: '0 0 16px 16px',
	        cursor: 'pointer',
	        backgroundColor: included ? focus_color() : 'white',
	        fontSize: 16,
	        zIndex: 0,
	        display: can_opine < 0 ? 'none' : void 0,
	        width: '100%'
	      },
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.hover_important = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.hover_important = false;
	          return save(_this.local);
	        };
	      })(this),
	      onTouchEnd: includePoint,
	      onClick: includePoint,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            includePoint(e);
	            e.preventDefault();
	            return e.stopPropagation();
	          }
	        };
	      })(this)
	    }, I({
	      className: 'fa fa-thumbs-o-up',
	      style: {
	        display: 'inline-block',
	        marginRight: 10
	      }
	    }), translator("engage.include_button", "Important") + ("" + (included ? '' : '?')))) : void 0, is_selected ? Discussion({
	      key: "/comments/" + point.id,
	      comments: "/comments/" + point.id,
	      point: point.key,
	      rendered_as: this.props.rendered_as
	    }) : void 0);
	  },
	  componentDidMount: function() {
	    this.ensureDiscussionIsInViewPort();
	    if (this.props.enable_dragging) {
	      return this.initializeDragging();
	    }
	  },
	  componentDidUpdate: function() {
	    this.ensureDiscussionIsInViewPort();
	    if (this.props.enable_dragging) {
	      return this.initializeDragging();
	    }
	  },
	  initializeDragging: function() {
	    var last_mouse_over_target, point_root, point_width;
	    if (!this.drag_initialized) {
	      this.drag_initialized = true;
	      point_root = ReactDOM.findDOMNode(this);
	      point_width = null;
	      last_mouse_over_target = null;
	      this.draggable = new Draggable.Draggable(point_root, {
	        draggable: '.point',
	        delay: 0,
	        distance: 1,
	        mirror: {
	          appendTo: '#content'
	        }
	      });
	      this.draggable.on('drag:start', (function(_this) {
	        return function(evt) {
	          return point_width = evt.source.getBoundingClientRect().width;
	        };
	      })(this));
	      this.draggable.on('mirror:created', (function(_this) {
	        return function(evt) {
	          return evt.mirror.style.width = point_width + "px";
	        };
	      })(this));
	      this.draggable.on('drag:move', (function(_this) {
	        return function(evt) {
	          var db;
	          last_mouse_over_target = evt.sensorEvent.target;
	          if (_this.props.rendered_as !== 'decision_board_point') {
	            db = last_mouse_over_target != null ? last_mouse_over_target.closest('.DecisionBoard') : void 0;
	            if (db) {
	              return db.closest(".ProposalItem").classList.add('community-point-is-being-dragged');
	            } else {
	              return point_root.closest(".ProposalItem").classList.remove('community-point-is-being-dragged');
	            }
	          }
	        };
	      })(this));
	      return this.draggable.on('drag:stop', (function(_this) {
	        return function(evt) {
	          var db, idx, point, proposal, ref, ref1, validate_first, your_opinion;
	          if (_this.props.rendered_as !== 'decision_board_point') {
	            point_root.closest(".ProposalItem").classList.remove('community-point-is-being-dragged');
	            if (db = last_mouse_over_target != null ? last_mouse_over_target.closest('.DecisionBoard') : void 0) {
	              point = fetch(_this.props.point);
	              proposal = fetch(point.proposal);
	              your_opinion = proposal.your_opinion;
	              if (!your_opinion.point_inclusions || (ref = point.key, indexOf.call(your_opinion.point_inclusions, ref) < 0)) {
	                if (your_opinion.key == null) {
	                  your_opinion.key = "/new/opinion";
	                }
	                your_opinion.published = true;
	                if (your_opinion.point_inclusions == null) {
	                  your_opinion.point_inclusions = [];
	                }
	                your_opinion.point_inclusions.push(point.key);
	                save(your_opinion);
	                return window.writeToLog({
	                  what: 'included point',
	                  details: {
	                    point: point.id
	                  }
	                });
	              }
	            }
	          } else {
	            if (last_mouse_over_target != null ? last_mouse_over_target.closest('.points_by_community') : void 0) {
	              point = fetch(_this.props.point);
	              proposal = fetch(point.proposal);
	              your_opinion = proposal.your_opinion;
	              validate_first = point.user === fetch('/current_user').user && point.includers.length < 2;
	              if (!validate_first || confirm('Are you sure you want to remove your point? It will be gone forever.')) {
	                your_opinion = proposal.your_opinion;
	                if (your_opinion.point_inclusions && (ref1 = point.key, indexOf.call(your_opinion.point_inclusions, ref1) >= 0)) {
	                  idx = your_opinion.point_inclusions.indexOf(point.key);
	                  your_opinion.point_inclusions.splice(idx, 1);
	                  save(your_opinion);
	                  return window.writeToLog({
	                    what: 'removed point',
	                    details: {
	                      point: point.key
	                    }
	                  });
	                }
	              }
	            }
	          }
	        };
	      })(this));
	    }
	  },
	  ensureDiscussionIsInViewPort: function() {
	    var i, is_selected;
	    is_selected = get_selected_point() === this.props.point;
	    if (!!this.local.is_selected !== !!is_selected) {
	      if (is_selected) {
	        i = setInterval((function(_this) {
	          return function() {
	            var discussion;
	            discussion = document.getElementById('open_point');
	            if (discussion) {
	              if (browser.is_mobile) {
	                $$.moveToTop(ReactDOM.findDOMNode(_this));
	                discussion.focus();
	              } else {
	                $$.ensureInView(discussion, {
	                  scroll: true,
	                  offset_buffer: 50 + $$.height(ReactDOM.findDOMNode(_this)),
	                  callback: function() {
	                    return discussion.focus();
	                  }
	                });
	              }
	              return clearInterval(i);
	            }
	          };
	        })(this), 10);
	      }
	      this.local.is_selected = is_selected;
	      return save(this.local);
	    }
	  },
	  included: function() {
	    var point, proposal, your_opinion;
	    point = fetch(this.props.point);
	    proposal = fetch(point.proposal);
	    your_opinion = proposal.your_opinion;
	    if (your_opinion.point_inclusions == null) {
	      your_opinion.point_inclusions = [];
	    }
	    return your_opinion.point_inclusions.indexOf(this.props.point) > -1;
	  },
	  include: function() {
	    var point, proposal, your_opinion;
	    point = fetch(this.props.point);
	    proposal = fetch(point.proposal);
	    your_opinion = proposal.your_opinion;
	    if (your_opinion.key == null) {
	      your_opinion.key = "/new/opinion";
	    }
	    your_opinion.published = true;
	    if (your_opinion.point_inclusions == null) {
	      your_opinion.point_inclusions = [];
	    }
	    your_opinion.point_inclusions.push(this.props.point);
	    save(your_opinion);
	    return window.writeToLog({
	      what: 'included point',
	      details: {
	        point: this.props.point
	      }
	    });
	  },
	  remove: function() {
	    var idx, point, proposal, your_opinion;
	    point = fetch(this.props.point);
	    proposal = fetch(point.proposal);
	    your_opinion = proposal.your_opinion;
	    if (your_opinion.key == null) {
	      your_opinion.key = "/new/opinion";
	    }
	    idx = your_opinion.point_inclusions.indexOf(point.key);
	    if (idx > -1) {
	      your_opinion.point_inclusions.splice(idx, 1);
	      return save(your_opinion);
	    }
	  },
	  selectPoint: function(e) {
	    var loc, point, what;
	    e.stopPropagation();
	    point = fetch(this.props.point);
	    if (!point.text && customization('disable_comments')) {
	      return;
	    }
	    loc = fetch('location');
	    if (get_selected_point() === this.props.point) {
	      delete loc.query_params.selected;
	      what = 'deselected a point';
	      document.activeElement.blur();
	    } else {
	      what = 'selected a point';
	      loc.query_params.selected = this.props.point;
	    }
	    save(loc);
	    return window.writeToLog({
	      what: what,
	      details: {
	        point: this.props.point
	      }
	    });
	  },
	  highlightIncluders: function() {
	    var includers, opinion_views, point;
	    point = fetch(this.props.point);
	    includers = point.includers;
	    if (point.hide_name) {
	      includers = _.without(includers, point.user);
	    }
	    opinion_views = fetch('opinion_views');
	    opinion_views.active_views.point_includers = {
	      created_by: this.props.point,
	      point: point.key,
	      get_salience: function(u, opinion, proposal) {
	        var ref;
	        if (ref = u.key || u, indexOf.call(includers, ref) >= 0) {
	          return 1;
	        } else {
	          return .1;
	        }
	      }
	    };
	    return save(opinion_views);
	  },
	  unHighlightIncluders: function() {
	    var opinion_views;
	    opinion_views = fetch('opinion_views');
	    if (opinion_views.active_views.point_includers) {
	      delete opinion_views.active_views.point_includers;
	      return save(opinion_views);
	    }
	  },
	  buildIncluders: function() {
	    var groups, i, ignore_views, includers, opinion_views, point, proposal, ref, salience, weights;
	    point = fetch(this.props.point);
	    proposal = fetch(point.proposal);
	    includers = point.includers;
	    opinion_views = fetch('opinion_views');
	    if (!opinion_views.active_views.single_opinion_selected && !opinion_views.active_views.region_selected) {
	      ignore_views = {
	        point_includers: true
	      };
	    } else {
	      ignore_views = null;
	    }
	    ref = compose_opinion_views(null, proposal, ignore_views), weights = ref.weights, salience = ref.salience, groups = ref.groups;
	    includers = (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = includers.length; j < len; j++) {
	        i = includers[j];
	        if (salience[i] === 1 && weights[i] > 0) {
	          results.push(i);
	        }
	      }
	      return results;
	    })();
	    includers = _.without(includers, point.user);
	    includers.push(point.user);
	    return _.uniq(includers);
	  }
	});
	
	styles += "\n.point {\n  position: relative;\n  list-style: none outside none;\n}\n\n.point.decision_board_point {\n  margin-left: 9px;\n  padding: 0 0 0 18px;\n}\n\n.point.community_point {\n  margin-bottom: 0.5em;\n}\n\n.point.is-selected {\n  z-index: 100;\n}\n\n@media " + NOT_PHONE_MEDIA + " {\n  .point.community_point {\n    filter: drop-shadow(rgba(0, 0, 0, 0.25) 0px 1px 1px);\n  }\n\n}\n\n\n\n.point_content[draggable=\"false\"] {\n  cursor: pointer !important; }\n\n" + (css.grab_cursor('.point_content[draggable="true"]')) + "\n\n\n.point.draggable-mirror {\n  z-index: 99999999;\n}\n.point.draggable-mirror .includers, .point.draggable-mirror button {\n  display: none;\n}  \n.point.draggable-source--is-dragging {\n  transition: opacity 0ms !important;\n  opacity: 0.2 !important;\n}\n.point.draggable--original {\n  display: none;\n}\n  \n\n\n.commenting-disabled .point_content[draggable=\"false\"] {\n  cursor: auto; }\n\n\n.commenting-disabled .point_details_tease {\n  cursor: auto;\n}\n\n\n.point_content {\n  border-width: 3px;\n  border-style: solid; \n  border-color: transparent;\n  top: -3px;\n  position: relative;\n  z-index: 1;\n  outline: none;\n}\n\n.decision_board_point .point_content {\n  padding: 8px 0px;\n  border-radius: 8px;\n  top: -11px;\n}\n\n.community_point .point_content {\n  padding: 8px;\n  border-radius: 16px;\n  top: -11px;\n  background-color: " + considerit_gray + ";\n  /* box-shadow: #b5b5b5 0 1px 1px 0px; */\n  min-height: 34px; \n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .community_point .point_content {\n    border-radius: 16px 16px 0 0;\n  }\n}\n\n.point_nutshell a { text-decoration: underline; }\n.point_details_tease a, .point_details a {\n  text-decoration: underline;\n  word-break: break-all; }\n.point_details a.select_point{\n  text-decoration: none;\n  font-weight: 400;\n}\n\n.point_details {\n  display: block; }\n\n.point_details_tease {\n  cursor: pointer; }\n  .point_details_tease a.select_point {\n    text-decoration: none; \n    font-weight: 400;    \n    }\n    .point_details_tease a.select_point:hover {\n      text-decoration: underline; }\n\n.point_details p {\n  margin-bottom: 1em; }\n\n.point_details p:last-child {\n  margin-bottom: 0; }\n\n.point_includer_avatar {\n  width: 22px;\n  height: 22px; }\n\n.community_point.con .point_includer_avatar {\n  box-shadow: -1px 2px 0 0 #eeeeee; }\n\n.community_point.pro .point_includer_avatar {\n  box-shadow: 1px 2px 0 0 #eeeeee; }\n\n.decision_board_point.pro .point_includer_avatar {\n  left: -10px; }\n";


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	
	__webpack_require__(46);
	
	styles += "button.create_account {\n  background-color: " + selected_color + ";\n}\n#user_nav {\n  position: absolute;\n  z-index: 999;\n  right: 30px;\n  font-size: 26px;    \n}\n@media " + PHONE_MEDIA + " {\n  #user_nav {\n    right: 8px;\n  }\n}";
	
	window.ProfileMenu = ReactiveComponent({
	  displayName: 'ProfileMenu',
	  render: function() {
	    var bg, color, config, current_user, edit_forum, is_admin, is_light, is_moderator, is_super, light_background, loc, menu_options, settings, show_dash_modal, subdomain;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    loc = fetch('location');
	    is_admin = current_user.is_admin;
	    is_moderator = current_user.is_moderator;
	    is_super = current_user.is_super_admin;
	    menu_options = [
	      {
	        href: '/dashboard/edit_profile',
	        label: 'Edit Profile'
	      }, {
	        href: '/dashboard/email_notifications',
	        label: 'Email Settings'
	      }, is_admin ? {
	        href: '/dashboard/data_import_export',
	        label: 'Import / Export Data'
	      } : null, is_admin ? {
	        href: '/dashboard/application',
	        label: 'Forum Settings'
	      } : null, is_super ? {
	        href: '/dashboard/customizations',
	        label: 'Customizations'
	      } : null, is_admin ? {
	        href: '/dashboard/roles',
	        label: 'Permissions & Roles'
	      } : null, is_super ? {
	        href: '/dashboard/tags',
	        label: 'User Tags'
	      } : null, is_admin ? {
	        href: '/dashboard/analytics',
	        label: 'Analytics'
	      } : null, is_moderator ? {
	        href: '/dashboard/moderate',
	        label: 'Moderate'
	      } : null, {
	        label: 'Log out',
	        'data-action': 'logout'
	      }
	    ];
	    menu_options = _.compact(menu_options);
	    light_background = !is_a_dialogue_page() || is_light_background();
	    edit_forum = fetch('edit_forum');
	    return DIV({
	      id: 'user_nav',
	      style: _.defaults({}, customization('profile_menu_style') || {}, this.props.style || {}, {
	        top: current_user.is_admin && (edit_forum.editing || loc.url.startsWith('/dashboard')) && permit('configure paid feature') < 0 ? 57 : 17
	      })
	    }, current_user.logged_in ? !edit_forum.editing ? DropMenu({
	      options: menu_options,
	      selection_made_callback: function(option) {
	        if (option.label === 'Log out') {
	          return logout();
	        }
	      },
	      render_anchor: function(menu_showing) {
	        return [
	          Avatar({
	            key: current_user.user,
	            hide_popover: true,
	            className: 'userbar_avatar',
	            style: {
	              height: 35,
	              width: 35,
	              marginRight: 12,
	              marginTop: 1
	            }
	          }), SPAN({
	            key: 'username',
	            style: {
	              color: menu_showing ? '#777' : void 0,
	              fontSize: 18,
	              position: 'relative',
	              paddingRight: 12
	            }
	          }, current_user.name), I({
	            key: 'caret',
	            className: 'fa fa-caret-down',
	            style: {
	              visibility: menu_showing ? 'hidden' : void 0
	            }
	          })
	        ];
	      },
	      render_option: function(option) {
	        if (option.label === 'Log out') {
	          return translator("auth.log_out", "Log out");
	        } else {
	          return translator("user_menu.option." + option.label, option.label);
	        }
	      },
	      anchor_style: {
	        color: !light_background ? 'white' : void 0,
	        zIndex: 9999999999,
	        backgroundColor: 'rgba(255,255,255, .1)',
	        borderRadius: 8,
	        padding: '3px 4px',
	        fontWeight: 600,
	        display: 'flex',
	        alignItems: 'center'
	      },
	      anchor_when_open_style: {
	        backgroundColor: 'transparent',
	        boxShadow: 'none',
	        color: '#666'
	      },
	      menu_style: {
	        left: 'auto',
	        right: -9999,
	        margin: '-42px 0 0 -8px',
	        padding: "56px 14px 8px 8px",
	        backgroundColor: '#eee',
	        textAlign: 'right',
	        minWidth: '100%'
	      },
	      menu_when_open_style: {
	        right: 0
	      },
	      option_style: {
	        color: focus_color(),
	        position: 'relative',
	        bottom: 8,
	        paddingLeft: 27,
	        display: 'block',
	        whiteSpace: 'nowrap',
	        fontWeight: 600
	      },
	      active_option_style: {
	        color: 'black'
	      }
	    }) : (is_light = is_light_background(), color = is_light ? 'black' : 'white', bg = is_light ? 'rgba(255,255,255,.4)' : 'rgba(0,0,0,.4)', settings = [
	      {
	        name: 'Forum Settings',
	        url: '/dashboard/application'
	      }, {
	        name: 'Permissions & Roles',
	        url: '/dashboard/roles'
	      }
	    ], is_admin ? settings.push({
	      name: 'Sign-up Questions',
	      url: '/dashboard/intake_questions',
	      paid: true
	    }) : void 0, show_dash_modal = fetch('show_dash_modal'), DIV({
	      style: {
	        marginTop: 48,
	        padding: '12px 24px',
	        backgroundColor: bg,
	        fontSize: 14
	      }
	    }, show_dash_modal.showing ? ModalDash({
	      url: show_dash_modal.showing.url,
	      done_callback: (function(_this) {
	        return function() {
	          show_dash_modal.showing = null;
	          return save(show_dash_modal);
	        };
	      })(this)
	    }) : void 0, UL({
	      style: {
	        listStyle: 'none'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = settings.length; i < len; i++) {
	        config = settings[i];
	        results.push(LI({
	          key: config.name,
	          style: {
	            marginBottom: 6
	          }
	        }, BUTTON({
	          className: 'like_link',
	          style: {
	            fontWeight: 700,
	            color: color,
	            fontSize: 14
	          },
	          onClick: (function(_this) {
	            return function(config) {
	              return function() {
	                show_dash_modal.showing = config;
	                return save(show_dash_modal);
	              };
	            };
	          })(this)(config)
	        }, config.name), config.paid && permit('configure paid feature') < 0 ? UpgradeForumButton({
	          text: 'upgrade'
	        }) : void 0));
	      }
	      return results;
	    }).call(this)))) : fetch('/subdomain').SSO_domain ? A({
	      href: '/login_via_saml',
	      treat_as_external_link: true,
	      style: {
	        color: !light_background ? 'white' : void 0,
	        backgroundColor: 'transparent',
	        border: 'none',
	        textDecoration: 'none'
	      }
	    }, translator("auth.log_in", "Log in")) : DIV({
	      style: {
	        fontSize: 18
	      }
	    }, BUTTON({
	      className: 'btn create_account',
	      'data-action': 'create_account',
	      onClick: (function(_this) {
	        return function(e) {
	          return reset_key('auth', {
	            form: 'create account'
	          });
	        };
	      })(this)
	    }, translator("shared.auth.sign_up", "Sign up")), BUTTON({
	      className: 'profile_anchor login like_link',
	      'data-action': 'login',
	      onClick: (function(_this) {
	        return function(e) {
	          return reset_key('auth', {
	            form: 'login'
	          });
	        };
	      })(this),
	      style: {
	        color: !light_background ? 'white' : void 0,
	        fontWeight: 700,
	        fontSize: 18,
	        marginLeft: 20,
	        position: 'relative',
	        top: 0
	      }
	    }, translator("auth.log_in", "Log in"))));
	  },
	  bitcoinVerification: function() {
	    var current_user, dd, mm, subdomain, today, yyyy;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    return DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 10,
	        left: -315
	      },
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.show_verify = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.show_verify = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, DIV({
	      style: {
	        backgroundColor: focus_color(),
	        color: 'white',
	        fontWeight: 600,
	        padding: '4px 12px',
	        fontSize: 21,
	        borderRadius: !this.local.show_verify ? 8 : void 0,
	        position: 'relative',
	        cursor: 'pointer'
	      }
	    }, SPAN({
	      style: cssTriangle('right', focus_color(), 10, 12, {
	        position: 'absolute',
	        right: -10,
	        top: 12
	      })
	    }), 'Please verify you are human!'), this.local.show_verify ? (today = new Date(), dd = today.getDate(), mm = today.getMonth() + 1, yyyy = today.getFullYear(), dd < 10 ? dd = '0' + dd : void 0, mm < 10 ? mm = '0' + mm : void 0, today = yyyy + '/' + mm + '/' + dd, DIV({
	      style: {
	        width: 650,
	        position: 'absolute',
	        right: 0,
	        zIndex: 999,
	        padding: 40,
	        backgroundColor: 'white',
	        boxShadow: '0 1px 2px rgba(0,0,0,.3)',
	        fontSize: 21
	      }
	    }, DIV({
	      style: {
	        marginBottom: 20
	      }
	    }, "To verify you are human, write on a piece of paper:"), DIV({
	      style: {
	        marginBottom: 20,
	        marginLeft: 50
	      }
	    }, current_user.name, BR(null), "bitcoin.consider.it", BR(null), today), DIV({
	      style: {
	        marginBottom: 20
	      }
	    }, "Then take a photo of yourself with it, and email the photo to ", A({
	      href: 'mailto:verify@consider.it',
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'verify@consider.it'), ". This photo will be publicly visible proof that you are real!"), DIV({
	      style: {
	        marginBottom: 20
	      }
	    }, "Yours,", BR(null), "The Admins"), IMG({
	      src: asset('bitcoin/verify example.jpg'),
	      style: {
	        width: 570
	      }
	    }), IMG({
	      src: asset('bitcoin/verification-travis.jpg'),
	      style: {
	        width: 570
	      }
	    }), IMG({
	      src: asset('bitcoin/KevinBitcoin.jpg'),
	      style: {
	        width: 570
	      }
	    }))) : void 0);
	  }
	});
	
	styles += ".profile_menu_wrap:hover .profile_anchor,\n.profile_menu_wrap:focus-within .profile_anchor { \n  color: inherit; \n}";


/***/ },
/* 79 */
/***/ function(module, exports) {

	window.BUBBLE_WRAP = ReactiveComponent({
	  displayName: 'BUBBLE_WRAP',
	  render: function() {
	    var ioffset, left_or_right, mouth_style, mouth_w, pic_style, w;
	    left_or_right = 'right';
	    ioffset = -10;
	    w = this.props.width || 400;
	    mouth_w = (this.props.mouth_style || {}).width || POINT_MOUTH_WIDTH;
	    mouth_style = _.defaults(this.props.mouth_style || {}, {
	      top: 8,
	      position: 'absolute',
	      left: -mouth_w + 1,
	      transform: 'rotate(270deg) scaleX(-1)'
	    });
	    pic_style = _.defaults({}, this.props.avatar_style || {}, {
	      position: 'absolute',
	      top: 0,
	      width: 50,
	      height: 50,
	      left: -64,
	      boxShadow: '-1px 2px 0 0 #eeeeee'
	    });
	    return DIV({
	      style: {
	        position: 'relative',
	        listStyle: 'none outside none',
	        marginBottom: '0.5em'
	      }
	    }, this.props.user ? Avatar({
	      key: this.props.user.key || this.props.user,
	      style: pic_style,
	      hide_popover: false,
	      anonymous: this.props.anon
	    }) : this.props.pic ? IMG({
	      style: pic_style,
	      src: this.props.pic
	    }) : void 0, DIV({
	      style: _.defaults({}, this.props.bubble_style || {}, {
	        width: w,
	        borderWidth: 3,
	        borderStyle: 'solid',
	        borderColor: 'transparent',
	        position: 'relative',
	        zIndex: 1,
	        outline: 'none',
	        padding: 8,
	        borderRadius: 16,
	        backgroundColor: considerit_gray,
	        boxShadow: '#b5b5b5 0 1px 1px 0px'
	      })
	    }, this.props.user || this.props.pic ? DIV({
	      style: mouth_style
	    }, Bubblemouth({
	      apex_xfrac: 0,
	      width: mouth_w,
	      height: mouth_w,
	      fill: considerit_gray,
	      stroke: 'none',
	      box_shadow: _.defaults({}, this.props.mouth_shadow || {}, {
	        dx: 3,
	        dy: 0,
	        stdDeviation: 2,
	        opacity: .5
	      })
	    })) : void 0, this.props.children || STATEMENT(this.props)));
	  }
	});
	
	window.STATEMENT = ReactiveComponent({
	  displayName: 'Statement',
	  render: function() {
	    var body, title;
	    title = this.props.title;
	    body = this.props.body;
	    return DIV({
	      style: {
	        wordWrap: 'break-word'
	      }
	    }, DIV({
	      style: _.defaults({}, this.props.title_style || {}, {
	        fontSize: POINT_FONT_SIZE()
	      }),
	      className: 'statement'
	    }, title), body ? DIV({
	      className: "statement",
	      style: _.defaults({}, this.props.body_style || {}, {
	        wordWrap: 'break-word',
	        marginTop: '0.5em',
	        fontSize: POINT_FONT_SIZE(),
	        fontWeight: 300
	      }),
	      dangerouslySetInnerHTML: {
	        __html: body
	      }
	    }) : void 0);
	  }
	});
	
	styles += "\n.statement a {\n  text-decoration: underline;\n  // word-break: break-all; \n}\n\n.statement p {\n  margin-bottom: 12px; }";


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	
	window.SU = ReactiveComponent({
	  displayName: 'SU',
	  render: function() {
	    var su, user, users;
	    su = fetch('su');
	    if (!su.enabled) {
	      return SPAN(null);
	    }
	    users = fetch('/users');
	    return DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 9999,
	        left: 0,
	        top: 0,
	        width: '100%',
	        backgroundColor: 'black',
	        color: 'white',
	        padding: 10
	      },
	      onMouseLeave: (function(_this) {
	        return function() {
	          su.enabled = false;
	          return save(su);
	        };
	      })(this)
	    }, UL({
	      style: {
	        width: '100%'
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = users.users;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        user = ref[i];
	        results.push(LI({
	          key: user.key || user,
	          style: {
	            backgroundColor: 'black',
	            listStyle: 'none',
	            display: 'inline-block',
	            margin: 10,
	            cursor: 'pointer'
	          },
	          onClick: (function(_this) {
	            return function(user) {
	              return function() {
	                var current_user;
	                current_user = fetch('/current_user');
	                current_user.trying_to = 'switch_users';
	                current_user.switch_to = user;
	                save(current_user, function() {
	                  return location.reload();
	                });
	                su.enabled = false;
	                return save(su);
	              };
	            };
	          })(this)(user)
	        }, Avatar({
	          key: user.key || user,
	          user: user.key || user,
	          hide_popover: true,
	          style: {
	            width: 50,
	            height: 50
	          }
	        }), SPAN({
	          style: {
	            paddingTop: 12,
	            paddingLeft: 5,
	            display: 'inline-block'
	          }
	        }, fetch(user).name)));
	      }
	      return results;
	    }).call(this)));
	  },
	  componentDidMount: function() {
	    return document.addEventListener("keyup", function(e) {
	      var key, su;
	      key = (e && e.keyCode) || e.keyCode;
	      if (key === 85 && e.ctrlKey) {
	        su = fetch('su');
	        su.enabled = !su.enabled;
	        return save(su);
	      }
	    });
	  }
	});


/***/ },
/* 81 */
/***/ function(module, exports) {

	var RATE_LIMIT, sense_viewport_visibility_changes, update_scheduled;
	
	RATE_LIMIT = 100;
	
	update_scheduled = false;
	
	window.is_el_visible = function(el, scrollY, viewport_height, slop) {
	  var el_bottom, el_top, parent, vh, visible;
	  if (slop == null) {
	    slop = 1;
	  }
	  slop -= 1;
	  el_top = -scrollY;
	  vh = viewport_height;
	  parent = el;
	  while (true) {
	    el_top += parent.offsetTop;
	    if (!parent.offsetParent) {
	      break;
	    }
	    parent = parent.offsetParent;
	  }
	  el_bottom = el_top + el.offsetHeight;
	  visible = el_top <= vh + slop * vh && el_bottom >= -slop * vh;
	  return visible;
	};
	
	sense_viewport_visibility_changes = function() {
	  var __, el, el_sets, els, found_visible, i, idx, inc, innerHeight, j, k, key, l, len, len1, len2, len3, len4, name, ref, scrollY, slop, start_here, state, step, visibility, visible;
	  els = document.querySelectorAll('[data-receive-viewport-visibility-updates]');
	  if (els.length > 0) {
	    scrollY = window.scrollY;
	    innerHeight = window.innerHeight;
	    el_sets = {};
	    for (i = 0, len1 = els.length; i < len1; i++) {
	      el = els[i];
	      slop = parseFloat(el.getAttribute('data-receive-viewport-visibility-updates') || 1);
	      name = el.getAttribute('data-visibility-name');
	      key = name + "-" + slop;
	      if (el_sets[key] == null) {
	        el_sets[key] = [];
	      }
	      el_sets[key].push(el);
	    }
	    for (__ in el_sets) {
	      els = el_sets[__];
	      visibility = {};
	      slop = parseFloat(els[0].getAttribute('data-receive-viewport-visibility-updates') || 1);
	      len = els.length;
	      start_here = Math.floor(len / 2);
	      found_visible = false;
	      for (idx = j = 0, len2 = els.length; j < len2; idx = ++j) {
	        el = els[idx];
	        state = fetch(el.getAttribute('data-component'));
	        if (state.in_viewport) {
	          visibility[idx] = is_el_visible(els[idx], scrollY, innerHeight, slop);
	          if (visibility[idx]) {
	            start_here = idx;
	            found_visible = true;
	          }
	        }
	      }
	      ref = [1, -1];
	      for (k = 0, len3 = ref.length; k < len3; k++) {
	        step = ref[k];
	        inc = start_here;
	        while (inc >= 0 && inc < len) {
	          if (visibility[inc] == null) {
	            visibility[inc] = is_el_visible(els[inc], scrollY, innerHeight, slop);
	          }
	          if (!visibility[inc] && found_visible) {
	            break;
	          }
	          inc += step;
	        }
	      }
	      for (idx = l = 0, len4 = els.length; l < len4; idx = ++l) {
	        el = els[idx];
	        visible = !!visibility[idx];
	        state = fetch(el.getAttribute('data-component'));
	        el.setAttribute('data-in-viewport', visible);
	        if ((state.in_viewport == null) || state.in_viewport !== visible) {
	          state.in_viewport = visible;
	          save(state);
	        }
	      }
	    }
	  }
	  return update_scheduled = false;
	};
	
	window.schedule_viewport_position_check = function() {
	  var to_timer;
	  if (!update_scheduled) {
	    update_scheduled = true;
	    return to_timer = setTimeout(function() {
	      var e;
	      try {
	        requestAnimationFrame(sense_viewport_visibility_changes);
	      } catch (error) {
	        e = error;
	        console.log("Got error running schedule_viewport_position_check");
	        console.error(e);
	      }
	      return clearTimeout(to_timer);
	    }, RATE_LIMIT);
	  }
	};
	
	document.addEventListener("visibilitychange", schedule_viewport_position_check);
	
	document.addEventListener("scroll", schedule_viewport_position_check);
	
	window.addEventListener("resize", schedule_viewport_position_check);


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** franklin.88f362761c9e7f8cc12d.js
 **/